(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("2kit"), require("classnames"), require("prop-types"), require("react"), require("react-dom"), require("react-intl"));else if (typeof define === 'function' && define.amd) define(["2kit", "classnames", "prop-types", "react", "react-dom", "react-intl"], factory);else {
    var a = typeof exports === 'object' ? factory(require("2kit"), require("classnames"), require("prop-types"), require("react"), require("react-dom"), require("react-intl")) : factory(root["2kit"], root["classnames"], root["prop-types"], root["react"], root["react-dom"], root["react-intl"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(window, function (__WEBPACK_EXTERNAL_MODULE__2kit__, __WEBPACK_EXTERNAL_MODULE_classnames__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE_react_intl__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // install a JSONP callback for chunk loading

      /******/
      function webpackJsonpCallback(data) {
        /******/
        var chunkIds = data[0];
        /******/

        var moreModules = data[1];
        /******/

        /******/

        /******/
        // add "moreModules" to the modules object,

        /******/
        // then flag all "chunkIds" as loaded and fire callback

        /******/

        var moduleId,
            chunkId,
            i = 0,
            resolves = [];
        /******/

        for (; i < chunkIds.length; i++) {
          /******/
          chunkId = chunkIds[i];
          /******/

          if (Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
            /******/
            resolves.push(installedChunks[chunkId][0]);
            /******/
          }
          /******/


          installedChunks[chunkId] = 0;
          /******/
        }
        /******/


        for (moduleId in moreModules) {
          /******/
          if (Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
            /******/
            modules[moduleId] = moreModules[moduleId];
            /******/
          }
          /******/

        }
        /******/


        if (parentJsonpFunction) parentJsonpFunction(data);
        /******/

        /******/

        while (resolves.length) {
          /******/
          resolves.shift()();
          /******/
        }
        /******/

        /******/

      }

      ;
      /******/

      /******/

      /******/
      // The module cache

      /******/

      var installedModules = {};
      /******/

      /******/
      // object to store loaded and loading chunks

      /******/
      // undefined = chunk not loaded, null = chunk preloaded/prefetched

      /******/
      // Promise = chunk loading, 0 = chunk loaded

      /******/

      var installedChunks = {
        /******/
        "letter.meta": 0
        /******/

      };
      /******/

      /******/

      /******/

      /******/
      // script path function

      /******/

      function jsonpScriptSrc(chunkId) {
        /******/
        return __webpack_require__.p + "" + ({
          "avia.header": "avia.header",
          "phishingalert.header": "phishingalert.header",
          "vendors~promodomain.header": "vendors~promodomain.header",
          "promodomain.header": "promodomain.header",
          "vendors~transaction.header": "vendors~transaction.header",
          "transaction.header": "transaction.header"
        }[chunkId] || chunkId) + ".js";
        /******/
      }
      /******/

      /******/
      // The require function

      /******/


      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/
      // This file contains only the entry chunk.

      /******/
      // The chunk loading function for additional chunks

      /******/


      __webpack_require__.e = function requireEnsure(chunkId) {
        /******/
        var promises = [];
        /******/

        /******/

        /******/
        // JSONP chunk loading for javascript

        /******/

        /******/

        var installedChunkData = installedChunks[chunkId];
        /******/

        if (installedChunkData !== 0) {
          // 0 means "already installed".

          /******/

          /******/
          // a Promise means "currently loading".

          /******/
          if (installedChunkData) {
            /******/
            promises.push(installedChunkData[2]);
            /******/
          } else {
            /******/
            // setup Promise in chunk cache

            /******/
            var promise = new Promise(function (resolve, reject) {
              /******/
              installedChunkData = installedChunks[chunkId] = [resolve, reject];
              /******/
            });
            /******/

            promises.push(installedChunkData[2] = promise);
            /******/

            /******/
            // start chunk loading

            /******/

            var script = document.createElement('script');
            /******/

            var onScriptComplete;
            /******/

            /******/

            script.charset = 'utf-8';
            /******/

            script.timeout = 120;
            /******/

            if (__webpack_require__.nc) {
              /******/
              script.setAttribute("nonce", __webpack_require__.nc);
              /******/
            }
            /******/


            script.src = jsonpScriptSrc(chunkId);
            /******/

            /******/
            // create error before stack unwound to get useful stacktrace later

            /******/

            var error = new Error();
            /******/

            onScriptComplete = function onScriptComplete(event) {
              /******/
              // avoid mem leaks in IE.

              /******/
              script.onerror = script.onload = null;
              /******/

              clearTimeout(timeout);
              /******/

              var chunk = installedChunks[chunkId];
              /******/

              if (chunk !== 0) {
                /******/
                if (chunk) {
                  /******/
                  var errorType = event && (event.type === 'load' ? 'missing' : event.type);
                  /******/

                  var realSrc = event && event.target && event.target.src;
                  /******/

                  error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
                  /******/

                  error.name = 'ChunkLoadError';
                  /******/

                  error.type = errorType;
                  /******/

                  error.request = realSrc;
                  /******/

                  chunk[1](error);
                  /******/
                }
                /******/


                installedChunks[chunkId] = undefined;
                /******/
              }
              /******/

            };
            /******/


            var timeout = setTimeout(function () {
              /******/
              onScriptComplete({
                type: 'timeout',
                target: script
              });
              /******/
            }, 120000);
            /******/

            script.onerror = script.onload = onScriptComplete;
            /******/

            document.head.appendChild(script);
            /******/
          }
          /******/

        }
        /******/


        return Promise.all(promises);
        /******/
      };
      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // on error function for async loading

      /******/

      __webpack_require__.oe = function (err) {
        console.error(err);
        throw err;
      };
      /******/

      /******/


      var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
      /******/

      var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
      /******/

      jsonpArray.push = webpackJsonpCallback;
      /******/

      jsonpArray = jsonpArray.slice();
      /******/

      for (var i = 0; i < jsonpArray.length; i++) {
        webpackJsonpCallback(jsonpArray[i]);
      }
      /******/


      var parentJsonpFunction = oldJsonpFunction;
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = "./src/index.ts");
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "./node_modules/2kit/components/Status/Status.js":
      /*!*******************************************************!*\
        !*** ./node_modules/2kit/components/Status/Status.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsStatusStatusJs(module, exports, __webpack_require__) {
        "use strict";

        var __extends = this && this.__extends || function () {
          var _extendStatics = function extendStatics(d, b) {
            _extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics(d, b);
          };

          return function (d, b) {
            _extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var classNames = __webpack_require__(
        /*! classnames */
        "classnames");

        var React = __webpack_require__(
        /*! react */
        "react");

        var getTextChildren_1 = __webpack_require__(
        /*! ../assets/getTextChildren */
        "./node_modules/2kit/components/assets/getTextChildren.js");

        var withStyles_1 = __webpack_require__(
        /*! ../decorators/withStyles */
        "./node_modules/2kit/components/decorators/withStyles.js");

        var Status_styles_1 = __webpack_require__(
        /*! ./Status.styles */
        "./node_modules/2kit/components/Status/Status.styles.js");

        var withResponsive_1 = __webpack_require__(
        /*! ../decorators/withResponsive */
        "./node_modules/2kit/components/decorators/withResponsive.js");

        var baseProps_1 = __webpack_require__(
        /*! ../assets/baseProps */
        "./node_modules/2kit/components/assets/baseProps.js");

        var Status =
        /** @class */
        function (_super) {
          __extends(Status, _super);

          function Status() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          Status.prototype.render = function () {
            var _a;

            var props = this.props;
            var _b = props.mode,
                mode = _b === void 0 ? 'default' : _b,
                classes = props.classes;
            var textChildren = getTextChildren_1.default(props);
            var className = classNames(classes.base, (_a = {}, _a[classes.default] = mode === 'default', _a[classes.warning] = mode === 'warning', _a[classes.process] = mode === 'process', _a[classes.done] = mode === 'done', _a[classes.empty] = mode === 'empty', _a));
            return React.createElement("div", __assign({}, baseProps_1.default(props), {
              className: className
            }), React.createElement("p", null, textChildren));
          };

          Status = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(Status_styles_1.styles)], Status);
          return Status;
        }(React.PureComponent);

        exports.default = Status; //# sourceMappingURL=Status.js.map

        /***/
      },

      /***/
      "./node_modules/2kit/components/Status/Status.styles.js":
      /*!**************************************************************!*\
        !*** ./node_modules/2kit/components/Status/Status.styles.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsStatusStatusStylesJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        exports.styles = function (_a) {
          var fontSize = _a.fontSize,
              fontFamily = _a.fontFamily,
              sizeBorderRadius = _a.sizeBorderRadius,
              colorText = _a.colorText,
              colorBgSecondary = _a.colorBgSecondary,
              colorError = _a.colorError,
              colorSuccess = _a.colorSuccess,
              fontSize1 = _a.fontSize1,
              colorWarning = _a.colorRating;
          return {
            base: {
              fontFamily: fontFamily,
              fontSize: fontSize,
              display: 'inline-block',
              textAlign: 'center',
              padding: '4px 6px',
              borderRadius: sizeBorderRadius,
              whiteSpace: 'nowrap',
              fontWeight: 'bold',
              '& p': {
                fontSize: fontSize1.fontSize,
                marginTop: 'auto',
                marginBottom: 'auto',
                textTransform: 'uppercase',
                userSelect: 'none'
              }
            },
            default: {
              backgroundColor: colorBgSecondary.normal,
              '& p': {
                color: colorText.normal
              }
            },
            warning: {
              backgroundColor: 'rgba(255, 17, 0, 0.1)',
              '& p': {
                color: colorError.normal
              }
            },
            process: {
              backgroundColor: 'rgba(255, 158, 0, 0.1)',
              '& p': {
                color: colorWarning.normal
              }
            },
            done: {
              backgroundColor: 'rgba(40, 199, 93, 0.1)',
              '& p': {
                color: colorSuccess.normal
              }
            },
            empty: {
              border: '1px solid rgba(0, 0, 0, 0.12)',
              '& p': {
                color: 'rgba(153, 153, 153, 1)'
              }
            }
          };
        }; //# sourceMappingURL=Status.styles.js.map

        /***/

      },

      /***/
      "./node_modules/2kit/components/assets/baseProps.js":
      /*!**********************************************************!*\
        !*** ./node_modules/2kit/components/assets/baseProps.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsAssetsBasePropsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        function baseProps(props) {
          var tabIndex = props.tabIndex,
              testId = props.testId,
              title = props.title,
              onClick = props.onClick,
              onContextMenu = props.onContextMenu,
              onMouseDown = props.onMouseDown,
              id = props.id;
          return {
            'data-test-id': testId,
            tabIndex: tabIndex,
            title: title,
            onContextMenu: onContextMenu,
            onClick: onClick,
            onMouseDown: onMouseDown,
            id: id
          };
        }

        function noop() {// Нужна чтобы не забивать память кучей пустых функций
        }

        exports.noop = noop;

        function isFunctionalProp(prop) {
          return typeof prop === 'function';
        }

        function functionalProp(prop, options) {
          return isFunctionalProp(prop) ? prop(options) : prop;
        }

        exports.functionalProp = functionalProp;
        exports.default = baseProps; //# sourceMappingURL=baseProps.js.map

        /***/
      },

      /***/
      "./node_modules/2kit/components/assets/getTextChildren.js":
      /*!****************************************************************!*\
        !*** ./node_modules/2kit/components/assets/getTextChildren.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsAssetsGetTextChildrenJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        function getTextChildren(_a) {
          var text = _a.text,
              children = _a.children;
          return text || children;
        }

        exports.default = getTextChildren; //# sourceMappingURL=getTextChildren.js.map

        /***/
      },

      /***/
      "./node_modules/2kit/components/decorators/decorators.js":
      /*!***************************************************************!*\
        !*** ./node_modules/2kit/components/decorators/decorators.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsDecoratorsDecoratorsJs(module, exports, __webpack_require__) {
        "use strict";

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(
        /*! react */
        "react");

        var decorations = [];

        function createDecorator(decorate) {
          return function (Component) {
            var DecoratedComponent = decorate(Component);
            getComponentDecorations(Component).push(DecoratedComponent);
            return DecoratedComponent;
          };
        }

        exports.createDecorator = createDecorator;

        function createWrapDecorator(Wrapper) {
          return createDecorator(function (Component) {
            return function (props) {
              return React.createElement(Wrapper, __assign({}, props), React.createElement(Component, __assign({}, props)));
            };
          });
        }

        exports.createWrapDecorator = createWrapDecorator;

        function combineDecorators() {
          var decorators = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            decorators[_i] = arguments[_i];
          }

          return function (Component) {
            return decorators.reduce(function (Component, decorator) {
              return decorator(Component);
            }, Component);
          };
        }

        exports.combineDecorators = combineDecorators;

        function getComponentDecorations(Component) {
          var foundDecorations = decorations.find(function (decorations) {
            return decorations.indexOf(Component) > -1;
          });

          if (foundDecorations) {
            return foundDecorations;
          }

          var newDecorations = [Component];
          decorations.push(newDecorations);
          return newDecorations;
        }

        exports.getComponentDecorations = getComponentDecorations;

        function getNakedComponent(Component) {
          var result = getComponentDecorations(Component)[0];
          result.defaultProps = __assign(__assign({}, result.defaultProps), {
            classes: {}
          });
          return result;
        }

        exports.getNakedComponent = getNakedComponent; //# sourceMappingURL=decorators.js.map

        /***/
      },

      /***/
      "./node_modules/2kit/components/decorators/withChannel.js":
      /*!****************************************************************!*\
        !*** ./node_modules/2kit/components/decorators/withChannel.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsDecoratorsWithChannelJs(module, exports, __webpack_require__) {
        "use strict";

        var __extends = this && this.__extends || function () {
          var _extendStatics2 = function extendStatics(d, b) {
            _extendStatics2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics2(d, b);
          };

          return function (d, b) {
            _extendStatics2(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(
        /*! react */
        "react");

        var decorators_1 = __webpack_require__(
        /*! ./decorators */
        "./node_modules/2kit/components/decorators/decorators.js");

        var PropTypes = __webpack_require__(
        /*! prop-types */
        "prop-types");

        function createChannel(channelName, defaultValue) {
          var _a;

          var contextTypes = (_a = {}, _a[channelName] = PropTypes.any, _a);

          var Broadcast =
          /** @class */
          function (_super) {
            __extends(Broadcast, _super);

            function Broadcast() {
              return _super !== null && _super.apply(this, arguments) || this;
            }

            Broadcast.prototype.getChildContext = function () {
              var _a;

              return _a = {}, _a[channelName] = this.props.channelValue, _a;
            };

            Broadcast.prototype.render = function () {
              return React.Children.only(this.props.children);
            };

            Broadcast.childContextTypes = contextTypes;
            return Broadcast;
          }(React.Component);

          var getDisplayName = function getDisplayName(componentDisplayName) {
            var upperCaseChannelName = channelName.charAt(0).toUpperCase() + channelName.slice(1);
            return "with" + upperCaseChannelName + "(" + componentDisplayName + ")";
          };

          var withChannel = function withChannel(mapChannelToProps) {
            return decorators_1.createDecorator(function (Component) {
              var _a;

              return _a =
              /** @class */
              function (_super) {
                __extends(Subscriber, _super);

                function Subscriber() {
                  return _super !== null && _super.apply(this, arguments) || this;
                }

                Subscriber.prototype.render = function () {
                  var _a = this,
                      context = _a.context,
                      props = _a.props;

                  var channelValue = context[channelName];
                  return React.createElement(Component, __assign({}, mapChannelToProps(typeof channelValue === 'undefined' ? defaultValue : channelValue, props), props));
                };

                return Subscriber;
              }(React.Component), _a.contextTypes = contextTypes, _a.NakedComponent = Component.NakedComponent || Component, _a.displayName = getDisplayName(Component.displayName || Component.name || 'Component'), _a;
            });
          };

          return {
            Broadcast: Broadcast,
            withChannel: withChannel
          };
        }

        exports.createChannel = createChannel; //# sourceMappingURL=withChannel.js.map

        /***/
      },

      /***/
      "./node_modules/2kit/components/decorators/withResponsive.js":
      /*!*******************************************************************!*\
        !*** ./node_modules/2kit/components/decorators/withResponsive.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsDecoratorsWithResponsiveJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(
        /*! react */
        "react");

        var withChannel_1 = __webpack_require__(
        /*! ./withChannel */
        "./node_modules/2kit/components/decorators/withChannel.js");

        var helpers = withChannel_1.createChannel('responsive', 'auto');
        var Broadcast = helpers.Broadcast;
        exports.Broadcast = Broadcast;
        var withChannel = helpers.withChannel;
        exports.withChannel = withChannel;

        function mapResponsiveToProps(responsive) {
          return {
            responsive: responsive
          };
        }

        exports.mapResponsiveToProps = mapResponsiveToProps;

        exports.Responsive = function (_a) {
          var mode = _a.mode,
              children = _a.children;
          return React.createElement(Broadcast, {
            channelValue: mode
          }, children);
        };

        exports.withResponsive = withChannel(mapResponsiveToProps); //# sourceMappingURL=withResponsive.js.map

        /***/
      },

      /***/
      "./node_modules/2kit/components/decorators/withStyles.js":
      /*!***************************************************************!*\
        !*** ./node_modules/2kit/components/decorators/withStyles.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsDecoratorsWithStylesJs(module, exports, __webpack_require__) {
        "use strict";

        var __extends = this && this.__extends || function () {
          var _extendStatics3 = function extendStatics(d, b) {
            _extendStatics3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics3(d, b);
          };

          return function (d, b) {
            _extendStatics3(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); ///<reference path="../../types/jss.d.ts"/>

        var jss_1 = __webpack_require__(
        /*! jss */
        "./node_modules/jss/lib/index.js");

        var jss_preset_2kit_1 = __webpack_require__(
        /*! @mail/jss-preset-2kit */
        "./node_modules/@mail/jss-preset-2kit/lib/index.js");

        var React = __webpack_require__(
        /*! react */
        "react");

        var theme_1 = __webpack_require__(
        /*! ../theme */
        "./node_modules/2kit/components/theme.js");

        var PropTypes = __webpack_require__(
        /*! prop-types */
        "prop-types");

        var decorators_1 = __webpack_require__(
        /*! ./decorators */
        "./node_modules/2kit/components/decorators/decorators.js");

        var react_jss_1 = __webpack_require__(
        /*! react-jss */
        "./node_modules/react-jss/lib/index.js");

        jss_1.default.setup(jss_preset_2kit_1.default());
        var ThemeProviderContextTypes = {
          hasThemeProvider: PropTypes.bool
        };

        var ThemeProvider =
        /** @class */
        function (_super) {
          __extends(ThemeProvider, _super);

          function ThemeProvider() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          ThemeProvider.prototype.render = function () {
            return React.createElement(react_jss_1.ThemeProvider, __assign({}, this.props));
          };

          ThemeProvider.prototype.getChildContext = function () {
            return {
              hasThemeProvider: true
            };
          };

          ThemeProvider.childContextTypes = ThemeProviderContextTypes;
          return ThemeProvider;
        }(React.Component);

        exports.ThemeProvider = ThemeProvider;
        /**
         * Фабрика декораторов для подключения jss стилей к компоненту
         *
         * В результате применения создаваемого декоратора
         * в свойства компонента подмешивается свойство classes
         * с картой соответствий исходных и сгенерированных CSS-классов
         *
         * @param styles описание jss-таблицы стилей
         * @genericParam C перечисление поддерживаемых компонентом CSS-классов
         * @genericParam P базовые (без св-ва) classes) свойства компонента
         * @return Декоратор для стилизуемого компонента
         */

        exports.withStyles = function (styles) {
          return decorators_1.createDecorator(function (Component) {
            var _a;

            if (typeof styles !== 'function') {
              return react_jss_1.default(styles)(Component);
            }

            var ThemedComponent = react_jss_1.default(styles)(Component);
            var BaseComponent = react_jss_1.default(styles(theme_1.theme))(Component);
            var componentDisplayName = Component.displayName || Component.name ||
            /* istanbul ignore next */
            'Component'; // tslint:disable-next-line:max-classes-per-file

            return _a =
            /** @class */
            function (_super) {
              __extends(class_1, _super);

              function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
              }

              class_1.prototype.render = function () {
                return this.context.hasThemeProvider ? React.createElement(ThemedComponent, __assign({}, this.props)) : React.createElement(BaseComponent, __assign({
                  theme: theme_1.theme
                }, this.props));
              };

              return class_1;
            }(React.Component), _a.contextTypes = ThemeProviderContextTypes, _a.NakedComponent = Component.NakedComponent || Component, _a.displayName = "withStyles(" + componentDisplayName + ")", _a;
          });
        }; //# sourceMappingURL=withStyles.js.map

        /***/

      },

      /***/
      "./node_modules/2kit/components/theme.js":
      /*!***********************************************!*\
        !*** ./node_modules/2kit/components/theme.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitComponentsThemeJs(module, exports, __webpack_require__) {
        "use strict";

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); /// <reference path="../types/modules.d.ts" />

        var index_js_1 = __webpack_require__(
        /*! @paradigm/themes/base/desktop_s/index.js */
        "./node_modules/2kit/node_modules/@paradigm/themes/base/desktop_s/index.js");

        var index_js_2 = __webpack_require__(
        /*! @paradigm/themes/octavius/subthemes/dit/index.js */
        "./node_modules/2kit/node_modules/@paradigm/themes/octavius/subthemes/dit/index.js");

        var index_js_3 = __webpack_require__(
        /*! @paradigm/themes/octavius/subthemes/black/index.js */
        "./node_modules/2kit/node_modules/@paradigm/themes/octavius/subthemes/black/index.js");

        var index_js_4 = __webpack_require__(
        /*! @paradigm/themes/base/default/index.js */
        "./node_modules/2kit/node_modules/@paradigm/themes/base/default/index.js");

        var index_js_5 = __webpack_require__(
        /*! @paradigm/themes/octavius/desktop_s/index.js */
        "./node_modules/2kit/node_modules/@paradigm/themes/octavius/desktop_s/index.js");

        var index_js_6 = __webpack_require__(
        /*! @paradigm/themes/mailID/desktop_s/index.js */
        "./node_modules/2kit/node_modules/@paradigm/themes/mailID/desktop_s/index.js");

        var color = __webpack_require__(
        /*! color */
        "./node_modules/color/index.js");

        exports.addStateFunctions = function (theme) {
          return __assign(__assign({}, theme), {
            stateHover: function stateHover(colorHover) {
              if (colorHover === 'transparent') {
                return 'rgba(' + theme.colorState.normal + ',' + theme.toneValueHover + ')';
              }

              return color(colorHover).mix(color(theme.colorState.normal), theme.toneValueHover).hex();
            },
            stateActive: function stateActive(colorActive) {
              if (colorActive === 'transparent') {
                return 'rgba(' + theme.colorState.normal + ',' + theme.toneValueActive + ')';
              }

              return color(colorActive).mix(color(theme.colorState.normal), theme.toneValueActive).hex();
            },
            stateFocus: function stateFocus(colorFocus) {
              if (colorFocus === 'transparent') {
                return 'rgba(' + theme.colorState.normal + ',' + theme.toneValueFocus + ')';
              }

              return color(colorFocus).mix(color(theme.colorState.normal), theme.toneValueFocus).hex();
            },
            stateDisabled: function stateDisabled(colorDisabled) {
              return color(colorDisabled).alpha(theme.toneValueBase).rgb().string();
            }
          });
        };

        exports.AllThemes = {
          octavius: exports.addStateFunctions(index_js_5.default),
          octaviusBlack: exports.addStateFunctions(__assign(__assign(__assign({}, index_js_1.default), index_js_5.default), index_js_3.default)),
          base: exports.addStateFunctions(index_js_1.default),
          dit: exports.addStateFunctions(__assign(__assign({}, index_js_1.default), index_js_2.default)),
          black: exports.addStateFunctions(__assign(__assign({}, index_js_1.default), index_js_3.default)),
          touch: exports.addStateFunctions(index_js_4.default),
          mailID: exports.addStateFunctions(index_js_6.default)
        };
        exports.theme = exports.AllThemes.base; //# sourceMappingURL=theme.js.map

        /***/
      },

      /***/
      "./node_modules/2kit/node_modules/@paradigm/themes/base/default/index.js":
      /*!*******************************************************************************!*\
        !*** ./node_modules/2kit/node_modules/@paradigm/themes/base/default/index.js ***!
        \*******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitNode_modulesParadigmThemesBaseDefaultIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var theme = {
          x0: 0,
          x025: 1,
          x05: 2,
          x1: 4,
          x2: 8,
          x3: 12,
          x4: 16,
          x5: 20,
          x6: 24,
          x8: 32,
          x10: 40,
          x12: 48,
          x15: 60,
          x20: 80,
          sizeBase: 4,
          sizeGrid: 20,
          fontSize1: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize2: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize3: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize4: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize5: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize6: {
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize7: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize8: {
            fontSize: 44,
            lineHeight: "52px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          toneValueX1: 0.04,
          toneValueX2: 0.08,
          toneValueX3: 0.12,
          toneValueX4: 0.16,
          toneValueX6: 0.24,
          toneValueX8: 0.32,
          toneValueX12: 0.48,
          toneValueX18: 0.72,
          toneValueOverlay: 0.48,
          toneValueBase: 0.48,
          toneValueViewer: 0.88,
          toneValueToolbar: 0.24,
          toneValueHover: 0.04,
          toneValueActive: 0.08,
          toneValueFocus: 0.08,
          depth0: "none",
          depth1: "0 2px 0 0 rgba(0, 0, 0, 0.04)",
          depth2: "0 4px 32px 0 rgba(0, 0, 0, 0.32)",
          depth3: "0 16px 48px 0 rgba(0, 0, 0, 0.48)",
          depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
          colorBorder: {
            normal: "rgba(0,0,0,0.12)",
            hover: "rgba(0,0,0,0.24)",
            active: "rgba(0,0,0,0.48)",
            focus: "rgba(0,0,0,0.24)"
          },
          colorDivider: {
            normal: "rgba(0,0,0,0.08)"
          },
          typeBorderButton: "solid",
          typeBorderPosition: "inset",
          animationDurationL: "0.4s",
          animationDurationM: "0.2s",
          animationDurationS: "0.1s",
          transitionEasingDefault: "cubic-bezier(0.3, 0.3, 0.5, 1)",
          paddingBase: 16,
          layoutWidthDesktopS: 768,
          colorPrimary: {
            normal: "#005ff9",
            hover: "#005BEF",
            active: "#0057E5"
          },
          colorSecondary: {
            normal: "#ff9e00",
            hover: "#F59800",
            active: "#EB9100"
          },
          sizeBorderWidth: 1,
          sizeBorderWidthTab: 2,
          sizeBorderWidthBar: 4,
          sizeBorderWidthAccent: 8,
          sizeBorderWidthAccentSecondary: 4,
          sizeBorderRadius: 2,
          sizeBorderRadiusPaper: 2,
          fontWeight: 400,
          fontWeightBold: 700,
          fontFamily: "Helvetica, Arial, sans-serif",
          fontSize: 17,
          lineHeight: 24,
          fontH0: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 20
          },
          fontH1: {
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 16
          },
          fontH2: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 12
          },
          fontH3: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 12
          },
          fontH4: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 12
          },
          fontH5: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontH6: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontBody: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontParagraph: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 24
          },
          fontList: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontListItem: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontFootnote: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontLead: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontQuote: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontTableHeader: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontControl: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontControlLabel: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontTab: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontBadge: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            letterSpacing: "1px",
            textTransform: "uppercase"
          },
          fontDisclaimer: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          sizeControlHeight: 48,
          sizeControlButtonWidthMin: 130,
          sizeControlButtonIconWidth: 48,
          sizeControlButtonSliderHeight: 24,
          sizeControlButtonSliderWidth: 12,
          sizeControlButtonSliderWidthPointer: 16,
          sizeControlButtonSmallHeight: 32,
          sizeControlButtonSmallWidth: 32,
          sizeControlFieldWidthMin: 328,
          sizeControlLabelWidth: 184,
          sizeControlCheckHeight: 16,
          sizeControlCheckWidth: 16,
          sizeProgress: 4,
          sizeProgressScroll: 12,
          sizeDotBullet: 4,
          sizeDotIndicate: 8,
          sizeDotClickable: 12,
          sizeArrowHeight: 8,
          sizeArrowWidth: 12,
          sizePopupSmall: 420,
          sizePopupMedium: 680,
          sizePopupLarge: 880,
          paddingControlHorizontal: 12,
          paddingControlVertical: 0,
          paddingControlMore: 8,
          paddingControlMoreIcon: 12,
          paddingControlButton: 20,
          paddingControlButtonIcon: 20,
          paddingControlDiv: 4,
          paddingMenu: 8,
          paddingTag: 8,
          paddingTab: 0,
          paddingArrow: 12,
          paddingTableHorizontal: 16,
          paddingTableVertical: 16,
          paddingSliceTop: 40,
          paddingSliceBottom: 60,
          marginControl: 12,
          marginFormLabelHorizontal: 16,
          marginFormLabelVertical: 4,
          marginFormTip: 4,
          marginFormFieldHorizontal: 16,
          marginFormFieldVertical: 24,
          marginFormFieldSet: 32,
          marginIcon: 12,
          marginChoice: 8,
          marginMenu: 2,
          marginTooltip: 8,
          marginTag: 8,
          marginTab: 32,
          marginBullet: 12,
          marginAttribute: 4,
          marginPopup: 8,
          sizeIconUI: 16,
          sizeIconHeader: 20,
          sizeIconWysiwyg: 14,
          sizeIllustrationS: 48,
          sizeIllustrationXM: 72,
          sizeIllustrationM: 96,
          sizeIllustrationL: 144,
          sizeIllustrationXXL: 228,
          sizeAvatarXS: 24,
          sizeAvatarS: 32,
          sizeAvatarM: 48,
          sizeAvatarL: 96,
          sizeAvatarXL: 128,
          widthTouch: "(width < 768px)",
          widthDesktopS: "(width >= 768px)",
          widthFromDesktopS: "(width >= 768px)",
          widthToTouch: "(width < 768px)",
          colorStateHover: {
            normal: "rgba(0, 0, 0, 0.04)"
          },
          colorStateActive: {
            normal: "rgba(0, 0, 0, 0.08)"
          },
          colorOverlay: {
            normal: "rgba(0, 0, 0, 0.48)"
          },
          colorText: {
            normal: "#333333"
          },
          colorTextSecondary: {
            normal: "#999999"
          },
          colorTextContrast: {
            normal: "#ffffff"
          },
          colorIcon: {
            normal: "#333333"
          },
          colorIconContrast: {
            normal: "#ffffff"
          },
          colorLink: {
            normal: "#005bd1"
          },
          colorLinkVisited: {
            normal: "#528fdf"
          },
          colorLinkContrast: {
            normal: "#ffffff"
          },
          colorTrueBlack: {
            normal: "#000000"
          },
          colorTrueWhite: {
            normal: "#ffffff"
          },
          colorState: {
            normal: "#000000"
          },
          colorAlert: {
            normal: "#c1341b"
          },
          colorIconSecondary: {
            normal: "#c7c7c7",
            hover: "#BFBFBF",
            active: "#B7B7B7"
          },
          colorBg: {
            normal: "#ffffff",
            hover: "#F5F5F5",
            active: "#EBEBEB"
          },
          colorBgPopup: {
            normal: "#ffffff",
            hover: "#F5F5F5",
            active: "#EBEBEB"
          },
          colorBgSecondary: {
            normal: "#f0f0f0",
            hover: "#E6E6E6",
            active: "#DDDDDD"
          },
          colorBgContrast: {
            normal: "#333333",
            hover: "#313131",
            active: "#2F2F2F"
          },
          colorBgThumbnail: {
            normal: "#00103d",
            hover: "#000F3B",
            active: "#000F38"
          },
          colorSuccess: {
            normal: "#28c75d",
            hover: "#26BF59",
            active: "#25B756"
          },
          colorError: {
            normal: "#ff1100",
            hover: "#F51000",
            active: "#EB1000"
          },
          colorWarning: {
            normal: "#fffce0",
            hover: "#F5F2D7",
            active: "#EBE8CE"
          },
          colorBgWarning: {
            normal: "#fffce0",
            hover: "#F5F2D7",
            active: "#EBE8CE"
          },
          colorRating: {
            normal: "#ffd400",
            hover: "#F5CC00",
            active: "#EBC300"
          },
          colorNotify: {
            normal: "#ff9e00",
            hover: "#F59800",
            active: "#EB9100"
          },
          colorSocialVk: {
            normal: "#4680C2",
            hover: "#437BBA",
            active: "#4076B2"
          },
          colorSocialOk: {
            normal: "#ee8208",
            hover: "#E47D08",
            active: "#DB7807"
          },
          colorSocialMir: {
            normal: "#117eda",
            hover: "#1079D1",
            active: "#1074C9"
          },
          colorSocialFb: {
            normal: "#0561af",
            hover: "#055DA8",
            active: "#0559A1"
          },
          colorSocialTwitter: {
            normal: "#00bff3",
            hover: "#00B7E9",
            active: "#00B0E0"
          },
          colorSocialDribbble: {
            normal: "#ea4c89",
            hover: "#E14984",
            active: "#D7467E"
          },
          colorSocialBehance: {
            normal: "#0057ff",
            hover: "#0054F5",
            active: "#0050EB"
          },
          colorPaletteRed1: {
            normal: "#fc2c38",
            hover: "#F22A36",
            active: "#E82834"
          },
          colorPaletteRed2: {
            normal: "#eb1981",
            hover: "#E2187C",
            active: "#D81777"
          },
          colorPaletteRed3: {
            normal: "#ff71bb",
            hover: "#F56CB4",
            active: "#EB68AC"
          },
          colorPaletteOrange1: {
            normal: "#ff8b2e",
            hover: "#F5852C",
            active: "#EB802A"
          },
          colorPaletteYellow1: {
            normal: "#ffc311",
            hover: "#F5BB10",
            active: "#EBB310"
          },
          colorPaletteGreen1: {
            normal: "#aee113",
            hover: "#A7D812",
            active: "#A0CF11"
          },
          colorPaletteGreen2: {
            normal: "#59c354",
            hover: "#55BB51",
            active: "#52B34D"
          },
          colorPaletteGreen3: {
            normal: "#37eb94",
            hover: "#35E28E",
            active: "#33D888"
          },
          colorPaletteGreen4: {
            normal: "#00b1b3",
            hover: "#00AAAC",
            active: "#00A3A5"
          },
          colorPaletteBlue1: {
            normal: "#2951ff",
            hover: "#274EF5",
            active: "#264BEB"
          },
          colorPaletteBlue2: {
            normal: "#00abf2",
            hover: "#00A4E8",
            active: "#009DDF"
          },
          colorPaletteBlue3: {
            normal: "#26dfdf",
            hover: "#24D6D6",
            active: "#23CDCD"
          },
          colorPaletteViolet1: {
            normal: "#6c00ff",
            hover: "#6800F5",
            active: "#6300EB"
          },
          colorPaletteViolet2: {
            normal: "#ae73ff",
            hover: "#A76EF5",
            active: "#A06AEB"
          }
        };
        exports.default = theme;
        /***/
      },

      /***/
      "./node_modules/2kit/node_modules/@paradigm/themes/base/desktop_s/index.js":
      /*!*********************************************************************************!*\
        !*** ./node_modules/2kit/node_modules/@paradigm/themes/base/desktop_s/index.js ***!
        \*********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitNode_modulesParadigmThemesBaseDesktop_sIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var theme = {
          x0: 0,
          x025: 1,
          x05: 2,
          x1: 4,
          x2: 8,
          x3: 12,
          x4: 16,
          x5: 20,
          x6: 24,
          x8: 32,
          x10: 40,
          x12: 48,
          x15: 60,
          x20: 80,
          sizeBase: 4,
          sizeGrid: 20,
          fontSize1: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize2: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize3: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize4: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize5: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize6: {
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize7: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize8: {
            fontSize: 44,
            lineHeight: "52px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          toneValueX1: 0.04,
          toneValueX2: 0.08,
          toneValueX3: 0.12,
          toneValueX4: 0.16,
          toneValueX6: 0.24,
          toneValueX8: 0.32,
          toneValueX12: 0.48,
          toneValueX18: 0.72,
          toneValueOverlay: 0.48,
          toneValueBase: 0.48,
          toneValueViewer: 0.88,
          toneValueToolbar: 0.24,
          toneValueHover: 0.04,
          toneValueActive: 0.08,
          toneValueFocus: 0.08,
          depth0: "none",
          depth1: "0 2px 0 0 rgba(0, 0, 0, 0.04)",
          depth2: "0 4px 32px 0 rgba(0, 0, 0, 0.32)",
          depth3: "0 16px 48px 0 rgba(0, 0, 0, 0.48)",
          depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
          colorBorder: {
            normal: "rgba(0,0,0,0.12)",
            hover: "rgba(0,0,0,0.24)",
            active: "rgba(0,0,0,0.48)",
            focus: "rgba(0,0,0,0.24)"
          },
          colorDivider: {
            normal: "rgba(0,0,0,0.08)"
          },
          typeBorderButton: "solid",
          typeBorderPosition: "inset",
          animationDurationL: "0.4s",
          animationDurationM: "0.2s",
          animationDurationS: "0.1s",
          transitionEasingDefault: "cubic-bezier(0.3, 0.3, 0.5, 1)",
          paddingBase: 20,
          layoutWidthDesktopS: 768,
          colorPrimary: {
            normal: "#005ff9",
            hover: "#005BEF",
            active: "#0057E5"
          },
          colorSecondary: {
            normal: "#ff9e00",
            hover: "#F59800",
            active: "#EB9100"
          },
          sizeBorderWidth: 1,
          sizeBorderWidthTab: 2,
          sizeBorderWidthBar: 4,
          sizeBorderWidthAccent: 8,
          sizeBorderWidthAccentSecondary: 4,
          sizeBorderRadius: 2,
          sizeBorderRadiusPaper: 2,
          fontWeight: 400,
          fontWeightBold: 700,
          fontFamily: "Helvetica, Arial, sans-serif",
          fontSize: 15,
          lineHeight: 20,
          fontH0: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 24
          },
          fontH1: {
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 20
          },
          fontH2: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 16
          },
          fontH3: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 12
          },
          fontH4: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontH5: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontH6: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontBody: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontParagraph: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontList: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontListItem: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontFootnote: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontLead: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontQuote: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontTableHeader: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontControl: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontControlLabel: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontTab: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontBadge: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            letterSpacing: "1px",
            textTransform: "uppercase"
          },
          fontDisclaimer: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          sizeControlHeight: 32,
          sizeControlButtonWidthMin: 104,
          sizeControlButtonIconWidth: 32,
          sizeControlButtonSliderHeight: 24,
          sizeControlButtonSliderWidth: 12,
          sizeControlButtonSliderWidthPointer: 16,
          sizeControlButtonSmallHeight: 32,
          sizeControlButtonSmallWidth: 32,
          sizeControlFieldWidthMin: 380,
          sizeControlLabelWidth: 184,
          sizeControlCheckHeight: 16,
          sizeControlCheckWidth: 16,
          sizeProgress: 4,
          sizeProgressScroll: 12,
          sizeDotBullet: 4,
          sizeDotIndicate: 8,
          sizeDotClickable: 12,
          sizeArrowHeight: 8,
          sizeArrowWidth: 12,
          sizePopupSmall: 420,
          sizePopupMedium: 680,
          sizePopupLarge: 880,
          paddingControlHorizontal: 12,
          paddingControlVertical: 0,
          paddingControlMore: 8,
          paddingControlMoreIcon: 8,
          paddingControlButton: 16,
          paddingControlButtonIcon: 16,
          paddingControlDiv: 4,
          paddingMenu: 8,
          paddingTag: 8,
          paddingTab: 0,
          paddingArrow: 12,
          paddingTableHorizontal: 16,
          paddingTableVertical: 16,
          paddingSliceTop: 40,
          paddingSliceBottom: 60,
          marginControl: 8,
          marginFormLabelHorizontal: 16,
          marginFormLabelVertical: 4,
          marginFormTip: 4,
          marginFormFieldHorizontal: 16,
          marginFormFieldVertical: 20,
          marginFormFieldSet: 32,
          marginIcon: 8,
          marginChoice: 8,
          marginMenu: 2,
          marginTooltip: 8,
          marginTag: 4,
          marginTab: 32,
          marginBullet: 12,
          marginAttribute: 4,
          marginPopup: 24,
          sizeIconUI: 16,
          sizeIconHeader: 20,
          sizeIconWysiwyg: 14,
          sizeIllustrationS: 48,
          sizeIllustrationXM: 72,
          sizeIllustrationM: 96,
          sizeIllustrationL: 144,
          sizeIllustrationXXL: 228,
          sizeAvatarXS: 24,
          sizeAvatarS: 32,
          sizeAvatarM: 48,
          sizeAvatarL: 96,
          sizeAvatarXL: 128,
          widthTouch: "(width < 768px)",
          widthDesktopS: "(width >= 768px)",
          widthFromDesktopS: "(width >= 768px)",
          widthToTouch: "(width < 768px)",
          colorStateHover: {
            normal: "rgba(0, 0, 0, 0.04)"
          },
          colorStateActive: {
            normal: "rgba(0, 0, 0, 0.08)"
          },
          colorOverlay: {
            normal: "rgba(0, 0, 0, 0.48)"
          },
          colorText: {
            normal: "#333333"
          },
          colorTextSecondary: {
            normal: "#999999"
          },
          colorTextContrast: {
            normal: "#ffffff"
          },
          colorIcon: {
            normal: "#333333"
          },
          colorIconContrast: {
            normal: "#ffffff"
          },
          colorLink: {
            normal: "#005bd1"
          },
          colorLinkVisited: {
            normal: "#528fdf"
          },
          colorLinkContrast: {
            normal: "#ffffff"
          },
          colorTrueBlack: {
            normal: "#000000"
          },
          colorTrueWhite: {
            normal: "#ffffff"
          },
          colorState: {
            normal: "#000000"
          },
          colorAlert: {
            normal: "#c1341b"
          },
          colorIconSecondary: {
            normal: "#c7c7c7",
            hover: "#BFBFBF",
            active: "#B7B7B7"
          },
          colorBg: {
            normal: "#ffffff",
            hover: "#F5F5F5",
            active: "#EBEBEB"
          },
          colorBgPopup: {
            normal: "#ffffff",
            hover: "#F5F5F5",
            active: "#EBEBEB"
          },
          colorBgSecondary: {
            normal: "#f0f0f0",
            hover: "#E6E6E6",
            active: "#DDDDDD"
          },
          colorBgContrast: {
            normal: "#333333",
            hover: "#313131",
            active: "#2F2F2F"
          },
          colorBgThumbnail: {
            normal: "#00103d",
            hover: "#000F3B",
            active: "#000F38"
          },
          colorSuccess: {
            normal: "#28c75d",
            hover: "#26BF59",
            active: "#25B756"
          },
          colorError: {
            normal: "#ff1100",
            hover: "#F51000",
            active: "#EB1000"
          },
          colorWarning: {
            normal: "#fffce0",
            hover: "#F5F2D7",
            active: "#EBE8CE"
          },
          colorBgWarning: {
            normal: "#fffce0",
            hover: "#F5F2D7",
            active: "#EBE8CE"
          },
          colorRating: {
            normal: "#ffd400",
            hover: "#F5CC00",
            active: "#EBC300"
          },
          colorNotify: {
            normal: "#ff9e00",
            hover: "#F59800",
            active: "#EB9100"
          },
          colorSocialVk: {
            normal: "#4680C2",
            hover: "#437BBA",
            active: "#4076B2"
          },
          colorSocialOk: {
            normal: "#ee8208",
            hover: "#E47D08",
            active: "#DB7807"
          },
          colorSocialMir: {
            normal: "#117eda",
            hover: "#1079D1",
            active: "#1074C9"
          },
          colorSocialFb: {
            normal: "#0561af",
            hover: "#055DA8",
            active: "#0559A1"
          },
          colorSocialTwitter: {
            normal: "#00bff3",
            hover: "#00B7E9",
            active: "#00B0E0"
          },
          colorSocialDribbble: {
            normal: "#ea4c89",
            hover: "#E14984",
            active: "#D7467E"
          },
          colorSocialBehance: {
            normal: "#0057ff",
            hover: "#0054F5",
            active: "#0050EB"
          },
          colorPaletteRed1: {
            normal: "#fc2c38",
            hover: "#F22A36",
            active: "#E82834"
          },
          colorPaletteRed2: {
            normal: "#eb1981",
            hover: "#E2187C",
            active: "#D81777"
          },
          colorPaletteRed3: {
            normal: "#ff71bb",
            hover: "#F56CB4",
            active: "#EB68AC"
          },
          colorPaletteOrange1: {
            normal: "#ff8b2e",
            hover: "#F5852C",
            active: "#EB802A"
          },
          colorPaletteYellow1: {
            normal: "#ffc311",
            hover: "#F5BB10",
            active: "#EBB310"
          },
          colorPaletteGreen1: {
            normal: "#aee113",
            hover: "#A7D812",
            active: "#A0CF11"
          },
          colorPaletteGreen2: {
            normal: "#59c354",
            hover: "#55BB51",
            active: "#52B34D"
          },
          colorPaletteGreen3: {
            normal: "#37eb94",
            hover: "#35E28E",
            active: "#33D888"
          },
          colorPaletteGreen4: {
            normal: "#00b1b3",
            hover: "#00AAAC",
            active: "#00A3A5"
          },
          colorPaletteBlue1: {
            normal: "#2951ff",
            hover: "#274EF5",
            active: "#264BEB"
          },
          colorPaletteBlue2: {
            normal: "#00abf2",
            hover: "#00A4E8",
            active: "#009DDF"
          },
          colorPaletteBlue3: {
            normal: "#26dfdf",
            hover: "#24D6D6",
            active: "#23CDCD"
          },
          colorPaletteViolet1: {
            normal: "#6c00ff",
            hover: "#6800F5",
            active: "#6300EB"
          },
          colorPaletteViolet2: {
            normal: "#ae73ff",
            hover: "#A76EF5",
            active: "#A06AEB"
          }
        };
        exports.default = theme;
        /***/
      },

      /***/
      "./node_modules/2kit/node_modules/@paradigm/themes/mailID/desktop_s/index.js":
      /*!***********************************************************************************!*\
        !*** ./node_modules/2kit/node_modules/@paradigm/themes/mailID/desktop_s/index.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitNode_modulesParadigmThemesMailIDDesktop_sIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var theme = {
          x0: 0,
          x025: 1,
          x05: 2,
          x1: 4,
          x2: 8,
          x3: 12,
          x4: 16,
          x5: 20,
          x6: 24,
          x8: 32,
          x10: 40,
          x12: 48,
          x15: 60,
          x20: 80,
          sizeBase: 4,
          sizeGrid: 20,
          fontSize1: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize2: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize3: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize4: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 500,
            fontFamily: "MailSans, Helvetica, Arial, sans-serif"
          },
          fontSize5: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 500,
            fontFamily: "MailSans, Helvetica, Arial, sans-serif"
          },
          fontSize6: {
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 500,
            fontFamily: "MailSans, Helvetica, Arial, sans-serif"
          },
          fontSize7: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 500,
            fontFamily: "MailSans, Helvetica, Arial, sans-serif"
          },
          fontSize8: {
            fontSize: 44,
            lineHeight: "52px",
            fontWeight: 500,
            fontFamily: "MailSans, Helvetica, Arial, sans-serif"
          },
          toneValueX1: 0.04,
          toneValueX2: 0.08,
          toneValueX3: 0.12,
          toneValueX4: 0.16,
          toneValueX6: 0.24,
          toneValueX8: 0.32,
          toneValueX12: 0.48,
          toneValueX18: 0.72,
          toneValueOverlay: 0.48,
          toneValueBase: 0.48,
          toneValueViewer: 0.88,
          toneValueToolbar: 0.24,
          toneValueHover: 0.04,
          toneValueActive: 0.08,
          toneValueFocus: 0.08,
          depth0: "none",
          depth1: "none",
          depth2: "0 4px 20px 0 rgba(0,16,61, 0.12)",
          depth3: "0 20px 80px 0 rgba(0,16,61, 0.24)",
          depthInset: "none",
          colorBorder: {
            normal: "rgba(0,0,0,0.12)",
            hover: "rgba(0,0,0,0.24)",
            active: "rgba(0,0,0,0.48)",
            focus: "rgba(0,0,0,0.24)"
          },
          colorDivider: {
            normal: "rgba(0,16,61,0.12)"
          },
          typeBorderButton: "solid",
          typeBorderPosition: "inset",
          colorBgToolbar: {
            normal: "#005ff9",
            hover: "#0056E2",
            active: "#004CCC"
          },
          colorBgSidebar: {
            normal: "transparent",
            hover: "rgba(0, 16, 61, 0.04)",
            active: "rgba(0, 16, 61, 0.08)"
          },
          depthSidebar: "none",
          colorBgTint: "transparent",
          colorBgGradientTint: "transparent",
          animationDurationL: "0.4s",
          animationDurationM: "0.2s",
          animationDurationS: "0.1s",
          transitionEasingDefault: "cubic-bezier(0.3, 0.3, 0.5, 1)",
          paddingBase: 20,
          layoutWidthDesktopS: 768,
          colorPrimary: {
            normal: "#005ff9",
            hover: "#005CF1",
            active: "#0059EA"
          },
          colorSecondary: {
            normal: "#ff9e00",
            hover: "#F59802",
            active: "#EB9305"
          },
          sizeBorderWidth: 1,
          sizeBorderWidthTab: 2,
          sizeBorderWidthBar: 4,
          sizeBorderWidthAccent: 8,
          sizeBorderWidthAccentSecondary: 4,
          sizeBorderRadius: 4,
          sizeBorderRadiusPaper: 12,
          fontWeight: 400,
          fontWeightBold: 700,
          fontFamily: "Helvetica, Arial, sans-serif",
          fontSize: 15,
          lineHeight: 20,
          fontH0: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 24
          },
          fontH1: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 500,
            fontFamily: "MailSans, Helvetica, Arial, sans-serif",
            marginBottom: 20
          },
          fontH2: {
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 500,
            fontFamily: "MailSans, Helvetica, Arial, sans-serif",
            marginBottom: 16
          },
          fontH3: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 500,
            fontFamily: "MailSans, Helvetica, Arial, sans-serif"
          },
          fontH4: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontH5: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontH6: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontBody: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontParagraph: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 24
          },
          fontList: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontListItem: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontFootnote: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontLead: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontQuote: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontTableHeader: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontControl: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontControlLabel: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontTab: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontBadge: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            letterSpacing: "1px",
            textTransform: "uppercase"
          },
          fontDisclaimer: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          sizeControlHeight: 40,
          sizeControlButtonWidthMin: 104,
          sizeControlButtonSmallHeight: 32,
          sizeControlButtonSmallWidth: 104,
          sizeControlButtonIconWidth: 40,
          sizeControlButtonSliderHeight: 24,
          sizeControlButtonSliderWidth: 12,
          sizeControlButtonSliderWidthPointer: 16,
          sizeControlFieldWidthMin: 380,
          sizeControlLabelWidth: 184,
          sizeControlCheckHeight: 16,
          sizeControlCheckWidth: 16,
          sizeProgress: 4,
          sizeProgressScroll: 12,
          sizeDotBullet: 4,
          sizeDotIndicate: 8,
          sizeDotClickable: 12,
          sizeArrowHeight: 8,
          sizeArrowWidth: 12,
          sizePopupSmall: 420,
          sizePopupMedium: 680,
          sizePopupLarge: 880,
          paddingControlHorizontal: 12,
          paddingControlVertical: 0,
          paddingControlMore: 8,
          paddingControlMoreIcon: 8,
          paddingControlButton: 16,
          paddingControlButtonIcon: 20,
          paddingControlDiv: 4,
          paddingMenu: 8,
          paddingTag: 8,
          paddingTab: 16,
          paddingArrow: 12,
          paddingTableHorizontal: 16,
          paddingTableVertical: 16,
          paddingSliceTop: 40,
          paddingSliceBottom: 60,
          marginControl: 12,
          marginFormLabelHorizontal: 16,
          marginFormLabelVertical: 4,
          marginFormTip: 4,
          marginFormFieldHorizontal: 20,
          marginFormFieldVertical: 24,
          marginFormFieldSet: 32,
          marginIcon: 8,
          marginChoice: 8,
          marginMenu: 2,
          marginTooltip: 8,
          marginTag: 8,
          marginTab: 8,
          marginBullet: 12,
          marginAttribute: 4,
          marginPopup: 24,
          sizeIconUI: 18,
          sizeIconHeader: 20,
          sizeIconWysiwyg: 14,
          sizeIllustrationS: 48,
          sizeIllustrationXM: 72,
          sizeIllustrationM: 96,
          sizeIllustrationL: 144,
          sizeIllustrationXXL: 228,
          sizeAvatarXS: 24,
          sizeAvatarS: 32,
          sizeAvatarM: 48,
          sizeAvatarL: 96,
          sizeAvatarXL: 160,
          widthTouch: "(width < 768px)",
          widthDesktopS: "(width >= 768px)",
          widthFromDesktopS: "(width >= 768px)",
          widthToTouch: "(width < 768px)",
          colorStateHover: {
            normal: "rgba(0, 16, 61, 0.04)"
          },
          colorStateActive: {
            normal: "rgba(0, 16, 61, 0.08)"
          },
          colorOverlay: {
            normal: "rgba(0, 0, 0, 0.48)"
          },
          colorText: {
            normal: "#333333"
          },
          colorTextSecondary: {
            normal: "#93969B"
          },
          colorTextContrast: {
            normal: "#ffffff"
          },
          colorIcon: {
            normal: "#333333"
          },
          colorIconContrast: {
            normal: "#ffffff"
          },
          colorLink: {
            normal: "#005bd1"
          },
          colorLinkVisited: {
            normal: "#528fdf"
          },
          colorLinkContrast: {
            normal: "#ffffff"
          },
          colorTrueBlack: {
            normal: "#000000"
          },
          colorTrueWhite: {
            normal: "#ffffff"
          },
          colorState: {
            normal: "#00103D"
          },
          colorAlert: {
            normal: "#c1341b"
          },
          colorIconSecondary: {
            normal: "#B6B8BE",
            hover: "#AFB1B9",
            active: "#A7ABB4"
          },
          colorBg: {
            normal: "#ffffff",
            hover: "#F5F5F7",
            active: "#EBECEF"
          },
          colorBgPopup: {
            normal: "#ffffff",
            hover: "#F5F5F7",
            active: "#EBECEF"
          },
          colorBgSecondary: {
            normal: "#EBECEF",
            hover: "#E2E3E8",
            active: "#D8DAE1"
          },
          colorBgContrast: {
            normal: "#333333",
            hover: "#313233",
            active: "#2F3034"
          },
          colorBgThumbnail: {
            normal: "rgba(0, 16, 61, 0.08)",
            hover: "rgba(0, 16, 61, 0.12)",
            active: "rgba(0, 16, 61, 0.16)"
          },
          colorSuccess: {
            normal: "#28c75d",
            hover: "#26C05C",
            active: "#25B85A"
          },
          colorError: {
            normal: "#ff1100",
            hover: "#F51102",
            active: "#EB1105"
          },
          colorWarning: {
            normal: "#fffce0",
            hover: "#F5F3D9",
            active: "#EBE9D3"
          },
          colorBgWarning: {
            normal: "#fffce0",
            hover: "#F5F3D9",
            active: "#EBE9D3"
          },
          colorRating: {
            normal: "#ffd400",
            hover: "#F5CC02",
            active: "#EBC405"
          },
          colorNotify: {
            normal: "#ff9e00",
            hover: "#F59802",
            active: "#EB9305"
          },
          colorSocialVk: {
            normal: "#4680C2",
            hover: "#437CBD",
            active: "#4077B7"
          },
          colorSocialOk: {
            normal: "#ee8208",
            hover: "#E47D0A",
            active: "#DB790C"
          },
          colorSocialMir: {
            normal: "#117eda",
            hover: "#107AD4",
            active: "#1075CD"
          },
          colorSocialFb: {
            normal: "#0561af",
            hover: "#055EAA",
            active: "#055BA6"
          },
          colorSocialTwitter: {
            normal: "#00bff3",
            hover: "#00B8EC",
            active: "#00B1E4"
          },
          colorSocialDribbble: {
            normal: "#ea4c89",
            hover: "#E14A86",
            active: "#D74783"
          },
          colorSocialBehance: {
            normal: "#0057ff",
            hover: "#0054F7",
            active: "#0051EF"
          },
          colorPaletteRed1: {
            normal: "#fc2c38",
            hover: "#F22B38",
            active: "#E82A38"
          },
          colorPaletteRed2: {
            normal: "#eb1981",
            hover: "#E2197E",
            active: "#D8187C"
          },
          colorPaletteRed3: {
            normal: "#ff71bb",
            hover: "#F56DB6",
            active: "#EB69B1"
          },
          colorPaletteOrange1: {
            normal: "#ff8b2e",
            hover: "#F5862F",
            active: "#EB812F"
          },
          colorPaletteYellow1: {
            normal: "#ffc311",
            hover: "#F5BC13",
            active: "#EBB515"
          },
          colorPaletteGreen1: {
            normal: "#aee113",
            hover: "#A7D915",
            active: "#A0D016"
          },
          colorPaletteGreen2: {
            normal: "#59c354",
            hover: "#55BC53",
            active: "#52B552"
          },
          colorPaletteGreen3: {
            normal: "#37eb94",
            hover: "#35E291",
            active: "#33D98D"
          },
          colorPaletteGreen4: {
            normal: "#00b1b3",
            hover: "#00ABAE",
            active: "#00A4AA"
          },
          colorPaletteBlue1: {
            normal: "#2951ff",
            hover: "#274EF7",
            active: "#264CEF"
          },
          colorPaletteBlue2: {
            normal: "#00abf2",
            hover: "#00A5EB",
            active: "#009FE4"
          },
          colorPaletteBlue3: {
            normal: "#26dfdf",
            hover: "#24D7D9",
            active: "#23CED2"
          },
          colorPaletteViolet1: {
            normal: "#6c00ff",
            hover: "#6801F7",
            active: "#6301EF"
          },
          colorPaletteViolet2: {
            normal: "#ae73ff",
            hover: "#A76FF7",
            active: "#A06BEF"
          },
          colorIconFavorite: {
            normal: "#fc2c38",
            hover: "#F22B38",
            active: "#E82A38"
          },
          colorIconUnread: {
            normal: "#005ff9",
            hover: "#005CF1",
            active: "#0059EA"
          },
          colorBgPlaceholder: {
            normal: "#ffffff"
          },
          colorTextSidebar: {
            normal: "#333333"
          },
          colorIconSidebar: {
            normal: "#333333"
          },
          colorBorderSidebar: {
            normal: "rgba(0,0,0,0.12)"
          },
          colorScrollbar: {
            normal: "rgba(0, 16, 61, 0.48)"
          },
          colorBgHighlight: {
            normal: "#FFFBBF"
          },
          colorBgSecondaryFlat: {
            normal: "#f0f0f0",
            hover: "#E6E7E9",
            active: "#DDDEE2"
          },
          colorCategoryMailings: {
            normal: "#FC8A15",
            hover: "#F28517",
            active: "#E88018"
          },
          colorCategorySocial: {
            normal: "#4F6DDC",
            hover: "#4C69D6",
            active: "#4966CF"
          },
          colorCategoryShopping: {
            normal: "#FF54AA",
            hover: "#F551A6",
            active: "#EB4FA1"
          },
          colorCategoryRegistrations: {
            normal: "#FF9E02",
            hover: "#F59804",
            active: "#EB9307"
          },
          colorCategoryFinance: {
            normal: "#07BB3F",
            hover: "#07B43F",
            active: "#06AD3F"
          },
          colorCategoryTicket: {
            normal: "#09A6FA",
            hover: "#09A0F2",
            active: "#089AEB"
          },
          colorCategoryTravel: {
            normal: "#BA34FC",
            hover: "#B333F4",
            active: "#AB31ED"
          },
          colorCategoryFees: {
            normal: "#E60000",
            hover: "#DD0102",
            active: "#D40105"
          }
        };
        exports.default = theme;
        /***/
      },

      /***/
      "./node_modules/2kit/node_modules/@paradigm/themes/octavius/desktop_s/index.js":
      /*!*************************************************************************************!*\
        !*** ./node_modules/2kit/node_modules/@paradigm/themes/octavius/desktop_s/index.js ***!
        \*************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitNode_modulesParadigmThemesOctaviusDesktop_sIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var theme = {
          x0: 0,
          x025: 1,
          x05: 2,
          x1: 4,
          x2: 8,
          x3: 12,
          x4: 16,
          x5: 20,
          x6: 24,
          x8: 32,
          x10: 40,
          x12: 48,
          x15: 60,
          x20: 80,
          sizeBase: 4,
          sizeGrid: 20,
          fontSize1: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize2: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize3: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize4: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize5: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize6: {
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize7: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontSize8: {
            fontSize: 44,
            lineHeight: "52px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          toneValueX1: 0.04,
          toneValueX2: 0.08,
          toneValueX3: 0.12,
          toneValueX4: 0.16,
          toneValueX6: 0.24,
          toneValueX8: 0.32,
          toneValueX12: 0.48,
          toneValueX18: 0.72,
          toneValueOverlay: 0.48,
          toneValueBase: 0.48,
          toneValueViewer: 0.88,
          toneValueToolbar: 0.24,
          toneValueHover: 0.04,
          toneValueActive: 0.08,
          toneValueFocus: 0.08,
          depth0: "none",
          depth1: "0 2px 0 0 rgba(0, 16, 61, 0.04)",
          depth2: "0 4px 32px 0 rgba(0, 16, 61, 0.32)",
          depth3: "0 16px 48px 0 rgba(0, 0, 0, 0.48)",
          depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
          colorBorder: {
            normal: "rgba(0,0,0,0.12)",
            hover: "rgba(0,0,0,0.24)",
            active: "rgba(0,0,0,0.48)",
            focus: "rgba(0,0,0,0.24)"
          },
          colorDivider: {
            normal: "rgba(0,16,61,0.12)"
          },
          typeBorderButton: "solid",
          typeBorderPosition: "inset",
          colorBgToolbar: {
            normal: "#005ff9",
            hover: "#0056E2",
            active: "#004CCC"
          },
          colorBgSidebar: {
            normal: "transparent",
            hover: "rgba(0, 16, 61, 0.04)",
            active: "rgba(0, 16, 61, 0.08)"
          },
          depthSidebar: "none",
          colorBgTint: "transparent",
          colorBgGradientTint: "transparent",
          animationDurationL: "0.4s",
          animationDurationM: "0.2s",
          animationDurationS: "0.1s",
          transitionEasingDefault: "cubic-bezier(0.3, 0.3, 0.5, 1)",
          paddingBase: 20,
          layoutWidthDesktopS: 768,
          colorPrimary: {
            normal: "#005ff9",
            hover: "#005CF1",
            active: "#0059EA"
          },
          colorSecondary: {
            normal: "#ff9e00",
            hover: "#F59802",
            active: "#EB9305"
          },
          sizeBorderWidth: 1,
          sizeBorderWidthTab: 2,
          sizeBorderWidthBar: 4,
          sizeBorderWidthAccent: 8,
          sizeBorderWidthAccentSecondary: 4,
          sizeBorderRadius: 4,
          sizeBorderRadiusPaper: 12,
          fontWeight: 400,
          fontWeightBold: 700,
          fontFamily: "Helvetica, Arial, sans-serif",
          fontSize: 15,
          lineHeight: 20,
          fontH0: {
            fontSize: 32,
            lineHeight: "40px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 24
          },
          fontH1: {
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 20
          },
          fontH2: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 16
          },
          fontH3: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 12
          },
          fontH4: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontH5: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontH6: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 8
          },
          fontBody: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontParagraph: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif",
            marginBottom: 24
          },
          fontList: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontListItem: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontFootnote: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontLead: {
            fontSize: 20,
            lineHeight: "28px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontQuote: {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontTableHeader: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontControl: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontControlLabel: {
            fontSize: 13,
            lineHeight: "20px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontTab: {
            fontSize: 15,
            lineHeight: "20px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          fontBadge: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 700,
            fontFamily: "Helvetica, Arial, sans-serif",
            letterSpacing: "1px",
            textTransform: "uppercase"
          },
          fontDisclaimer: {
            fontSize: 11,
            lineHeight: "12px",
            fontWeight: 400,
            fontFamily: "Helvetica, Arial, sans-serif"
          },
          sizeControlHeight: 40,
          sizeControlButtonWidthMin: 104,
          sizeControlButtonSmallHeight: 32,
          sizeControlButtonSmallWidth: 104,
          sizeControlButtonIconWidth: 40,
          sizeControlButtonSliderHeight: 24,
          sizeControlButtonSliderWidth: 12,
          sizeControlButtonSliderWidthPointer: 16,
          sizeControlFieldWidthMin: 380,
          sizeControlLabelWidth: 184,
          sizeControlCheckHeight: 16,
          sizeControlCheckWidth: 16,
          sizeProgress: 4,
          sizeProgressScroll: 12,
          sizeDotBullet: 4,
          sizeDotIndicate: 8,
          sizeDotClickable: 12,
          sizeArrowHeight: 8,
          sizeArrowWidth: 12,
          sizePopupSmall: 420,
          sizePopupMedium: 680,
          sizePopupLarge: 880,
          paddingControlHorizontal: 12,
          paddingControlVertical: 0,
          paddingControlMore: 8,
          paddingControlMoreIcon: 8,
          paddingControlButton: 16,
          paddingControlButtonIcon: 20,
          paddingControlDiv: 4,
          paddingMenu: 8,
          paddingTag: 8,
          paddingTab: 16,
          paddingArrow: 12,
          paddingTableHorizontal: 16,
          paddingTableVertical: 16,
          paddingSliceTop: 40,
          paddingSliceBottom: 60,
          marginControl: 12,
          marginFormLabelHorizontal: 16,
          marginFormLabelVertical: 4,
          marginFormTip: 4,
          marginFormFieldHorizontal: 20,
          marginFormFieldVertical: 24,
          marginFormFieldSet: 32,
          marginIcon: 8,
          marginChoice: 8,
          marginMenu: 2,
          marginTooltip: 8,
          marginTag: 8,
          marginTab: 8,
          marginBullet: 12,
          marginAttribute: 4,
          marginPopup: 24,
          sizeIconUI: 18,
          sizeIconHeader: 20,
          sizeIconWysiwyg: 14,
          sizeIllustrationS: 48,
          sizeIllustrationXM: 72,
          sizeIllustrationM: 96,
          sizeIllustrationL: 144,
          sizeIllustrationXXL: 228,
          sizeAvatarXS: 24,
          sizeAvatarS: 32,
          sizeAvatarM: 48,
          sizeAvatarL: 96,
          sizeAvatarXL: 128,
          widthTouch: "(width < 768px)",
          widthDesktopS: "(width >= 768px)",
          widthFromDesktopS: "(width >= 768px)",
          widthToTouch: "(width < 768px)",
          colorStateHover: {
            normal: "rgba(0, 16, 61, 0.04)"
          },
          colorStateActive: {
            normal: "rgba(0, 16, 61, 0.08)"
          },
          colorOverlay: {
            normal: "rgba(0, 0, 0, 0.48)"
          },
          colorText: {
            normal: "#333333"
          },
          colorTextSecondary: {
            normal: "#999999"
          },
          colorTextContrast: {
            normal: "#ffffff"
          },
          colorIcon: {
            normal: "#333333"
          },
          colorIconContrast: {
            normal: "#ffffff"
          },
          colorLink: {
            normal: "#005bd1"
          },
          colorLinkVisited: {
            normal: "#528fdf"
          },
          colorLinkContrast: {
            normal: "#ffffff"
          },
          colorTrueBlack: {
            normal: "#000000"
          },
          colorTrueWhite: {
            normal: "#ffffff"
          },
          colorState: {
            normal: "#00103d"
          },
          colorAlert: {
            normal: "#c1341b"
          },
          colorIconSecondary: {
            normal: "#c7c7c7",
            hover: "#BFC0C1",
            active: "#B7B8BC"
          },
          colorBg: {
            normal: "#ffffff",
            hover: "#F5F5F7",
            active: "#EBECEF"
          },
          colorBgPopup: {
            normal: "#ffffff",
            hover: "#F5F5F7",
            active: "#EBECEF"
          },
          colorBgSecondary: {
            normal: "#f0f0f0",
            hover: "#E6E7E9",
            active: "#DDDEE2"
          },
          colorBgContrast: {
            normal: "#333333",
            hover: "#313233",
            active: "#2F3034"
          },
          colorBgThumbnail: {
            normal: "rgba(0, 16, 61, 0.08)",
            hover: "rgba(0, 16, 61, 0.12)",
            active: "rgba(0, 16, 61, 0.16)"
          },
          colorSuccess: {
            normal: "#28c75d",
            hover: "#26C05C",
            active: "#25B85A"
          },
          colorError: {
            normal: "#ff1100",
            hover: "#F51102",
            active: "#EB1105"
          },
          colorWarning: {
            normal: "#fffce0",
            hover: "#F5F3D9",
            active: "#EBE9D3"
          },
          colorBgWarning: {
            normal: "#fffce0",
            hover: "#F5F3D9",
            active: "#EBE9D3"
          },
          colorRating: {
            normal: "#ffd400",
            hover: "#F5CC02",
            active: "#EBC405"
          },
          colorNotify: {
            normal: "#ff9e00",
            hover: "#F59802",
            active: "#EB9305"
          },
          colorSocialVk: {
            normal: "#4680C2",
            hover: "#437CBD",
            active: "#4077B7"
          },
          colorSocialOk: {
            normal: "#ee8208",
            hover: "#E47D0A",
            active: "#DB790C"
          },
          colorSocialMir: {
            normal: "#117eda",
            hover: "#107AD4",
            active: "#1075CD"
          },
          colorSocialFb: {
            normal: "#0561af",
            hover: "#055EAA",
            active: "#055BA6"
          },
          colorSocialTwitter: {
            normal: "#00bff3",
            hover: "#00B8EC",
            active: "#00B1E4"
          },
          colorSocialDribbble: {
            normal: "#ea4c89",
            hover: "#E14A86",
            active: "#D74783"
          },
          colorSocialBehance: {
            normal: "#0057ff",
            hover: "#0054F7",
            active: "#0051EF"
          },
          colorPaletteRed1: {
            normal: "#fc2c38",
            hover: "#F22B38",
            active: "#E82A38"
          },
          colorPaletteRed2: {
            normal: "#eb1981",
            hover: "#E2197E",
            active: "#D8187C"
          },
          colorPaletteRed3: {
            normal: "#ff71bb",
            hover: "#F56DB6",
            active: "#EB69B1"
          },
          colorPaletteOrange1: {
            normal: "#ff8b2e",
            hover: "#F5862F",
            active: "#EB812F"
          },
          colorPaletteYellow1: {
            normal: "#ffc311",
            hover: "#F5BC13",
            active: "#EBB515"
          },
          colorPaletteGreen1: {
            normal: "#aee113",
            hover: "#A7D915",
            active: "#A0D016"
          },
          colorPaletteGreen2: {
            normal: "#59c354",
            hover: "#55BC53",
            active: "#52B552"
          },
          colorPaletteGreen3: {
            normal: "#37eb94",
            hover: "#35E291",
            active: "#33D98D"
          },
          colorPaletteGreen4: {
            normal: "#00b1b3",
            hover: "#00ABAE",
            active: "#00A4AA"
          },
          colorPaletteBlue1: {
            normal: "#2951ff",
            hover: "#274EF7",
            active: "#264CEF"
          },
          colorPaletteBlue2: {
            normal: "#00abf2",
            hover: "#00A5EB",
            active: "#009FE4"
          },
          colorPaletteBlue3: {
            normal: "#26dfdf",
            hover: "#24D7D9",
            active: "#23CED2"
          },
          colorPaletteViolet1: {
            normal: "#6c00ff",
            hover: "#6801F7",
            active: "#6301EF"
          },
          colorPaletteViolet2: {
            normal: "#ae73ff",
            hover: "#A76FF7",
            active: "#A06BEF"
          },
          colorIconFavorite: {
            normal: "#fc2c38",
            hover: "#F22B38",
            active: "#E82A38"
          },
          colorIconUnread: {
            normal: "#005ff9",
            hover: "#005CF1",
            active: "#0059EA"
          },
          colorBgPlaceholder: {
            normal: "#ffffff"
          },
          colorTextSidebar: {
            normal: "#333333"
          },
          colorIconSidebar: {
            normal: "#333333"
          },
          colorBorderSidebar: {
            normal: "rgba(0,0,0,0.12)"
          },
          colorScrollbar: {
            normal: "rgba(0, 16, 61, 0.48)"
          },
          colorBgHighlight: {
            normal: "#FFFBBF"
          },
          colorBgSecondaryFlat: {
            normal: "#f0f0f0",
            hover: "#E6E7E9",
            active: "#DDDEE2"
          },
          colorCategoryMailings: {
            normal: "#FC8A15",
            hover: "#F28517",
            active: "#E88018"
          },
          colorCategorySocial: {
            normal: "#4F6DDC",
            hover: "#4C69D6",
            active: "#4966CF"
          },
          colorCategoryShopping: {
            normal: "#FF54AA",
            hover: "#F551A6",
            active: "#EB4FA1"
          },
          colorCategoryRegistrations: {
            normal: "#FF9E02",
            hover: "#F59804",
            active: "#EB9307"
          },
          colorCategoryFinance: {
            normal: "#07BB3F",
            hover: "#07B43F",
            active: "#06AD3F"
          },
          colorCategoryTicket: {
            normal: "#09A6FA",
            hover: "#09A0F2",
            active: "#089AEB"
          },
          colorCategoryTravel: {
            normal: "#BA34FC",
            hover: "#B333F4",
            active: "#AB31ED"
          },
          colorCategoryFees: {
            normal: "#E60000",
            hover: "#DD0102",
            active: "#D40105"
          }
        };
        exports.default = theme;
        /***/
      },

      /***/
      "./node_modules/2kit/node_modules/@paradigm/themes/octavius/subthemes/black/index.js":
      /*!*******************************************************************************************!*\
        !*** ./node_modules/2kit/node_modules/@paradigm/themes/octavius/subthemes/black/index.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitNode_modulesParadigmThemesOctaviusSubthemesBlackIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var theme = {
          toneValueHover: 0.08,
          toneValueActive: 0.12,
          toneValueFocus: 0.48,
          toneValueOverlay: 0.72,
          colorBgSidebar: {
            normal: "transparent",
            hover: "rgba(255, 255, 255, 0.12)",
            active: "rgba(255, 255, 255, 0.24)"
          },
          colorBgToolbar: {
            normal: "#000000",
            hover: "#1F1F1F",
            active: "#3D3D3D"
          },
          colorBorder: {
            normal: "rgba(255, 255, 255, 0.2)",
            hover: "rgba(255, 255, 255, 0.32)",
            active: "rgba(255, 255, 255, 0.48)",
            focus: "rgba(255, 255, 255, 0.48)"
          },
          depthSidebar: "none",
          depth3: "0 4px 32px 0 rgba(0, 0, 0, 0.48)",
          depth2: "0 4px 48px 0 rgba(0, 0, 0, 0.72)",
          depth1: "0 2px 0 0 rgba(0, 0, 0, 0.04)",
          depth0: "none",
          depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
          colorBgTint: "transparent",
          colorBgGradientTint: "transparent",
          colorStateHover: {
            normal: "rgba(255, 255, 255, 0.08)"
          },
          colorStateActive: {
            normal: "rgba(255, 255, 255, 0.12)"
          },
          colorOverlay: {
            normal: "rgba(0, 0, 0, 0.72)"
          },
          colorState: {
            normal: "#FFFFFF"
          },
          colorLink: {
            normal: "#589BFF"
          },
          colorLinkVisited: {
            normal: "#6492DA"
          },
          colorIconFavorite: {
            normal: "#FC2C38",
            hover: "#FC3D48",
            active: "#FC4550"
          },
          colorIconUnread: {
            normal: "#0C7CFF",
            hover: "#1F86FF",
            active: "#298CFF"
          },
          colorText: {
            normal: "#D7D7D7"
          },
          colorTextSecondary: {
            normal: "#7B7B7B"
          },
          colorTextAccent: {
            normal: "#ffffff"
          },
          colorTextSidebar: {
            normal: "#FFFFFF"
          },
          colorIcon: {
            normal: "#D7D7D7"
          },
          colorIconSecondary: {
            normal: "#707070",
            hover: "#7B7B7B",
            active: "#818181"
          },
          colorIconAccent: {
            normal: "#ffffff"
          },
          colorIconSidebar: {
            normal: "#FFFFFF"
          },
          colorBorderSidebar: {
            normal: "rgba(255, 255, 255, 0.12)"
          },
          colorScrollbar: {
            normal: "#707070"
          },
          colorBgPlaceholder: {
            normal: "#000000"
          },
          colorDivider: {
            normal: "rgba(0, 0, 0, 0.4)"
          },
          colorPrimary: {
            normal: "#0C7CFF",
            hover: "#1F86FF",
            active: "#298CFF"
          },
          colorBg: {
            normal: "#1F1F1F",
            hover: "#313131",
            active: "#3A3A3A"
          },
          colorBgHighlight: {
            normal: "#6C4E00"
          },
          colorBgPopup: {
            normal: "#313131",
            hover: "#414141",
            active: "#4A4A4A"
          },
          colorBgSecondary: {
            normal: "rgba(255, 255, 255, 0.08)",
            hover: "rgba(255, 255, 255, 0.16)",
            active: "rgba(255, 255, 255, 0.2)"
          },
          colorBgSecondaryFlat: {
            normal: "#313131",
            hover: "#414141",
            active: "#4A4A4A"
          },
          colorBgThumbnail: {
            normal: "#1F1F1F",
            hover: "#313131",
            active: "#3A3A3A"
          },
          colorCategoryMailings: {
            normal: "#FF9C37",
            hover: "#FFA447",
            active: "#FFA84F"
          },
          colorCategorySocial: {
            normal: "#7288FF",
            hover: "#7D92FF",
            active: "#8396FF"
          },
          colorCategoryShopping: {
            normal: "#F94CA3",
            hover: "#F95AAA",
            active: "#FA61AE"
          },
          colorCategoryRegistrations: {
            normal: "#EEAC2C",
            hover: "#EFB33D",
            active: "#F0B645"
          },
          colorCategoryFinance: {
            normal: "#24C780",
            hover: "#36CB8A",
            active: "#3ECE8F"
          },
          colorCategoryTicket: {
            normal: "#3BBAFE",
            hover: "#4BC0FE",
            active: "#53C2FE"
          },
          colorCategoryTravel: {
            normal: "#C15DF3",
            hover: "#C66AF4",
            active: "#C870F4"
          },
          colorCategoryFees: {
            normal: "#EE3C3C",
            hover: "#EF4C4C",
            active: "#F05353"
          }
        };
        exports.default = theme;
        /***/
      },

      /***/
      "./node_modules/2kit/node_modules/@paradigm/themes/octavius/subthemes/dit/index.js":
      /*!*****************************************************************************************!*\
        !*** ./node_modules/2kit/node_modules/@paradigm/themes/octavius/subthemes/dit/index.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modules2kitNode_modulesParadigmThemesOctaviusSubthemesDitIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var theme = {
          colorBorder: {
            normal: "rgba(0,0,0,0.12)",
            hover: "rgba(0,0,0,0.24)",
            active: "rgba(0,0,0,0.48)",
            focus: "rgba(0,0,0,0.24)"
          },
          toneValueHover: 0.04,
          toneValueActive: 0.08,
          toneValueFocus: 0.08,
          toneValueOverlay: 0.48,
          colorBgToolbar: {
            normal: "#2e72bf",
            hover: "#2864A8",
            active: "#235791"
          },
          colorBgSidebar: {
            normal: "transparent",
            hover: "rgba(0, 16, 61, 0.04)",
            active: "rgba(0, 16, 61, 0.08)"
          },
          depthSidebar: "none",
          depth0: "none",
          depth1: "0 2px 0 0 rgba(0, 16, 61, 0.04)",
          depth2: "0 4px 32px 0 rgba(0, 16, 61, 0.32)",
          depth3: "0 16px 48px 0 rgba(0, 0, 0, 0.48)",
          depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
          colorBgTint: "transparent",
          colorBgGradientTint: "transparent",
          colorStateHover: {
            normal: "rgba(0, 16, 61, 0.04)"
          },
          colorStateActive: {
            normal: "rgba(0, 16, 61, 0.08)"
          },
          colorOverlay: {
            normal: "rgba(0, 0, 0, 0.48)"
          },
          colorState: {
            normal: "#00103d"
          },
          colorLink: {
            normal: "#005bd1"
          },
          colorLinkVisited: {
            normal: "#528fdf"
          },
          colorIconFavorite: {
            normal: "#fc2c38",
            hover: "#F22B38",
            active: "#E82A38"
          },
          colorIconUnread: {
            normal: "#005ff9",
            hover: "#005CF1",
            active: "#0059EA"
          },
          colorBgPlaceholder: {
            normal: "#ffffff"
          },
          colorText: {
            normal: "#333333"
          },
          colorTextSecondary: {
            normal: "#999999"
          },
          colorTextSidebar: {
            normal: "#333333"
          },
          colorIcon: {
            normal: "#333333"
          },
          colorIconSecondary: {
            normal: "#c7c7c7",
            hover: "#BFC0C1",
            active: "#B7B8BC"
          },
          colorIconSidebar: {
            normal: "#333333"
          },
          colorBorderSidebar: {
            normal: "rgba(0,0,0,0.12)"
          },
          colorDivider: {
            normal: "rgba(0,16,61,0.12)"
          },
          colorScrollbar: {
            normal: "rgba(0, 16, 61, 0.48)"
          },
          colorPrimary: {
            normal: "#2e72bf",
            hover: "#2C6EBA",
            active: "#2A6AB5"
          },
          colorBg: {
            normal: "#ffffff",
            hover: "#F5F5F7",
            active: "#EBECEF"
          },
          colorBgHighlight: {
            normal: "#FFFBBF"
          },
          colorBgSecondary: {
            normal: "#f0f0f0",
            hover: "#E6E7E9",
            active: "#DDDEE2"
          },
          colorBgSecondaryFlat: {
            normal: "#f0f0f0",
            hover: "#E6E7E9",
            active: "#DDDEE2"
          },
          colorBgPopup: {
            normal: "#ffffff",
            hover: "#F5F5F7",
            active: "#EBECEF"
          },
          colorBgThumbnail: {
            normal: "rgba(0, 16, 61, 0.08)",
            hover: "rgba(0, 16, 61, 0.12)",
            active: "rgba(0, 16, 61, 0.16)"
          },
          colorCategoryMailings: {
            normal: "#FC8A15",
            hover: "#F28517",
            active: "#E88018"
          },
          colorCategorySocial: {
            normal: "#4F6DDC",
            hover: "#4C69D6",
            active: "#4966CF"
          },
          colorCategoryShopping: {
            normal: "#FF54AA",
            hover: "#F551A6",
            active: "#EB4FA1"
          },
          colorCategoryRegistrations: {
            normal: "#FF9E02",
            hover: "#F59804",
            active: "#EB9307"
          },
          colorCategoryFinance: {
            normal: "#07BB3F",
            hover: "#07B43F",
            active: "#06AD3F"
          },
          colorCategoryTicket: {
            normal: "#09A6FA",
            hover: "#09A0F2",
            active: "#089AEB"
          },
          colorCategoryTravel: {
            normal: "#BA34FC",
            hover: "#B333F4",
            active: "#AB31ED"
          },
          colorCategoryFees: {
            normal: "#E60000",
            hover: "#DD0102",
            active: "#D40105"
          }
        };
        exports.default = theme;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js ***!
        \*********************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesBabelRuntimeHelpersEsmArrayLikeToArrayJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _arrayLikeToArray;
        });

        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;

          for (var i = 0, arr2 = new Array(len); i < len; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        }
        /***/

      },

      /***/
      "./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js ***!
        \**********************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesBabelRuntimeHelpersEsmArrayWithoutHolesJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _arrayWithoutHoles;
        });
        /* harmony import */


        var _arrayLikeToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./arrayLikeToArray */
        "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return Object(_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(arr);
        }
        /***/

      },

      /***/
      "./node_modules/@babel/runtime/helpers/esm/iterableToArray.js":
      /*!********************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js ***!
        \********************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesBabelRuntimeHelpersEsmIterableToArrayJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _iterableToArray;
        });

        function _iterableToArray(iter) {
          if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
        }
        /***/

      },

      /***/
      "./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js ***!
        \**********************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesBabelRuntimeHelpersEsmNonIterableSpreadJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _nonIterableSpread;
        });

        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        /***/

      },

      /***/
      "./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js ***!
        \**********************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesBabelRuntimeHelpersEsmToConsumableArrayJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _toConsumableArray;
        });
        /* harmony import */


        var _arrayWithoutHoles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./arrayWithoutHoles */
        "./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js");
        /* harmony import */


        var _iterableToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./iterableToArray */
        "./node_modules/@babel/runtime/helpers/esm/iterableToArray.js");
        /* harmony import */


        var _unsupportedIterableToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./unsupportedIterableToArray */
        "./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
        /* harmony import */


        var _nonIterableSpread__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./nonIterableSpread */
        "./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js");

        function _toConsumableArray(arr) {
          return Object(_arrayWithoutHoles__WEBPACK_IMPORTED_MODULE_0__["default"])(arr) || Object(_iterableToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(arr) || Object(_unsupportedIterableToArray__WEBPACK_IMPORTED_MODULE_2__["default"])(arr) || Object(_nonIterableSpread__WEBPACK_IMPORTED_MODULE_3__["default"])();
        }
        /***/

      },

      /***/
      "./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js":
      /*!*******************************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js ***!
        \*******************************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesBabelRuntimeHelpersEsmUnsupportedIterableToArrayJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _unsupportedIterableToArray;
        });
        /* harmony import */


        var _arrayLikeToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./arrayLikeToArray */
        "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return Object(_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
        }
        /***/

      },

      /***/
      "./node_modules/@mail/Emitter/main.js":
      /*!********************************************!*\
        !*** ./node_modules/@mail/Emitter/main.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesMailEmitterMainJs(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        /**
        * @author RubaXa <trash@rubaxa.org>
        * @license MIT
        */


        (function () {
          "use strict";

          var RDASH = /-/g,
              RSPACE = /\s+/,
              r_camelCase = /-(.)/g,
              camelCase = function camelCase(_, chr) {
            return chr.toUpperCase();
          },
              hasOwn = {}.hasOwnProperty,
              emptyArray = [];
          /**
           * Получить список слушателей
           * @param    {Object}  target
           * @param    {string}  name
           * @returns  {Array}
           * @memberOf Emitter
           */


          function getListeners(target, name) {
            var list = target.__emList;
            name = name.toLowerCase().replace(RDASH, '');

            if (list === void 0) {
              list = target.__emList = {};
              list[name] = [];
            } else if (list[name] === void 0) {
              list[name] = [];
            }

            return list[name];
          }
          /**
           * Излучатель событий
           * @class Emitter
           * @constructs Emitter
           */


          var Emitter = function Emitter() {};

          Emitter.fn = Emitter.prototype =
          /** @lends Emitter# */
          {
            constructor: Emitter,

            /**
             * Прикрепить обработчик для одного или нескольких событий, поддерживается `handleEvent`
             * @param   {string}    events  одно или несколько событий, разделенных пробелом
             * @param   {Function}  fn      функция обработчик
             * @returns {Emitter}
             */
            on: function on(events, fn) {
              events = events.split(RSPACE);
              var n = events.length,
                  list;

              while (n--) {
                list = getListeners(this, events[n]);
                list.push(fn);
              }

              return this;
            },

            /**
             * Удалить обработчик для одного или нескольких событий
             * @param   {string}    [events]  одно или несколько событий, разделенных пробелом
             * @param   {Function}  [fn]      функция обработчик, если не передать, будут отвязаны все обработчики
             * @returns {Emitter}
             */
            off: function off(events, fn) {
              if (events === void 0) {
                this.__emList = events;
              } else {
                events = events.split(RSPACE);
                var n = events.length;

                while (n--) {
                  var list = getListeners(this, events[n]),
                      i = list.length,
                      idx = -1;

                  if (arguments.length === 1) {
                    list.splice(0, 1e5); // dirty hack
                  } else {
                    if (list.indexOf) {
                      idx = list.indexOf(fn);
                    } else {
                      // old browsers
                      while (i--) {
                        /* istanbul ignore else */
                        if (list[i] === fn) {
                          idx = i;
                          break;
                        }
                      }
                    }

                    if (idx !== -1) {
                      list.splice(idx, 1);
                    }
                  }
                }
              }

              return this;
            },

            /**
             * Прикрепить обработчик события, который выполняется единожды
             * @param   {string}    events  событие или список
             * @param   {Function}  fn      функция обработчик
             * @returns {Emitter}
             */
            one: function one(events, fn) {
              var proxy = function proxy() {
                this.off(events, proxy);
                return fn.apply(this, arguments);
              };

              return this.on(events, proxy);
            },

            /**
             * Распространить событие
             * @param   {string}  type    тип события
             * @param   {Array}   [args]  аргумент или массив аргументов
             * @returns {*}
             */
            emit: function emit(type, args) {
              var list = getListeners(this, type),
                  i = list.length,
                  fn,
                  ctx,
                  tmp,
                  retVal,
                  argsLength;
              type = 'on' + type.charAt(0).toUpperCase() + type.substr(1);

              if (type.indexOf('-') > -1) {
                type = type.replace(r_camelCase, camelCase);
              }

              if (typeof this[type] === 'function') {
                retVal = this[type].apply(this, [].concat(args));
              }

              if (i > 0) {
                args = args === void 0 ? emptyArray : [].concat(args);
                argsLength = args.length;

                while (i--) {
                  fn = list[i];
                  ctx = this;
                  /* istanbul ignore else */

                  if (fn !== void 0) {
                    if (fn.handleEvent !== void 0) {
                      ctx = fn;
                      fn = fn.handleEvent;
                    }

                    if (argsLength === 0) {
                      tmp = fn.call(ctx);
                    } else if (argsLength === 1) {
                      tmp = fn.call(ctx, args[0]);
                    } else if (argsLength === 2) {
                      tmp = fn.call(ctx, args[0], args[1]);
                    } else {
                      tmp = fn.apply(ctx, args);
                    }

                    if (tmp !== void 0) {
                      retVal = tmp;
                    }
                  }
                }
              }

              return retVal;
            },

            /**
             * Распространить `Emitter.Event`
             * @param   {string}  type    тип события
             * @param   {Array}   [args]  аргумент или массив аргументов
             * @param   {*}   [details]  детали объекта события
             * @returns {Emitter}
             */
            trigger: function trigger(type, args, details) {
              var evt = new Event(type);
              evt.target = evt.target || this;
              evt.details = details;
              evt.result = this.emit(type.type || type, [evt].concat(args));
              return this;
            }
          };
          /**
           * Событие
           * @class Emitter.Event
           * @constructs Emitter.Event
           * @param   {string|Object|Event}  type  тип события
           * @returns {Emitter.Event}
           */

          function Event(type) {
            if (type instanceof Event) {
              return type;
            }

            if (type.type) {
              for (var key in type) {
                /* istanbul ignore else */
                if (hasOwn.call(type, key)) {
                  this[key] = type[key];
                }
              }

              type = type.type;
            }

            this.type = type.toLowerCase().replace(RDASH, '');
          }

          Event.fn = Event.prototype =
          /** @lends Emitter.Event# */
          {
            constructor: Event,

            /**
             * Действие по умолчанию отмененом
             * @type {boolean}
             */
            defaultPrevented: false,

            /**
             * Вcплытие события отменено
             * @type {boolean}
             */
            propagationStopped: false,

            /**
             * Позволяет определить, было ли отменено действие по умолчанию
             * @returns {boolean}
             */
            isDefaultPrevented: function isDefaultPrevented() {
              return this.defaultPrevented;
            },

            /**
             * Отменить действие по умолчанию
             */
            preventDefault: function preventDefault() {
              this.defaultPrevented = true;
            },

            /**
             * Остановить продвижение события
             */
            stopPropagation: function stopPropagation() {
              this.propagationStopped = true;
            },

            /**
             * Позволяет определить, было ли отменено продвижение события
             * @return {boolean}
             */
            isPropagationStopped: function isPropagationStopped() {
              return this.propagationStopped;
            }
          };
          /**
           * Подмешать методы к объекту
           * @static
           * @memberof Emitter
           * @param   {Object}  target    цель
           * @returns {Object}
           */

          Emitter.apply = function (target) {
            target.on = Emitter.fn.on;
            target.off = Emitter.fn.off;
            target.one = Emitter.fn.one;
            target.emit = Emitter.fn.emit;
            target.trigger = Emitter.fn.trigger;
            return target;
          }; // Версия модуля


          Emitter.version = "0.4.0"; // exports

          Emitter.Event = Event;
          Emitter.getListeners = getListeners;

          if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return Emitter;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })();
        /***/

      },

      /***/
      "./node_modules/@mail/jss-preset-2kit/lib/index.js":
      /*!*********************************************************!*\
        !*** ./node_modules/@mail/jss-preset-2kit/lib/index.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesMailJssPreset2kitLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _jssTemplate = __webpack_require__(
        /*! jss-template */
        "./node_modules/jss-template/lib/index.js");

        var _jssTemplate2 = _interopRequireDefault(_jssTemplate);

        var _jssGlobal = __webpack_require__(
        /*! jss-global */
        "./node_modules/jss-global/lib/index.js");

        var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

        var _jssExtend = __webpack_require__(
        /*! jss-extend */
        "./node_modules/jss-extend/lib/index.js");

        var _jssExtend2 = _interopRequireDefault(_jssExtend);

        var _jssNested = __webpack_require__(
        /*! jss-nested */
        "./node_modules/jss-nested/lib/index.js");

        var _jssNested2 = _interopRequireDefault(_jssNested);

        var _jssCompose = __webpack_require__(
        /*! jss-compose */
        "./node_modules/jss-compose/lib/index.js");

        var _jssCompose2 = _interopRequireDefault(_jssCompose);

        var _jssCamelCase = __webpack_require__(
        /*! jss-camel-case */
        "./node_modules/jss-camel-case/lib/index.js");

        var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

        var _jssDefaultUnit = __webpack_require__(
        /*! jss-default-unit */
        "./node_modules/jss-default-unit/lib/index.js");

        var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

        var _jssExpand = __webpack_require__(
        /*! jss-expand */
        "./node_modules/jss-expand/lib/index.js");

        var _jssExpand2 = _interopRequireDefault(_jssExpand);

        var _jssVendorPrefixer = __webpack_require__(
        /*! jss-vendor-prefixer */
        "./node_modules/jss-vendor-prefixer/lib/index.js");

        var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

        var _jssPropsSort = __webpack_require__(
        /*! jss-props-sort */
        "./node_modules/jss-props-sort/lib/index.js");

        var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return {
            plugins: [(0, _jssTemplate2.default)(options.template), (0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
          };
        };
        /***/

      },

      /***/
      "./node_modules/@mail/react-provider/emitter.ts":
      /*!******************************************************!*\
        !*** ./node_modules/@mail/react-provider/emitter.ts ***!
        \******************************************************/

      /*! exports provided: emitterMiddleware, emitterApply, emit */

      /***/
      function node_modulesMailReactProviderEmitterTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "emitterMiddleware", function () {
          return emitterMiddleware;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "emitterApply", function () {
          return emitterApply;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "emit", function () {
          return emit;
        });
        /* harmony import */


        var _mail_Emitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @mail/Emitter */
        "./node_modules/@mail/Emitter/main.js");
        /* harmony import */


        var _mail_Emitter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_mail_Emitter__WEBPACK_IMPORTED_MODULE_0__);

        var emitter = null;

        var emitterMiddleware = function emitterMiddleware() {
          return function (next) {
            return function (action) {
              if (emitter) {
                emitter.emit(action.type, action.payload);
              }

              return next(action);
            };
          };
        };

        var emitterApply = function emitterApply(target) {
          emitter = _mail_Emitter__WEBPACK_IMPORTED_MODULE_0___default.a.apply(target);
        };

        var emit = function emit(type, payload) {
          emitter.emit(type, payload);
        };
        /***/

      },

      /***/
      "./node_modules/@mail/react-provider/index.ts":
      /*!****************************************************!*\
        !*** ./node_modules/@mail/react-provider/index.ts ***!
        \****************************************************/

      /*! exports provided: Injector, emitterMiddleware, emit, default */

      /***/
      function node_modulesMailReactProviderIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react-dom */
        "react-dom");
        /* harmony import */


        var react_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _injector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./injector */
        "./node_modules/@mail/react-provider/injector.ts");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Injector", function () {
          return _injector__WEBPACK_IMPORTED_MODULE_1__["default"];
        });
        /* harmony import */


        var _emitter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./emitter */
        "./node_modules/@mail/react-provider/emitter.ts");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "emitterMiddleware", function () {
          return _emitter__WEBPACK_IMPORTED_MODULE_2__["emitterMiddleware"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "emit", function () {
          return _emitter__WEBPACK_IMPORTED_MODULE_2__["emit"];
        });

        var default_1 =
        /** @class */
        function () {
          function default_1(element) {
            this.container = element;
            Object(_emitter__WEBPACK_IMPORTED_MODULE_2__["emitterApply"])(this);
          }

          default_1.prototype.injectDependencies = function (dependencies) {
            _injector__WEBPACK_IMPORTED_MODULE_1__["default"].setAll(dependencies);
          };

          default_1.prototype.create = function () {
            console.error('[react-provider] You should override create or render method');
          };
          /**
           * @deprecated
           */


          default_1.prototype.render = function () {
            this.create();
          };

          default_1.prototype.destroy = function () {
            react_dom__WEBPACK_IMPORTED_MODULE_0__["unmountComponentAtNode"](this.container);
          };
          /**
           * @deprecated
           */


          default_1.prototype.unmount = function () {
            this.destroy();
          };

          return default_1;
        }();
        /* harmony default export */


        __webpack_exports__["default"] = default_1;
        /***/
      },

      /***/
      "./node_modules/@mail/react-provider/injector.ts":
      /*!*******************************************************!*\
        !*** ./node_modules/@mail/react-provider/injector.ts ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesMailReactProviderInjectorTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_fn_object_entries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/fn/object/entries */
        "./node_modules/core-js/fn/object/entries.js");
        /* harmony import */


        var core_js_fn_object_entries__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_fn_object_entries__WEBPACK_IMPORTED_MODULE_0__);

        var dependencies = {};
        /* harmony default export */

        __webpack_exports__["default"] = {
          setAll: function setAll(dependencies) {
            var _this = this;

            Object.entries(dependencies).map(function (entry) {
              _this.set(entry[0], entry[1]);
            });
          },
          set: function set(name, module) {
            dependencies[name] = module;
          },
          get: function get(name, defaultValue) {
            if (typeof dependencies[name] === 'undefined' && typeof defaultValue === 'undefined') {
              throw Error("Inject dependency: " + name);
            }

            return dependencies[name] || defaultValue;
          }
        };
        /***/
      },

      /***/
      "./node_modules/@mail/xray/index.js":
      /*!******************************************!*\
        !*** ./node_modules/@mail/xray/index.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function node_modulesMailXrayIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* istanbul ignore next */


        var CustomEventConstructor = window && window.CustomEvent;
        /* istanbul ignore next */

        if (typeof CustomEventConstructor !== 'function' && typeof window !== 'undefined') {
          var CustomEvent = function CustomEvent(event, params) {
            params = params || {
              bubbles: false,
              cancelable: false,
              detail: undefined
            };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
          };

          CustomEvent.prototype = window.Event.prototype;
          CustomEventConstructor = CustomEvent;
        }
        /**
         * Генерирует событие отправки радаров
         * @param {'send'|'warn'} type - тип события
         * @param {*} [detail] - параметры
         */


        function emitXrayEvent(type, detail) {
          try {
            var event = new CustomEventConstructor("xray-".concat(type), {
              bubbles: true,
              cancelable: false,
              detail: detail
            });
            document.dispatchEvent(event);
          } catch (e) {// ignore
          }
        }

        var mylog = [];
        /**
         * @module xrayLogger
         */

        var logger = {
          maxSize: 500,
          getLog: function getLog() {
            return Array.prototype.slice.call(mylog, 0);
          },
          clear: function clear() {
            mylog = [];
          }
        };
        /**
         * @param {*} item
         */

        function log(item) {
          mylog.push(item);

          while (mylog.length > logger.maxSize) {
            mylog.shift();
          }
        }

        function log$1()
        /* arguments */
        {
          try {
            (console.debug || console.log).apply(console, arguments);
          } catch (_) {// ignore error
          }
        }

        function error()
        /* arguments */
        {
          try {
            console.error.apply(console, arguments);
          } catch (_) {// ignore error
          }
        }

        function warn()
        /* arguments */
        {
          try {
            console.warn.apply(console, arguments);
          } catch (_) {// ignore error
          }
        }

        var console$1 = {
          log: log$1,
          error: error,
          warn: warn
        };

        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }

          return _typeof(obj);
        }
        /**
         * Возвращает true, если переданное значение - объект
         */


        function isObject(item) {
          return item && _typeof(item) === 'object' && !isArray(item);
        }
        /**
         * Полифилл Array.isArray()
         */


        function isArray(item) {
          return Object.prototype.toString.call(item) === '[object Array]';
        }
        /**
         * Осуществляет рекурсивное слияние нескольких объектов
         * @param {...Object} arguments
         */


        function deepMerge()
        /* arguments */
        {
          var result = {};

          for (var i = 0; i < arguments.length; ++i) {
            var obj = arguments[i];

            for (var key in obj) {
              if (result[key] && isObject(result[key]) && isObject(obj[key])) {
                result[key] = deepMerge(result[key], obj[key]);
              } else {
                result[key] = obj[key];
              }
            }
          }

          return result;
        }

        var getParamsNames = ['p', 'email', 'split', 'utm', 'r', 'pgid', 'o_ss', 'o_v'];
        var configured = false;
        /**
         * @class Queue
         * @classdesc Собирает все радары, отправленные в течение 1 секунды после отправки первого, в батчи и отправяет их
         */

        function Queue() {
          /**
           * @member {Object} - объект, ключами которого являются урлы запросов на отправку радаров,
           * а значениями - массив батчей, которые нужно отправить по данному урлу
           * @private
           */
          this._batchesByUrls = {}; // { [url: string]: Array<Params[]> }

          /**
           * @member {number|null} - id таймера отправки
           * @private
           */

          this._timeoutId = null;
          /**
           * @member {QueueConfig} - объект конфига очереди
           * @private
           */

          this._config = {
            maxBatchSize: 6e4,
            maxChunkSize: 4e3,
            timeout: 1000,
            idle: false
          };
          /* istanbul ignore next */

          if (typeof window !== 'undefined') {
            // на beforeunload отправляем все радары в очереди через Beacon API
            window.addEventListener('beforeunload', this.process.bind(this, true));
          }
        }
        /**
         * Конфигурация очереди
         * Установить конфиг можно только при первом вызове - в дальнейшем их нельзя будет изменить, только добавить новые
         * @param {QueueConfig} config
         */


        Queue.prototype.setConfig = function (config) {
          if (!configured) {
            this._config = deepMerge(this._config, config);
            configured = true;
            return;
          }

          var commonFields = [];

          for (var field in config) {
            // tslint:disable-line
            if (field in this._config) {
              commonFields.push(field);
              continue;
            }

            this._config[field] = config[field];
          }
          /* istanbul ignore next */


          if (commonFields.length) {
            console$1.warn('Queue config field(s) ' + commonFields.join(', ') + ' are already set and can\'t be modified');
          }
        };
        /**
         * Возвращает копию объекта конфига очереди
         * @return {QueueConfig}
         */


        Queue.prototype.getConfig = function () {
          return deepMerge(this._config, {});
        };
        /**
         * Добавляет радар в очередь
         * При добавлении радара сразу распределяет его в батч, в котором осталось достаточно места, чтобы вместить новый
         * @param {string} baseUrl - урл запроса на отправку
         * @param {Object} params - параметры радара
         */


        Queue.prototype.push = function (baseUrl, params) {
          emitXrayEvent('send', {
            baseUrl: baseUrl,
            params: params
          });
          log(params);

          var url = baseUrl + '/batch?' + Queue._buildQueryString(params);

          params = Queue._stringifyParams(params); // проверка параметров радара на превышение размера

          var stringifiedParams = JSON.stringify(params);

          if (stringifiedParams.length + 2 > this._config.maxBatchSize) {
            console$1.error('Radar #' + params.uid + ' body is too long: ' + stringifiedParams);
            return;
          }

          if (!this._batchesByUrls[url]) {
            this._batchesByUrls[url] = [[]];
          }

          var batches = this._batchesByUrls[url]; // Array<Params[]>
          // ищем батч, в который влезет наш радар

          var i;

          for (i = 0; i < batches.length; ++i) {
            var batch = batches[i]; // Params[]

            if (JSON.stringify(batch.concat([params])).length <= this._config.maxBatchSize) {
              batch.push(params);
              break;
            }
          } // если не нашли, создаём новый батч


          if (i === batches.length) {
            batches.push([params]);
          }

          if (!this._timeoutId) {
            this._timeoutId = setTimeout(this.process.bind(this), this._config.timeout);
          }
        };
        /**
         * Отправка всех накопленных батчей
         * @param {boolean} [useBeacon] - флаг, отправляем запрос через Beacon API
         */


        Queue.prototype.process = function (useBeacon) {
          clearTimeout(this._timeoutId);
          this._timeoutId = null;

          for (var url in this._batchesByUrls) {
            // tslint:disable-line
            var batches = this._batchesByUrls[url];

            for (var i = 0; i < batches.length; ++i) {
              this._send(url, batches[i], useBeacon);
            }

            delete this._batchesByUrls[url];
          }
        };
        /**
         * Возвращает значение параметра idle из конфига очереди
         * @returns {boolean}
         */


        Queue.prototype.isIdle = function () {
          return this._config.idle;
        };
        /**
         * Из объекта параметров радара достаёт поля, перечисленные в массиве
         * @see getParamsNames
         * и их сохраняя их порядок как в массиве (!) строит из значений этих полей querystring
         *
         * Если есть параметр baseQuery, его ключи сортируются в алфавитном порядке и добавляются в querystring в нём же
         */


        Queue._buildQueryString = function (params) {
          var queryStringArray = [];

          for (var i = 0; i < getParamsNames.length; ++i) {
            var key = getParamsNames[i];
            var value = typeof params[key] === 'string' ? params[key] : JSON.stringify(params[key]);
            delete params[key];

            if (typeof value === 'undefined' || !value.length) {
              continue;
            }

            queryStringArray.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
          } // собираем ключи объекта params.baseQuery и сортируем их


          var baseQueryKeys = [];

          for (var queryKey in params.baseQuery) {
            // tslint:disable-line
            baseQueryKeys.push(queryKey);
          }

          baseQueryKeys = baseQueryKeys.sort(); // добавялем поля объекта params.baseQuery в отсортированном порядке

          for (var _i = 0; _i < baseQueryKeys.length; ++_i) {
            var _key = baseQueryKeys[_i];
            queryStringArray.push(encodeURIComponent(_key) + '=' + encodeURIComponent(params.baseQuery[_key]));
          }

          delete params.baseQuery;
          return queryStringArray.join('&');
        };
        /**
         * Отправляет запрос, предварительно вызвав коллбек beforeSend, если он есть
         * @see QueueConfig#beforeSend
         * @param {string} url - урл запроса (с гет-параметрами)
         * @param {Object} body - тело запроса
         * @param {boolean} [useBeacon] - флаг, отправляем запрос через Beacon API
         * @private
         */


        Queue.prototype._send = function (url, body, useBeacon) {
          var settings = {
            url: url,
            data: 'batch=' + encodeURIComponent(JSON.stringify(body)),
            type: 'POST',
            async: true
          };

          if (this._config.idle) {
            return;
          }

          if (useBeacon && window.navigator.sendBeacon) {
            window.navigator.sendBeacon(settings.url, settings.data);
            return;
          }

          var xhr = new XMLHttpRequest();
          var isAborted = typeof this._config.beforeSend === 'function' && !this._config.beforeSend(xhr, settings);

          if (isAborted) {
            xhr.abort();
            return;
          }

          xhr.open(settings.type, settings.url, settings.async);
          xhr.withCredentials = true;
          xhr.send(settings.data);
        };
        /**
         * Конвертирует все поля объекта параметров радара в строки
         * Поле i конвертируется отдельно
         * @link Queue#_stringifyI
         * @private
         */


        Queue._stringifyParams = function (params) {
          var result = {};

          for (var key in params) {
            // tslint:disable-line
            if (key === 'i') {
              // объект i обрабатывается отдельно
              result.i = Queue._stringifyI(params.i);
              continue;
            }

            result[key] = typeof params[key] === 'string' ? params[key] : JSON.stringify(params[key]);
          }

          return result;
        };
        /**
         * Конвертирует объект i в строку вида 'name:1,name:2...'
         * @param {I} iObject - объект с параметрами i
         * @return {string} - строка, результат преобразования
         * @private
         */


        Queue._stringifyI = function (iObject) {
          var result = [];

          for (var name in iObject) {
            // tslint:disable-line
            var value = iObject[name];
            result.push(name + ':' + value);
          }

          return result.join(',');
        };
        /**
         * Форматирует значения для параметра радаров split (вырезает повторяющиеся s)
         * @param {string} split
         * @return {string}
         */


        function clearSplit(split) {
          return "s".concat(split, "s").replace(/s+/g, 's').replace(/^s$/g, '');
        }
        /**
         * Удаляет из объекта все поля, равные null или undefined
         * @param {Object} object
         * @return {Object}
         */


        function filterObject(object) {
          for (var key in object) {
            if (typeof object[key] === 'undefined' || object[key] === null) {
              delete object[key];
            }
          }

          return object;
        }

        var uid = 0;
        var protectedParams = ['radarPrefix', 'split', 'r', 'pgid', 'utm', 'o_ss', 'o_v'];
        var configured$1 = false;
        var queue = new Queue();
        /**
         * @class XrayInstance
         * @classdesc Класс инстанса xray
         */

        function XrayInstance() {
          /**
           * @member {Config} - объект с конфигом инстанса
           * @private
           */
          this._config = {
            xrayRadarUrl: 'https://xray.mail.ru',
            pgid: (Date.now() + Math.random()).toString(36),
            radarPrefix: '',
            r: document && document.referrer || '',
            defaultParams: {
              p: 'mail',
              t_feature: '',
              v: 1
            }
          };
        }
        /**
         * Логгер, общий для всех инстансов
         * @see xrayLogger
         */


        XrayInstance.prototype.logger = logger;
        /**
         * Метод для конфигурирования инстанса xray
         *
         * Некоротые параметры
         * @see protectedParams
         * могут быть установлены только единожды при первичной конфигурации xray
         *
         * @param {Config} config - объект конфига
         * @param {boolean} [force]
         */

        XrayInstance.prototype.setConfig = function (config, force) {
          config = config || {};

          if (config.split) {
            config.split = clearSplit(config.split);
          }

          if (configured$1) {
            for (var i = 0; i < protectedParams.length; ++i) {
              delete config[protectedParams[i]];
            }
          }

          configured$1 = true;

          if (config.defaultParams && config.defaultParams.i) {
            config.defaultParams.i = this._formatIntervals(config.defaultParams.i); // параметр i переписывается, а не мерджится

            delete this._config.defaultParams.i;
          }

          this._config = force ? config : deepMerge(this._config, config);

          if (config.gaTrackingId) {
            this._initGA(config.gaTrackingId);
          }
        };
        /**
         * Добавляет новые значения split в текущий конфиг
         * @param {string} split - новые сплиты
         */


        XrayInstance.prototype.addSplit = function (split) {
          this._config.split = clearSplit("".concat(this._config.split || '', "s").concat(split));
        };
        /**
         * Возвращает копию объекта конфига инстанса
         * @return {Config}
         */


        XrayInstance.prototype.getConfig = function () {
          return deepMerge(this._config, {});
        };
        /**
         * Возвращает количество отправленных на странице радаров
         * @return {number}
         */


        XrayInstance.prototype.getTotalSended = function () {
          return uid;
        };
        /**
         * @link Queue#setConfig
         */


        XrayInstance.prototype.setQueueConfig = Queue.prototype.setConfig.bind(queue);
        /**
         * @link Queue#getConfig
         */

        XrayInstance.prototype.getQueueConfig = Queue.prototype.getConfig.bind(queue);
        /**
         * Возвращает копию того инстанса, у которого был вызван
         * @constructs
         * @return {XrayInstance}
         */

        XrayInstance.prototype.getInstanceCopy = function () {
          var instanceCopy = new XrayInstance();
          configured$1 = false;
          instanceCopy.setConfig(this._config, true);
          return instanceCopy;
        };
        /**
         * Отправляет радары
         * Осуществляет валидацию и преобразование данных, добавление радара в очередь на отправку, отправку гугл-аналитики,
         * логирование (в т.ч. в консоль браузера)
         * @param {string|Array<string>} t - имя метрики или цепочка
         * @param {Params} [params] - параметры радара
         * @param {string|boolean} [ga] - trackingId гугл-аналитики или булевское значение, которое в случае равенства true
         * разрешит отправку гугл-аналитики с tracking id из конфига
         */


        XrayInstance.prototype.send = function (t, params, ga) {
          if (!configured$1) {
            console$1.warn('Your xray instance is not configured');
          } // чтобы не затронуть оригинальный объект params, копируем его


          params = deepMerge(params || {}, {}); // если в t передана цепочка, "собираем" из неё имя метрики

          t = isArray(t) ? t.join('_') : t;

          if (params.i) {
            params.i = this._formatIntervals(params.i);
          }

          params = deepMerge(this._config.defaultParams, params, {
            t: t,
            split: this._config.split,
            r: this._config.r,
            pgid: this._config.pgid,
            utm: this._config.utm,
            o_ss: this._config.o_ss,
            o_v: this._config.o_v,
            baseQuery: this._config.baseQuery,
            uid: uid++
          }); // добавляем в начало к t фичу и префикс

          var tParts = [params.t_feature, this._config.radarPrefix];

          for (var i = 0; i < tParts.length; ++i) {
            if (!tParts[i]) {
              continue;
            }

            params.t = tParts[i] + '_' + params.t;
          }

          delete params.t_feature;

          try {
            params = this._validateParams(params);
          } catch (error) {
            console$1.log('xray', params.uid, params);
            console$1.error(error.message);
            return;
          }

          if (this._config.verbose) {
            console$1.log('xray', params.uid, params.t, params, !!ga ? 'GA: ' + !!ga : void 0);
          }

          queue.push(this._config.xrayRadarUrl, params);

          if (ga === true && !this._config.gaTrackingId) {
            console$1.error('Radar #' + params.uid + ': no GA tracking id specified');
            return;
          }

          var trackingId = typeof ga === 'string' ? ga : this._config.gaTrackingId;

          if (!!ga && trackingId && !queue.isIdle()) {
            if (params.i) {
              for (var name in params.i) {
                // tslint:disable-line
                this._sendGA(t + '_' + name, params.i[name], trackingId);
              }

              return;
            }

            this._sendGA(t, params.v, trackingId);
          }
        };
        /**
         * Отправляет радар и вызывает принудительную обработку очереди, не дожидаясь таймаута
         * @link XrayInstance#send
         * @link Queue#process
         */


        XrayInstance.prototype.sendImmediately = function (t, params, ga) {
          this.send(t, params, ga);
          queue.process();
        };
        /**
         * Отправка гугл-аналитики
         * @param {string} event - событие (по факту - имя метрики)
         * @param {number} value - значение (параметр v)
         * @param {string} trackingId - tracking id гугл-аналитики
         * @private
         */


        XrayInstance.prototype._sendGA = function (event, value, trackingId) {
          if (typeof gtag !== 'function') {
            this._initGA(trackingId);
          }

          var parts = event.split(/_/g);
          var eventAction = parts[1] || parts[0];
          var eventCategory = parts[1] ? parts[0] : '';
          var eventLabel = parts.slice(2).join('_');
          var eventParams = {
            value: value,
            send_to: trackingId
          };

          if (eventCategory) {
            eventParams.event_category = eventCategory;
          }

          if (eventLabel) {
            eventParams.event_label = eventLabel;
          }

          gtag('event', eventAction, eventParams);
        };
        /* istanbul ignore next */

        /**
         * Инициализация гугл-аналитики
         * @see https://developers.google.com/analytics/devguides/collection/gtagjs/
         * @private
         */


        XrayInstance.prototype._initGA = function (trackingId) {
          if (!window.gtag) {
            var gtagScript = document.createElement('script');
            gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackingId;
            gtagScript.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(gtagScript);
            window.dataLayer = window.dataLayer || [];

            window.gtag = function () {
              window.dataLayer.push(arguments);
            };

            gtag('js', new Date());
          }

          gtag('config', trackingId, {
            'send_page_view': false
          });
        };
        /**
         * Валидация параметров радара
         * Правила валидации см. в комментах в коде метода
         * @param {Params} params
         * @return {Params}
         * @private
         */


        XrayInstance.prototype._validateParams = function (params) {
          params = filterObject(params);

          if (params.rlog && params.rlog.indexOf('.') !== -1) {
            console$1.error("Radar #".concat(params.uid, ": rlog can not contain file extension"));
            delete params.rlog;
            delete params.rlog_message;
          } // rlog и rlog_message должны отправляться только вместе


          if (!(params.rlog && params.rlog_message)) {
            if (params.rlog_message) {
              console$1.error("Radar #".concat(params.uid, ": rlog_message would not be sent without rlog"));
            }

            delete params.rlog;
            delete params.rlog_message;
          } // объект, собирающий данные для валидации (ключ - максимальная длина строки, значение - массив валидируемых строк)


          var validationObject = {
            32: [params.p, params.rlog],
            64: [params.p + '_' + params.t]
          }; //  12 var (
          //  11 ........radarLimits       = cfggroup.NewCfgGroup("radar.limits", "Limits of request parser")
          //  10 ........maxProjectNameLen = radarLimits.Int("max_project_name_len", 32,
          //   9 ................"Maximum length of project name")
          //   8 ........maxKeySize = radarLimits.Int("max_key_size", 32,
          //   7 ................"Maximum length of i-parameter key")
          //   6 ........maxValueSize = radarLimits.Int("max_value_size", 32,
          //   5 ................"Maximum length of i-parameter value")
          //   4 ........maxRlogKeyLen = radarLimits.Int("max_rlog_key_len", 32,
          //   3 ................"Maximum length of rlog-key")
          //   2 ........maxTypeLen = radarLimits.Int("max_type_len", 64,
          //   1 ................"Maximum length of metrics type")
          // 34  )
          // каждый ключ объекта i должен быть <= 32-х символов, a (p + '_' + t + '_' + i.key) <= 64

          for (var name in params.i) {
            // tslint:disable-line
            validationObject[32].push(name);
            validationObject[64].push(params.p + '_' + params.t + '_' + name);
          }

          for (var limit in validationObject) {
            // tslint:disable-line
            var values = validationObject[limit];

            for (var i = 0; i < values.length; ++i) {
              if (values[i] && values[i].length > limit) {
                throw new Error("Radar #".concat(params.uid, ": value is too long: ").concat(validationObject[limit][i]) + " (len: ".concat(values[i].length, ", limit: ").concat(limit, ")"));
              }
            }
          }

          return params;
        };
        /**
         * Приводит разные форматы параметра i к одному - к объекту вида { [name: string]: number; }
         * Пример:
         * ['foo', 'bar:2'] => { foo: 1, bar: 2 }
         * 'foo:1,bar:2,baz' => { foo: 1, bar: 2, baz: 1 }
         * { foo: 1, bar: 2 } => { foo: 1, bar: 2 }
         * @param {Object|string|Array<string>} intervals
         * @return {Object} - i в формате объекта
         * @private
         */


        XrayInstance.prototype._formatIntervals = function (intervals) {
          if (isObject(intervals)) {
            return intervals;
          }

          var intervalsObject = {}; // если i - массив вида ['foo', 'bar:2'], сплиттим каждый элемент ('<name>[:<value>]') по двоеточию
          // и пишем в результирующий объект поле 'name' со значением value или с дефолтным значением метрики из конфига

          if (isArray(intervals)) {
            for (var i = 0; i < intervals.length; ++i) {
              var parts = intervals[i].split(':'); // => [ 'name', value ]

              intervalsObject[parts[0]] = +parts[1] || this._config.defaultParams.v;
            }

            return intervalsObject;
          } // если i - строка формата 'foo:1,bar:2,baz', сплиттим её по запятой (=> ['foo:1', 'bar:2', 'baz'])
          // и снова скармливаем этому методу


          if (typeof intervals === 'string') {
            var intervalsArray = intervals.split(',');
            return this._formatIntervals(intervalsArray);
          }
        };

        var xrayInstance = new XrayInstance();
        /**
         * Функция-фасад над объектом XrayInstance, обеспечивающая обратную совместимость
         * @param {string} raw - строка с параметрами
         * @param {{immediately: boolean, ga: string | boolean}} [options]
         */

        function xray(raw, options) {
          var rawParams = raw.split('&');
          var t = rawParams[0];
          var params = {};

          for (var i = 1; i < rawParams.length; ++i) {
            var parts = rawParams[i].split('=');
            var name = decodeURIComponent(parts[0]);
            var value = decodeURIComponent(parts[1]);

            try {
              value = JSON.parse(value);
            } catch (_) {}

            params[name] = value;
          }

          options = options || {};

          if (options.immediately) {
            xrayInstance.sendImmediately(t, params, options.ga);
          } else {
            xrayInstance.send(t, params, options.ga);
          }
        }
        /**
         * Функция для обеспечения обратной совместимости метода setConfig
         * @param {Config & OldConfig & QueueConfig} config - объект конфига со старым или новым интерфейсом
         */


        xray.setConfig = function (config) {
          xrayInstance.setConfig(filterObject({
            verbose: config.verbose,
            pgid: config.pgid,
            split: config.split,
            xrayRadarUrl: config.xrayRadarUrl || config.XRAY_RADAR_URL,
            radarPrefix: config.radarPrefix || config.RadarPrefix,
            utm: config.utm,
            o_ss: config.o_ss,
            o_v: config.o_v,
            baseQuery: config.baseQuery,
            gaTrackingId: config.gaTrackingId || config.GA_TRACKING_ID,
            defaultParams: config.defaultParams || filterObject({
              p: config.project,
              email: config.ActiveEmail
            })
          }));
          xrayInstance.setQueueConfig(filterObject({
            maxBatchSize: config.MAX_BATCH_SIZE,
            maxChunkSize: config.MAX_CHUNK_SIZE,
            beforeSend: config.beforeSend,
            idle: config.idle
          }));
        };

        xray.getConfig = XrayInstance.prototype.getConfig.bind(xrayInstance);
        xray.addSplit = XrayInstance.prototype.addSplit.bind(xrayInstance);
        xray.setQueueConfig = XrayInstance.prototype.setQueueConfig.bind(xrayInstance);
        xray.getQueueConfig = XrayInstance.prototype.getQueueConfig.bind(xrayInstance);
        xray.getTotalSended = XrayInstance.prototype.getTotalSended.bind(xrayInstance);
        xray.send = XrayInstance.prototype.send.bind(xrayInstance);
        xray.sendImmediately = XrayInstance.prototype.sendImmediately.bind(xrayInstance);
        xray.getInstanceCopy = XrayInstance.prototype.getInstanceCopy.bind(xrayInstance);
        /* harmony default export */

        __webpack_exports__["default"] = xray;
        /***/
      },

      /***/
      "./node_modules/axios-mock-adapter/src/handle_request.js":
      /*!***************************************************************!*\
        !*** ./node_modules/axios-mock-adapter/src/handle_request.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosMockAdapterSrcHandle_requestJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./utils */
        "./node_modules/axios-mock-adapter/src/utils.js");

        function makeResponse(result, config) {
          return {
            status: result[0],
            data: utils.isSimpleObject(result[1]) ? JSON.parse(JSON.stringify(result[1])) : result[1],
            headers: result[2],
            config: config,
            request: {
              responseUrl: config.url
            }
          };
        }

        function handleRequest(mockAdapter, resolve, reject, config) {
          var url = config.url;

          if (config.baseURL && config.url.substr(0, config.baseURL.length) === config.baseURL) {
            url = config.url.slice(config.baseURL ? config.baseURL.length : 0);
          }

          delete config.adapter;
          mockAdapter.history[config.method].push(config);
          var handler = utils.findHandler(mockAdapter.handlers, config.method, url, config.data, config.params, config.headers, config.baseURL);

          if (handler) {
            if (handler.length === 7) {
              utils.purgeIfReplyOnce(mockAdapter, handler);
            }

            if (handler.length === 2) {
              // passThrough handler
              mockAdapter.originalAdapter(config).then(resolve, reject);
            } else if (typeof handler[3] !== 'function') {
              utils.settle(resolve, reject, makeResponse(handler.slice(3), config), mockAdapter.delayResponse);
            } else {
              var result = handler[3](config); // TODO throw a sane exception when return value is incorrect

              if (typeof result.then !== 'function') {
                utils.settle(resolve, reject, makeResponse(result, config), mockAdapter.delayResponse);
              } else {
                result.then(function (result) {
                  if (result.config && result.status) {
                    utils.settle(resolve, reject, makeResponse([result.status, result.data, result.headers], result.config), 0);
                  } else {
                    utils.settle(resolve, reject, makeResponse(result, config), mockAdapter.delayResponse);
                  }
                }, function (error) {
                  if (mockAdapter.delayResponse > 0) {
                    setTimeout(function () {
                      reject(error);
                    }, mockAdapter.delayResponse);
                  } else {
                    reject(error);
                  }
                });
              }
            }
          } else {
            // handler not found
            if (mockAdapter.passThroughByDefault) {
              mockAdapter.originalAdapter(config).then(resolve, reject);
            } else {
              utils.settle(resolve, reject, {
                status: 404,
                config: config
              }, mockAdapter.delayResponse);
            }
          }
        }

        module.exports = handleRequest;
        /***/
      },

      /***/
      "./node_modules/axios-mock-adapter/src/index.js":
      /*!******************************************************!*\
        !*** ./node_modules/axios-mock-adapter/src/index.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosMockAdapterSrcIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var deepEqual = __webpack_require__(
        /*! deep-equal */
        "./node_modules/deep-equal/index.js");

        var handleRequest = __webpack_require__(
        /*! ./handle_request */
        "./node_modules/axios-mock-adapter/src/handle_request.js");

        var utils = __webpack_require__(
        /*! ./utils */
        "./node_modules/axios-mock-adapter/src/utils.js");

        var VERBS = ['get', 'post', 'head', 'delete', 'patch', 'put', 'options', 'list'];

        function adapter() {
          return function (config) {
            var mockAdapter = this; // axios >= 0.13.0 only passes the config and expects a promise to be
            // returned. axios < 0.13.0 passes (config, resolve, reject).

            if (arguments.length === 3) {
              handleRequest(mockAdapter, arguments[0], arguments[1], arguments[2]);
            } else {
              return new Promise(function (resolve, reject) {
                handleRequest(mockAdapter, resolve, reject, config);
              });
            }
          }.bind(this);
        }

        function getVerbObject() {
          return VERBS.reduce(function (accumulator, verb) {
            accumulator[verb] = [];
            return accumulator;
          }, {});
        }

        function reset() {
          resetHandlers.call(this);
          resetHistory.call(this);
        }

        function resetHandlers() {
          this.handlers = getVerbObject();
        }

        function resetHistory() {
          this.history = getVerbObject();
        }

        function MockAdapter(axiosInstance, options) {
          reset.call(this);

          if (axiosInstance) {
            this.axiosInstance = axiosInstance;
            this.originalAdapter = axiosInstance.defaults.adapter;
            this.delayResponse = options && options.delayResponse > 0 ? options.delayResponse : null;
            this.passThroughByDefault = !!(options && options.passThroughByDefault);
            axiosInstance.defaults.adapter = this.adapter.call(this);
          }
        }

        MockAdapter.prototype.adapter = adapter;

        MockAdapter.prototype.restore = function restore() {
          if (this.axiosInstance) {
            this.axiosInstance.defaults.adapter = this.originalAdapter;
          }
        };

        MockAdapter.prototype.reset = reset;
        MockAdapter.prototype.resetHandlers = resetHandlers;
        MockAdapter.prototype.resetHistory = resetHistory;
        VERBS.concat('any').forEach(function (method) {
          var methodName = 'on' + method.charAt(0).toUpperCase() + method.slice(1);

          MockAdapter.prototype[methodName] = function (matcher, body, requestHeaders) {
            var _this = this;

            var matcher = matcher === undefined ? /.*/ : matcher;

            function reply(code, response, headers) {
              var handler = [matcher, body, requestHeaders, code, response, headers];
              addHandler(method, _this.handlers, handler);
              return _this;
            }

            function replyOnce(code, response, headers) {
              var handler = [matcher, body, requestHeaders, code, response, headers, true];
              addHandler(method, _this.handlers, handler);
              return _this;
            }

            return {
              reply: reply,
              replyOnce: replyOnce,
              passThrough: function passThrough() {
                var handler = [matcher, body];
                addHandler(method, _this.handlers, handler);
                return _this;
              },
              networkError: function networkError() {
                reply(function (config) {
                  var error = utils.createAxiosError('Network Error', config);
                  return Promise.reject(error);
                });
              },
              networkErrorOnce: function networkErrorOnce() {
                replyOnce(function (config) {
                  var error = utils.createAxiosError('Network Error', config);
                  return Promise.reject(error);
                });
              },
              timeout: function timeout() {
                reply(function (config) {
                  var error = utils.createAxiosError('timeout of ' + config.timeout + 'ms exceeded', config, undefined, 'ECONNABORTED');
                  return Promise.reject(error);
                });
              },
              timeoutOnce: function timeoutOnce() {
                replyOnce(function (config) {
                  var error = utils.createAxiosError('timeout of ' + config.timeout + 'ms exceeded', config, undefined, 'ECONNABORTED');
                  return Promise.reject(error);
                });
              }
            };
          };
        });

        function findInHandlers(method, handlers, handler) {
          var index = -1;

          for (var i = 0; i < handlers[method].length; i += 1) {
            var item = handlers[method][i];
            var isReplyOnce = item.length === 7;
            var comparePaths = item[0] instanceof RegExp && handler[0] instanceof RegExp ? String(item[0]) === String(handler[0]) : item[0] === handler[0];
            var isSame = comparePaths && deepEqual(item[1], handler[1], {
              strict: true
            }) && deepEqual(item[2], handler[2], {
              strict: true
            });

            if (isSame && !isReplyOnce) {
              index = i;
            }
          }

          return index;
        }

        function addHandler(method, handlers, handler) {
          if (method === 'any') {
            VERBS.forEach(function (verb) {
              handlers[verb].push(handler);
            });
          } else {
            var indexOfExistingHandler = findInHandlers(method, handlers, handler);

            if (indexOfExistingHandler > -1 && handler.length < 7) {
              handlers[method].splice(indexOfExistingHandler, 1, handler);
            } else {
              handlers[method].push(handler);
            }
          }
        }

        module.exports = MockAdapter;
        module.exports.default = MockAdapter;
        /***/
      },

      /***/
      "./node_modules/axios-mock-adapter/src/utils.js":
      /*!******************************************************!*\
        !*** ./node_modules/axios-mock-adapter/src/utils.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosMockAdapterSrcUtilsJs(module, exports, __webpack_require__) {
        "use strict";

        var axios = __webpack_require__(
        /*! axios */
        "./node_modules/axios/index.js");

        var deepEqual = __webpack_require__(
        /*! deep-equal */
        "./node_modules/deep-equal/index.js");

        function isEqual(a, b) {
          return deepEqual(a, b, {
            strict: true
          });
        } // < 0.13.0 will not have default headers set on a custom instance


        var rejectWithError = !!axios.create().defaults.headers;

        function find(array, predicate) {
          var length = array.length;

          for (var i = 0; i < length; i++) {
            var value = array[i];
            if (predicate(value)) return value;
          }
        }

        function combineUrls(baseURL, url) {
          if (baseURL) {
            return baseURL.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '');
          }

          return url;
        }

        function findHandler(handlers, method, url, body, parameters, headers, baseURL) {
          return find(handlers[method.toLowerCase()], function (handler) {
            if (typeof handler[0] === 'string') {
              return (isUrlMatching(url, handler[0]) || isUrlMatching(combineUrls(baseURL, url), handler[0])) && isBodyOrParametersMatching(method, body, parameters, handler[1]) && isRequestHeadersMatching(headers, handler[2]);
            } else if (handler[0] instanceof RegExp) {
              return (handler[0].test(url) || handler[0].test(combineUrls(baseURL, url))) && isBodyOrParametersMatching(method, body, parameters, handler[1]) && isRequestHeadersMatching(headers, handler[2]);
            }
          });
        }

        function isUrlMatching(url, required) {
          var noSlashUrl = url[0] === '/' ? url.substr(1) : url;
          var noSlashRequired = required[0] === '/' ? required.substr(1) : required;
          return noSlashUrl === noSlashRequired;
        }

        function isRequestHeadersMatching(requestHeaders, required) {
          if (required === undefined) return true;
          return isEqual(requestHeaders, required);
        }

        function isBodyOrParametersMatching(method, body, parameters, required) {
          var allowedParamsMethods = ['delete', 'get', 'head', 'options'];

          if (allowedParamsMethods.indexOf(method.toLowerCase()) >= 0) {
            var params = required ? required.params : undefined;
            return isParametersMatching(parameters, params);
          } else {
            return isBodyMatching(body, required);
          }
        }

        function isParametersMatching(parameters, required) {
          if (required === undefined) return true;
          return isEqual(parameters, required);
        }

        function isBodyMatching(body, requiredBody) {
          if (requiredBody === undefined) {
            return true;
          }

          var parsedBody;

          try {
            parsedBody = JSON.parse(body);
          } catch (e) {}

          return parsedBody ? isEqual(parsedBody, requiredBody) : isEqual(body, requiredBody);
        }

        function purgeIfReplyOnce(mock, handler) {
          Object.keys(mock.handlers).forEach(function (key) {
            var index = mock.handlers[key].indexOf(handler);

            if (index > -1) {
              mock.handlers[key].splice(index, 1);
            }
          });
        }

        function settle(resolve, reject, response, delay) {
          if (delay > 0) {
            setTimeout(function () {
              settle(resolve, reject, response);
            }, delay);
            return;
          }

          if (response.config && response.config.validateStatus) {
            response.config.validateStatus(response.status) ? resolve(response) : reject(createAxiosError('Request failed with status code ' + response.status, response.config, response));
            return;
          } // Support for axios < 0.11


          if (response.status >= 200 && response.status < 300) {
            resolve(response);
          } else {
            reject(response);
          }
        }

        function createAxiosError(message, config, response, code) {
          // Support for axios < 0.13.0
          if (!rejectWithError) return response;
          var error = new Error(message);
          error.isAxiosError = true;
          error.config = config;

          if (response !== undefined) {
            error.response = response;
          }

          if (code !== undefined) {
            error.code = code;
          }

          return error;
        }

        function isSimpleObject(value) {
          return value !== null && value !== undefined && value.toString() === '[object Object]';
        }

        module.exports = {
          find: find,
          findHandler: findHandler,
          isSimpleObject: isSimpleObject,
          purgeIfReplyOnce: purgeIfReplyOnce,
          settle: settle,
          createAxiosError: createAxiosError
        };
        /***/
      },

      /***/
      "./node_modules/axios/index.js":
      /*!*************************************!*\
        !*** ./node_modules/axios/index.js ***!
        \*************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosIndexJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! ./lib/axios */
        "./node_modules/axios/lib/axios.js");
        /***/
      },

      /***/
      "./node_modules/axios/lib/adapters/xhr.js":
      /*!************************************************!*\
        !*** ./node_modules/axios/lib/adapters/xhr.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibAdaptersXhrJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js");

        var settle = __webpack_require__(
        /*! ./../core/settle */
        "./node_modules/axios/lib/core/settle.js");

        var buildURL = __webpack_require__(
        /*! ./../helpers/buildURL */
        "./node_modules/axios/lib/helpers/buildURL.js");

        var buildFullPath = __webpack_require__(
        /*! ../core/buildFullPath */
        "./node_modules/axios/lib/core/buildFullPath.js");

        var parseHeaders = __webpack_require__(
        /*! ./../helpers/parseHeaders */
        "./node_modules/axios/lib/helpers/parseHeaders.js");

        var isURLSameOrigin = __webpack_require__(
        /*! ./../helpers/isURLSameOrigin */
        "./node_modules/axios/lib/helpers/isURLSameOrigin.js");

        var createError = __webpack_require__(
        /*! ../core/createError */
        "./node_modules/axios/lib/core/createError.js");

        module.exports = function xhrAdapter(config) {
          return new Promise(function dispatchXhrRequest(resolve, reject) {
            var requestData = config.data;
            var requestHeaders = config.headers;

            if (utils.isFormData(requestData)) {
              delete requestHeaders['Content-Type']; // Let the browser set it
            }

            var request = new XMLHttpRequest(); // HTTP basic authentication

            if (config.auth) {
              var username = config.auth.username || '';
              var password = config.auth.password || '';
              requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
            }

            var fullPath = buildFullPath(config.baseURL, config.url);
            request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

            request.timeout = config.timeout; // Listen for ready state

            request.onreadystatechange = function handleLoad() {
              if (!request || request.readyState !== 4) {
                return;
              } // The request errored out and we didn't get a response, this will be
              // handled by onerror instead
              // With one exception: request that using file: protocol, most browsers
              // will return status as 0 even though it's a successful request


              if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                return;
              } // Prepare the response


              var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
              var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
              var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
              };
              settle(resolve, reject, response); // Clean up request

              request = null;
            }; // Handle browser request cancellation (as opposed to a manual cancellation)


            request.onabort = function handleAbort() {
              if (!request) {
                return;
              }

              reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

              request = null;
            }; // Handle low level network errors


            request.onerror = function handleError() {
              // Real errors are hidden from us by the browser
              // onerror should only fire if it's a network error
              reject(createError('Network Error', config, null, request)); // Clean up request

              request = null;
            }; // Handle timeout


            request.ontimeout = function handleTimeout() {
              var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

              if (config.timeoutErrorMessage) {
                timeoutErrorMessage = config.timeoutErrorMessage;
              }

              reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request)); // Clean up request

              request = null;
            }; // Add xsrf header
            // This is only done if running in a standard browser environment.
            // Specifically not if we're in a web worker, or react-native.


            if (utils.isStandardBrowserEnv()) {
              var cookies = __webpack_require__(
              /*! ./../helpers/cookies */
              "./node_modules/axios/lib/helpers/cookies.js"); // Add xsrf header


              var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

              if (xsrfValue) {
                requestHeaders[config.xsrfHeaderName] = xsrfValue;
              }
            } // Add headers to the request


            if ('setRequestHeader' in request) {
              utils.forEach(requestHeaders, function setRequestHeader(val, key) {
                if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                  // Remove Content-Type if data is undefined
                  delete requestHeaders[key];
                } else {
                  // Otherwise add header to the request
                  request.setRequestHeader(key, val);
                }
              });
            } // Add withCredentials to request if needed


            if (!utils.isUndefined(config.withCredentials)) {
              request.withCredentials = !!config.withCredentials;
            } // Add responseType to request if needed


            if (config.responseType) {
              try {
                request.responseType = config.responseType;
              } catch (e) {
                // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
                // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
                if (config.responseType !== 'json') {
                  throw e;
                }
              }
            } // Handle progress if needed


            if (typeof config.onDownloadProgress === 'function') {
              request.addEventListener('progress', config.onDownloadProgress);
            } // Not all browsers support upload events


            if (typeof config.onUploadProgress === 'function' && request.upload) {
              request.upload.addEventListener('progress', config.onUploadProgress);
            }

            if (config.cancelToken) {
              // Handle cancellation
              config.cancelToken.promise.then(function onCanceled(cancel) {
                if (!request) {
                  return;
                }

                request.abort();
                reject(cancel); // Clean up request

                request = null;
              });
            }

            if (requestData === undefined) {
              requestData = null;
            } // Send the request


            request.send(requestData);
          });
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/axios.js":
      /*!*****************************************!*\
        !*** ./node_modules/axios/lib/axios.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibAxiosJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./utils */
        "./node_modules/axios/lib/utils.js");

        var bind = __webpack_require__(
        /*! ./helpers/bind */
        "./node_modules/axios/lib/helpers/bind.js");

        var Axios = __webpack_require__(
        /*! ./core/Axios */
        "./node_modules/axios/lib/core/Axios.js");

        var mergeConfig = __webpack_require__(
        /*! ./core/mergeConfig */
        "./node_modules/axios/lib/core/mergeConfig.js");

        var defaults = __webpack_require__(
        /*! ./defaults */
        "./node_modules/axios/lib/defaults.js");
        /**
         * Create an instance of Axios
         *
         * @param {Object} defaultConfig The default config for the instance
         * @return {Axios} A new instance of Axios
         */


        function createInstance(defaultConfig) {
          var context = new Axios(defaultConfig);
          var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

          utils.extend(instance, Axios.prototype, context); // Copy context to instance

          utils.extend(instance, context);
          return instance;
        } // Create the default instance to be exported


        var axios = createInstance(defaults); // Expose Axios class to allow class inheritance

        axios.Axios = Axios; // Factory for creating new instances

        axios.create = function create(instanceConfig) {
          return createInstance(mergeConfig(axios.defaults, instanceConfig));
        }; // Expose Cancel & CancelToken


        axios.Cancel = __webpack_require__(
        /*! ./cancel/Cancel */
        "./node_modules/axios/lib/cancel/Cancel.js");
        axios.CancelToken = __webpack_require__(
        /*! ./cancel/CancelToken */
        "./node_modules/axios/lib/cancel/CancelToken.js");
        axios.isCancel = __webpack_require__(
        /*! ./cancel/isCancel */
        "./node_modules/axios/lib/cancel/isCancel.js"); // Expose all/spread

        axios.all = function all(promises) {
          return Promise.all(promises);
        };

        axios.spread = __webpack_require__(
        /*! ./helpers/spread */
        "./node_modules/axios/lib/helpers/spread.js");
        module.exports = axios; // Allow use of default import syntax in TypeScript

        module.exports.default = axios;
        /***/
      },

      /***/
      "./node_modules/axios/lib/cancel/Cancel.js":
      /*!*************************************************!*\
        !*** ./node_modules/axios/lib/cancel/Cancel.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCancelCancelJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * A `Cancel` is an object that is thrown when an operation is canceled.
         *
         * @class
         * @param {string=} message The message.
         */

        function Cancel(message) {
          this.message = message;
        }

        Cancel.prototype.toString = function toString() {
          return 'Cancel' + (this.message ? ': ' + this.message : '');
        };

        Cancel.prototype.__CANCEL__ = true;
        module.exports = Cancel;
        /***/
      },

      /***/
      "./node_modules/axios/lib/cancel/CancelToken.js":
      /*!******************************************************!*\
        !*** ./node_modules/axios/lib/cancel/CancelToken.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCancelCancelTokenJs(module, exports, __webpack_require__) {
        "use strict";

        var Cancel = __webpack_require__(
        /*! ./Cancel */
        "./node_modules/axios/lib/cancel/Cancel.js");
        /**
         * A `CancelToken` is an object that can be used to request cancellation of an operation.
         *
         * @class
         * @param {Function} executor The executor function.
         */


        function CancelToken(executor) {
          if (typeof executor !== 'function') {
            throw new TypeError('executor must be a function.');
          }

          var resolvePromise;
          this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
          });
          var token = this;
          executor(function cancel(message) {
            if (token.reason) {
              // Cancellation has already been requested
              return;
            }

            token.reason = new Cancel(message);
            resolvePromise(token.reason);
          });
        }
        /**
         * Throws a `Cancel` if cancellation has been requested.
         */


        CancelToken.prototype.throwIfRequested = function throwIfRequested() {
          if (this.reason) {
            throw this.reason;
          }
        };
        /**
         * Returns an object that contains a new `CancelToken` and a function that, when called,
         * cancels the `CancelToken`.
         */


        CancelToken.source = function source() {
          var cancel;
          var token = new CancelToken(function executor(c) {
            cancel = c;
          });
          return {
            token: token,
            cancel: cancel
          };
        };

        module.exports = CancelToken;
        /***/
      },

      /***/
      "./node_modules/axios/lib/cancel/isCancel.js":
      /*!***************************************************!*\
        !*** ./node_modules/axios/lib/cancel/isCancel.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCancelIsCancelJs(module, exports, __webpack_require__) {
        "use strict";

        module.exports = function isCancel(value) {
          return !!(value && value.__CANCEL__);
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/core/Axios.js":
      /*!**********************************************!*\
        !*** ./node_modules/axios/lib/core/Axios.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreAxiosJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js");

        var buildURL = __webpack_require__(
        /*! ../helpers/buildURL */
        "./node_modules/axios/lib/helpers/buildURL.js");

        var InterceptorManager = __webpack_require__(
        /*! ./InterceptorManager */
        "./node_modules/axios/lib/core/InterceptorManager.js");

        var dispatchRequest = __webpack_require__(
        /*! ./dispatchRequest */
        "./node_modules/axios/lib/core/dispatchRequest.js");

        var mergeConfig = __webpack_require__(
        /*! ./mergeConfig */
        "./node_modules/axios/lib/core/mergeConfig.js");
        /**
         * Create a new instance of Axios
         *
         * @param {Object} instanceConfig The default config for the instance
         */


        function Axios(instanceConfig) {
          this.defaults = instanceConfig;
          this.interceptors = {
            request: new InterceptorManager(),
            response: new InterceptorManager()
          };
        }
        /**
         * Dispatch a request
         *
         * @param {Object} config The config specific for this request (merged with this.defaults)
         */


        Axios.prototype.request = function request(config) {
          /*eslint no-param-reassign:0*/
          // Allow for axios('example/url'[, config]) a la fetch API
          if (typeof config === 'string') {
            config = arguments[1] || {};
            config.url = arguments[0];
          } else {
            config = config || {};
          }

          config = mergeConfig(this.defaults, config); // Set config.method

          if (config.method) {
            config.method = config.method.toLowerCase();
          } else if (this.defaults.method) {
            config.method = this.defaults.method.toLowerCase();
          } else {
            config.method = 'get';
          } // Hook up interceptors middleware


          var chain = [dispatchRequest, undefined];
          var promise = Promise.resolve(config);
          this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            chain.unshift(interceptor.fulfilled, interceptor.rejected);
          });
          this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            chain.push(interceptor.fulfilled, interceptor.rejected);
          });

          while (chain.length) {
            promise = promise.then(chain.shift(), chain.shift());
          }

          return promise;
        };

        Axios.prototype.getUri = function getUri(config) {
          config = mergeConfig(this.defaults, config);
          return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
        }; // Provide aliases for supported request methods


        utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
          /*eslint func-names:0*/
          Axios.prototype[method] = function (url, config) {
            return this.request(utils.merge(config || {}, {
              method: method,
              url: url
            }));
          };
        });
        utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
          /*eslint func-names:0*/
          Axios.prototype[method] = function (url, data, config) {
            return this.request(utils.merge(config || {}, {
              method: method,
              url: url,
              data: data
            }));
          };
        });
        module.exports = Axios;
        /***/
      },

      /***/
      "./node_modules/axios/lib/core/InterceptorManager.js":
      /*!***********************************************************!*\
        !*** ./node_modules/axios/lib/core/InterceptorManager.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreInterceptorManagerJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js");

        function InterceptorManager() {
          this.handlers = [];
        }
        /**
         * Add a new interceptor to the stack
         *
         * @param {Function} fulfilled The function to handle `then` for a `Promise`
         * @param {Function} rejected The function to handle `reject` for a `Promise`
         *
         * @return {Number} An ID used to remove interceptor later
         */


        InterceptorManager.prototype.use = function use(fulfilled, rejected) {
          this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected
          });
          return this.handlers.length - 1;
        };
        /**
         * Remove an interceptor from the stack
         *
         * @param {Number} id The ID that was returned by `use`
         */


        InterceptorManager.prototype.eject = function eject(id) {
          if (this.handlers[id]) {
            this.handlers[id] = null;
          }
        };
        /**
         * Iterate over all the registered interceptors
         *
         * This method is particularly useful for skipping over any
         * interceptors that may have become `null` calling `eject`.
         *
         * @param {Function} fn The function to call for each interceptor
         */


        InterceptorManager.prototype.forEach = function forEach(fn) {
          utils.forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) {
              fn(h);
            }
          });
        };

        module.exports = InterceptorManager;
        /***/
      },

      /***/
      "./node_modules/axios/lib/core/buildFullPath.js":
      /*!******************************************************!*\
        !*** ./node_modules/axios/lib/core/buildFullPath.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreBuildFullPathJs(module, exports, __webpack_require__) {
        "use strict";

        var isAbsoluteURL = __webpack_require__(
        /*! ../helpers/isAbsoluteURL */
        "./node_modules/axios/lib/helpers/isAbsoluteURL.js");

        var combineURLs = __webpack_require__(
        /*! ../helpers/combineURLs */
        "./node_modules/axios/lib/helpers/combineURLs.js");
        /**
         * Creates a new URL by combining the baseURL with the requestedURL,
         * only when the requestedURL is not already an absolute URL.
         * If the requestURL is absolute, this function returns the requestedURL untouched.
         *
         * @param {string} baseURL The base URL
         * @param {string} requestedURL Absolute or relative URL to combine
         * @returns {string} The combined full path
         */


        module.exports = function buildFullPath(baseURL, requestedURL) {
          if (baseURL && !isAbsoluteURL(requestedURL)) {
            return combineURLs(baseURL, requestedURL);
          }

          return requestedURL;
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/core/createError.js":
      /*!****************************************************!*\
        !*** ./node_modules/axios/lib/core/createError.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreCreateErrorJs(module, exports, __webpack_require__) {
        "use strict";

        var enhanceError = __webpack_require__(
        /*! ./enhanceError */
        "./node_modules/axios/lib/core/enhanceError.js");
        /**
         * Create an Error with the specified message, config, error code, request and response.
         *
         * @param {string} message The error message.
         * @param {Object} config The config.
         * @param {string} [code] The error code (for example, 'ECONNABORTED').
         * @param {Object} [request] The request.
         * @param {Object} [response] The response.
         * @returns {Error} The created error.
         */


        module.exports = function createError(message, config, code, request, response) {
          var error = new Error(message);
          return enhanceError(error, config, code, request, response);
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/core/dispatchRequest.js":
      /*!********************************************************!*\
        !*** ./node_modules/axios/lib/core/dispatchRequest.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreDispatchRequestJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js");

        var transformData = __webpack_require__(
        /*! ./transformData */
        "./node_modules/axios/lib/core/transformData.js");

        var isCancel = __webpack_require__(
        /*! ../cancel/isCancel */
        "./node_modules/axios/lib/cancel/isCancel.js");

        var defaults = __webpack_require__(
        /*! ../defaults */
        "./node_modules/axios/lib/defaults.js");
        /**
         * Throws a `Cancel` if cancellation has been requested.
         */


        function throwIfCancellationRequested(config) {
          if (config.cancelToken) {
            config.cancelToken.throwIfRequested();
          }
        }
        /**
         * Dispatch a request to the server using the configured adapter.
         *
         * @param {object} config The config that is to be used for the request
         * @returns {Promise} The Promise to be fulfilled
         */


        module.exports = function dispatchRequest(config) {
          throwIfCancellationRequested(config); // Ensure headers exist

          config.headers = config.headers || {}; // Transform request data

          config.data = transformData(config.data, config.headers, config.transformRequest); // Flatten headers

          config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
          utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
            delete config.headers[method];
          });
          var adapter = config.adapter || defaults.adapter;
          return adapter(config).then(function onAdapterResolution(response) {
            throwIfCancellationRequested(config); // Transform response data

            response.data = transformData(response.data, response.headers, config.transformResponse);
            return response;
          }, function onAdapterRejection(reason) {
            if (!isCancel(reason)) {
              throwIfCancellationRequested(config); // Transform response data

              if (reason && reason.response) {
                reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
              }
            }

            return Promise.reject(reason);
          });
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/core/enhanceError.js":
      /*!*****************************************************!*\
        !*** ./node_modules/axios/lib/core/enhanceError.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreEnhanceErrorJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Update an Error with the specified config, error code, and response.
         *
         * @param {Error} error The error to update.
         * @param {Object} config The config.
         * @param {string} [code] The error code (for example, 'ECONNABORTED').
         * @param {Object} [request] The request.
         * @param {Object} [response] The response.
         * @returns {Error} The error.
         */

        module.exports = function enhanceError(error, config, code, request, response) {
          error.config = config;

          if (code) {
            error.code = code;
          }

          error.request = request;
          error.response = response;
          error.isAxiosError = true;

          error.toJSON = function () {
            return {
              // Standard
              message: this.message,
              name: this.name,
              // Microsoft
              description: this.description,
              number: this.number,
              // Mozilla
              fileName: this.fileName,
              lineNumber: this.lineNumber,
              columnNumber: this.columnNumber,
              stack: this.stack,
              // Axios
              config: this.config,
              code: this.code
            };
          };

          return error;
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/core/mergeConfig.js":
      /*!****************************************************!*\
        !*** ./node_modules/axios/lib/core/mergeConfig.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreMergeConfigJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ../utils */
        "./node_modules/axios/lib/utils.js");
        /**
         * Config-specific merge-function which creates a new config-object
         * by merging two configuration objects together.
         *
         * @param {Object} config1
         * @param {Object} config2
         * @returns {Object} New object resulting from merging config2 to config1
         */


        module.exports = function mergeConfig(config1, config2) {
          // eslint-disable-next-line no-param-reassign
          config2 = config2 || {};
          var config = {};
          var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
          var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
          var defaultToConfig2Keys = ['baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath'];
          utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
            if (typeof config2[prop] !== 'undefined') {
              config[prop] = config2[prop];
            }
          });
          utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
            if (utils.isObject(config2[prop])) {
              config[prop] = utils.deepMerge(config1[prop], config2[prop]);
            } else if (typeof config2[prop] !== 'undefined') {
              config[prop] = config2[prop];
            } else if (utils.isObject(config1[prop])) {
              config[prop] = utils.deepMerge(config1[prop]);
            } else if (typeof config1[prop] !== 'undefined') {
              config[prop] = config1[prop];
            }
          });
          utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
            if (typeof config2[prop] !== 'undefined') {
              config[prop] = config2[prop];
            } else if (typeof config1[prop] !== 'undefined') {
              config[prop] = config1[prop];
            }
          });
          var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
          var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
            return axiosKeys.indexOf(key) === -1;
          });
          utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
            if (typeof config2[prop] !== 'undefined') {
              config[prop] = config2[prop];
            } else if (typeof config1[prop] !== 'undefined') {
              config[prop] = config1[prop];
            }
          });
          return config;
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/core/settle.js":
      /*!***********************************************!*\
        !*** ./node_modules/axios/lib/core/settle.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreSettleJs(module, exports, __webpack_require__) {
        "use strict";

        var createError = __webpack_require__(
        /*! ./createError */
        "./node_modules/axios/lib/core/createError.js");
        /**
         * Resolve or reject a Promise based on response status.
         *
         * @param {Function} resolve A function that resolves the promise.
         * @param {Function} reject A function that rejects the promise.
         * @param {object} response The response.
         */


        module.exports = function settle(resolve, reject, response) {
          var validateStatus = response.config.validateStatus;

          if (!validateStatus || validateStatus(response.status)) {
            resolve(response);
          } else {
            reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
          }
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/core/transformData.js":
      /*!******************************************************!*\
        !*** ./node_modules/axios/lib/core/transformData.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibCoreTransformDataJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js");
        /**
         * Transform the data for a request or a response
         *
         * @param {Object|String} data The data to be transformed
         * @param {Array} headers The headers for the request or response
         * @param {Array|Function} fns A single function or Array of functions
         * @returns {*} The resulting transformed data
         */


        module.exports = function transformData(data, headers, fns) {
          /*eslint no-param-reassign:0*/
          utils.forEach(fns, function transform(fn) {
            data = fn(data, headers);
          });
          return data;
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/defaults.js":
      /*!********************************************!*\
        !*** ./node_modules/axios/lib/defaults.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibDefaultsJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (process) {
          var utils = __webpack_require__(
          /*! ./utils */
          "./node_modules/axios/lib/utils.js");

          var normalizeHeaderName = __webpack_require__(
          /*! ./helpers/normalizeHeaderName */
          "./node_modules/axios/lib/helpers/normalizeHeaderName.js");

          var DEFAULT_CONTENT_TYPE = {
            'Content-Type': 'application/x-www-form-urlencoded'
          };

          function setContentTypeIfUnset(headers, value) {
            if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
              headers['Content-Type'] = value;
            }
          }

          function getDefaultAdapter() {
            var adapter;

            if (typeof XMLHttpRequest !== 'undefined') {
              // For browsers use XHR adapter
              adapter = __webpack_require__(
              /*! ./adapters/xhr */
              "./node_modules/axios/lib/adapters/xhr.js");
            } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
              // For node use HTTP adapter
              adapter = __webpack_require__(
              /*! ./adapters/http */
              "./node_modules/axios/lib/adapters/xhr.js");
            }

            return adapter;
          }

          var defaults = {
            adapter: getDefaultAdapter(),
            transformRequest: [function transformRequest(data, headers) {
              normalizeHeaderName(headers, 'Accept');
              normalizeHeaderName(headers, 'Content-Type');

              if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
                return data;
              }

              if (utils.isArrayBufferView(data)) {
                return data.buffer;
              }

              if (utils.isURLSearchParams(data)) {
                setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
              }

              if (utils.isObject(data)) {
                setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
              }

              return data;
            }],
            transformResponse: [function transformResponse(data) {
              /*eslint no-param-reassign:0*/
              if (typeof data === 'string') {
                try {
                  data = JSON.parse(data);
                } catch (e) {
                  /* Ignore */
                }
              }

              return data;
            }],

            /**
             * A timeout in milliseconds to abort a request. If set to 0 (default) a
             * timeout is not created.
             */
            timeout: 0,
            xsrfCookieName: 'XSRF-TOKEN',
            xsrfHeaderName: 'X-XSRF-TOKEN',
            maxContentLength: -1,
            validateStatus: function validateStatus(status) {
              return status >= 200 && status < 300;
            }
          };
          defaults.headers = {
            common: {
              'Accept': 'application/json, text/plain, */*'
            }
          };
          utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
            defaults.headers[method] = {};
          });
          utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
            defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
          });
          module.exports = defaults;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../process/browser.js */
        "./node_modules/process/browser.js"));
        /***/
      },

      /***/
      "./node_modules/axios/lib/helpers/bind.js":
      /*!************************************************!*\
        !*** ./node_modules/axios/lib/helpers/bind.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersBindJs(module, exports, __webpack_require__) {
        "use strict";

        module.exports = function bind(fn, thisArg) {
          return function wrap() {
            var args = new Array(arguments.length);

            for (var i = 0; i < args.length; i++) {
              args[i] = arguments[i];
            }

            return fn.apply(thisArg, args);
          };
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/helpers/buildURL.js":
      /*!****************************************************!*\
        !*** ./node_modules/axios/lib/helpers/buildURL.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersBuildURLJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js");

        function encode(val) {
          return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
        }
        /**
         * Build a URL by appending params to the end
         *
         * @param {string} url The base of the url (e.g., http://www.google.com)
         * @param {object} [params] The params to be appended
         * @returns {string} The formatted url
         */


        module.exports = function buildURL(url, params, paramsSerializer) {
          /*eslint no-param-reassign:0*/
          if (!params) {
            return url;
          }

          var serializedParams;

          if (paramsSerializer) {
            serializedParams = paramsSerializer(params);
          } else if (utils.isURLSearchParams(params)) {
            serializedParams = params.toString();
          } else {
            var parts = [];
            utils.forEach(params, function serialize(val, key) {
              if (val === null || typeof val === 'undefined') {
                return;
              }

              if (utils.isArray(val)) {
                key = key + '[]';
              } else {
                val = [val];
              }

              utils.forEach(val, function parseValue(v) {
                if (utils.isDate(v)) {
                  v = v.toISOString();
                } else if (utils.isObject(v)) {
                  v = JSON.stringify(v);
                }

                parts.push(encode(key) + '=' + encode(v));
              });
            });
            serializedParams = parts.join('&');
          }

          if (serializedParams) {
            var hashmarkIndex = url.indexOf('#');

            if (hashmarkIndex !== -1) {
              url = url.slice(0, hashmarkIndex);
            }

            url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
          }

          return url;
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/helpers/combineURLs.js":
      /*!*******************************************************!*\
        !*** ./node_modules/axios/lib/helpers/combineURLs.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersCombineURLsJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Creates a new URL by combining the specified URLs
         *
         * @param {string} baseURL The base URL
         * @param {string} relativeURL The relative URL
         * @returns {string} The combined URL
         */

        module.exports = function combineURLs(baseURL, relativeURL) {
          return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/helpers/cookies.js":
      /*!***************************************************!*\
        !*** ./node_modules/axios/lib/helpers/cookies.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersCookiesJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js");

        module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
        function standardBrowserEnv() {
          return {
            write: function write(name, value, expires, path, domain, secure) {
              var cookie = [];
              cookie.push(name + '=' + encodeURIComponent(value));

              if (utils.isNumber(expires)) {
                cookie.push('expires=' + new Date(expires).toGMTString());
              }

              if (utils.isString(path)) {
                cookie.push('path=' + path);
              }

              if (utils.isString(domain)) {
                cookie.push('domain=' + domain);
              }

              if (secure === true) {
                cookie.push('secure');
              }

              document.cookie = cookie.join('; ');
            },
            read: function read(name) {
              var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
              return match ? decodeURIComponent(match[3]) : null;
            },
            remove: function remove(name) {
              this.write(name, '', Date.now() - 86400000);
            }
          };
        }() : // Non standard browser env (web workers, react-native) lack needed support.
        function nonStandardBrowserEnv() {
          return {
            write: function write() {},
            read: function read() {
              return null;
            },
            remove: function remove() {}
          };
        }();
        /***/
      },

      /***/
      "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
      /*!*********************************************************!*\
        !*** ./node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersIsAbsoluteURLJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Determines whether the specified URL is absolute
         *
         * @param {string} url The URL to test
         * @returns {boolean} True if the specified URL is absolute, otherwise false
         */

        module.exports = function isAbsoluteURL(url) {
          // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
          // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
          // by any combination of letters, digits, plus, period, or hyphen.
          return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
      /*!***********************************************************!*\
        !*** ./node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersIsURLSameOriginJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js");

        module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
        // whether the request URL is of the same origin as current location.
        function standardBrowserEnv() {
          var msie = /(msie|trident)/i.test(navigator.userAgent);
          var urlParsingNode = document.createElement('a');
          var originURL;
          /**
          * Parse a URL to discover it's components
          *
          * @param {String} url The URL to be parsed
          * @returns {Object}
          */

          function resolveURL(url) {
            var href = url;

            if (msie) {
              // IE needs attribute set twice to normalize properties
              urlParsingNode.setAttribute('href', href);
              href = urlParsingNode.href;
            }

            urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

            return {
              href: urlParsingNode.href,
              protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
              host: urlParsingNode.host,
              search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
              hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
              hostname: urlParsingNode.hostname,
              port: urlParsingNode.port,
              pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
            };
          }

          originURL = resolveURL(window.location.href);
          /**
          * Determine if a URL shares the same origin as the current location
          *
          * @param {String} requestURL The URL to test
          * @returns {boolean} True if URL shares the same origin, otherwise false
          */

          return function isURLSameOrigin(requestURL) {
            var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
            return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
          };
        }() : // Non standard browser envs (web workers, react-native) lack needed support.
        function nonStandardBrowserEnv() {
          return function isURLSameOrigin() {
            return true;
          };
        }();
        /***/
      },

      /***/
      "./node_modules/axios/lib/helpers/normalizeHeaderName.js":
      /*!***************************************************************!*\
        !*** ./node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersNormalizeHeaderNameJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ../utils */
        "./node_modules/axios/lib/utils.js");

        module.exports = function normalizeHeaderName(headers, normalizedName) {
          utils.forEach(headers, function processHeader(value, name) {
            if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
              headers[normalizedName] = value;
              delete headers[name];
            }
          });
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/helpers/parseHeaders.js":
      /*!********************************************************!*\
        !*** ./node_modules/axios/lib/helpers/parseHeaders.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersParseHeadersJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__(
        /*! ./../utils */
        "./node_modules/axios/lib/utils.js"); // Headers whose duplicates are ignored by node
        // c.f. https://nodejs.org/api/http.html#http_message_headers


        var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
        /**
         * Parse headers into an object
         *
         * ```
         * Date: Wed, 27 Aug 2014 08:58:49 GMT
         * Content-Type: application/json
         * Connection: keep-alive
         * Transfer-Encoding: chunked
         * ```
         *
         * @param {String} headers Headers needing to be parsed
         * @returns {Object} Headers parsed into an object
         */

        module.exports = function parseHeaders(headers) {
          var parsed = {};
          var key;
          var val;
          var i;

          if (!headers) {
            return parsed;
          }

          utils.forEach(headers.split('\n'), function parser(line) {
            i = line.indexOf(':');
            key = utils.trim(line.substr(0, i)).toLowerCase();
            val = utils.trim(line.substr(i + 1));

            if (key) {
              if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
                return;
              }

              if (key === 'set-cookie') {
                parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
              } else {
                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
              }
            }
          });
          return parsed;
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/helpers/spread.js":
      /*!**************************************************!*\
        !*** ./node_modules/axios/lib/helpers/spread.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibHelpersSpreadJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Syntactic sugar for invoking a function and expanding an array for arguments.
         *
         * Common use case would be to use `Function.prototype.apply`.
         *
         *  ```js
         *  function f(x, y, z) {}
         *  var args = [1, 2, 3];
         *  f.apply(null, args);
         *  ```
         *
         * With `spread` this example can be re-written.
         *
         *  ```js
         *  spread(function(x, y, z) {})([1, 2, 3]);
         *  ```
         *
         * @param {Function} callback
         * @returns {Function}
         */

        module.exports = function spread(callback) {
          return function wrap(arr) {
            return callback.apply(null, arr);
          };
        };
        /***/

      },

      /***/
      "./node_modules/axios/lib/utils.js":
      /*!*****************************************!*\
        !*** ./node_modules/axios/lib/utils.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesAxiosLibUtilsJs(module, exports, __webpack_require__) {
        "use strict";

        var bind = __webpack_require__(
        /*! ./helpers/bind */
        "./node_modules/axios/lib/helpers/bind.js");
        /*global toString:true*/
        // utils is a library of generic helper functions non-specific to axios


        var toString = Object.prototype.toString;
        /**
         * Determine if a value is an Array
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is an Array, otherwise false
         */

        function isArray(val) {
          return toString.call(val) === '[object Array]';
        }
        /**
         * Determine if a value is undefined
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if the value is undefined, otherwise false
         */


        function isUndefined(val) {
          return typeof val === 'undefined';
        }
        /**
         * Determine if a value is a Buffer
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Buffer, otherwise false
         */


        function isBuffer(val) {
          return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
        }
        /**
         * Determine if a value is an ArrayBuffer
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is an ArrayBuffer, otherwise false
         */


        function isArrayBuffer(val) {
          return toString.call(val) === '[object ArrayBuffer]';
        }
        /**
         * Determine if a value is a FormData
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is an FormData, otherwise false
         */


        function isFormData(val) {
          return typeof FormData !== 'undefined' && val instanceof FormData;
        }
        /**
         * Determine if a value is a view on an ArrayBuffer
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
         */


        function isArrayBufferView(val) {
          var result;

          if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
            result = ArrayBuffer.isView(val);
          } else {
            result = val && val.buffer && val.buffer instanceof ArrayBuffer;
          }

          return result;
        }
        /**
         * Determine if a value is a String
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a String, otherwise false
         */


        function isString(val) {
          return typeof val === 'string';
        }
        /**
         * Determine if a value is a Number
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Number, otherwise false
         */


        function isNumber(val) {
          return typeof val === 'number';
        }
        /**
         * Determine if a value is an Object
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is an Object, otherwise false
         */


        function isObject(val) {
          return val !== null && typeof val === 'object';
        }
        /**
         * Determine if a value is a Date
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Date, otherwise false
         */


        function isDate(val) {
          return toString.call(val) === '[object Date]';
        }
        /**
         * Determine if a value is a File
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a File, otherwise false
         */


        function isFile(val) {
          return toString.call(val) === '[object File]';
        }
        /**
         * Determine if a value is a Blob
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Blob, otherwise false
         */


        function isBlob(val) {
          return toString.call(val) === '[object Blob]';
        }
        /**
         * Determine if a value is a Function
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Function, otherwise false
         */


        function isFunction(val) {
          return toString.call(val) === '[object Function]';
        }
        /**
         * Determine if a value is a Stream
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Stream, otherwise false
         */


        function isStream(val) {
          return isObject(val) && isFunction(val.pipe);
        }
        /**
         * Determine if a value is a URLSearchParams object
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a URLSearchParams object, otherwise false
         */


        function isURLSearchParams(val) {
          return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
        }
        /**
         * Trim excess whitespace off the beginning and end of a string
         *
         * @param {String} str The String to trim
         * @returns {String} The String freed of excess whitespace
         */


        function trim(str) {
          return str.replace(/^\s*/, '').replace(/\s*$/, '');
        }
        /**
         * Determine if we're running in a standard browser environment
         *
         * This allows axios to run in a web worker, and react-native.
         * Both environments support XMLHttpRequest, but not fully standard globals.
         *
         * web workers:
         *  typeof window -> undefined
         *  typeof document -> undefined
         *
         * react-native:
         *  navigator.product -> 'ReactNative'
         * nativescript
         *  navigator.product -> 'NativeScript' or 'NS'
         */


        function isStandardBrowserEnv() {
          if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
            return false;
          }

          return typeof window !== 'undefined' && typeof document !== 'undefined';
        }
        /**
         * Iterate over an Array or an Object invoking a function for each item.
         *
         * If `obj` is an Array callback will be called passing
         * the value, index, and complete array for each item.
         *
         * If 'obj' is an Object callback will be called passing
         * the value, key, and complete object for each property.
         *
         * @param {Object|Array} obj The object to iterate
         * @param {Function} fn The callback to invoke for each item
         */


        function forEach(obj, fn) {
          // Don't bother if no value provided
          if (obj === null || typeof obj === 'undefined') {
            return;
          } // Force an array if not already something iterable


          if (typeof obj !== 'object') {
            /*eslint no-param-reassign:0*/
            obj = [obj];
          }

          if (isArray(obj)) {
            // Iterate over array values
            for (var i = 0, l = obj.length; i < l; i++) {
              fn.call(null, obj[i], i, obj);
            }
          } else {
            // Iterate over object keys
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                fn.call(null, obj[key], key, obj);
              }
            }
          }
        }
        /**
         * Accepts varargs expecting each argument to be an object, then
         * immutably merges the properties of each object and returns result.
         *
         * When multiple objects contain the same key the later object in
         * the arguments list will take precedence.
         *
         * Example:
         *
         * ```js
         * var result = merge({foo: 123}, {foo: 456});
         * console.log(result.foo); // outputs 456
         * ```
         *
         * @param {Object} obj1 Object to merge
         * @returns {Object} Result of all merge properties
         */


        function merge()
        /* obj1, obj2, obj3, ... */
        {
          var result = {};

          function assignValue(val, key) {
            if (typeof result[key] === 'object' && typeof val === 'object') {
              result[key] = merge(result[key], val);
            } else {
              result[key] = val;
            }
          }

          for (var i = 0, l = arguments.length; i < l; i++) {
            forEach(arguments[i], assignValue);
          }

          return result;
        }
        /**
         * Function equal to merge with the difference being that no reference
         * to original objects is kept.
         *
         * @see merge
         * @param {Object} obj1 Object to merge
         * @returns {Object} Result of all merge properties
         */


        function deepMerge()
        /* obj1, obj2, obj3, ... */
        {
          var result = {};

          function assignValue(val, key) {
            if (typeof result[key] === 'object' && typeof val === 'object') {
              result[key] = deepMerge(result[key], val);
            } else if (typeof val === 'object') {
              result[key] = deepMerge({}, val);
            } else {
              result[key] = val;
            }
          }

          for (var i = 0, l = arguments.length; i < l; i++) {
            forEach(arguments[i], assignValue);
          }

          return result;
        }
        /**
         * Extends object a by mutably adding to it the properties of object b.
         *
         * @param {Object} a The object to be extended
         * @param {Object} b The object to copy properties from
         * @param {Object} thisArg The object to bind function to
         * @return {Object} The resulting value of object a
         */


        function extend(a, b, thisArg) {
          forEach(b, function assignValue(val, key) {
            if (thisArg && typeof val === 'function') {
              a[key] = bind(val, thisArg);
            } else {
              a[key] = val;
            }
          });
          return a;
        }

        module.exports = {
          isArray: isArray,
          isArrayBuffer: isArrayBuffer,
          isBuffer: isBuffer,
          isFormData: isFormData,
          isArrayBufferView: isArrayBufferView,
          isString: isString,
          isNumber: isNumber,
          isObject: isObject,
          isUndefined: isUndefined,
          isDate: isDate,
          isFile: isFile,
          isBlob: isBlob,
          isFunction: isFunction,
          isStream: isStream,
          isURLSearchParams: isURLSearchParams,
          isStandardBrowserEnv: isStandardBrowserEnv,
          forEach: forEach,
          merge: merge,
          deepMerge: deepMerge,
          extend: extend,
          trim: trim
        };
        /***/
      },

      /***/
      "./node_modules/brcast/dist/brcast.es.js":
      /*!***********************************************!*\
        !*** ./node_modules/brcast/dist/brcast.es.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function node_modulesBrcastDistBrcastEsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        function createBroadcast(initialState) {
          var listeners = {};
          var id = 1;
          var _state = initialState;

          function getState() {
            return _state;
          }

          function setState(state) {
            _state = state;
            var keys = Object.keys(listeners);
            var i = 0;
            var len = keys.length;

            for (; i < len; i++) {
              // if a listener gets unsubscribed during setState we just skip it
              if (listeners[keys[i]]) {
                listeners[keys[i]](state);
              }
            }
          } // subscribe to changes and return the subscriptionId


          function subscribe(listener) {
            if (typeof listener !== 'function') {
              throw new Error('listener must be a function.');
            }

            var currentId = id;
            listeners[currentId] = listener;
            id += 1;
            return currentId;
          } // remove subscription by removing the listener function


          function unsubscribe(id) {
            delete listeners[id];
          }

          return {
            getState: getState,
            setState: setState,
            subscribe: subscribe,
            unsubscribe: unsubscribe
          };
        }
        /* harmony default export */


        __webpack_exports__["default"] = createBroadcast;
        /***/
      },

      /***/
      "./node_modules/color-convert/conversions.js":
      /*!***************************************************!*\
        !*** ./node_modules/color-convert/conversions.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesColorConvertConversionsJs(module, exports, __webpack_require__) {
        /* MIT license */
        var cssKeywords = __webpack_require__(
        /*! color-name */
        "./node_modules/color-name/index.js"); // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)


        var reverseKeywords = {};

        for (var key in cssKeywords) {
          if (cssKeywords.hasOwnProperty(key)) {
            reverseKeywords[cssKeywords[key]] = key;
          }
        }

        var convert = module.exports = {
          rgb: {
            channels: 3,
            labels: 'rgb'
          },
          hsl: {
            channels: 3,
            labels: 'hsl'
          },
          hsv: {
            channels: 3,
            labels: 'hsv'
          },
          hwb: {
            channels: 3,
            labels: 'hwb'
          },
          cmyk: {
            channels: 4,
            labels: 'cmyk'
          },
          xyz: {
            channels: 3,
            labels: 'xyz'
          },
          lab: {
            channels: 3,
            labels: 'lab'
          },
          lch: {
            channels: 3,
            labels: 'lch'
          },
          hex: {
            channels: 1,
            labels: ['hex']
          },
          keyword: {
            channels: 1,
            labels: ['keyword']
          },
          ansi16: {
            channels: 1,
            labels: ['ansi16']
          },
          ansi256: {
            channels: 1,
            labels: ['ansi256']
          },
          hcg: {
            channels: 3,
            labels: ['h', 'c', 'g']
          },
          apple: {
            channels: 3,
            labels: ['r16', 'g16', 'b16']
          },
          gray: {
            channels: 1,
            labels: ['gray']
          }
        }; // hide .channels and .labels properties

        for (var model in convert) {
          if (convert.hasOwnProperty(model)) {
            if (!('channels' in convert[model])) {
              throw new Error('missing channels property: ' + model);
            }

            if (!('labels' in convert[model])) {
              throw new Error('missing channel labels property: ' + model);
            }

            if (convert[model].labels.length !== convert[model].channels) {
              throw new Error('channel and label counts mismatch: ' + model);
            }

            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], 'channels', {
              value: channels
            });
            Object.defineProperty(convert[model], 'labels', {
              value: labels
            });
          }
        }

        convert.rgb.hsl = function (rgb) {
          var r = rgb[0] / 255;
          var g = rgb[1] / 255;
          var b = rgb[2] / 255;
          var min = Math.min(r, g, b);
          var max = Math.max(r, g, b);
          var delta = max - min;
          var h;
          var s;
          var l;

          if (max === min) {
            h = 0;
          } else if (r === max) {
            h = (g - b) / delta;
          } else if (g === max) {
            h = 2 + (b - r) / delta;
          } else if (b === max) {
            h = 4 + (r - g) / delta;
          }

          h = Math.min(h * 60, 360);

          if (h < 0) {
            h += 360;
          }

          l = (min + max) / 2;

          if (max === min) {
            s = 0;
          } else if (l <= 0.5) {
            s = delta / (max + min);
          } else {
            s = delta / (2 - max - min);
          }

          return [h, s * 100, l * 100];
        };

        convert.rgb.hsv = function (rgb) {
          var rdif;
          var gdif;
          var bdif;
          var h;
          var s;
          var r = rgb[0] / 255;
          var g = rgb[1] / 255;
          var b = rgb[2] / 255;
          var v = Math.max(r, g, b);
          var diff = v - Math.min(r, g, b);

          var diffc = function diffc(c) {
            return (v - c) / 6 / diff + 1 / 2;
          };

          if (diff === 0) {
            h = s = 0;
          } else {
            s = diff / v;
            rdif = diffc(r);
            gdif = diffc(g);
            bdif = diffc(b);

            if (r === v) {
              h = bdif - gdif;
            } else if (g === v) {
              h = 1 / 3 + rdif - bdif;
            } else if (b === v) {
              h = 2 / 3 + gdif - rdif;
            }

            if (h < 0) {
              h += 1;
            } else if (h > 1) {
              h -= 1;
            }
          }

          return [h * 360, s * 100, v * 100];
        };

        convert.rgb.hwb = function (rgb) {
          var r = rgb[0];
          var g = rgb[1];
          var b = rgb[2];
          var h = convert.rgb.hsl(rgb)[0];
          var w = 1 / 255 * Math.min(r, Math.min(g, b));
          b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
          return [h, w * 100, b * 100];
        };

        convert.rgb.cmyk = function (rgb) {
          var r = rgb[0] / 255;
          var g = rgb[1] / 255;
          var b = rgb[2] / 255;
          var c;
          var m;
          var y;
          var k;
          k = Math.min(1 - r, 1 - g, 1 - b);
          c = (1 - r - k) / (1 - k) || 0;
          m = (1 - g - k) / (1 - k) || 0;
          y = (1 - b - k) / (1 - k) || 0;
          return [c * 100, m * 100, y * 100, k * 100];
        };
        /**
         * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
         * */


        function comparativeDistance(x, y) {
          return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }

        convert.rgb.keyword = function (rgb) {
          var reversed = reverseKeywords[rgb];

          if (reversed) {
            return reversed;
          }

          var currentClosestDistance = Infinity;
          var currentClosestKeyword;

          for (var keyword in cssKeywords) {
            if (cssKeywords.hasOwnProperty(keyword)) {
              var value = cssKeywords[keyword]; // Compute comparative distance

              var distance = comparativeDistance(rgb, value); // Check if its less, if so set as closest

              if (distance < currentClosestDistance) {
                currentClosestDistance = distance;
                currentClosestKeyword = keyword;
              }
            }
          }

          return currentClosestKeyword;
        };

        convert.keyword.rgb = function (keyword) {
          return cssKeywords[keyword];
        };

        convert.rgb.xyz = function (rgb) {
          var r = rgb[0] / 255;
          var g = rgb[1] / 255;
          var b = rgb[2] / 255; // assume sRGB

          r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
          g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
          b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
          var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
          var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
          var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
          return [x * 100, y * 100, z * 100];
        };

        convert.rgb.lab = function (rgb) {
          var xyz = convert.rgb.xyz(rgb);
          var x = xyz[0];
          var y = xyz[1];
          var z = xyz[2];
          var l;
          var a;
          var b;
          x /= 95.047;
          y /= 100;
          z /= 108.883;
          x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
          y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
          z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
          l = 116 * y - 16;
          a = 500 * (x - y);
          b = 200 * (y - z);
          return [l, a, b];
        };

        convert.hsl.rgb = function (hsl) {
          var h = hsl[0] / 360;
          var s = hsl[1] / 100;
          var l = hsl[2] / 100;
          var t1;
          var t2;
          var t3;
          var rgb;
          var val;

          if (s === 0) {
            val = l * 255;
            return [val, val, val];
          }

          if (l < 0.5) {
            t2 = l * (1 + s);
          } else {
            t2 = l + s - l * s;
          }

          t1 = 2 * l - t2;
          rgb = [0, 0, 0];

          for (var i = 0; i < 3; i++) {
            t3 = h + 1 / 3 * -(i - 1);

            if (t3 < 0) {
              t3++;
            }

            if (t3 > 1) {
              t3--;
            }

            if (6 * t3 < 1) {
              val = t1 + (t2 - t1) * 6 * t3;
            } else if (2 * t3 < 1) {
              val = t2;
            } else if (3 * t3 < 2) {
              val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
            } else {
              val = t1;
            }

            rgb[i] = val * 255;
          }

          return rgb;
        };

        convert.hsl.hsv = function (hsl) {
          var h = hsl[0];
          var s = hsl[1] / 100;
          var l = hsl[2] / 100;
          var smin = s;
          var lmin = Math.max(l, 0.01);
          var sv;
          var v;
          l *= 2;
          s *= l <= 1 ? l : 2 - l;
          smin *= lmin <= 1 ? lmin : 2 - lmin;
          v = (l + s) / 2;
          sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
          return [h, sv * 100, v * 100];
        };

        convert.hsv.rgb = function (hsv) {
          var h = hsv[0] / 60;
          var s = hsv[1] / 100;
          var v = hsv[2] / 100;
          var hi = Math.floor(h) % 6;
          var f = h - Math.floor(h);
          var p = 255 * v * (1 - s);
          var q = 255 * v * (1 - s * f);
          var t = 255 * v * (1 - s * (1 - f));
          v *= 255;

          switch (hi) {
            case 0:
              return [v, t, p];

            case 1:
              return [q, v, p];

            case 2:
              return [p, v, t];

            case 3:
              return [p, q, v];

            case 4:
              return [t, p, v];

            case 5:
              return [v, p, q];
          }
        };

        convert.hsv.hsl = function (hsv) {
          var h = hsv[0];
          var s = hsv[1] / 100;
          var v = hsv[2] / 100;
          var vmin = Math.max(v, 0.01);
          var lmin;
          var sl;
          var l;
          l = (2 - s) * v;
          lmin = (2 - s) * vmin;
          sl = s * vmin;
          sl /= lmin <= 1 ? lmin : 2 - lmin;
          sl = sl || 0;
          l /= 2;
          return [h, sl * 100, l * 100];
        }; // http://dev.w3.org/csswg/css-color/#hwb-to-rgb


        convert.hwb.rgb = function (hwb) {
          var h = hwb[0] / 360;
          var wh = hwb[1] / 100;
          var bl = hwb[2] / 100;
          var ratio = wh + bl;
          var i;
          var v;
          var f;
          var n; // wh + bl cant be > 1

          if (ratio > 1) {
            wh /= ratio;
            bl /= ratio;
          }

          i = Math.floor(6 * h);
          v = 1 - bl;
          f = 6 * h - i;

          if ((i & 0x01) !== 0) {
            f = 1 - f;
          }

          n = wh + f * (v - wh); // linear interpolation

          var r;
          var g;
          var b;

          switch (i) {
            default:
            case 6:
            case 0:
              r = v;
              g = n;
              b = wh;
              break;

            case 1:
              r = n;
              g = v;
              b = wh;
              break;

            case 2:
              r = wh;
              g = v;
              b = n;
              break;

            case 3:
              r = wh;
              g = n;
              b = v;
              break;

            case 4:
              r = n;
              g = wh;
              b = v;
              break;

            case 5:
              r = v;
              g = wh;
              b = n;
              break;
          }

          return [r * 255, g * 255, b * 255];
        };

        convert.cmyk.rgb = function (cmyk) {
          var c = cmyk[0] / 100;
          var m = cmyk[1] / 100;
          var y = cmyk[2] / 100;
          var k = cmyk[3] / 100;
          var r;
          var g;
          var b;
          r = 1 - Math.min(1, c * (1 - k) + k);
          g = 1 - Math.min(1, m * (1 - k) + k);
          b = 1 - Math.min(1, y * (1 - k) + k);
          return [r * 255, g * 255, b * 255];
        };

        convert.xyz.rgb = function (xyz) {
          var x = xyz[0] / 100;
          var y = xyz[1] / 100;
          var z = xyz[2] / 100;
          var r;
          var g;
          var b;
          r = x * 3.2406 + y * -1.5372 + z * -0.4986;
          g = x * -0.9689 + y * 1.8758 + z * 0.0415;
          b = x * 0.0557 + y * -0.2040 + z * 1.0570; // assume sRGB

          r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
          g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
          b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
          r = Math.min(Math.max(0, r), 1);
          g = Math.min(Math.max(0, g), 1);
          b = Math.min(Math.max(0, b), 1);
          return [r * 255, g * 255, b * 255];
        };

        convert.xyz.lab = function (xyz) {
          var x = xyz[0];
          var y = xyz[1];
          var z = xyz[2];
          var l;
          var a;
          var b;
          x /= 95.047;
          y /= 100;
          z /= 108.883;
          x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
          y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
          z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
          l = 116 * y - 16;
          a = 500 * (x - y);
          b = 200 * (y - z);
          return [l, a, b];
        };

        convert.lab.xyz = function (lab) {
          var l = lab[0];
          var a = lab[1];
          var b = lab[2];
          var x;
          var y;
          var z;
          y = (l + 16) / 116;
          x = a / 500 + y;
          z = y - b / 200;
          var y2 = Math.pow(y, 3);
          var x2 = Math.pow(x, 3);
          var z2 = Math.pow(z, 3);
          y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
          x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
          z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
          x *= 95.047;
          y *= 100;
          z *= 108.883;
          return [x, y, z];
        };

        convert.lab.lch = function (lab) {
          var l = lab[0];
          var a = lab[1];
          var b = lab[2];
          var hr;
          var h;
          var c;
          hr = Math.atan2(b, a);
          h = hr * 360 / 2 / Math.PI;

          if (h < 0) {
            h += 360;
          }

          c = Math.sqrt(a * a + b * b);
          return [l, c, h];
        };

        convert.lch.lab = function (lch) {
          var l = lch[0];
          var c = lch[1];
          var h = lch[2];
          var a;
          var b;
          var hr;
          hr = h / 360 * 2 * Math.PI;
          a = c * Math.cos(hr);
          b = c * Math.sin(hr);
          return [l, a, b];
        };

        convert.rgb.ansi16 = function (args) {
          var r = args[0];
          var g = args[1];
          var b = args[2];
          var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

          value = Math.round(value / 50);

          if (value === 0) {
            return 30;
          }

          var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));

          if (value === 2) {
            ansi += 60;
          }

          return ansi;
        };

        convert.hsv.ansi16 = function (args) {
          // optimization here; we already know the value and don't need to get
          // it converted for us.
          return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };

        convert.rgb.ansi256 = function (args) {
          var r = args[0];
          var g = args[1];
          var b = args[2]; // we use the extended greyscale palette here, with the exception of
          // black and white. normal palette only has 4 greyscale shades.

          if (r === g && g === b) {
            if (r < 8) {
              return 16;
            }

            if (r > 248) {
              return 231;
            }

            return Math.round((r - 8) / 247 * 24) + 232;
          }

          var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
          return ansi;
        };

        convert.ansi16.rgb = function (args) {
          var color = args % 10; // handle greyscale

          if (color === 0 || color === 7) {
            if (args > 50) {
              color += 3.5;
            }

            color = color / 10.5 * 255;
            return [color, color, color];
          }

          var mult = (~~(args > 50) + 1) * 0.5;
          var r = (color & 1) * mult * 255;
          var g = (color >> 1 & 1) * mult * 255;
          var b = (color >> 2 & 1) * mult * 255;
          return [r, g, b];
        };

        convert.ansi256.rgb = function (args) {
          // handle greyscale
          if (args >= 232) {
            var c = (args - 232) * 10 + 8;
            return [c, c, c];
          }

          args -= 16;
          var rem;
          var r = Math.floor(args / 36) / 5 * 255;
          var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
          var b = rem % 6 / 5 * 255;
          return [r, g, b];
        };

        convert.rgb.hex = function (args) {
          var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
          var string = integer.toString(16).toUpperCase();
          return '000000'.substring(string.length) + string;
        };

        convert.hex.rgb = function (args) {
          var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);

          if (!match) {
            return [0, 0, 0];
          }

          var colorString = match[0];

          if (match[0].length === 3) {
            colorString = colorString.split('').map(function (char) {
              return char + char;
            }).join('');
          }

          var integer = parseInt(colorString, 16);
          var r = integer >> 16 & 0xFF;
          var g = integer >> 8 & 0xFF;
          var b = integer & 0xFF;
          return [r, g, b];
        };

        convert.rgb.hcg = function (rgb) {
          var r = rgb[0] / 255;
          var g = rgb[1] / 255;
          var b = rgb[2] / 255;
          var max = Math.max(Math.max(r, g), b);
          var min = Math.min(Math.min(r, g), b);
          var chroma = max - min;
          var grayscale;
          var hue;

          if (chroma < 1) {
            grayscale = min / (1 - chroma);
          } else {
            grayscale = 0;
          }

          if (chroma <= 0) {
            hue = 0;
          } else if (max === r) {
            hue = (g - b) / chroma % 6;
          } else if (max === g) {
            hue = 2 + (b - r) / chroma;
          } else {
            hue = 4 + (r - g) / chroma + 4;
          }

          hue /= 6;
          hue %= 1;
          return [hue * 360, chroma * 100, grayscale * 100];
        };

        convert.hsl.hcg = function (hsl) {
          var s = hsl[1] / 100;
          var l = hsl[2] / 100;
          var c = 1;
          var f = 0;

          if (l < 0.5) {
            c = 2.0 * s * l;
          } else {
            c = 2.0 * s * (1.0 - l);
          }

          if (c < 1.0) {
            f = (l - 0.5 * c) / (1.0 - c);
          }

          return [hsl[0], c * 100, f * 100];
        };

        convert.hsv.hcg = function (hsv) {
          var s = hsv[1] / 100;
          var v = hsv[2] / 100;
          var c = s * v;
          var f = 0;

          if (c < 1.0) {
            f = (v - c) / (1 - c);
          }

          return [hsv[0], c * 100, f * 100];
        };

        convert.hcg.rgb = function (hcg) {
          var h = hcg[0] / 360;
          var c = hcg[1] / 100;
          var g = hcg[2] / 100;

          if (c === 0.0) {
            return [g * 255, g * 255, g * 255];
          }

          var pure = [0, 0, 0];
          var hi = h % 1 * 6;
          var v = hi % 1;
          var w = 1 - v;
          var mg = 0;

          switch (Math.floor(hi)) {
            case 0:
              pure[0] = 1;
              pure[1] = v;
              pure[2] = 0;
              break;

            case 1:
              pure[0] = w;
              pure[1] = 1;
              pure[2] = 0;
              break;

            case 2:
              pure[0] = 0;
              pure[1] = 1;
              pure[2] = v;
              break;

            case 3:
              pure[0] = 0;
              pure[1] = w;
              pure[2] = 1;
              break;

            case 4:
              pure[0] = v;
              pure[1] = 0;
              pure[2] = 1;
              break;

            default:
              pure[0] = 1;
              pure[1] = 0;
              pure[2] = w;
          }

          mg = (1.0 - c) * g;
          return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
        };

        convert.hcg.hsv = function (hcg) {
          var c = hcg[1] / 100;
          var g = hcg[2] / 100;
          var v = c + g * (1.0 - c);
          var f = 0;

          if (v > 0.0) {
            f = c / v;
          }

          return [hcg[0], f * 100, v * 100];
        };

        convert.hcg.hsl = function (hcg) {
          var c = hcg[1] / 100;
          var g = hcg[2] / 100;
          var l = g * (1.0 - c) + 0.5 * c;
          var s = 0;

          if (l > 0.0 && l < 0.5) {
            s = c / (2 * l);
          } else if (l >= 0.5 && l < 1.0) {
            s = c / (2 * (1 - l));
          }

          return [hcg[0], s * 100, l * 100];
        };

        convert.hcg.hwb = function (hcg) {
          var c = hcg[1] / 100;
          var g = hcg[2] / 100;
          var v = c + g * (1.0 - c);
          return [hcg[0], (v - c) * 100, (1 - v) * 100];
        };

        convert.hwb.hcg = function (hwb) {
          var w = hwb[1] / 100;
          var b = hwb[2] / 100;
          var v = 1 - b;
          var c = v - w;
          var g = 0;

          if (c < 1) {
            g = (v - c) / (1 - c);
          }

          return [hwb[0], c * 100, g * 100];
        };

        convert.apple.rgb = function (apple) {
          return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
        };

        convert.rgb.apple = function (rgb) {
          return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
        };

        convert.gray.rgb = function (args) {
          return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
        };

        convert.gray.hsl = convert.gray.hsv = function (args) {
          return [0, 0, args[0]];
        };

        convert.gray.hwb = function (gray) {
          return [0, 100, gray[0]];
        };

        convert.gray.cmyk = function (gray) {
          return [0, 0, 0, gray[0]];
        };

        convert.gray.lab = function (gray) {
          return [gray[0], 0, 0];
        };

        convert.gray.hex = function (gray) {
          var val = Math.round(gray[0] / 100 * 255) & 0xFF;
          var integer = (val << 16) + (val << 8) + val;
          var string = integer.toString(16).toUpperCase();
          return '000000'.substring(string.length) + string;
        };

        convert.rgb.gray = function (rgb) {
          var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
          return [val / 255 * 100];
        };
        /***/

      },

      /***/
      "./node_modules/color-convert/index.js":
      /*!*********************************************!*\
        !*** ./node_modules/color-convert/index.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesColorConvertIndexJs(module, exports, __webpack_require__) {
        var conversions = __webpack_require__(
        /*! ./conversions */
        "./node_modules/color-convert/conversions.js");

        var route = __webpack_require__(
        /*! ./route */
        "./node_modules/color-convert/route.js");

        var convert = {};
        var models = Object.keys(conversions);

        function wrapRaw(fn) {
          var wrappedFn = function wrappedFn(args) {
            if (args === undefined || args === null) {
              return args;
            }

            if (arguments.length > 1) {
              args = Array.prototype.slice.call(arguments);
            }

            return fn(args);
          }; // preserve .conversion property if there is one


          if ('conversion' in fn) {
            wrappedFn.conversion = fn.conversion;
          }

          return wrappedFn;
        }

        function wrapRounded(fn) {
          var wrappedFn = function wrappedFn(args) {
            if (args === undefined || args === null) {
              return args;
            }

            if (arguments.length > 1) {
              args = Array.prototype.slice.call(arguments);
            }

            var result = fn(args); // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.

            if (typeof result === 'object') {
              for (var len = result.length, i = 0; i < len; i++) {
                result[i] = Math.round(result[i]);
              }
            }

            return result;
          }; // preserve .conversion property if there is one


          if ('conversion' in fn) {
            wrappedFn.conversion = fn.conversion;
          }

          return wrappedFn;
        }

        models.forEach(function (fromModel) {
          convert[fromModel] = {};
          Object.defineProperty(convert[fromModel], 'channels', {
            value: conversions[fromModel].channels
          });
          Object.defineProperty(convert[fromModel], 'labels', {
            value: conversions[fromModel].labels
          });
          var routes = route(fromModel);
          var routeModels = Object.keys(routes);
          routeModels.forEach(function (toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
          });
        });
        module.exports = convert;
        /***/
      },

      /***/
      "./node_modules/color-convert/route.js":
      /*!*********************************************!*\
        !*** ./node_modules/color-convert/route.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesColorConvertRouteJs(module, exports, __webpack_require__) {
        var conversions = __webpack_require__(
        /*! ./conversions */
        "./node_modules/color-convert/conversions.js");
        /*
        	this function routes a model to all other models.
        
        	all functions that are routed have a property `.conversion` attached
        	to the returned synthetic function. This property is an array
        	of strings, each with the steps in between the 'from' and 'to'
        	color models (inclusive).
        
        	conversions that are not possible simply are not included.
        */


        function buildGraph() {
          var graph = {}; // https://jsperf.com/object-keys-vs-for-in-with-closure/3

          var models = Object.keys(conversions);

          for (var len = models.length, i = 0; i < len; i++) {
            graph[models[i]] = {
              // http://jsperf.com/1-vs-infinity
              // micro-opt, but this is simple.
              distance: -1,
              parent: null
            };
          }

          return graph;
        } // https://en.wikipedia.org/wiki/Breadth-first_search


        function deriveBFS(fromModel) {
          var graph = buildGraph();
          var queue = [fromModel]; // unshift -> queue -> pop

          graph[fromModel].distance = 0;

          while (queue.length) {
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);

            for (var len = adjacents.length, i = 0; i < len; i++) {
              var adjacent = adjacents[i];
              var node = graph[adjacent];

              if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
              }
            }
          }

          return graph;
        }

        function link(from, to) {
          return function (args) {
            return to(from(args));
          };
        }

        function wrapConversion(toModel, graph) {
          var path = [graph[toModel].parent, toModel];
          var fn = conversions[graph[toModel].parent][toModel];
          var cur = graph[toModel].parent;

          while (graph[cur].parent) {
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
          }

          fn.conversion = path;
          return fn;
        }

        module.exports = function (fromModel) {
          var graph = deriveBFS(fromModel);
          var conversion = {};
          var models = Object.keys(graph);

          for (var len = models.length, i = 0; i < len; i++) {
            var toModel = models[i];
            var node = graph[toModel];

            if (node.parent === null) {
              // no possible conversion, or this node is the source model.
              continue;
            }

            conversion[toModel] = wrapConversion(toModel, graph);
          }

          return conversion;
        };
        /***/

      },

      /***/
      "./node_modules/color-name/index.js":
      /*!******************************************!*\
        !*** ./node_modules/color-name/index.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesColorNameIndexJs(module, exports, __webpack_require__) {
        "use strict";

        module.exports = {
          "aliceblue": [240, 248, 255],
          "antiquewhite": [250, 235, 215],
          "aqua": [0, 255, 255],
          "aquamarine": [127, 255, 212],
          "azure": [240, 255, 255],
          "beige": [245, 245, 220],
          "bisque": [255, 228, 196],
          "black": [0, 0, 0],
          "blanchedalmond": [255, 235, 205],
          "blue": [0, 0, 255],
          "blueviolet": [138, 43, 226],
          "brown": [165, 42, 42],
          "burlywood": [222, 184, 135],
          "cadetblue": [95, 158, 160],
          "chartreuse": [127, 255, 0],
          "chocolate": [210, 105, 30],
          "coral": [255, 127, 80],
          "cornflowerblue": [100, 149, 237],
          "cornsilk": [255, 248, 220],
          "crimson": [220, 20, 60],
          "cyan": [0, 255, 255],
          "darkblue": [0, 0, 139],
          "darkcyan": [0, 139, 139],
          "darkgoldenrod": [184, 134, 11],
          "darkgray": [169, 169, 169],
          "darkgreen": [0, 100, 0],
          "darkgrey": [169, 169, 169],
          "darkkhaki": [189, 183, 107],
          "darkmagenta": [139, 0, 139],
          "darkolivegreen": [85, 107, 47],
          "darkorange": [255, 140, 0],
          "darkorchid": [153, 50, 204],
          "darkred": [139, 0, 0],
          "darksalmon": [233, 150, 122],
          "darkseagreen": [143, 188, 143],
          "darkslateblue": [72, 61, 139],
          "darkslategray": [47, 79, 79],
          "darkslategrey": [47, 79, 79],
          "darkturquoise": [0, 206, 209],
          "darkviolet": [148, 0, 211],
          "deeppink": [255, 20, 147],
          "deepskyblue": [0, 191, 255],
          "dimgray": [105, 105, 105],
          "dimgrey": [105, 105, 105],
          "dodgerblue": [30, 144, 255],
          "firebrick": [178, 34, 34],
          "floralwhite": [255, 250, 240],
          "forestgreen": [34, 139, 34],
          "fuchsia": [255, 0, 255],
          "gainsboro": [220, 220, 220],
          "ghostwhite": [248, 248, 255],
          "gold": [255, 215, 0],
          "goldenrod": [218, 165, 32],
          "gray": [128, 128, 128],
          "green": [0, 128, 0],
          "greenyellow": [173, 255, 47],
          "grey": [128, 128, 128],
          "honeydew": [240, 255, 240],
          "hotpink": [255, 105, 180],
          "indianred": [205, 92, 92],
          "indigo": [75, 0, 130],
          "ivory": [255, 255, 240],
          "khaki": [240, 230, 140],
          "lavender": [230, 230, 250],
          "lavenderblush": [255, 240, 245],
          "lawngreen": [124, 252, 0],
          "lemonchiffon": [255, 250, 205],
          "lightblue": [173, 216, 230],
          "lightcoral": [240, 128, 128],
          "lightcyan": [224, 255, 255],
          "lightgoldenrodyellow": [250, 250, 210],
          "lightgray": [211, 211, 211],
          "lightgreen": [144, 238, 144],
          "lightgrey": [211, 211, 211],
          "lightpink": [255, 182, 193],
          "lightsalmon": [255, 160, 122],
          "lightseagreen": [32, 178, 170],
          "lightskyblue": [135, 206, 250],
          "lightslategray": [119, 136, 153],
          "lightslategrey": [119, 136, 153],
          "lightsteelblue": [176, 196, 222],
          "lightyellow": [255, 255, 224],
          "lime": [0, 255, 0],
          "limegreen": [50, 205, 50],
          "linen": [250, 240, 230],
          "magenta": [255, 0, 255],
          "maroon": [128, 0, 0],
          "mediumaquamarine": [102, 205, 170],
          "mediumblue": [0, 0, 205],
          "mediumorchid": [186, 85, 211],
          "mediumpurple": [147, 112, 219],
          "mediumseagreen": [60, 179, 113],
          "mediumslateblue": [123, 104, 238],
          "mediumspringgreen": [0, 250, 154],
          "mediumturquoise": [72, 209, 204],
          "mediumvioletred": [199, 21, 133],
          "midnightblue": [25, 25, 112],
          "mintcream": [245, 255, 250],
          "mistyrose": [255, 228, 225],
          "moccasin": [255, 228, 181],
          "navajowhite": [255, 222, 173],
          "navy": [0, 0, 128],
          "oldlace": [253, 245, 230],
          "olive": [128, 128, 0],
          "olivedrab": [107, 142, 35],
          "orange": [255, 165, 0],
          "orangered": [255, 69, 0],
          "orchid": [218, 112, 214],
          "palegoldenrod": [238, 232, 170],
          "palegreen": [152, 251, 152],
          "paleturquoise": [175, 238, 238],
          "palevioletred": [219, 112, 147],
          "papayawhip": [255, 239, 213],
          "peachpuff": [255, 218, 185],
          "peru": [205, 133, 63],
          "pink": [255, 192, 203],
          "plum": [221, 160, 221],
          "powderblue": [176, 224, 230],
          "purple": [128, 0, 128],
          "rebeccapurple": [102, 51, 153],
          "red": [255, 0, 0],
          "rosybrown": [188, 143, 143],
          "royalblue": [65, 105, 225],
          "saddlebrown": [139, 69, 19],
          "salmon": [250, 128, 114],
          "sandybrown": [244, 164, 96],
          "seagreen": [46, 139, 87],
          "seashell": [255, 245, 238],
          "sienna": [160, 82, 45],
          "silver": [192, 192, 192],
          "skyblue": [135, 206, 235],
          "slateblue": [106, 90, 205],
          "slategray": [112, 128, 144],
          "slategrey": [112, 128, 144],
          "snow": [255, 250, 250],
          "springgreen": [0, 255, 127],
          "steelblue": [70, 130, 180],
          "tan": [210, 180, 140],
          "teal": [0, 128, 128],
          "thistle": [216, 191, 216],
          "tomato": [255, 99, 71],
          "turquoise": [64, 224, 208],
          "violet": [238, 130, 238],
          "wheat": [245, 222, 179],
          "white": [255, 255, 255],
          "whitesmoke": [245, 245, 245],
          "yellow": [255, 255, 0],
          "yellowgreen": [154, 205, 50]
        };
        /***/
      },

      /***/
      "./node_modules/color-string/index.js":
      /*!********************************************!*\
        !*** ./node_modules/color-string/index.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesColorStringIndexJs(module, exports, __webpack_require__) {
        /* MIT license */
        var colorNames = __webpack_require__(
        /*! color-name */
        "./node_modules/color-name/index.js");

        var swizzle = __webpack_require__(
        /*! simple-swizzle */
        "./node_modules/simple-swizzle/index.js");

        var reverseNames = {}; // create a list of reverse color names

        for (var name in colorNames) {
          if (colorNames.hasOwnProperty(name)) {
            reverseNames[colorNames[name]] = name;
          }
        }

        var cs = module.exports = {
          to: {},
          get: {}
        };

        cs.get = function (string) {
          var prefix = string.substring(0, 3).toLowerCase();
          var val;
          var model;

          switch (prefix) {
            case 'hsl':
              val = cs.get.hsl(string);
              model = 'hsl';
              break;

            case 'hwb':
              val = cs.get.hwb(string);
              model = 'hwb';
              break;

            default:
              val = cs.get.rgb(string);
              model = 'rgb';
              break;
          }

          if (!val) {
            return null;
          }

          return {
            model: model,
            value: val
          };
        };

        cs.get.rgb = function (string) {
          if (!string) {
            return null;
          }

          var abbr = /^#([a-f0-9]{3,4})$/i;
          var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
          var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
          var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
          var keyword = /(\D+)/;
          var rgb = [0, 0, 0, 1];
          var match;
          var i;
          var hexAlpha;

          if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];

            for (i = 0; i < 3; i++) {
              // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
              var i2 = i * 2;
              rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
            }

            if (hexAlpha) {
              rgb[3] = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
            }
          } else if (match = string.match(abbr)) {
            match = match[1];
            hexAlpha = match[3];

            for (i = 0; i < 3; i++) {
              rgb[i] = parseInt(match[i] + match[i], 16);
            }

            if (hexAlpha) {
              rgb[3] = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
            }
          } else if (match = string.match(rgba)) {
            for (i = 0; i < 3; i++) {
              rgb[i] = parseInt(match[i + 1], 0);
            }

            if (match[4]) {
              rgb[3] = parseFloat(match[4]);
            }
          } else if (match = string.match(per)) {
            for (i = 0; i < 3; i++) {
              rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            }

            if (match[4]) {
              rgb[3] = parseFloat(match[4]);
            }
          } else if (match = string.match(keyword)) {
            if (match[1] === 'transparent') {
              return [0, 0, 0, 0];
            }

            rgb = colorNames[match[1]];

            if (!rgb) {
              return null;
            }

            rgb[3] = 1;
            return rgb;
          } else {
            return null;
          }

          for (i = 0; i < 3; i++) {
            rgb[i] = clamp(rgb[i], 0, 255);
          }

          rgb[3] = clamp(rgb[3], 0, 1);
          return rgb;
        };

        cs.get.hsl = function (string) {
          if (!string) {
            return null;
          }

          var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
          var match = string.match(hsl);

          if (match) {
            var alpha = parseFloat(match[4]);
            var h = (parseFloat(match[1]) + 360) % 360;
            var s = clamp(parseFloat(match[2]), 0, 100);
            var l = clamp(parseFloat(match[3]), 0, 100);
            var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [h, s, l, a];
          }

          return null;
        };

        cs.get.hwb = function (string) {
          if (!string) {
            return null;
          }

          var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
          var match = string.match(hwb);

          if (match) {
            var alpha = parseFloat(match[4]);
            var h = (parseFloat(match[1]) % 360 + 360) % 360;
            var w = clamp(parseFloat(match[2]), 0, 100);
            var b = clamp(parseFloat(match[3]), 0, 100);
            var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [h, w, b, a];
          }

          return null;
        };

        cs.to.hex = function () {
          var rgba = swizzle(arguments);
          return '#' + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : '');
        };

        cs.to.rgb = function () {
          var rgba = swizzle(arguments);
          return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
        };

        cs.to.rgb.percent = function () {
          var rgba = swizzle(arguments);
          var r = Math.round(rgba[0] / 255 * 100);
          var g = Math.round(rgba[1] / 255 * 100);
          var b = Math.round(rgba[2] / 255 * 100);
          return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
        };

        cs.to.hsl = function () {
          var hsla = swizzle(arguments);
          return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
        }; // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
        // (hwb have alpha optional & 1 is default value)


        cs.to.hwb = function () {
          var hwba = swizzle(arguments);
          var a = '';

          if (hwba.length >= 4 && hwba[3] !== 1) {
            a = ', ' + hwba[3];
          }

          return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
        };

        cs.to.keyword = function (rgb) {
          return reverseNames[rgb.slice(0, 3)];
        }; // helpers


        function clamp(num, min, max) {
          return Math.min(Math.max(min, num), max);
        }

        function hexDouble(num) {
          var str = num.toString(16).toUpperCase();
          return str.length < 2 ? '0' + str : str;
        }
        /***/

      },

      /***/
      "./node_modules/color/index.js":
      /*!*************************************!*\
        !*** ./node_modules/color/index.js ***!
        \*************************************/

      /*! no static exports found */

      /***/
      function node_modulesColorIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var colorString = __webpack_require__(
        /*! color-string */
        "./node_modules/color-string/index.js");

        var convert = __webpack_require__(
        /*! color-convert */
        "./node_modules/color-convert/index.js");

        var _slice = [].slice;
        var skippedModels = [// to be honest, I don't really feel like keyword belongs in color convert, but eh.
        'keyword', // gray conflicts with some method names, and has its own method defined.
        'gray', // shouldn't really be in color-convert either...
        'hex'];
        var hashedModelKeys = {};
        Object.keys(convert).forEach(function (model) {
          hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
        });
        var limiters = {};

        function Color(obj, model) {
          if (!(this instanceof Color)) {
            return new Color(obj, model);
          }

          if (model && model in skippedModels) {
            model = null;
          }

          if (model && !(model in convert)) {
            throw new Error('Unknown model: ' + model);
          }

          var i;
          var channels;

          if (!obj) {
            this.model = 'rgb';
            this.color = [0, 0, 0];
            this.valpha = 1;
          } else if (obj instanceof Color) {
            this.model = obj.model;
            this.color = obj.color.slice();
            this.valpha = obj.valpha;
          } else if (typeof obj === 'string') {
            var result = colorString.get(obj);

            if (result === null) {
              throw new Error('Unable to parse color from string: ' + obj);
            }

            this.model = result.model;
            channels = convert[this.model].channels;
            this.color = result.value.slice(0, channels);
            this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
          } else if (obj.length) {
            this.model = model || 'rgb';
            channels = convert[this.model].channels;

            var newArr = _slice.call(obj, 0, channels);

            this.color = zeroArray(newArr, channels);
            this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
          } else if (typeof obj === 'number') {
            // this is always RGB - can be converted later on.
            obj &= 0xFFFFFF;
            this.model = 'rgb';
            this.color = [obj >> 16 & 0xFF, obj >> 8 & 0xFF, obj & 0xFF];
            this.valpha = 1;
          } else {
            this.valpha = 1;
            var keys = Object.keys(obj);

            if ('alpha' in obj) {
              keys.splice(keys.indexOf('alpha'), 1);
              this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
            }

            var hashedKeys = keys.sort().join('');

            if (!(hashedKeys in hashedModelKeys)) {
              throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
            }

            this.model = hashedModelKeys[hashedKeys];
            var labels = convert[this.model].labels;
            var color = [];

            for (i = 0; i < labels.length; i++) {
              color.push(obj[labels[i]]);
            }

            this.color = zeroArray(color);
          } // perform limitations (clamping, etc.)


          if (limiters[this.model]) {
            channels = convert[this.model].channels;

            for (i = 0; i < channels; i++) {
              var limit = limiters[this.model][i];

              if (limit) {
                this.color[i] = limit(this.color[i]);
              }
            }
          }

          this.valpha = Math.max(0, Math.min(1, this.valpha));

          if (Object.freeze) {
            Object.freeze(this);
          }
        }

        Color.prototype = {
          toString: function toString() {
            return this.string();
          },
          toJSON: function toJSON() {
            return this[this.model]();
          },
          string: function string(places) {
            var self = this.model in colorString.to ? this : this.rgb();
            self = self.round(typeof places === 'number' ? places : 1);
            var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
            return colorString.to[self.model](args);
          },
          percentString: function percentString(places) {
            var self = this.rgb().round(typeof places === 'number' ? places : 1);
            var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
            return colorString.to.rgb.percent(args);
          },
          array: function array() {
            return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
          },
          object: function object() {
            var result = {};
            var channels = convert[this.model].channels;
            var labels = convert[this.model].labels;

            for (var i = 0; i < channels; i++) {
              result[labels[i]] = this.color[i];
            }

            if (this.valpha !== 1) {
              result.alpha = this.valpha;
            }

            return result;
          },
          unitArray: function unitArray() {
            var rgb = this.rgb().color;
            rgb[0] /= 255;
            rgb[1] /= 255;
            rgb[2] /= 255;

            if (this.valpha !== 1) {
              rgb.push(this.valpha);
            }

            return rgb;
          },
          unitObject: function unitObject() {
            var rgb = this.rgb().object();
            rgb.r /= 255;
            rgb.g /= 255;
            rgb.b /= 255;

            if (this.valpha !== 1) {
              rgb.alpha = this.valpha;
            }

            return rgb;
          },
          round: function round(places) {
            places = Math.max(places || 0, 0);
            return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
          },
          alpha: function alpha(val) {
            if (arguments.length) {
              return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
            }

            return this.valpha;
          },
          // rgb
          red: getset('rgb', 0, maxfn(255)),
          green: getset('rgb', 1, maxfn(255)),
          blue: getset('rgb', 2, maxfn(255)),
          hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) {
            return (val % 360 + 360) % 360;
          }),
          // eslint-disable-line brace-style
          saturationl: getset('hsl', 1, maxfn(100)),
          lightness: getset('hsl', 2, maxfn(100)),
          saturationv: getset('hsv', 1, maxfn(100)),
          value: getset('hsv', 2, maxfn(100)),
          chroma: getset('hcg', 1, maxfn(100)),
          gray: getset('hcg', 2, maxfn(100)),
          white: getset('hwb', 1, maxfn(100)),
          wblack: getset('hwb', 2, maxfn(100)),
          cyan: getset('cmyk', 0, maxfn(100)),
          magenta: getset('cmyk', 1, maxfn(100)),
          yellow: getset('cmyk', 2, maxfn(100)),
          black: getset('cmyk', 3, maxfn(100)),
          x: getset('xyz', 0, maxfn(100)),
          y: getset('xyz', 1, maxfn(100)),
          z: getset('xyz', 2, maxfn(100)),
          l: getset('lab', 0, maxfn(100)),
          a: getset('lab', 1),
          b: getset('lab', 2),
          keyword: function keyword(val) {
            if (arguments.length) {
              return new Color(val);
            }

            return convert[this.model].keyword(this.color);
          },
          hex: function hex(val) {
            if (arguments.length) {
              return new Color(val);
            }

            return colorString.to.hex(this.rgb().round().color);
          },
          rgbNumber: function rgbNumber() {
            var rgb = this.rgb().color;
            return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
          },
          luminosity: function luminosity() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.rgb().color;
            var lum = [];

            for (var i = 0; i < rgb.length; i++) {
              var chan = rgb[i] / 255;
              lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }

            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
          },
          contrast: function contrast(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();

            if (lum1 > lum2) {
              return (lum1 + 0.05) / (lum2 + 0.05);
            }

            return (lum2 + 0.05) / (lum1 + 0.05);
          },
          level: function level(color2) {
            var contrastRatio = this.contrast(color2);

            if (contrastRatio >= 7.1) {
              return 'AAA';
            }

            return contrastRatio >= 4.5 ? 'AA' : '';
          },
          dark: function dark() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.rgb().color;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
          },
          light: function light() {
            return !this.dark();
          },
          negate: function negate() {
            var rgb = this.rgb();

            for (var i = 0; i < 3; i++) {
              rgb.color[i] = 255 - rgb.color[i];
            }

            return rgb;
          },
          lighten: function lighten(ratio) {
            var hsl = this.hsl();
            hsl.color[2] += hsl.color[2] * ratio;
            return hsl;
          },
          darken: function darken(ratio) {
            var hsl = this.hsl();
            hsl.color[2] -= hsl.color[2] * ratio;
            return hsl;
          },
          saturate: function saturate(ratio) {
            var hsl = this.hsl();
            hsl.color[1] += hsl.color[1] * ratio;
            return hsl;
          },
          desaturate: function desaturate(ratio) {
            var hsl = this.hsl();
            hsl.color[1] -= hsl.color[1] * ratio;
            return hsl;
          },
          whiten: function whiten(ratio) {
            var hwb = this.hwb();
            hwb.color[1] += hwb.color[1] * ratio;
            return hwb;
          },
          blacken: function blacken(ratio) {
            var hwb = this.hwb();
            hwb.color[2] += hwb.color[2] * ratio;
            return hwb;
          },
          grayscale: function grayscale() {
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var rgb = this.rgb().color;
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            return Color.rgb(val, val, val);
          },
          fade: function fade(ratio) {
            return this.alpha(this.valpha - this.valpha * ratio);
          },
          opaquer: function opaquer(ratio) {
            return this.alpha(this.valpha + this.valpha * ratio);
          },
          rotate: function rotate(degrees) {
            var hsl = this.hsl();
            var hue = hsl.color[0];
            hue = (hue + degrees) % 360;
            hue = hue < 0 ? 360 + hue : hue;
            hsl.color[0] = hue;
            return hsl;
          },
          mix: function mix(mixinColor, weight) {
            // ported from sass implementation in C
            // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
            var color1 = mixinColor.rgb();
            var color2 = this.rgb();
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
          }
        }; // model conversion methods and static constructors

        Object.keys(convert).forEach(function (model) {
          if (skippedModels.indexOf(model) !== -1) {
            return;
          }

          var channels = convert[model].channels; // conversion methods

          Color.prototype[model] = function () {
            if (this.model === model) {
              return new Color(this);
            }

            if (arguments.length) {
              return new Color(arguments, model);
            }

            var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
            return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
          }; // 'static' construction methods


          Color[model] = function (color) {
            if (typeof color === 'number') {
              color = zeroArray(_slice.call(arguments), channels);
            }

            return new Color(color, model);
          };
        });

        function roundTo(num, places) {
          return Number(num.toFixed(places));
        }

        function roundToPlace(places) {
          return function (num) {
            return roundTo(num, places);
          };
        }

        function getset(model, channel, modifier) {
          model = Array.isArray(model) ? model : [model];
          model.forEach(function (m) {
            (limiters[m] || (limiters[m] = []))[channel] = modifier;
          });
          model = model[0];
          return function (val) {
            var result;

            if (arguments.length) {
              if (modifier) {
                val = modifier(val);
              }

              result = this[model]();
              result.color[channel] = val;
              return result;
            }

            result = this[model]().color[channel];

            if (modifier) {
              result = modifier(result);
            }

            return result;
          };
        }

        function maxfn(max) {
          return function (v) {
            return Math.max(0, Math.min(max, v));
          };
        }

        function assertArray(val) {
          return Array.isArray(val) ? val : [val];
        }

        function zeroArray(arr, length) {
          for (var i = 0; i < length; i++) {
            if (typeof arr[i] !== 'number') {
              arr[i] = 0;
            }
          }

          return arr;
        }

        module.exports = Color;
        /***/
      },

      /***/
      "./node_modules/core-js/fn/object/entries.js":
      /*!***************************************************!*\
        !*** ./node_modules/core-js/fn/object/entries.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsFnObjectEntriesJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es7.object.entries */
        "./node_modules/core-js/modules/es7.object.entries.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_core */
        "./node_modules/core-js/modules/_core.js").Object.entries;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_a-function.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_a-function.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_aFunctionJs(module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_an-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_an-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_anObjectJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_array-includes.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_array-includes.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_arrayIncludesJs(module, exports, __webpack_require__) {
        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js");

        var toAbsoluteIndex = __webpack_require__(
        /*! ./_to-absolute-index */
        "./node_modules/core-js/modules/_to-absolute-index.js");

        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare

            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++]; // eslint-disable-next-line no-self-compare

              if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
            }
            return !IS_INCLUDES && -1;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_cof.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_cof.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_cofJs(module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_core.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_core.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_coreJs(module, exports) {
        var core = module.exports = {
          version: '2.6.11'
        };
        if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/modules/_ctx.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_ctx.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_ctxJs(module, exports, __webpack_require__) {
        // optional / simple context binding
        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/modules/_a-function.js");

        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;

          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a);
              };

            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };

            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }

          return function ()
          /* ...args */
          {
            return fn.apply(that, arguments);
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_defined.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_defined.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_definedJs(module, exports) {
        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_descriptors.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_descriptors.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_descriptorsJs(module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty({}, 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_dom-create.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_dom-create.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_domCreateJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var document = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").document; // typeof document.createElement is 'object' in old IE


        var is = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return is ? document.createElement(it) : {};
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_enum-bug-keys.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_enum-bug-keys.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_enumBugKeysJs(module, exports) {
        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_export.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_export.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_exportJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js");

        var PROTOTYPE = 'prototype';

        var $export = function $export(type, name, source) {
          var IS_FORCED = type & $export.F;
          var IS_GLOBAL = type & $export.G;
          var IS_STATIC = type & $export.S;
          var IS_PROTO = type & $export.P;
          var IS_BIND = type & $export.B;
          var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
          var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
          var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
          var key, own, out, exp;
          if (IS_GLOBAL) source = name;

          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

            out = (own ? target : source)[key]; // bind timers to global for call from export context

            exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

            if (target) redefine(target, key, out, type & $export.U); // export

            if (exports[key] != out) hide(exports, key, exp);
            if (IS_PROTO && expProto[key] != out) expProto[key] = out;
          }
        };

        global.core = core; // type bitmap

        $export.F = 1; // forced

        $export.G = 2; // global

        $export.S = 4; // static

        $export.P = 8; // proto

        $export.B = 16; // bind

        $export.W = 32; // wrap

        $export.U = 64; // safe

        $export.R = 128; // real proto method for `library`

        module.exports = $export;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_fails.js":
      /*!************************************************!*\
        !*** ./node_modules/core-js/modules/_fails.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_failsJs(module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_function-to-string.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/_function-to-string.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_functionToStringJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_global.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_global.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_globalJs(module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
        : Function('return this')();
        if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/modules/_has.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_has.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_hasJs(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_hide.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_hide.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_hideJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
          return dP.f(object, key, createDesc(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_ie8-dom-define.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_ie8-dom-define.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_ie8DomDefineJs(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty(__webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/modules/_dom-create.js")('div'), 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_iobject.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_iobject.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iobjectJs(module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js"); // eslint-disable-next-line no-prototype-builtins


        module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
          return cof(it) == 'String' ? it.split('') : Object(it);
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_is-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_is-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isObjectJs(module, exports) {
        module.exports = function (it) {
          return typeof it === 'object' ? it !== null : typeof it === 'function';
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_library.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_library.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_libraryJs(module, exports) {
        module.exports = false;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-dp.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-dp.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectDpJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "./node_modules/core-js/modules/_ie8-dom-define.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js");

        var dP = Object.defineProperty;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
          } catch (e) {
            /* empty */
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-keys-internal.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/modules/_object-keys-internal.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectKeysInternalJs(module, exports, __webpack_require__) {
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var arrayIndexOf = __webpack_require__(
        /*! ./_array-includes */
        "./node_modules/core-js/modules/_array-includes.js")(false);

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        module.exports = function (object, names) {
          var O = toIObject(object);
          var i = 0;
          var result = [];
          var key;

          for (key in O) {
            if (key != IE_PROTO) has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys


          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-keys.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-keys.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "./node_modules/core-js/modules/_object-keys-internal.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js");

        module.exports = Object.keys || function keys(O) {
          return $keys(O, enumBugKeys);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-pie.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-pie.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectPieJs(module, exports) {
        exports.f = {}.propertyIsEnumerable;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-to-array.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/_object-to-array.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectToArrayJs(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var isEnum = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/modules/_object-pie.js").f;

        module.exports = function (isEntries) {
          return function (it) {
            var O = toIObject(it);
            var keys = getKeys(O);
            var length = keys.length;
            var i = 0;
            var result = [];
            var key;

            while (length > i) {
              key = keys[i++];

              if (!DESCRIPTORS || isEnum.call(O, key)) {
                result.push(isEntries ? [key, O[key]] : O[key]);
              }
            }

            return result;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_property-desc.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_property-desc.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_propertyDescJs(module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_redefine.js":
      /*!***************************************************!*\
        !*** ./node_modules/core-js/modules/_redefine.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_redefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var SRC = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js")('src');

        var $toString = __webpack_require__(
        /*! ./_function-to-string */
        "./node_modules/core-js/modules/_function-to-string.js");

        var TO_STRING = 'toString';
        var TPL = ('' + $toString).split(TO_STRING);

        __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
          return $toString.call(it);
        };

        (module.exports = function (O, key, val, safe) {
          var isFunction = typeof val == 'function';
          if (isFunction) has(val, 'name') || hide(val, 'name', key);
          if (O[key] === val) return;
          if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

          if (O === global) {
            O[key] = val;
          } else if (!safe) {
            delete O[key];
            hide(O, key, val);
          } else if (O[key]) {
            O[key] = val;
          } else {
            hide(O, key, val);
          } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

        })(Function.prototype, TO_STRING, function toString() {
          return typeof this == 'function' && this[SRC] || $toString.call(this);
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_shared-key.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_shared-key.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sharedKeyJs(module, exports, __webpack_require__) {
        var shared = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('keys');

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js");

        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_shared.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_shared.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sharedJs(module, exports, __webpack_require__) {
        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js");

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || (global[SHARED] = {});
        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: core.version,
          mode: __webpack_require__(
          /*! ./_library */
          "./node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
          copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_to-absolute-index.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/_to-absolute-index.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toAbsoluteIndexJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js");

        var max = Math.max;
        var min = Math.min;

        module.exports = function (index, length) {
          index = toInteger(index);
          return index < 0 ? max(index + length, 0) : min(index, length);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-integer.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-integer.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIntegerJs(module, exports) {
        // 7.1.4 ToInteger
        var ceil = Math.ceil;
        var floor = Math.floor;

        module.exports = function (it) {
          return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-iobject.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-iobject.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIobjectJs(module, exports, __webpack_require__) {
        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__(
        /*! ./_iobject */
        "./node_modules/core-js/modules/_iobject.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return IObject(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-length.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-length.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toLengthJs(module, exports, __webpack_require__) {
        // 7.1.15 ToLength
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js");

        var min = Math.min;

        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-primitive.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/modules/_to-primitive.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toPrimitiveJs(module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string


        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
          if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_uid.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_uid.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_uidJs(module, exports) {
        var id = 0;
        var px = Math.random();

        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es7.object.entries.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es7.object.entries.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs7ObjectEntriesJs(module, exports, __webpack_require__) {
        // https://github.com/tc39/proposal-object-values-entries
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var $entries = __webpack_require__(
        /*! ./_object-to-array */
        "./node_modules/core-js/modules/_object-to-array.js")(true);

        $export($export.S, 'Object', {
          entries: function entries(it) {
            return $entries(it);
          }
        });
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Address/Address.css":
      /*!******************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Address/Address.css ***!
        \******************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsAddressAddressCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._2Dg8kvjr0VCHzXRC84UNqQ {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: column;\n\t        flex-direction: column;\n\t-ms-flex-wrap: nowrap;\n\t    flex-wrap: nowrap;\n\tmin-width: 200px;\n\tborder-radius: 12px;\n\tbackground-color: rgba(239, 239, 239, 1);\n\tmargin-top: 12px;\n\tpadding: 12px 16px 16px;\n}\n\n._3Tddc2FAk_fGzFlp-40CLk {\n\tbackground-color: rgba(255, 255, 255, .08);\n}\n\n._2eCLZucAi9yIVsB29cRNv3 {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tline-height: 20px;\n\tpadding-top: 8px;\n}\n\n._2lfG1HngeRSxh4uYOeCgyS {\n\tmin-width: 102px;\n}\n", ""]); // Exports

        exports.locals = {
          "base": "_2Dg8kvjr0VCHzXRC84UNqQ",
          "baseBlack": "_3Tddc2FAk_fGzFlp-40CLk",
          "details-item": "_2eCLZucAi9yIVsB29cRNv3",
          "details-name": "_2lfG1HngeRSxh4uYOeCgyS"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Bill/Bill.css":
      /*!************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Bill/Bill.css ***!
        \************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsBillBillCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, ".AaSoXyFOW-TtlP17vJz3O {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 2px;\n\tpadding: 0 16px 16px;\n\tmargin-top: 12px;\n\tmargin-bottom: 8px;\n\tdisplay: table;\n\twidth: calc(100% - 32px);\n}\n\n._2B5jUZlVwS4T6y-NXv4FyC {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 12px;\n\tpadding: 0 20px 16px;\n\tmargin-top: 12px;\n\tmargin-bottom: 10px;\n\tdisplay: table;\n\twidth: calc(100% - 40px);\n}\n\n._2GL2OT1rjXC2XDk7X3Rqex {\n\tbackground-color: rgba(255, 255, 255, .08);\n}\n\n._1dhAxxmcD10oxFz-crKYEO {\n\tposition: relative;\n\tfloat: right;\n\twidth: 42px;\n\theight: 32px;\n\tright: -25px;\n\ttop: 14px;\n}\n\n._5l91GTjor1hAvlg82yWjQ {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 12px;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-ms-flex-wrap: wrap;\n\t    flex-wrap: wrap;\n\tmax-width: calc(100% - 147px);\n\tmargin-bottom: 8px\n}\n\n._3eVUYcgGzgTY1mw9F6iLUb {\n\tmargin-top: 1px;\n\tmargin-left: 20px;\n}\n\n._2dPuMM17yeCpvbxNCvpw4a {\n\tmargin-bottom: 12px;\n}\n\n._2awQbUNeNGeOVyodCQvhU {\n\tmargin-right: 20px;\n}\n\n.vZekJ4Tbfalpyjz8EExcV {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 12px;\n}\n\n._1KiiVHN96-xIsf6cpU0NlD, ._24EJybX0annrUI_EiuPal1 {\n\tmargin-right: 8px;\n}\n\n._3BevdsFgDAW520ed_y1ouC {\n\tmargin-top: 8px;\n}\n\n._4vucd3PIBff-w7haaP2i0 {\n\tdisplay: inline;\n}\n\n.jYVY0YILMk9nP2ppsLWIP {\n\tdisplay: none;\n}\n\n.t6sQeBYlWMbhyHt6Yvj0c {\n\tfloat: right;\n\tmargin-top: 12px;\n\tpadding-top: 1px;\n}\n\n._6meCY-T0TaW-5JPxwUpsn {\n\t/*margin-bottom: 8px;*/\n\tmargin-right: 20px;\n}\n", ""]); // Exports

        exports.locals = {
          "bill-main": "AaSoXyFOW-TtlP17vJz3O",
          "bill-main-octavius": "_2B5jUZlVwS4T6y-NXv4FyC",
          "bill-main-octavius-darkMode": "_2GL2OT1rjXC2XDk7X3Rqex",
          "icon-button": "_1dhAxxmcD10oxFz-crKYEO",
          "header": "_5l91GTjor1hAvlg82yWjQ",
          "link": "_3eVUYcgGzgTY1mw9F6iLUb",
          "payment-info": "_2dPuMM17yeCpvbxNCvpw4a",
          "payment-info-element": "_2awQbUNeNGeOVyodCQvhU",
          "buttons-block": "vZekJ4Tbfalpyjz8EExcV",
          "button-pay": "_1KiiVHN96-xIsf6cpU0NlD",
          "button-view": "_24EJybX0annrUI_EiuPal1",
          "additional-info": "_3BevdsFgDAW520ed_y1ouC",
          "more-info": "_4vucd3PIBff-w7haaP2i0",
          "more-info-disabled": "jYVY0YILMk9nP2ppsLWIP",
          "billing-info": "t6sQeBYlWMbhyHt6Yvj0c",
          "header-text": "_6meCY-T0TaW-5JPxwUpsn"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/BillingInfoTooltip/BillingInfoTooltip.css":
      /*!****************************************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/BillingInfoTooltip/BillingInfoTooltip.css ***!
        \****************************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsBillingInfoTooltipBillingInfoTooltipCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._1u35JpaNEpZioUQ8WvO1k5 {\n\tcursor: pointer;\n\twhite-space: nowrap;\n\tline-height: 16px;\n}\n\n._2EuD62R6yymvYFs_91CF0U {\n\tpadding-right: 8px;\n\tfont-size: 13px;\n\tvertical-align: top;\n}\n\n._2EuD62R6yymvYFs_91CF0U > svg {\n\tfill: #07bb3f;\n\tpadding-top: 1px;\n}\n\n._3jsRdKnBNljhOZu09D3Z-D > * {\n\tvertical-align: top;\n}\n\n._2pf9WBwGgPGYi8T3D3bvpF {\n\tmargin: 8px 0;\n\twidth: 368px;\n}\n\n._2D40_0zEw-aHO6PfXrQ8J2 {\n\tfloat: left;\n\tmargin-right: 16px;\n}\n\n._2D40_0zEw-aHO6PfXrQ8J2 > img {\n\twidth: 48px;\n\theight: 48px;\n}\n\n._3-l9TGyAqPPEg_i3XhONdd {\n\tmin-height: 48px;\n}\n\n._3OjtCmd6FEUzeqJLHL4xni {\n\tclear: both;\n\tmargin: 8px 0 20px;\n\tpadding-left: 16px;\n}\n\n._1g4zsSaIxAFcL3v9bPT2e6 {\n\tmargin-top: 8px;\n}\n\n", ""]); // Exports

        exports.locals = {
          "link": "_1u35JpaNEpZioUQ8WvO1k5",
          "icon": "_2EuD62R6yymvYFs_91CF0U",
          "link-text": "_3jsRdKnBNljhOZu09D3Z-D",
          "tooltip": "_2pf9WBwGgPGYi8T3D3bvpF",
          "shield": "_2D40_0zEw-aHO6PfXrQ8J2",
          "header": "_3-l9TGyAqPPEg_i3XhONdd",
          "list": "_3OjtCmd6FEUzeqJLHL4xni",
          "list-item": "_1g4zsSaIxAFcL3v9bPT2e6"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Dobro/Dobro.css":
      /*!**************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Dobro/Dobro.css ***!
        \**************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsDobroDobroCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._1vWwky84zNa2u4iteLECTA {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 2px;\n\tpadding: 0 16px 16px;\n\tmargin-top: 12px;\n\tmargin-bottom: 8px;\n\tdisplay: table;\n\twidth: calc(100% - 32px);\n}\n\n._1xzgfHiiLPBiK8HsSXsiQf {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 12px;\n\tpadding: 0 20px 16px;\n\tmargin-top: 12px;\n\tmargin-bottom: 10px;\n\tdisplay: table;\n\twidth: calc(100% - 40px);\n}\n\n._3Q3mYW0eisIPwc-MBUEn72 {\n\tbackground-color: rgba(255, 255, 255, .08);\n}\n\n._1qJCObzV2occm01F8hVHUg {\n\tfloat: left;\n\tmargin-right: 12px;\n\tmargin-top: 1px;\n\theight: 16px;\n\twidth: 16px;\n}\n\n._1qJCObzV2occm01F8hVHUg > svg {\n\twidth: 100%;\n\theight: 100%;\n\tfill: #ff0000;\n}\n\n._3fMFgyYZGD82RKTrh_GKR7 {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 16px;\n}\n\n._3UILzSkXtoqeoNbVSBsGUi {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 12px;\n}\n\n._3cTvfdhN4VZLGJ6bvtnhqc {\n\tmargin-left: auto;\n\tpadding-top: 1px;\n\tpadding-left: 16px;\n\theight: 17px;\n}\n", ""]); // Exports

        exports.locals = {
          "main": "_1vWwky84zNa2u4iteLECTA",
          "main-octavius": "_1xzgfHiiLPBiK8HsSXsiQf",
          "main-octavius-darkMode": "_3Q3mYW0eisIPwc-MBUEn72",
          "icon": "_1qJCObzV2occm01F8hVHUg",
          "header": "_3fMFgyYZGD82RKTrh_GKR7",
          "buttons-block": "_3UILzSkXtoqeoNbVSBsGUi",
          "billing-info": "_3cTvfdhN4VZLGJ6bvtnhqc"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/Gibdd.css":
      /*!**************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Gibdd/Gibdd.css ***!
        \**************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsGibddGibddCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._352xHJ6JFazYNNO5L_cGYO {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2eB9kjpQ7Av46lPAhFGn1d {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1xFfGL4Hz_A40wr15O38Zd {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3lkPtbg1HXsaH-XkY6PDPb {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2ttNwG29EZ83KjKVuiRNjO {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.sFPdieisM6JiZKSmjNVau {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2hQ1fS2GirG73dNtAvMgCH {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2SqCuukvmQAdXTlaA6E7iV {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._19gy66g0OipeoVmGqzSZuX {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._19gy66g0OipeoVmGqzSZuX {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._3PS77guH8iSAjr5QJ3t6T8 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._3PS77guH8iSAjr5QJ3t6T8 {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._1c7xai0VqKhT39FGxqt1Cu {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1c7xai0VqKhT39FGxqt1Cu {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._15Oaf4Pv8qaebDfGjTFebr {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._15Oaf4Pv8qaebDfGjTFebr {\n\t\tfont-weight: 400;\n\t}\n}\n.ojXHTUqL7OiFgGHF9g7it {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.ojXHTUqL7OiFgGHF9g7it {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._3Y2yuKMOSQLPldHUKznNxo {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._1--GoChuB4wCWvBAHerbL1 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._1s81kqOpJT3tfmbvoV_XuU {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1s81kqOpJT3tfmbvoV_XuU {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._1kRuVHRENiG3Z1AQebKprZ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._1kRuVHRENiG3Z1AQebKprZ {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._14LBp6X-QYih81Acc6M-Ku {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.NiOcqUFO_eLHrcleU8dEF {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2_-t22Fs_UxzkopuVAFE_x {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.t1Haz-u_NPsVtKDnaYRKC {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.H6sgJ-XrIPEPEiHHuWSFC {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.ug0_gEOL9ELCeNgA1iTC5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1NESX_CCWb7awCoGm4Y9ny {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1BA96xx3E50phfNCJcirY6 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2lNfueS-wyWGbtaQB7PYdt {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._2lNfueS-wyWGbtaQB7PYdt {\n\t\tfont-size: 15px;\n\t}\n}\n._3td0q8OX8oyPhouXUFaEQX {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._3VSesqpb31NZ_R5gQbATnA {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n._352xHJ6JFazYNNO5L_cGYO {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2eB9kjpQ7Av46lPAhFGn1d {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1xFfGL4Hz_A40wr15O38Zd {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3lkPtbg1HXsaH-XkY6PDPb {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2ttNwG29EZ83KjKVuiRNjO {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.sFPdieisM6JiZKSmjNVau {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2hQ1fS2GirG73dNtAvMgCH {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2SqCuukvmQAdXTlaA6E7iV {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._19gy66g0OipeoVmGqzSZuX {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._19gy66g0OipeoVmGqzSZuX {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._3PS77guH8iSAjr5QJ3t6T8 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._3PS77guH8iSAjr5QJ3t6T8 {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._1c7xai0VqKhT39FGxqt1Cu {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1c7xai0VqKhT39FGxqt1Cu {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._15Oaf4Pv8qaebDfGjTFebr {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._15Oaf4Pv8qaebDfGjTFebr {\n\t\tfont-weight: 400;\n\t}\n}\n.ojXHTUqL7OiFgGHF9g7it {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.ojXHTUqL7OiFgGHF9g7it {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._3Y2yuKMOSQLPldHUKznNxo {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3Y2yuKMOSQLPldHUKznNxo {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1--GoChuB4wCWvBAHerbL1 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1--GoChuB4wCWvBAHerbL1 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1s81kqOpJT3tfmbvoV_XuU {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1kRuVHRENiG3Z1AQebKprZ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n._14LBp6X-QYih81Acc6M-Ku {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.NiOcqUFO_eLHrcleU8dEF {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2_-t22Fs_UxzkopuVAFE_x {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.t1Haz-u_NPsVtKDnaYRKC {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t.t1Haz-u_NPsVtKDnaYRKC {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n.H6sgJ-XrIPEPEiHHuWSFC {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.ug0_gEOL9ELCeNgA1iTC5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1NESX_CCWb7awCoGm4Y9ny {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1BA96xx3E50phfNCJcirY6 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2lNfueS-wyWGbtaQB7PYdt {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._2lNfueS-wyWGbtaQB7PYdt {\n\t\tfont-size: 15px;\n\t}\n}\n._3td0q8OX8oyPhouXUFaEQX {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._3VSesqpb31NZ_R5gQbATnA {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n.uIzX-jVWkKG_Lrn9Jb-o2 {\n\tbackground-color: #f0f0f0;\n\tborder-radius: 2px;\n\tpadding: 0 16px 16px;\n\tmargin-top: 2px;\n\tmargin-bottom: 8px;\n\tdisplay: table;\n\twidth: calc(100% - 32px);\n}\n.vnTaOEOXvsdiu3AUr1UsO {\n\tbackground-color: #f0f0f0;\n\tborder-radius: 12px;\n\tpadding: 0 20px 12px;\n\tmargin-top: 12px;\n\tmargin-bottom: 10px;\n\tdisplay: table;\n\twidth: calc(100% - 40px);\n}\n._1AKEh43YPbgmsLlzvFJ6_u {\n\tbackground-color: rgba(255, 255, 255, .08);\n}\n._2S1vpnaDf2bwesV0iY9mAY {\n\twidth: 100%;\n}\n._3pTRUpvZ5kYZxikhU2zcC7 {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-ms-flex-wrap: wrap;\n\t    flex-wrap: wrap;\n\twidth: 100%;\n\tborder-bottom: 1px solid rgba(0, 16, 61, .12);\n\t-webkit-box-pack: justify;\n\t    -ms-flex-pack: justify;\n\t        justify-content: space-between;\n}\n._3Po099gGR8IU-sjoX105yl {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\theight: 44px;\n}\n._3CVRRd0Vky-sNDULZmebmU {\n\tmargin-top: 4px;\n}\n._2PSQ1dvSLkDkdv5cf6bMvo {\n\tmargin-top: 2px;\n\tmargin-right: 12px;\n}\n._19_IfDKbHILwVgAoRsl0eA {\n\tmargin-left: 12px;\n}\n._2Ctf32DpyStqT6NgHiRvbf {\n\tmargin-top: 8px;\n\tmargin-bottom: 16px;\n}\n._17rZlr9z_D3ofjqRLCztgE {\n\tpadding-top: 1px;\n}\n._3kYu-BMnT7wcUmNrr3qhOm {\n\tmargin-right: 20px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n}\n._1_UAGuUZrZtjC9A8-u9VPO {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: baseline;\n\t    -ms-flex-align: baseline;\n\t        align-items: baseline;\n\tpadding-bottom: 8px;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "_352xHJ6JFazYNNO5L_cGYO",
          "font-size2": "_2eB9kjpQ7Av46lPAhFGn1d",
          "font-size3": "_1xFfGL4Hz_A40wr15O38Zd",
          "font-size4": "_3lkPtbg1HXsaH-XkY6PDPb",
          "font-size5": "_2ttNwG29EZ83KjKVuiRNjO",
          "font-size6": "sFPdieisM6JiZKSmjNVau",
          "font-size7": "_2hQ1fS2GirG73dNtAvMgCH",
          "font-size8": "_2SqCuukvmQAdXTlaA6E7iV",
          "font-h0": "_19gy66g0OipeoVmGqzSZuX",
          "font-h1": "_3PS77guH8iSAjr5QJ3t6T8",
          "font-h2": "_1c7xai0VqKhT39FGxqt1Cu",
          "font-h3": "_15Oaf4Pv8qaebDfGjTFebr",
          "font-h4": "ojXHTUqL7OiFgGHF9g7it",
          "font-h5": "_3Y2yuKMOSQLPldHUKznNxo",
          "font-h6": "_1--GoChuB4wCWvBAHerbL1",
          "font-body": "_1s81kqOpJT3tfmbvoV_XuU",
          "font-paragraph": "_1kRuVHRENiG3Z1AQebKprZ",
          "font-list": "_14LBp6X-QYih81Acc6M-Ku",
          "font-list-item": "NiOcqUFO_eLHrcleU8dEF",
          "font-footnote": "_2_-t22Fs_UxzkopuVAFE_x",
          "font-lead": "t1Haz-u_NPsVtKDnaYRKC",
          "font-quote": "H6sgJ-XrIPEPEiHHuWSFC",
          "font-table-header": "ug0_gEOL9ELCeNgA1iTC5",
          "font-control": "_1NESX_CCWb7awCoGm4Y9ny",
          "font-control-label": "_1BA96xx3E50phfNCJcirY6",
          "font-tab": "_2lNfueS-wyWGbtaQB7PYdt",
          "font-badge": "_3td0q8OX8oyPhouXUFaEQX",
          "font-disclaimer": "_3VSesqpb31NZ_R5gQbATnA",
          "main": "uIzX-jVWkKG_Lrn9Jb-o2",
          "main-octavius": "vnTaOEOXvsdiu3AUr1UsO",
          "main-octavius-darkMode": "_1AKEh43YPbgmsLlzvFJ6_u",
          "content": "_2S1vpnaDf2bwesV0iY9mAY",
          "header": "_3pTRUpvZ5kYZxikhU2zcC7",
          "header-info": "_3Po099gGR8IU-sjoX105yl",
          "little-info-text": "_3CVRRd0Vky-sNDULZmebmU",
          "icon": "_2PSQ1dvSLkDkdv5cf6bMvo",
          "discount-date-full": "_19_IfDKbHILwVgAoRsl0eA",
          "discount-date": "_2Ctf32DpyStqT6NgHiRvbf",
          "billing-info": "_17rZlr9z_D3ofjqRLCztgE",
          "header-text": "_3kYu-BMnT7wcUmNrr3qhOm",
          "payment-block": "_1_UAGuUZrZtjC9A8-u9VPO"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/GibddBody/GibddBody.css":
      /*!***************************************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Gibdd/components/GibddBody/GibddBody.css ***!
        \***************************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsGibddComponentsGibddBodyGibddBodyCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, ".T7Q04zD9L5v064OSId5Cs {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._7Y-4jzczfbJIEmSA-4u4J {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.rh-B06mhdfqDZ7RtvDKoP {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1xGh_YCZj9YbakibXhyWdX {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3qYN3fxQoVCzvuM0dwJXEl {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3VOshGFBWuD5tbrIiuSFW1 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3pt83gkY_YdlG0Wdioa2By {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3IEgPbZbH6qS2cXV3yKSSB {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.Sp6wq6eU2XmtpBUdiw2S3 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t.Sp6wq6eU2XmtpBUdiw2S3 {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._104_EMvELhybHZfvENdQr_ {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._104_EMvELhybHZfvENdQr_ {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._25GvkJFNBYZ11rh-5Naa4k {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._25GvkJFNBYZ11rh-5Naa4k {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._271m6CBa4w_jwR2HPSdwIG {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._271m6CBa4w_jwR2HPSdwIG {\n\t\tfont-weight: 400;\n\t}\n}\n.Z3BNnd8CmKBUEz8zkBLS {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.Z3BNnd8CmKBUEz8zkBLS {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.wuBSbPPpxogjYXMoaGB-m {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._2pGbQxhEfy4DyPtjil-u5Y {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n.xty5UYz_STJeqraB5B0Wu {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t.xty5UYz_STJeqraB5B0Wu {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._3GrnmpTO3DeSzDq-nnrDJ5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._3GrnmpTO3DeSzDq-nnrDJ5 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.vYs72atcUQZJ2lGiVgo4i {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2VL0oOgk1mWoVZHEEIpau2 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1Wiqt-o_x72xkzP_O8rOLQ {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1Px5r5MG_pmo8j-R0bkZV4 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1-sdHjFLLBZuX8OxdcbRb1 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1FcOub66VaLPmuz-drBuoR {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1A_qbDBRij8gqC-Vb2oaHY {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1zreIuviqXOQyEO_Nv81He {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1WZxM8GPGXmJtGg7fNo3K0 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1WZxM8GPGXmJtGg7fNo3K0 {\n\t\tfont-size: 15px;\n\t}\n}\n.ktlZe_8FEfveJUiIvFQ6O {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1Rw82erq8P6rQY0EdAwQx_ {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n.T7Q04zD9L5v064OSId5Cs {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._7Y-4jzczfbJIEmSA-4u4J {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.rh-B06mhdfqDZ7RtvDKoP {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1xGh_YCZj9YbakibXhyWdX {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3qYN3fxQoVCzvuM0dwJXEl {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3VOshGFBWuD5tbrIiuSFW1 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3pt83gkY_YdlG0Wdioa2By {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3IEgPbZbH6qS2cXV3yKSSB {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.Sp6wq6eU2XmtpBUdiw2S3 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t.Sp6wq6eU2XmtpBUdiw2S3 {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._104_EMvELhybHZfvENdQr_ {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._104_EMvELhybHZfvENdQr_ {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._25GvkJFNBYZ11rh-5Naa4k {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._25GvkJFNBYZ11rh-5Naa4k {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._271m6CBa4w_jwR2HPSdwIG {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._271m6CBa4w_jwR2HPSdwIG {\n\t\tfont-weight: 400;\n\t}\n}\n.Z3BNnd8CmKBUEz8zkBLS {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.Z3BNnd8CmKBUEz8zkBLS {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.wuBSbPPpxogjYXMoaGB-m {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.wuBSbPPpxogjYXMoaGB-m {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2pGbQxhEfy4DyPtjil-u5Y {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2pGbQxhEfy4DyPtjil-u5Y {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.xty5UYz_STJeqraB5B0Wu {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3GrnmpTO3DeSzDq-nnrDJ5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n.vYs72atcUQZJ2lGiVgo4i {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2VL0oOgk1mWoVZHEEIpau2 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1Wiqt-o_x72xkzP_O8rOLQ {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1Px5r5MG_pmo8j-R0bkZV4 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1Px5r5MG_pmo8j-R0bkZV4 {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n._1-sdHjFLLBZuX8OxdcbRb1 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1FcOub66VaLPmuz-drBuoR {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1A_qbDBRij8gqC-Vb2oaHY {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1zreIuviqXOQyEO_Nv81He {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1WZxM8GPGXmJtGg7fNo3K0 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1WZxM8GPGXmJtGg7fNo3K0 {\n\t\tfont-size: 15px;\n\t}\n}\n.ktlZe_8FEfveJUiIvFQ6O {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1Rw82erq8P6rQY0EdAwQx_ {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n._2mu0wvoPoTycvyouMwlOcQ {\n\tpadding-left: 0;\n\tmargin: 12px 0;\n}\n._1r5X55A5mHdyNgQlCjNuyT {\n\tmargin-bottom: 8px;\n\tlist-style-type: none;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n}\n._1VjzMwkR861ljM5iu844fJ {\n\twidth: 90px;\n\tmargin-right: 16px;\n\t-ms-flex-negative: 0;\n\t    flex-shrink: 0;\n}\n.e2SZ8XQTucEJgAIyHRdEP {\n\t-webkit-font-feature-settings: \"c2sc\";\n\t        font-feature-settings: \"c2sc\";\n\tfont-variant: small-caps;\n\ttext-transform: lowercase;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "T7Q04zD9L5v064OSId5Cs",
          "font-size2": "_7Y-4jzczfbJIEmSA-4u4J",
          "font-size3": "rh-B06mhdfqDZ7RtvDKoP",
          "font-size4": "_1xGh_YCZj9YbakibXhyWdX",
          "font-size5": "_3qYN3fxQoVCzvuM0dwJXEl",
          "font-size6": "_3VOshGFBWuD5tbrIiuSFW1",
          "font-size7": "_3pt83gkY_YdlG0Wdioa2By",
          "font-size8": "_3IEgPbZbH6qS2cXV3yKSSB",
          "font-h0": "Sp6wq6eU2XmtpBUdiw2S3",
          "font-h1": "_104_EMvELhybHZfvENdQr_",
          "font-h2": "_25GvkJFNBYZ11rh-5Naa4k",
          "font-h3": "_271m6CBa4w_jwR2HPSdwIG",
          "font-h4": "Z3BNnd8CmKBUEz8zkBLS",
          "font-h5": "wuBSbPPpxogjYXMoaGB-m",
          "font-h6": "_2pGbQxhEfy4DyPtjil-u5Y",
          "font-body": "xty5UYz_STJeqraB5B0Wu",
          "font-paragraph": "_3GrnmpTO3DeSzDq-nnrDJ5",
          "font-list": "vYs72atcUQZJ2lGiVgo4i",
          "font-list-item": "_2VL0oOgk1mWoVZHEEIpau2",
          "font-footnote": "_1Wiqt-o_x72xkzP_O8rOLQ",
          "font-lead": "_1Px5r5MG_pmo8j-R0bkZV4",
          "font-quote": "_1-sdHjFLLBZuX8OxdcbRb1",
          "font-table-header": "_1FcOub66VaLPmuz-drBuoR",
          "font-control": "_1A_qbDBRij8gqC-Vb2oaHY",
          "font-control-label": "_1zreIuviqXOQyEO_Nv81He",
          "font-tab": "_1WZxM8GPGXmJtGg7fNo3K0",
          "font-badge": "ktlZe_8FEfveJUiIvFQ6O",
          "font-disclaimer": "_1Rw82erq8P6rQY0EdAwQx_",
          "info-list": "_2mu0wvoPoTycvyouMwlOcQ",
          "info-list-element": "_1r5X55A5mHdyNgQlCjNuyT",
          "info-element-label": "_1VjzMwkR861ljM5iu844fJ",
          "small-caps": "e2SZ8XQTucEJgAIyHRdEP"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/GibddButtons/GibddButtons.css":
      /*!*********************************************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Gibdd/components/GibddButtons/GibddButtons.css ***!
        \*********************************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsGibddComponentsGibddButtonsGibddButtonsCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._3_1Ahmin-xfT4ZxRNZt7j7 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3ZGZxWV0hkJ9T5yj00x_KP {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2nqz6Dz3_-MadmJKwoK5dc {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._193ypL-_YVzOFhj1q1LIbk {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1Cs3VrVQJhPFc8MQe-Jqxp {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._11DbUKp773V3NdLA4HCHiX {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2HRgWjmXSi-xsgKBDcKNkS {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2vWlfsR28l4dvT0cG1Zh1J {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1c8xCZ-2vP6rZx_0tN9WYw {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._1c8xCZ-2vP6rZx_0tN9WYw {\n\t\tmargin-bottom: 24px;\n\t}\n}\n.b2c3C2KoaQUuyzuAmL6Dm {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t.b2c3C2KoaQUuyzuAmL6Dm {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.BG0SPc_3ehRvZSHpUfoWo {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.BG0SPc_3ehRvZSHpUfoWo {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n.OLd6GCW-jnyn2n2tlbKyW {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.OLd6GCW-jnyn2n2tlbKyW {\n\t\tfont-weight: 400;\n\t}\n}\n._1PgRey9jTXL5sXiq-ijbxf {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1PgRey9jTXL5sXiq-ijbxf {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1csK38rG8Io3sNXjL3CNbN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._9qwtP2ak4Q9nuffndSwxN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._2v2e1hAm3O8Su2uep9YsYj {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._2v2e1hAm3O8Su2uep9YsYj {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._1qrwgECPuUHXc_05xNZ2Ne {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._1qrwgECPuUHXc_05xNZ2Ne {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2skKQpdo17XV2PrP2oBmWi {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3Yr4RZliZPLdjxn-tiT9Vz {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._4E2fC4Poq5Sve7jxIFeQi {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._8qmUM04d5moNVcJWFNHNe {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2mBaJ0e5Hrh7HaV0ABFAWR {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._15PS5uuKbwru6Ts59becF4 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1bh8MI9Guc7MrnyLqv_8Gl {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.r30s7JKPMuOuCNuwBlZcu {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.K_7KMkqa9M1Ki9pEWc8Fo {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t.K_7KMkqa9M1Ki9pEWc8Fo {\n\t\tfont-size: 15px;\n\t}\n}\n._3r8FGqusZtFjEl23btBP0j {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1MtT9hpXJu3g34gD5AYMqe {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n._3_1Ahmin-xfT4ZxRNZt7j7 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3ZGZxWV0hkJ9T5yj00x_KP {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2nqz6Dz3_-MadmJKwoK5dc {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._193ypL-_YVzOFhj1q1LIbk {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1Cs3VrVQJhPFc8MQe-Jqxp {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._11DbUKp773V3NdLA4HCHiX {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2HRgWjmXSi-xsgKBDcKNkS {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2vWlfsR28l4dvT0cG1Zh1J {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1c8xCZ-2vP6rZx_0tN9WYw {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._1c8xCZ-2vP6rZx_0tN9WYw {\n\t\tmargin-bottom: 24px;\n\t}\n}\n.b2c3C2KoaQUuyzuAmL6Dm {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t.b2c3C2KoaQUuyzuAmL6Dm {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.BG0SPc_3ehRvZSHpUfoWo {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.BG0SPc_3ehRvZSHpUfoWo {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n.OLd6GCW-jnyn2n2tlbKyW {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.OLd6GCW-jnyn2n2tlbKyW {\n\t\tfont-weight: 400;\n\t}\n}\n._1PgRey9jTXL5sXiq-ijbxf {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1PgRey9jTXL5sXiq-ijbxf {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1csK38rG8Io3sNXjL3CNbN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1csK38rG8Io3sNXjL3CNbN {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._9qwtP2ak4Q9nuffndSwxN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._9qwtP2ak4Q9nuffndSwxN {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2v2e1hAm3O8Su2uep9YsYj {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1qrwgECPuUHXc_05xNZ2Ne {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n._2skKQpdo17XV2PrP2oBmWi {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3Yr4RZliZPLdjxn-tiT9Vz {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._4E2fC4Poq5Sve7jxIFeQi {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._8qmUM04d5moNVcJWFNHNe {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._8qmUM04d5moNVcJWFNHNe {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n._2mBaJ0e5Hrh7HaV0ABFAWR {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._15PS5uuKbwru6Ts59becF4 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1bh8MI9Guc7MrnyLqv_8Gl {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.r30s7JKPMuOuCNuwBlZcu {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.K_7KMkqa9M1Ki9pEWc8Fo {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t.K_7KMkqa9M1Ki9pEWc8Fo {\n\t\tfont-size: 15px;\n\t}\n}\n._3r8FGqusZtFjEl23btBP0j {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1MtT9hpXJu3g34gD5AYMqe {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n._37u1mUUnfEY_ze4Ym0F_BA {\n\tmargin-bottom: 24px;\n}\n._1xQri-O4G49lEP7NLksM3y {\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 100%;\n\tmargin-left: -20px;\n\tborder: 1px #f0f0f0;\n\tborder-top-style: solid;\n\theight: 72px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n}\n._1xQri-O4G49lEP7NLksM3y button {\n\tmargin-right: 8px;\n\tmargin-top: 20px;\n}\n.WLKvWa3-rjx5z_uDAN5B8  {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: justify;\n\t    -ms-flex-pack: justify;\n\t        justify-content: space-between;\n\tmargin-top: 24px;\n\tmargin-bottom: 90px;\n}\n.WLKvWa3-rjx5z_uDAN5B8 svg {\n\twidth: 180px;\n\theight: 180px;\n\tbackground-color: #f0f0f0;\n}\n.WLKvWa3-rjx5z_uDAN5B8 a {\n\tmargin-right: 20px;\n}\n._3lJB4Z3fQbRctft2ioeXLr {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\tmargin-bottom: 70px;\n}\n._1RJ9L8OqH2vHzJWfSsfKlu svg {\n\twidth: 240px;\n\theight: 240px;\n\tmargin-right: 20px;\n\tbackground-color: #f0f0f0;\n}\n._2LeebW-RtzEKiZ2MS2Gs_h {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: column;\n\t        flex-direction: column;\n}\n._2LeebW-RtzEKiZ2MS2Gs_h svg {\n\twidth: 120px;\n\theight: 110px;\n\tmargin-bottom: 20px;\n\tbackground-color: #f0f0f0;\n}\n.fr-k8Yo-HfMSzbgxbd_hG {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: column;\n\t        flex-direction: column;\n\tmargin-top: 24px;\n\tmargin-bottom: 90px;\n}\n._9yf76GFO48QZBsGIG-sJ_ {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\tmargin-bottom: 20px;\n}\n.fr-k8Yo-HfMSzbgxbd_hG svg {\n\twidth: 180px;\n\theight: 180px;\n\tmargin-right: 20px;\n\tbackground-color: #f0f0f0;\n}\n._1fVcPBrfC7ZH1yhx4n8nmn {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n}\n._tKomhWuaf7B1uN4Hm_Vg {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 16px;\n\twhite-space: nowrap;\n}\n._12RRxVvtmoPOSEYPSgSuTd {\n\tmargin-right: 8px;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "_3_1Ahmin-xfT4ZxRNZt7j7",
          "font-size2": "_3ZGZxWV0hkJ9T5yj00x_KP",
          "font-size3": "_2nqz6Dz3_-MadmJKwoK5dc",
          "font-size4": "_193ypL-_YVzOFhj1q1LIbk",
          "font-size5": "_1Cs3VrVQJhPFc8MQe-Jqxp",
          "font-size6": "_11DbUKp773V3NdLA4HCHiX",
          "font-size7": "_2HRgWjmXSi-xsgKBDcKNkS",
          "font-size8": "_2vWlfsR28l4dvT0cG1Zh1J",
          "font-h0": "_1c8xCZ-2vP6rZx_0tN9WYw",
          "font-h1": "b2c3C2KoaQUuyzuAmL6Dm",
          "font-h2": "BG0SPc_3ehRvZSHpUfoWo",
          "font-h3": "OLd6GCW-jnyn2n2tlbKyW",
          "font-h4": "_1PgRey9jTXL5sXiq-ijbxf",
          "font-h5": "_1csK38rG8Io3sNXjL3CNbN",
          "font-h6": "_9qwtP2ak4Q9nuffndSwxN",
          "font-body": "_2v2e1hAm3O8Su2uep9YsYj",
          "font-paragraph": "_1qrwgECPuUHXc_05xNZ2Ne",
          "font-list": "_2skKQpdo17XV2PrP2oBmWi",
          "font-list-item": "_3Yr4RZliZPLdjxn-tiT9Vz",
          "font-footnote": "_4E2fC4Poq5Sve7jxIFeQi",
          "font-lead": "_8qmUM04d5moNVcJWFNHNe",
          "font-quote": "_2mBaJ0e5Hrh7HaV0ABFAWR",
          "font-table-header": "_15PS5uuKbwru6Ts59becF4",
          "font-control": "_1bh8MI9Guc7MrnyLqv_8Gl",
          "font-control-label": "r30s7JKPMuOuCNuwBlZcu",
          "font-tab": "K_7KMkqa9M1Ki9pEWc8Fo",
          "font-badge": "_3r8FGqusZtFjEl23btBP0j",
          "font-disclaimer": "_1MtT9hpXJu3g34gD5AYMqe",
          "popup-header": "_37u1mUUnfEY_ze4Ym0F_BA",
          "popup-buttons-block": "_1xQri-O4G49lEP7NLksM3y",
          "photo-block-2": "WLKvWa3-rjx5z_uDAN5B8",
          "photo-block-3": "_3lJB4Z3fQbRctft2ioeXLr",
          "photo-block-3-main": "_1RJ9L8OqH2vHzJWfSsfKlu",
          "photo-block-3-previous": "_2LeebW-RtzEKiZ2MS2Gs_h",
          "photo-block-4": "fr-k8Yo-HfMSzbgxbd_hG",
          "photo-block-4-row-first": "_9yf76GFO48QZBsGIG-sJ_",
          "photo-block-4-row": "_1fVcPBrfC7ZH1yhx4n8nmn",
          "buttons-block": "_tKomhWuaf7B1uN4Hm_Vg",
          "button-pay": "_12RRxVvtmoPOSEYPSgSuTd"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/GroupPayments/GroupPayments.css":
      /*!***********************************************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Gibdd/components/GroupPayments/GroupPayments.css ***!
        \***********************************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsGibddComponentsGroupPaymentsGroupPaymentsCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._3VibzykJRYGUpZVCplxRcP {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._11uhBbl2vV2J_IldHYo_7M {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2-HzPi64PxzHh8Gw4bhoSf {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2Mmp9jo-IcXBUWsMIqNRfG {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.HGHygz0nmYfnVvo7dvGqy {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.YtRmi9eZdDuvur2PBwwjn {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1zkTKyZyhjoca0VY9MrIym {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.qFW8QLxK68RbcGNcJXOWw {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3bXoAQUwGsUM_qiVfPNRh {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._3bXoAQUwGsUM_qiVfPNRh {\n\t\tmargin-bottom: 24px;\n\t}\n}\n.dWDhvmfVx363Kf6Xqbs6- {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t.dWDhvmfVx363Kf6Xqbs6- {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.GfX-djCi7P08pNX3F4ebi {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.GfX-djCi7P08pNX3F4ebi {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._2D1B-tQUp8H-qUsyalXSLu {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2D1B-tQUp8H-qUsyalXSLu {\n\t\tfont-weight: 400;\n\t}\n}\n._2pf_7kPHUCKZFZYR8swYsN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2pf_7kPHUCKZFZYR8swYsN {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._34FYcBoutc_Krh5zngS4Wm {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._3tsA1K8tqYzUUXrDJ7iPh3 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._2JoppM_2xRL6_STIgcKgo5 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._2JoppM_2xRL6_STIgcKgo5 {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._39Ghzz3VKCKmkD_8xkC8Lf {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._39Ghzz3VKCKmkD_8xkC8Lf {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1xbrXffdOFZWtzKkeJdhg5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2vDOaD3t32f8ZPOlw4RWtC {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2jfR7yc-dhKEFji1DsKms3 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2B3lA9Szu04Fs4cB4aIQMR {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.CGxUoL2miFDeXjk_csGCM {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._38szwAAkCFif6c8Mj8PpEX {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1mflkz-9D23eOGACy3JYiP {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2daFGyINg1nJRxeQ13xJgg {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3wWmKSFXjVHhNOraGOeuFS {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._3wWmKSFXjVHhNOraGOeuFS {\n\t\tfont-size: 15px;\n\t}\n}\n._3GtiON447Qlb7q4tDf7dec {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1GF-sjOXL7EO1k3pNduqTB {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n._3VibzykJRYGUpZVCplxRcP {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._11uhBbl2vV2J_IldHYo_7M {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2-HzPi64PxzHh8Gw4bhoSf {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2Mmp9jo-IcXBUWsMIqNRfG {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.HGHygz0nmYfnVvo7dvGqy {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.YtRmi9eZdDuvur2PBwwjn {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1zkTKyZyhjoca0VY9MrIym {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.qFW8QLxK68RbcGNcJXOWw {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3bXoAQUwGsUM_qiVfPNRh {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._3bXoAQUwGsUM_qiVfPNRh {\n\t\tmargin-bottom: 24px;\n\t}\n}\n.dWDhvmfVx363Kf6Xqbs6- {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t.dWDhvmfVx363Kf6Xqbs6- {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.GfX-djCi7P08pNX3F4ebi {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.GfX-djCi7P08pNX3F4ebi {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._2D1B-tQUp8H-qUsyalXSLu {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2D1B-tQUp8H-qUsyalXSLu {\n\t\tfont-weight: 400;\n\t}\n}\n._2pf_7kPHUCKZFZYR8swYsN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2pf_7kPHUCKZFZYR8swYsN {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._34FYcBoutc_Krh5zngS4Wm {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._34FYcBoutc_Krh5zngS4Wm {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._3tsA1K8tqYzUUXrDJ7iPh3 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3tsA1K8tqYzUUXrDJ7iPh3 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2JoppM_2xRL6_STIgcKgo5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._39Ghzz3VKCKmkD_8xkC8Lf {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n._1xbrXffdOFZWtzKkeJdhg5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2vDOaD3t32f8ZPOlw4RWtC {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2jfR7yc-dhKEFji1DsKms3 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2B3lA9Szu04Fs4cB4aIQMR {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._2B3lA9Szu04Fs4cB4aIQMR {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n.CGxUoL2miFDeXjk_csGCM {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._38szwAAkCFif6c8Mj8PpEX {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1mflkz-9D23eOGACy3JYiP {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2daFGyINg1nJRxeQ13xJgg {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3wWmKSFXjVHhNOraGOeuFS {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._3wWmKSFXjVHhNOraGOeuFS {\n\t\tfont-size: 15px;\n\t}\n}\n._3GtiON447Qlb7q4tDf7dec {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1GF-sjOXL7EO1k3pNduqTB {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n.tgSMbu02z7PtKeGOgk6MT {\n\tmargin-top: 8px;\n\tpadding-top: 12px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tborder-top: 1px solid rgba(0, 16, 61, .12);\n}\n.LLBvTaq1gbFKlYylvpzgq {\n\tmargin-top: 1px;\n\tpadding-right: 12px;\n}\n.KqG6OnXJE_a26ezUKNzgE {\n\tmargin-left: 24px;\n}\n._21t2knDR_Q8glM5SxXUwb- {\n\tfont-weight: 600;\n\tcolor: #333333;\n}\n/* скругляем углы попапов */\n[data-test-id=\"popup-wrapper\"],\n[data-test-id=\"popup-wrapper\"] iframe {\n\tborder-radius: 12px !important;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "_3VibzykJRYGUpZVCplxRcP",
          "font-size2": "_11uhBbl2vV2J_IldHYo_7M",
          "font-size3": "_2-HzPi64PxzHh8Gw4bhoSf",
          "font-size4": "_2Mmp9jo-IcXBUWsMIqNRfG",
          "font-size5": "HGHygz0nmYfnVvo7dvGqy",
          "font-size6": "YtRmi9eZdDuvur2PBwwjn",
          "font-size7": "_1zkTKyZyhjoca0VY9MrIym",
          "font-size8": "qFW8QLxK68RbcGNcJXOWw",
          "font-h0": "_3bXoAQUwGsUM_qiVfPNRh",
          "font-h1": "dWDhvmfVx363Kf6Xqbs6-",
          "font-h2": "GfX-djCi7P08pNX3F4ebi",
          "font-h3": "_2D1B-tQUp8H-qUsyalXSLu",
          "font-h4": "_2pf_7kPHUCKZFZYR8swYsN",
          "font-h5": "_34FYcBoutc_Krh5zngS4Wm",
          "font-h6": "_3tsA1K8tqYzUUXrDJ7iPh3",
          "font-body": "_2JoppM_2xRL6_STIgcKgo5",
          "font-paragraph": "_39Ghzz3VKCKmkD_8xkC8Lf",
          "font-list": "_1xbrXffdOFZWtzKkeJdhg5",
          "font-list-item": "_2vDOaD3t32f8ZPOlw4RWtC",
          "font-footnote": "_2jfR7yc-dhKEFji1DsKms3",
          "font-lead": "_2B3lA9Szu04Fs4cB4aIQMR",
          "font-quote": "CGxUoL2miFDeXjk_csGCM",
          "font-table-header": "_38szwAAkCFif6c8Mj8PpEX",
          "font-control": "_1mflkz-9D23eOGACy3JYiP",
          "font-control-label": "_2daFGyINg1nJRxeQ13xJgg",
          "font-tab": "_3wWmKSFXjVHhNOraGOeuFS",
          "font-badge": "_3GtiON447Qlb7q4tDf7dec",
          "font-disclaimer": "_1GF-sjOXL7EO1k3pNduqTB",
          "group-payment-block": "tgSMbu02z7PtKeGOgk6MT",
          "info-icon": "LLBvTaq1gbFKlYylvpzgq",
          "button-group-more": "KqG6OnXJE_a26ezUKNzgE",
          "group-payment-amount": "_21t2knDR_Q8glM5SxXUwb-"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.css":
      /*!***********************************************************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.css ***!
        \***********************************************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsGibddComponentsGroupPaymentsLoaderGroupPaymentsLoaderCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._2cmzYeF7WHbDS5Vl4Gx1T7 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._36qQuuzypaspHkr_u7M4pV {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.DuY7wwZn73R_bPOxXDnMP {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2j2RM7Dxcc0S0B_kgKXXAZ {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1M_3Z6CSrTmNoC_73u93kY {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.Xy2RrZY9fbFB6USLkLLGv {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2fuD5PwpL56bQc1d0_9MxD {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3wJJmHDzQ1UAZAPOCcOYbA {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.HHIqEj5Pz-zxv-sdrFdK3 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t.HHIqEj5Pz-zxv-sdrFdK3 {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._34OPTeKwtEp9Y0Xz60mYKH {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._34OPTeKwtEp9Y0Xz60mYKH {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._33QUt41ARp-kfd_q_mrCPL {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._33QUt41ARp-kfd_q_mrCPL {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._3jy3Isf_jJZ2OLoCCV2X5l {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3jy3Isf_jJZ2OLoCCV2X5l {\n\t\tfont-weight: 400;\n\t}\n}\n._1MvMNdGtrw54kccMRwDgIE {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1MvMNdGtrw54kccMRwDgIE {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1JhaB1WPd-WqQGhfBMea4v {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._34XuGpyE2FuPm4Nm6IfDj5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._13oodvt8GmqKWz0DEDZFqJ {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._13oodvt8GmqKWz0DEDZFqJ {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._3mDxlud5vQDNfACZa7BR94 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._3mDxlud5vQDNfACZa7BR94 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.bPF2i-qfBUp10W5I8BY1c {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2GmCNOK7rh7JdkXlKMoYqL {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2VzizLTUGM48i2wueDMXW {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1dA_BLaKF-FydzJzyaSi {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.SxEmy_R_CpVwpr42TVB_w {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1myIjKngpDJizTgLO1lpdN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1CbyVb1recNZ7qrf6bHsq {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.jgjLoE2K0nGwQAm4JZAbk {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2U8h2_T-f2zoz9l2bZOS46 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._2U8h2_T-f2zoz9l2bZOS46 {\n\t\tfont-size: 15px;\n\t}\n}\n.g5xZ6Tm1xfHpnWsB6BviX {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1XCAdmle-tRXGh-5Fj9SjX {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n._2cmzYeF7WHbDS5Vl4Gx1T7 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._36qQuuzypaspHkr_u7M4pV {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.DuY7wwZn73R_bPOxXDnMP {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2j2RM7Dxcc0S0B_kgKXXAZ {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1M_3Z6CSrTmNoC_73u93kY {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.Xy2RrZY9fbFB6USLkLLGv {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2fuD5PwpL56bQc1d0_9MxD {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3wJJmHDzQ1UAZAPOCcOYbA {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.HHIqEj5Pz-zxv-sdrFdK3 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t.HHIqEj5Pz-zxv-sdrFdK3 {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._34OPTeKwtEp9Y0Xz60mYKH {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._34OPTeKwtEp9Y0Xz60mYKH {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._33QUt41ARp-kfd_q_mrCPL {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._33QUt41ARp-kfd_q_mrCPL {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._3jy3Isf_jJZ2OLoCCV2X5l {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3jy3Isf_jJZ2OLoCCV2X5l {\n\t\tfont-weight: 400;\n\t}\n}\n._1MvMNdGtrw54kccMRwDgIE {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1MvMNdGtrw54kccMRwDgIE {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1JhaB1WPd-WqQGhfBMea4v {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1JhaB1WPd-WqQGhfBMea4v {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._34XuGpyE2FuPm4Nm6IfDj5 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._34XuGpyE2FuPm4Nm6IfDj5 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._13oodvt8GmqKWz0DEDZFqJ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3mDxlud5vQDNfACZa7BR94 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n.bPF2i-qfBUp10W5I8BY1c {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2GmCNOK7rh7JdkXlKMoYqL {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2VzizLTUGM48i2wueDMXW {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1dA_BLaKF-FydzJzyaSi {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1dA_BLaKF-FydzJzyaSi {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n.SxEmy_R_CpVwpr42TVB_w {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1myIjKngpDJizTgLO1lpdN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1CbyVb1recNZ7qrf6bHsq {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.jgjLoE2K0nGwQAm4JZAbk {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2U8h2_T-f2zoz9l2bZOS46 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._2U8h2_T-f2zoz9l2bZOS46 {\n\t\tfont-size: 15px;\n\t}\n}\n.g5xZ6Tm1xfHpnWsB6BviX {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1XCAdmle-tRXGh-5Fj9SjX {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n._1XQ1AU9aT6CPy8hwRIXVwH {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\tborder-top: 1px solid rgba(0, 16, 61, .12);\n\tpadding-top: 12px;\n}\n._2VCQpnyM-C1gCxPNLz6JP1 {\n\tmargin-right: 12px;\n\theight: 16px;\n\tpadding-bottom: 2px;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "_2cmzYeF7WHbDS5Vl4Gx1T7",
          "font-size2": "_36qQuuzypaspHkr_u7M4pV",
          "font-size3": "DuY7wwZn73R_bPOxXDnMP",
          "font-size4": "_2j2RM7Dxcc0S0B_kgKXXAZ",
          "font-size5": "_1M_3Z6CSrTmNoC_73u93kY",
          "font-size6": "Xy2RrZY9fbFB6USLkLLGv",
          "font-size7": "_2fuD5PwpL56bQc1d0_9MxD",
          "font-size8": "_3wJJmHDzQ1UAZAPOCcOYbA",
          "font-h0": "HHIqEj5Pz-zxv-sdrFdK3",
          "font-h1": "_34OPTeKwtEp9Y0Xz60mYKH",
          "font-h2": "_33QUt41ARp-kfd_q_mrCPL",
          "font-h3": "_3jy3Isf_jJZ2OLoCCV2X5l",
          "font-h4": "_1MvMNdGtrw54kccMRwDgIE",
          "font-h5": "_1JhaB1WPd-WqQGhfBMea4v",
          "font-h6": "_34XuGpyE2FuPm4Nm6IfDj5",
          "font-body": "_13oodvt8GmqKWz0DEDZFqJ",
          "font-paragraph": "_3mDxlud5vQDNfACZa7BR94",
          "font-list": "bPF2i-qfBUp10W5I8BY1c",
          "font-list-item": "_2GmCNOK7rh7JdkXlKMoYqL",
          "font-footnote": "_2VzizLTUGM48i2wueDMXW",
          "font-lead": "_1dA_BLaKF-FydzJzyaSi",
          "font-quote": "SxEmy_R_CpVwpr42TVB_w",
          "font-table-header": "_1myIjKngpDJizTgLO1lpdN",
          "font-control": "_1CbyVb1recNZ7qrf6bHsq",
          "font-control-label": "jgjLoE2K0nGwQAm4JZAbk",
          "font-tab": "_2U8h2_T-f2zoz9l2bZOS46",
          "font-badge": "g5xZ6Tm1xfHpnWsB6BviX",
          "font-disclaimer": "_1XCAdmle-tRXGh-5Fj9SjX",
          "group-payment-loading-block": "_1XQ1AU9aT6CPy8hwRIXVwH",
          "loader": "_2VCQpnyM-C1gCxPNLz6JP1"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.css":
      /*!***************************************************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.css ***!
        \***************************************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsGibddComponentsUnpaidFinesInfoUnpaidFinesInfoCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._1E8vGHCQSVsREcYmTryd40 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3-M3rMtxT-GEzjWlI9_uqX {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2CZkfrzTGbxfmrm7UVm_Yn {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.hzBLCc-ZRZoL4EzeqFMzn {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1tAeGu9__ZkcgQ-OqZWnPS {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2YUDKR27k3tqJ1TPLkWlg3 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3oiTRpXNSeNS5GPlaa3V1P {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.BsI9jol5a-OWQKb2zovED {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2zlKo-yaEGVQEr26hQ4vsM {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._2zlKo-yaEGVQEr26hQ4vsM {\n\t\tmargin-bottom: 24px;\n\t}\n}\n.Sh4iXn4B4uHwZl_0S0ght {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t.Sh4iXn4B4uHwZl_0S0ght {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._34l3GZDbiyeOkgSoCbFBLs {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._34l3GZDbiyeOkgSoCbFBLs {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n.XMwO3Lx58yh6SEHcyRm0f {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.XMwO3Lx58yh6SEHcyRm0f {\n\t\tfont-weight: 400;\n\t}\n}\n._1JHbDwxw3WkF4uS1OujWDV {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1JHbDwxw3WkF4uS1OujWDV {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2OVKwKL8HqEy696Fr5gf1f {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n.Wfn7LEpiRyvY_X7krjh7w {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._1EuldFQ0FY-i36iHMcoTZe {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1EuldFQ0FY-i36iHMcoTZe {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._3y57wlvRwgbYuJ3-2JTEE6 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._3y57wlvRwgbYuJ3-2JTEE6 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2e4E3oXo2TFwkLvLQE7OWq {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2cBtsfUg1bt_9Mgzon8Exa {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.RqsJApEDfYjdzpWb8vhz4 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1yO5qeY2BkPBBa-KriaCXP {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._115tFJ7sVEYdHJ4naiiZjl {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._35U743b373mfS3Yb8fnodN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1p6XXriepnhxsj_b02cXkL {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3xEYVhWReRD9fvaXoOHFBv {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.dAfGN9lBFw2NHOu2711ow {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t.dAfGN9lBFw2NHOu2711ow {\n\t\tfont-size: 15px;\n\t}\n}\n._2lcnqviReyXZKIm-vMJrAG {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._2Qk6zDZNE6PvQ4dUJhsh95 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n._1E8vGHCQSVsREcYmTryd40 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3-M3rMtxT-GEzjWlI9_uqX {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2CZkfrzTGbxfmrm7UVm_Yn {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.hzBLCc-ZRZoL4EzeqFMzn {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1tAeGu9__ZkcgQ-OqZWnPS {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2YUDKR27k3tqJ1TPLkWlg3 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3oiTRpXNSeNS5GPlaa3V1P {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.BsI9jol5a-OWQKb2zovED {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2zlKo-yaEGVQEr26hQ4vsM {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._2zlKo-yaEGVQEr26hQ4vsM {\n\t\tmargin-bottom: 24px;\n\t}\n}\n.Sh4iXn4B4uHwZl_0S0ght {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t.Sh4iXn4B4uHwZl_0S0ght {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._34l3GZDbiyeOkgSoCbFBLs {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._34l3GZDbiyeOkgSoCbFBLs {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n.XMwO3Lx58yh6SEHcyRm0f {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.XMwO3Lx58yh6SEHcyRm0f {\n\t\tfont-weight: 400;\n\t}\n}\n._1JHbDwxw3WkF4uS1OujWDV {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1JHbDwxw3WkF4uS1OujWDV {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2OVKwKL8HqEy696Fr5gf1f {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2OVKwKL8HqEy696Fr5gf1f {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.Wfn7LEpiRyvY_X7krjh7w {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.Wfn7LEpiRyvY_X7krjh7w {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1EuldFQ0FY-i36iHMcoTZe {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3y57wlvRwgbYuJ3-2JTEE6 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n._2e4E3oXo2TFwkLvLQE7OWq {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2cBtsfUg1bt_9Mgzon8Exa {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.RqsJApEDfYjdzpWb8vhz4 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1yO5qeY2BkPBBa-KriaCXP {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1yO5qeY2BkPBBa-KriaCXP {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n._115tFJ7sVEYdHJ4naiiZjl {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._35U743b373mfS3Yb8fnodN {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1p6XXriepnhxsj_b02cXkL {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3xEYVhWReRD9fvaXoOHFBv {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.dAfGN9lBFw2NHOu2711ow {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t.dAfGN9lBFw2NHOu2711ow {\n\t\tfont-size: 15px;\n\t}\n}\n._2lcnqviReyXZKIm-vMJrAG {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._2Qk6zDZNE6PvQ4dUJhsh95 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n._13qYhVFi9ULT1ksjmiAxc0 {\n\tmargin-top: 8px;\n\tpadding-top: 12px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tborder-top: 1px solid rgba(0, 16, 61, .12);\n}\n.y6eJYi95b4JgszDSDr5YR {\n\tmargin-top: 1px;\n\tpadding-right: 12px;\n}\n._1t-icVH11aTVGOOcyg1EO7 {\n\tmargin-left: 16px;\n}\n.ad-AdNRur_FwOb0289y7Q {\n\tfont-weight: 600;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "_1E8vGHCQSVsREcYmTryd40",
          "font-size2": "_3-M3rMtxT-GEzjWlI9_uqX",
          "font-size3": "_2CZkfrzTGbxfmrm7UVm_Yn",
          "font-size4": "hzBLCc-ZRZoL4EzeqFMzn",
          "font-size5": "_1tAeGu9__ZkcgQ-OqZWnPS",
          "font-size6": "_2YUDKR27k3tqJ1TPLkWlg3",
          "font-size7": "_3oiTRpXNSeNS5GPlaa3V1P",
          "font-size8": "BsI9jol5a-OWQKb2zovED",
          "font-h0": "_2zlKo-yaEGVQEr26hQ4vsM",
          "font-h1": "Sh4iXn4B4uHwZl_0S0ght",
          "font-h2": "_34l3GZDbiyeOkgSoCbFBLs",
          "font-h3": "XMwO3Lx58yh6SEHcyRm0f",
          "font-h4": "_1JHbDwxw3WkF4uS1OujWDV",
          "font-h5": "_2OVKwKL8HqEy696Fr5gf1f",
          "font-h6": "Wfn7LEpiRyvY_X7krjh7w",
          "font-body": "_1EuldFQ0FY-i36iHMcoTZe",
          "font-paragraph": "_3y57wlvRwgbYuJ3-2JTEE6",
          "font-list": "_2e4E3oXo2TFwkLvLQE7OWq",
          "font-list-item": "_2cBtsfUg1bt_9Mgzon8Exa",
          "font-footnote": "RqsJApEDfYjdzpWb8vhz4",
          "font-lead": "_1yO5qeY2BkPBBa-KriaCXP",
          "font-quote": "_115tFJ7sVEYdHJ4naiiZjl",
          "font-table-header": "_35U743b373mfS3Yb8fnodN",
          "font-control": "_1p6XXriepnhxsj_b02cXkL",
          "font-control-label": "_3xEYVhWReRD9fvaXoOHFBv",
          "font-tab": "dAfGN9lBFw2NHOu2711ow",
          "font-badge": "_2lcnqviReyXZKIm-vMJrAG",
          "font-disclaimer": "_2Qk6zDZNE6PvQ4dUJhsh95",
          "group-payment-block": "_13qYhVFi9ULT1ksjmiAxc0",
          "info-icon": "y6eJYi95b4JgszDSDr5YR",
          "button-group-more": "_1t-icVH11aTVGOOcyg1EO7",
          "group-payment-amount": "ad-AdNRur_FwOb0289y7Q"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/IncompleteOrder/IncompleteOrder.css":
      /*!**********************************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/IncompleteOrder/IncompleteOrder.css ***!
        \**********************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsIncompleteOrderIncompleteOrderCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._2lNDC03OkbapZFdz52EzCp {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 2px;\n\tmargin-top: 12px;\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.cqXmIArvr9yYmYT3nTeNr {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 12px;\n\tmargin-top: 12px;\n\tmargin-bottom: 10px;\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.E8xNgEGbBsUkiPoP1gh2a {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n}\n\n._2Iaghg9SYnHIGsrkZPUM6W {\n\tbackground-color: rgba(255, 255, 255, .08);\n}\n\n._1h2AHefzEpLKUtqDj4KRnT {\n\tmargin-right: 20px;\n}\n\n.RNPaaVDv8T2msGX0uv-rD {\n\twidth: 100%;\n\tpadding-right: 16px;\n}\n\n.cqXmIArvr9yYmYT3nTeNr .RNPaaVDv8T2msGX0uv-rD {\n\tpadding-right: 20px;\n}\n\n._1epOcryhJoS4YUsVTxnljU {\n\twidth: 120px;\n\theight: 100%;\n\tborder-radius: 12px 0 0 12px;\n\tbackground-position: center;\n\tbackground-size: cover;\n}\n\n._1KpY7OiSWBOaKd4_5IOWNE {\n\tposition: relative;\n\tfloat: right;\n\twidth: 42px;\n\theight: 32px;\n\tmargin-top: 11px;\n\tmargin-right: -12px;\n}\n\n.YGGrwQdUheQzkHTm9gBe4 {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-ms-flex-wrap: wrap;\n\t    flex-wrap: wrap;\n\tmargin-top: 12px;\n\tmax-width: calc(100% - 147px);\n}\n\n.zpEEDTVa_xAIXEtVM6k7I {\n\tmargin-right: 20px;\n\tmargin-bottom: 8px;\n}\n\n.SIWLUU42lKXiG7yR6tRW {\n\tmargin-top: 1px;\n\tmargin-right: 20px;\n}\n\n._1r9cyy2k8howXBZljWDevL {\n\tmargin-bottom: 12px;\n}\n\n._1jLZ0b9KpDM12xdsp4yBGp {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 8px;\n\tmargin-bottom: 16px;\n}\n\n._2vaCly52hHyANmzRLlQgvc {\n\tmargin-top: 8px;\n\tdisplay: table-cell;\n\twidth: 1px;\n}\n\n._2P23QxvP4gCNvjxnRGGLyq {\n\tfloat: right;\n\tmargin-top: 12px;\n\tpadding-top: 1px;\n}\n", ""]); // Exports

        exports.locals = {
          "order": "_2lNDC03OkbapZFdz52EzCp",
          "order-octavius": "cqXmIArvr9yYmYT3nTeNr",
          "order-main": "E8xNgEGbBsUkiPoP1gh2a",
          "order-main-darkMode": "_2Iaghg9SYnHIGsrkZPUM6W",
          "order-main-image-block": "_1h2AHefzEpLKUtqDj4KRnT",
          "order-main-text-block": "RNPaaVDv8T2msGX0uv-rD",
          "order-main-image": "_1epOcryhJoS4YUsVTxnljU",
          "icon-button": "_1KpY7OiSWBOaKd4_5IOWNE",
          "header": "YGGrwQdUheQzkHTm9gBe4",
          "header-text": "zpEEDTVa_xAIXEtVM6k7I",
          "link": "SIWLUU42lKXiG7yR6tRW",
          "name": "_1r9cyy2k8howXBZljWDevL",
          "buttons-block": "_1jLZ0b9KpDM12xdsp4yBGp",
          "additional-info": "_2vaCly52hHyANmzRLlQgvc",
          "billing-info": "_2P23QxvP4gCNvjxnRGGLyq"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Mobile/Mobile.css":
      /*!****************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Mobile/Mobile.css ***!
        \****************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsMobileMobileCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._13h0Ny52Y8yYmzPO4yKigg {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 2px;\n\tpadding: 0 16px 16px;\n\tmargin-top: 12px;\n\tmargin-bottom: 8px;\n\tdisplay: table;\n\twidth: calc(100% - 32px);\n}\n\n._3rjot478ZKpKq53dbYdmSE {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 12px;\n\tpadding: 0 20px 16px;\n\tmargin-top: 12px;\n\tmargin-bottom: 10px;\n\tdisplay: table;\n\twidth: calc(100% - 40px);\n}\n\n.JOy53jGq6aIgtEK0FS3fE {\n\tbackground-color: rgba(255, 255, 255, .08);\n}\n\n._2J48yydV4WaMWHajfaljjq {\n\tfloat: left;\n\tmargin-right: 8px;\n\tmargin-top: -2px;\n\theight: 24px;\n\twidth: 24px;\n}\n\n.iBhU2Ad0x1dCKIf-oaCD3 {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 12px;\n}\n\n.z3CKP7Tgf4PS6JbK7bzFg {\n\tmargin-top: 6px;\n\tmargin-bottom: 12px;\n}\n\n.cwNft9En5cIvW1ekUoA7d {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-top: 12px;\n}\n\n._2paBaRSDk5OuVk22xDGbkq {\n\tmargin-left: auto;\n\tpadding-top: 1px;\n}\n", ""]); // Exports

        exports.locals = {
          "main": "_13h0Ny52Y8yYmzPO4yKigg",
          "main-octavius": "_3rjot478ZKpKq53dbYdmSE",
          "main-octavius-darkMode": "JOy53jGq6aIgtEK0FS3fE",
          "icon": "_2J48yydV4WaMWHajfaljjq",
          "header": "iBhU2Ad0x1dCKIf-oaCD3",
          "info": "z3CKP7Tgf4PS6JbK7bzFg",
          "buttons-block": "cwNft9En5cIvW1ekUoA7d",
          "billing-info": "_2paBaRSDk5OuVk22xDGbkq"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Moneta/Body/Body.css":
      /*!*******************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Moneta/Body/Body.css ***!
        \*******************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsMonetaBodyBodyCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._1_9qEUE8z6XiIUxP7EKewp {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._86ktauiLES3JWZDr6g73t {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3zAHrU15Wp-gHBMoO5p1Ue {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.c7jCkbGBoo6bskn-1hBM1 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3MglQEb1Uv0647anMIzIJj {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._32uH31bYCU0GCdbwsjc7e4 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3h_NhFqIFAdvSbKh1cP2xk {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3G5f5DqG-rxGlx9JdDrkzG {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2t-XUnNKB8gXL1SdJ5D6V6 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._2t-XUnNKB8gXL1SdJ5D6V6 {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._3vbbbZskE4RZ_OaFAOgCQd {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._3vbbbZskE4RZ_OaFAOgCQd {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.T7UjwFDupm055eoEZN56a {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.T7UjwFDupm055eoEZN56a {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._1OvWVqEjIPW-tRbqqStenV {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1OvWVqEjIPW-tRbqqStenV {\n\t\tfont-weight: 400;\n\t}\n}\n._22lPGs5xnyAhlwhPyosIN7 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._22lPGs5xnyAhlwhPyosIN7 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1e9kwAGhPPE0BioYszbEV9 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._1Spdr_BbzncdzLyRyjfqf- {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._11c57ZH-OMV9kAaXN9jmgK {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._11c57ZH-OMV9kAaXN9jmgK {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._3qyiD3YHuV980dlsmB8vMm {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._3qyiD3YHuV980dlsmB8vMm {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._3o4VHaA6b5xMEnvZZHDrsR {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2HwJVo0zQ8xDM13CxT9Y-Z {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._10825USp0M73jSzsj5PnMy {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1HmM6UW3nUxZ6bxJbc_gi1 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2QMd8xhbMlC03Bo0z1z31q {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._32OeIvmNhLE-rouec_ByT- {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3Guoptw2SZUvr7dJAqUj8N {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3Q2yXTEzY9_QzJXHLdpURo {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.gRvLUaDVydX-f2jh1n0WJ {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t.gRvLUaDVydX-f2jh1n0WJ {\n\t\tfont-size: 15px;\n\t}\n}\n._9hVE-g5CBJCj0mvWLpL10 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1wDJ4uarINN3eJif0Fvv8b {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n._1_9qEUE8z6XiIUxP7EKewp {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._86ktauiLES3JWZDr6g73t {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3zAHrU15Wp-gHBMoO5p1Ue {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.c7jCkbGBoo6bskn-1hBM1 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3MglQEb1Uv0647anMIzIJj {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._32uH31bYCU0GCdbwsjc7e4 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3h_NhFqIFAdvSbKh1cP2xk {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3G5f5DqG-rxGlx9JdDrkzG {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2t-XUnNKB8gXL1SdJ5D6V6 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._2t-XUnNKB8gXL1SdJ5D6V6 {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._3vbbbZskE4RZ_OaFAOgCQd {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._3vbbbZskE4RZ_OaFAOgCQd {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.T7UjwFDupm055eoEZN56a {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.T7UjwFDupm055eoEZN56a {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._1OvWVqEjIPW-tRbqqStenV {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1OvWVqEjIPW-tRbqqStenV {\n\t\tfont-weight: 400;\n\t}\n}\n._22lPGs5xnyAhlwhPyosIN7 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._22lPGs5xnyAhlwhPyosIN7 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1e9kwAGhPPE0BioYszbEV9 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1e9kwAGhPPE0BioYszbEV9 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1Spdr_BbzncdzLyRyjfqf- {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1Spdr_BbzncdzLyRyjfqf- {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._11c57ZH-OMV9kAaXN9jmgK {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3qyiD3YHuV980dlsmB8vMm {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n._3o4VHaA6b5xMEnvZZHDrsR {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2HwJVo0zQ8xDM13CxT9Y-Z {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._10825USp0M73jSzsj5PnMy {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1HmM6UW3nUxZ6bxJbc_gi1 {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1HmM6UW3nUxZ6bxJbc_gi1 {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n._2QMd8xhbMlC03Bo0z1z31q {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._32OeIvmNhLE-rouec_ByT- {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3Guoptw2SZUvr7dJAqUj8N {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3Q2yXTEzY9_QzJXHLdpURo {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.gRvLUaDVydX-f2jh1n0WJ {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t.gRvLUaDVydX-f2jh1n0WJ {\n\t\tfont-size: 15px;\n\t}\n}\n._9hVE-g5CBJCj0mvWLpL10 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1wDJ4uarINN3eJif0Fvv8b {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n._16l2zr4bY1vMGJWi4xSiOe {\n\tpadding-top: 12px;\n\tpadding-bottom: 16px;\n}\n._3i3MkckF8Q19u7hdlkMVJT {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmargin-bottom: 12px;\n}\n.xjL2_2PRLELrPEQOwP1G6 {\n\twidth: 120px;\n\tmargin-right: 16px;\n}\n._3BDpdzFmUIM4E1sOcpSU5c {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n}\n._3BDpdzFmUIM4E1sOcpSU5c svg {\n\tfill: #333333 !important;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "_1_9qEUE8z6XiIUxP7EKewp",
          "font-size2": "_86ktauiLES3JWZDr6g73t",
          "font-size3": "_3zAHrU15Wp-gHBMoO5p1Ue",
          "font-size4": "c7jCkbGBoo6bskn-1hBM1",
          "font-size5": "_3MglQEb1Uv0647anMIzIJj",
          "font-size6": "_32uH31bYCU0GCdbwsjc7e4",
          "font-size7": "_3h_NhFqIFAdvSbKh1cP2xk",
          "font-size8": "_3G5f5DqG-rxGlx9JdDrkzG",
          "font-h0": "_2t-XUnNKB8gXL1SdJ5D6V6",
          "font-h1": "_3vbbbZskE4RZ_OaFAOgCQd",
          "font-h2": "T7UjwFDupm055eoEZN56a",
          "font-h3": "_1OvWVqEjIPW-tRbqqStenV",
          "font-h4": "_22lPGs5xnyAhlwhPyosIN7",
          "font-h5": "_1e9kwAGhPPE0BioYszbEV9",
          "font-h6": "_1Spdr_BbzncdzLyRyjfqf-",
          "font-body": "_11c57ZH-OMV9kAaXN9jmgK",
          "font-paragraph": "_3qyiD3YHuV980dlsmB8vMm",
          "font-list": "_3o4VHaA6b5xMEnvZZHDrsR",
          "font-list-item": "_2HwJVo0zQ8xDM13CxT9Y-Z",
          "font-footnote": "_10825USp0M73jSzsj5PnMy",
          "font-lead": "_1HmM6UW3nUxZ6bxJbc_gi1",
          "font-quote": "_2QMd8xhbMlC03Bo0z1z31q",
          "font-table-header": "_32OeIvmNhLE-rouec_ByT-",
          "font-control": "_3Guoptw2SZUvr7dJAqUj8N",
          "font-control-label": "_3Q2yXTEzY9_QzJXHLdpURo",
          "font-tab": "gRvLUaDVydX-f2jh1n0WJ",
          "font-badge": "_9hVE-g5CBJCj0mvWLpL10",
          "font-disclaimer": "_1wDJ4uarINN3eJif0Fvv8b",
          "body": "_16l2zr4bY1vMGJWi4xSiOe",
          "paymentInfoElement": "_3i3MkckF8Q19u7hdlkMVJT",
          "label": "xjL2_2PRLELrPEQOwP1G6",
          "buttonBlock": "_3BDpdzFmUIM4E1sOcpSU5c"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Moneta/Footer/Footer.css":
      /*!***********************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Moneta/Footer/Footer.css ***!
        \***********************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsMonetaFooterFooterCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._5sIMTCmEz-z1UfwGaG8nk {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.qua250SQT1dnySjkypwoQ {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.pi3O-946bJnE9iOVMe12d {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3Hqhp3iTqks76MxWrrgiAC {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._27_03fb2a0rIKCAuOYH8F0 {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2Tmcg2zARROt4LaN4SER4l {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._lYGNlYKsINDSTCCJkF21 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1nP146pXBiL06_Hw8qhkwZ {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2o4yJe-rfKjkwvOvlkWFIb {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._2o4yJe-rfKjkwvOvlkWFIb {\n\t\tmargin-bottom: 24px;\n\t}\n}\n.NT069asDYqHeao-ohF1oE {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t.NT069asDYqHeao-ohF1oE {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._2axJ1GHpt2-TKQoW88gY-0 {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2axJ1GHpt2-TKQoW88gY-0 {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n.godv_dSy7OHEo4cZ-BX-F {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.godv_dSy7OHEo4cZ-BX-F {\n\t\tfont-weight: 400;\n\t}\n}\n.oT7A9XBUolBH5v1gyWSe1 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.oT7A9XBUolBH5v1gyWSe1 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1cCIRYA7ULo9uy_YF_35F3 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._3B5pCPCCUQVQzjB7TPk8W4 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._3Hs01H0LKQGddsjuSW9JHw {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._3Hs01H0LKQGddsjuSW9JHw {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._3tPLdN7t-tDnlvpSx_mdZJ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._3tPLdN7t-tDnlvpSx_mdZJ {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.Xz0pzVK8pKVm2mxD1P2wW {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3zep5RLJqxqAF0dVgX6J5v {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.Xl2cVGt2kH1eSiuGHsfO1 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._11bKOhWUZ9XTixqtJRXxtQ {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2u-ecuWiZNCBDpwwvK8_Vj {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3-z5_ow0XaCO6AtAfOP263 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1KxPD4qUocF5RQxy1MJQ_N {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3PD8iFsDYSIYOnYwD-pn6- {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._30gkWEfLcFoS2abrAPCqB7 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._30gkWEfLcFoS2abrAPCqB7 {\n\t\tfont-size: 15px;\n\t}\n}\n._2JzFPvlE41hR4CucIyG_dk {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._2RQ2W1vaSz57sWN88p3_NZ {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n._5sIMTCmEz-z1UfwGaG8nk {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.qua250SQT1dnySjkypwoQ {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.pi3O-946bJnE9iOVMe12d {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3Hqhp3iTqks76MxWrrgiAC {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._27_03fb2a0rIKCAuOYH8F0 {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2Tmcg2zARROt4LaN4SER4l {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._lYGNlYKsINDSTCCJkF21 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1nP146pXBiL06_Hw8qhkwZ {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2o4yJe-rfKjkwvOvlkWFIb {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._2o4yJe-rfKjkwvOvlkWFIb {\n\t\tmargin-bottom: 24px;\n\t}\n}\n.NT069asDYqHeao-ohF1oE {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t.NT069asDYqHeao-ohF1oE {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._2axJ1GHpt2-TKQoW88gY-0 {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2axJ1GHpt2-TKQoW88gY-0 {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n.godv_dSy7OHEo4cZ-BX-F {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.godv_dSy7OHEo4cZ-BX-F {\n\t\tfont-weight: 400;\n\t}\n}\n.oT7A9XBUolBH5v1gyWSe1 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.oT7A9XBUolBH5v1gyWSe1 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1cCIRYA7ULo9uy_YF_35F3 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._1cCIRYA7ULo9uy_YF_35F3 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._3B5pCPCCUQVQzjB7TPk8W4 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3B5pCPCCUQVQzjB7TPk8W4 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._3Hs01H0LKQGddsjuSW9JHw {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3tPLdN7t-tDnlvpSx_mdZJ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n.Xz0pzVK8pKVm2mxD1P2wW {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3zep5RLJqxqAF0dVgX6J5v {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.Xl2cVGt2kH1eSiuGHsfO1 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._11bKOhWUZ9XTixqtJRXxtQ {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._11bKOhWUZ9XTixqtJRXxtQ {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n._2u-ecuWiZNCBDpwwvK8_Vj {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3-z5_ow0XaCO6AtAfOP263 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1KxPD4qUocF5RQxy1MJQ_N {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3PD8iFsDYSIYOnYwD-pn6- {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._30gkWEfLcFoS2abrAPCqB7 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._30gkWEfLcFoS2abrAPCqB7 {\n\t\tfont-size: 15px;\n\t}\n}\n._2JzFPvlE41hR4CucIyG_dk {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._2RQ2W1vaSz57sWN88p3_NZ {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n._3MUhJrqATZ5a5IEPWRcR1o {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\tpadding-top: 12px;\n\tborder-top-style: solid;\n\tborder-top-width: 1px;\n\tborder-top-color: rgba(0, 16, 61, .12);\n}\n._188QLcpyWD8pu1CpATlEdm {\n\tmargin-right: 6px;\n\tmargin-left: 12px;\n}\n._1e44FkgBeWYo_4VdmhS9c- a {\n\tcolor: #005ff9 !important;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "_5sIMTCmEz-z1UfwGaG8nk",
          "font-size2": "qua250SQT1dnySjkypwoQ",
          "font-size3": "pi3O-946bJnE9iOVMe12d",
          "font-size4": "_3Hqhp3iTqks76MxWrrgiAC",
          "font-size5": "_27_03fb2a0rIKCAuOYH8F0",
          "font-size6": "_2Tmcg2zARROt4LaN4SER4l",
          "font-size7": "_lYGNlYKsINDSTCCJkF21",
          "font-size8": "_1nP146pXBiL06_Hw8qhkwZ",
          "font-h0": "_2o4yJe-rfKjkwvOvlkWFIb",
          "font-h1": "NT069asDYqHeao-ohF1oE",
          "font-h2": "_2axJ1GHpt2-TKQoW88gY-0",
          "font-h3": "godv_dSy7OHEo4cZ-BX-F",
          "font-h4": "oT7A9XBUolBH5v1gyWSe1",
          "font-h5": "_1cCIRYA7ULo9uy_YF_35F3",
          "font-h6": "_3B5pCPCCUQVQzjB7TPk8W4",
          "font-body": "_3Hs01H0LKQGddsjuSW9JHw",
          "font-paragraph": "_3tPLdN7t-tDnlvpSx_mdZJ",
          "font-list": "Xz0pzVK8pKVm2mxD1P2wW",
          "font-list-item": "_3zep5RLJqxqAF0dVgX6J5v",
          "font-footnote": "Xl2cVGt2kH1eSiuGHsfO1",
          "font-lead": "_11bKOhWUZ9XTixqtJRXxtQ",
          "font-quote": "_2u-ecuWiZNCBDpwwvK8_Vj",
          "font-table-header": "_3-z5_ow0XaCO6AtAfOP263",
          "font-control": "_1KxPD4qUocF5RQxy1MJQ_N",
          "font-control-label": "_3PD8iFsDYSIYOnYwD-pn6-",
          "font-tab": "_30gkWEfLcFoS2abrAPCqB7",
          "font-badge": "_2JzFPvlE41hR4CucIyG_dk",
          "font-disclaimer": "_2RQ2W1vaSz57sWN88p3_NZ",
          "footer": "_3MUhJrqATZ5a5IEPWRcR1o",
          "mainText": "_188QLcpyWD8pu1CpATlEdm",
          "paymentCenterLink": "_1e44FkgBeWYo_4VdmhS9c-"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Moneta/Header/Header.css":
      /*!***********************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Moneta/Header/Header.css ***!
        \***********************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsMonetaHeaderHeaderCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, ".JocDgedFkmx17ito-ZhZ_ {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.AjUvIckNxS3CQ0pNcAqle {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._8WLIPmqb8Ajv5LchKVzJ6 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2_3RD6zPUaI_bVtU9zN6sF {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1CgdfP1kYaetuR2d8itm3M {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2K9k6AIS2e2mdknetjyr_Q {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1FATdgU_ITEHzvnVId0qaB {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.eG8jnV0cvKAjhghObR4Tq {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1CJ3a9I4H_eQXMMUDr_QR4 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._1CJ3a9I4H_eQXMMUDr_QR4 {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._3Q15RV8Bz1LgVEQxyCT_22 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._3Q15RV8Bz1LgVEQxyCT_22 {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._3CLn0GfufPCx-TpAJwCkd_ {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3CLn0GfufPCx-TpAJwCkd_ {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._29Qe1B3kQc3_i2O-GD8r3t {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._29Qe1B3kQc3_i2O-GD8r3t {\n\t\tfont-weight: 400;\n\t}\n}\n._3itEjFxDuI9Oa-eqfeLVTR {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3itEjFxDuI9Oa-eqfeLVTR {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.TptWaGGxvIiylwf_E4tSD {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._12xhKCSFvH2cvDdXt0A7Jk {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._1yuJxP6YTWmbNhSXz0UMyr {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._1yuJxP6YTWmbNhSXz0UMyr {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n._3VOQ9EiQ4bswR9h-cK-xVl {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t._3VOQ9EiQ4bswR9h-cK-xVl {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1FBi8wcLvXY2HcJ8fSmiGh {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3cfXadphd9sFyLSwyL8EPB {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1jGErOvDJY1uKIHdDuRLU0 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._34_4BWHfaZJJ8j40xXI53E {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2HuaGdIaOzsk7Jpi8-nRis {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1ShZciu35PMbCDxZOraOGL {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.Lk0Mhqx30bzK8SiNoHreQ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2kQ5ChtzN4b9nqLe2sUlMt {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3mvhUFhMxULcy6cJfwcnaF {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._3mvhUFhMxULcy6cJfwcnaF {\n\t\tfont-size: 15px;\n\t}\n}\n.yWHjDvmA8XiAYVjZQ8vkf {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1NbZK3zklvA12ZjqP5J0H3 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n.JocDgedFkmx17ito-ZhZ_ {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.AjUvIckNxS3CQ0pNcAqle {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._8WLIPmqb8Ajv5LchKVzJ6 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2_3RD6zPUaI_bVtU9zN6sF {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1CgdfP1kYaetuR2d8itm3M {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2K9k6AIS2e2mdknetjyr_Q {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1FATdgU_ITEHzvnVId0qaB {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.eG8jnV0cvKAjhghObR4Tq {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1CJ3a9I4H_eQXMMUDr_QR4 {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._1CJ3a9I4H_eQXMMUDr_QR4 {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._3Q15RV8Bz1LgVEQxyCT_22 {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._3Q15RV8Bz1LgVEQxyCT_22 {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._3CLn0GfufPCx-TpAJwCkd_ {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3CLn0GfufPCx-TpAJwCkd_ {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._29Qe1B3kQc3_i2O-GD8r3t {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._29Qe1B3kQc3_i2O-GD8r3t {\n\t\tfont-weight: 400;\n\t}\n}\n._3itEjFxDuI9Oa-eqfeLVTR {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3itEjFxDuI9Oa-eqfeLVTR {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.TptWaGGxvIiylwf_E4tSD {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t.TptWaGGxvIiylwf_E4tSD {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._12xhKCSFvH2cvDdXt0A7Jk {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._12xhKCSFvH2cvDdXt0A7Jk {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._1yuJxP6YTWmbNhSXz0UMyr {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3VOQ9EiQ4bswR9h-cK-xVl {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n._1FBi8wcLvXY2HcJ8fSmiGh {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3cfXadphd9sFyLSwyL8EPB {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1jGErOvDJY1uKIHdDuRLU0 {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._34_4BWHfaZJJ8j40xXI53E {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._34_4BWHfaZJJ8j40xXI53E {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n._2HuaGdIaOzsk7Jpi8-nRis {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1ShZciu35PMbCDxZOraOGL {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.Lk0Mhqx30bzK8SiNoHreQ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2kQ5ChtzN4b9nqLe2sUlMt {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3mvhUFhMxULcy6cJfwcnaF {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._3mvhUFhMxULcy6cJfwcnaF {\n\t\tfont-size: 15px;\n\t}\n}\n.yWHjDvmA8XiAYVjZQ8vkf {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._1NbZK3zklvA12ZjqP5J0H3 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n._1KWYFzGbR7GQqzGK-k7t4m {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: justify;\n\t    -ms-flex-pack: justify;\n\t        justify-content: space-between;\n\tpadding-top: 12px;\n\tborder-bottom-style: solid;\n\tborder-bottom-width: 1px;\n\tborder-bottom-color: rgba(0, 16, 61, .12);\n}\n.zK9O6UlNC8-x77OdZPLOE {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\twhite-space: nowrap;\n\tmargin-right: 16px;\n}\n.EyjyWU6DSpNTQPDRYKnW3 {\n\tmargin-right: 14px;\n}\n.EyjyWU6DSpNTQPDRYKnW3 svg {\n\tfill: #28c75d;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n}\n._2GJl9NhPjoWgh_PZHryOCa div {\n\tmargin-bottom: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "JocDgedFkmx17ito-ZhZ_",
          "font-size2": "AjUvIckNxS3CQ0pNcAqle",
          "font-size3": "_8WLIPmqb8Ajv5LchKVzJ6",
          "font-size4": "_2_3RD6zPUaI_bVtU9zN6sF",
          "font-size5": "_1CgdfP1kYaetuR2d8itm3M",
          "font-size6": "_2K9k6AIS2e2mdknetjyr_Q",
          "font-size7": "_1FATdgU_ITEHzvnVId0qaB",
          "font-size8": "eG8jnV0cvKAjhghObR4Tq",
          "font-h0": "_1CJ3a9I4H_eQXMMUDr_QR4",
          "font-h1": "_3Q15RV8Bz1LgVEQxyCT_22",
          "font-h2": "_3CLn0GfufPCx-TpAJwCkd_",
          "font-h3": "_29Qe1B3kQc3_i2O-GD8r3t",
          "font-h4": "_3itEjFxDuI9Oa-eqfeLVTR",
          "font-h5": "TptWaGGxvIiylwf_E4tSD",
          "font-h6": "_12xhKCSFvH2cvDdXt0A7Jk",
          "font-body": "_1yuJxP6YTWmbNhSXz0UMyr",
          "font-paragraph": "_3VOQ9EiQ4bswR9h-cK-xVl",
          "font-list": "_1FBi8wcLvXY2HcJ8fSmiGh",
          "font-list-item": "_3cfXadphd9sFyLSwyL8EPB",
          "font-footnote": "_1jGErOvDJY1uKIHdDuRLU0",
          "font-lead": "_34_4BWHfaZJJ8j40xXI53E",
          "font-quote": "_2HuaGdIaOzsk7Jpi8-nRis",
          "font-table-header": "_1ShZciu35PMbCDxZOraOGL",
          "font-control": "Lk0Mhqx30bzK8SiNoHreQ",
          "font-control-label": "_2kQ5ChtzN4b9nqLe2sUlMt",
          "font-tab": "_3mvhUFhMxULcy6cJfwcnaF",
          "font-badge": "yWHjDvmA8XiAYVjZQ8vkf",
          "font-disclaimer": "_1NbZK3zklvA12ZjqP5J0H3",
          "header": "_1KWYFzGbR7GQqzGK-k7t4m",
          "amountBlock": "zK9O6UlNC8-x77OdZPLOE",
          "icon": "EyjyWU6DSpNTQPDRYKnW3",
          "status": "_2GJl9NhPjoWgh_PZHryOCa"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Moneta/Moneta.css":
      /*!****************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Moneta/Moneta.css ***!
        \****************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsMonetaMonetaCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._1bTWxE5x9edTrvgkTBkdsh {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.AlymUA-3mkWJvo0JOsxlK {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.vEIAVnZCxJ2gwq4jUpY5_ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._9iFEYaueMV2Kbbs6iVyWe {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3UkJx53wMMsAD2n1S72EVb {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2KGT4AhE0-sNDvc4v96UTo {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.X--0i92kHvltn0OJFaWkZ {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.PkqyZjS-5YvReuxCKx-AT {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3IZdy9ecRufrTA1Pwnwqii {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._3IZdy9ecRufrTA1Pwnwqii {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._12ZwBI4_bgsETtwb3_f1dJ {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._12ZwBI4_bgsETtwb3_f1dJ {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._3MblYIBzttafrextjXeet3 {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3MblYIBzttafrextjXeet3 {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._3urklaZ6YyfQQLpTlLCI2I {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3urklaZ6YyfQQLpTlLCI2I {\n\t\tfont-weight: 400;\n\t}\n}\n._3Us5mT1LOeaiBMQwP8MjBY {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3Us5mT1LOeaiBMQwP8MjBY {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2bfK_9MqsLPVUefdkiWrqb {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._36RvT2xkzk747szlim5NgB {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 8px;\n}\n._39M_5uiD-1AmI33W9myE4n {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._39M_5uiD-1AmI33W9myE4n {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n}\n.PJPhG6wEp14XLX58k2d20 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n@media (min-width: 768px) {\n\t.PJPhG6wEp14XLX58k2d20 {\n\t\tmargin-bottom: 8px;\n\t}\n}\n.IzlucY5GIYuWHwSa3lGZc {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3E2NTmifJlpN8WHKo5iXVp {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.J4eW9_N-Vvvl3aBh8n33_ {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._22bX06cD3YyIm8vutVNiuI {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1PJGKTLn_9JA8p9keVbIFl {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1VqWy7mc8lgAd6HbVXvR5X {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._4wHF6q0phwuvoDku34KGP {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.NT_a9ElxsLRwoYROK5bEO {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3G6PFtbQIt7yZq1MLz8zTr {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._3G6PFtbQIt7yZq1MLz8zTr {\n\t\tfont-size: 15px;\n\t}\n}\n._2kQlBco2te-mDGL8OxCX_4 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._14wM41z9WnKbI17Tk-MC6U {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--font-size: 15px;\n\t\t--line-height: 20px;\n\t\t--size-control-height: 32px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 32px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 16px;\n\t\t--margin-control: 8px;\n\t\t--margin-form-field-vertical: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-tag: 4px;\n\t\t--margin-popup: 24px;\n\n\t}\n}\n._1bTWxE5x9edTrvgkTBkdsh {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.AlymUA-3mkWJvo0JOsxlK {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.vEIAVnZCxJ2gwq4jUpY5_ {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._9iFEYaueMV2Kbbs6iVyWe {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3UkJx53wMMsAD2n1S72EVb {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._2KGT4AhE0-sNDvc4v96UTo {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.X--0i92kHvltn0OJFaWkZ {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.PkqyZjS-5YvReuxCKx-AT {\n\tfont-size: 44px;\n\tline-height: 52px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3IZdy9ecRufrTA1Pwnwqii {\n\tfont-size: 32px;\n\tline-height: 40px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 20px;\n}\n@media (min-width: 768px) {\n\t._3IZdy9ecRufrTA1Pwnwqii {\n\t\tmargin-bottom: 24px;\n\t}\n}\n._12ZwBI4_bgsETtwb3_f1dJ {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 16px;\n}\n@media (min-width: 768px) {\n\t._12ZwBI4_bgsETtwb3_f1dJ {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 20px;\n\t}\n}\n._3MblYIBzttafrextjXeet3 {\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3MblYIBzttafrextjXeet3 {\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 16px;\n\t}\n}\n._3urklaZ6YyfQQLpTlLCI2I {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3urklaZ6YyfQQLpTlLCI2I {\n\t\tfont-weight: 400;\n\t}\n}\n._3Us5mT1LOeaiBMQwP8MjBY {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._3Us5mT1LOeaiBMQwP8MjBY {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._2bfK_9MqsLPVUefdkiWrqb {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._2bfK_9MqsLPVUefdkiWrqb {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._36RvT2xkzk747szlim5NgB {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 12px;\n}\n@media (min-width: 768px) {\n\t._36RvT2xkzk747szlim5NgB {\n\t\tmargin-bottom: 8px;\n\t}\n}\n._39M_5uiD-1AmI33W9myE4n {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.PJPhG6wEp14XLX58k2d20 {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tmargin-bottom: 24px;\n}\n.IzlucY5GIYuWHwSa3lGZc {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3E2NTmifJlpN8WHKo5iXVp {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.J4eW9_N-Vvvl3aBh8n33_ {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._22bX06cD3YyIm8vutVNiuI {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._22bX06cD3YyIm8vutVNiuI {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n}\n._1PJGKTLn_9JA8p9keVbIFl {\n\tfont-size: 17px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._1VqWy7mc8lgAd6HbVXvR5X {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._4wHF6q0phwuvoDku34KGP {\n\tfont-size: 15px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n.NT_a9ElxsLRwoYROK5bEO {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n._3G6PFtbQIt7yZq1MLz8zTr {\n\tfont-size: 13px;\n\tline-height: 20px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t._3G6PFtbQIt7yZq1MLz8zTr {\n\t\tfont-size: 15px;\n\t}\n}\n._2kQlBco2te-mDGL8OxCX_4 {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 700;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n._14wM41z9WnKbI17Tk-MC6U {\n\tfont-size: 11px;\n\tline-height: 12px;\n\tfont-weight: 400;\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n@media (min-width: 768px) {\n\t:root {\n\t\t--padding-base: 20px;\n\t\t--size-control-height: 40px;\n\t\t--size-control-button-width-min: 104px;\n\t\t--size-control-button-icon-width: 40px;\n\t\t--size-control-field-width-min: 380px;\n\t\t--padding-control-more-icon: 8px;\n\t\t--padding-control-button: 16px;\n\t\t--padding-control-button-icon: 20px;\n\t\t--margin-form-field-horizontal: 20px;\n\t\t--margin-icon: 8px;\n\t\t--margin-popup: 24px;\n\t\t--size-icon-u-i: 18px;\n\n\t}\n}\n._37eh815ugZE9ePwzqs8jvB {\n\tbackground-color: #f0f0f0;\n\tborder-radius: 12px;\n\tpadding: 0 16px 16px;\n\tmargin-top: 2px;\n\tmargin-bottom: 8px;\n\tdisplay: table;\n\twidth: calc(100% - 32px);\n}\n", ""]); // Exports

        exports.locals = {
          "font-size1": "_1bTWxE5x9edTrvgkTBkdsh",
          "font-size2": "AlymUA-3mkWJvo0JOsxlK",
          "font-size3": "vEIAVnZCxJ2gwq4jUpY5_",
          "font-size4": "_9iFEYaueMV2Kbbs6iVyWe",
          "font-size5": "_3UkJx53wMMsAD2n1S72EVb",
          "font-size6": "_2KGT4AhE0-sNDvc4v96UTo",
          "font-size7": "X--0i92kHvltn0OJFaWkZ",
          "font-size8": "PkqyZjS-5YvReuxCKx-AT",
          "font-h0": "_3IZdy9ecRufrTA1Pwnwqii",
          "font-h1": "_12ZwBI4_bgsETtwb3_f1dJ",
          "font-h2": "_3MblYIBzttafrextjXeet3",
          "font-h3": "_3urklaZ6YyfQQLpTlLCI2I",
          "font-h4": "_3Us5mT1LOeaiBMQwP8MjBY",
          "font-h5": "_2bfK_9MqsLPVUefdkiWrqb",
          "font-h6": "_36RvT2xkzk747szlim5NgB",
          "font-body": "_39M_5uiD-1AmI33W9myE4n",
          "font-paragraph": "PJPhG6wEp14XLX58k2d20",
          "font-list": "IzlucY5GIYuWHwSa3lGZc",
          "font-list-item": "_3E2NTmifJlpN8WHKo5iXVp",
          "font-footnote": "J4eW9_N-Vvvl3aBh8n33_",
          "font-lead": "_22bX06cD3YyIm8vutVNiuI",
          "font-quote": "_1PJGKTLn_9JA8p9keVbIFl",
          "font-table-header": "_1VqWy7mc8lgAd6HbVXvR5X",
          "font-control": "_4wHF6q0phwuvoDku34KGP",
          "font-control-label": "NT_a9ElxsLRwoYROK5bEO",
          "font-tab": "_3G6PFtbQIt7yZq1MLz8zTr",
          "font-badge": "_2kQlBco2te-mDGL8OxCX_4",
          "font-disclaimer": "_14wM41z9WnKbI17Tk-MC6U",
          "main": "_37eh815ugZE9ePwzqs8jvB"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Promotional/Promotional.css":
      /*!**************************************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/src!./src/components/Promotional/Promotional.css ***!
        \**************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesPostcssLoaderSrcIndexJsSrcComponentsPromotionalPromotionalCss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, "._2FyPsYtgTcE5_oCoWzvLiD {\n\tbackground-color: rgba(240, 240, 240, 1);\n\tborder-radius: 2px;\n\tpadding: 12px 20px 16px;\n\tmargin-top: 12px;\n\tmargin-bottom: 10px;\n}\n\n.ENNnsZW7zroE0NjYqpYtE {\n\tbackground-color: rgba(255, 255, 255, .08);\n}\n\n._3092OJXHojGFr2ntj5ZsE5 p {\n\tfont-weight: bold;\n}\n\n._1ONXjH5HK39gxOdisJHC1h {\n\theight: 100%;\n\tfloat: left;\n}\n\n._3C93uHXh9wZXHmpezwXvu5 {\n\tmargin-left: 64px;\n\tmargin-right: 24px;\n}\n\n._1AvmDfuMO_K2fUPsUI5pO5 {\n\tfloat: right;\n\tmargin-right: -8px;\n\tfill: #c7c7c7;\n\tcursor: pointer;\n}\n", ""]); // Exports

        exports.locals = {
          "promo": "_2FyPsYtgTcE5_oCoWzvLiD",
          "promo-darkMode": "ENNnsZW7zroE0NjYqpYtE",
          "bold": "_3092OJXHojGFr2ntj5ZsE5",
          "icon": "_1ONXjH5HK39gxOdisJHC1h",
          "content": "_3C93uHXh9wZXHmpezwXvu5",
          "closeIcon": "_1AvmDfuMO_K2fUPsUI5pO5"
        };
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/runtime/api.js":
      /*!*****************************************************!*\
        !*** ./node_modules/css-loader/dist/runtime/api.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistRuntimeApiJs(module, exports, __webpack_require__) {
        "use strict";
        /*
          MIT License http://www.opensource.org/licenses/mit-license.php
          Author Tobias Koppers @sokra
        */
        // css base code, injected by the css-loader

        module.exports = function (useSourceMap) {
          var list = []; // return the list of modules as css string

          list.toString = function toString() {
            return this.map(function (item) {
              var content = cssWithMappingToString(item, useSourceMap);

              if (item[2]) {
                return '@media ' + item[2] + '{' + content + '}';
              } else {
                return content;
              }
            }).join('');
          }; // import a list of modules into the list


          list.i = function (modules, mediaQuery) {
            if (typeof modules === 'string') {
              modules = [[null, modules, '']];
            }

            var alreadyImportedModules = {};

            for (var i = 0; i < this.length; i++) {
              var id = this[i][0];

              if (id != null) {
                alreadyImportedModules[id] = true;
              }
            }

            for (i = 0; i < modules.length; i++) {
              var item = modules[i]; // skip already imported module
              // this implementation is not 100% perfect for weird media query combinations
              // when a module is imported multiple times with different media queries.
              // I hope this will never occur (Hey this way we have smaller bundles)

              if (item[0] == null || !alreadyImportedModules[item[0]]) {
                if (mediaQuery && !item[2]) {
                  item[2] = mediaQuery;
                } else if (mediaQuery) {
                  item[2] = '(' + item[2] + ') and (' + mediaQuery + ')';
                }

                list.push(item);
              }
            }
          };

          return list;
        };

        function cssWithMappingToString(item, useSourceMap) {
          var content = item[1] || '';
          var cssMapping = item[3];

          if (!cssMapping) {
            return content;
          }

          if (useSourceMap && typeof btoa === 'function') {
            var sourceMapping = toComment(cssMapping);
            var sourceURLs = cssMapping.sources.map(function (source) {
              return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
            });
            return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
          }

          return [content].join('\n');
        } // Adapted from convert-source-map (MIT)


        function toComment(sourceMap) {
          // eslint-disable-next-line no-undef
          var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
          var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
          return '/*# ' + data + ' */';
        }
        /***/

      },

      /***/
      "./node_modules/css-vendor/dist/css-vendor.esm.js":
      /*!********************************************************!*\
        !*** ./node_modules/css-vendor/dist/css-vendor.esm.js ***!
        \********************************************************/

      /*! exports provided: default, prefix, supportedKeyframes, supportedProperty, supportedValue */

      /***/
      function node_modulesCssVendorDistCssVendorEsmJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "prefix", function () {
          return prefix;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "supportedKeyframes", function () {
          return supportedKeyframes;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "supportedProperty", function () {
          return supportedProperty;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "supportedValue", function () {
          return supportedValue;
        });
        /* harmony import */


        var is_in_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! is-in-browser */
        "./node_modules/is-in-browser/dist/module.js");
        /* harmony import */


        var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/esm/toConsumableArray */
        "./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"); // Export javascript style and css style vendor prefixes.


        var js = '';
        var css = '';
        var vendor = ''; // We should not do anything if required serverside.

        if (is_in_browser__WEBPACK_IMPORTED_MODULE_0__["default"]) {
          // Order matters. We need to check Webkit the last one because
          // other vendors use to add Webkit prefixes to some properties
          var jsCssMap = {
            Moz: '-moz-',
            ms: '-ms-',
            O: '-o-',
            Webkit: '-webkit-'
          };

          var _document$createEleme = document.createElement('p'),
              style = _document$createEleme.style;

          var testProp = 'Transform';

          for (var key in jsCssMap) {
            if (key + testProp in style) {
              js = key;
              css = jsCssMap[key];
              break;
            }
          } // Correctly detect the Edge browser.


          if (js === 'Webkit' && 'msHyphens' in style) {
            js = 'ms';
            css = jsCssMap.ms;
          } // Correctly detect the Safari browser.


          if (js === 'Webkit' && '-apple-trailing-word' in style) {
            vendor = 'apple';
          }
        }
        /**
         * Vendor prefix string for the current browser.
         *
         * @type {{js: String, css: String}}
         * @api public
         */


        var prefix = {
          js: js,
          css: css,
          vendor: vendor
        };
        /**
         * Test if a keyframe at-rule should be prefixed or not
         *
         * @param {String} vendor prefix string for the current browser.
         * @return {String}
         * @api public
         */

        function supportedKeyframes(key) {
          // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
          if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
          // https://caniuse.com/#search=keyframes

          if (prefix.js === 'ms') return key;
          return "@" + prefix.css + "keyframes" + key.substr(10);
        } // https://caniuse.com/#search=appearance


        var appearence = {
          noPrefill: ['appearance'],
          supportedProperty: function supportedProperty(prop) {
            if (prop !== 'appearance') return false;
            if (prefix.js === 'ms') return "-webkit-" + prop;
            return prefix.css + prop;
          }
        };
        var regExp = /[-\s]+(.)?/g;
        /**
         * Replaces the letter with the capital letter
         *
         * @param {String} match
         * @param {String} c
         * @return {String}
         * @api private
         */

        function toUpper(match, c) {
          return c ? c.toUpperCase() : '';
        }
        /**
         * Convert dash separated strings to camel-cased.
         *
         * @param {String} str
         * @return {String}
         * @api private
         */


        function camelize(str) {
          return str.replace(regExp, toUpper);
        }
        /**
         * Convert dash separated strings to pascal cased.
         *
         * @param {String} str
         * @return {String}
         * @api private
         */


        function pascalize(str) {
          return camelize("-" + str);
        } // https://caniuse.com/#search=multicolumn
        // https://github.com/postcss/autoprefixer/issues/491
        // https://github.com/postcss/autoprefixer/issues/177


        var breakPropsOld = {
          supportedProperty: function supportedProperty(prop, style) {
            if (!/^break-/.test(prop)) return false;

            if (prefix.js === 'Webkit') {
              var jsProp = "WebkitColumn" + pascalize(prop);
              return jsProp in style ? prefix.css + "column-" + prop : false;
            }

            if (prefix.js === 'Moz') {
              var _jsProp = "page" + pascalize(prop);

              return _jsProp in style ? "page-" + prop : false;
            }

            return false;
          }
        }; // https://caniuse.com/#feat=text-decoration

        var textDecorationSkipInk = {
          noPrefill: ['text-decoration-skip-ink'],
          supportedProperty: function supportedProperty(prop) {
            if (prop !== 'text-decoration-skip-ink') return false;
            if (prefix.vendor === 'apple') return "" + prefix.css + prop;
            if (prefix.js === 'Webkit' || prefix.js === 'Moz') return prop;
            return prefix.css + prop;
          }
        }; // https://caniuse.com/#search=color-adjust

        var colorAdjust = {
          noPrefill: ['color-adjust'],
          supportedProperty: function supportedProperty(prop) {
            if (prop !== 'color-adjust') return false;
            if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
            return prop;
          }
        };
        var propMap = {
          flex: 'box-flex',
          'flex-grow': 'box-flex',
          'flex-direction': ['box-orient', 'box-direction'],
          order: 'box-ordinal-group',
          'align-items': 'box-align',
          'flex-flow': ['box-orient', 'box-direction'],
          'justify-content': 'box-pack'
        };
        var propKeys = Object.keys(propMap);

        var prefixCss = function prefixCss(p) {
          return prefix.css + p;
        }; // Support old flex spec from 2009.


        var flex2009 = {
          supportedProperty: function supportedProperty(prop, style, _ref) {
            var multiple = _ref.multiple;

            if (propKeys.indexOf(prop) > -1) {
              var newProp = propMap[prop];

              if (!Array.isArray(newProp)) {
                return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
              }

              if (!multiple) return false;

              for (var i = 0; i < newProp.length; i++) {
                if (!(prefix.js + pascalize(newProp[0]) in style)) {
                  return false;
                }
              }

              return newProp.map(prefixCss);
            }

            return false;
          }
        };
        var propMap$1 = {
          'flex-grow': 'flex-positive',
          'flex-shrink': 'flex-negative',
          'flex-basis': 'flex-preferred-size',
          'justify-content': 'flex-pack',
          order: 'flex-order',
          'align-items': 'flex-align',
          'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
          // Support old flex spec from 2012.

        };
        var flex2012 = {
          supportedProperty: function supportedProperty(prop, style) {
            var newProp = propMap$1[prop];
            if (!newProp) return false;
            return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
          }
        }; // See https://github.com/postcss/autoprefixer/issues/324.

        var inlineLogicalOld = {
          supportedProperty: function supportedProperty(prop, style) {
            if (!/^(border|margin|padding)-inline/.test(prop)) return false;
            if (prefix.js === 'Moz') return prop;
            var newProp = prop.replace('-inline', '');
            return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
          }
        }; // but we can use a longhand property instead.
        // https://caniuse.com/#search=mask

        var mask = {
          noPrefill: ['mask'],
          supportedProperty: function supportedProperty(prop, style) {
            if (!/^mask/.test(prop)) return false;

            if (prefix.js === 'Webkit') {
              var longhand = 'mask-image';

              if (camelize(longhand) in style) {
                return prop;
              }

              if (prefix.js + pascalize(longhand) in style) {
                return prefix.css + prop;
              }
            }

            return prop;
          }
        };
        var prefixed = {
          supportedProperty: function supportedProperty(prop, style) {
            var pascalized = pascalize(prop);
            if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

            if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return prop;
            return false;
          }
        }; // https://caniuse.com/#search=scroll-snap

        var scrollSnap = {
          supportedProperty: function supportedProperty(prop) {
            if (prop.substring(0, 11) !== 'scroll-snap') return false;

            if (prefix.js === 'ms') {
              return "" + prefix.css + prop;
            }

            return prop;
          }
        }; // https://caniuse.com/#search=overscroll-behavior

        var overscrollBehavior = {
          supportedProperty: function supportedProperty(prop) {
            if (prop !== 'overscroll-behavior') return false;

            if (prefix.js === 'ms') {
              return prefix.css + "scroll-chaining";
            }

            return prop;
          }
        }; // https://caniuse.com/#search=transform

        var transform = {
          noPrefill: ['transform'],
          supportedProperty: function supportedProperty(prop, style, options) {
            if (prop !== 'transform') return false;

            if (options.transform) {
              return prop;
            }

            return prefix.css + prop;
          }
        }; // https://caniuse.com/#search=transition

        var transition = {
          noPrefill: ['transition'],
          supportedProperty: function supportedProperty(prop, style, options) {
            if (prop !== 'transition') return false;

            if (options.transition) {
              return prop;
            }

            return prefix.css + prop;
          }
        }; // Camelization is required because we can't test using.
        // CSS syntax for e.g. in FF.

        var unprefixed = {
          supportedProperty: function supportedProperty(prop, style) {
            return camelize(prop) in style ? prop : false;
          }
        }; // https://caniuse.com/#search=writing-mode

        var writingMode = {
          noPrefill: ['writing-mode'],
          supportedProperty: function supportedProperty(prop) {
            if (prop !== 'writing-mode') return false;

            if (prefix.js === 'Webkit' || prefix.js === 'ms') {
              return prefix.css + prop;
            }

            return prop;
          }
        }; // plugins = [
        //   ...plugins,
        //    breakPropsOld,
        //    inlineLogicalOld,
        //    unprefixed,
        //    prefixed,
        //    scrollSnap,
        //    flex2012,
        //    flex2009
        // ]
        // Plugins without 'noPrefill' value, going last.
        // 'flex-*' plugins should be at the bottom.
        // 'flex2009' going after 'flex2012'.
        // 'prefixed' going after 'unprefixed'

        var plugins = [appearence, transform, transition, mask, writingMode, colorAdjust, textDecorationSkipInk, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
        var propertyDetectors = plugins.filter(function (p) {
          return p.supportedProperty;
        }).map(function (p) {
          return p.supportedProperty;
        });
        var noPrefill = plugins.filter(function (p) {
          return p.noPrefill;
        }).reduce(function (a, p) {
          a.push.apply(a, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__["default"])(p.noPrefill));
          return a;
        }, []);
        var el;
        var cache = {};

        if (is_in_browser__WEBPACK_IMPORTED_MODULE_0__["default"]) {
          el = document.createElement('p'); // We test every property on vendor prefix requirement.
          // Once tested, result is cached. It gives us up to 70% perf boost.
          // http://jsperf.com/element-style-object-access-vs-plain-object
          //
          // Prefill cache with known css properties to reduce amount of
          // properties we need to feature test at runtime.
          // http://davidwalsh.name/vendor-prefix

          var computed = window.getComputedStyle(document.documentElement, '');

          for (var key$1 in computed) {
            // eslint-disable-next-line no-restricted-globals
            if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
          } // Properties that cannot be correctly detected using the
          // cache prefill method.


          noPrefill.forEach(function (x) {
            return delete cache[x];
          });
        }
        /**
         * Test if a property is supported, returns supported property with vendor
         * prefix if required. Returns `false` if not supported.
         *
         * @param {String} prop dash separated
         * @param {Object} [options]
         * @return {String|Boolean}
         * @api public
         */


        function supportedProperty(prop, options) {
          if (options === void 0) {
            options = {};
          } // For server-side rendering.


          if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

          if (true && cache[prop] != null) {
            return cache[prop];
          } // Check if 'transition' or 'transform' natively supported in browser.


          if (prop === 'transition' || prop === 'transform') {
            options[prop] = prop in el.style;
          } // Find a plugin for current prefix property.


          for (var i = 0; i < propertyDetectors.length; i++) {
            cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

            if (cache[prop]) break;
          } // Reset styles for current property.
          // Firefox can even throw an error for invalid properties, e.g., "0".


          try {
            el.style[prop] = '';
          } catch (err) {
            return false;
          }

          return cache[prop];
        }

        var cache$1 = {};
        var transitionProperties = {
          transition: 1,
          'transition-property': 1,
          '-webkit-transition': 1,
          '-webkit-transition-property': 1
        };
        var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
        var el$1;
        /**
         * Returns prefixed value transition/transform if needed.
         *
         * @param {String} match
         * @param {String} p1
         * @param {String} p2
         * @return {String}
         * @api private
         */

        function prefixTransitionCallback(match, p1, p2) {
          if (p1 === 'all') return 'all';
          if (p2 === 'all') return ', all';
          return p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
        }

        if (is_in_browser__WEBPACK_IMPORTED_MODULE_0__["default"]) el$1 = document.createElement('p');
        /**
         * Returns prefixed value if needed. Returns `false` if value is not supported.
         *
         * @param {String} property
         * @param {String} value
         * @return {String|Boolean}
         * @api public
         */

        function supportedValue(property, value) {
          // For server-side rendering.
          var prefixedValue = '';
          if (!el$1) return value; // It is a string or a number as a string like '1'.
          // We want only prefixable values here.
          // eslint-disable-next-line no-restricted-globals

          if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) {
            return value;
          } // Create cache key for current value.


          var cacheKey = property + value; // Remove cache for benchmark tests or return value from cache.

          if (true && cache$1[cacheKey] != null) {
            return cache$1[cacheKey];
          } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


          try {
            // Test value as it is.
            el$1.style[property] = value;
          } catch (err) {
            // Return false if value not supported.
            cache$1[cacheKey] = false;
            return false;
          } // If 'transition' or 'transition-property' property.


          if (transitionProperties[property]) {
            prefixedValue = value.replace(transPropsRegExp, prefixTransitionCallback);
          } else if (el$1.style[property] === '') {
            // Value with a vendor prefix.
            prefixedValue = prefix.css + value; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

            if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

            el$1.style[property] = prefixedValue; // Return false if value not supported.

            if (el$1.style[property] === '') {
              cache$1[cacheKey] = false;
              return false;
            }
          } // Reset styles for current property.


          el$1.style[property] = ''; // Write current value to cache.

          cache$1[cacheKey] = value;
          return cache$1[cacheKey];
        }
        /**
         * CSS Vendor prefix detection and property feature testing.
         *
         * @copyright Oleg Slobodskoi 2015
         * @website https://github.com/jsstyles/css-vendor
         * @license MIT
         */


        var index = {
          prefix: prefix,
          supportedKeyframes: supportedKeyframes,
          supportedProperty: supportedProperty,
          supportedValue: supportedValue
        };
        /* harmony default export */

        __webpack_exports__["default"] = index;
        /***/
      },

      /***/
      "./node_modules/decode-uri-component/index.js":
      /*!****************************************************!*\
        !*** ./node_modules/decode-uri-component/index.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesDecodeUriComponentIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var token = '%[a-f0-9]{2}';
        var singleMatcher = new RegExp(token, 'gi');
        var multiMatcher = new RegExp('(' + token + ')+', 'gi');

        function decodeComponents(components, split) {
          try {
            // Try to decode the entire string first
            return decodeURIComponent(components.join(''));
          } catch (err) {// Do nothing
          }

          if (components.length === 1) {
            return components;
          }

          split = split || 1; // Split the array in 2 parts

          var left = components.slice(0, split);
          var right = components.slice(split);
          return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
        }

        function decode(input) {
          try {
            return decodeURIComponent(input);
          } catch (err) {
            var tokens = input.match(singleMatcher);

            for (var i = 1; i < tokens.length; i++) {
              input = decodeComponents(tokens, i).join('');
              tokens = input.match(singleMatcher);
            }

            return input;
          }
        }

        function customDecodeURIComponent(input) {
          // Keep track of all the replacements and prefill the map with the `BOM`
          var replaceMap = {
            '%FE%FF': "\uFFFD\uFFFD",
            '%FF%FE': "\uFFFD\uFFFD"
          };
          var match = multiMatcher.exec(input);

          while (match) {
            try {
              // Decode as big chunks as possible
              replaceMap[match[0]] = decodeURIComponent(match[0]);
            } catch (err) {
              var result = decode(match[0]);

              if (result !== match[0]) {
                replaceMap[match[0]] = result;
              }
            }

            match = multiMatcher.exec(input);
          } // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else


          replaceMap['%C2'] = "\uFFFD";
          var entries = Object.keys(replaceMap);

          for (var i = 0; i < entries.length; i++) {
            // Replace all decoded components
            var key = entries[i];
            input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
          }

          return input;
        }

        module.exports = function (encodedURI) {
          if (typeof encodedURI !== 'string') {
            throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
          }

          try {
            encodedURI = encodedURI.replace(/\+/g, ' '); // Try the built in decoder first

            return decodeURIComponent(encodedURI);
          } catch (err) {
            // Fallback to a more advanced decoder
            return customDecodeURIComponent(encodedURI);
          }
        };
        /***/

      },

      /***/
      "./node_modules/deep-equal/index.js":
      /*!******************************************!*\
        !*** ./node_modules/deep-equal/index.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesDeepEqualIndexJs(module, exports, __webpack_require__) {
        var objectKeys = __webpack_require__(
        /*! object-keys */
        "./node_modules/object-keys/index.js");

        var isArguments = __webpack_require__(
        /*! is-arguments */
        "./node_modules/is-arguments/index.js");

        var is = __webpack_require__(
        /*! object-is */
        "./node_modules/object-is/index.js");

        var isRegex = __webpack_require__(
        /*! is-regex */
        "./node_modules/is-regex/index.js");

        var flags = __webpack_require__(
        /*! regexp.prototype.flags */
        "./node_modules/regexp.prototype.flags/index.js");

        var isDate = __webpack_require__(
        /*! is-date-object */
        "./node_modules/is-date-object/index.js");

        var getTime = Date.prototype.getTime;

        function deepEqual(actual, expected, options) {
          var opts = options || {}; // 7.1. All identical values are equivalent, as determined by ===.

          if (opts.strict ? is(actual, expected) : actual === expected) {
            return true;
          } // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.


          if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') {
            return opts.strict ? is(actual, expected) : actual == expected;
          }
          /*
           * 7.4. For all other Object pairs, including Array objects, equivalence is
           * determined by having the same number of owned properties (as verified
           * with Object.prototype.hasOwnProperty.call), the same set of keys
           * (although not necessarily the same order), equivalent values for every
           * corresponding key, and an identical 'prototype' property. Note: this
           * accounts for both named and indexed properties on Arrays.
           */
          // eslint-disable-next-line no-use-before-define


          return objEquiv(actual, expected, opts);
        }

        function isUndefinedOrNull(value) {
          return value === null || value === undefined;
        }

        function isBuffer(x) {
          if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
            return false;
          }

          if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
            return false;
          }

          if (x.length > 0 && typeof x[0] !== 'number') {
            return false;
          }

          return true;
        }

        function objEquiv(a, b, opts) {
          /* eslint max-statements: [2, 50] */
          var i, key;

          if (typeof a !== typeof b) {
            return false;
          }

          if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
            return false;
          } // an identical 'prototype' property.


          if (a.prototype !== b.prototype) {
            return false;
          }

          if (isArguments(a) !== isArguments(b)) {
            return false;
          }

          var aIsRegex = isRegex(a);
          var bIsRegex = isRegex(b);

          if (aIsRegex !== bIsRegex) {
            return false;
          }

          if (aIsRegex || bIsRegex) {
            return a.source === b.source && flags(a) === flags(b);
          }

          if (isDate(a) && isDate(b)) {
            return getTime.call(a) === getTime.call(b);
          }

          var aIsBuffer = isBuffer(a);
          var bIsBuffer = isBuffer(b);

          if (aIsBuffer !== bIsBuffer) {
            return false;
          }

          if (aIsBuffer || bIsBuffer) {
            // && would work too, because both are true or both false here
            if (a.length !== b.length) {
              return false;
            }

            for (i = 0; i < a.length; i++) {
              if (a[i] !== b[i]) {
                return false;
              }
            }

            return true;
          }

          if (typeof a !== typeof b) {
            return false;
          }

          try {
            var ka = objectKeys(a);
            var kb = objectKeys(b);
          } catch (e) {
            // happens when one is a string literal and the other isn't
            return false;
          } // having the same number of owned properties (keys incorporates hasOwnProperty)


          if (ka.length !== kb.length) {
            return false;
          } // the same set of keys (although not necessarily the same order),


          ka.sort();
          kb.sort(); // ~~~cheap key test

          for (i = ka.length - 1; i >= 0; i--) {
            if (ka[i] != kb[i]) {
              return false;
            }
          } // equivalent values for every corresponding key, and ~~~possibly expensive deep test


          for (i = ka.length - 1; i >= 0; i--) {
            key = ka[i];

            if (!deepEqual(a[key], b[key], opts)) {
              return false;
            }
          }

          return true;
        }

        module.exports = deepEqual;
        /***/
      },

      /***/
      "./node_modules/define-properties/index.js":
      /*!*************************************************!*\
        !*** ./node_modules/define-properties/index.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesDefinePropertiesIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var keys = __webpack_require__(
        /*! object-keys */
        "./node_modules/object-keys/index.js");

        var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
        var toStr = Object.prototype.toString;
        var concat = Array.prototype.concat;
        var origDefineProperty = Object.defineProperty;

        var isFunction = function isFunction(fn) {
          return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
        };

        var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
          var obj = {};

          try {
            origDefineProperty(obj, 'x', {
              enumerable: false,
              value: obj
            }); // eslint-disable-next-line no-unused-vars, no-restricted-syntax

            for (var _ in obj) {
              // jscs:ignore disallowUnusedVariables
              return false;
            }

            return obj.x === obj;
          } catch (e) {
            /* this is IE 8. */
            return false;
          }
        };

        var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

        var defineProperty = function defineProperty(object, name, value, predicate) {
          if (name in object && (!isFunction(predicate) || !predicate())) {
            return;
          }

          if (supportsDescriptors) {
            origDefineProperty(object, name, {
              configurable: true,
              enumerable: false,
              value: value,
              writable: true
            });
          } else {
            object[name] = value;
          }
        };

        var defineProperties = function defineProperties(object, map) {
          var predicates = arguments.length > 2 ? arguments[2] : {};
          var props = keys(map);

          if (hasSymbols) {
            props = concat.call(props, Object.getOwnPropertySymbols(map));
          }

          for (var i = 0; i < props.length; i += 1) {
            defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
          }
        };

        defineProperties.supportsDescriptors = !!supportsDescriptors;
        module.exports = defineProperties;
        /***/
      },

      /***/
      "./node_modules/es-abstract/GetIntrinsic.js":
      /*!**************************************************!*\
        !*** ./node_modules/es-abstract/GetIntrinsic.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesEsAbstractGetIntrinsicJs(module, exports, __webpack_require__) {
        "use strict";
        /* globals
        	Atomics,
        	SharedArrayBuffer,
        */

        var undefined;
        var $TypeError = TypeError;
        var $gOPD = Object.getOwnPropertyDescriptor;

        if ($gOPD) {
          try {
            $gOPD({}, '');
          } catch (e) {
            $gOPD = null; // this is IE 8, which has a broken gOPD
          }
        }

        var throwTypeError = function throwTypeError() {
          throw new $TypeError();
        };

        var ThrowTypeError = $gOPD ? function () {
          try {
            // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
            arguments.callee; // IE 8 does not throw here

            return throwTypeError;
          } catch (calleeThrows) {
            try {
              // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
              return $gOPD(arguments, 'callee').get;
            } catch (gOPDthrows) {
              return throwTypeError;
            }
          }
        }() : throwTypeError;

        var hasSymbols = __webpack_require__(
        /*! has-symbols */
        "./node_modules/has-symbols/index.js")();

        var getProto = Object.getPrototypeOf || function (x) {
          return x.__proto__;
        }; // eslint-disable-line no-proto


        var generator; // = function * () {};

        var generatorFunction = generator ? getProto(generator) : undefined;
        var asyncFn; // async function() {};

        var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
        var asyncGen; // async function * () {};

        var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
        var asyncGenIterator = asyncGen ? asyncGen() : undefined;
        var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
        var INTRINSICS = {
          '%Array%': Array,
          '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
          '%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
          '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
          '%ArrayPrototype%': Array.prototype,
          '%ArrayProto_entries%': Array.prototype.entries,
          '%ArrayProto_forEach%': Array.prototype.forEach,
          '%ArrayProto_keys%': Array.prototype.keys,
          '%ArrayProto_values%': Array.prototype.values,
          '%AsyncFromSyncIteratorPrototype%': undefined,
          '%AsyncFunction%': asyncFunction,
          '%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
          '%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
          '%AsyncGeneratorFunction%': asyncGenFunction,
          '%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
          '%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
          '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
          '%Boolean%': Boolean,
          '%BooleanPrototype%': Boolean.prototype,
          '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
          '%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
          '%Date%': Date,
          '%DatePrototype%': Date.prototype,
          '%decodeURI%': decodeURI,
          '%decodeURIComponent%': decodeURIComponent,
          '%encodeURI%': encodeURI,
          '%encodeURIComponent%': encodeURIComponent,
          '%Error%': Error,
          '%ErrorPrototype%': Error.prototype,
          '%eval%': eval,
          // eslint-disable-line no-eval
          '%EvalError%': EvalError,
          '%EvalErrorPrototype%': EvalError.prototype,
          '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
          '%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
          '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
          '%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
          '%Function%': Function,
          '%FunctionPrototype%': Function.prototype,
          '%Generator%': generator ? getProto(generator()) : undefined,
          '%GeneratorFunction%': generatorFunction,
          '%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
          '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
          '%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
          '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
          '%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
          '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
          '%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
          '%isFinite%': isFinite,
          '%isNaN%': isNaN,
          '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
          '%JSON%': typeof JSON === 'object' ? JSON : undefined,
          '%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
          '%Map%': typeof Map === 'undefined' ? undefined : Map,
          '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
          '%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
          '%Math%': Math,
          '%Number%': Number,
          '%NumberPrototype%': Number.prototype,
          '%Object%': Object,
          '%ObjectPrototype%': Object.prototype,
          '%ObjProto_toString%': Object.prototype.toString,
          '%ObjProto_valueOf%': Object.prototype.valueOf,
          '%parseFloat%': parseFloat,
          '%parseInt%': parseInt,
          '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
          '%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
          '%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
          '%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
          '%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
          '%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
          '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
          '%RangeError%': RangeError,
          '%RangeErrorPrototype%': RangeError.prototype,
          '%ReferenceError%': ReferenceError,
          '%ReferenceErrorPrototype%': ReferenceError.prototype,
          '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
          '%RegExp%': RegExp,
          '%RegExpPrototype%': RegExp.prototype,
          '%Set%': typeof Set === 'undefined' ? undefined : Set,
          '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
          '%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
          '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
          '%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
          '%String%': String,
          '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
          '%StringPrototype%': String.prototype,
          '%Symbol%': hasSymbols ? Symbol : undefined,
          '%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
          '%SyntaxError%': SyntaxError,
          '%SyntaxErrorPrototype%': SyntaxError.prototype,
          '%ThrowTypeError%': ThrowTypeError,
          '%TypedArray%': TypedArray,
          '%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
          '%TypeError%': $TypeError,
          '%TypeErrorPrototype%': $TypeError.prototype,
          '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
          '%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
          '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
          '%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
          '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
          '%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
          '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
          '%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
          '%URIError%': URIError,
          '%URIErrorPrototype%': URIError.prototype,
          '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
          '%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
          '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
          '%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
        };

        var bind = __webpack_require__(
        /*! function-bind */
        "./node_modules/function-bind/index.js");

        var $replace = bind.call(Function.call, String.prototype.replace);
        /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */

        var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
        var reEscapeChar = /\\(\\)?/g;
        /** Used to match backslashes in property paths. */

        var stringToPath = function stringToPath(string) {
          var result = [];
          $replace(string, rePropName, function (match, number, quote, subString) {
            result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
          });
          return result;
        };
        /* end adaptation */


        var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
          if (!(name in INTRINSICS)) {
            throw new SyntaxError('intrinsic ' + name + ' does not exist!');
          } // istanbul ignore if // hopefully this is impossible to test :-)


          if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
            throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
          }

          return INTRINSICS[name];
        };

        module.exports = function GetIntrinsic(name, allowMissing) {
          if (typeof name !== 'string' || name.length === 0) {
            throw new TypeError('intrinsic name must be a non-empty string');
          }

          if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
            throw new TypeError('"allowMissing" argument must be a boolean');
          }

          var parts = stringToPath(name);
          var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);

          for (var i = 1; i < parts.length; i += 1) {
            if (value != null) {
              if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, parts[i]);

                if (!allowMissing && !(parts[i] in value)) {
                  throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                }

                value = desc ? desc.get || desc.value : value[parts[i]];
              } else {
                value = value[parts[i]];
              }
            }
          }

          return value;
        };
        /***/

      },

      /***/
      "./node_modules/es-abstract/helpers/callBind.js":
      /*!******************************************************!*\
        !*** ./node_modules/es-abstract/helpers/callBind.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesEsAbstractHelpersCallBindJs(module, exports, __webpack_require__) {
        "use strict";

        var bind = __webpack_require__(
        /*! function-bind */
        "./node_modules/function-bind/index.js");

        var GetIntrinsic = __webpack_require__(
        /*! ../GetIntrinsic */
        "./node_modules/es-abstract/GetIntrinsic.js");

        var $apply = GetIntrinsic('%Function.prototype.apply%');
        var $call = GetIntrinsic('%Function.prototype.call%');
        var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

        module.exports = function callBind() {
          return $reflectApply(bind, $call, arguments);
        };

        module.exports.apply = function applyBind() {
          return $reflectApply(bind, $apply, arguments);
        };
        /***/

      },

      /***/
      "./node_modules/function-bind/implementation.js":
      /*!******************************************************!*\
        !*** ./node_modules/function-bind/implementation.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesFunctionBindImplementationJs(module, exports, __webpack_require__) {
        "use strict";
        /* eslint no-invalid-this: 1 */

        var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
        var slice = Array.prototype.slice;
        var toStr = Object.prototype.toString;
        var funcType = '[object Function]';

        module.exports = function bind(that) {
          var target = this;

          if (typeof target !== 'function' || toStr.call(target) !== funcType) {
            throw new TypeError(ERROR_MESSAGE + target);
          }

          var args = slice.call(arguments, 1);
          var bound;

          var binder = function binder() {
            if (this instanceof bound) {
              var result = target.apply(this, args.concat(slice.call(arguments)));

              if (Object(result) === result) {
                return result;
              }

              return this;
            } else {
              return target.apply(that, args.concat(slice.call(arguments)));
            }
          };

          var boundLength = Math.max(0, target.length - args.length);
          var boundArgs = [];

          for (var i = 0; i < boundLength; i++) {
            boundArgs.push('$' + i);
          }

          bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

          if (target.prototype) {
            var Empty = function Empty() {};

            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            Empty.prototype = null;
          }

          return bound;
        };
        /***/

      },

      /***/
      "./node_modules/function-bind/index.js":
      /*!*********************************************!*\
        !*** ./node_modules/function-bind/index.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesFunctionBindIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var implementation = __webpack_require__(
        /*! ./implementation */
        "./node_modules/function-bind/implementation.js");

        module.exports = Function.prototype.bind || implementation;
        /***/
      },

      /***/
      "./node_modules/gibdd.api/dist/api/fetchFines.js":
      /*!*******************************************************!*\
        !*** ./node_modules/gibdd.api/dist/api/fetchFines.js ***!
        \*******************************************************/

      /*! exports provided: fetchFines */

      /***/
      function node_modulesGibddApiDistApiFetchFinesJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "fetchFines", function () {
          return fetchFines;
        });
        /* harmony import */


        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! tslib */
        "./node_modules/tslib/tslib.es6.js");
        /* harmony import */


        var _tools_initializeAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../tools/initializeAxios */
        "./node_modules/gibdd.api/dist/tools/initializeAxios.js");
        /* harmony import */


        var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../constants */
        "./node_modules/gibdd.api/dist/constants.js"); // TODO: аналитика, xray в externals и в пиры


        var fetchFines = function fetchFines(params) {
          return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var response, error_1;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
              switch (_a.label) {
                case 0:
                  _a.trys.push([0, 2,, 3]);

                  return [4
                  /*yield*/
                  , _tools_initializeAxios__WEBPACK_IMPORTED_MODULE_1__["axios"].get(_constants__WEBPACK_IMPORTED_MODULE_2__["FINE_ENTITIES_URL"], {
                    params: params
                  })];

                case 1:
                  response = _a.sent();
                  return [2
                  /*return*/
                  , {
                    status: response ? response.status : 500,
                    fines: response.data.data || []
                  }];

                case 2:
                  error_1 = _a.sent();
                  console.error(error_1);
                  return [2
                  /*return*/
                  , {
                    status: 500,
                    fines: []
                  }];

                case 3:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        }; //# sourceMappingURL=fetchFines.js.map

        /***/

      },

      /***/
      "./node_modules/gibdd.api/dist/api/sendPaymentInProgress.js":
      /*!******************************************************************!*\
        !*** ./node_modules/gibdd.api/dist/api/sendPaymentInProgress.js ***!
        \******************************************************************/

      /*! exports provided: sendPaymentInProgress */

      /***/
      function node_modulesGibddApiDistApiSendPaymentInProgressJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "sendPaymentInProgress", function () {
          return sendPaymentInProgress;
        });
        /* harmony import */


        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! tslib */
        "./node_modules/tslib/tslib.es6.js");
        /* harmony import */


        var _tools_initializeAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../tools/initializeAxios */
        "./node_modules/gibdd.api/dist/tools/initializeAxios.js");
        /* harmony import */


        var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../constants */
        "./node_modules/gibdd.api/dist/constants.js"); // TODO: аналитика, xray в externals и в пиры


        var sendPaymentInProgress = function sendPaymentInProgress(resolutionNumber) {
          return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var url, response, error_1;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
              switch (_a.label) {
                case 0:
                  _a.trys.push([0, 2,, 3]);

                  url = "" + _constants__WEBPACK_IMPORTED_MODULE_2__["PAYMENT_IN_PROGRESS_URL"] + resolutionNumber;
                  return [4
                  /*yield*/
                  , _tools_initializeAxios__WEBPACK_IMPORTED_MODULE_1__["axios"].post(url)];

                case 1:
                  response = _a.sent();
                  return [2
                  /*return*/
                  , response];

                case 2:
                  error_1 = _a.sent();
                  console.error(error_1);
                  return [2
                  /*return*/
                  , null];

                case 3:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        }; //# sourceMappingURL=sendPaymentInProgress.js.map

        /***/

      },

      /***/
      "./node_modules/gibdd.api/dist/api/sendPaymentInProgressBatch.js":
      /*!***********************************************************************!*\
        !*** ./node_modules/gibdd.api/dist/api/sendPaymentInProgressBatch.js ***!
        \***********************************************************************/

      /*! exports provided: sendPaymentInProgressBatch */

      /***/
      function node_modulesGibddApiDistApiSendPaymentInProgressBatchJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "sendPaymentInProgressBatch", function () {
          return sendPaymentInProgressBatch;
        });
        /* harmony import */


        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! tslib */
        "./node_modules/tslib/tslib.es6.js");
        /* harmony import */


        var _tools_initializeAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../tools/initializeAxios */
        "./node_modules/gibdd.api/dist/tools/initializeAxios.js");
        /* harmony import */


        var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../constants */
        "./node_modules/gibdd.api/dist/constants.js"); // TODO: аналитика, xray в externals и в пиры


        var sendPaymentInProgressBatch = function sendPaymentInProgressBatch(resolutionNumbers) {
          return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var url, body, response, error_1;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
              switch (_a.label) {
                case 0:
                  _a.trys.push([0, 2,, 3]);

                  url = _constants__WEBPACK_IMPORTED_MODULE_2__["PAYMENT_IN_PROGRESS_URL"];
                  body = resolutionNumbers.map(function (number) {
                    return "resolution_number=" + number;
                  }).join('&');
                  return [4
                  /*yield*/
                  , _tools_initializeAxios__WEBPACK_IMPORTED_MODULE_1__["axios"].post(url, body, {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    }
                  })];

                case 1:
                  response = _a.sent();
                  return [2
                  /*return*/
                  , response];

                case 2:
                  error_1 = _a.sent();
                  console.error(error_1);
                  return [2
                  /*return*/
                  , null];

                case 3:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        }; //# sourceMappingURL=sendPaymentInProgressBatch.js.map

        /***/

      },

      /***/
      "./node_modules/gibdd.api/dist/constants.js":
      /*!**************************************************!*\
        !*** ./node_modules/gibdd.api/dist/constants.js ***!
        \**************************************************/

      /*! exports provided: GIBDD_BASE_URL, PAYMENT_IN_PROGRESS_URL, FINE_ENTITIES_URL */

      /***/
      function node_modulesGibddApiDistConstantsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "GIBDD_BASE_URL", function () {
          return GIBDD_BASE_URL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PAYMENT_IN_PROGRESS_URL", function () {
          return PAYMENT_IN_PROGRESS_URL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "FINE_ENTITIES_URL", function () {
          return FINE_ENTITIES_URL;
        });

        var GIBDD_BASE_URL = 'https://api.gibdd.mail.ru';
        var PAYMENT_IN_PROGRESS_URL = GIBDD_BASE_URL + "/payment/in_progress/";
        var FINE_ENTITIES_URL = GIBDD_BASE_URL + "/fine/entities/"; //# sourceMappingURL=constants.js.map

        /***/
      },

      /***/
      "./node_modules/gibdd.api/dist/index.js":
      /*!**********************************************!*\
        !*** ./node_modules/gibdd.api/dist/index.js ***!
        \**********************************************/

      /*! exports provided: fetchFines, sendPaymentInProgress, sendPaymentInProgressBatch, FinesList, filterUnpaidFines, filterPaidFines, countTotalAmountWithDiscount, getActualAmount, Status, mockGibddApi */

      /***/
      function node_modulesGibddApiDistIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _api_fetchFines__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./api/fetchFines */
        "./node_modules/gibdd.api/dist/api/fetchFines.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "fetchFines", function () {
          return _api_fetchFines__WEBPACK_IMPORTED_MODULE_0__["fetchFines"];
        });
        /* harmony import */


        var _api_sendPaymentInProgress__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./api/sendPaymentInProgress */
        "./node_modules/gibdd.api/dist/api/sendPaymentInProgress.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "sendPaymentInProgress", function () {
          return _api_sendPaymentInProgress__WEBPACK_IMPORTED_MODULE_1__["sendPaymentInProgress"];
        });
        /* harmony import */


        var _api_sendPaymentInProgressBatch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./api/sendPaymentInProgressBatch */
        "./node_modules/gibdd.api/dist/api/sendPaymentInProgressBatch.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "sendPaymentInProgressBatch", function () {
          return _api_sendPaymentInProgressBatch__WEBPACK_IMPORTED_MODULE_2__["sendPaymentInProgressBatch"];
        });
        /* harmony import */


        var _model_FinesList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./model/FinesList */
        "./node_modules/gibdd.api/dist/model/FinesList.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "FinesList", function () {
          return _model_FinesList__WEBPACK_IMPORTED_MODULE_3__["FinesList"];
        });
        /* harmony import */


        var _selectors_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./selectors/selectors */
        "./node_modules/gibdd.api/dist/selectors/selectors.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "filterUnpaidFines", function () {
          return _selectors_selectors__WEBPACK_IMPORTED_MODULE_4__["filterUnpaidFines"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "filterPaidFines", function () {
          return _selectors_selectors__WEBPACK_IMPORTED_MODULE_4__["filterPaidFines"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "countTotalAmountWithDiscount", function () {
          return _selectors_selectors__WEBPACK_IMPORTED_MODULE_4__["countTotalAmountWithDiscount"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "getActualAmount", function () {
          return _selectors_selectors__WEBPACK_IMPORTED_MODULE_4__["getActualAmount"];
        });
        /* harmony import */


        var _types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./types */
        "./node_modules/gibdd.api/dist/types/index.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Status", function () {
          return _types__WEBPACK_IMPORTED_MODULE_5__["Status"];
        });
        /* harmony import */


        var _tools_mockApiGibdd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./tools/mockApiGibdd */
        "./node_modules/gibdd.api/dist/tools/mockApiGibdd.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "mockGibddApi", function () {
          return _tools_mockApiGibdd__WEBPACK_IMPORTED_MODULE_6__["mockGibddApi"];
        }); //# sourceMappingURL=index.js.map

        /***/

      },

      /***/
      "./node_modules/gibdd.api/dist/model/FinesList.js":
      /*!********************************************************!*\
        !*** ./node_modules/gibdd.api/dist/model/FinesList.js ***!
        \********************************************************/

      /*! exports provided: FinesList */

      /***/
      function node_modulesGibddApiDistModelFinesListJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "FinesList", function () {
          return FinesList;
        });
        /* harmony import */


        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! tslib */
        "./node_modules/tslib/tslib.es6.js");
        /* harmony import */


        var mobx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! mobx */
        "./node_modules/mobx/lib/mobx.module.js");
        /* harmony import */


        var _selectors_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../selectors/selectors */
        "./node_modules/gibdd.api/dist/selectors/selectors.js");
        /* harmony import */


        var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../types */
        "./node_modules/gibdd.api/dist/types/index.js");
        /* harmony import */


        var _api_fetchFines__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ../api/fetchFines */
        "./node_modules/gibdd.api/dist/api/fetchFines.js");

        var FinesList =
        /** @class */
        function () {
          function FinesList() {
            this.fines = [];
            this.lastUpdate = Date.now();
            this.loading = false;
          }

          Object.defineProperty(FinesList.prototype, "unpaid", {
            get: function get() {
              return Object(_selectors_selectors__WEBPACK_IMPORTED_MODULE_2__["filterUnpaidFines"])(this.fines);
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(FinesList.prototype, "paid", {
            get: function get() {
              return Object(_selectors_selectors__WEBPACK_IMPORTED_MODULE_2__["filterPaidFines"])(this.fines);
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(FinesList.prototype, "totalAmountWithDiscount", {
            get: function get() {
              return Object(_selectors_selectors__WEBPACK_IMPORTED_MODULE_2__["countTotalAmountWithDiscount"])(this.fines);
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(FinesList.prototype, "snapshot", {
            get: function get() {
              return {
                fines: this.fines,
                lastUpdate: this.lastUpdate
              };
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(FinesList.prototype, "finesInfo", {
            get: function get() {
              return {
                count: this.fines.length,
                amount: this.totalAmountWithDiscount,
                lastUpdate: this.lastUpdate
              };
            },
            enumerable: true,
            configurable: true
          });

          FinesList.prototype.fetchFines = function (params, selectors) {
            if (selectors === void 0) {
              selectors = [];
            }

            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
              var response;

              var _this = this;

              return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    this.setLoading(true);
                    return [4
                    /*yield*/
                    , Object(_api_fetchFines__WEBPACK_IMPORTED_MODULE_4__["fetchFines"])(params)];

                  case 1:
                    response = _a.sent();
                    this.fines = response.fines;
                    this.status = response.status;
                    selectors.forEach(function (selector) {
                      return _this.fines = selector(_this.fines);
                    });
                    this.lastUpdate = Date.now();
                    this.setLoading(false);
                    return [2
                    /*return*/
                    ];
                }
              });
            });
          };

          FinesList.prototype.setLoading = function (value) {
            this.loading = value;
          };

          FinesList.FromSnapshot = function (_a) {
            var fines = _a.fines,
                lastUpdate = _a.lastUpdate;
            var instance = new FinesList();
            instance.fines = fines;
            instance.lastUpdate = lastUpdate;
            return instance;
          };

          FinesList.GetAll = function (params) {
            var instance = new FinesList();
            instance.fetchFines(params);
            return instance;
          }; // оставляет in_progress=true, и статус "payed", "done"


          FinesList.GetPaid = function (params) {
            var instance = new FinesList();
            instance.fetchFines(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), [_selectors_selectors__WEBPACK_IMPORTED_MODULE_2__["filterPaidFines"]]);
            return instance;
          }; // оставляет новые и при этом in_progress=false


          FinesList.GetUnpaid = function (params) {
            var instance = new FinesList();
            instance.fetchFines(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), {
              status: _types__WEBPACK_IMPORTED_MODULE_3__["Status"].New
            }), [_selectors_selectors__WEBPACK_IMPORTED_MODULE_2__["filterUnpaidFines"]]);
            return instance;
          };

          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["observable"]], FinesList.prototype, "fines", void 0);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["observable"]], FinesList.prototype, "lastUpdate", void 0);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["observable"]], FinesList.prototype, "loading", void 0);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["observable"]], FinesList.prototype, "status", void 0);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["computed"]], FinesList.prototype, "unpaid", null);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["computed"]], FinesList.prototype, "paid", null);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["computed"]], FinesList.prototype, "totalAmountWithDiscount", null);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["computed"]], FinesList.prototype, "snapshot", null);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["computed"]], FinesList.prototype, "finesInfo", null);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["action"]], FinesList.prototype, "fetchFines", null);
          Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([mobx__WEBPACK_IMPORTED_MODULE_1__["action"]], FinesList.prototype, "setLoading", null);
          return FinesList;
        }(); //# sourceMappingURL=FinesList.js.map

        /***/

      },

      /***/
      "./node_modules/gibdd.api/dist/selectors/selectors.js":
      /*!************************************************************!*\
        !*** ./node_modules/gibdd.api/dist/selectors/selectors.js ***!
        \************************************************************/

      /*! exports provided: getActualAmount, isPaid, filterUnpaidFines, filterPaidFines, countTotalAmountWithDiscount */

      /***/
      function node_modulesGibddApiDistSelectorsSelectorsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getActualAmount", function () {
          return getActualAmount;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "isPaid", function () {
          return isPaid;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "filterUnpaidFines", function () {
          return filterUnpaidFines;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "filterPaidFines", function () {
          return filterPaidFines;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "countTotalAmountWithDiscount", function () {
          return countTotalAmountWithDiscount;
        });
        /* harmony import */


        var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ../types */
        "./node_modules/gibdd.api/dist/types/index.js"); // возвращает сумму штрафа с учетом скидки


        var getActualAmount = function getActualAmount(fine) {
          var amountToPay = fine.amountToPay,
              isActiveDiscount = fine.isActiveDiscount,
              discountSize = fine.discountSize;
          var discountMultiplier = (100 - (discountSize || 0)) / 100;
          return isActiveDiscount ? amountToPay * discountMultiplier : amountToPay;
        }; // возвращает оплачен штраф или нет (учитывает погашен, оплачен, временная метка оплачен)


        var isPaid = function isPaid(fine) {
          return fine.status === _types__WEBPACK_IMPORTED_MODULE_0__["Status"].Done || fine.status === _types__WEBPACK_IMPORTED_MODULE_0__["Status"].Payed || fine.paymentInProgress === true;
        }; // оставляет только новые (неоплаченные) штрафы


        var filterUnpaidFines = function filterUnpaidFines(fines) {
          return fines.filter(function (fine) {
            return fine.status === _types__WEBPACK_IMPORTED_MODULE_0__["Status"].New && fine.paymentInProgress === false;
          });
        }; // оставляет только погашенные и оплаченные штрафы


        var filterPaidFines = function filterPaidFines(fines) {
          return fines.filter(function (fine) {
            return isPaid(fine);
          });
        }; // возвращает сумму с учетом скидок по всем переданным штрафам


        var countTotalAmountWithDiscount = function countTotalAmountWithDiscount(fines) {
          return fines.reduce(function (total, fine) {
            return total + getActualAmount(fine);
          }, 0);
        }; //# sourceMappingURL=selectors.js.map

        /***/

      },

      /***/
      "./node_modules/gibdd.api/dist/tools/initializeAxios.js":
      /*!**************************************************************!*\
        !*** ./node_modules/gibdd.api/dist/tools/initializeAxios.js ***!
        \**************************************************************/

      /*! exports provided: axios */

      /***/
      function node_modulesGibddApiDistToolsInitializeAxiosJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "axios", function () {
          return axios;
        });
        /* harmony import */


        var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! axios */
        "./node_modules/axios/index.js");
        /* harmony import */


        var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

        var initializeAxios = function initializeAxios() {
          var instance = axios__WEBPACK_IMPORTED_MODULE_0___default.a.create({});
          instance.defaults.withCredentials = true;
          return instance;
        };

        var axios = initializeAxios(); //# sourceMappingURL=initializeAxios.js.map

        /***/
      },

      /***/
      "./node_modules/gibdd.api/dist/tools/mockApiGibdd.js":
      /*!***********************************************************!*\
        !*** ./node_modules/gibdd.api/dist/tools/mockApiGibdd.js ***!
        \***********************************************************/

      /*! exports provided: mockGibddApi */

      /***/
      function node_modulesGibddApiDistToolsMockApiGibddJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "mockGibddApi", function () {
          return mockGibddApi;
        });
        /* harmony import */


        var _tools_initializeAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ../tools/initializeAxios */
        "./node_modules/gibdd.api/dist/tools/initializeAxios.js");
        /* harmony import */


        var axios_mock_adapter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! axios-mock-adapter */
        "./node_modules/axios-mock-adapter/src/index.js");
        /* harmony import */


        var axios_mock_adapter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios_mock_adapter__WEBPACK_IMPORTED_MODULE_1__); // не стоит проверять регуляркой query-параметры, потому что axios их отбрасывает. Для них есть поле params


        var mockGibddApi = function mockGibddApi(_a) {
          var mocks = _a.mocks,
              timeout = _a.timeout;
          if (!(mocks && mocks.length)) return;
          var mock = new axios_mock_adapter__WEBPACK_IMPORTED_MODULE_1___default.a(_tools_initializeAxios__WEBPACK_IMPORTED_MODULE_0__["axios"], {
            delayResponse: timeout
          });
          mock.onAny().reply(function (config) {
            var reply = [500, {}];
            mocks.forEach(function (_a) {
              var url = _a.url,
                  params = _a.params,
                  status = _a.status,
                  method = _a.method,
                  _b = _a.response,
                  response = _b === void 0 ? {} : _b;
              var checkUrl = !!config.url.match(new RegExp(url));
              var checkQueryParams = !params || config.params && Object.keys(params).every(function (key) {
                return params[key] === config.params[key];
              });
              var checkMethod = config.method.toUpperCase() === method.toUpperCase();

              if (checkUrl && checkQueryParams && checkMethod) {
                reply = [status, response];
              }
            });
            return reply;
          });
        }; //# sourceMappingURL=mockApiGibdd.js.map

        /***/

      },

      /***/
      "./node_modules/gibdd.api/dist/types/index.js":
      /*!****************************************************!*\
        !*** ./node_modules/gibdd.api/dist/types/index.js ***!
        \****************************************************/

      /*! exports provided: Status */

      /***/
      function node_modulesGibddApiDistTypesIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Status", function () {
          return Status;
        }); // статус с сервера


        var Status;

        (function (Status) {
          Status["New"] = "new";
          Status["Done"] = "done";
          Status["Payed"] = "payed";
        })(Status || (Status = {})); //# sourceMappingURL=index.js.map

        /***/

      },

      /***/
      "./node_modules/has-symbols/index.js":
      /*!*******************************************!*\
        !*** ./node_modules/has-symbols/index.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesHasSymbolsIndexJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (global) {
          var origSymbol = global.Symbol;

          var hasSymbolSham = __webpack_require__(
          /*! ./shams */
          "./node_modules/has-symbols/shams.js");

          module.exports = function hasNativeSymbols() {
            if (typeof origSymbol !== 'function') {
              return false;
            }

            if (typeof Symbol !== 'function') {
              return false;
            }

            if (typeof origSymbol('foo') !== 'symbol') {
              return false;
            }

            if (typeof Symbol('bar') !== 'symbol') {
              return false;
            }

            return hasSymbolSham();
          };
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./node_modules/has-symbols/shams.js":
      /*!*******************************************!*\
        !*** ./node_modules/has-symbols/shams.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesHasSymbolsShamsJs(module, exports, __webpack_require__) {
        "use strict";
        /* eslint complexity: [2, 18], max-statements: [2, 33] */

        module.exports = function hasSymbols() {
          if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
            return false;
          }

          if (typeof Symbol.iterator === 'symbol') {
            return true;
          }

          var obj = {};
          var sym = Symbol('test');
          var symObj = Object(sym);

          if (typeof sym === 'string') {
            return false;
          }

          if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
            return false;
          }

          if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
            return false;
          } // temp disabled per https://github.com/ljharb/object.assign/issues/17
          // if (sym instanceof Symbol) { return false; }
          // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
          // if (!(symObj instanceof Symbol)) { return false; }
          // if (typeof Symbol.prototype.toString !== 'function') { return false; }
          // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }


          var symVal = 42;
          obj[sym] = symVal;

          for (sym in obj) {
            return false;
          } // eslint-disable-line no-restricted-syntax


          if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
            return false;
          }

          if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
            return false;
          }

          var syms = Object.getOwnPropertySymbols(obj);

          if (syms.length !== 1 || syms[0] !== sym) {
            return false;
          }

          if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
            return false;
          }

          if (typeof Object.getOwnPropertyDescriptor === 'function') {
            var descriptor = Object.getOwnPropertyDescriptor(obj, sym);

            if (descriptor.value !== symVal || descriptor.enumerable !== true) {
              return false;
            }
          }

          return true;
        };
        /***/

      },

      /***/
      "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js":
      /*!**********************************************************************************!*\
        !*** ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js ***!
        \**********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesHoistNonReactStaticsDistHoistNonReactStaticsCjsJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright 2015, Yahoo! Inc.
         * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
         */

        var REACT_STATICS = {
          childContextTypes: true,
          contextTypes: true,
          defaultProps: true,
          displayName: true,
          getDefaultProps: true,
          getDerivedStateFromProps: true,
          mixins: true,
          propTypes: true,
          type: true
        };
        var KNOWN_STATICS = {
          name: true,
          length: true,
          prototype: true,
          caller: true,
          callee: true,
          arguments: true,
          arity: true
        };
        var defineProperty = Object.defineProperty;
        var getOwnPropertyNames = Object.getOwnPropertyNames;
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var getPrototypeOf = Object.getPrototypeOf;
        var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

        function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
          if (typeof sourceComponent !== 'string') {
            // don't hoist over string (html) components
            if (objectPrototype) {
              var inheritedComponent = getPrototypeOf(sourceComponent);

              if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
              }
            }

            var keys = getOwnPropertyNames(sourceComponent);

            if (getOwnPropertySymbols) {
              keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }

            for (var i = 0; i < keys.length; ++i) {
              var key = keys[i];

              if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

                try {
                  // Avoid failures from read-only properties
                  defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
              }
            }

            return targetComponent;
          }

          return targetComponent;
        }

        module.exports = hoistNonReactStatics;
        /***/
      },

      /***/
      "./node_modules/hyphenate-style-name/index.js":
      /*!****************************************************!*\
        !*** ./node_modules/hyphenate-style-name/index.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesHyphenateStyleNameIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* eslint-disable no-var, prefer-template */


        var uppercasePattern = /[A-Z]/g;
        var msPattern = /^ms-/;
        var cache = {};

        function toHyphenLower(match) {
          return '-' + match.toLowerCase();
        }

        function hyphenateStyleName(name) {
          if (cache.hasOwnProperty(name)) {
            return cache[name];
          }

          var hName = name.replace(uppercasePattern, toHyphenLower);
          return cache[name] = msPattern.test(hName) ? '-' + hName : hName;
        }
        /* harmony default export */


        __webpack_exports__["default"] = hyphenateStyleName;
        /***/
      },

      /***/
      "./node_modules/is-arguments/index.js":
      /*!********************************************!*\
        !*** ./node_modules/is-arguments/index.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsArgumentsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
        var toStr = Object.prototype.toString;

        var isStandardArguments = function isArguments(value) {
          if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
            return false;
          }

          return toStr.call(value) === '[object Arguments]';
        };

        var isLegacyArguments = function isArguments(value) {
          if (isStandardArguments(value)) {
            return true;
          }

          return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value) !== '[object Array]' && toStr.call(value.callee) === '[object Function]';
        };

        var supportsStandardArguments = function () {
          return isStandardArguments(arguments);
        }();

        isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

        module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
        /***/
      },

      /***/
      "./node_modules/is-arrayish/index.js":
      /*!*******************************************!*\
        !*** ./node_modules/is-arrayish/index.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsArrayishIndexJs(module, exports) {
        module.exports = function isArrayish(obj) {
          if (!obj || typeof obj === 'string') {
            return false;
          }

          return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
        };
        /***/

      },

      /***/
      "./node_modules/is-date-object/index.js":
      /*!**********************************************!*\
        !*** ./node_modules/is-date-object/index.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsDateObjectIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var getDay = Date.prototype.getDay;

        var tryDateObject = function tryDateGetDayCall(value) {
          try {
            getDay.call(value);
            return true;
          } catch (e) {
            return false;
          }
        };

        var toStr = Object.prototype.toString;
        var dateClass = '[object Date]';
        var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

        module.exports = function isDateObject(value) {
          if (typeof value !== 'object' || value === null) {
            return false;
          }

          return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
        };
        /***/

      },

      /***/
      "./node_modules/is-function/index.js":
      /*!*******************************************!*\
        !*** ./node_modules/is-function/index.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsFunctionIndexJs(module, exports) {
        module.exports = isFunction;
        var toString = Object.prototype.toString;

        function isFunction(fn) {
          if (!fn) {
            return false;
          }

          var string = toString.call(fn);
          return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && ( // IE8 and below
          fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
        }

        ;
        /***/
      },

      /***/
      "./node_modules/is-in-browser/dist/module.js":
      /*!***************************************************!*\
        !*** ./node_modules/is-in-browser/dist/module.js ***!
        \***************************************************/

      /*! exports provided: isBrowser, default */

      /***/
      function node_modulesIsInBrowserDistModuleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "isBrowser", function () {
          return isBrowser;
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
        /* harmony default export */

        __webpack_exports__["default"] = isBrowser;
        /***/
      },

      /***/
      "./node_modules/is-plain-object/index.js":
      /*!***********************************************!*\
        !*** ./node_modules/is-plain-object/index.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsPlainObjectIndexJs(module, exports, __webpack_require__) {
        "use strict";
        /*!
         * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
         *
         * Copyright (c) 2014-2017, Jon Schlinkert.
         * Released under the MIT License.
         */

        var isObject = __webpack_require__(
        /*! isobject */
        "./node_modules/isobject/index.js");

        function isObjectObject(o) {
          return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
        }

        module.exports = function isPlainObject(o) {
          var ctor, prot;
          if (isObjectObject(o) === false) return false; // If has modified constructor

          ctor = o.constructor;
          if (typeof ctor !== 'function') return false; // If has modified prototype

          prot = ctor.prototype;
          if (isObjectObject(prot) === false) return false; // If constructor does not have an Object-specific method

          if (prot.hasOwnProperty('isPrototypeOf') === false) {
            return false;
          } // Most likely a plain Object


          return true;
        };
        /***/

      },

      /***/
      "./node_modules/is-regex/index.js":
      /*!****************************************!*\
        !*** ./node_modules/is-regex/index.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsRegexIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var hasSymbols = __webpack_require__(
        /*! has-symbols */
        "./node_modules/has-symbols/index.js")();

        var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
        var regexExec;
        var isRegexMarker;
        var badStringifier;

        if (hasToStringTag) {
          regexExec = Function.call.bind(RegExp.prototype.exec);
          isRegexMarker = {};

          var throwRegexMarker = function throwRegexMarker() {
            throw isRegexMarker;
          };

          badStringifier = {
            toString: throwRegexMarker,
            valueOf: throwRegexMarker
          };

          if (typeof Symbol.toPrimitive === 'symbol') {
            badStringifier[Symbol.toPrimitive] = throwRegexMarker;
          }
        }

        var toStr = Object.prototype.toString;
        var regexClass = '[object RegExp]';
        module.exports = hasToStringTag // eslint-disable-next-line consistent-return
        ? function isRegex(value) {
          if (!value || typeof value !== 'object') {
            return false;
          }

          try {
            regexExec(value, badStringifier);
          } catch (e) {
            return e === isRegexMarker;
          }
        } : function isRegex(value) {
          // In older browsers, typeof regex incorrectly returns 'function'
          if (!value || typeof value !== 'object' && typeof value !== 'function') {
            return false;
          }

          return toStr.call(value) === regexClass;
        };
        /***/
      },

      /***/
      "./node_modules/isobject/index.js":
      /*!****************************************!*\
        !*** ./node_modules/isobject/index.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsobjectIndexJs(module, exports, __webpack_require__) {
        "use strict";
        /*!
         * isobject <https://github.com/jonschlinkert/isobject>
         *
         * Copyright (c) 2014-2017, Jon Schlinkert.
         * Released under the MIT License.
         */

        module.exports = function isObject(val) {
          return val != null && typeof val === 'object' && Array.isArray(val) === false;
        };
        /***/

      },

      /***/
      "./node_modules/jss-camel-case/lib/index.js":
      /*!**************************************************!*\
        !*** ./node_modules/jss-camel-case/lib/index.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssCamelCaseLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = camelCase;

        var _hyphenateStyleName = __webpack_require__(
        /*! hyphenate-style-name */
        "./node_modules/hyphenate-style-name/index.js");

        var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        /**
         * Convert camel cased property names to dash separated.
         *
         * @param {Object} style
         * @return {Object}
         */


        function convertCase(style) {
          var converted = {};

          for (var prop in style) {
            converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
          }

          if (style.fallbacks) {
            if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
          }

          return converted;
        }
        /**
         * Allow camel cased property names by converting them back to dasherized.
         *
         * @param {Rule} rule
         */


        function camelCase() {
          function onProcessStyle(style) {
            if (Array.isArray(style)) {
              // Handle rules like @font-face, which can have multiple styles in an array
              for (var index = 0; index < style.length; index++) {
                style[index] = convertCase(style[index]);
              }

              return style;
            }

            return convertCase(style);
          }

          function onChangeValue(value, prop, rule) {
            var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop); // There was no camel case in place

            if (prop === hyphenatedProp) return value;
            rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

            return null;
          }

          return {
            onProcessStyle: onProcessStyle,
            onChangeValue: onChangeValue
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-compose/lib/index.js":
      /*!***********************************************!*\
        !*** ./node_modules/jss-compose/lib/index.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssComposeLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = jssCompose;

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        /**
         * Set selector.
         *
         * @param {Object} original rule
         * @param {String} className class string
         * @return {Boolean} flag, indicating function was successfull or not
         */


        function registerClass(rule, className) {
          // Skip falsy values
          if (!className) return true; // Support array of class names `{composes: ['foo', 'bar']}`

          if (Array.isArray(className)) {
            for (var index = 0; index < className.length; index++) {
              var isSetted = registerClass(rule, className[index]);
              if (!isSetted) return false;
            }

            return true;
          } // Support space separated class names `{composes: 'foo bar'}`


          if (className.indexOf(' ') > -1) {
            return registerClass(rule, className.split(' '));
          }

          var parent = rule.options.parent; // It is a ref to a local rule.

          if (className[0] === '$') {
            var refRule = parent.getRule(className.substr(1));

            if (!refRule) {
              (0, _warning2.default)(false, '[JSS] Referenced rule is not defined. \r\n%s', rule);
              return false;
            }

            if (refRule === rule) {
              (0, _warning2.default)(false, '[JSS] Cyclic composition detected. \r\n%s', rule);
              return false;
            }

            parent.classes[rule.key] += ' ' + parent.classes[refRule.key];
            return true;
          }

          rule.options.parent.classes[rule.key] += ' ' + className;
          return true;
        }
        /**
         * Convert compose property to additional class, remove property from original styles.
         *
         * @param {Rule} rule
         * @api public
         */


        function jssCompose() {
          function onProcessStyle(style, rule) {
            if (!style.composes) return style;
            registerClass(rule, style.composes); // Remove composes property to prevent infinite loop.

            delete style.composes;
            return style;
          }

          return {
            onProcessStyle: onProcessStyle
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-default-unit/lib/defaultUnits.js":
      /*!***********************************************************!*\
        !*** ./node_modules/jss-default-unit/lib/defaultUnits.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssDefaultUnitLibDefaultUnitsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        /**
         * Generated jss-default-unit CSS property units
         *
         * @type object
         */

        exports['default'] = {
          'animation-delay': 'ms',
          'animation-duration': 'ms',
          'background-position': 'px',
          'background-position-x': 'px',
          'background-position-y': 'px',
          'background-size': 'px',
          border: 'px',
          'border-bottom': 'px',
          'border-bottom-left-radius': 'px',
          'border-bottom-right-radius': 'px',
          'border-bottom-width': 'px',
          'border-left': 'px',
          'border-left-width': 'px',
          'border-radius': 'px',
          'border-right': 'px',
          'border-right-width': 'px',
          'border-spacing': 'px',
          'border-top': 'px',
          'border-top-left-radius': 'px',
          'border-top-right-radius': 'px',
          'border-top-width': 'px',
          'border-width': 'px',
          'border-after-width': 'px',
          'border-before-width': 'px',
          'border-end-width': 'px',
          'border-horizontal-spacing': 'px',
          'border-start-width': 'px',
          'border-vertical-spacing': 'px',
          bottom: 'px',
          'box-shadow': 'px',
          'column-gap': 'px',
          'column-rule': 'px',
          'column-rule-width': 'px',
          'column-width': 'px',
          'flex-basis': 'px',
          'font-size': 'px',
          'font-size-delta': 'px',
          height: 'px',
          left: 'px',
          'letter-spacing': 'px',
          'logical-height': 'px',
          'logical-width': 'px',
          margin: 'px',
          'margin-after': 'px',
          'margin-before': 'px',
          'margin-bottom': 'px',
          'margin-left': 'px',
          'margin-right': 'px',
          'margin-top': 'px',
          'max-height': 'px',
          'max-width': 'px',
          'margin-end': 'px',
          'margin-start': 'px',
          'mask-position-x': 'px',
          'mask-position-y': 'px',
          'mask-size': 'px',
          'max-logical-height': 'px',
          'max-logical-width': 'px',
          'min-height': 'px',
          'min-width': 'px',
          'min-logical-height': 'px',
          'min-logical-width': 'px',
          motion: 'px',
          'motion-offset': 'px',
          outline: 'px',
          'outline-offset': 'px',
          'outline-width': 'px',
          padding: 'px',
          'padding-bottom': 'px',
          'padding-left': 'px',
          'padding-right': 'px',
          'padding-top': 'px',
          'padding-after': 'px',
          'padding-before': 'px',
          'padding-end': 'px',
          'padding-start': 'px',
          'perspective-origin-x': '%',
          'perspective-origin-y': '%',
          perspective: 'px',
          right: 'px',
          'shape-margin': 'px',
          size: 'px',
          'text-indent': 'px',
          'text-stroke': 'px',
          'text-stroke-width': 'px',
          top: 'px',
          'transform-origin': '%',
          'transform-origin-x': '%',
          'transform-origin-y': '%',
          'transform-origin-z': '%',
          'transition-delay': 'ms',
          'transition-duration': 'ms',
          'vertical-align': 'px',
          width: 'px',
          'word-spacing': 'px',
          // Not existing properties.
          // Used to avoid issues with jss-expand intergration.
          'box-shadow-x': 'px',
          'box-shadow-y': 'px',
          'box-shadow-blur': 'px',
          'box-shadow-spread': 'px',
          'font-line-height': 'px',
          'text-shadow-x': 'px',
          'text-shadow-y': 'px',
          'text-shadow-blur': 'px'
        };
        /***/
      },

      /***/
      "./node_modules/jss-default-unit/lib/index.js":
      /*!****************************************************!*\
        !*** ./node_modules/jss-default-unit/lib/index.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssDefaultUnitLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        exports['default'] = defaultUnit;

        var _defaultUnits = __webpack_require__(
        /*! ./defaultUnits */
        "./node_modules/jss-default-unit/lib/defaultUnits.js");

        var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        /**
         * Clones the object and adds a camel cased property version.
         */


        function addCamelCasedVersion(obj) {
          var regExp = /(-[a-z])/g;

          var replace = function replace(str) {
            return str[1].toUpperCase();
          };

          var newObj = {};

          for (var key in obj) {
            newObj[key] = obj[key];
            newObj[key.replace(regExp, replace)] = obj[key];
          }

          return newObj;
        }

        var units = addCamelCasedVersion(_defaultUnits2['default']);
        /**
         * Recursive deep style passing function
         *
         * @param {String} current property
         * @param {(Object|Array|Number|String)} property value
         * @param {Object} options
         * @return {(Object|Array|Number|String)} resulting value
         */

        function iterate(prop, value, options) {
          if (!value) return value;
          var convertedValue = value;
          var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
          if (type === 'object' && Array.isArray(value)) type = 'array';

          switch (type) {
            case 'object':
              if (prop === 'fallbacks') {
                for (var innerProp in value) {
                  value[innerProp] = iterate(innerProp, value[innerProp], options);
                }

                break;
              }

              for (var _innerProp in value) {
                value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
              }

              break;

            case 'array':
              for (var i = 0; i < value.length; i++) {
                value[i] = iterate(prop, value[i], options);
              }

              break;

            case 'number':
              if (value !== 0) {
                convertedValue = value + (options[prop] || units[prop] || '');
              }

              break;

            default:
              break;
          }

          return convertedValue;
        }
        /**
         * Add unit to numeric values.
         */


        function defaultUnit() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var camelCasedOptions = addCamelCasedVersion(options);

          function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;

            for (var prop in style) {
              style[prop] = iterate(prop, style[prop], camelCasedOptions);
            }

            return style;
          }

          function onChangeValue(value, prop) {
            return iterate(prop, value, camelCasedOptions);
          }

          return {
            onProcessStyle: onProcessStyle,
            onChangeValue: onChangeValue
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-expand/lib/index.js":
      /*!**********************************************!*\
        !*** ./node_modules/jss-expand/lib/index.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssExpandLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        exports.default = jssExpand;

        var _props = __webpack_require__(
        /*! ./props */
        "./node_modules/jss-expand/lib/props.js");

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }
        /**
         * Map values by given prop.
         *
         * @param {Array} array of values
         * @param {String} original property
         * @param {String} original rule
         * @return {String} mapped values
         */


        function mapValuesByProp(value, prop, rule) {
          return value.map(function (item) {
            return objectToArray(item, prop, rule, false, true);
          });
        }
        /**
         * Convert array to nested array, if needed
         *
         * @param {Array} array of values
         * @param {String} original property
         * @param {Object} sheme, for converting arrays in strings
         * @param {Object} original rule
         * @return {String} converted string
         */


        function processArray(value, prop, scheme, rule) {
          if (scheme[prop] == null) return value;
          if (value.length === 0) return [];
          if (Array.isArray(value[0])) return processArray(value[0], prop, scheme);

          if (_typeof(value[0]) === 'object') {
            return mapValuesByProp(value, prop, rule);
          }

          return [value];
        }
        /**
         * Convert object to array.
         *
         * @param {Object} object of values
         * @param {String} original property
         * @param {Object} original rule
         * @param {Boolean} is fallback prop
         * @param {Boolean} object is inside array
         * @return {String} converted string
         */


        function objectToArray(value, prop, rule, isFallback, isInArray) {
          if (!(_props.propObj[prop] || _props.customPropObj[prop])) return [];
          var result = []; // Check if exists any non-standart property

          if (_props.customPropObj[prop]) {
            value = customPropsToStyle(value, rule, _props.customPropObj[prop], isFallback);
          } // Pass throught all standart props


          if (Object.keys(value).length) {
            for (var baseProp in _props.propObj[prop]) {
              if (value[baseProp]) {
                if (Array.isArray(value[baseProp])) {
                  result.push(_props.propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(' '));
                } else result.push(value[baseProp]);

                continue;
              } // Add default value from props config.


              if (_props.propObj[prop][baseProp] != null) {
                result.push(_props.propObj[prop][baseProp]);
              }
            }
          }

          if (!result.length || isInArray) return result;
          return [result];
        }
        /**
         * Convert custom properties values to styles adding them to rule directly
         *
         * @param {Object} object of values
         * @param {Object} original rule
         * @param {String} property, that contain partial custom properties
         * @param {Boolean} is fallback prop
         * @return {Object} value without custom properties, that was already added to rule
         */


        function customPropsToStyle(value, rule, customProps, isFallback) {
          for (var prop in customProps) {
            var propName = customProps[prop]; // If current property doesn't exist already in rule - add new one

            if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
              var appendedValue = styleDetector(_defineProperty({}, propName, value[prop]), rule)[propName]; // Add style directly in rule

              if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
            } // Delete converted property to avoid double converting


            delete value[prop];
          }

          return value;
        }
        /**
         * Detect if a style needs to be converted.
         *
         * @param {Object} style
         * @param {Object} rule
         * @param {Boolean} is fallback prop
         * @return {Object} convertedStyle
         */


        function styleDetector(style, rule, isFallback) {
          for (var prop in style) {
            var value = style[prop];

            if (Array.isArray(value)) {
              // Check double arrays to avoid recursion.
              if (!Array.isArray(value[0])) {
                if (prop === 'fallbacks') {
                  for (var index = 0; index < style.fallbacks.length; index++) {
                    style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
                  }

                  continue;
                }

                style[prop] = processArray(value, prop, _props.propArray); // Avoid creating properties with empty values

                if (!style[prop].length) delete style[prop];
              }
            } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
              if (prop === 'fallbacks') {
                style.fallbacks = styleDetector(style.fallbacks, rule, true);
                continue;
              }

              style[prop] = objectToArray(value, prop, rule, isFallback); // Avoid creating properties with empty values

              if (!style[prop].length) delete style[prop];
            } // Maybe a computed value resulting in an empty string
            else if (style[prop] === '') delete style[prop];
          }

          return style;
        }
        /**
         * Adds possibility to write expanded styles.
         *
         * @param {Rule} rule
         * @api public
         */


        function jssExpand() {
          function onProcessStyle(style, rule) {
            if (!style || rule.type !== 'style') return style;

            if (Array.isArray(style)) {
              // Pass rules one by one and reformat them
              for (var index = 0; index < style.length; index++) {
                style[index] = styleDetector(style[index], rule);
              }

              return style;
            }

            return styleDetector(style, rule);
          }

          return {
            onProcessStyle: onProcessStyle
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-expand/lib/props.js":
      /*!**********************************************!*\
        !*** ./node_modules/jss-expand/lib/props.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssExpandLibPropsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        /**
         * A scheme for converting properties from array to regular style.
         * All properties listed below will be transformed to a string separated by space.
         */

        var propArray = exports.propArray = {
          'background-size': true,
          'background-position': true,
          border: true,
          'border-bottom': true,
          'border-left': true,
          'border-top': true,
          'border-right': true,
          'border-radius': true,
          'border-image': true,
          'border-width': true,
          'border-style': true,
          'border-color': true,
          'box-shadow': true,
          flex: true,
          margin: true,
          padding: true,
          outline: true,
          'transform-origin': true,
          transform: true,
          transition: true
          /**
           * A scheme for converting arrays to regular styles inside of objects.
           * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
           */

        };
        var propArrayInObj = exports.propArrayInObj = {
          position: true,
          // background-position
          size: true // background-size

          /**
           * A scheme for parsing and building correct styles from passed objects.
           */

        };
        var propObj = exports.propObj = {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          background: {
            attachment: null,
            color: null,
            image: null,
            position: null,
            repeat: null
          },
          border: {
            width: null,
            style: null,
            color: null
          },
          'border-top': {
            width: null,
            style: null,
            color: null
          },
          'border-right': {
            width: null,
            style: null,
            color: null
          },
          'border-bottom': {
            width: null,
            style: null,
            color: null
          },
          'border-left': {
            width: null,
            style: null,
            color: null
          },
          outline: {
            width: null,
            style: null,
            color: null
          },
          'list-style': {
            type: null,
            position: null,
            image: null
          },
          transition: {
            property: null,
            duration: null,
            'timing-function': null,
            timingFunction: null,
            // Needed for avoiding comilation issues with jss-camel-case
            delay: null
          },
          animation: {
            name: null,
            duration: null,
            'timing-function': null,
            timingFunction: null,
            // Needed to avoid compilation issues with jss-camel-case
            delay: null,
            'iteration-count': null,
            iterationCount: null,
            // Needed to avoid compilation issues with jss-camel-case
            direction: null,
            'fill-mode': null,
            fillMode: null,
            // Needed to avoid compilation issues with jss-camel-case
            'play-state': null,
            playState: null // Needed to avoid compilation issues with jss-camel-case

          },
          'box-shadow': {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0,
            color: null,
            inset: null
          },
          'text-shadow': {
            x: 0,
            y: 0,
            blur: null,
            color: null
          }
          /**
           * A scheme for converting non-standart properties inside object.
           * For e.g.: include 'border-radius' property inside 'border' object.
           */

        };
        var customPropObj = exports.customPropObj = {
          border: {
            radius: 'border-radius',
            image: 'border-image',
            width: 'border-width',
            style: 'border-style',
            color: 'border-color'
          },
          background: {
            size: 'background-size',
            image: 'background-image'
          },
          font: {
            style: 'font-style',
            variant: 'font-variant',
            weight: 'font-weight',
            stretch: 'font-stretch',
            size: 'font-size',
            family: 'font-family',
            lineHeight: 'line-height',
            // Needed to avoid compilation issues with jss-camel-case
            'line-height': 'line-height'
          },
          flex: {
            grow: 'flex-grow',
            basis: 'flex-basis',
            direction: 'flex-direction',
            wrap: 'flex-wrap',
            flow: 'flex-flow',
            shrink: 'flex-shrink'
          },
          align: {
            self: 'align-self',
            items: 'align-items',
            content: 'align-content'
          },
          grid: {
            'template-columns': 'grid-template-columns',
            templateColumns: 'grid-template-columns',
            'template-rows': 'grid-template-rows',
            templateRows: 'grid-template-rows',
            'template-areas': 'grid-template-areas',
            templateAreas: 'grid-template-areas',
            template: 'grid-template',
            'auto-columns': 'grid-auto-columns',
            autoColumns: 'grid-auto-columns',
            'auto-rows': 'grid-auto-rows',
            autoRows: 'grid-auto-rows',
            'auto-flow': 'grid-auto-flow',
            autoFlow: 'grid-auto-flow',
            row: 'grid-row',
            column: 'grid-column',
            'row-start': 'grid-row-start',
            rowStart: 'grid-row-start',
            'row-end': 'grid-row-end',
            rowEnd: 'grid-row-end',
            'column-start': 'grid-column-start',
            columnStart: 'grid-column-start',
            'column-end': 'grid-column-end',
            columnEnd: 'grid-column-end',
            area: 'grid-area',
            gap: 'grid-gap',
            'row-gap': 'grid-row-gap',
            rowGap: 'grid-row-gap',
            'column-gap': 'grid-column-gap',
            columnGap: 'grid-column-gap'
          }
        };
        /***/
      },

      /***/
      "./node_modules/jss-extend/lib/index.js":
      /*!**********************************************!*\
        !*** ./node_modules/jss-extend/lib/index.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssExtendLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        exports['default'] = jssExtend;

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var isObject = function isObject(obj) {
          return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
        };

        var valueNs = 'extendCurrValue' + Date.now();

        function mergeExtend(style, rule, sheet, newStyle) {
          var extendType = _typeof(style.extend); // Extend using a rule name.


          if (extendType === 'string') {
            if (!sheet) return;
            var refRule = sheet.getRule(style.extend);
            if (!refRule) return;

            if (refRule === rule) {
              (0, _warning2['default'])(false, '[JSS] A rule tries to extend itself \r\n%s', rule);
              return;
            }

            var parent = refRule.options.parent;

            if (parent) {
              var originalStyle = parent.rules.raw[style.extend];
              extend(originalStyle, rule, sheet, newStyle);
            }

            return;
          } // Extend using an array of objects.


          if (Array.isArray(style.extend)) {
            for (var index = 0; index < style.extend.length; index++) {
              extend(style.extend[index], rule, sheet, newStyle);
            }

            return;
          } // Extend is a style object.


          for (var prop in style.extend) {
            if (prop === 'extend') {
              extend(style.extend.extend, rule, sheet, newStyle);
              continue;
            }

            if (isObject(style.extend[prop])) {
              if (!(prop in newStyle)) newStyle[prop] = {};
              extend(style.extend[prop], rule, sheet, newStyle[prop]);
              continue;
            }

            newStyle[prop] = style.extend[prop];
          }
        }

        function mergeRest(style, rule, sheet, newStyle) {
          // Copy base style.
          for (var prop in style) {
            if (prop === 'extend') continue;

            if (isObject(newStyle[prop]) && isObject(style[prop])) {
              extend(style[prop], rule, sheet, newStyle[prop]);
              continue;
            }

            if (isObject(style[prop])) {
              newStyle[prop] = extend(style[prop], rule, sheet);
              continue;
            }

            newStyle[prop] = style[prop];
          }
        }
        /**
         * Recursively extend styles.
         */


        function extend(style, rule, sheet) {
          var newStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          mergeExtend(style, rule, sheet, newStyle);
          mergeRest(style, rule, sheet, newStyle);
          return newStyle;
        }
        /**
         * Handle `extend` property.
         *
         * @param {Rule} rule
         * @api public
         */


        function jssExtend() {
          function onProcessStyle(style, rule, sheet) {
            if ('extend' in style) return extend(style, rule, sheet);
            return style;
          }

          function onChangeValue(value, prop, rule) {
            if (prop !== 'extend') return value; // Value is empty, remove properties set previously.

            if (value == null || value === false) {
              for (var key in rule[valueNs]) {
                rule.prop(key, null);
              }

              rule[valueNs] = null;
              return null;
            }

            for (var _key in value) {
              rule.prop(_key, value[_key]);
            }

            rule[valueNs] = value; // Make sure we don't set the value in the core.

            return null;
          }

          return {
            onProcessStyle: onProcessStyle,
            onChangeValue: onChangeValue
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-global/lib/index.js":
      /*!**********************************************!*\
        !*** ./node_modules/jss-global/lib/index.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssGlobalLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        exports['default'] = jssGlobal;

        var _jss = __webpack_require__(
        /*! jss */
        "./node_modules/jss/lib/index.js");

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var propKey = '@global';
        var prefixKey = '@global ';

        var GlobalContainerRule = function () {
          function GlobalContainerRule(key, styles, options) {
            _classCallCheck(this, GlobalContainerRule);

            this.type = 'global';
            this.key = key;
            this.options = options;
            this.rules = new _jss.RuleList(_extends({}, options, {
              parent: this
            }));

            for (var selector in styles) {
              this.rules.add(selector, styles[selector], {
                selector: selector
              });
            }

            this.rules.process();
          }
          /**
           * Get a rule.
           */


          _createClass(GlobalContainerRule, [{
            key: 'getRule',
            value: function getRule(name) {
              return this.rules.get(name);
            }
            /**
             * Create and register rule, run plugins.
             */

          }, {
            key: 'addRule',
            value: function addRule(name, style, options) {
              var rule = this.rules.add(name, style, options);
              this.options.jss.plugins.onProcessRule(rule);
              return rule;
            }
            /**
             * Get index of a rule.
             */

          }, {
            key: 'indexOf',
            value: function indexOf(rule) {
              return this.rules.indexOf(rule);
            }
            /**
             * Generates a CSS string.
             */

          }, {
            key: 'toString',
            value: function toString() {
              return this.rules.toString();
            }
          }]);

          return GlobalContainerRule;
        }();

        var GlobalPrefixedRule = function () {
          function GlobalPrefixedRule(name, style, options) {
            _classCallCheck(this, GlobalPrefixedRule);

            this.name = name;
            this.options = options;
            var selector = name.substr(prefixKey.length);
            this.rule = options.jss.createRule(selector, style, _extends({}, options, {
              parent: this,
              selector: selector
            }));
          }

          _createClass(GlobalPrefixedRule, [{
            key: 'toString',
            value: function toString(options) {
              return this.rule.toString(options);
            }
          }]);

          return GlobalPrefixedRule;
        }();

        var separatorRegExp = /\s*,\s*/g;

        function addScope(selector, scope) {
          var parts = selector.split(separatorRegExp);
          var scoped = '';

          for (var i = 0; i < parts.length; i++) {
            scoped += scope + ' ' + parts[i].trim();
            if (parts[i + 1]) scoped += ', ';
          }

          return scoped;
        }

        function handleNestedGlobalContainerRule(rule) {
          var options = rule.options,
              style = rule.style;
          var rules = style[propKey];
          if (!rules) return;

          for (var name in rules) {
            options.sheet.addRule(name, rules[name], _extends({}, options, {
              selector: addScope(name, rule.selector)
            }));
          }

          delete style[propKey];
        }

        function handlePrefixedGlobalRule(rule) {
          var options = rule.options,
              style = rule.style;

          for (var prop in style) {
            if (prop.substr(0, propKey.length) !== propKey) continue;
            var selector = addScope(prop.substr(propKey.length), rule.selector);
            options.sheet.addRule(selector, style[prop], _extends({}, options, {
              selector: selector
            }));
            delete style[prop];
          }
        }
        /**
         * Convert nested rules to separate, remove them from original styles.
         *
         * @param {Rule} rule
         * @api public
         */


        function jssGlobal() {
          function onCreateRule(name, styles, options) {
            if (name === propKey) {
              return new GlobalContainerRule(name, styles, options);
            }

            if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
              return new GlobalPrefixedRule(name, styles, options);
            }

            var parent = options.parent;

            if (parent) {
              if (parent.type === 'global' || parent.options.parent.type === 'global') {
                options.global = true;
              }
            }

            if (options.global) options.selector = name;
            return null;
          }

          function onProcessRule(rule) {
            if (rule.type !== 'style') return;
            handleNestedGlobalContainerRule(rule);
            handlePrefixedGlobalRule(rule);
          }

          return {
            onCreateRule: onCreateRule,
            onProcessRule: onProcessRule
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-nested/lib/index.js":
      /*!**********************************************!*\
        !*** ./node_modules/jss-nested/lib/index.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssNestedLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        exports.default = jssNested;

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var separatorRegExp = /\s*,\s*/g;
        var parentRegExp = /&/g;
        var refRegExp = /\$([\w-]+)/g;
        /**
         * Convert nested rules to separate, remove them from original styles.
         *
         * @param {Rule} rule
         * @api public
         */

        function jssNested() {
          // Get a function to be used for $ref replacement.
          function getReplaceRef(container) {
            return function (match, key) {
              var rule = container.getRule(key);
              if (rule) return rule.selector;
              (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
              return key;
            };
          }

          var hasAnd = function hasAnd(str) {
            return str.indexOf('&') !== -1;
          };

          function replaceParentRefs(nestedProp, parentProp) {
            var parentSelectors = parentProp.split(separatorRegExp);
            var nestedSelectors = nestedProp.split(separatorRegExp);
            var result = '';

            for (var i = 0; i < parentSelectors.length; i++) {
              var parent = parentSelectors[i];

              for (var j = 0; j < nestedSelectors.length; j++) {
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

                result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
              }
            }

            return result;
          }

          function getOptions(rule, container, options) {
            // Options has been already created, now we only increase index.
            if (options) return _extends({}, options, {
              index: options.index + 1
            });
            var nestingLevel = rule.options.nestingLevel;
            nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
            return _extends({}, rule.options, {
              nestingLevel: nestingLevel,
              index: container.indexOf(rule) + 1
            });
          }

          function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var container = rule.options.parent;
            var options = void 0;
            var replaceRef = void 0;

            for (var prop in style) {
              var isNested = hasAnd(prop);
              var isNestedConditional = prop[0] === '@';
              if (!isNested && !isNestedConditional) continue;
              options = getOptions(rule, container, options);

              if (isNested) {
                var selector = replaceParentRefs(prop, rule.selector // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                );
                if (!replaceRef) replaceRef = getReplaceRef(container // Replace all $refs.
                );
                selector = selector.replace(refRegExp, replaceRef);
                container.addRule(selector, style[prop], _extends({}, options, {
                  selector: selector
                }));
              } else if (isNestedConditional) {
                container // Place conditional right after the parent rule to ensure right ordering.
                .addRule(prop, null, options).addRule(rule.key, style[prop], {
                  selector: rule.selector
                });
              }

              delete style[prop];
            }

            return style;
          }

          return {
            onProcessStyle: onProcessStyle
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-preset-default/lib/index.js":
      /*!******************************************************!*\
        !*** ./node_modules/jss-preset-default/lib/index.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssPresetDefaultLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _jssTemplate = __webpack_require__(
        /*! jss-template */
        "./node_modules/jss-template/lib/index.js");

        var _jssTemplate2 = _interopRequireDefault(_jssTemplate);

        var _jssGlobal = __webpack_require__(
        /*! jss-global */
        "./node_modules/jss-global/lib/index.js");

        var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

        var _jssExtend = __webpack_require__(
        /*! jss-extend */
        "./node_modules/jss-extend/lib/index.js");

        var _jssExtend2 = _interopRequireDefault(_jssExtend);

        var _jssNested = __webpack_require__(
        /*! jss-nested */
        "./node_modules/jss-nested/lib/index.js");

        var _jssNested2 = _interopRequireDefault(_jssNested);

        var _jssCompose = __webpack_require__(
        /*! jss-compose */
        "./node_modules/jss-compose/lib/index.js");

        var _jssCompose2 = _interopRequireDefault(_jssCompose);

        var _jssCamelCase = __webpack_require__(
        /*! jss-camel-case */
        "./node_modules/jss-camel-case/lib/index.js");

        var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

        var _jssDefaultUnit = __webpack_require__(
        /*! jss-default-unit */
        "./node_modules/jss-default-unit/lib/index.js");

        var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

        var _jssExpand = __webpack_require__(
        /*! jss-expand */
        "./node_modules/jss-expand/lib/index.js");

        var _jssExpand2 = _interopRequireDefault(_jssExpand);

        var _jssVendorPrefixer = __webpack_require__(
        /*! jss-vendor-prefixer */
        "./node_modules/jss-preset-default/node_modules/jss-vendor-prefixer/lib/index.js");

        var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

        var _jssPropsSort = __webpack_require__(
        /*! jss-props-sort */
        "./node_modules/jss-props-sort/lib/index.js");

        var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return {
            plugins: [(0, _jssTemplate2.default)(options.template), (0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
          };
        };
        /***/

      },

      /***/
      "./node_modules/jss-preset-default/node_modules/css-vendor/lib/camelize.js":
      /*!*********************************************************************************!*\
        !*** ./node_modules/jss-preset-default/node_modules/css-vendor/lib/camelize.js ***!
        \*********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssPresetDefaultNode_modulesCssVendorLibCamelizeJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = camelize;
        var regExp = /[-\s]+(.)?/g;
        /**
         * Convert dash separated strings to camel cased.
         *
         * @param {String} str
         * @return {String}
         */

        function camelize(str) {
          return str.replace(regExp, toUpper);
        }

        function toUpper(match, c) {
          return c ? c.toUpperCase() : '';
        }
        /***/

      },

      /***/
      "./node_modules/jss-preset-default/node_modules/css-vendor/lib/index.js":
      /*!******************************************************************************!*\
        !*** ./node_modules/jss-preset-default/node_modules/css-vendor/lib/index.js ***!
        \******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssPresetDefaultNode_modulesCssVendorLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

        var _prefix = __webpack_require__(
        /*! ./prefix */
        "./node_modules/jss-preset-default/node_modules/css-vendor/lib/prefix.js");

        var _prefix2 = _interopRequireDefault(_prefix);

        var _supportedProperty = __webpack_require__(
        /*! ./supported-property */
        "./node_modules/jss-preset-default/node_modules/css-vendor/lib/supported-property.js");

        var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

        var _supportedValue = __webpack_require__(
        /*! ./supported-value */
        "./node_modules/jss-preset-default/node_modules/css-vendor/lib/supported-value.js");

        var _supportedValue2 = _interopRequireDefault(_supportedValue);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        exports['default'] = {
          prefix: _prefix2['default'],
          supportedProperty: _supportedProperty2['default'],
          supportedValue: _supportedValue2['default']
        };
        /**
         * CSS Vendor prefix detection and property feature testing.
         *
         * @copyright Oleg Slobodskoi 2015
         * @website https://github.com/jsstyles/css-vendor
         * @license MIT
         */

        exports.prefix = _prefix2['default'];
        exports.supportedProperty = _supportedProperty2['default'];
        exports.supportedValue = _supportedValue2['default'];
        /***/
      },

      /***/
      "./node_modules/jss-preset-default/node_modules/css-vendor/lib/prefix.js":
      /*!*******************************************************************************!*\
        !*** ./node_modules/jss-preset-default/node_modules/css-vendor/lib/prefix.js ***!
        \*******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssPresetDefaultNode_modulesCssVendorLibPrefixJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _isInBrowser = __webpack_require__(
        /*! is-in-browser */
        "./node_modules/is-in-browser/dist/module.js");

        var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var js = '';
        /**
         * Export javascript style and css style vendor prefixes.
         * Based on "transform" support test.
         */

        var css = ''; // We should not do anything if required serverside.

        if (_isInBrowser2['default']) {
          // Order matters. We need to check Webkit the last one because
          // other vendors use to add Webkit prefixes to some properties
          var jsCssMap = {
            Moz: '-moz-',
            // IE did it wrong again ...
            ms: '-ms-',
            O: '-o-',
            Webkit: '-webkit-'
          };
          var style = document.createElement('p').style;
          var testProp = 'Transform';

          for (var key in jsCssMap) {
            if (key + testProp in style) {
              js = key;
              css = jsCssMap[key];
              break;
            }
          }
        }
        /**
         * Vendor prefix string for the current browser.
         *
         * @type {{js: String, css: String}}
         * @api public
         */


        exports['default'] = {
          js: js,
          css: css
        };
        /***/
      },

      /***/
      "./node_modules/jss-preset-default/node_modules/css-vendor/lib/supported-property.js":
      /*!*******************************************************************************************!*\
        !*** ./node_modules/jss-preset-default/node_modules/css-vendor/lib/supported-property.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssPresetDefaultNode_modulesCssVendorLibSupportedPropertyJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = supportedProperty;

        var _isInBrowser = __webpack_require__(
        /*! is-in-browser */
        "./node_modules/is-in-browser/dist/module.js");

        var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

        var _prefix = __webpack_require__(
        /*! ./prefix */
        "./node_modules/jss-preset-default/node_modules/css-vendor/lib/prefix.js");

        var _prefix2 = _interopRequireDefault(_prefix);

        var _camelize = __webpack_require__(
        /*! ./camelize */
        "./node_modules/jss-preset-default/node_modules/css-vendor/lib/camelize.js");

        var _camelize2 = _interopRequireDefault(_camelize);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var el = void 0;
        var cache = {};

        if (_isInBrowser2['default']) {
          el = document.createElement('p');
          /**
           * We test every property on vendor prefix requirement.
           * Once tested, result is cached. It gives us up to 70% perf boost.
           * http://jsperf.com/element-style-object-access-vs-plain-object
           *
           * Prefill cache with known css properties to reduce amount of
           * properties we need to feature test at runtime.
           * http://davidwalsh.name/vendor-prefix
           */

          var computed = window.getComputedStyle(document.documentElement, '');

          for (var key in computed) {
            if (!isNaN(key)) cache[computed[key]] = computed[key];
          }
        }
        /**
         * Test if a property is supported, returns supported property with vendor
         * prefix if required. Returns `false` if not supported.
         *
         * @param {String} prop dash separated
         * @return {String|Boolean}
         * @api public
         */


        function supportedProperty(prop) {
          // For server-side rendering.
          if (!el) return prop; // We have not tested this prop yet, lets do the test.

          if (cache[prop] != null) return cache[prop]; // Camelization is required because we can't test using
          // css syntax for e.g. in FF.
          // Test if property is supported as it is.

          if ((0, _camelize2['default'])(prop) in el.style) {
            cache[prop] = prop;
          } // Test if property is supported with vendor prefix.
          else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
              cache[prop] = _prefix2['default'].css + prop;
            } else {
              cache[prop] = false;
            }

          return cache[prop];
        }
        /***/

      },

      /***/
      "./node_modules/jss-preset-default/node_modules/css-vendor/lib/supported-value.js":
      /*!****************************************************************************************!*\
        !*** ./node_modules/jss-preset-default/node_modules/css-vendor/lib/supported-value.js ***!
        \****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssPresetDefaultNode_modulesCssVendorLibSupportedValueJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = supportedValue;

        var _isInBrowser = __webpack_require__(
        /*! is-in-browser */
        "./node_modules/is-in-browser/dist/module.js");

        var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

        var _prefix = __webpack_require__(
        /*! ./prefix */
        "./node_modules/jss-preset-default/node_modules/css-vendor/lib/prefix.js");

        var _prefix2 = _interopRequireDefault(_prefix);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var cache = {};
        var el = void 0;
        if (_isInBrowser2['default']) el = document.createElement('p');
        /**
         * Returns prefixed value if needed. Returns `false` if value is not supported.
         *
         * @param {String} property
         * @param {String} value
         * @return {String|Boolean}
         * @api public
         */

        function supportedValue(property, value) {
          // For server-side rendering.
          if (!el) return value; // It is a string or a number as a string like '1'.
          // We want only prefixable values here.

          if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;
          var cacheKey = property + value;
          if (cache[cacheKey] != null) return cache[cacheKey]; // IE can even throw an error in some cases, for e.g. style.content = 'bar'

          try {
            // Test value as it is.
            el.style[property] = value;
          } catch (err) {
            cache[cacheKey] = false;
            return false;
          } // Value is supported as it is.


          if (el.style[property] !== '') {
            cache[cacheKey] = value;
          } else {
            // Test value with vendor prefix.
            value = _prefix2['default'].css + value; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

            if (value === '-ms-flex') value = '-ms-flexbox';
            el.style[property] = value; // Value is supported with vendor prefix.

            if (el.style[property] !== '') cache[cacheKey] = value;
          }

          if (!cache[cacheKey]) cache[cacheKey] = false; // Reset style value.

          el.style[property] = '';
          return cache[cacheKey];
        }
        /***/

      },

      /***/
      "./node_modules/jss-preset-default/node_modules/jss-vendor-prefixer/lib/index.js":
      /*!***************************************************************************************!*\
        !*** ./node_modules/jss-preset-default/node_modules/jss-vendor-prefixer/lib/index.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssPresetDefaultNode_modulesJssVendorPrefixerLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = jssVendorPrefixer;

        var _cssVendor = __webpack_require__(
        /*! css-vendor */
        "./node_modules/jss-preset-default/node_modules/css-vendor/lib/index.js");

        var vendor = _interopRequireWildcard(_cssVendor);

        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};

            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }

            newObj['default'] = obj;
            return newObj;
          }
        }
        /**
         * Add vendor prefix to a property name when needed.
         *
         * @param {Rule} rule
         * @api public
         */


        function jssVendorPrefixer() {
          function onProcessRule(rule) {
            if (rule.type === 'keyframes') {
              rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
            }
          }

          function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;

            for (var prop in style) {
              var value = style[prop];
              var changeProp = false;
              var supportedProp = vendor.supportedProperty(prop);
              if (supportedProp && supportedProp !== prop) changeProp = true;
              var changeValue = false;
              var supportedValue = vendor.supportedValue(supportedProp, value);
              if (supportedValue && supportedValue !== value) changeValue = true;

              if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue || value;
              }
            }

            return style;
          }

          function onChangeValue(value, prop) {
            return vendor.supportedValue(prop, value);
          }

          return {
            onProcessRule: onProcessRule,
            onProcessStyle: onProcessStyle,
            onChangeValue: onChangeValue
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-props-sort/lib/index.js":
      /*!**************************************************!*\
        !*** ./node_modules/jss-props-sort/lib/index.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssPropsSortLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = jssPropsSort;
        /**
         * Sort props by length.
         */

        function jssPropsSort() {
          function sort(prop0, prop1) {
            return prop0.length - prop1.length;
          }

          function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);

            for (var prop in props) {
              newStyle[props[prop]] = style[props[prop]];
            }

            return newStyle;
          }

          return {
            onProcessStyle: onProcessStyle
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss-template/lib/index.js":
      /*!************************************************!*\
        !*** ./node_modules/jss-template/lib/index.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssTemplateLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _parse = __webpack_require__(
        /*! ./parse */
        "./node_modules/jss-template/lib/parse.js");

        var _parse2 = _interopRequireDefault(_parse);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var onProcessRule = function onProcessRule(rule) {
          if (typeof rule.style === 'string') {
            rule.style = (0, _parse2['default'])(rule.style);
          }
        };

        exports['default'] = function () {
          return {
            onProcessRule: onProcessRule
          };
        };
        /***/

      },

      /***/
      "./node_modules/jss-template/lib/parse.js":
      /*!************************************************!*\
        !*** ./node_modules/jss-template/lib/parse.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssTemplateLibParseJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var semiWithNl = /;\n/;
        /**
         * Naive CSS parser.
         * - Supports only rule body (no selectors)
         * - Requires semicolon and new line after the value (except of last line)
         * - No nested rules support
         */

        exports['default'] = function (cssText) {
          var style = {};
          var split = cssText.split(semiWithNl);

          for (var i = 0; i < split.length; i++) {
            var decl = (split[i] || '').trim();
            if (!decl) continue;
            var colonIndex = decl.indexOf(':');

            if (colonIndex === -1) {
              (0, _warning2['default'])(false, 'Malformed CSS string "%s"', decl);
              continue;
            }

            var prop = decl.substr(0, colonIndex).trim();
            var value = decl.substr(colonIndex + 1).trim();
            style[prop] = value;
          }

          return style;
        };
        /***/

      },

      /***/
      "./node_modules/jss-vendor-prefixer/lib/index.js":
      /*!*******************************************************!*\
        !*** ./node_modules/jss-vendor-prefixer/lib/index.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssVendorPrefixerLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = jssVendorPrefixer;

        var _cssVendor = __webpack_require__(
        /*! css-vendor */
        "./node_modules/css-vendor/dist/css-vendor.esm.js");

        var vendor = _interopRequireWildcard(_cssVendor);

        var _jss = __webpack_require__(
        /*! jss */
        "./node_modules/jss/lib/index.js");

        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};

            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }

            newObj['default'] = obj;
            return newObj;
          }
        }
        /**
         * Add vendor prefix to a property name when needed.
         *
         * @param {Rule} rule
         * @api public
         */


        function jssVendorPrefixer() {
          function onProcessRule(rule) {
            if (rule.type === 'keyframes') {
              rule.key = vendor.supportedKeyframes(rule.key);
            }
          }

          function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;

            for (var prop in style) {
              var value = style[prop];
              var changeProp = false;
              var supportedProp = vendor.supportedProperty(prop);
              if (supportedProp && supportedProp !== prop) changeProp = true;
              var changeValue = false;
              var supportedValue = vendor.supportedValue(supportedProp, (0, _jss.toCssValue)(value));
              if (supportedValue && supportedValue !== value) changeValue = true;

              if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue || value;
              }
            }

            return style;
          }

          function onChangeValue(value, prop) {
            return vendor.supportedValue(prop, (0, _jss.toCssValue)(value)) || value;
          }

          return {
            onProcessRule: onProcessRule,
            onProcessStyle: onProcessStyle,
            onChangeValue: onChangeValue
          };
        }
        /***/

      },

      /***/
      "./node_modules/jss/lib/Jss.js":
      /*!*************************************!*\
        !*** ./node_modules/jss/lib/Jss.js ***!
        \*************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibJssJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _isInBrowser = __webpack_require__(
        /*! is-in-browser */
        "./node_modules/is-in-browser/dist/module.js");

        var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

        var _StyleSheet = __webpack_require__(
        /*! ./StyleSheet */
        "./node_modules/jss/lib/StyleSheet.js");

        var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

        var _PluginsRegistry = __webpack_require__(
        /*! ./PluginsRegistry */
        "./node_modules/jss/lib/PluginsRegistry.js");

        var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

        var _rules = __webpack_require__(
        /*! ./plugins/rules */
        "./node_modules/jss/lib/plugins/rules.js");

        var _rules2 = _interopRequireDefault(_rules);

        var _observables = __webpack_require__(
        /*! ./plugins/observables */
        "./node_modules/jss/lib/plugins/observables.js");

        var _observables2 = _interopRequireDefault(_observables);

        var _functions = __webpack_require__(
        /*! ./plugins/functions */
        "./node_modules/jss/lib/plugins/functions.js");

        var _functions2 = _interopRequireDefault(_functions);

        var _sheets = __webpack_require__(
        /*! ./sheets */
        "./node_modules/jss/lib/sheets.js");

        var _sheets2 = _interopRequireDefault(_sheets);

        var _StyleRule = __webpack_require__(
        /*! ./rules/StyleRule */
        "./node_modules/jss/lib/rules/StyleRule.js");

        var _StyleRule2 = _interopRequireDefault(_StyleRule);

        var _createGenerateClassName = __webpack_require__(
        /*! ./utils/createGenerateClassName */
        "./node_modules/jss/lib/utils/createGenerateClassName.js");

        var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

        var _createRule2 = __webpack_require__(
        /*! ./utils/createRule */
        "./node_modules/jss/lib/utils/createRule.js");

        var _createRule3 = _interopRequireDefault(_createRule2);

        var _DomRenderer = __webpack_require__(
        /*! ./renderers/DomRenderer */
        "./node_modules/jss/lib/renderers/DomRenderer.js");

        var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

        var _VirtualRenderer = __webpack_require__(
        /*! ./renderers/VirtualRenderer */
        "./node_modules/jss/lib/renderers/VirtualRenderer.js");

        var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

        var instanceCounter = 0;

        var Jss = function () {
          function Jss(options) {
            _classCallCheck(this, Jss);

            this.id = instanceCounter++;
            this.version = "9.8.7";
            this.plugins = new _PluginsRegistry2['default']();
            this.options = {
              createGenerateClassName: _createGenerateClassName2['default'],
              Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
              plugins: []
            };
            this.generateClassName = (0, _createGenerateClassName2['default'])(); // eslint-disable-next-line prefer-spread

            this.use.apply(this, defaultPlugins);
            this.setup(options);
          }

          _createClass(Jss, [{
            key: 'setup',
            value: function setup() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

              if (options.createGenerateClassName) {
                this.options.createGenerateClassName = options.createGenerateClassName; // $FlowFixMe

                this.generateClassName = options.createGenerateClassName();
              }

              if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

              if (options.virtual || options.Renderer) {
                this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
              } // eslint-disable-next-line prefer-spread


              if (options.plugins) this.use.apply(this, options.plugins);
              return this;
            }
            /**
             * Create a Style Sheet.
             */

          }, {
            key: 'createStyleSheet',
            value: function createStyleSheet(styles) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var index = options.index;

              if (typeof index !== 'number') {
                index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
              }

              var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
                jss: this,
                generateClassName: options.generateClassName || this.generateClassName,
                insertionPoint: this.options.insertionPoint,
                Renderer: this.options.Renderer,
                index: index
              }));
              this.plugins.onProcessSheet(sheet);
              return sheet;
            }
            /**
             * Detach the Style Sheet and remove it from the registry.
             */

          }, {
            key: 'removeStyleSheet',
            value: function removeStyleSheet(sheet) {
              sheet.detach();

              _sheets2['default'].remove(sheet);

              return this;
            }
            /**
             * Create a rule without a Style Sheet.
             */

          }, {
            key: 'createRule',
            value: function createRule(name) {
              var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}; // Enable rule without name for inline styles.

              if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
                options = style;
                style = name;
                name = undefined;
              } // Cast from RuleFactoryOptions to RuleOptions
              // https://stackoverflow.com/questions/41328728/force-casting-in-flow


              var ruleOptions = options;
              ruleOptions.jss = this;
              ruleOptions.Renderer = this.options.Renderer;
              if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
              if (!ruleOptions.classes) ruleOptions.classes = {};
              var rule = (0, _createRule3['default'])(name, style, ruleOptions);

              if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
                rule.selector = '.' + ruleOptions.generateClassName(rule);
              }

              this.plugins.onProcessRule(rule);
              return rule;
            }
            /**
             * Register plugin. Passed function will be invoked with a rule instance.
             */

          }, {
            key: 'use',
            value: function use() {
              var _this = this;

              for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
                plugins[_key] = arguments[_key];
              }

              plugins.forEach(function (plugin) {
                // Avoids applying same plugin twice, at least based on ref.
                if (_this.options.plugins.indexOf(plugin) === -1) {
                  _this.options.plugins.push(plugin);

                  _this.plugins.use(plugin);
                }
              });
              return this;
            }
          }]);

          return Jss;
        }();

        exports['default'] = Jss;
        /***/
      },

      /***/
      "./node_modules/jss/lib/PluginsRegistry.js":
      /*!*************************************************!*\
        !*** ./node_modules/jss/lib/PluginsRegistry.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibPluginsRegistryJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var PluginsRegistry = function () {
          function PluginsRegistry() {
            _classCallCheck(this, PluginsRegistry);

            this.hooks = {
              onCreateRule: [],
              onProcessRule: [],
              onProcessStyle: [],
              onProcessSheet: [],
              onChangeValue: [],
              onUpdate: []
              /**
               * Call `onCreateRule` hooks and return an object if returned by a hook.
               */

            };
          }

          _createClass(PluginsRegistry, [{
            key: 'onCreateRule',
            value: function onCreateRule(name, decl, options) {
              for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
                var rule = this.hooks.onCreateRule[i](name, decl, options);
                if (rule) return rule;
              }

              return null;
            }
            /**
             * Call `onProcessRule` hooks.
             */

          }, {
            key: 'onProcessRule',
            value: function onProcessRule(rule) {
              if (rule.isProcessed) return;
              var sheet = rule.options.sheet;

              for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
                this.hooks.onProcessRule[i](rule, sheet);
              } // $FlowFixMe


              if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
              rule.isProcessed = true;
            }
            /**
             * Call `onProcessStyle` hooks.
             */

          }, {
            key: 'onProcessStyle',
            value: function onProcessStyle(style, rule, sheet) {
              var nextStyle = style;

              for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
                nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet); // $FlowFixMe

                rule.style = nextStyle;
              }
            }
            /**
             * Call `onProcessSheet` hooks.
             */

          }, {
            key: 'onProcessSheet',
            value: function onProcessSheet(sheet) {
              for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
                this.hooks.onProcessSheet[i](sheet);
              }
            }
            /**
             * Call `onUpdate` hooks.
             */

          }, {
            key: 'onUpdate',
            value: function onUpdate(data, rule, sheet) {
              for (var i = 0; i < this.hooks.onUpdate.length; i++) {
                this.hooks.onUpdate[i](data, rule, sheet);
              }
            }
            /**
             * Call `onChangeValue` hooks.
             */

          }, {
            key: 'onChangeValue',
            value: function onChangeValue(value, prop, rule) {
              var processedValue = value;

              for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
                processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
              }

              return processedValue;
            }
            /**
             * Register a plugin.
             * If function is passed, it is a shortcut for `{onProcessRule}`.
             */

          }, {
            key: 'use',
            value: function use(plugin) {
              for (var name in plugin) {
                if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
              }
            }
          }]);

          return PluginsRegistry;
        }();

        exports['default'] = PluginsRegistry;
        /***/
      },

      /***/
      "./node_modules/jss/lib/RuleList.js":
      /*!******************************************!*\
        !*** ./node_modules/jss/lib/RuleList.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRuleListJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _createRule = __webpack_require__(
        /*! ./utils/createRule */
        "./node_modules/jss/lib/utils/createRule.js");

        var _createRule2 = _interopRequireDefault(_createRule);

        var _linkRule = __webpack_require__(
        /*! ./utils/linkRule */
        "./node_modules/jss/lib/utils/linkRule.js");

        var _linkRule2 = _interopRequireDefault(_linkRule);

        var _StyleRule = __webpack_require__(
        /*! ./rules/StyleRule */
        "./node_modules/jss/lib/rules/StyleRule.js");

        var _StyleRule2 = _interopRequireDefault(_StyleRule);

        var _escape = __webpack_require__(
        /*! ./utils/escape */
        "./node_modules/jss/lib/utils/escape.js");

        var _escape2 = _interopRequireDefault(_escape);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /**
         * Contains rules objects and allows adding/removing etc.
         * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
         */


        var RuleList = function () {
          // Original styles object.
          function RuleList(options) {
            var _this = this;

            _classCallCheck(this, RuleList);

            this.map = {};
            this.raw = {};
            this.index = [];

            this.update = function (name, data) {
              var _options = _this.options,
                  plugins = _options.jss.plugins,
                  sheet = _options.sheet;

              if (typeof name === 'string') {
                plugins.onUpdate(data, _this.get(name), sheet);
              } else {
                for (var index = 0; index < _this.index.length; index++) {
                  plugins.onUpdate(name, _this.index[index], sheet);
                }
              }
            };

            this.options = options;
            this.classes = options.classes;
          }
          /**
           * Create and register rule.
           *
           * Will not render after Style Sheet was rendered the first time.
           */
          // Used to ensure correct rules order.
          // Rules registry for access by .get() method.
          // It contains the same rule registered by name and by selector.


          _createClass(RuleList, [{
            key: 'add',
            value: function add(name, decl, options) {
              var _options2 = this.options,
                  parent = _options2.parent,
                  sheet = _options2.sheet,
                  jss = _options2.jss,
                  Renderer = _options2.Renderer,
                  generateClassName = _options2.generateClassName;
              options = _extends({
                classes: this.classes,
                parent: parent,
                sheet: sheet,
                jss: jss,
                Renderer: Renderer,
                generateClassName: generateClassName
              }, options);

              if (!options.selector && this.classes[name]) {
                options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
              }

              this.raw[name] = decl;
              var rule = (0, _createRule2['default'])(name, decl, options);
              var className = void 0;

              if (!options.selector && rule instanceof _StyleRule2['default']) {
                className = generateClassName(rule, sheet);
                rule.selector = '.' + (0, _escape2['default'])(className);
              }

              this.register(rule, className);
              var index = options.index === undefined ? this.index.length : options.index;
              this.index.splice(index, 0, rule);
              return rule;
            }
            /**
             * Get a rule.
             */

          }, {
            key: 'get',
            value: function get(name) {
              return this.map[name];
            }
            /**
             * Delete a rule.
             */

          }, {
            key: 'remove',
            value: function remove(rule) {
              this.unregister(rule);
              this.index.splice(this.indexOf(rule), 1);
            }
            /**
             * Get index of a rule.
             */

          }, {
            key: 'indexOf',
            value: function indexOf(rule) {
              return this.index.indexOf(rule);
            }
            /**
             * Run `onProcessRule()` plugins on every rule.
             */

          }, {
            key: 'process',
            value: function process() {
              var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
              // we end up with very hard-to-track-down side effects.

              this.index.slice(0).forEach(plugins.onProcessRule, plugins);
            }
            /**
             * Register a rule in `.map` and `.classes` maps.
             */

          }, {
            key: 'register',
            value: function register(rule, className) {
              this.map[rule.key] = rule;

              if (rule instanceof _StyleRule2['default']) {
                this.map[rule.selector] = rule;
                if (className) this.classes[rule.key] = className;
              }
            }
            /**
             * Unregister a rule.
             */

          }, {
            key: 'unregister',
            value: function unregister(rule) {
              delete this.map[rule.key];

              if (rule instanceof _StyleRule2['default']) {
                delete this.map[rule.selector];
                delete this.classes[rule.key];
              }
            }
            /**
             * Update the function values with a new data.
             */

          }, {
            key: 'link',

            /**
             * Link renderable rules with CSSRuleList.
             */
            value: function link(cssRules) {
              var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

              for (var i = 0; i < cssRules.length; i++) {
                var cssRule = cssRules[i];

                var _key = this.options.sheet.renderer.getKey(cssRule);

                if (map[_key]) _key = map[_key];
                var rule = this.map[_key];
                if (rule) (0, _linkRule2['default'])(rule, cssRule);
              }
            }
            /**
             * Convert rules to a CSS string.
             */

          }, {
            key: 'toString',
            value: function toString(options) {
              var str = '';
              var sheet = this.options.sheet;
              var link = sheet ? sheet.options.link : false;

              for (var index = 0; index < this.index.length; index++) {
                var rule = this.index[index];
                var css = rule.toString(options); // No need to render an empty rule.

                if (!css && !link) continue;
                if (str) str += '\n';
                str += css;
              }

              return str;
            }
          }]);

          return RuleList;
        }();

        exports['default'] = RuleList;
        /***/
      },

      /***/
      "./node_modules/jss/lib/SheetsManager.js":
      /*!***********************************************!*\
        !*** ./node_modules/jss/lib/SheetsManager.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibSheetsManagerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /**
         * SheetsManager is like a WeakMap which is designed to count StyleSheet
         * instances and attach/detach automatically.
         */


        var SheetsManager = function () {
          function SheetsManager() {
            _classCallCheck(this, SheetsManager);

            this.sheets = [];
            this.refs = [];
            this.keys = [];
          }

          _createClass(SheetsManager, [{
            key: 'get',
            value: function get(key) {
              var index = this.keys.indexOf(key);
              return this.sheets[index];
            }
          }, {
            key: 'add',
            value: function add(key, sheet) {
              var sheets = this.sheets,
                  refs = this.refs,
                  keys = this.keys;
              var index = sheets.indexOf(sheet);
              if (index !== -1) return index;
              sheets.push(sheet);
              refs.push(0);
              keys.push(key);
              return sheets.length - 1;
            }
          }, {
            key: 'manage',
            value: function manage(key) {
              var index = this.keys.indexOf(key);
              var sheet = this.sheets[index];
              if (this.refs[index] === 0) sheet.attach();
              this.refs[index]++;
              if (!this.keys[index]) this.keys.splice(index, 0, key);
              return sheet;
            }
          }, {
            key: 'unmanage',
            value: function unmanage(key) {
              var index = this.keys.indexOf(key);

              if (index === -1) {
                // eslint-ignore-next-line no-console
                (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
                return;
              }

              if (this.refs[index] > 0) {
                this.refs[index]--;
                if (this.refs[index] === 0) this.sheets[index].detach();
              }
            }
          }, {
            key: 'size',
            get: function get() {
              return this.keys.length;
            }
          }]);

          return SheetsManager;
        }();

        exports['default'] = SheetsManager;
        /***/
      },

      /***/
      "./node_modules/jss/lib/SheetsRegistry.js":
      /*!************************************************!*\
        !*** ./node_modules/jss/lib/SheetsRegistry.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibSheetsRegistryJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /**
         * Sheets registry to access them all at one place.
         */


        var SheetsRegistry = function () {
          function SheetsRegistry() {
            _classCallCheck(this, SheetsRegistry);

            this.registry = [];
          }

          _createClass(SheetsRegistry, [{
            key: 'add',

            /**
             * Register a Style Sheet.
             */
            value: function add(sheet) {
              var registry = this.registry;
              var index = sheet.options.index;
              if (registry.indexOf(sheet) !== -1) return;

              if (registry.length === 0 || index >= this.index) {
                registry.push(sheet);
                return;
              } // Find a position.


              for (var i = 0; i < registry.length; i++) {
                if (registry[i].options.index > index) {
                  registry.splice(i, 0, sheet);
                  return;
                }
              }
            }
            /**
             * Reset the registry.
             */

          }, {
            key: 'reset',
            value: function reset() {
              this.registry = [];
            }
            /**
             * Remove a Style Sheet.
             */

          }, {
            key: 'remove',
            value: function remove(sheet) {
              var index = this.registry.indexOf(sheet);
              this.registry.splice(index, 1);
            }
            /**
             * Convert all attached sheets to a CSS string.
             */

          }, {
            key: 'toString',
            value: function toString(options) {
              return this.registry.filter(function (sheet) {
                return sheet.attached;
              }).map(function (sheet) {
                return sheet.toString(options);
              }).join('\n');
            }
          }, {
            key: 'index',

            /**
             * Current highest index number.
             */
            get: function get() {
              return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
          }]);

          return SheetsRegistry;
        }();

        exports['default'] = SheetsRegistry;
        /***/
      },

      /***/
      "./node_modules/jss/lib/StyleSheet.js":
      /*!********************************************!*\
        !*** ./node_modules/jss/lib/StyleSheet.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibStyleSheetJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _linkRule = __webpack_require__(
        /*! ./utils/linkRule */
        "./node_modules/jss/lib/utils/linkRule.js");

        var _linkRule2 = _interopRequireDefault(_linkRule);

        var _RuleList = __webpack_require__(
        /*! ./RuleList */
        "./node_modules/jss/lib/RuleList.js");

        var _RuleList2 = _interopRequireDefault(_RuleList);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /* eslint-disable-next-line no-use-before-define */


        var StyleSheet = function () {
          function StyleSheet(styles, options) {
            var _this = this;

            _classCallCheck(this, StyleSheet);

            this.update = function (name, data) {
              if (typeof name === 'string') {
                _this.rules.update(name, data);
              } else {
                _this.rules.update(name);
              }

              return _this;
            };

            this.attached = false;
            this.deployed = false;
            this.linked = false;
            this.classes = {};
            this.options = _extends({}, options, {
              sheet: this,
              parent: this,
              classes: this.classes
            });
            this.renderer = new options.Renderer(this);
            this.rules = new _RuleList2['default'](this.options);

            for (var _name in styles) {
              this.rules.add(_name, styles[_name]);
            }

            this.rules.process();
          }
          /**
           * Attach renderable to the render tree.
           */


          _createClass(StyleSheet, [{
            key: 'attach',
            value: function attach() {
              if (this.attached) return this;
              if (!this.deployed) this.deploy();
              this.renderer.attach();
              if (!this.linked && this.options.link) this.link();
              this.attached = true;
              return this;
            }
            /**
             * Remove renderable from render tree.
             */

          }, {
            key: 'detach',
            value: function detach() {
              if (!this.attached) return this;
              this.renderer.detach();
              this.attached = false;
              return this;
            }
            /**
             * Add a rule to the current stylesheet.
             * Will insert a rule also after the stylesheet has been rendered first time.
             */

          }, {
            key: 'addRule',
            value: function addRule(name, decl, options) {
              var queue = this.queue; // Plugins can create rules.
              // In order to preserve the right order, we need to queue all `.addRule` calls,
              // which happen after the first `rules.add()` call.

              if (this.attached && !queue) this.queue = [];
              var rule = this.rules.add(name, decl, options);
              this.options.jss.plugins.onProcessRule(rule);

              if (this.attached) {
                if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
                // It will be inserted all together when .attach is called.

                if (queue) queue.push(rule);else {
                  this.insertRule(rule);

                  if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                  }
                }
                return rule;
              } // We can't add rules to a detached style node.
              // We will redeploy the sheet once user will attach it.


              this.deployed = false;
              return rule;
            }
            /**
             * Insert rule into the StyleSheet
             */

          }, {
            key: 'insertRule',
            value: function insertRule(rule) {
              var renderable = this.renderer.insertRule(rule);
              if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
            }
            /**
             * Create and add rules.
             * Will render also after Style Sheet was rendered the first time.
             */

          }, {
            key: 'addRules',
            value: function addRules(styles, options) {
              var added = [];

              for (var _name2 in styles) {
                added.push(this.addRule(_name2, styles[_name2], options));
              }

              return added;
            }
            /**
             * Get a rule by name.
             */

          }, {
            key: 'getRule',
            value: function getRule(name) {
              return this.rules.get(name);
            }
            /**
             * Delete a rule by name.
             * Returns `true`: if rule has been deleted from the DOM.
             */

          }, {
            key: 'deleteRule',
            value: function deleteRule(name) {
              var rule = this.rules.get(name);
              if (!rule) return false;
              this.rules.remove(rule);

              if (this.attached && rule.renderable) {
                return this.renderer.deleteRule(rule.renderable);
              }

              return true;
            }
            /**
             * Get index of a rule.
             */

          }, {
            key: 'indexOf',
            value: function indexOf(rule) {
              return this.rules.indexOf(rule);
            }
            /**
             * Deploy pure CSS string to a renderable.
             */

          }, {
            key: 'deploy',
            value: function deploy() {
              this.renderer.deploy();
              this.deployed = true;
              return this;
            }
            /**
             * Link renderable CSS rules from sheet with their corresponding models.
             */

          }, {
            key: 'link',
            value: function link() {
              var cssRules = this.renderer.getRules(); // Is undefined when VirtualRenderer is used.

              if (cssRules) this.rules.link(cssRules);
              this.linked = true;
              return this;
            }
            /**
             * Update the function values with a new data.
             */

          }, {
            key: 'toString',

            /**
             * Convert rules to a CSS string.
             */
            value: function toString(options) {
              return this.rules.toString(options);
            }
          }]);

          return StyleSheet;
        }();

        exports['default'] = StyleSheet;
        /***/
      },

      /***/
      "./node_modules/jss/lib/index.js":
      /*!***************************************!*\
        !*** ./node_modules/jss/lib/index.js ***!
        \***************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

        var _getDynamicStyles = __webpack_require__(
        /*! ./utils/getDynamicStyles */
        "./node_modules/jss/lib/utils/getDynamicStyles.js");

        Object.defineProperty(exports, 'getDynamicStyles', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_getDynamicStyles)['default'];
          }
        });

        var _toCssValue = __webpack_require__(
        /*! ./utils/toCssValue */
        "./node_modules/jss/lib/utils/toCssValue.js");

        Object.defineProperty(exports, 'toCssValue', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_toCssValue)['default'];
          }
        });

        var _SheetsRegistry = __webpack_require__(
        /*! ./SheetsRegistry */
        "./node_modules/jss/lib/SheetsRegistry.js");

        Object.defineProperty(exports, 'SheetsRegistry', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_SheetsRegistry)['default'];
          }
        });

        var _SheetsManager = __webpack_require__(
        /*! ./SheetsManager */
        "./node_modules/jss/lib/SheetsManager.js");

        Object.defineProperty(exports, 'SheetsManager', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_SheetsManager)['default'];
          }
        });

        var _RuleList = __webpack_require__(
        /*! ./RuleList */
        "./node_modules/jss/lib/RuleList.js");

        Object.defineProperty(exports, 'RuleList', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_RuleList)['default'];
          }
        });

        var _sheets = __webpack_require__(
        /*! ./sheets */
        "./node_modules/jss/lib/sheets.js");

        Object.defineProperty(exports, 'sheets', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_sheets)['default'];
          }
        });

        var _createGenerateClassName = __webpack_require__(
        /*! ./utils/createGenerateClassName */
        "./node_modules/jss/lib/utils/createGenerateClassName.js");

        Object.defineProperty(exports, 'createGenerateClassName', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_createGenerateClassName)['default'];
          }
        });

        var _Jss = __webpack_require__(
        /*! ./Jss */
        "./node_modules/jss/lib/Jss.js");

        var _Jss2 = _interopRequireDefault(_Jss);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        /**
         * Creates a new instance of Jss.
         */


        var create = exports.create = function create(options) {
          return new _Jss2['default'](options);
        };
        /**
         * A global Jss instance.
         */


        exports['default'] = create();
        /***/
      },

      /***/
      "./node_modules/jss/lib/plugins/functions.js":
      /*!***************************************************!*\
        !*** ./node_modules/jss/lib/plugins/functions.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibPluginsFunctionsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _RuleList = __webpack_require__(
        /*! ../RuleList */
        "./node_modules/jss/lib/RuleList.js");

        var _RuleList2 = _interopRequireDefault(_RuleList);

        var _StyleRule = __webpack_require__(
        /*! ../rules/StyleRule */
        "./node_modules/jss/lib/rules/StyleRule.js");

        var _StyleRule2 = _interopRequireDefault(_StyleRule);

        var _createRule = __webpack_require__(
        /*! ../utils/createRule */
        "./node_modules/jss/lib/utils/createRule.js");

        var _createRule2 = _interopRequireDefault(_createRule);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        } // A symbol replacement.


        var now = Date.now();
        var fnValuesNs = 'fnValues' + now;
        var fnStyleNs = 'fnStyle' + ++now;
        exports['default'] = {
          onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, _createRule2['default'])(name, {}, options);
            rule[fnStyleNs] = decl;
            return rule;
          },
          onProcessStyle: function onProcessStyle(style, rule) {
            var fn = {};

            for (var prop in style) {
              var value = style[prop];
              if (typeof value !== 'function') continue;
              delete style[prop];
              fn[prop] = value;
            }

            rule = rule;
            rule[fnValuesNs] = fn;
            return style;
          },
          onUpdate: function onUpdate(data, rule) {
            // It is a rules container like for e.g. ConditionalRule.
            if (rule.rules instanceof _RuleList2['default']) {
              rule.rules.update(data);
              return;
            }

            if (!(rule instanceof _StyleRule2['default'])) return;
            rule = rule; // If we have a fn values map, it is a rule with function values.

            if (rule[fnValuesNs]) {
              for (var prop in rule[fnValuesNs]) {
                rule.prop(prop, rule[fnValuesNs][prop](data));
              }
            }

            rule = rule;
            var fnStyle = rule[fnStyleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.

            if (fnStyle) {
              var style = fnStyle(data);

              for (var _prop in style) {
                rule.prop(_prop, style[_prop]);
              }
            }
          }
        };
        /***/
      },

      /***/
      "./node_modules/jss/lib/plugins/observables.js":
      /*!*****************************************************!*\
        !*** ./node_modules/jss/lib/plugins/observables.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibPluginsObservablesJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _StyleRule = __webpack_require__(
        /*! ../rules/StyleRule */
        "./node_modules/jss/lib/rules/StyleRule.js");

        var _StyleRule2 = _interopRequireDefault(_StyleRule);

        var _createRule = __webpack_require__(
        /*! ../utils/createRule */
        "./node_modules/jss/lib/utils/createRule.js");

        var _createRule2 = _interopRequireDefault(_createRule);

        var _isObservable = __webpack_require__(
        /*! ../utils/isObservable */
        "./node_modules/jss/lib/utils/isObservable.js");

        var _isObservable2 = _interopRequireDefault(_isObservable);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        exports['default'] = {
          onCreateRule: function onCreateRule(name, decl, options) {
            if (!(0, _isObservable2['default'])(decl)) return null; // Cast `decl` to `Observable`, since it passed the type guard.

            var style$ = decl;
            var rule = (0, _createRule2['default'])(name, {}, options); // TODO
            // Call `stream.subscribe()` returns a subscription, which should be explicitly
            // unsubscribed from when we know this sheet is no longer needed.

            style$.subscribe(function (style) {
              for (var prop in style) {
                rule.prop(prop, style[prop]);
              }
            });
            return rule;
          },
          onProcessRule: function onProcessRule(rule) {
            if (!(rule instanceof _StyleRule2['default'])) return;
            var styleRule = rule;
            var style = styleRule.style;

            var _loop = function _loop(prop) {
              var value = style[prop];
              if (!(0, _isObservable2['default'])(value)) return 'continue';
              delete style[prop];
              value.subscribe({
                next: function next(nextValue) {
                  styleRule.prop(prop, nextValue);
                }
              });
            };

            for (var prop in style) {
              var _ret = _loop(prop);

              if (_ret === 'continue') continue;
            }
          }
        };
        /***/
      },

      /***/
      "./node_modules/jss/lib/plugins/rules.js":
      /*!***********************************************!*\
        !*** ./node_modules/jss/lib/plugins/rules.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibPluginsRulesJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _SimpleRule = __webpack_require__(
        /*! ../rules/SimpleRule */
        "./node_modules/jss/lib/rules/SimpleRule.js");

        var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

        var _KeyframesRule = __webpack_require__(
        /*! ../rules/KeyframesRule */
        "./node_modules/jss/lib/rules/KeyframesRule.js");

        var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

        var _ConditionalRule = __webpack_require__(
        /*! ../rules/ConditionalRule */
        "./node_modules/jss/lib/rules/ConditionalRule.js");

        var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

        var _FontFaceRule = __webpack_require__(
        /*! ../rules/FontFaceRule */
        "./node_modules/jss/lib/rules/FontFaceRule.js");

        var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

        var _ViewportRule = __webpack_require__(
        /*! ../rules/ViewportRule */
        "./node_modules/jss/lib/rules/ViewportRule.js");

        var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var classes = {
          '@charset': _SimpleRule2['default'],
          '@import': _SimpleRule2['default'],
          '@namespace': _SimpleRule2['default'],
          '@keyframes': _KeyframesRule2['default'],
          '@media': _ConditionalRule2['default'],
          '@supports': _ConditionalRule2['default'],
          '@font-face': _FontFaceRule2['default'],
          '@viewport': _ViewportRule2['default'],
          '@-ms-viewport': _ViewportRule2['default']
          /**
           * Generate plugins which will register all rules.
           */

        };
        var plugins = Object.keys(classes).map(function (key) {
          // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
          var re = new RegExp('^' + key);
          var RuleClass = classes[key];

          var onCreateRule = function onCreateRule(name, decl, options) {
            return re.test(name) ? new RuleClass(name, decl, options) : null;
          };

          return {
            onCreateRule: onCreateRule
          };
        });
        exports['default'] = plugins;
        /***/
      },

      /***/
      "./node_modules/jss/lib/renderers/DomRenderer.js":
      /*!*******************************************************!*\
        !*** ./node_modules/jss/lib/renderers/DomRenderer.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRenderersDomRendererJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        var _sheets = __webpack_require__(
        /*! ../sheets */
        "./node_modules/jss/lib/sheets.js");

        var _sheets2 = _interopRequireDefault(_sheets);

        var _StyleRule = __webpack_require__(
        /*! ../rules/StyleRule */
        "./node_modules/jss/lib/rules/StyleRule.js");

        var _StyleRule2 = _interopRequireDefault(_StyleRule);

        var _toCssValue = __webpack_require__(
        /*! ../utils/toCssValue */
        "./node_modules/jss/lib/utils/toCssValue.js");

        var _toCssValue2 = _interopRequireDefault(_toCssValue);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /**
         * Cache the value from the first time a function is called.
         */


        var memoize = function memoize(fn) {
          var value = void 0;
          return function () {
            if (!value) value = fn();
            return value;
          };
        };
        /**
         * Get a style property value.
         */


        function getPropertyValue(cssRule, prop) {
          try {
            return cssRule.style.getPropertyValue(prop);
          } catch (err) {
            // IE may throw if property is unknown.
            return '';
          }
        }
        /**
         * Set a style property.
         */


        function setProperty(cssRule, prop, value) {
          try {
            var cssValue = value;

            if (Array.isArray(value)) {
              cssValue = (0, _toCssValue2['default'])(value, true);

              if (value[value.length - 1] === '!important') {
                cssRule.style.setProperty(prop, cssValue, 'important');
                return true;
              }
            }

            cssRule.style.setProperty(prop, cssValue);
          } catch (err) {
            // IE may throw if property is unknown.
            return false;
          }

          return true;
        }
        /**
         * Remove a style property.
         */


        function removeProperty(cssRule, prop) {
          try {
            cssRule.style.removeProperty(prop);
          } catch (err) {
            (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
          }
        }

        var CSSRuleTypes = {
          STYLE_RULE: 1,
          KEYFRAMES_RULE: 7
          /**
           * Get the CSS Rule key.
           */

        };

        var getKey = function () {
          var extractKey = function extractKey(cssText) {
            var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return cssText.substr(from, cssText.indexOf('{') - 1);
          };

          return function (cssRule) {
            if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;

            if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
              var name = cssRule.name;
              if (name) return '@keyframes ' + name; // There is no rule.name in the following browsers:
              // - IE 9
              // - Safari 7.1.8
              // - Mobile Safari 9.0.0

              var cssText = cssRule.cssText;
              return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
            } // Conditionals.


            return extractKey(cssRule.cssText);
          };
        }();
        /**
         * Set the selector.
         */


        function setSelector(cssRule, selectorText) {
          cssRule.selectorText = selectorText; // Return false if setter was not successful.
          // Currently works in chrome only.

          return cssRule.selectorText === selectorText;
        }
        /**
         * Gets the `head` element upon the first call and caches it.
         */


        var getHead = memoize(function () {
          return document.head || document.getElementsByTagName('head')[0];
        });
        /**
         * Gets a map of rule keys, where the property is an unescaped key and value
         * is a potentially escaped one.
         * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
         * for CSSStyleRule we normally use `selectorText`. Though if original selector text
         * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
         * and so CSS rule's `selectorText` won't match JSS rule selector.
         *
         * https://www.w3.org/International/questions/qa-escapes#cssescapes
         */

        var getUnescapedKeysMap = function () {
          var style = void 0;
          var isAttached = false;
          return function (rules) {
            var map = {}; // https://github.com/facebook/flow/issues/2696

            if (!style) style = document.createElement('style');

            for (var i = 0; i < rules.length; i++) {
              var rule = rules[i];
              if (!(rule instanceof _StyleRule2['default'])) continue;
              var selector = rule.selector; // Only unescape selector over CSSOM if it contains a back slash.

              if (selector && selector.indexOf('\\') !== -1) {
                // Lazilly attach when needed.
                if (!isAttached) {
                  getHead().appendChild(style);
                  isAttached = true;
                }

                style.textContent = selector + ' {}';
                var _style = style,
                    sheet = _style.sheet;

                if (sheet) {
                  var cssRules = sheet.cssRules;
                  if (cssRules) map[cssRules[0].selectorText] = rule.key;
                }
              }
            }

            if (isAttached) {
              getHead().removeChild(style);
              isAttached = false;
            }

            return map;
          };
        }();
        /**
         * Find attached sheet with an index higher than the passed one.
         */


        function findHigherSheet(registry, options) {
          for (var i = 0; i < registry.length; i++) {
            var sheet = registry[i];

            if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
              return sheet;
            }
          }

          return null;
        }
        /**
         * Find attached sheet with the highest index.
         */


        function findHighestSheet(registry, options) {
          for (var i = registry.length - 1; i >= 0; i--) {
            var sheet = registry[i];

            if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
              return sheet;
            }
          }

          return null;
        }
        /**
         * Find a comment with "jss" inside.
         */


        function findCommentNode(text) {
          var head = getHead();

          for (var i = 0; i < head.childNodes.length; i++) {
            var node = head.childNodes[i];

            if (node.nodeType === 8 && node.nodeValue.trim() === text) {
              return node;
            }
          }

          return null;
        }
        /**
         * Find a node before which we can insert the sheet.
         */


        function findPrevNode(options) {
          var registry = _sheets2['default'].registry;

          if (registry.length > 0) {
            // Try to insert before the next higher sheet.
            var sheet = findHigherSheet(registry, options);
            if (sheet) return sheet.renderer.element; // Otherwise insert after the last attached.

            sheet = findHighestSheet(registry, options);
            if (sheet) return sheet.renderer.element.nextElementSibling;
          } // Try to find a comment placeholder if registry is empty.


          var insertionPoint = options.insertionPoint;

          if (insertionPoint && typeof insertionPoint === 'string') {
            var comment = findCommentNode(insertionPoint);
            if (comment) return comment.nextSibling; // If user specifies an insertion point and it can't be found in the document -
            // bad specificity issues may appear.

            (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
          }

          return null;
        }
        /**
         * Insert style element into the DOM.
         */


        function insertStyle(style, options) {
          var insertionPoint = options.insertionPoint;
          var prevNode = findPrevNode(options);

          if (prevNode) {
            var parentNode = prevNode.parentNode;
            if (parentNode) parentNode.insertBefore(style, prevNode);
            return;
          } // Works with iframes and any node types.


          if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
            // https://stackoverflow.com/questions/41328728/force-casting-in-flow
            var insertionPointElement = insertionPoint;
            var _parentNode = insertionPointElement.parentNode;
            if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
            return;
          }

          getHead().insertBefore(style, prevNode);
        }
        /**
         * Read jss nonce setting from the page if the user has set it.
         */


        var getNonce = memoize(function () {
          var node = document.querySelector('meta[property="csp-nonce"]');
          return node ? node.getAttribute('content') : null;
        });

        var DomRenderer = function () {
          function DomRenderer(sheet) {
            _classCallCheck(this, DomRenderer);

            this.getPropertyValue = getPropertyValue;
            this.setProperty = setProperty;
            this.removeProperty = removeProperty;
            this.setSelector = setSelector;
            this.getKey = getKey;
            this.getUnescapedKeysMap = getUnescapedKeysMap;
            this.hasInsertedRules = false; // There is no sheet when the renderer is used from a standalone StyleRule.

            if (sheet) _sheets2['default'].add(sheet);
            this.sheet = sheet;

            var _ref = this.sheet ? this.sheet.options : {},
                media = _ref.media,
                meta = _ref.meta,
                element = _ref.element;

            this.element = element || document.createElement('style');
            this.element.setAttribute('data-jss', '');
            if (media) this.element.setAttribute('media', media);
            if (meta) this.element.setAttribute('data-meta', meta);
            var nonce = getNonce();
            if (nonce) this.element.setAttribute('nonce', nonce);
          }
          /**
           * Insert style element into render tree.
           */
          // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


          _createClass(DomRenderer, [{
            key: 'attach',
            value: function attach() {
              // In the case the element node is external and it is already in the DOM.
              if (this.element.parentNode || !this.sheet) return; // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
              // browsers remove those rules.
              // TODO figure out if its a bug and if it is known.
              // Workaround is to redeploy the sheet before attaching as a string.

              if (this.hasInsertedRules) {
                this.deploy();
                this.hasInsertedRules = false;
              }

              insertStyle(this.element, this.sheet.options);
            }
            /**
             * Remove style element from render tree.
             */

          }, {
            key: 'detach',
            value: function detach() {
              this.element.parentNode.removeChild(this.element);
            }
            /**
             * Inject CSS string into element.
             */

          }, {
            key: 'deploy',
            value: function deploy() {
              if (!this.sheet) return;
              this.element.textContent = '\n' + this.sheet.toString() + '\n';
            }
            /**
             * Insert a rule into element.
             */

          }, {
            key: 'insertRule',
            value: function insertRule(rule, index) {
              var sheet = this.element.sheet;
              var cssRules = sheet.cssRules;
              var str = rule.toString();
              if (!index) index = cssRules.length;
              if (!str) return false;

              try {
                sheet.insertRule(str, index);
              } catch (err) {
                (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
                return false;
              }

              this.hasInsertedRules = true;
              return cssRules[index];
            }
            /**
             * Delete a rule.
             */

          }, {
            key: 'deleteRule',
            value: function deleteRule(cssRule) {
              var sheet = this.element.sheet;
              var index = this.indexOf(cssRule);
              if (index === -1) return false;
              sheet.deleteRule(index);
              return true;
            }
            /**
             * Get index of a CSS Rule.
             */

          }, {
            key: 'indexOf',
            value: function indexOf(cssRule) {
              var cssRules = this.element.sheet.cssRules;

              for (var _index = 0; _index < cssRules.length; _index++) {
                if (cssRule === cssRules[_index]) return _index;
              }

              return -1;
            }
            /**
             * Generate a new CSS rule and replace the existing one.
             */

          }, {
            key: 'replaceRule',
            value: function replaceRule(cssRule, rule) {
              var index = this.indexOf(cssRule);
              var newCssRule = this.insertRule(rule, index);
              this.element.sheet.deleteRule(index);
              return newCssRule;
            }
            /**
             * Get all rules elements.
             */

          }, {
            key: 'getRules',
            value: function getRules() {
              return this.element.sheet.cssRules;
            }
          }]);

          return DomRenderer;
        }();

        exports['default'] = DomRenderer;
        /***/
      },

      /***/
      "./node_modules/jss/lib/renderers/VirtualRenderer.js":
      /*!***********************************************************!*\
        !*** ./node_modules/jss/lib/renderers/VirtualRenderer.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRenderersVirtualRendererJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /* eslint-disable class-methods-use-this */

        /**
         * Rendering backend to do nothing in nodejs.
         */


        var VirtualRenderer = function () {
          function VirtualRenderer() {
            _classCallCheck(this, VirtualRenderer);
          }

          _createClass(VirtualRenderer, [{
            key: 'setProperty',
            value: function setProperty() {
              return true;
            }
          }, {
            key: 'getPropertyValue',
            value: function getPropertyValue() {
              return '';
            }
          }, {
            key: 'removeProperty',
            value: function removeProperty() {}
          }, {
            key: 'setSelector',
            value: function setSelector() {
              return true;
            }
          }, {
            key: 'getKey',
            value: function getKey() {
              return '';
            }
          }, {
            key: 'attach',
            value: function attach() {}
          }, {
            key: 'detach',
            value: function detach() {}
          }, {
            key: 'deploy',
            value: function deploy() {}
          }, {
            key: 'insertRule',
            value: function insertRule() {
              return false;
            }
          }, {
            key: 'deleteRule',
            value: function deleteRule() {
              return true;
            }
          }, {
            key: 'replaceRule',
            value: function replaceRule() {
              return false;
            }
          }, {
            key: 'getRules',
            value: function getRules() {}
          }, {
            key: 'indexOf',
            value: function indexOf() {
              return -1;
            }
          }]);

          return VirtualRenderer;
        }();

        exports['default'] = VirtualRenderer;
        /***/
      },

      /***/
      "./node_modules/jss/lib/rules/ConditionalRule.js":
      /*!*******************************************************!*\
        !*** ./node_modules/jss/lib/rules/ConditionalRule.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRulesConditionalRuleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _RuleList = __webpack_require__(
        /*! ../RuleList */
        "./node_modules/jss/lib/RuleList.js");

        var _RuleList2 = _interopRequireDefault(_RuleList);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /**
         * Conditional rule for @media, @supports
         */


        var ConditionalRule = function () {
          function ConditionalRule(key, styles, options) {
            _classCallCheck(this, ConditionalRule);

            this.type = 'conditional';
            this.isProcessed = false;
            this.key = key;
            this.options = options;
            this.rules = new _RuleList2['default'](_extends({}, options, {
              parent: this
            }));

            for (var name in styles) {
              this.rules.add(name, styles[name]);
            }

            this.rules.process();
          }
          /**
           * Get a rule.
           */


          _createClass(ConditionalRule, [{
            key: 'getRule',
            value: function getRule(name) {
              return this.rules.get(name);
            }
            /**
             * Get index of a rule.
             */

          }, {
            key: 'indexOf',
            value: function indexOf(rule) {
              return this.rules.indexOf(rule);
            }
            /**
             * Create and register rule, run plugins.
             */

          }, {
            key: 'addRule',
            value: function addRule(name, style, options) {
              var rule = this.rules.add(name, style, options);
              this.options.jss.plugins.onProcessRule(rule);
              return rule;
            }
            /**
             * Generates a CSS string.
             */

          }, {
            key: 'toString',
            value: function toString() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                indent: 1
              };
              var inner = this.rules.toString(options);
              return inner ? this.key + ' {\n' + inner + '\n}' : '';
            }
          }]);

          return ConditionalRule;
        }();

        exports['default'] = ConditionalRule;
        /***/
      },

      /***/
      "./node_modules/jss/lib/rules/FontFaceRule.js":
      /*!****************************************************!*\
        !*** ./node_modules/jss/lib/rules/FontFaceRule.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRulesFontFaceRuleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _toCss = __webpack_require__(
        /*! ../utils/toCss */
        "./node_modules/jss/lib/utils/toCss.js");

        var _toCss2 = _interopRequireDefault(_toCss);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var FontFaceRule = function () {
          function FontFaceRule(key, style, options) {
            _classCallCheck(this, FontFaceRule);

            this.type = 'font-face';
            this.isProcessed = false;
            this.key = key;
            this.style = style;
            this.options = options;
          }
          /**
           * Generates a CSS string.
           */


          _createClass(FontFaceRule, [{
            key: 'toString',
            value: function toString(options) {
              if (Array.isArray(this.style)) {
                var str = '';

                for (var index = 0; index < this.style.length; index++) {
                  str += (0, _toCss2['default'])(this.key, this.style[index]);
                  if (this.style[index + 1]) str += '\n';
                }

                return str;
              }

              return (0, _toCss2['default'])(this.key, this.style, options);
            }
          }]);

          return FontFaceRule;
        }();

        exports['default'] = FontFaceRule;
        /***/
      },

      /***/
      "./node_modules/jss/lib/rules/KeyframesRule.js":
      /*!*****************************************************!*\
        !*** ./node_modules/jss/lib/rules/KeyframesRule.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRulesKeyframesRuleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _RuleList = __webpack_require__(
        /*! ../RuleList */
        "./node_modules/jss/lib/RuleList.js");

        var _RuleList2 = _interopRequireDefault(_RuleList);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /**
         * Rule for @keyframes
         */


        var KeyframesRule = function () {
          function KeyframesRule(key, frames, options) {
            _classCallCheck(this, KeyframesRule);

            this.type = 'keyframes';
            this.isProcessed = false;
            this.key = key;
            this.options = options;
            this.rules = new _RuleList2['default'](_extends({}, options, {
              parent: this
            }));

            for (var name in frames) {
              this.rules.add(name, frames[name], _extends({}, this.options, {
                parent: this,
                selector: name
              }));
            }

            this.rules.process();
          }
          /**
           * Generates a CSS string.
           */


          _createClass(KeyframesRule, [{
            key: 'toString',
            value: function toString() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                indent: 1
              };
              var inner = this.rules.toString(options);
              if (inner) inner += '\n';
              return this.key + ' {\n' + inner + '}';
            }
          }]);

          return KeyframesRule;
        }();

        exports['default'] = KeyframesRule;
        /***/
      },

      /***/
      "./node_modules/jss/lib/rules/SimpleRule.js":
      /*!**************************************************!*\
        !*** ./node_modules/jss/lib/rules/SimpleRule.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRulesSimpleRuleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var SimpleRule = function () {
          function SimpleRule(key, value, options) {
            _classCallCheck(this, SimpleRule);

            this.type = 'simple';
            this.isProcessed = false;
            this.key = key;
            this.value = value;
            this.options = options;
          }
          /**
           * Generates a CSS string.
           */
          // eslint-disable-next-line no-unused-vars


          _createClass(SimpleRule, [{
            key: 'toString',
            value: function toString(options) {
              if (Array.isArray(this.value)) {
                var str = '';

                for (var index = 0; index < this.value.length; index++) {
                  str += this.key + ' ' + this.value[index] + ';';
                  if (this.value[index + 1]) str += '\n';
                }

                return str;
              }

              return this.key + ' ' + this.value + ';';
            }
          }]);

          return SimpleRule;
        }();

        exports['default'] = SimpleRule;
        /***/
      },

      /***/
      "./node_modules/jss/lib/rules/StyleRule.js":
      /*!*************************************************!*\
        !*** ./node_modules/jss/lib/rules/StyleRule.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRulesStyleRuleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        var _toCss = __webpack_require__(
        /*! ../utils/toCss */
        "./node_modules/jss/lib/utils/toCss.js");

        var _toCss2 = _interopRequireDefault(_toCss);

        var _toCssValue = __webpack_require__(
        /*! ../utils/toCssValue */
        "./node_modules/jss/lib/utils/toCssValue.js");

        var _toCssValue2 = _interopRequireDefault(_toCssValue);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var StyleRule = function () {
          function StyleRule(key, style, options) {
            _classCallCheck(this, StyleRule);

            this.type = 'style';
            this.isProcessed = false;
            var sheet = options.sheet,
                Renderer = options.Renderer,
                selector = options.selector;
            this.key = key;
            this.options = options;
            this.style = style;
            if (selector) this.selectorText = selector;
            this.renderer = sheet ? sheet.renderer : new Renderer();
          }
          /**
           * Set selector string.
           * Attention: use this with caution. Most browsers didn't implement
           * selectorText setter, so this may result in rerendering of entire Style Sheet.
           */


          _createClass(StyleRule, [{
            key: 'prop',

            /**
             * Get or set a style property.
             */
            value: function prop(name, value) {
              // It's a getter.
              if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

              if (this.style[name] === value) return this;
              value = this.options.jss.plugins.onChangeValue(value, name, this);
              var isEmpty = value == null || value === false;
              var isDefined = (name in this.style); // Value is empty and wasn't defined before.

              if (isEmpty && !isDefined) return this; // We are going to remove this value.

              var remove = isEmpty && isDefined;
              if (remove) delete this.style[name];else this.style[name] = value; // Renderable is defined if StyleSheet option `link` is true.

              if (this.renderable) {
                if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
                return this;
              }

              var sheet = this.options.sheet;

              if (sheet && sheet.attached) {
                (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
              }

              return this;
            }
            /**
             * Apply rule to an element inline.
             */

          }, {
            key: 'applyTo',
            value: function applyTo(renderable) {
              var json = this.toJSON();

              for (var prop in json) {
                this.renderer.setProperty(renderable, prop, json[prop]);
              }

              return this;
            }
            /**
             * Returns JSON representation of the rule.
             * Fallbacks are not supported.
             * Useful for inline styles.
             */

          }, {
            key: 'toJSON',
            value: function toJSON() {
              var json = {};

              for (var prop in this.style) {
                var value = this.style[prop];
                if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
              }

              return json;
            }
            /**
             * Generates a CSS string.
             */

          }, {
            key: 'toString',
            value: function toString(options) {
              var sheet = this.options.sheet;
              var link = sheet ? sheet.options.link : false;
              var opts = link ? _extends({}, options, {
                allowEmpty: true
              }) : options;
              return (0, _toCss2['default'])(this.selector, this.style, opts);
            }
          }, {
            key: 'selector',
            set: function set(selector) {
              if (selector === this.selectorText) return;
              this.selectorText = selector;
              if (!this.renderable) return;
              var hasChanged = this.renderer.setSelector(this.renderable, selector); // If selector setter is not implemented, rerender the rule.

              if (!hasChanged && this.renderable) {
                var renderable = this.renderer.replaceRule(this.renderable, this);
                if (renderable) this.renderable = renderable;
              }
            }
            /**
             * Get selector string.
             */
            ,
            get: function get() {
              return this.selectorText;
            }
          }]);

          return StyleRule;
        }();

        exports['default'] = StyleRule;
        /***/
      },

      /***/
      "./node_modules/jss/lib/rules/ViewportRule.js":
      /*!****************************************************!*\
        !*** ./node_modules/jss/lib/rules/ViewportRule.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibRulesViewportRuleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _toCss = __webpack_require__(
        /*! ../utils/toCss */
        "./node_modules/jss/lib/utils/toCss.js");

        var _toCss2 = _interopRequireDefault(_toCss);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var ViewportRule = function () {
          function ViewportRule(key, style, options) {
            _classCallCheck(this, ViewportRule);

            this.type = 'viewport';
            this.isProcessed = false;
            this.key = key;
            this.style = style;
            this.options = options;
          }
          /**
           * Generates a CSS string.
           */


          _createClass(ViewportRule, [{
            key: 'toString',
            value: function toString(options) {
              return (0, _toCss2['default'])(this.key, this.style, options);
            }
          }]);

          return ViewportRule;
        }();

        exports['default'] = ViewportRule;
        /***/
      },

      /***/
      "./node_modules/jss/lib/sheets.js":
      /*!****************************************!*\
        !*** ./node_modules/jss/lib/sheets.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibSheetsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _SheetsRegistry = __webpack_require__(
        /*! ./SheetsRegistry */
        "./node_modules/jss/lib/SheetsRegistry.js");

        var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        /**
         * This is a global sheets registry. Only DomRenderer will add sheets to it.
         * On the server one should use an own SheetsRegistry instance and add the
         * sheets to it, because you need to make sure to create a new registry for
         * each request in order to not leak sheets across requests.
         */


        exports['default'] = new _SheetsRegistry2['default']();
        /***/
      },

      /***/
      "./node_modules/jss/lib/utils/cloneStyle.js":
      /*!**************************************************!*\
        !*** ./node_modules/jss/lib/utils/cloneStyle.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsCloneStyleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        exports['default'] = cloneStyle;

        var _isObservable = __webpack_require__(
        /*! ./isObservable */
        "./node_modules/jss/lib/utils/isObservable.js");

        var _isObservable2 = _interopRequireDefault(_isObservable);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var isArray = Array.isArray;

        function cloneStyle(style) {
          // Support empty values in case user ends up with them by accident.
          if (style == null) return style; // Support string value for SimpleRule.

          var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

          if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
            return style;
          } // Support array for FontFaceRule.


          if (isArray(style)) return style.map(cloneStyle); // Support Observable styles.  Observables are immutable, so we don't need to
          // copy them.

          if ((0, _isObservable2['default'])(style)) return style;
          var newStyle = {};

          for (var name in style) {
            var value = style[name];

            if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
              newStyle[name] = cloneStyle(value);
              continue;
            }

            newStyle[name] = value;
          }

          return newStyle;
        }
        /***/

      },

      /***/
      "./node_modules/jss/lib/utils/createGenerateClassName.js":
      /*!***************************************************************!*\
        !*** ./node_modules/jss/lib/utils/createGenerateClassName.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsCreateGenerateClassNameJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        var _StyleSheet = __webpack_require__(
        /*! ../StyleSheet */
        "./node_modules/jss/lib/StyleSheet.js");

        var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

        var _moduleId = __webpack_require__(
        /*! ./moduleId */
        "./node_modules/jss/lib/utils/moduleId.js");

        var _moduleId2 = _interopRequireDefault(_moduleId);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        var maxRules = 1e10;
        var env = "production";
        /**
         * Returns a function which generates unique class names based on counters.
         * When new generator function is created, rule counter is reseted.
         * We need to reset the rule counter for SSR for each request.
         */

        exports['default'] = function () {
          var ruleCounter = 0;
          var defaultPrefix = env === 'production' ? 'c' : '';
          return function (rule, sheet) {
            ruleCounter += 1;

            if (ruleCounter > maxRules) {
              (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
            }

            var prefix = defaultPrefix;
            var jssId = '';

            if (sheet) {
              prefix = sheet.options.classNamePrefix || defaultPrefix;
              if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
            }

            if (env === 'production') {
              return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
            }

            return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
          };
        };
        /***/

      },

      /***/
      "./node_modules/jss/lib/utils/createRule.js":
      /*!**************************************************!*\
        !*** ./node_modules/jss/lib/utils/createRule.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsCreateRuleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = createRule;

        var _warning = __webpack_require__(
        /*! warning */
        "./node_modules/warning/browser.js");

        var _warning2 = _interopRequireDefault(_warning);

        var _StyleRule = __webpack_require__(
        /*! ../rules/StyleRule */
        "./node_modules/jss/lib/rules/StyleRule.js");

        var _StyleRule2 = _interopRequireDefault(_StyleRule);

        var _cloneStyle = __webpack_require__(
        /*! ../utils/cloneStyle */
        "./node_modules/jss/lib/utils/cloneStyle.js");

        var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        /**
         * Create a rule instance.
         */


        function createRule() {
          var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
          var decl = arguments[1];
          var options = arguments[2];
          var jss = options.jss;
          var declCopy = (0, _cloneStyle2['default'])(decl);
          var rule = jss.plugins.onCreateRule(name, declCopy, options);
          if (rule) return rule; // It is an at-rule and it has no instance.

          if (name[0] === '@') {
            (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
          }

          return new _StyleRule2['default'](name, declCopy, options);
        }
        /***/

      },

      /***/
      "./node_modules/jss/lib/utils/escape.js":
      /*!**********************************************!*\
        !*** ./node_modules/jss/lib/utils/escape.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsEscapeJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (global) {
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          var CSS = global.CSS;
          var env = "production";
          var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

          exports['default'] = function (str) {
            // We don't need to escape it in production, because we are not using user's
            // input for selectors, we are generating a valid selector.
            if (env === 'production') return str;

            if (!CSS || !CSS.escape) {
              return str.replace(escapeRegex, '\\$1');
            }

            return CSS.escape(str);
          };
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../../../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./node_modules/jss/lib/utils/getDynamicStyles.js":
      /*!********************************************************!*\
        !*** ./node_modules/jss/lib/utils/getDynamicStyles.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsGetDynamicStylesJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        exports['default'] = getDynamicStyles;
        /**
         * Extracts a styles object with only props that contain function values.
         */

        function getDynamicStyles(styles) {
          var to = null;

          for (var key in styles) {
            var value = styles[key];
            var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

            if (type === 'function') {
              if (!to) to = {};
              to[key] = value;
            } else if (type === 'object' && value !== null && !Array.isArray(value)) {
              var extracted = getDynamicStyles(value);

              if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
              }
            }
          }

          return to;
        }
        /***/

      },

      /***/
      "./node_modules/jss/lib/utils/isObservable.js":
      /*!****************************************************!*\
        !*** ./node_modules/jss/lib/utils/isObservable.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsIsObservableJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _symbolObservable = __webpack_require__(
        /*! symbol-observable */
        "./node_modules/symbol-observable/es/index.js");

        var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        exports['default'] = function (value) {
          return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
        };
        /***/

      },

      /***/
      "./node_modules/jss/lib/utils/linkRule.js":
      /*!************************************************!*\
        !*** ./node_modules/jss/lib/utils/linkRule.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsLinkRuleJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = linkRule;
        /**
         * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
         */

        function linkRule(rule, cssRule) {
          rule.renderable = cssRule;
          if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
        }
        /***/

      },

      /***/
      "./node_modules/jss/lib/utils/moduleId.js":
      /*!************************************************!*\
        !*** ./node_modules/jss/lib/utils/moduleId.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsModuleIdJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (global) {
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
          if (global[ns] == null) global[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
          // the current version with just one short number and use it for classes generation
          // we use a counter. Also it is more accurate, because user can manually reevaluate
          // the module.

          exports['default'] = global[ns]++;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./node_modules/jss/lib/utils/toCss.js":
      /*!*********************************************!*\
        !*** ./node_modules/jss/lib/utils/toCss.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsToCssJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = toCss;

        var _toCssValue = __webpack_require__(
        /*! ./toCssValue */
        "./node_modules/jss/lib/utils/toCssValue.js");

        var _toCssValue2 = _interopRequireDefault(_toCssValue);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        /**
         * Indent a string.
         * http://jsperf.com/array-join-vs-for
         */


        function indentStr(str, indent) {
          var result = '';

          for (var index = 0; index < indent; index++) {
            result += '  ';
          }

          return result + str;
        }
        /**
         * Converts a Rule to CSS string.
         */


        function toCss(selector, style) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var result = '';
          if (!style) return result;
          var _options$indent = options.indent,
              indent = _options$indent === undefined ? 0 : _options$indent;
          var fallbacks = style.fallbacks;
          indent++; // Apply fallbacks first.

          if (fallbacks) {
            // Array syntax {fallbacks: [{prop: value}]}
            if (Array.isArray(fallbacks)) {
              for (var index = 0; index < fallbacks.length; index++) {
                var fallback = fallbacks[index];

                for (var prop in fallback) {
                  var value = fallback[prop];

                  if (value != null) {
                    result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
                  }
                }
              }
            } else {
              // Object syntax {fallbacks: {prop: value}}
              for (var _prop in fallbacks) {
                var _value = fallbacks[_prop];

                if (_value != null) {
                  result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
                }
              }
            }
          }

          for (var _prop2 in style) {
            var _value2 = style[_prop2];

            if (_value2 != null && _prop2 !== 'fallbacks') {
              result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
            }
          } // Allow empty style in this case, because properties will be added dynamically.


          if (!result && !options.allowEmpty) return result;
          indent--;
          result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);
          return result;
        }
        /***/

      },

      /***/
      "./node_modules/jss/lib/utils/toCssValue.js":
      /*!**************************************************!*\
        !*** ./node_modules/jss/lib/utils/toCssValue.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJssLibUtilsToCssValueJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = toCssValue;

        var join = function join(value, by) {
          var result = '';

          for (var i = 0; i < value.length; i++) {
            // Remove !important from the value, it will be readded later.
            if (value[i] === '!important') break;
            if (result) result += by;
            result += value[i];
          }

          return result;
        };
        /**
         * Converts array values to string.
         *
         * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
         * `border: ['1px', '2px']` > `border: 1px, 2px;`
         * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
         * `color: ['red', !important]` > `color: red !important;`
         */


        function toCssValue(value) {
          var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          if (!Array.isArray(value)) return value;
          var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

          if (Array.isArray(value[0])) {
            for (var i = 0; i < value.length; i++) {
              if (value[i] === '!important') break;
              if (cssValue) cssValue += ', ';
              cssValue += join(value[i], ' ');
            }
          } else cssValue = join(value, ', '); // Add !important, because it was ignored.


          if (!ignoreImportant && value[value.length - 1] === '!important') {
            cssValue += ' !important';
          }

          return cssValue;
        }
        /***/

      },

      /***/
      "./node_modules/lodash/_DataView.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_DataView.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_DataViewJs(module, exports, __webpack_require__) {
        var getNative = __webpack_require__(
        /*! ./_getNative */
        "./node_modules/lodash/_getNative.js"),
            root = __webpack_require__(
        /*! ./_root */
        "./node_modules/lodash/_root.js");
        /* Built-in method references that are verified to be native. */


        var DataView = getNative(root, 'DataView');
        module.exports = DataView;
        /***/
      },

      /***/
      "./node_modules/lodash/_Hash.js":
      /*!**************************************!*\
        !*** ./node_modules/lodash/_Hash.js ***!
        \**************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_HashJs(module, exports, __webpack_require__) {
        var hashClear = __webpack_require__(
        /*! ./_hashClear */
        "./node_modules/lodash/_hashClear.js"),
            hashDelete = __webpack_require__(
        /*! ./_hashDelete */
        "./node_modules/lodash/_hashDelete.js"),
            hashGet = __webpack_require__(
        /*! ./_hashGet */
        "./node_modules/lodash/_hashGet.js"),
            hashHas = __webpack_require__(
        /*! ./_hashHas */
        "./node_modules/lodash/_hashHas.js"),
            hashSet = __webpack_require__(
        /*! ./_hashSet */
        "./node_modules/lodash/_hashSet.js");
        /**
         * Creates a hash object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */


        function Hash(entries) {
          var index = -1,
              length = entries == null ? 0 : entries.length;
          this.clear();

          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        } // Add methods to `Hash`.


        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        module.exports = Hash;
        /***/
      },

      /***/
      "./node_modules/lodash/_ListCache.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_ListCache.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_ListCacheJs(module, exports, __webpack_require__) {
        var listCacheClear = __webpack_require__(
        /*! ./_listCacheClear */
        "./node_modules/lodash/_listCacheClear.js"),
            listCacheDelete = __webpack_require__(
        /*! ./_listCacheDelete */
        "./node_modules/lodash/_listCacheDelete.js"),
            listCacheGet = __webpack_require__(
        /*! ./_listCacheGet */
        "./node_modules/lodash/_listCacheGet.js"),
            listCacheHas = __webpack_require__(
        /*! ./_listCacheHas */
        "./node_modules/lodash/_listCacheHas.js"),
            listCacheSet = __webpack_require__(
        /*! ./_listCacheSet */
        "./node_modules/lodash/_listCacheSet.js");
        /**
         * Creates an list cache object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */


        function ListCache(entries) {
          var index = -1,
              length = entries == null ? 0 : entries.length;
          this.clear();

          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        } // Add methods to `ListCache`.


        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        module.exports = ListCache;
        /***/
      },

      /***/
      "./node_modules/lodash/_Map.js":
      /*!*************************************!*\
        !*** ./node_modules/lodash/_Map.js ***!
        \*************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_MapJs(module, exports, __webpack_require__) {
        var getNative = __webpack_require__(
        /*! ./_getNative */
        "./node_modules/lodash/_getNative.js"),
            root = __webpack_require__(
        /*! ./_root */
        "./node_modules/lodash/_root.js");
        /* Built-in method references that are verified to be native. */


        var Map = getNative(root, 'Map');
        module.exports = Map;
        /***/
      },

      /***/
      "./node_modules/lodash/_MapCache.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_MapCache.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_MapCacheJs(module, exports, __webpack_require__) {
        var mapCacheClear = __webpack_require__(
        /*! ./_mapCacheClear */
        "./node_modules/lodash/_mapCacheClear.js"),
            mapCacheDelete = __webpack_require__(
        /*! ./_mapCacheDelete */
        "./node_modules/lodash/_mapCacheDelete.js"),
            mapCacheGet = __webpack_require__(
        /*! ./_mapCacheGet */
        "./node_modules/lodash/_mapCacheGet.js"),
            mapCacheHas = __webpack_require__(
        /*! ./_mapCacheHas */
        "./node_modules/lodash/_mapCacheHas.js"),
            mapCacheSet = __webpack_require__(
        /*! ./_mapCacheSet */
        "./node_modules/lodash/_mapCacheSet.js");
        /**
         * Creates a map cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */


        function MapCache(entries) {
          var index = -1,
              length = entries == null ? 0 : entries.length;
          this.clear();

          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        } // Add methods to `MapCache`.


        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        module.exports = MapCache;
        /***/
      },

      /***/
      "./node_modules/lodash/_Promise.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_Promise.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_PromiseJs(module, exports, __webpack_require__) {
        var getNative = __webpack_require__(
        /*! ./_getNative */
        "./node_modules/lodash/_getNative.js"),
            root = __webpack_require__(
        /*! ./_root */
        "./node_modules/lodash/_root.js");
        /* Built-in method references that are verified to be native. */


        var Promise = getNative(root, 'Promise');
        module.exports = Promise;
        /***/
      },

      /***/
      "./node_modules/lodash/_Set.js":
      /*!*************************************!*\
        !*** ./node_modules/lodash/_Set.js ***!
        \*************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_SetJs(module, exports, __webpack_require__) {
        var getNative = __webpack_require__(
        /*! ./_getNative */
        "./node_modules/lodash/_getNative.js"),
            root = __webpack_require__(
        /*! ./_root */
        "./node_modules/lodash/_root.js");
        /* Built-in method references that are verified to be native. */


        var Set = getNative(root, 'Set');
        module.exports = Set;
        /***/
      },

      /***/
      "./node_modules/lodash/_SetCache.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_SetCache.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_SetCacheJs(module, exports, __webpack_require__) {
        var MapCache = __webpack_require__(
        /*! ./_MapCache */
        "./node_modules/lodash/_MapCache.js"),
            setCacheAdd = __webpack_require__(
        /*! ./_setCacheAdd */
        "./node_modules/lodash/_setCacheAdd.js"),
            setCacheHas = __webpack_require__(
        /*! ./_setCacheHas */
        "./node_modules/lodash/_setCacheHas.js");
        /**
         *
         * Creates an array cache object to store unique values.
         *
         * @private
         * @constructor
         * @param {Array} [values] The values to cache.
         */


        function SetCache(values) {
          var index = -1,
              length = values == null ? 0 : values.length;
          this.__data__ = new MapCache();

          while (++index < length) {
            this.add(values[index]);
          }
        } // Add methods to `SetCache`.


        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        module.exports = SetCache;
        /***/
      },

      /***/
      "./node_modules/lodash/_Stack.js":
      /*!***************************************!*\
        !*** ./node_modules/lodash/_Stack.js ***!
        \***************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_StackJs(module, exports, __webpack_require__) {
        var ListCache = __webpack_require__(
        /*! ./_ListCache */
        "./node_modules/lodash/_ListCache.js"),
            stackClear = __webpack_require__(
        /*! ./_stackClear */
        "./node_modules/lodash/_stackClear.js"),
            stackDelete = __webpack_require__(
        /*! ./_stackDelete */
        "./node_modules/lodash/_stackDelete.js"),
            stackGet = __webpack_require__(
        /*! ./_stackGet */
        "./node_modules/lodash/_stackGet.js"),
            stackHas = __webpack_require__(
        /*! ./_stackHas */
        "./node_modules/lodash/_stackHas.js"),
            stackSet = __webpack_require__(
        /*! ./_stackSet */
        "./node_modules/lodash/_stackSet.js");
        /**
         * Creates a stack cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */


        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        } // Add methods to `Stack`.


        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        module.exports = Stack;
        /***/
      },

      /***/
      "./node_modules/lodash/_Symbol.js":
      /*!****************************************!*\
        !*** ./node_modules/lodash/_Symbol.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_SymbolJs(module, exports, __webpack_require__) {
        var root = __webpack_require__(
        /*! ./_root */
        "./node_modules/lodash/_root.js");
        /** Built-in value references. */


        var Symbol = root.Symbol;
        module.exports = Symbol;
        /***/
      },

      /***/
      "./node_modules/lodash/_Uint8Array.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_Uint8Array.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_Uint8ArrayJs(module, exports, __webpack_require__) {
        var root = __webpack_require__(
        /*! ./_root */
        "./node_modules/lodash/_root.js");
        /** Built-in value references. */


        var Uint8Array = root.Uint8Array;
        module.exports = Uint8Array;
        /***/
      },

      /***/
      "./node_modules/lodash/_WeakMap.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_WeakMap.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_WeakMapJs(module, exports, __webpack_require__) {
        var getNative = __webpack_require__(
        /*! ./_getNative */
        "./node_modules/lodash/_getNative.js"),
            root = __webpack_require__(
        /*! ./_root */
        "./node_modules/lodash/_root.js");
        /* Built-in method references that are verified to be native. */


        var WeakMap = getNative(root, 'WeakMap');
        module.exports = WeakMap;
        /***/
      },

      /***/
      "./node_modules/lodash/_apply.js":
      /*!***************************************!*\
        !*** ./node_modules/lodash/_apply.js ***!
        \***************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_applyJs(module, exports) {
        /**
         * A faster alternative to `Function#apply`, this function invokes `func`
         * with the `this` binding of `thisArg` and the arguments of `args`.
         *
         * @private
         * @param {Function} func The function to invoke.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} args The arguments to invoke `func` with.
         * @returns {*} Returns the result of `func`.
         */
        function apply(func, thisArg, args) {
          switch (args.length) {
            case 0:
              return func.call(thisArg);

            case 1:
              return func.call(thisArg, args[0]);

            case 2:
              return func.call(thisArg, args[0], args[1]);

            case 3:
              return func.call(thisArg, args[0], args[1], args[2]);
          }

          return func.apply(thisArg, args);
        }

        module.exports = apply;
        /***/
      },

      /***/
      "./node_modules/lodash/_arrayEach.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_arrayEach.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_arrayEachJs(module, exports) {
        /**
         * A specialized version of `_.forEach` for arrays without support for
         * iteratee shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns `array`.
         */
        function arrayEach(array, iteratee) {
          var index = -1,
              length = array == null ? 0 : array.length;

          while (++index < length) {
            if (iteratee(array[index], index, array) === false) {
              break;
            }
          }

          return array;
        }

        module.exports = arrayEach;
        /***/
      },

      /***/
      "./node_modules/lodash/_arrayFilter.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_arrayFilter.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_arrayFilterJs(module, exports) {
        /**
         * A specialized version of `_.filter` for arrays without support for
         * iteratee shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         */
        function arrayFilter(array, predicate) {
          var index = -1,
              length = array == null ? 0 : array.length,
              resIndex = 0,
              result = [];

          while (++index < length) {
            var value = array[index];

            if (predicate(value, index, array)) {
              result[resIndex++] = value;
            }
          }

          return result;
        }

        module.exports = arrayFilter;
        /***/
      },

      /***/
      "./node_modules/lodash/_arrayLikeKeys.js":
      /*!***********************************************!*\
        !*** ./node_modules/lodash/_arrayLikeKeys.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_arrayLikeKeysJs(module, exports, __webpack_require__) {
        var baseTimes = __webpack_require__(
        /*! ./_baseTimes */
        "./node_modules/lodash/_baseTimes.js"),
            isArguments = __webpack_require__(
        /*! ./isArguments */
        "./node_modules/lodash/isArguments.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js"),
            isBuffer = __webpack_require__(
        /*! ./isBuffer */
        "./node_modules/lodash/isBuffer.js"),
            isIndex = __webpack_require__(
        /*! ./_isIndex */
        "./node_modules/lodash/_isIndex.js"),
            isTypedArray = __webpack_require__(
        /*! ./isTypedArray */
        "./node_modules/lodash/isTypedArray.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */

        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value),
              isArg = !isArr && isArguments(value),
              isBuff = !isArr && !isArg && isBuffer(value),
              isType = !isArr && !isArg && !isBuff && isTypedArray(value),
              skipIndexes = isArr || isArg || isBuff || isType,
              result = skipIndexes ? baseTimes(value.length, String) : [],
              length = result.length;

          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
            key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) {
              result.push(key);
            }
          }

          return result;
        }

        module.exports = arrayLikeKeys;
        /***/
      },

      /***/
      "./node_modules/lodash/_arrayMap.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_arrayMap.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_arrayMapJs(module, exports) {
        /**
         * A specialized version of `_.map` for arrays without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         */
        function arrayMap(array, iteratee) {
          var index = -1,
              length = array == null ? 0 : array.length,
              result = Array(length);

          while (++index < length) {
            result[index] = iteratee(array[index], index, array);
          }

          return result;
        }

        module.exports = arrayMap;
        /***/
      },

      /***/
      "./node_modules/lodash/_arrayPush.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_arrayPush.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_arrayPushJs(module, exports) {
        /**
         * Appends the elements of `values` to `array`.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {Array} values The values to append.
         * @returns {Array} Returns `array`.
         */
        function arrayPush(array, values) {
          var index = -1,
              length = values.length,
              offset = array.length;

          while (++index < length) {
            array[offset + index] = values[index];
          }

          return array;
        }

        module.exports = arrayPush;
        /***/
      },

      /***/
      "./node_modules/lodash/_arraySome.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_arraySome.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_arraySomeJs(module, exports) {
        /**
         * A specialized version of `_.some` for arrays without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         */
        function arraySome(array, predicate) {
          var index = -1,
              length = array == null ? 0 : array.length;

          while (++index < length) {
            if (predicate(array[index], index, array)) {
              return true;
            }
          }

          return false;
        }

        module.exports = arraySome;
        /***/
      },

      /***/
      "./node_modules/lodash/_asciiToArray.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_asciiToArray.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_asciiToArrayJs(module, exports) {
        /**
         * Converts an ASCII `string` to an array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the converted array.
         */
        function asciiToArray(string) {
          return string.split('');
        }

        module.exports = asciiToArray;
        /***/
      },

      /***/
      "./node_modules/lodash/_assignValue.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_assignValue.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_assignValueJs(module, exports, __webpack_require__) {
        var baseAssignValue = __webpack_require__(
        /*! ./_baseAssignValue */
        "./node_modules/lodash/_baseAssignValue.js"),
            eq = __webpack_require__(
        /*! ./eq */
        "./node_modules/lodash/eq.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Assigns `value` to `key` of `object` if the existing value is not equivalent
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */

        function assignValue(object, key, value) {
          var objValue = object[key];

          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }

        module.exports = assignValue;
        /***/
      },

      /***/
      "./node_modules/lodash/_assocIndexOf.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_assocIndexOf.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_assocIndexOfJs(module, exports, __webpack_require__) {
        var eq = __webpack_require__(
        /*! ./eq */
        "./node_modules/lodash/eq.js");
        /**
         * Gets the index at which the `key` is found in `array` of key-value pairs.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} key The key to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */


        function assocIndexOf(array, key) {
          var length = array.length;

          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }

          return -1;
        }

        module.exports = assocIndexOf;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseAssignValue.js":
      /*!*************************************************!*\
        !*** ./node_modules/lodash/_baseAssignValue.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseAssignValueJs(module, exports, __webpack_require__) {
        var defineProperty = __webpack_require__(
        /*! ./_defineProperty */
        "./node_modules/lodash/_defineProperty.js");
        /**
         * The base implementation of `assignValue` and `assignMergeValue` without
         * value checks.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */


        function baseAssignValue(object, key, value) {
          if (key == '__proto__' && defineProperty) {
            defineProperty(object, key, {
              'configurable': true,
              'enumerable': true,
              'value': value,
              'writable': true
            });
          } else {
            object[key] = value;
          }
        }

        module.exports = baseAssignValue;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseEach.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_baseEach.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseEachJs(module, exports, __webpack_require__) {
        var baseForOwn = __webpack_require__(
        /*! ./_baseForOwn */
        "./node_modules/lodash/_baseForOwn.js"),
            createBaseEach = __webpack_require__(
        /*! ./_createBaseEach */
        "./node_modules/lodash/_createBaseEach.js");
        /**
         * The base implementation of `_.forEach` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */


        var baseEach = createBaseEach(baseForOwn);
        module.exports = baseEach;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseFilter.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_baseFilter.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseFilterJs(module, exports, __webpack_require__) {
        var baseEach = __webpack_require__(
        /*! ./_baseEach */
        "./node_modules/lodash/_baseEach.js");
        /**
         * The base implementation of `_.filter` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         */


        function baseFilter(collection, predicate) {
          var result = [];
          baseEach(collection, function (value, index, collection) {
            if (predicate(value, index, collection)) {
              result.push(value);
            }
          });
          return result;
        }

        module.exports = baseFilter;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseFindIndex.js":
      /*!***********************************************!*\
        !*** ./node_modules/lodash/_baseFindIndex.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseFindIndexJs(module, exports) {
        /**
         * The base implementation of `_.findIndex` and `_.findLastIndex` without
         * support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} predicate The function invoked per iteration.
         * @param {number} fromIndex The index to search from.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function baseFindIndex(array, predicate, fromIndex, fromRight) {
          var length = array.length,
              index = fromIndex + (fromRight ? 1 : -1);

          while (fromRight ? index-- : ++index < length) {
            if (predicate(array[index], index, array)) {
              return index;
            }
          }

          return -1;
        }

        module.exports = baseFindIndex;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseFor.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_baseFor.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseForJs(module, exports, __webpack_require__) {
        var createBaseFor = __webpack_require__(
        /*! ./_createBaseFor */
        "./node_modules/lodash/_createBaseFor.js");
        /**
         * The base implementation of `baseForOwn` which iterates over `object`
         * properties returned by `keysFunc` and invokes `iteratee` for each property.
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */


        var baseFor = createBaseFor();
        module.exports = baseFor;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseForOwn.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_baseForOwn.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseForOwnJs(module, exports, __webpack_require__) {
        var baseFor = __webpack_require__(
        /*! ./_baseFor */
        "./node_modules/lodash/_baseFor.js"),
            keys = __webpack_require__(
        /*! ./keys */
        "./node_modules/lodash/keys.js");
        /**
         * The base implementation of `_.forOwn` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */


        function baseForOwn(object, iteratee) {
          return object && baseFor(object, iteratee, keys);
        }

        module.exports = baseForOwn;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseGet.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_baseGet.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseGetJs(module, exports, __webpack_require__) {
        var castPath = __webpack_require__(
        /*! ./_castPath */
        "./node_modules/lodash/_castPath.js"),
            toKey = __webpack_require__(
        /*! ./_toKey */
        "./node_modules/lodash/_toKey.js");
        /**
         * The base implementation of `_.get` without support for default values.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @returns {*} Returns the resolved value.
         */


        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0,
              length = path.length;

          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }

          return index && index == length ? object : undefined;
        }

        module.exports = baseGet;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseGetAllKeys.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_baseGetAllKeys.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseGetAllKeysJs(module, exports, __webpack_require__) {
        var arrayPush = __webpack_require__(
        /*! ./_arrayPush */
        "./node_modules/lodash/_arrayPush.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js");
        /**
         * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
         * `keysFunc` and `symbolsFunc` to get the enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @param {Function} symbolsFunc The function to get the symbols of `object`.
         * @returns {Array} Returns the array of property names and symbols.
         */


        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result = keysFunc(object);
          return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }

        module.exports = baseGetAllKeys;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseGetTag.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_baseGetTag.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseGetTagJs(module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(
        /*! ./_Symbol */
        "./node_modules/lodash/_Symbol.js"),
            getRawTag = __webpack_require__(
        /*! ./_getRawTag */
        "./node_modules/lodash/_getRawTag.js"),
            objectToString = __webpack_require__(
        /*! ./_objectToString */
        "./node_modules/lodash/_objectToString.js");
        /** `Object#toString` result references. */


        var nullTag = '[object Null]',
            undefinedTag = '[object Undefined]';
        /** Built-in value references. */

        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */

        function baseGetTag(value) {
          if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
          }

          return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }

        module.exports = baseGetTag;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseHasIn.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_baseHasIn.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseHasInJs(module, exports) {
        /**
         * The base implementation of `_.hasIn` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */
        function baseHasIn(object, key) {
          return object != null && key in Object(object);
        }

        module.exports = baseHasIn;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIndexOf.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_baseIndexOf.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIndexOfJs(module, exports, __webpack_require__) {
        var baseFindIndex = __webpack_require__(
        /*! ./_baseFindIndex */
        "./node_modules/lodash/_baseFindIndex.js"),
            baseIsNaN = __webpack_require__(
        /*! ./_baseIsNaN */
        "./node_modules/lodash/_baseIsNaN.js"),
            strictIndexOf = __webpack_require__(
        /*! ./_strictIndexOf */
        "./node_modules/lodash/_strictIndexOf.js");
        /**
         * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} fromIndex The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */


        function baseIndexOf(array, value, fromIndex) {
          return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
        }

        module.exports = baseIndexOf;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIsArguments.js":
      /*!*************************************************!*\
        !*** ./node_modules/lodash/_baseIsArguments.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsArgumentsJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "./node_modules/lodash/_baseGetTag.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "./node_modules/lodash/isObjectLike.js");
        /** `Object#toString` result references. */


        var argsTag = '[object Arguments]';
        /**
         * The base implementation of `_.isArguments`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         */

        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }

        module.exports = baseIsArguments;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIsEqual.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_baseIsEqual.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsEqualJs(module, exports, __webpack_require__) {
        var baseIsEqualDeep = __webpack_require__(
        /*! ./_baseIsEqualDeep */
        "./node_modules/lodash/_baseIsEqualDeep.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "./node_modules/lodash/isObjectLike.js");
        /**
         * The base implementation of `_.isEqual` which supports partial comparisons
         * and tracks traversed objects.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Unordered comparison
         *  2 - Partial comparison
         * @param {Function} [customizer] The function to customize comparisons.
         * @param {Object} [stack] Tracks traversed `value` and `other` objects.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         */


        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }

          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }

          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }

        module.exports = baseIsEqual;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIsEqualDeep.js":
      /*!*************************************************!*\
        !*** ./node_modules/lodash/_baseIsEqualDeep.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsEqualDeepJs(module, exports, __webpack_require__) {
        var Stack = __webpack_require__(
        /*! ./_Stack */
        "./node_modules/lodash/_Stack.js"),
            equalArrays = __webpack_require__(
        /*! ./_equalArrays */
        "./node_modules/lodash/_equalArrays.js"),
            equalByTag = __webpack_require__(
        /*! ./_equalByTag */
        "./node_modules/lodash/_equalByTag.js"),
            equalObjects = __webpack_require__(
        /*! ./_equalObjects */
        "./node_modules/lodash/_equalObjects.js"),
            getTag = __webpack_require__(
        /*! ./_getTag */
        "./node_modules/lodash/_getTag.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js"),
            isBuffer = __webpack_require__(
        /*! ./isBuffer */
        "./node_modules/lodash/isBuffer.js"),
            isTypedArray = __webpack_require__(
        /*! ./isTypedArray */
        "./node_modules/lodash/isTypedArray.js");
        /** Used to compose bitmasks for value comparisons. */


        var COMPARE_PARTIAL_FLAG = 1;
        /** `Object#toString` result references. */

        var argsTag = '[object Arguments]',
            arrayTag = '[object Array]',
            objectTag = '[object Object]';
        /** Used for built-in method references. */

        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * A specialized version of `baseIsEqual` for arrays and objects which performs
         * deep comparisons and tracks traversed objects enabling objects with circular
         * references to be compared.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} [stack] Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */

        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object),
              othIsArr = isArray(other),
              objTag = objIsArr ? arrayTag : getTag(object),
              othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag,
              othIsObj = othTag == objectTag,
              isSameTag = objTag == othTag;

          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }

            objIsArr = true;
            objIsObj = false;
          }

          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }

          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
                othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object,
                  othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }

          if (!isSameTag) {
            return false;
          }

          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }

        module.exports = baseIsEqualDeep;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIsMatch.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_baseIsMatch.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsMatchJs(module, exports, __webpack_require__) {
        var Stack = __webpack_require__(
        /*! ./_Stack */
        "./node_modules/lodash/_Stack.js"),
            baseIsEqual = __webpack_require__(
        /*! ./_baseIsEqual */
        "./node_modules/lodash/_baseIsEqual.js");
        /** Used to compose bitmasks for value comparisons. */


        var COMPARE_PARTIAL_FLAG = 1,
            COMPARE_UNORDERED_FLAG = 2;
        /**
         * The base implementation of `_.isMatch` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Array} matchData The property names, values, and compare flags to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         */

        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length,
              length = index,
              noCustomizer = !customizer;

          if (object == null) {
            return !length;
          }

          object = Object(object);

          while (index--) {
            var data = matchData[index];

            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }

          while (++index < length) {
            data = matchData[index];
            var key = data[0],
                objValue = object[key],
                srcValue = data[1];

            if (noCustomizer && data[2]) {
              if (objValue === undefined && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();

              if (customizer) {
                var result = customizer(objValue, srcValue, key, object, source, stack);
              }

              if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                return false;
              }
            }
          }

          return true;
        }

        module.exports = baseIsMatch;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIsNaN.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_baseIsNaN.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsNaNJs(module, exports) {
        /**
         * The base implementation of `_.isNaN` without support for number objects.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
         */
        function baseIsNaN(value) {
          return value !== value;
        }

        module.exports = baseIsNaN;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIsNative.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_baseIsNative.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsNativeJs(module, exports, __webpack_require__) {
        var isFunction = __webpack_require__(
        /*! ./isFunction */
        "./node_modules/lodash/isFunction.js"),
            isMasked = __webpack_require__(
        /*! ./_isMasked */
        "./node_modules/lodash/_isMasked.js"),
            isObject = __webpack_require__(
        /*! ./isObject */
        "./node_modules/lodash/isObject.js"),
            toSource = __webpack_require__(
        /*! ./_toSource */
        "./node_modules/lodash/_toSource.js");
        /**
         * Used to match `RegExp`
         * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
         */


        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
        /** Used to detect host constructors (Safari). */

        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        /** Used for built-in method references. */

        var funcProto = Function.prototype,
            objectProto = Object.prototype;
        /** Used to resolve the decompiled source of functions. */

        var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to detect if a method is native. */

        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /**
         * The base implementation of `_.isNative` without bad shim checks.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         */

        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }

          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }

        module.exports = baseIsNative;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIsTypedArray.js":
      /*!**************************************************!*\
        !*** ./node_modules/lodash/_baseIsTypedArray.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsTypedArrayJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "./node_modules/lodash/_baseGetTag.js"),
            isLength = __webpack_require__(
        /*! ./isLength */
        "./node_modules/lodash/isLength.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "./node_modules/lodash/isObjectLike.js");
        /** `Object#toString` result references. */


        var argsTag = '[object Arguments]',
            arrayTag = '[object Array]',
            boolTag = '[object Boolean]',
            dateTag = '[object Date]',
            errorTag = '[object Error]',
            funcTag = '[object Function]',
            mapTag = '[object Map]',
            numberTag = '[object Number]',
            objectTag = '[object Object]',
            regexpTag = '[object RegExp]',
            setTag = '[object Set]',
            stringTag = '[object String]',
            weakMapTag = '[object WeakMap]';
        var arrayBufferTag = '[object ArrayBuffer]',
            dataViewTag = '[object DataView]',
            float32Tag = '[object Float32Array]',
            float64Tag = '[object Float64Array]',
            int8Tag = '[object Int8Array]',
            int16Tag = '[object Int16Array]',
            int32Tag = '[object Int32Array]',
            uint8Tag = '[object Uint8Array]',
            uint8ClampedTag = '[object Uint8ClampedArray]',
            uint16Tag = '[object Uint16Array]',
            uint32Tag = '[object Uint32Array]';
        /** Used to identify `toStringTag` values of typed arrays. */

        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        /**
         * The base implementation of `_.isTypedArray` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         */

        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }

        module.exports = baseIsTypedArray;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseIteratee.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_baseIteratee.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIterateeJs(module, exports, __webpack_require__) {
        var baseMatches = __webpack_require__(
        /*! ./_baseMatches */
        "./node_modules/lodash/_baseMatches.js"),
            baseMatchesProperty = __webpack_require__(
        /*! ./_baseMatchesProperty */
        "./node_modules/lodash/_baseMatchesProperty.js"),
            identity = __webpack_require__(
        /*! ./identity */
        "./node_modules/lodash/identity.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js"),
            property = __webpack_require__(
        /*! ./property */
        "./node_modules/lodash/property.js");
        /**
         * The base implementation of `_.iteratee`.
         *
         * @private
         * @param {*} [value=_.identity] The value to convert to an iteratee.
         * @returns {Function} Returns the iteratee.
         */


        function baseIteratee(value) {
          // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
          // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
          if (typeof value == 'function') {
            return value;
          }

          if (value == null) {
            return identity;
          }

          if (typeof value == 'object') {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }

          return property(value);
        }

        module.exports = baseIteratee;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseKeys.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_baseKeys.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseKeysJs(module, exports, __webpack_require__) {
        var isPrototype = __webpack_require__(
        /*! ./_isPrototype */
        "./node_modules/lodash/_isPrototype.js"),
            nativeKeys = __webpack_require__(
        /*! ./_nativeKeys */
        "./node_modules/lodash/_nativeKeys.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */

        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }

          var result = [];

          for (var key in Object(object)) {
            if (hasOwnProperty.call(object, key) && key != 'constructor') {
              result.push(key);
            }
          }

          return result;
        }

        module.exports = baseKeys;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseMatches.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_baseMatches.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseMatchesJs(module, exports, __webpack_require__) {
        var baseIsMatch = __webpack_require__(
        /*! ./_baseIsMatch */
        "./node_modules/lodash/_baseIsMatch.js"),
            getMatchData = __webpack_require__(
        /*! ./_getMatchData */
        "./node_modules/lodash/_getMatchData.js"),
            matchesStrictComparable = __webpack_require__(
        /*! ./_matchesStrictComparable */
        "./node_modules/lodash/_matchesStrictComparable.js");
        /**
         * The base implementation of `_.matches` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         */


        function baseMatches(source) {
          var matchData = getMatchData(source);

          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }

          return function (object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }

        module.exports = baseMatches;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseMatchesProperty.js":
      /*!*****************************************************!*\
        !*** ./node_modules/lodash/_baseMatchesProperty.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseMatchesPropertyJs(module, exports, __webpack_require__) {
        var baseIsEqual = __webpack_require__(
        /*! ./_baseIsEqual */
        "./node_modules/lodash/_baseIsEqual.js"),
            get = __webpack_require__(
        /*! ./get */
        "./node_modules/lodash/get.js"),
            hasIn = __webpack_require__(
        /*! ./hasIn */
        "./node_modules/lodash/hasIn.js"),
            isKey = __webpack_require__(
        /*! ./_isKey */
        "./node_modules/lodash/_isKey.js"),
            isStrictComparable = __webpack_require__(
        /*! ./_isStrictComparable */
        "./node_modules/lodash/_isStrictComparable.js"),
            matchesStrictComparable = __webpack_require__(
        /*! ./_matchesStrictComparable */
        "./node_modules/lodash/_matchesStrictComparable.js"),
            toKey = __webpack_require__(
        /*! ./_toKey */
        "./node_modules/lodash/_toKey.js");
        /** Used to compose bitmasks for value comparisons. */


        var COMPARE_PARTIAL_FLAG = 1,
            COMPARE_UNORDERED_FLAG = 2;
        /**
         * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
         *
         * @private
         * @param {string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */

        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }

          return function (object) {
            var objValue = get(object, path);
            return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }

        module.exports = baseMatchesProperty;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseProperty.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_baseProperty.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_basePropertyJs(module, exports) {
        /**
         * The base implementation of `_.property` without support for deep paths.
         *
         * @private
         * @param {string} key The key of the property to get.
         * @returns {Function} Returns the new accessor function.
         */
        function baseProperty(key) {
          return function (object) {
            return object == null ? undefined : object[key];
          };
        }

        module.exports = baseProperty;
        /***/
      },

      /***/
      "./node_modules/lodash/_basePropertyDeep.js":
      /*!**************************************************!*\
        !*** ./node_modules/lodash/_basePropertyDeep.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_basePropertyDeepJs(module, exports, __webpack_require__) {
        var baseGet = __webpack_require__(
        /*! ./_baseGet */
        "./node_modules/lodash/_baseGet.js");
        /**
         * A specialized version of `baseProperty` which supports deep paths.
         *
         * @private
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         */


        function basePropertyDeep(path) {
          return function (object) {
            return baseGet(object, path);
          };
        }

        module.exports = basePropertyDeep;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseRest.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_baseRest.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseRestJs(module, exports, __webpack_require__) {
        var identity = __webpack_require__(
        /*! ./identity */
        "./node_modules/lodash/identity.js"),
            overRest = __webpack_require__(
        /*! ./_overRest */
        "./node_modules/lodash/_overRest.js"),
            setToString = __webpack_require__(
        /*! ./_setToString */
        "./node_modules/lodash/_setToString.js");
        /**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */


        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + '');
        }

        module.exports = baseRest;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseSetToString.js":
      /*!*************************************************!*\
        !*** ./node_modules/lodash/_baseSetToString.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseSetToStringJs(module, exports, __webpack_require__) {
        var constant = __webpack_require__(
        /*! ./constant */
        "./node_modules/lodash/constant.js"),
            defineProperty = __webpack_require__(
        /*! ./_defineProperty */
        "./node_modules/lodash/_defineProperty.js"),
            identity = __webpack_require__(
        /*! ./identity */
        "./node_modules/lodash/identity.js");
        /**
         * The base implementation of `setToString` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */


        var baseSetToString = !defineProperty ? identity : function (func, string) {
          return defineProperty(func, 'toString', {
            'configurable': true,
            'enumerable': false,
            'value': constant(string),
            'writable': true
          });
        };
        module.exports = baseSetToString;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseSlice.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_baseSlice.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseSliceJs(module, exports) {
        /**
         * The base implementation of `_.slice` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */
        function baseSlice(array, start, end) {
          var index = -1,
              length = array.length;

          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }

          end = end > length ? length : end;

          if (end < 0) {
            end += length;
          }

          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result = Array(length);

          while (++index < length) {
            result[index] = array[index + start];
          }

          return result;
        }

        module.exports = baseSlice;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseTimes.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_baseTimes.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseTimesJs(module, exports) {
        /**
         * The base implementation of `_.times` without support for iteratee shorthands
         * or max array length checks.
         *
         * @private
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         */
        function baseTimes(n, iteratee) {
          var index = -1,
              result = Array(n);

          while (++index < n) {
            result[index] = iteratee(index);
          }

          return result;
        }

        module.exports = baseTimes;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseToString.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_baseToString.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseToStringJs(module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(
        /*! ./_Symbol */
        "./node_modules/lodash/_Symbol.js"),
            arrayMap = __webpack_require__(
        /*! ./_arrayMap */
        "./node_modules/lodash/_arrayMap.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js"),
            isSymbol = __webpack_require__(
        /*! ./isSymbol */
        "./node_modules/lodash/isSymbol.js");
        /** Used as references for various `Number` constants. */


        var INFINITY = 1 / 0;
        /** Used to convert symbols to primitives and strings. */

        var symbolProto = Symbol ? Symbol.prototype : undefined,
            symbolToString = symbolProto ? symbolProto.toString : undefined;
        /**
         * The base implementation of `_.toString` which doesn't convert nullish
         * values to empty strings.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {string} Returns the string.
         */

        function baseToString(value) {
          // Exit early for strings to avoid a performance hit in some environments.
          if (typeof value == 'string') {
            return value;
          }

          if (isArray(value)) {
            // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
          }

          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : '';
          }

          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }

        module.exports = baseToString;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseUnary.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_baseUnary.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseUnaryJs(module, exports) {
        /**
         * The base implementation of `_.unary` without support for storing metadata.
         *
         * @private
         * @param {Function} func The function to cap arguments for.
         * @returns {Function} Returns the new capped function.
         */
        function baseUnary(func) {
          return function (value) {
            return func(value);
          };
        }

        module.exports = baseUnary;
        /***/
      },

      /***/
      "./node_modules/lodash/_baseValues.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_baseValues.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseValuesJs(module, exports, __webpack_require__) {
        var arrayMap = __webpack_require__(
        /*! ./_arrayMap */
        "./node_modules/lodash/_arrayMap.js");
        /**
         * The base implementation of `_.values` and `_.valuesIn` which creates an
         * array of `object` property values corresponding to the property names
         * of `props`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array} props The property names to get values for.
         * @returns {Object} Returns the array of property values.
         */


        function baseValues(object, props) {
          return arrayMap(props, function (key) {
            return object[key];
          });
        }

        module.exports = baseValues;
        /***/
      },

      /***/
      "./node_modules/lodash/_cacheHas.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_cacheHas.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_cacheHasJs(module, exports) {
        /**
         * Checks if a `cache` value for `key` exists.
         *
         * @private
         * @param {Object} cache The cache to query.
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function cacheHas(cache, key) {
          return cache.has(key);
        }

        module.exports = cacheHas;
        /***/
      },

      /***/
      "./node_modules/lodash/_castFunction.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_castFunction.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_castFunctionJs(module, exports, __webpack_require__) {
        var identity = __webpack_require__(
        /*! ./identity */
        "./node_modules/lodash/identity.js");
        /**
         * Casts `value` to `identity` if it's not a function.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Function} Returns cast function.
         */


        function castFunction(value) {
          return typeof value == 'function' ? value : identity;
        }

        module.exports = castFunction;
        /***/
      },

      /***/
      "./node_modules/lodash/_castPath.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_castPath.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_castPathJs(module, exports, __webpack_require__) {
        var isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js"),
            isKey = __webpack_require__(
        /*! ./_isKey */
        "./node_modules/lodash/_isKey.js"),
            stringToPath = __webpack_require__(
        /*! ./_stringToPath */
        "./node_modules/lodash/_stringToPath.js"),
            toString = __webpack_require__(
        /*! ./toString */
        "./node_modules/lodash/toString.js");
        /**
         * Casts `value` to a path array if it's not one.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {Object} [object] The object to query keys on.
         * @returns {Array} Returns the cast property path array.
         */


        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }

          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }

        module.exports = castPath;
        /***/
      },

      /***/
      "./node_modules/lodash/_castSlice.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_castSlice.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_castSliceJs(module, exports, __webpack_require__) {
        var baseSlice = __webpack_require__(
        /*! ./_baseSlice */
        "./node_modules/lodash/_baseSlice.js");
        /**
         * Casts `array` to a slice if it's needed.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {number} start The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the cast slice.
         */


        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }

        module.exports = castSlice;
        /***/
      },

      /***/
      "./node_modules/lodash/_charsEndIndex.js":
      /*!***********************************************!*\
        !*** ./node_modules/lodash/_charsEndIndex.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_charsEndIndexJs(module, exports, __webpack_require__) {
        var baseIndexOf = __webpack_require__(
        /*! ./_baseIndexOf */
        "./node_modules/lodash/_baseIndexOf.js");
        /**
         * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
         * that is not found in the character symbols.
         *
         * @private
         * @param {Array} strSymbols The string symbols to inspect.
         * @param {Array} chrSymbols The character symbols to find.
         * @returns {number} Returns the index of the last unmatched string symbol.
         */


        function charsEndIndex(strSymbols, chrSymbols) {
          var index = strSymbols.length;

          while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

          return index;
        }

        module.exports = charsEndIndex;
        /***/
      },

      /***/
      "./node_modules/lodash/_charsStartIndex.js":
      /*!*************************************************!*\
        !*** ./node_modules/lodash/_charsStartIndex.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_charsStartIndexJs(module, exports, __webpack_require__) {
        var baseIndexOf = __webpack_require__(
        /*! ./_baseIndexOf */
        "./node_modules/lodash/_baseIndexOf.js");
        /**
         * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
         * that is not found in the character symbols.
         *
         * @private
         * @param {Array} strSymbols The string symbols to inspect.
         * @param {Array} chrSymbols The character symbols to find.
         * @returns {number} Returns the index of the first unmatched string symbol.
         */


        function charsStartIndex(strSymbols, chrSymbols) {
          var index = -1,
              length = strSymbols.length;

          while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

          return index;
        }

        module.exports = charsStartIndex;
        /***/
      },

      /***/
      "./node_modules/lodash/_copyObject.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_copyObject.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_copyObjectJs(module, exports, __webpack_require__) {
        var assignValue = __webpack_require__(
        /*! ./_assignValue */
        "./node_modules/lodash/_assignValue.js"),
            baseAssignValue = __webpack_require__(
        /*! ./_baseAssignValue */
        "./node_modules/lodash/_baseAssignValue.js");
        /**
         * Copies properties of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy properties from.
         * @param {Array} props The property identifiers to copy.
         * @param {Object} [object={}] The object to copy properties to.
         * @param {Function} [customizer] The function to customize copied values.
         * @returns {Object} Returns `object`.
         */


        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1,
              length = props.length;

          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

            if (newValue === undefined) {
              newValue = source[key];
            }

            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }

          return object;
        }

        module.exports = copyObject;
        /***/
      },

      /***/
      "./node_modules/lodash/_coreJsData.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_coreJsData.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_coreJsDataJs(module, exports, __webpack_require__) {
        var root = __webpack_require__(
        /*! ./_root */
        "./node_modules/lodash/_root.js");
        /** Used to detect overreaching core-js shims. */


        var coreJsData = root['__core-js_shared__'];
        module.exports = coreJsData;
        /***/
      },

      /***/
      "./node_modules/lodash/_createAssigner.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_createAssigner.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_createAssignerJs(module, exports, __webpack_require__) {
        var baseRest = __webpack_require__(
        /*! ./_baseRest */
        "./node_modules/lodash/_baseRest.js"),
            isIterateeCall = __webpack_require__(
        /*! ./_isIterateeCall */
        "./node_modules/lodash/_isIterateeCall.js");
        /**
         * Creates a function like `_.assign`.
         *
         * @private
         * @param {Function} assigner The function to assign values.
         * @returns {Function} Returns the new assigner function.
         */


        function createAssigner(assigner) {
          return baseRest(function (object, sources) {
            var index = -1,
                length = sources.length,
                customizer = length > 1 ? sources[length - 1] : undefined,
                guard = length > 2 ? sources[2] : undefined;
            customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined : customizer;
              length = 1;
            }

            object = Object(object);

            while (++index < length) {
              var source = sources[index];

              if (source) {
                assigner(object, source, index, customizer);
              }
            }

            return object;
          });
        }

        module.exports = createAssigner;
        /***/
      },

      /***/
      "./node_modules/lodash/_createBaseEach.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_createBaseEach.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_createBaseEachJs(module, exports, __webpack_require__) {
        var isArrayLike = __webpack_require__(
        /*! ./isArrayLike */
        "./node_modules/lodash/isArrayLike.js");
        /**
         * Creates a `baseEach` or `baseEachRight` function.
         *
         * @private
         * @param {Function} eachFunc The function to iterate over a collection.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */


        function createBaseEach(eachFunc, fromRight) {
          return function (collection, iteratee) {
            if (collection == null) {
              return collection;
            }

            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee);
            }

            var length = collection.length,
                index = fromRight ? length : -1,
                iterable = Object(collection);

            while (fromRight ? index-- : ++index < length) {
              if (iteratee(iterable[index], index, iterable) === false) {
                break;
              }
            }

            return collection;
          };
        }

        module.exports = createBaseEach;
        /***/
      },

      /***/
      "./node_modules/lodash/_createBaseFor.js":
      /*!***********************************************!*\
        !*** ./node_modules/lodash/_createBaseFor.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_createBaseForJs(module, exports) {
        /**
         * Creates a base function for methods like `_.forIn` and `_.forOwn`.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */
        function createBaseFor(fromRight) {
          return function (object, iteratee, keysFunc) {
            var index = -1,
                iterable = Object(object),
                props = keysFunc(object),
                length = props.length;

            while (length--) {
              var key = props[fromRight ? length : ++index];

              if (iteratee(iterable[key], key, iterable) === false) {
                break;
              }
            }

            return object;
          };
        }

        module.exports = createBaseFor;
        /***/
      },

      /***/
      "./node_modules/lodash/_defineProperty.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_defineProperty.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_definePropertyJs(module, exports, __webpack_require__) {
        var getNative = __webpack_require__(
        /*! ./_getNative */
        "./node_modules/lodash/_getNative.js");

        var defineProperty = function () {
          try {
            var func = getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
          } catch (e) {}
        }();

        module.exports = defineProperty;
        /***/
      },

      /***/
      "./node_modules/lodash/_equalArrays.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_equalArrays.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_equalArraysJs(module, exports, __webpack_require__) {
        var SetCache = __webpack_require__(
        /*! ./_SetCache */
        "./node_modules/lodash/_SetCache.js"),
            arraySome = __webpack_require__(
        /*! ./_arraySome */
        "./node_modules/lodash/_arraySome.js"),
            cacheHas = __webpack_require__(
        /*! ./_cacheHas */
        "./node_modules/lodash/_cacheHas.js");
        /** Used to compose bitmasks for value comparisons. */


        var COMPARE_PARTIAL_FLAG = 1,
            COMPARE_UNORDERED_FLAG = 2;
        /**
         * A specialized version of `baseIsEqualDeep` for arrays with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Array} array The array to compare.
         * @param {Array} other The other array to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `array` and `other` objects.
         * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
         */

        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
              arrLength = array.length,
              othLength = other.length;

          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          } // Assume cyclic values are equal.


          var stacked = stack.get(array);

          if (stacked && stack.get(other)) {
            return stacked == other;
          }

          var index = -1,
              result = true,
              seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
          stack.set(array, other);
          stack.set(other, array); // Ignore non-index properties.

          while (++index < arrLength) {
            var arrValue = array[index],
                othValue = other[index];

            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }

            if (compared !== undefined) {
              if (compared) {
                continue;
              }

              result = false;
              break;
            } // Recursively compare arrays (susceptible to call stack limits).


            if (seen) {
              if (!arraySome(other, function (othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result = false;
              break;
            }
          }

          stack['delete'](array);
          stack['delete'](other);
          return result;
        }

        module.exports = equalArrays;
        /***/
      },

      /***/
      "./node_modules/lodash/_equalByTag.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_equalByTag.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_equalByTagJs(module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(
        /*! ./_Symbol */
        "./node_modules/lodash/_Symbol.js"),
            Uint8Array = __webpack_require__(
        /*! ./_Uint8Array */
        "./node_modules/lodash/_Uint8Array.js"),
            eq = __webpack_require__(
        /*! ./eq */
        "./node_modules/lodash/eq.js"),
            equalArrays = __webpack_require__(
        /*! ./_equalArrays */
        "./node_modules/lodash/_equalArrays.js"),
            mapToArray = __webpack_require__(
        /*! ./_mapToArray */
        "./node_modules/lodash/_mapToArray.js"),
            setToArray = __webpack_require__(
        /*! ./_setToArray */
        "./node_modules/lodash/_setToArray.js");
        /** Used to compose bitmasks for value comparisons. */


        var COMPARE_PARTIAL_FLAG = 1,
            COMPARE_UNORDERED_FLAG = 2;
        /** `Object#toString` result references. */

        var boolTag = '[object Boolean]',
            dateTag = '[object Date]',
            errorTag = '[object Error]',
            mapTag = '[object Map]',
            numberTag = '[object Number]',
            regexpTag = '[object RegExp]',
            setTag = '[object Set]',
            stringTag = '[object String]',
            symbolTag = '[object Symbol]';
        var arrayBufferTag = '[object ArrayBuffer]',
            dataViewTag = '[object DataView]';
        /** Used to convert symbols to primitives and strings. */

        var symbolProto = Symbol ? Symbol.prototype : undefined,
            symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
        /**
         * A specialized version of `baseIsEqualDeep` for comparing objects of
         * the same `toStringTag`.
         *
         * **Note:** This function only supports comparing values with tags of
         * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {string} tag The `toStringTag` of the objects to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */

        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }

              object = object.buffer;
              other = other.buffer;

            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                return false;
              }

              return true;

            case boolTag:
            case dateTag:
            case numberTag:
              // Coerce booleans to `1` or `0` and dates to milliseconds.
              // Invalid dates are coerced to `NaN`.
              return eq(+object, +other);

            case errorTag:
              return object.name == other.name && object.message == other.message;

            case regexpTag:
            case stringTag:
              // Coerce regexes to strings and treat strings, primitives and objects,
              // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
              // for more details.
              return object == other + '';

            case mapTag:
              var convert = mapToArray;

            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);

              if (object.size != other.size && !isPartial) {
                return false;
              } // Assume cyclic values are equal.


              var stacked = stack.get(object);

              if (stacked) {
                return stacked == other;
              }

              bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

              stack.set(object, other);
              var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack['delete'](object);
              return result;

            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }

          }

          return false;
        }

        module.exports = equalByTag;
        /***/
      },

      /***/
      "./node_modules/lodash/_equalObjects.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_equalObjects.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_equalObjectsJs(module, exports, __webpack_require__) {
        var getAllKeys = __webpack_require__(
        /*! ./_getAllKeys */
        "./node_modules/lodash/_getAllKeys.js");
        /** Used to compose bitmasks for value comparisons. */


        var COMPARE_PARTIAL_FLAG = 1;
        /** Used for built-in method references. */

        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * A specialized version of `baseIsEqualDeep` for objects with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */

        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
              objProps = getAllKeys(object),
              objLength = objProps.length,
              othProps = getAllKeys(other),
              othLength = othProps.length;

          if (objLength != othLength && !isPartial) {
            return false;
          }

          var index = objLength;

          while (index--) {
            var key = objProps[index];

            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          } // Assume cyclic values are equal.


          var stacked = stack.get(object);

          if (stacked && stack.get(other)) {
            return stacked == other;
          }

          var result = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;

          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key],
                othValue = other[key];

            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            } // Recursively compare objects (susceptible to call stack limits).


            if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result = false;
              break;
            }

            skipCtor || (skipCtor = key == 'constructor');
          }

          if (result && !skipCtor) {
            var objCtor = object.constructor,
                othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

            if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
              result = false;
            }
          }

          stack['delete'](object);
          stack['delete'](other);
          return result;
        }

        module.exports = equalObjects;
        /***/
      },

      /***/
      "./node_modules/lodash/_freeGlobal.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_freeGlobal.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_freeGlobalJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          /** Detect free variable `global` from Node.js. */
          var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
          module.exports = freeGlobal;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./node_modules/lodash/_getAllKeys.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_getAllKeys.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getAllKeysJs(module, exports, __webpack_require__) {
        var baseGetAllKeys = __webpack_require__(
        /*! ./_baseGetAllKeys */
        "./node_modules/lodash/_baseGetAllKeys.js"),
            getSymbols = __webpack_require__(
        /*! ./_getSymbols */
        "./node_modules/lodash/_getSymbols.js"),
            keys = __webpack_require__(
        /*! ./keys */
        "./node_modules/lodash/keys.js");
        /**
         * Creates an array of own enumerable property names and symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */


        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }

        module.exports = getAllKeys;
        /***/
      },

      /***/
      "./node_modules/lodash/_getMapData.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_getMapData.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getMapDataJs(module, exports, __webpack_require__) {
        var isKeyable = __webpack_require__(
        /*! ./_isKeyable */
        "./node_modules/lodash/_isKeyable.js");
        /**
         * Gets the data for `map`.
         *
         * @private
         * @param {Object} map The map to query.
         * @param {string} key The reference key.
         * @returns {*} Returns the map data.
         */


        function getMapData(map, key) {
          var data = map.__data__;
          return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }

        module.exports = getMapData;
        /***/
      },

      /***/
      "./node_modules/lodash/_getMatchData.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_getMatchData.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getMatchDataJs(module, exports, __webpack_require__) {
        var isStrictComparable = __webpack_require__(
        /*! ./_isStrictComparable */
        "./node_modules/lodash/_isStrictComparable.js"),
            keys = __webpack_require__(
        /*! ./keys */
        "./node_modules/lodash/keys.js");
        /**
         * Gets the property names, values, and compare flags of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the match data of `object`.
         */


        function getMatchData(object) {
          var result = keys(object),
              length = result.length;

          while (length--) {
            var key = result[length],
                value = object[key];
            result[length] = [key, value, isStrictComparable(value)];
          }

          return result;
        }

        module.exports = getMatchData;
        /***/
      },

      /***/
      "./node_modules/lodash/_getNative.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_getNative.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getNativeJs(module, exports, __webpack_require__) {
        var baseIsNative = __webpack_require__(
        /*! ./_baseIsNative */
        "./node_modules/lodash/_baseIsNative.js"),
            getValue = __webpack_require__(
        /*! ./_getValue */
        "./node_modules/lodash/_getValue.js");
        /**
         * Gets the native function at `key` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the method to get.
         * @returns {*} Returns the function if it's native, else `undefined`.
         */


        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined;
        }

        module.exports = getNative;
        /***/
      },

      /***/
      "./node_modules/lodash/_getRawTag.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_getRawTag.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getRawTagJs(module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(
        /*! ./_Symbol */
        "./node_modules/lodash/_Symbol.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */

        var nativeObjectToString = objectProto.toString;
        /** Built-in value references. */

        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */

        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
              tag = value[symToStringTag];

          try {
            value[symToStringTag] = undefined;
            var unmasked = true;
          } catch (e) {}

          var result = nativeObjectToString.call(value);

          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }

          return result;
        }

        module.exports = getRawTag;
        /***/
      },

      /***/
      "./node_modules/lodash/_getSymbols.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_getSymbols.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getSymbolsJs(module, exports, __webpack_require__) {
        var arrayFilter = __webpack_require__(
        /*! ./_arrayFilter */
        "./node_modules/lodash/_arrayFilter.js"),
            stubArray = __webpack_require__(
        /*! ./stubArray */
        "./node_modules/lodash/stubArray.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Built-in value references. */

        var propertyIsEnumerable = objectProto.propertyIsEnumerable;
        /* Built-in method references for those with the same name as other `lodash` methods. */

        var nativeGetSymbols = Object.getOwnPropertySymbols;
        /**
         * Creates an array of the own enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */

        var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
          if (object == null) {
            return [];
          }

          object = Object(object);
          return arrayFilter(nativeGetSymbols(object), function (symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        module.exports = getSymbols;
        /***/
      },

      /***/
      "./node_modules/lodash/_getTag.js":
      /*!****************************************!*\
        !*** ./node_modules/lodash/_getTag.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getTagJs(module, exports, __webpack_require__) {
        var DataView = __webpack_require__(
        /*! ./_DataView */
        "./node_modules/lodash/_DataView.js"),
            Map = __webpack_require__(
        /*! ./_Map */
        "./node_modules/lodash/_Map.js"),
            Promise = __webpack_require__(
        /*! ./_Promise */
        "./node_modules/lodash/_Promise.js"),
            Set = __webpack_require__(
        /*! ./_Set */
        "./node_modules/lodash/_Set.js"),
            WeakMap = __webpack_require__(
        /*! ./_WeakMap */
        "./node_modules/lodash/_WeakMap.js"),
            baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "./node_modules/lodash/_baseGetTag.js"),
            toSource = __webpack_require__(
        /*! ./_toSource */
        "./node_modules/lodash/_toSource.js");
        /** `Object#toString` result references. */


        var mapTag = '[object Map]',
            objectTag = '[object Object]',
            promiseTag = '[object Promise]',
            setTag = '[object Set]',
            weakMapTag = '[object WeakMap]';
        var dataViewTag = '[object DataView]';
        /** Used to detect maps, sets, and weakmaps. */

        var dataViewCtorString = toSource(DataView),
            mapCtorString = toSource(Map),
            promiseCtorString = toSource(Promise),
            setCtorString = toSource(Set),
            weakMapCtorString = toSource(WeakMap);
        /**
         * Gets the `toStringTag` of `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */

        var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function getTag(value) {
            var result = baseGetTag(value),
                Ctor = result == objectTag ? value.constructor : undefined,
                ctorString = Ctor ? toSource(Ctor) : '';

            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;

                case mapCtorString:
                  return mapTag;

                case promiseCtorString:
                  return promiseTag;

                case setCtorString:
                  return setTag;

                case weakMapCtorString:
                  return weakMapTag;
              }
            }

            return result;
          };
        }

        module.exports = getTag;
        /***/
      },

      /***/
      "./node_modules/lodash/_getValue.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_getValue.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getValueJs(module, exports) {
        /**
         * Gets the value at `key` of `object`.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {string} key The key of the property to get.
         * @returns {*} Returns the property value.
         */
        function getValue(object, key) {
          return object == null ? undefined : object[key];
        }

        module.exports = getValue;
        /***/
      },

      /***/
      "./node_modules/lodash/_hasPath.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_hasPath.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_hasPathJs(module, exports, __webpack_require__) {
        var castPath = __webpack_require__(
        /*! ./_castPath */
        "./node_modules/lodash/_castPath.js"),
            isArguments = __webpack_require__(
        /*! ./isArguments */
        "./node_modules/lodash/isArguments.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js"),
            isIndex = __webpack_require__(
        /*! ./_isIndex */
        "./node_modules/lodash/_isIndex.js"),
            isLength = __webpack_require__(
        /*! ./isLength */
        "./node_modules/lodash/isLength.js"),
            toKey = __webpack_require__(
        /*! ./_toKey */
        "./node_modules/lodash/_toKey.js");
        /**
         * Checks if `path` exists on `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @param {Function} hasFunc The function to check properties.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         */


        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1,
              length = path.length,
              result = false;

          while (++index < length) {
            var key = toKey(path[index]);

            if (!(result = object != null && hasFunc(object, key))) {
              break;
            }

            object = object[key];
          }

          if (result || ++index != length) {
            return result;
          }

          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }

        module.exports = hasPath;
        /***/
      },

      /***/
      "./node_modules/lodash/_hasUnicode.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_hasUnicode.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_hasUnicodeJs(module, exports) {
        /** Used to compose unicode character classes. */
        var rsAstralRange = "\\ud800-\\udfff",
            rsComboMarksRange = "\\u0300-\\u036f",
            reComboHalfMarksRange = "\\ufe20-\\ufe2f",
            rsComboSymbolsRange = "\\u20d0-\\u20ff",
            rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
            rsVarRange = "\\ufe0e\\ufe0f";
        /** Used to compose unicode capture groups. */

        var rsZWJ = "\\u200d";
        /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

        var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
        /**
         * Checks if `string` contains Unicode symbols.
         *
         * @private
         * @param {string} string The string to inspect.
         * @returns {boolean} Returns `true` if a symbol is found, else `false`.
         */

        function hasUnicode(string) {
          return reHasUnicode.test(string);
        }

        module.exports = hasUnicode;
        /***/
      },

      /***/
      "./node_modules/lodash/_hashClear.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_hashClear.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_hashClearJs(module, exports, __webpack_require__) {
        var nativeCreate = __webpack_require__(
        /*! ./_nativeCreate */
        "./node_modules/lodash/_nativeCreate.js");
        /**
         * Removes all key-value entries from the hash.
         *
         * @private
         * @name clear
         * @memberOf Hash
         */


        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }

        module.exports = hashClear;
        /***/
      },

      /***/
      "./node_modules/lodash/_hashDelete.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_hashDelete.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_hashDeleteJs(module, exports) {
        /**
         * Removes `key` and its value from the hash.
         *
         * @private
         * @name delete
         * @memberOf Hash
         * @param {Object} hash The hash to modify.
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function hashDelete(key) {
          var result = this.has(key) && delete this.__data__[key];
          this.size -= result ? 1 : 0;
          return result;
        }

        module.exports = hashDelete;
        /***/
      },

      /***/
      "./node_modules/lodash/_hashGet.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_hashGet.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_hashGetJs(module, exports, __webpack_require__) {
        var nativeCreate = __webpack_require__(
        /*! ./_nativeCreate */
        "./node_modules/lodash/_nativeCreate.js");
        /** Used to stand-in for `undefined` hash values. */


        var HASH_UNDEFINED = '__lodash_hash_undefined__';
        /** Used for built-in method references. */

        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Gets the hash value for `key`.
         *
         * @private
         * @name get
         * @memberOf Hash
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */

        function hashGet(key) {
          var data = this.__data__;

          if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
          }

          return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }

        module.exports = hashGet;
        /***/
      },

      /***/
      "./node_modules/lodash/_hashHas.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_hashHas.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_hashHasJs(module, exports, __webpack_require__) {
        var nativeCreate = __webpack_require__(
        /*! ./_nativeCreate */
        "./node_modules/lodash/_nativeCreate.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Checks if a hash value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Hash
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */

        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }

        module.exports = hashHas;
        /***/
      },

      /***/
      "./node_modules/lodash/_hashSet.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_hashSet.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_hashSetJs(module, exports, __webpack_require__) {
        var nativeCreate = __webpack_require__(
        /*! ./_nativeCreate */
        "./node_modules/lodash/_nativeCreate.js");
        /** Used to stand-in for `undefined` hash values. */


        var HASH_UNDEFINED = '__lodash_hash_undefined__';
        /**
         * Sets the hash `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Hash
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the hash instance.
         */

        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
          return this;
        }

        module.exports = hashSet;
        /***/
      },

      /***/
      "./node_modules/lodash/_isIndex.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_isIndex.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isIndexJs(module, exports) {
        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;
        /** Used to detect unsigned integer values. */

        var reIsUint = /^(?:0|[1-9]\d*)$/;
        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */

        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }

        module.exports = isIndex;
        /***/
      },

      /***/
      "./node_modules/lodash/_isIterateeCall.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_isIterateeCall.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isIterateeCallJs(module, exports, __webpack_require__) {
        var eq = __webpack_require__(
        /*! ./eq */
        "./node_modules/lodash/eq.js"),
            isArrayLike = __webpack_require__(
        /*! ./isArrayLike */
        "./node_modules/lodash/isArrayLike.js"),
            isIndex = __webpack_require__(
        /*! ./_isIndex */
        "./node_modules/lodash/_isIndex.js"),
            isObject = __webpack_require__(
        /*! ./isObject */
        "./node_modules/lodash/isObject.js");
        /**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */


        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }

          var type = typeof index;

          if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
            return eq(object[index], value);
          }

          return false;
        }

        module.exports = isIterateeCall;
        /***/
      },

      /***/
      "./node_modules/lodash/_isKey.js":
      /*!***************************************!*\
        !*** ./node_modules/lodash/_isKey.js ***!
        \***************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isKeyJs(module, exports, __webpack_require__) {
        var isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js"),
            isSymbol = __webpack_require__(
        /*! ./isSymbol */
        "./node_modules/lodash/isSymbol.js");
        /** Used to match property names within property paths. */


        var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            reIsPlainProp = /^\w*$/;
        /**
         * Checks if `value` is a property name and not a property path.
         *
         * @private
         * @param {*} value The value to check.
         * @param {Object} [object] The object to query keys on.
         * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
         */

        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }

          var type = typeof value;

          if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
            return true;
          }

          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
        }

        module.exports = isKey;
        /***/
      },

      /***/
      "./node_modules/lodash/_isKeyable.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/_isKeyable.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isKeyableJs(module, exports) {
        /**
         * Checks if `value` is suitable for use as unique object key.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
         */
        function isKeyable(value) {
          var type = typeof value;
          return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }

        module.exports = isKeyable;
        /***/
      },

      /***/
      "./node_modules/lodash/_isMasked.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_isMasked.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isMaskedJs(module, exports, __webpack_require__) {
        var coreJsData = __webpack_require__(
        /*! ./_coreJsData */
        "./node_modules/lodash/_coreJsData.js");
        /** Used to detect methods masquerading as native. */


        var maskSrcKey = function () {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
          return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
         * Checks if `func` has its source masked.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` is masked, else `false`.
         */


        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }

        module.exports = isMasked;
        /***/
      },

      /***/
      "./node_modules/lodash/_isPrototype.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_isPrototype.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isPrototypeJs(module, exports) {
        /** Used for built-in method references. */
        var objectProto = Object.prototype;
        /**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */

        function isPrototype(value) {
          var Ctor = value && value.constructor,
              proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
          return value === proto;
        }

        module.exports = isPrototype;
        /***/
      },

      /***/
      "./node_modules/lodash/_isStrictComparable.js":
      /*!****************************************************!*\
        !*** ./node_modules/lodash/_isStrictComparable.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isStrictComparableJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./isObject */
        "./node_modules/lodash/isObject.js");
        /**
         * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` if suitable for strict
         *  equality comparisons, else `false`.
         */


        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }

        module.exports = isStrictComparable;
        /***/
      },

      /***/
      "./node_modules/lodash/_listCacheClear.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_listCacheClear.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_listCacheClearJs(module, exports) {
        /**
         * Removes all key-value entries from the list cache.
         *
         * @private
         * @name clear
         * @memberOf ListCache
         */
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }

        module.exports = listCacheClear;
        /***/
      },

      /***/
      "./node_modules/lodash/_listCacheDelete.js":
      /*!*************************************************!*\
        !*** ./node_modules/lodash/_listCacheDelete.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_listCacheDeleteJs(module, exports, __webpack_require__) {
        var assocIndexOf = __webpack_require__(
        /*! ./_assocIndexOf */
        "./node_modules/lodash/_assocIndexOf.js");
        /** Used for built-in method references. */


        var arrayProto = Array.prototype;
        /** Built-in value references. */

        var splice = arrayProto.splice;
        /**
         * Removes `key` and its value from the list cache.
         *
         * @private
         * @name delete
         * @memberOf ListCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */

        function listCacheDelete(key) {
          var data = this.__data__,
              index = assocIndexOf(data, key);

          if (index < 0) {
            return false;
          }

          var lastIndex = data.length - 1;

          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }

          --this.size;
          return true;
        }

        module.exports = listCacheDelete;
        /***/
      },

      /***/
      "./node_modules/lodash/_listCacheGet.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_listCacheGet.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_listCacheGetJs(module, exports, __webpack_require__) {
        var assocIndexOf = __webpack_require__(
        /*! ./_assocIndexOf */
        "./node_modules/lodash/_assocIndexOf.js");
        /**
         * Gets the list cache value for `key`.
         *
         * @private
         * @name get
         * @memberOf ListCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */


        function listCacheGet(key) {
          var data = this.__data__,
              index = assocIndexOf(data, key);
          return index < 0 ? undefined : data[index][1];
        }

        module.exports = listCacheGet;
        /***/
      },

      /***/
      "./node_modules/lodash/_listCacheHas.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_listCacheHas.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_listCacheHasJs(module, exports, __webpack_require__) {
        var assocIndexOf = __webpack_require__(
        /*! ./_assocIndexOf */
        "./node_modules/lodash/_assocIndexOf.js");
        /**
         * Checks if a list cache value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf ListCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */


        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }

        module.exports = listCacheHas;
        /***/
      },

      /***/
      "./node_modules/lodash/_listCacheSet.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_listCacheSet.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_listCacheSetJs(module, exports, __webpack_require__) {
        var assocIndexOf = __webpack_require__(
        /*! ./_assocIndexOf */
        "./node_modules/lodash/_assocIndexOf.js");
        /**
         * Sets the list cache `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf ListCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the list cache instance.
         */


        function listCacheSet(key, value) {
          var data = this.__data__,
              index = assocIndexOf(data, key);

          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }

          return this;
        }

        module.exports = listCacheSet;
        /***/
      },

      /***/
      "./node_modules/lodash/_mapCacheClear.js":
      /*!***********************************************!*\
        !*** ./node_modules/lodash/_mapCacheClear.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_mapCacheClearJs(module, exports, __webpack_require__) {
        var Hash = __webpack_require__(
        /*! ./_Hash */
        "./node_modules/lodash/_Hash.js"),
            ListCache = __webpack_require__(
        /*! ./_ListCache */
        "./node_modules/lodash/_ListCache.js"),
            Map = __webpack_require__(
        /*! ./_Map */
        "./node_modules/lodash/_Map.js");
        /**
         * Removes all key-value entries from the map.
         *
         * @private
         * @name clear
         * @memberOf MapCache
         */


        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            'hash': new Hash(),
            'map': new (Map || ListCache)(),
            'string': new Hash()
          };
        }

        module.exports = mapCacheClear;
        /***/
      },

      /***/
      "./node_modules/lodash/_mapCacheDelete.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_mapCacheDelete.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_mapCacheDeleteJs(module, exports, __webpack_require__) {
        var getMapData = __webpack_require__(
        /*! ./_getMapData */
        "./node_modules/lodash/_getMapData.js");
        /**
         * Removes `key` and its value from the map.
         *
         * @private
         * @name delete
         * @memberOf MapCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */


        function mapCacheDelete(key) {
          var result = getMapData(this, key)['delete'](key);
          this.size -= result ? 1 : 0;
          return result;
        }

        module.exports = mapCacheDelete;
        /***/
      },

      /***/
      "./node_modules/lodash/_mapCacheGet.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_mapCacheGet.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_mapCacheGetJs(module, exports, __webpack_require__) {
        var getMapData = __webpack_require__(
        /*! ./_getMapData */
        "./node_modules/lodash/_getMapData.js");
        /**
         * Gets the map value for `key`.
         *
         * @private
         * @name get
         * @memberOf MapCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */


        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }

        module.exports = mapCacheGet;
        /***/
      },

      /***/
      "./node_modules/lodash/_mapCacheHas.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_mapCacheHas.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_mapCacheHasJs(module, exports, __webpack_require__) {
        var getMapData = __webpack_require__(
        /*! ./_getMapData */
        "./node_modules/lodash/_getMapData.js");
        /**
         * Checks if a map value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf MapCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */


        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }

        module.exports = mapCacheHas;
        /***/
      },

      /***/
      "./node_modules/lodash/_mapCacheSet.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_mapCacheSet.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_mapCacheSetJs(module, exports, __webpack_require__) {
        var getMapData = __webpack_require__(
        /*! ./_getMapData */
        "./node_modules/lodash/_getMapData.js");
        /**
         * Sets the map `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf MapCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the map cache instance.
         */


        function mapCacheSet(key, value) {
          var data = getMapData(this, key),
              size = data.size;
          data.set(key, value);
          this.size += data.size == size ? 0 : 1;
          return this;
        }

        module.exports = mapCacheSet;
        /***/
      },

      /***/
      "./node_modules/lodash/_mapToArray.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_mapToArray.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_mapToArrayJs(module, exports) {
        /**
         * Converts `map` to its key-value pairs.
         *
         * @private
         * @param {Object} map The map to convert.
         * @returns {Array} Returns the key-value pairs.
         */
        function mapToArray(map) {
          var index = -1,
              result = Array(map.size);
          map.forEach(function (value, key) {
            result[++index] = [key, value];
          });
          return result;
        }

        module.exports = mapToArray;
        /***/
      },

      /***/
      "./node_modules/lodash/_matchesStrictComparable.js":
      /*!*********************************************************!*\
        !*** ./node_modules/lodash/_matchesStrictComparable.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_matchesStrictComparableJs(module, exports) {
        /**
         * A specialized version of `matchesProperty` for source values suitable
         * for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {string} key The key of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */
        function matchesStrictComparable(key, srcValue) {
          return function (object) {
            if (object == null) {
              return false;
            }

            return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
          };
        }

        module.exports = matchesStrictComparable;
        /***/
      },

      /***/
      "./node_modules/lodash/_memoizeCapped.js":
      /*!***********************************************!*\
        !*** ./node_modules/lodash/_memoizeCapped.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_memoizeCappedJs(module, exports, __webpack_require__) {
        var memoize = __webpack_require__(
        /*! ./memoize */
        "./node_modules/lodash/memoize.js");
        /** Used as the maximum memoize cache size. */


        var MAX_MEMOIZE_SIZE = 500;
        /**
         * A specialized version of `_.memoize` which clears the memoized function's
         * cache when it exceeds `MAX_MEMOIZE_SIZE`.
         *
         * @private
         * @param {Function} func The function to have its output memoized.
         * @returns {Function} Returns the new memoized function.
         */

        function memoizeCapped(func) {
          var result = memoize(func, function (key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }

            return key;
          });
          var cache = result.cache;
          return result;
        }

        module.exports = memoizeCapped;
        /***/
      },

      /***/
      "./node_modules/lodash/_nativeCreate.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_nativeCreate.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_nativeCreateJs(module, exports, __webpack_require__) {
        var getNative = __webpack_require__(
        /*! ./_getNative */
        "./node_modules/lodash/_getNative.js");
        /* Built-in method references that are verified to be native. */


        var nativeCreate = getNative(Object, 'create');
        module.exports = nativeCreate;
        /***/
      },

      /***/
      "./node_modules/lodash/_nativeKeys.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_nativeKeys.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_nativeKeysJs(module, exports, __webpack_require__) {
        var overArg = __webpack_require__(
        /*! ./_overArg */
        "./node_modules/lodash/_overArg.js");
        /* Built-in method references for those with the same name as other `lodash` methods. */


        var nativeKeys = overArg(Object.keys, Object);
        module.exports = nativeKeys;
        /***/
      },

      /***/
      "./node_modules/lodash/_nodeUtil.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_nodeUtil.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_nodeUtilJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (module) {
          var freeGlobal = __webpack_require__(
          /*! ./_freeGlobal */
          "./node_modules/lodash/_freeGlobal.js");
          /** Detect free variable `exports`. */


          var freeExports = true && exports && !exports.nodeType && exports;
          /** Detect free variable `module`. */

          var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
          /** Detect the popular CommonJS extension `module.exports`. */

          var moduleExports = freeModule && freeModule.exports === freeExports;
          /** Detect free variable `process` from Node.js. */

          var freeProcess = moduleExports && freeGlobal.process;
          /** Used to access faster Node.js helpers. */

          var nodeUtil = function () {
            try {
              // Use `util.types` for Node.js 10+.
              var types = freeModule && freeModule.require && freeModule.require('util').types;

              if (types) {
                return types;
              } // Legacy `process.binding('util')` for Node.js < 10.


              return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
          }();

          module.exports = nodeUtil;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../webpack/buildin/module.js */
        "./node_modules/webpack/buildin/module.js")(module));
        /***/
      },

      /***/
      "./node_modules/lodash/_objectToString.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_objectToString.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_objectToStringJs(module, exports) {
        /** Used for built-in method references. */
        var objectProto = Object.prototype;
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */

        var nativeObjectToString = objectProto.toString;
        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */

        function objectToString(value) {
          return nativeObjectToString.call(value);
        }

        module.exports = objectToString;
        /***/
      },

      /***/
      "./node_modules/lodash/_overArg.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/_overArg.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_overArgJs(module, exports) {
        /**
         * Creates a unary function that invokes `func` with its argument transformed.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {Function} transform The argument transform.
         * @returns {Function} Returns the new function.
         */
        function overArg(func, transform) {
          return function (arg) {
            return func(transform(arg));
          };
        }

        module.exports = overArg;
        /***/
      },

      /***/
      "./node_modules/lodash/_overRest.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_overRest.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_overRestJs(module, exports, __webpack_require__) {
        var apply = __webpack_require__(
        /*! ./_apply */
        "./node_modules/lodash/_apply.js");
        /* Built-in method references for those with the same name as other `lodash` methods. */


        var nativeMax = Math.max;
        /**
         * A specialized version of `baseRest` which transforms the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @param {Function} transform The rest array transform.
         * @returns {Function} Returns the new function.
         */

        function overRest(func, start, transform) {
          start = nativeMax(start === undefined ? func.length - 1 : start, 0);
          return function () {
            var args = arguments,
                index = -1,
                length = nativeMax(args.length - start, 0),
                array = Array(length);

            while (++index < length) {
              array[index] = args[start + index];
            }

            index = -1;
            var otherArgs = Array(start + 1);

            while (++index < start) {
              otherArgs[index] = args[index];
            }

            otherArgs[start] = transform(array);
            return apply(func, this, otherArgs);
          };
        }

        module.exports = overRest;
        /***/
      },

      /***/
      "./node_modules/lodash/_root.js":
      /*!**************************************!*\
        !*** ./node_modules/lodash/_root.js ***!
        \**************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_rootJs(module, exports, __webpack_require__) {
        var freeGlobal = __webpack_require__(
        /*! ./_freeGlobal */
        "./node_modules/lodash/_freeGlobal.js");
        /** Detect free variable `self`. */


        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        /** Used as a reference to the global object. */

        var root = freeGlobal || freeSelf || Function('return this')();
        module.exports = root;
        /***/
      },

      /***/
      "./node_modules/lodash/_setCacheAdd.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_setCacheAdd.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_setCacheAddJs(module, exports) {
        /** Used to stand-in for `undefined` hash values. */
        var HASH_UNDEFINED = '__lodash_hash_undefined__';
        /**
         * Adds `value` to the array cache.
         *
         * @private
         * @name add
         * @memberOf SetCache
         * @alias push
         * @param {*} value The value to cache.
         * @returns {Object} Returns the cache instance.
         */

        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);

          return this;
        }

        module.exports = setCacheAdd;
        /***/
      },

      /***/
      "./node_modules/lodash/_setCacheHas.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_setCacheHas.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_setCacheHasJs(module, exports) {
        /**
         * Checks if `value` is in the array cache.
         *
         * @private
         * @name has
         * @memberOf SetCache
         * @param {*} value The value to search for.
         * @returns {number} Returns `true` if `value` is found, else `false`.
         */
        function setCacheHas(value) {
          return this.__data__.has(value);
        }

        module.exports = setCacheHas;
        /***/
      },

      /***/
      "./node_modules/lodash/_setToArray.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_setToArray.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_setToArrayJs(module, exports) {
        /**
         * Converts `set` to an array of its values.
         *
         * @private
         * @param {Object} set The set to convert.
         * @returns {Array} Returns the values.
         */
        function setToArray(set) {
          var index = -1,
              result = Array(set.size);
          set.forEach(function (value) {
            result[++index] = value;
          });
          return result;
        }

        module.exports = setToArray;
        /***/
      },

      /***/
      "./node_modules/lodash/_setToString.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_setToString.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_setToStringJs(module, exports, __webpack_require__) {
        var baseSetToString = __webpack_require__(
        /*! ./_baseSetToString */
        "./node_modules/lodash/_baseSetToString.js"),
            shortOut = __webpack_require__(
        /*! ./_shortOut */
        "./node_modules/lodash/_shortOut.js");
        /**
         * Sets the `toString` method of `func` to return `string`.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */


        var setToString = shortOut(baseSetToString);
        module.exports = setToString;
        /***/
      },

      /***/
      "./node_modules/lodash/_shortOut.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_shortOut.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_shortOutJs(module, exports) {
        /** Used to detect hot functions by number of calls within a span of milliseconds. */
        var HOT_COUNT = 800,
            HOT_SPAN = 16;
        /* Built-in method references for those with the same name as other `lodash` methods. */

        var nativeNow = Date.now;
        /**
         * Creates a function that'll short out and invoke `identity` instead
         * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
         * milliseconds.
         *
         * @private
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new shortable function.
         */

        function shortOut(func) {
          var count = 0,
              lastCalled = 0;
          return function () {
            var stamp = nativeNow(),
                remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;

            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }

            return func.apply(undefined, arguments);
          };
        }

        module.exports = shortOut;
        /***/
      },

      /***/
      "./node_modules/lodash/_stackClear.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/_stackClear.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_stackClearJs(module, exports, __webpack_require__) {
        var ListCache = __webpack_require__(
        /*! ./_ListCache */
        "./node_modules/lodash/_ListCache.js");
        /**
         * Removes all key-value entries from the stack.
         *
         * @private
         * @name clear
         * @memberOf Stack
         */


        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }

        module.exports = stackClear;
        /***/
      },

      /***/
      "./node_modules/lodash/_stackDelete.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/_stackDelete.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_stackDeleteJs(module, exports) {
        /**
         * Removes `key` and its value from the stack.
         *
         * @private
         * @name delete
         * @memberOf Stack
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function stackDelete(key) {
          var data = this.__data__,
              result = data['delete'](key);
          this.size = data.size;
          return result;
        }

        module.exports = stackDelete;
        /***/
      },

      /***/
      "./node_modules/lodash/_stackGet.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_stackGet.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_stackGetJs(module, exports) {
        /**
         * Gets the stack value for `key`.
         *
         * @private
         * @name get
         * @memberOf Stack
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function stackGet(key) {
          return this.__data__.get(key);
        }

        module.exports = stackGet;
        /***/
      },

      /***/
      "./node_modules/lodash/_stackHas.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_stackHas.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_stackHasJs(module, exports) {
        /**
         * Checks if a stack value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Stack
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function stackHas(key) {
          return this.__data__.has(key);
        }

        module.exports = stackHas;
        /***/
      },

      /***/
      "./node_modules/lodash/_stackSet.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_stackSet.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_stackSetJs(module, exports, __webpack_require__) {
        var ListCache = __webpack_require__(
        /*! ./_ListCache */
        "./node_modules/lodash/_ListCache.js"),
            Map = __webpack_require__(
        /*! ./_Map */
        "./node_modules/lodash/_Map.js"),
            MapCache = __webpack_require__(
        /*! ./_MapCache */
        "./node_modules/lodash/_MapCache.js");
        /** Used as the size to enable large array optimizations. */


        var LARGE_ARRAY_SIZE = 200;
        /**
         * Sets the stack `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Stack
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the stack cache instance.
         */

        function stackSet(key, value) {
          var data = this.__data__;

          if (data instanceof ListCache) {
            var pairs = data.__data__;

            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }

            data = this.__data__ = new MapCache(pairs);
          }

          data.set(key, value);
          this.size = data.size;
          return this;
        }

        module.exports = stackSet;
        /***/
      },

      /***/
      "./node_modules/lodash/_strictIndexOf.js":
      /*!***********************************************!*\
        !*** ./node_modules/lodash/_strictIndexOf.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_strictIndexOfJs(module, exports) {
        /**
         * A specialized version of `_.indexOf` which performs strict equality
         * comparisons of values, i.e. `===`.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} fromIndex The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function strictIndexOf(array, value, fromIndex) {
          var index = fromIndex - 1,
              length = array.length;

          while (++index < length) {
            if (array[index] === value) {
              return index;
            }
          }

          return -1;
        }

        module.exports = strictIndexOf;
        /***/
      },

      /***/
      "./node_modules/lodash/_stringToArray.js":
      /*!***********************************************!*\
        !*** ./node_modules/lodash/_stringToArray.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_stringToArrayJs(module, exports, __webpack_require__) {
        var asciiToArray = __webpack_require__(
        /*! ./_asciiToArray */
        "./node_modules/lodash/_asciiToArray.js"),
            hasUnicode = __webpack_require__(
        /*! ./_hasUnicode */
        "./node_modules/lodash/_hasUnicode.js"),
            unicodeToArray = __webpack_require__(
        /*! ./_unicodeToArray */
        "./node_modules/lodash/_unicodeToArray.js");
        /**
         * Converts `string` to an array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the converted array.
         */


        function stringToArray(string) {
          return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
        }

        module.exports = stringToArray;
        /***/
      },

      /***/
      "./node_modules/lodash/_stringToPath.js":
      /*!**********************************************!*\
        !*** ./node_modules/lodash/_stringToPath.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_stringToPathJs(module, exports, __webpack_require__) {
        var memoizeCapped = __webpack_require__(
        /*! ./_memoizeCapped */
        "./node_modules/lodash/_memoizeCapped.js");
        /** Used to match property names within property paths. */


        var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        /** Used to match backslashes in property paths. */

        var reEscapeChar = /\\(\\)?/g;
        /**
         * Converts `string` to a property path array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the property path array.
         */

        var stringToPath = memoizeCapped(function (string) {
          var result = [];

          if (string.charCodeAt(0) === 46
          /* . */
          ) {
              result.push('');
            }

          string.replace(rePropName, function (match, number, quote, subString) {
            result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
          });
          return result;
        });
        module.exports = stringToPath;
        /***/
      },

      /***/
      "./node_modules/lodash/_toKey.js":
      /*!***************************************!*\
        !*** ./node_modules/lodash/_toKey.js ***!
        \***************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_toKeyJs(module, exports, __webpack_require__) {
        var isSymbol = __webpack_require__(
        /*! ./isSymbol */
        "./node_modules/lodash/isSymbol.js");
        /** Used as references for various `Number` constants. */


        var INFINITY = 1 / 0;
        /**
         * Converts `value` to a string key if it's not a string or symbol.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {string|symbol} Returns the key.
         */

        function toKey(value) {
          if (typeof value == 'string' || isSymbol(value)) {
            return value;
          }

          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }

        module.exports = toKey;
        /***/
      },

      /***/
      "./node_modules/lodash/_toSource.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/_toSource.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_toSourceJs(module, exports) {
        /** Used for built-in method references. */
        var funcProto = Function.prototype;
        /** Used to resolve the decompiled source of functions. */

        var funcToString = funcProto.toString;
        /**
         * Converts `func` to its source code.
         *
         * @private
         * @param {Function} func The function to convert.
         * @returns {string} Returns the source code.
         */

        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {}

            try {
              return func + '';
            } catch (e) {}
          }

          return '';
        }

        module.exports = toSource;
        /***/
      },

      /***/
      "./node_modules/lodash/_unicodeToArray.js":
      /*!************************************************!*\
        !*** ./node_modules/lodash/_unicodeToArray.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_unicodeToArrayJs(module, exports) {
        /** Used to compose unicode character classes. */
        var rsAstralRange = "\\ud800-\\udfff",
            rsComboMarksRange = "\\u0300-\\u036f",
            reComboHalfMarksRange = "\\ufe20-\\ufe2f",
            rsComboSymbolsRange = "\\u20d0-\\u20ff",
            rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
            rsVarRange = "\\ufe0e\\ufe0f";
        /** Used to compose unicode capture groups. */

        var rsAstral = '[' + rsAstralRange + ']',
            rsCombo = '[' + rsComboRange + ']',
            rsFitz = "\\ud83c[\\udffb-\\udfff]",
            rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
            rsNonAstral = '[^' + rsAstralRange + ']',
            rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            rsZWJ = "\\u200d";
        /** Used to compose unicode regexes. */

        var reOptMod = rsModifier + '?',
            rsOptVar = '[' + rsVarRange + ']?',
            rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
            rsSeq = rsOptVar + reOptMod + rsOptJoin,
            rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
        /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

        var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
        /**
         * Converts a Unicode `string` to an array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the converted array.
         */

        function unicodeToArray(string) {
          return string.match(reUnicode) || [];
        }

        module.exports = unicodeToArray;
        /***/
      },

      /***/
      "./node_modules/lodash/assign.js":
      /*!***************************************!*\
        !*** ./node_modules/lodash/assign.js ***!
        \***************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashAssignJs(module, exports, __webpack_require__) {
        var assignValue = __webpack_require__(
        /*! ./_assignValue */
        "./node_modules/lodash/_assignValue.js"),
            copyObject = __webpack_require__(
        /*! ./_copyObject */
        "./node_modules/lodash/_copyObject.js"),
            createAssigner = __webpack_require__(
        /*! ./_createAssigner */
        "./node_modules/lodash/_createAssigner.js"),
            isArrayLike = __webpack_require__(
        /*! ./isArrayLike */
        "./node_modules/lodash/isArrayLike.js"),
            isPrototype = __webpack_require__(
        /*! ./_isPrototype */
        "./node_modules/lodash/_isPrototype.js"),
            keys = __webpack_require__(
        /*! ./keys */
        "./node_modules/lodash/keys.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Assigns own enumerable string keyed properties of source objects to the
         * destination object. Source objects are applied from left to right.
         * Subsequent sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object` and is loosely based on
         * [`Object.assign`](https://mdn.io/Object/assign).
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assignIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assign({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'c': 3 }
         */

        var assign = createAssigner(function (object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }

          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        module.exports = assign;
        /***/
      },

      /***/
      "./node_modules/lodash/constant.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/constant.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashConstantJs(module, exports) {
        /**
         * Creates a function that returns `value`.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {*} value The value to return from the new function.
         * @returns {Function} Returns the new constant function.
         * @example
         *
         * var objects = _.times(2, _.constant({ 'a': 1 }));
         *
         * console.log(objects);
         * // => [{ 'a': 1 }, { 'a': 1 }]
         *
         * console.log(objects[0] === objects[1]);
         * // => true
         */
        function constant(value) {
          return function () {
            return value;
          };
        }

        module.exports = constant;
        /***/
      },

      /***/
      "./node_modules/lodash/eq.js":
      /*!***********************************!*\
        !*** ./node_modules/lodash/eq.js ***!
        \***********************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashEqJs(module, exports) {
        /**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }

        module.exports = eq;
        /***/
      },

      /***/
      "./node_modules/lodash/filter.js":
      /*!***************************************!*\
        !*** ./node_modules/lodash/filter.js ***!
        \***************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashFilterJs(module, exports, __webpack_require__) {
        var arrayFilter = __webpack_require__(
        /*! ./_arrayFilter */
        "./node_modules/lodash/_arrayFilter.js"),
            baseFilter = __webpack_require__(
        /*! ./_baseFilter */
        "./node_modules/lodash/_baseFilter.js"),
            baseIteratee = __webpack_require__(
        /*! ./_baseIteratee */
        "./node_modules/lodash/_baseIteratee.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js");
        /**
         * Iterates over elements of `collection`, returning an array of all elements
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * **Note:** Unlike `_.remove`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.reject
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * _.filter(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, { 'age': 36, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.filter(users, 'active');
         * // => objects for ['barney']
         */


        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, baseIteratee(predicate, 3));
        }

        module.exports = filter;
        /***/
      },

      /***/
      "./node_modules/lodash/forEach.js":
      /*!****************************************!*\
        !*** ./node_modules/lodash/forEach.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashForEachJs(module, exports, __webpack_require__) {
        var arrayEach = __webpack_require__(
        /*! ./_arrayEach */
        "./node_modules/lodash/_arrayEach.js"),
            baseEach = __webpack_require__(
        /*! ./_baseEach */
        "./node_modules/lodash/_baseEach.js"),
            castFunction = __webpack_require__(
        /*! ./_castFunction */
        "./node_modules/lodash/_castFunction.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js");
        /**
         * Iterates over elements of `collection` and invokes `iteratee` for each element.
         * The iteratee is invoked with three arguments: (value, index|key, collection).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * **Note:** As with other "Collections" methods, objects with a "length"
         * property are iterated like arrays. To avoid this behavior use `_.forIn`
         * or `_.forOwn` for object iteration.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias each
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEachRight
         * @example
         *
         * _.forEach([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `1` then `2`.
         *
         * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */


        function forEach(collection, iteratee) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, castFunction(iteratee));
        }

        module.exports = forEach;
        /***/
      },

      /***/
      "./node_modules/lodash/get.js":
      /*!************************************!*\
        !*** ./node_modules/lodash/get.js ***!
        \************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashGetJs(module, exports, __webpack_require__) {
        var baseGet = __webpack_require__(
        /*! ./_baseGet */
        "./node_modules/lodash/_baseGet.js");
        /**
         * Gets the value at `path` of `object`. If the resolved value is
         * `undefined`, the `defaultValue` is returned in its place.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.get(object, 'a[0].b.c');
         * // => 3
         *
         * _.get(object, ['a', '0', 'b', 'c']);
         * // => 3
         *
         * _.get(object, 'a.b.c', 'default');
         * // => 'default'
         */


        function get(object, path, defaultValue) {
          var result = object == null ? undefined : baseGet(object, path);
          return result === undefined ? defaultValue : result;
        }

        module.exports = get;
        /***/
      },

      /***/
      "./node_modules/lodash/hasIn.js":
      /*!**************************************!*\
        !*** ./node_modules/lodash/hasIn.js ***!
        \**************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashHasInJs(module, exports, __webpack_require__) {
        var baseHasIn = __webpack_require__(
        /*! ./_baseHasIn */
        "./node_modules/lodash/_baseHasIn.js"),
            hasPath = __webpack_require__(
        /*! ./_hasPath */
        "./node_modules/lodash/_hasPath.js");
        /**
         * Checks if `path` is a direct or inherited property of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.hasIn(object, 'a');
         * // => true
         *
         * _.hasIn(object, 'a.b');
         * // => true
         *
         * _.hasIn(object, ['a', 'b']);
         * // => true
         *
         * _.hasIn(object, 'b');
         * // => false
         */


        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }

        module.exports = hasIn;
        /***/
      },

      /***/
      "./node_modules/lodash/identity.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/identity.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIdentityJs(module, exports) {
        /**
         * This method returns the first argument it receives.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {*} value Any value.
         * @returns {*} Returns `value`.
         * @example
         *
         * var object = { 'a': 1 };
         *
         * console.log(_.identity(object) === object);
         * // => true
         */
        function identity(value) {
          return value;
        }

        module.exports = identity;
        /***/
      },

      /***/
      "./node_modules/lodash/includes.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/includes.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIncludesJs(module, exports, __webpack_require__) {
        var baseIndexOf = __webpack_require__(
        /*! ./_baseIndexOf */
        "./node_modules/lodash/_baseIndexOf.js"),
            isArrayLike = __webpack_require__(
        /*! ./isArrayLike */
        "./node_modules/lodash/isArrayLike.js"),
            isString = __webpack_require__(
        /*! ./isString */
        "./node_modules/lodash/isString.js"),
            toInteger = __webpack_require__(
        /*! ./toInteger */
        "./node_modules/lodash/toInteger.js"),
            values = __webpack_require__(
        /*! ./values */
        "./node_modules/lodash/values.js");
        /* Built-in method references for those with the same name as other `lodash` methods. */


        var nativeMax = Math.max;
        /**
         * Checks if `value` is in `collection`. If `collection` is a string, it's
         * checked for a substring of `value`, otherwise
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * is used for equality comparisons. If `fromIndex` is negative, it's used as
         * the offset from the end of `collection`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object|string} collection The collection to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=0] The index to search from.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
         * @returns {boolean} Returns `true` if `value` is found, else `false`.
         * @example
         *
         * _.includes([1, 2, 3], 1);
         * // => true
         *
         * _.includes([1, 2, 3], 1, 2);
         * // => false
         *
         * _.includes({ 'a': 1, 'b': 2 }, 1);
         * // => true
         *
         * _.includes('abcd', 'bc');
         * // => true
         */

        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;

          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }

          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }

        module.exports = includes;
        /***/
      },

      /***/
      "./node_modules/lodash/isArguments.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/isArguments.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsArgumentsJs(module, exports, __webpack_require__) {
        var baseIsArguments = __webpack_require__(
        /*! ./_baseIsArguments */
        "./node_modules/lodash/_baseIsArguments.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "./node_modules/lodash/isObjectLike.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /** Built-in value references. */

        var propertyIsEnumerable = objectProto.propertyIsEnumerable;
        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */

        var isArguments = baseIsArguments(function () {
          return arguments;
        }()) ? baseIsArguments : function (value) {
          return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        module.exports = isArguments;
        /***/
      },

      /***/
      "./node_modules/lodash/isArray.js":
      /*!****************************************!*\
        !*** ./node_modules/lodash/isArray.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsArrayJs(module, exports) {
        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */
        var isArray = Array.isArray;
        module.exports = isArray;
        /***/
      },

      /***/
      "./node_modules/lodash/isArrayLike.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/isArrayLike.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsArrayLikeJs(module, exports, __webpack_require__) {
        var isFunction = __webpack_require__(
        /*! ./isFunction */
        "./node_modules/lodash/isFunction.js"),
            isLength = __webpack_require__(
        /*! ./isLength */
        "./node_modules/lodash/isLength.js");
        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */


        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }

        module.exports = isArrayLike;
        /***/
      },

      /***/
      "./node_modules/lodash/isBoolean.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/isBoolean.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsBooleanJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "./node_modules/lodash/_baseGetTag.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "./node_modules/lodash/isObjectLike.js");
        /** `Object#toString` result references. */


        var boolTag = '[object Boolean]';
        /**
         * Checks if `value` is classified as a boolean primitive or object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
         * @example
         *
         * _.isBoolean(false);
         * // => true
         *
         * _.isBoolean(null);
         * // => false
         */

        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }

        module.exports = isBoolean;
        /***/
      },

      /***/
      "./node_modules/lodash/isBuffer.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/isBuffer.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsBufferJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (module) {
          var root = __webpack_require__(
          /*! ./_root */
          "./node_modules/lodash/_root.js"),
              stubFalse = __webpack_require__(
          /*! ./stubFalse */
          "./node_modules/lodash/stubFalse.js");
          /** Detect free variable `exports`. */


          var freeExports = true && exports && !exports.nodeType && exports;
          /** Detect free variable `module`. */

          var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
          /** Detect the popular CommonJS extension `module.exports`. */

          var moduleExports = freeModule && freeModule.exports === freeExports;
          /** Built-in value references. */

          var Buffer = moduleExports ? root.Buffer : undefined;
          /* Built-in method references for those with the same name as other `lodash` methods. */

          var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
          /**
           * Checks if `value` is a buffer.
           *
           * @static
           * @memberOf _
           * @since 4.3.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
           * @example
           *
           * _.isBuffer(new Buffer(2));
           * // => true
           *
           * _.isBuffer(new Uint8Array(2));
           * // => false
           */

          var isBuffer = nativeIsBuffer || stubFalse;
          module.exports = isBuffer;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../webpack/buildin/module.js */
        "./node_modules/webpack/buildin/module.js")(module));
        /***/
      },

      /***/
      "./node_modules/lodash/isFunction.js":
      /*!*******************************************!*\
        !*** ./node_modules/lodash/isFunction.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsFunctionJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "./node_modules/lodash/_baseGetTag.js"),
            isObject = __webpack_require__(
        /*! ./isObject */
        "./node_modules/lodash/isObject.js");
        /** `Object#toString` result references. */


        var asyncTag = '[object AsyncFunction]',
            funcTag = '[object Function]',
            genTag = '[object GeneratorFunction]',
            proxyTag = '[object Proxy]';
        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */

        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          } // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 9 which returns 'object' for typed arrays and other constructors.


          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }

        module.exports = isFunction;
        /***/
      },

      /***/
      "./node_modules/lodash/isLength.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/isLength.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsLengthJs(module, exports) {
        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;
        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */

        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }

        module.exports = isLength;
        /***/
      },

      /***/
      "./node_modules/lodash/isObject.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/isObject.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsObjectJs(module, exports) {
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == 'object' || type == 'function');
        }

        module.exports = isObject;
        /***/
      },

      /***/
      "./node_modules/lodash/isObjectLike.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/isObjectLike.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsObjectLikeJs(module, exports) {
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
          return value != null && typeof value == 'object';
        }

        module.exports = isObjectLike;
        /***/
      },

      /***/
      "./node_modules/lodash/isString.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/isString.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsStringJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "./node_modules/lodash/_baseGetTag.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "./node_modules/lodash/isArray.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "./node_modules/lodash/isObjectLike.js");
        /** `Object#toString` result references. */


        var stringTag = '[object String]';
        /**
         * Checks if `value` is classified as a `String` primitive or object.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a string, else `false`.
         * @example
         *
         * _.isString('abc');
         * // => true
         *
         * _.isString(1);
         * // => false
         */

        function isString(value) {
          return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }

        module.exports = isString;
        /***/
      },

      /***/
      "./node_modules/lodash/isSymbol.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/isSymbol.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsSymbolJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "./node_modules/lodash/_baseGetTag.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "./node_modules/lodash/isObjectLike.js");
        /** `Object#toString` result references. */


        var symbolTag = '[object Symbol]';
        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */

        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }

        module.exports = isSymbol;
        /***/
      },

      /***/
      "./node_modules/lodash/isTypedArray.js":
      /*!*********************************************!*\
        !*** ./node_modules/lodash/isTypedArray.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsTypedArrayJs(module, exports, __webpack_require__) {
        var baseIsTypedArray = __webpack_require__(
        /*! ./_baseIsTypedArray */
        "./node_modules/lodash/_baseIsTypedArray.js"),
            baseUnary = __webpack_require__(
        /*! ./_baseUnary */
        "./node_modules/lodash/_baseUnary.js"),
            nodeUtil = __webpack_require__(
        /*! ./_nodeUtil */
        "./node_modules/lodash/_nodeUtil.js");
        /* Node.js helper references. */


        var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        /**
         * Checks if `value` is classified as a typed array.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         * @example
         *
         * _.isTypedArray(new Uint8Array);
         * // => true
         *
         * _.isTypedArray([]);
         * // => false
         */

        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        module.exports = isTypedArray;
        /***/
      },

      /***/
      "./node_modules/lodash/isUndefined.js":
      /*!********************************************!*\
        !*** ./node_modules/lodash/isUndefined.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsUndefinedJs(module, exports) {
        /**
         * Checks if `value` is `undefined`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
         * @example
         *
         * _.isUndefined(void 0);
         * // => true
         *
         * _.isUndefined(null);
         * // => false
         */
        function isUndefined(value) {
          return value === undefined;
        }

        module.exports = isUndefined;
        /***/
      },

      /***/
      "./node_modules/lodash/keys.js":
      /*!*************************************!*\
        !*** ./node_modules/lodash/keys.js ***!
        \*************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashKeysJs(module, exports, __webpack_require__) {
        var arrayLikeKeys = __webpack_require__(
        /*! ./_arrayLikeKeys */
        "./node_modules/lodash/_arrayLikeKeys.js"),
            baseKeys = __webpack_require__(
        /*! ./_baseKeys */
        "./node_modules/lodash/_baseKeys.js"),
            isArrayLike = __webpack_require__(
        /*! ./isArrayLike */
        "./node_modules/lodash/isArrayLike.js");
        /**
         * Creates an array of the own enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects. See the
         * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * for more details.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keys(new Foo);
         * // => ['a', 'b'] (iteration order is not guaranteed)
         *
         * _.keys('hi');
         * // => ['0', '1']
         */


        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }

        module.exports = keys;
        /***/
      },

      /***/
      "./node_modules/lodash/memoize.js":
      /*!****************************************!*\
        !*** ./node_modules/lodash/memoize.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashMemoizeJs(module, exports, __webpack_require__) {
        var MapCache = __webpack_require__(
        /*! ./_MapCache */
        "./node_modules/lodash/_MapCache.js");
        /** Error message constants. */


        var FUNC_ERROR_TEXT = 'Expected a function';
        /**
         * Creates a function that memoizes the result of `func`. If `resolver` is
         * provided, it determines the cache key for storing the result based on the
         * arguments provided to the memoized function. By default, the first argument
         * provided to the memoized function is used as the map cache key. The `func`
         * is invoked with the `this` binding of the memoized function.
         *
         * **Note:** The cache is exposed as the `cache` property on the memoized
         * function. Its creation may be customized by replacing the `_.memoize.Cache`
         * constructor with one whose instances implement the
         * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
         * method interface of `clear`, `delete`, `get`, `has`, and `set`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to have its output memoized.
         * @param {Function} [resolver] The function to resolve the cache key.
         * @returns {Function} Returns the new memoized function.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         * var other = { 'c': 3, 'd': 4 };
         *
         * var values = _.memoize(_.values);
         * values(object);
         * // => [1, 2]
         *
         * values(other);
         * // => [3, 4]
         *
         * object.a = 2;
         * values(object);
         * // => [1, 2]
         *
         * // Modify the result cache.
         * values.cache.set(object, ['a', 'b']);
         * values(object);
         * // => ['a', 'b']
         *
         * // Replace `_.memoize.Cache`.
         * _.memoize.Cache = WeakMap;
         */

        function memoize(func, resolver) {
          if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          var memoized = function memoized() {
            var args = arguments,
                key = resolver ? resolver.apply(this, args) : args[0],
                cache = memoized.cache;

            if (cache.has(key)) {
              return cache.get(key);
            }

            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result) || cache;
            return result;
          };

          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        } // Expose `MapCache`.


        memoize.Cache = MapCache;
        module.exports = memoize;
        /***/
      },

      /***/
      "./node_modules/lodash/property.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/property.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashPropertyJs(module, exports, __webpack_require__) {
        var baseProperty = __webpack_require__(
        /*! ./_baseProperty */
        "./node_modules/lodash/_baseProperty.js"),
            basePropertyDeep = __webpack_require__(
        /*! ./_basePropertyDeep */
        "./node_modules/lodash/_basePropertyDeep.js"),
            isKey = __webpack_require__(
        /*! ./_isKey */
        "./node_modules/lodash/_isKey.js"),
            toKey = __webpack_require__(
        /*! ./_toKey */
        "./node_modules/lodash/_toKey.js");
        /**
         * Creates a function that returns the value at `path` of a given object.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': 2 } },
         *   { 'a': { 'b': 1 } }
         * ];
         *
         * _.map(objects, _.property('a.b'));
         * // => [2, 1]
         *
         * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
         * // => [1, 2]
         */


        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }

        module.exports = property;
        /***/
      },

      /***/
      "./node_modules/lodash/stubArray.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/stubArray.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashStubArrayJs(module, exports) {
        /**
         * This method returns a new empty array.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Array} Returns the new empty array.
         * @example
         *
         * var arrays = _.times(2, _.stubArray);
         *
         * console.log(arrays);
         * // => [[], []]
         *
         * console.log(arrays[0] === arrays[1]);
         * // => false
         */
        function stubArray() {
          return [];
        }

        module.exports = stubArray;
        /***/
      },

      /***/
      "./node_modules/lodash/stubFalse.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/stubFalse.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashStubFalseJs(module, exports) {
        /**
         * This method returns `false`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `false`.
         * @example
         *
         * _.times(2, _.stubFalse);
         * // => [false, false]
         */
        function stubFalse() {
          return false;
        }

        module.exports = stubFalse;
        /***/
      },

      /***/
      "./node_modules/lodash/toFinite.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/toFinite.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashToFiniteJs(module, exports, __webpack_require__) {
        var toNumber = __webpack_require__(
        /*! ./toNumber */
        "./node_modules/lodash/toNumber.js");
        /** Used as references for various `Number` constants. */


        var INFINITY = 1 / 0,
            MAX_INTEGER = 1.7976931348623157e+308;
        /**
         * Converts `value` to a finite number.
         *
         * @static
         * @memberOf _
         * @since 4.12.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted number.
         * @example
         *
         * _.toFinite(3.2);
         * // => 3.2
         *
         * _.toFinite(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toFinite(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toFinite('3.2');
         * // => 3.2
         */

        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }

          value = toNumber(value);

          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }

          return value === value ? value : 0;
        }

        module.exports = toFinite;
        /***/
      },

      /***/
      "./node_modules/lodash/toInteger.js":
      /*!******************************************!*\
        !*** ./node_modules/lodash/toInteger.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashToIntegerJs(module, exports, __webpack_require__) {
        var toFinite = __webpack_require__(
        /*! ./toFinite */
        "./node_modules/lodash/toFinite.js");
        /**
         * Converts `value` to an integer.
         *
         * **Note:** This method is loosely based on
         * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toInteger(3.2);
         * // => 3
         *
         * _.toInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toInteger(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toInteger('3.2');
         * // => 3
         */


        function toInteger(value) {
          var result = toFinite(value),
              remainder = result % 1;
          return result === result ? remainder ? result - remainder : result : 0;
        }

        module.exports = toInteger;
        /***/
      },

      /***/
      "./node_modules/lodash/toNumber.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/toNumber.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashToNumberJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./isObject */
        "./node_modules/lodash/isObject.js"),
            isSymbol = __webpack_require__(
        /*! ./isSymbol */
        "./node_modules/lodash/isSymbol.js");
        /** Used as references for various `Number` constants. */


        var NAN = 0 / 0;
        /** Used to match leading and trailing whitespace. */

        var reTrim = /^\s+|\s+$/g;
        /** Used to detect bad signed hexadecimal string values. */

        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        /** Used to detect binary string values. */

        var reIsBinary = /^0b[01]+$/i;
        /** Used to detect octal string values. */

        var reIsOctal = /^0o[0-7]+$/i;
        /** Built-in method references without a dependency on `root`. */

        var freeParseInt = parseInt;
        /**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */

        function toNumber(value) {
          if (typeof value == 'number') {
            return value;
          }

          if (isSymbol(value)) {
            return NAN;
          }

          if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
          }

          if (typeof value != 'string') {
            return value === 0 ? value : +value;
          }

          value = value.replace(reTrim, '');
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }

        module.exports = toNumber;
        /***/
      },

      /***/
      "./node_modules/lodash/toString.js":
      /*!*****************************************!*\
        !*** ./node_modules/lodash/toString.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashToStringJs(module, exports, __webpack_require__) {
        var baseToString = __webpack_require__(
        /*! ./_baseToString */
        "./node_modules/lodash/_baseToString.js");
        /**
         * Converts `value` to a string. An empty string is returned for `null`
         * and `undefined` values. The sign of `-0` is preserved.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.toString(null);
         * // => ''
         *
         * _.toString(-0);
         * // => '-0'
         *
         * _.toString([1, 2, 3]);
         * // => '1,2,3'
         */


        function toString(value) {
          return value == null ? '' : baseToString(value);
        }

        module.exports = toString;
        /***/
      },

      /***/
      "./node_modules/lodash/trim.js":
      /*!*************************************!*\
        !*** ./node_modules/lodash/trim.js ***!
        \*************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashTrimJs(module, exports, __webpack_require__) {
        var baseToString = __webpack_require__(
        /*! ./_baseToString */
        "./node_modules/lodash/_baseToString.js"),
            castSlice = __webpack_require__(
        /*! ./_castSlice */
        "./node_modules/lodash/_castSlice.js"),
            charsEndIndex = __webpack_require__(
        /*! ./_charsEndIndex */
        "./node_modules/lodash/_charsEndIndex.js"),
            charsStartIndex = __webpack_require__(
        /*! ./_charsStartIndex */
        "./node_modules/lodash/_charsStartIndex.js"),
            stringToArray = __webpack_require__(
        /*! ./_stringToArray */
        "./node_modules/lodash/_stringToArray.js"),
            toString = __webpack_require__(
        /*! ./toString */
        "./node_modules/lodash/toString.js");
        /** Used to match leading and trailing whitespace. */


        var reTrim = /^\s+|\s+$/g;
        /**
         * Removes leading and trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trim('  abc  ');
         * // => 'abc'
         *
         * _.trim('-_-abc-_-', '_-');
         * // => 'abc'
         *
         * _.map(['  foo  ', '  bar  '], _.trim);
         * // => ['foo', 'bar']
         */

        function trim(string, chars, guard) {
          string = toString(string);

          if (string && (guard || chars === undefined)) {
            return string.replace(reTrim, '');
          }

          if (!string || !(chars = baseToString(chars))) {
            return string;
          }

          var strSymbols = stringToArray(string),
              chrSymbols = stringToArray(chars),
              start = charsStartIndex(strSymbols, chrSymbols),
              end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join('');
        }

        module.exports = trim;
        /***/
      },

      /***/
      "./node_modules/lodash/values.js":
      /*!***************************************!*\
        !*** ./node_modules/lodash/values.js ***!
        \***************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashValuesJs(module, exports, __webpack_require__) {
        var baseValues = __webpack_require__(
        /*! ./_baseValues */
        "./node_modules/lodash/_baseValues.js"),
            keys = __webpack_require__(
        /*! ./keys */
        "./node_modules/lodash/keys.js");
        /**
         * Creates an array of the own enumerable string keyed property values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.values(new Foo);
         * // => [1, 2] (iteration order is not guaranteed)
         *
         * _.values('hi');
         * // => ['h', 'i']
         */


        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }

        module.exports = values;
        /***/
      },

      /***/
      "./node_modules/mobx-react/index.module.js":
      /*!*************************************************!*\
        !*** ./node_modules/mobx-react/index.module.js ***!
        \*************************************************/

      /*! exports provided: propTypes, PropTypes, onError, observer, Observer, renderReporter, componentByNodeRegistery, componentByNodeRegistry, trackComponents, useStaticRendering, Provider, inject, disposeOnUnmount */

      /***/
      function node_modulesMobxReactIndexModuleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "propTypes", function () {
          return propTypes;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PropTypes", function () {
          return propTypes;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "onError", function () {
          return onError;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "observer", function () {
          return observer;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Observer", function () {
          return Observer;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "renderReporter", function () {
          return renderReporter;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "componentByNodeRegistery", function () {
          return componentByNodeRegistry;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "componentByNodeRegistry", function () {
          return componentByNodeRegistry;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "trackComponents", function () {
          return trackComponents;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "useStaticRendering", function () {
          return useStaticRendering;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Provider", function () {
          return Provider;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "inject", function () {
          return inject;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "disposeOnUnmount", function () {
          return disposeOnUnmount;
        });
        /* harmony import */


        var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! mobx */
        "./node_modules/mobx/lib/mobx.module.js");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-dom */
        "react-dom");
        /* harmony import */


        var react_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_2__);
        /** @license mobx-react v5.4.4
         * index.module.js
         *
         * Copyright (c) 2015 Michel Weststrate.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */


        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }

          return _typeof(obj);
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }

        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }

        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };

          return _setPrototypeOf(o, p);
        }

        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return self;
        }

        function _possibleConstructorReturn(self, call) {
          if (call && (typeof call === "object" || typeof call === "function")) {
            return call;
          }

          return _assertThisInitialized(self);
        } // These functions can be stubbed out in specific environments


        function unwrapExports(x) {
          return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
        }

        function createCommonjsModule(fn, module) {
          return module = {
            exports: {}
          }, fn(module, module.exports), module.exports;
        }

        var reactIs_production_min = createCommonjsModule(function (module, exports) {
          Object.defineProperty(exports, "__esModule", {
            value: !0
          });
          var b = "function" === typeof Symbol && Symbol.for,
              c = b ? Symbol.for("react.element") : 60103,
              d = b ? Symbol.for("react.portal") : 60106,
              e = b ? Symbol.for("react.fragment") : 60107,
              f = b ? Symbol.for("react.strict_mode") : 60108,
              g = b ? Symbol.for("react.profiler") : 60114,
              h = b ? Symbol.for("react.provider") : 60109,
              k = b ? Symbol.for("react.context") : 60110,
              l = b ? Symbol.for("react.async_mode") : 60111,
              m = b ? Symbol.for("react.concurrent_mode") : 60111,
              n = b ? Symbol.for("react.forward_ref") : 60112,
              p = b ? Symbol.for("react.suspense") : 60113,
              r = b ? Symbol.for("react.memo") : 60115,
              t = b ? Symbol.for("react.lazy") : 60116;

          function u(a) {
            if ("object" === typeof a && null !== a) {
              var q = a.$$typeof;

              switch (q) {
                case c:
                  switch (a = a.type, a) {
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                      return a;

                    default:
                      switch (a = a && a.$$typeof, a) {
                        case k:
                        case n:
                        case h:
                          return a;

                        default:
                          return q;
                      }

                  }

                case d:
                  return q;
              }
            }
          }

          function v(a) {
            return u(a) === m;
          }

          exports.typeOf = u;
          exports.AsyncMode = l;
          exports.ConcurrentMode = m;
          exports.ContextConsumer = k;
          exports.ContextProvider = h;
          exports.Element = c;
          exports.ForwardRef = n;
          exports.Fragment = e;
          exports.Profiler = g;
          exports.Portal = d;
          exports.StrictMode = f;

          exports.isValidElementType = function (a) {
            return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
          };

          exports.isAsyncMode = function (a) {
            return v(a) || u(a) === l;
          };

          exports.isConcurrentMode = v;

          exports.isContextConsumer = function (a) {
            return u(a) === k;
          };

          exports.isContextProvider = function (a) {
            return u(a) === h;
          };

          exports.isElement = function (a) {
            return "object" === typeof a && null !== a && a.$$typeof === c;
          };

          exports.isForwardRef = function (a) {
            return u(a) === n;
          };

          exports.isFragment = function (a) {
            return u(a) === e;
          };

          exports.isProfiler = function (a) {
            return u(a) === g;
          };

          exports.isPortal = function (a) {
            return u(a) === d;
          };

          exports.isStrictMode = function (a) {
            return u(a) === f;
          };
        });
        unwrapExports(reactIs_production_min);
        var reactIs_production_min_1 = reactIs_production_min.typeOf;
        var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
        var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
        var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
        var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
        var reactIs_production_min_6 = reactIs_production_min.Element;
        var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
        var reactIs_production_min_8 = reactIs_production_min.Fragment;
        var reactIs_production_min_9 = reactIs_production_min.Profiler;
        var reactIs_production_min_10 = reactIs_production_min.Portal;
        var reactIs_production_min_11 = reactIs_production_min.StrictMode;
        var reactIs_production_min_12 = reactIs_production_min.isValidElementType;
        var reactIs_production_min_13 = reactIs_production_min.isAsyncMode;
        var reactIs_production_min_14 = reactIs_production_min.isConcurrentMode;
        var reactIs_production_min_15 = reactIs_production_min.isContextConsumer;
        var reactIs_production_min_16 = reactIs_production_min.isContextProvider;
        var reactIs_production_min_17 = reactIs_production_min.isElement;
        var reactIs_production_min_18 = reactIs_production_min.isForwardRef;
        var reactIs_production_min_19 = reactIs_production_min.isFragment;
        var reactIs_production_min_20 = reactIs_production_min.isProfiler;
        var reactIs_production_min_21 = reactIs_production_min.isPortal;
        var reactIs_production_min_22 = reactIs_production_min.isStrictMode;
        var reactIs = createCommonjsModule(function (module) {
          {
            module.exports = reactIs_production_min;
          }
        });
        /**
         * Copyright 2015, Yahoo! Inc.
         * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
         */

        var REACT_STATICS = {
          childContextTypes: true,
          contextType: true,
          contextTypes: true,
          defaultProps: true,
          displayName: true,
          getDefaultProps: true,
          getDerivedStateFromError: true,
          getDerivedStateFromProps: true,
          mixins: true,
          propTypes: true,
          type: true
        };
        var KNOWN_STATICS = {
          name: true,
          length: true,
          prototype: true,
          caller: true,
          callee: true,
          arguments: true,
          arity: true
        };
        var FORWARD_REF_STATICS = {
          '$$typeof': true,
          render: true,
          defaultProps: true,
          displayName: true,
          propTypes: true
        };
        var TYPE_STATICS = {};
        TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
        var defineProperty = Object.defineProperty;
        var getOwnPropertyNames = Object.getOwnPropertyNames;
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var getPrototypeOf = Object.getPrototypeOf;
        var objectPrototype = Object.prototype;

        function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
          if (typeof sourceComponent !== 'string') {
            // don't hoist over string (html) components
            if (objectPrototype) {
              var inheritedComponent = getPrototypeOf(sourceComponent);

              if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
              }
            }

            var keys = getOwnPropertyNames(sourceComponent);

            if (getOwnPropertySymbols) {
              keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }

            var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
            var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

            for (var i = 0; i < keys.length; ++i) {
              var key = keys[i];

              if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

                try {
                  // Avoid failures from read-only properties
                  defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
              }
            }

            return targetComponent;
          }

          return targetComponent;
        }

        var hoistNonReactStatics_cjs = hoistNonReactStatics;

        var EventEmitter = /*#__PURE__*/function () {
          function EventEmitter() {
            _classCallCheck(this, EventEmitter);

            this.listeners = [];
          }

          _createClass(EventEmitter, [{
            key: "on",
            value: function on(cb) {
              var _this = this;

              this.listeners.push(cb);
              return function () {
                var index = _this.listeners.indexOf(cb);

                if (index !== -1) _this.listeners.splice(index, 1);
              };
            }
          }, {
            key: "emit",
            value: function emit(data) {
              this.listeners.forEach(function (fn) {
                return fn(data);
              });
            }
          }]);

          return EventEmitter;
        }();

        function createChainableTypeChecker(validate) {
          function checkType(isRequired, props, propName, componentName, location, propFullName) {
            for (var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
              rest[_key - 6] = arguments[_key];
            }

            return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["untracked"])(function () {
              componentName = componentName || "<<anonymous>>";
              propFullName = propFullName || propName;

              if (props[propName] == null) {
                if (isRequired) {
                  var actual = props[propName] === null ? "null" : "undefined";
                  return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }

                return null;
              } else {
                return validate.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
              }
            });
          }

          var chainedCheckType = checkType.bind(null, false);
          chainedCheckType.isRequired = checkType.bind(null, true);
          return chainedCheckType;
        } // Copied from React.PropTypes


        function isSymbol(propType, propValue) {
          // Native Symbol.
          if (propType === "symbol") {
            return true;
          } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


          if (propValue["@@toStringTag"] === "Symbol") {
            return true;
          } // Fallback for non-spec compliant Symbols which are polyfilled.


          if (typeof Symbol === "function" && propValue instanceof Symbol) {
            return true;
          }

          return false;
        } // Copied from React.PropTypes


        function getPropType(propValue) {
          var propType = _typeof(propValue);

          if (Array.isArray(propValue)) {
            return "array";
          }

          if (propValue instanceof RegExp) {
            // Old webkits (at least until Android 4.0) return 'function' rather than
            // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
            // passes PropTypes.object.
            return "object";
          }

          if (isSymbol(propType, propValue)) {
            return "symbol";
          }

          return propType;
        } // This handles more types than `getPropType`. Only used for error messages.
        // Copied from React.PropTypes


        function getPreciseType(propValue) {
          var propType = getPropType(propValue);

          if (propType === "object") {
            if (propValue instanceof Date) {
              return "date";
            } else if (propValue instanceof RegExp) {
              return "regexp";
            }
          }

          return propType;
        }

        function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
          return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
            return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["untracked"])(function () {
              if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
              }

              var mobxChecker;

              switch (mobxType) {
                case "Array":
                  mobxChecker = mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableArray"];
                  break;

                case "Object":
                  mobxChecker = mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableObject"];
                  break;

                case "Map":
                  mobxChecker = mobx__WEBPACK_IMPORTED_MODULE_0__["isObservableMap"];
                  break;

                default:
                  throw new Error("Unexpected mobxType: ".concat(mobxType));
              }

              var propValue = props[propName];

              if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
              }

              return null;
            });
          });
        }

        function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
          return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
            for (var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
              rest[_key2 - 5] = arguments[_key2];
            }

            return Object(mobx__WEBPACK_IMPORTED_MODULE_0__["untracked"])(function () {
              if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
              }

              var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
              if (error instanceof Error) return error;
              var propValue = props[propName];

              for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(void 0, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
              }

              return null;
            });
          });
        }

        var observableArray = createObservableTypeCheckerCreator(false, "Array");
        var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
        var observableMap = createObservableTypeCheckerCreator(false, "Map");
        var observableObject = createObservableTypeCheckerCreator(false, "Object");
        var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
        var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
        var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
        var propTypes = /*#__PURE__*/Object.freeze({
          observableArray: observableArray,
          observableArrayOf: observableArrayOf,
          observableMap: observableMap,
          observableObject: observableObject,
          arrayOrObservableArray: arrayOrObservableArray,
          arrayOrObservableArrayOf: arrayOrObservableArrayOf,
          objectOrObservableObject: objectOrObservableObject
        });

        function isStateless(component) {
          // `function() {}` has prototype, but `() => {}` doesn't
          // `() => {}` via Babel has prototype too.
          return !(component.prototype && component.prototype.render);
        }

        var symbolId = 0;

        function createSymbol(name) {
          if (typeof Symbol === "function") {
            return Symbol(name);
          }

          var symbol = "__$mobx-react ".concat(name, " (").concat(symbolId, ")");
          symbolId++;
          return symbol;
        }

        var createdSymbols = {};

        function newSymbol(name) {
          if (!createdSymbols[name]) {
            createdSymbols[name] = createSymbol(name);
          }

          return createdSymbols[name];
        }

        var mobxMixins = newSymbol("patchMixins");
        var mobxPatchedDefinition = newSymbol("patchedDefinition");

        function getMixins(target, methodName) {
          var mixins = target[mobxMixins] = target[mobxMixins] || {};
          var methodMixins = mixins[methodName] = mixins[methodName] || {};
          methodMixins.locks = methodMixins.locks || 0;
          methodMixins.methods = methodMixins.methods || [];
          return methodMixins;
        }

        function wrapper(realMethod, mixins) {
          var _this = this;

          for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          } // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls


          mixins.locks++;

          try {
            var retVal;

            if (realMethod !== undefined && realMethod !== null) {
              retVal = realMethod.apply(this, args);
            }

            return retVal;
          } finally {
            mixins.locks--;

            if (mixins.locks === 0) {
              mixins.methods.forEach(function (mx) {
                mx.apply(_this, args);
              });
            }
          }
        }

        function wrapFunction(realMethod, mixins) {
          var fn = function fn() {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            wrapper.call.apply(wrapper, [this, realMethod, mixins].concat(args));
          };

          return fn;
        }

        function patch(target, methodName) {
          var mixins = getMixins(target, methodName);

          for (var _len3 = arguments.length, mixinMethods = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            mixinMethods[_key3 - 2] = arguments[_key3];
          }

          for (var _i = 0; _i < mixinMethods.length; _i++) {
            var mixinMethod = mixinMethods[_i];

            if (mixins.methods.indexOf(mixinMethod) < 0) {
              mixins.methods.push(mixinMethod);
            }
          }

          var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);

          if (oldDefinition && oldDefinition[mobxPatchedDefinition]) {
            // already patched definition, do not repatch
            return;
          }

          var originalMethod = target[methodName];
          var newDefinition = createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
          Object.defineProperty(target, methodName, newDefinition);
        }

        function createDefinition(target, methodName, enumerable, mixins, originalMethod) {
          var _ref;

          var wrappedFunc = wrapFunction(originalMethod, mixins);
          return _ref = {}, _defineProperty(_ref, mobxPatchedDefinition, true), _defineProperty(_ref, "get", function get() {
            return wrappedFunc;
          }), _defineProperty(_ref, "set", function set(value) {
            if (this === target) {
              wrappedFunc = wrapFunction(value, mixins);
            } else {
              // when it is an instance of the prototype/a child prototype patch that particular case again separately
              // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
              // e.g. the method for super might not be the same as the method for the prototype which might be not the same
              // as the method for the instance
              var newDefinition = createDefinition(this, methodName, enumerable, mixins, value);
              Object.defineProperty(this, methodName, newDefinition);
            }
          }), _defineProperty(_ref, "configurable", true), _defineProperty(_ref, "enumerable", enumerable), _ref;
        }

        var injectorContextTypes = {
          mobxStores: objectOrObservableObject
        };
        Object.seal(injectorContextTypes);
        var proxiedInjectorProps = {
          contextTypes: {
            get: function get() {
              return injectorContextTypes;
            },
            set: function set(_) {
              console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
            },
            configurable: true,
            enumerable: false
          },
          isMobxInjector: {
            value: true,
            writable: true,
            configurable: true,
            enumerable: true
          }
          /**
           * Store Injection
           */

        };

        function createStoreInjector(grabStoresFn, component, injectNames) {
          var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
          if (injectNames) displayName += "-with-" + injectNames;

          var Injector = /*#__PURE__*/function (_Component) {
            _inherits(Injector, _Component);

            function Injector() {
              var _getPrototypeOf2;

              var _this;

              _classCallCheck(this, Injector);

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Injector)).call.apply(_getPrototypeOf2, [this].concat(args)));

              _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
              };

              return _this;
            }

            _createClass(Injector, [{
              key: "render",
              value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};

                for (var key in this.props) {
                  if (this.props.hasOwnProperty(key)) {
                    newProps[key] = this.props[key];
                  }
                }

                var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};

                for (var _key2 in additionalProps) {
                  newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                  newProps.ref = this.storeRef;
                }

                return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(component, newProps);
              }
            }]);

            return Injector;
          }(react__WEBPACK_IMPORTED_MODULE_1__["Component"]); // Static fields from component should be visible on the generated Injector


          Injector.displayName = displayName;
          hoistNonReactStatics_cjs(Injector, component);
          Injector.wrappedComponent = component;
          Object.defineProperties(Injector, proxiedInjectorProps);
          return Injector;
        }

        function grabStoresByName(storeNames) {
          return function (baseStores, nextProps) {
            storeNames.forEach(function (storeName) {
              if (storeName in nextProps // prefer props over stores
              ) return;
              if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
              nextProps[storeName] = baseStores[storeName];
            });
            return nextProps;
          };
        }
        /**
         * higher order component that injects stores to a child.
         * takes either a varargs list of strings, which are stores read from the context,
         * or a function that manually maps the available stores from the context to props:
         * storesToProps(mobxStores, props, context) => newProps
         */


        function inject()
        /* fn(stores, nextProps) or ...storeNames */
        {
          var grabStoresFn;

          if (typeof arguments[0] === "function") {
            grabStoresFn = arguments[0];
            return function (componentClass) {
              var injected = createStoreInjector(grabStoresFn, componentClass);
              injected.isMobxInjector = false; // supress warning
              // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
              // see #111

              injected = observer(injected);
              injected.isMobxInjector = true; // restore warning

              return injected;
            };
          } else {
            var storeNames = [];

            for (var i = 0; i < arguments.length; i++) {
              storeNames[i] = arguments[i];
            }

            grabStoresFn = grabStoresByName(storeNames);
            return function (componentClass) {
              return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
            };
          }
        }

        var mobxAdminProperty = mobx__WEBPACK_IMPORTED_MODULE_0__["$mobx"] || "$mobx";
        var mobxIsUnmounted = newSymbol("isUnmounted");
        /**
         * dev tool support
         */

        var isDevtoolsEnabled = false;
        var isUsingStaticRendering = false;
        var warnedAboutObserverInjectDeprecation = false; // WeakMap<Node, Object>;

        var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
        var renderReporter = new EventEmitter();
        var skipRenderKey = newSymbol("skipRender");
        var isForcingUpdateKey = newSymbol("isForcingUpdate"); // Using react-is had some issues (and operates on elements, not on types), see #608 / #609

        var ReactForwardRefSymbol = typeof react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"] === "function" && Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function (_props, _ref) {})["$$typeof"];
        /**
         * Helper to set `prop` to `this` as non-enumerable (hidden prop)
         * @param target
         * @param prop
         * @param value
         */

        function setHiddenProp(target, prop, value) {
          if (!Object.hasOwnProperty.call(target, prop)) {
            Object.defineProperty(target, prop, {
              enumerable: false,
              configurable: true,
              writable: true,
              value: value
            });
          } else {
            target[prop] = value;
          }
        }

        function findDOMNode$2(component) {
          if (react_dom__WEBPACK_IMPORTED_MODULE_2__["findDOMNode"]) {
            try {
              return Object(react_dom__WEBPACK_IMPORTED_MODULE_2__["findDOMNode"])(component);
            } catch (e) {
              // findDOMNode will throw in react-test-renderer, see:
              // See https://github.com/mobxjs/mobx-react/issues/216
              // Is there a better heuristic?
              return null;
            }
          }

          return null;
        }

        function reportRendering(component) {
          var node = findDOMNode$2(component);
          if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
          renderReporter.emit({
            event: "render",
            renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
            totalTime: Date.now() - component.__$mobRenderStart,
            component: component,
            node: node
          });
        }

        function trackComponents() {
          if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
          if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
        }

        function useStaticRendering(useStaticRendering) {
          isUsingStaticRendering = useStaticRendering;
        }
        /**
         * Errors reporter
         */


        var errorsReporter = new EventEmitter();
        /**
         * Utilities
         */

        function patch$1(target, funcName) {
          patch(target, funcName, reactiveMixin[funcName]);
        }

        function shallowEqual(objA, objB) {
          //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
          if (is(objA, objB)) return true;

          if (_typeof(objA) !== "object" || objA === null || _typeof(objB) !== "object" || objB === null) {
            return false;
          }

          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) return false;

          for (var i = 0; i < keysA.length; i++) {
            if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
              return false;
            }
          }

          return true;
        }

        function is(x, y) {
          // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
          if (x === y) {
            return x !== 0 || 1 / x === 1 / y;
          } else {
            return x !== x && y !== y;
          }
        }

        function makeComponentReactive(render) {
          var _this2 = this;

          if (isUsingStaticRendering === true) return render.call(this);

          function reactiveRender() {
            var _this = this;

            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
              if (isDevtoolsEnabled) {
                _this.__$mobRenderStart = Date.now();
              }

              try {
                rendering = Object(mobx__WEBPACK_IMPORTED_MODULE_0__["_allowStateChanges"])(false, baseRender);
              } catch (e) {
                exception = e;
              }

              if (isDevtoolsEnabled) {
                _this.__$mobRenderEnd = Date.now();
              }
            });

            if (exception) {
              errorsReporter.emit(exception);
              throw exception;
            }

            return rendering;
          } // Generate friendly name for debugging


          var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
          var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
          /**
           * If props are shallowly modified, react will render anyway,
           * so atom.reportChanged() should not result in yet another re-render
           */

          setHiddenProp(this, skipRenderKey, false);
          /**
           * forceUpdate will re-assign this.props. We don't want that to cause a loop,
           * so detect these changes
           */

          setHiddenProp(this, isForcingUpdateKey, false); // wire up reactive render

          var baseRender = render.bind(this);
          var isRenderingPending = false;
          var reaction = new mobx__WEBPACK_IMPORTED_MODULE_0__["Reaction"]("".concat(initialName, "#").concat(rootNodeID, ".render()"), function () {
            if (!isRenderingPending) {
              // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
              // This unidiomatic React usage but React will correctly warn about this so we continue as usual
              // See #85 / Pull #44
              isRenderingPending = true;
              if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?

              if (_this2[mobxIsUnmounted] !== true) {
                // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                // However, people also claim this might happen during unit tests..
                var hasError = true;

                try {
                  setHiddenProp(_this2, isForcingUpdateKey, true);
                  if (!_this2[skipRenderKey]) react__WEBPACK_IMPORTED_MODULE_1__["Component"].prototype.forceUpdate.call(_this2);
                  hasError = false;
                } finally {
                  setHiddenProp(_this2, isForcingUpdateKey, false);
                  if (hasError) reaction.dispose();
                }
              }
            }
          });
          reaction.reactComponent = this;
          reactiveRender[mobxAdminProperty] = reaction;
          this.render = reactiveRender;
          return reactiveRender.call(this);
        }
        /**
         * ReactiveMixin
         */


        var reactiveMixin = {
          componentWillUnmount: function componentWillUnmount() {
            if (isUsingStaticRendering === true) return;
            this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
            this[mobxIsUnmounted] = true;

            if (isDevtoolsEnabled) {
              var node = findDOMNode$2(this);

              if (node && componentByNodeRegistry) {
                componentByNodeRegistry.delete(node);
              }

              renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
              });
            }
          },
          componentDidMount: function componentDidMount() {
            if (isDevtoolsEnabled) {
              reportRendering(this);
            }
          },
          componentDidUpdate: function componentDidUpdate() {
            if (isDevtoolsEnabled) {
              reportRendering(this);
            }
          },
          shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
            if (isUsingStaticRendering) {
              console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
            } // update on any state changes (as is the default)


            if (this.state !== nextState) {
              return true;
            } // update if props are shallowly not equal, inspired by PureRenderMixin
            // we could return just 'false' here, and avoid the `skipRender` checks etc
            // however, it is nicer if lifecycle events are triggered like usually,
            // so we return true here if props are shallowly modified.


            return !shallowEqual(this.props, nextProps);
          }
        };

        function makeObservableProp(target, propName) {
          var valueHolderKey = newSymbol("reactProp_".concat(propName, "_valueHolder"));
          var atomHolderKey = newSymbol("reactProp_".concat(propName, "_atomHolder"));

          function getAtom() {
            if (!this[atomHolderKey]) {
              setHiddenProp(this, atomHolderKey, Object(mobx__WEBPACK_IMPORTED_MODULE_0__["createAtom"])("reactive " + propName));
            }

            return this[atomHolderKey];
          }

          Object.defineProperty(target, propName, {
            configurable: true,
            enumerable: true,
            get: function get() {
              getAtom.call(this).reportObserved();
              return this[valueHolderKey];
            },
            set: function set(v) {
              if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
                setHiddenProp(this, valueHolderKey, v);
                setHiddenProp(this, skipRenderKey, true);
                getAtom.call(this).reportChanged();
                setHiddenProp(this, skipRenderKey, false);
              } else {
                setHiddenProp(this, valueHolderKey, v);
              }
            }
          });
        }
        /**
         * Observer function / decorator
         */


        function observer(arg1, arg2) {
          if (typeof arg1 === "string") {
            throw new Error("Store names should be provided as array");
          }

          if (Array.isArray(arg1)) {
            // TODO: remove in next major
            // component needs stores
            if (!warnedAboutObserverInjectDeprecation) {
              warnedAboutObserverInjectDeprecation = true;
              console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
            }

            if (!arg2) {
              // invoked as decorator
              return function (componentClass) {
                return observer(arg1, componentClass);
              };
            } else {
              return inject.apply(null, arg1)(observer(arg2));
            }
          }

          var componentClass = arg1;

          if (componentClass.isMobxInjector === true) {
            console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
          }

          if (componentClass.__proto__ === react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]) {
            console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
          } // Unwrap forward refs into `<Observer>` component
          // we need to unwrap the render, because it is the inner render that needs to be tracked,
          // not the ForwardRef HoC


          if (ReactForwardRefSymbol && componentClass["$$typeof"] === ReactForwardRefSymbol) {
            var _baseRender = componentClass.render;
            if (typeof _baseRender !== "function") throw new Error("render property of ForwardRef was not a function"); // TODO: do we need to hoist statics from baseRender to the forward ref?

            return Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function ObserverForwardRef() {
              var _arguments = arguments;
              return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(Observer, null, function () {
                return _baseRender.apply(undefined, _arguments);
              });
            });
          } // Stateless function component:
          // If it is function but doesn't seem to be a react class constructor,
          // wrap it to a react class automatically


          if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !react__WEBPACK_IMPORTED_MODULE_1__["Component"].isPrototypeOf(componentClass)) {
            var _class, _temp;

            var observerComponent = observer((_temp = _class = /*#__PURE__*/function (_Component) {
              _inherits(_class, _Component);

              function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
              }

              _createClass(_class, [{
                key: "render",
                value: function render() {
                  return componentClass.call(this, this.props, this.context);
                }
              }]);

              return _class;
            }(react__WEBPACK_IMPORTED_MODULE_1__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
            hoistNonReactStatics_cjs(observerComponent, componentClass);
            return observerComponent;
          }

          if (!componentClass) {
            throw new Error("Please pass a valid component to 'observer'");
          }

          var target = componentClass.prototype || componentClass;
          mixinLifecycleEvents(target);
          componentClass.isMobXReactObserver = true;
          makeObservableProp(target, "props");
          makeObservableProp(target, "state");
          var baseRender = target.render;

          target.render = function () {
            return makeComponentReactive.call(this, baseRender);
          };

          return componentClass;
        }

        function mixinLifecycleEvents(target) {
          ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
            patch$1(target, funcName);
          });

          if (!target.shouldComponentUpdate) {
            target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
          } else {
            if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
              // TODO: make throw in next major
              console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
            }
          }
        }

        var Observer = observer(function (_ref2) {
          var children = _ref2.children,
              observerInject = _ref2.inject,
              render = _ref2.render;
          var component = children || render;

          if (typeof component === "undefined") {
            return null;
          }

          if (!observerInject) {
            return component();
          } // TODO: remove in next major


          console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
          var InjectComponent = inject(observerInject)(component);
          return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(InjectComponent, null);
        });
        Observer.displayName = "Observer";

        var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
          var extraKey = key === "children" ? "render" : "children";

          if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
            return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
          }

          if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
            return;
          }

          return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
        };

        Observer.propTypes = {
          render: ObserverPropsCheck,
          children: ObserverPropsCheck
        };
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        function componentWillMount() {
          // Call this.constructor.gDSFP to support sub-classes.
          var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

          if (state !== null && state !== undefined) {
            this.setState(state);
          }
        }

        function componentWillReceiveProps(nextProps) {
          // Call this.constructor.gDSFP to support sub-classes.
          // Use the setState() updater to ensure state isn't stale in certain edge cases.
          function updater(prevState) {
            var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
            return state !== null && state !== undefined ? state : null;
          } // Binding "this" is important for shallow renderer support.


          this.setState(updater.bind(this));
        }

        function componentWillUpdate(nextProps, nextState) {
          try {
            var prevProps = this.props;
            var prevState = this.state;
            this.props = nextProps;
            this.state = nextState;
            this.__reactInternalSnapshotFlag = true;
            this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
          } finally {
            this.props = prevProps;
            this.state = prevState;
          }
        } // React may warn about cWM/cWRP/cWU methods being deprecated.
        // Add a flag to suppress these warnings for this special case.


        componentWillMount.__suppressDeprecationWarning = true;
        componentWillReceiveProps.__suppressDeprecationWarning = true;
        componentWillUpdate.__suppressDeprecationWarning = true;

        function polyfill(Component$$1) {
          var prototype = Component$$1.prototype;

          if (!prototype || !prototype.isReactComponent) {
            throw new Error('Can only polyfill class components');
          }

          if (typeof Component$$1.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
            return Component$$1;
          } // If new component APIs are defined, "unsafe" lifecycles won't be called.
          // Error if any of these lifecycles are present,
          // Because they would work differently between older and newer (16.3+) versions of React.


          var foundWillMountName = null;
          var foundWillReceivePropsName = null;
          var foundWillUpdateName = null;

          if (typeof prototype.componentWillMount === 'function') {
            foundWillMountName = 'componentWillMount';
          } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
            foundWillMountName = 'UNSAFE_componentWillMount';
          }

          if (typeof prototype.componentWillReceiveProps === 'function') {
            foundWillReceivePropsName = 'componentWillReceiveProps';
          } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
            foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
          }

          if (typeof prototype.componentWillUpdate === 'function') {
            foundWillUpdateName = 'componentWillUpdate';
          } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
            foundWillUpdateName = 'UNSAFE_componentWillUpdate';
          }

          if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
            var componentName = Component$$1.displayName || Component$$1.name;
            var newApiName = typeof Component$$1.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
            throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
          } // React <= 16.2 does not support static getDerivedStateFromProps.
          // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
          // Newer versions of React will ignore these lifecycles if gDSFP exists.


          if (typeof Component$$1.getDerivedStateFromProps === 'function') {
            prototype.componentWillMount = componentWillMount;
            prototype.componentWillReceiveProps = componentWillReceiveProps;
          } // React <= 16.2 does not support getSnapshotBeforeUpdate.
          // As a workaround, use cWU to invoke the new lifecycle.
          // Newer versions of React will ignore that lifecycle if gSBU exists.


          if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
            if (typeof prototype.componentDidUpdate !== 'function') {
              throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
            }

            prototype.componentWillUpdate = componentWillUpdate;
            var componentDidUpdate = prototype.componentDidUpdate;

            prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
              // 16.3+ will not execute our will-update method;
              // It will pass a snapshot value to did-update though.
              // Older versions will require our polyfilled will-update value.
              // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
              // Because for <= 15.x versions this might be a "prevContext" object.
              // We also can't just check "__reactInternalSnapshot",
              // Because get-snapshot might return a falsy value.
              // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
              var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
              componentDidUpdate.call(this, prevProps, prevState, snapshot);
            };
          }

          return Component$$1;
        }

        var specialReactKeys = {
          children: true,
          key: true,
          ref: true
        };

        var Provider = /*#__PURE__*/function (_Component) {
          _inherits(Provider, _Component);

          function Provider(props, context) {
            var _this;

            _classCallCheck(this, Provider);

            _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props, context));
            _this.state = {};
            copyStores(props, _this.state);
            return _this;
          }

          _createClass(Provider, [{
            key: "render",
            value: function render() {
              return react__WEBPACK_IMPORTED_MODULE_1__["Children"].only(this.props.children);
            }
          }, {
            key: "getChildContext",
            value: function getChildContext() {
              var stores = {}; // inherit stores

              copyStores(this.context.mobxStores, stores); // add own stores

              copyStores(this.props, stores);
              return {
                mobxStores: stores
              };
            }
          }], [{
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
              if (!nextProps) return null;
              if (!prevState) return nextProps; // Maybe this warning is too aggressive?

              if (Object.keys(nextProps).filter(validStoreName).length !== Object.keys(prevState).filter(validStoreName).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
              if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (validStoreName(key) && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
              }
              return nextProps;
            }
          }]);

          return Provider;
        }(react__WEBPACK_IMPORTED_MODULE_1__["Component"]);

        Provider.contextTypes = {
          mobxStores: objectOrObservableObject
        };
        Provider.childContextTypes = {
          mobxStores: objectOrObservableObject.isRequired
        };

        function copyStores(from, to) {
          if (!from) return;

          for (var key in from) {
            if (validStoreName(key)) to[key] = from[key];
          }
        }

        function validStoreName(key) {
          return !specialReactKeys[key] && key !== "suppressChangedStoreWarning";
        } // TODO: kill in next major


        polyfill(Provider);
        var storeKey = newSymbol("disposeOnUnmount");

        function runDisposersOnWillUnmount() {
          var _this = this;

          if (!this[storeKey]) {
            // when disposeOnUnmount is only set to some instances of a component it will still patch the prototype
            return;
          }

          this[storeKey].forEach(function (propKeyOrFunction) {
            var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;

            if (prop !== undefined && prop !== null) {
              if (typeof prop !== "function") {
                throw new Error("[mobx-react] disposeOnUnmount only works on functions such as disposers returned by reactions, autorun, etc.");
              }

              prop();
            }
          });
          this[storeKey] = [];
        }

        function disposeOnUnmount(target, propertyKeyOrFunction) {
          if (Array.isArray(propertyKeyOrFunction)) {
            return propertyKeyOrFunction.map(function (fn) {
              return disposeOnUnmount(target, fn);
            });
          }

          if (!target instanceof react__WEBPACK_IMPORTED_MODULE_1__["Component"]) {
            throw new Error("[mobx-react] disposeOnUnmount only works on class based React components.");
          }

          if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function") {
            throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
          } // add property key / function we want run (disposed) to the store


          var componentWasAlreadyModified = !!target[storeKey];
          var store = target[storeKey] || (target[storeKey] = []);
          store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already

          if (!componentWasAlreadyModified) {
            patch(target, "componentWillUnmount", runDisposersOnWillUnmount);
          } // return the disposer as is if invoked as a non decorator


          if (typeof propertyKeyOrFunction !== "string") {
            return propertyKeyOrFunction;
          }
        }

        if (!react__WEBPACK_IMPORTED_MODULE_1__["Component"]) throw new Error("mobx-react requires React to be available");
        if (!mobx__WEBPACK_IMPORTED_MODULE_0__["spy"]) throw new Error("mobx-react requires mobx to be available");
        if (typeof react_dom__WEBPACK_IMPORTED_MODULE_2__["unstable_batchedUpdates"] === "function") Object(mobx__WEBPACK_IMPORTED_MODULE_0__["configure"])({
          reactionScheduler: react_dom__WEBPACK_IMPORTED_MODULE_2__["unstable_batchedUpdates"]
        });

        var onError = function onError(fn) {
          return errorsReporter.on(fn);
        };

        if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
          var mobx = {
            spy: mobx__WEBPACK_IMPORTED_MODULE_0__["spy"],
            extras: {
              getDebugName: mobx__WEBPACK_IMPORTED_MODULE_0__["getDebugName"]
            }
          };
          var mobxReact = {
            renderReporter: renderReporter,
            componentByNodeRegistry: componentByNodeRegistry,
            componentByNodeRegistery: componentByNodeRegistry,
            trackComponents: trackComponents
          };

          __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx);
        }
        /***/

      },

      /***/
      "./node_modules/mobx/lib/mobx.module.js":
      /*!**********************************************!*\
        !*** ./node_modules/mobx/lib/mobx.module.js ***!
        \**********************************************/

      /*! exports provided: $mobx, FlowCancellationError, IDerivationState, ObservableMap, ObservableSet, Reaction, _allowStateChanges, _allowStateChangesInsideComputed, _endAction, _getAdministration, _getGlobalState, _interceptReads, _isComputingDerivation, _resetGlobalState, _startAction, action, autorun, comparer, computed, configure, createAtom, decorate, entries, extendObservable, extendShallowObservable, flow, get, getAtom, getDebugName, getDependencyTree, getObserverTree, has, intercept, isAction, isArrayLike, isBoxedObservable, isComputed, isComputedProp, isFlowCancellationError, isObservable, isObservableArray, isObservableMap, isObservableObject, isObservableProp, isObservableSet, keys, observable, observe, onBecomeObserved, onBecomeUnobserved, onReactionError, reaction, remove, runInAction, set, spy, toJS, trace, transaction, untracked, values, when */

      /***/
      function node_modulesMobxLibMobxModuleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* WEBPACK VAR INJECTION */


        (function (global, process) {
          /* harmony export (binding) */
          __webpack_require__.d(__webpack_exports__, "$mobx", function () {
            return $mobx;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "FlowCancellationError", function () {
            return FlowCancellationError;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "IDerivationState", function () {
            return IDerivationState;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "ObservableMap", function () {
            return ObservableMap;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "ObservableSet", function () {
            return ObservableSet;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "Reaction", function () {
            return Reaction;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_allowStateChanges", function () {
            return allowStateChanges;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_allowStateChangesInsideComputed", function () {
            return allowStateChangesInsideComputed;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_endAction", function () {
            return _endAction;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_getAdministration", function () {
            return getAdministration;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_getGlobalState", function () {
            return getGlobalState;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_interceptReads", function () {
            return interceptReads;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_isComputingDerivation", function () {
            return isComputingDerivation;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_resetGlobalState", function () {
            return resetGlobalState;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "_startAction", function () {
            return _startAction;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "action", function () {
            return action;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "autorun", function () {
            return autorun;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "comparer", function () {
            return comparer;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "computed", function () {
            return computed;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "configure", function () {
            return configure;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "createAtom", function () {
            return createAtom;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "decorate", function () {
            return decorate;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "entries", function () {
            return entries;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "extendObservable", function () {
            return extendObservable;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "extendShallowObservable", function () {
            return extendShallowObservable;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "flow", function () {
            return flow;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "get", function () {
            return get;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getAtom", function () {
            return getAtom;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getDebugName", function () {
            return getDebugName;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getDependencyTree", function () {
            return getDependencyTree;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getObserverTree", function () {
            return getObserverTree;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "has", function () {
            return has;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "intercept", function () {
            return intercept;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isAction", function () {
            return isAction;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isArrayLike", function () {
            return isArrayLike;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function () {
            return isObservableValue;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isComputed", function () {
            return isComputed;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isComputedProp", function () {
            return isComputedProp;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isFlowCancellationError", function () {
            return isFlowCancellationError;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isObservable", function () {
            return isObservable;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isObservableArray", function () {
            return isObservableArray;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isObservableMap", function () {
            return isObservableMap;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isObservableObject", function () {
            return isObservableObject;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isObservableProp", function () {
            return isObservableProp;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "isObservableSet", function () {
            return isObservableSet;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "keys", function () {
            return keys;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "observable", function () {
            return observable;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "observe", function () {
            return observe;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "onBecomeObserved", function () {
            return onBecomeObserved;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "onBecomeUnobserved", function () {
            return onBecomeUnobserved;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "onReactionError", function () {
            return onReactionError;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "reaction", function () {
            return reaction;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "remove", function () {
            return remove;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "runInAction", function () {
            return runInAction;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "set", function () {
            return set;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "spy", function () {
            return spy;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "toJS", function () {
            return toJS;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "trace", function () {
            return trace;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "transaction", function () {
            return transaction;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "untracked", function () {
            return untracked;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "values", function () {
            return values;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "when", function () {
            return when;
          });
          /** MobX - (c) Michel Weststrate 2015 - 2018 - MIT Licensed */

          /*! *****************************************************************************
          Copyright (c) Microsoft Corporation. All rights reserved.
          Licensed under the Apache License, Version 2.0 (the "License"); you may not use
          this file except in compliance with the License. You may obtain a copy of the
          License at http://www.apache.org/licenses/LICENSE-2.0
          
          THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
          KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
          WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
          MERCHANTABLITY OR NON-INFRINGEMENT.
          
          See the Apache Version 2.0 License for specific language governing permissions
          and limitations under the License.
          ***************************************************************************** */

          /* global Reflect, Promise */


          var _extendStatics4 = function extendStatics(d, b) {
            _extendStatics4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics4(d, b);
          };

          function __extends(d, b) {
            _extendStatics4(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          }

          var _assign = function __assign() {
            _assign = Object.assign || function __assign(t) {
              for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];

                for (var p in s) {
                  if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
              }

              return t;
            };

            return _assign.apply(this, arguments);
          };

          function __read(o, n) {
            var m = typeof Symbol === "function" && o[Symbol.iterator];
            if (!m) return o;
            var i = m.call(o),
                r,
                ar = [],
                e;

            try {
              while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
                ar.push(r.value);
              }
            } catch (error) {
              e = {
                error: error
              };
            } finally {
              try {
                if (r && !r.done && (m = i["return"])) m.call(i);
              } finally {
                if (e) throw e.error;
              }
            }

            return ar;
          }

          function __spread() {
            for (var ar = [], i = 0; i < arguments.length; i++) {
              ar = ar.concat(__read(arguments[i]));
            }

            return ar;
          }

          var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
          var EMPTY_ARRAY = [];
          Object.freeze(EMPTY_ARRAY);
          var EMPTY_OBJECT = {};
          Object.freeze(EMPTY_OBJECT);
          var mockGlobal = {};

          function getGlobal() {
            if (typeof window !== "undefined") {
              return window;
            }

            if (typeof global !== "undefined") {
              return global;
            }

            if (typeof self !== "undefined") {
              return self;
            }

            return mockGlobal;
          }

          function getNextId() {
            return ++globalState.mobxGuid;
          }

          function fail(message) {
            invariant(false, message);
            throw "X"; // unreachable
          }

          function invariant(check, message) {
            if (!check) throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
          }
          /**
           * Prints a deprecation message, but only one time.
           * Returns false if the deprecated message was already printed before
           */


          var deprecatedMessages = [];

          function deprecated(msg, thing) {
            if (true) return false;

            if (thing) {
              return deprecated("'" + msg + "', use '" + thing + "' instead.");
            }

            if (deprecatedMessages.indexOf(msg) !== -1) return false;
            deprecatedMessages.push(msg);
            console.error("[mobx] Deprecated: " + msg);
            return true;
          }
          /**
           * Makes sure that the provided function is invoked at most once.
           */


          function once(func) {
            var invoked = false;
            return function () {
              if (invoked) return;
              invoked = true;
              return func.apply(this, arguments);
            };
          }

          var noop = function noop() {};

          function unique(list) {
            var res = [];
            list.forEach(function (item) {
              if (res.indexOf(item) === -1) res.push(item);
            });
            return res;
          }

          function isObject(value) {
            return value !== null && typeof value === "object";
          }

          function isPlainObject(value) {
            if (value === null || typeof value !== "object") return false;
            var proto = Object.getPrototypeOf(value);
            return proto === Object.prototype || proto === null;
          }

          function convertToMap(dataStructure) {
            if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
              return dataStructure;
            } else if (Array.isArray(dataStructure)) {
              return new Map(dataStructure);
            } else if (isPlainObject(dataStructure)) {
              return new Map(Object.entries(dataStructure));
            } else {
              return fail("Cannot convert to map from '" + dataStructure + "'");
            }
          }

          function makeNonEnumerable(object, propNames) {
            for (var i = 0; i < propNames.length; i++) {
              addHiddenProp(object, propNames[i], object[propNames[i]]);
            }
          }

          function addHiddenProp(object, propName, value) {
            Object.defineProperty(object, propName, {
              enumerable: false,
              writable: true,
              configurable: true,
              value: value
            });
          }

          function addHiddenFinalProp(object, propName, value) {
            Object.defineProperty(object, propName, {
              enumerable: false,
              writable: false,
              configurable: true,
              value: value
            });
          }

          function isPropertyConfigurable(object, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(object, prop);
            return !descriptor || descriptor.configurable !== false && descriptor.writable !== false;
          }

          function assertPropertyConfigurable(object, prop) {
            if (false) {}
          }

          function createInstanceofPredicate(name, clazz) {
            var propName = "isMobX" + name;
            clazz.prototype[propName] = true;
            return function (x) {
              return isObject(x) && x[propName] === true;
            };
          }

          function areBothNaN(a, b) {
            return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
          }
          /**
           * Returns whether the argument is an array, disregarding observability.
           */


          function isArrayLike(x) {
            return Array.isArray(x) || isObservableArray(x);
          }

          function isES6Map(thing) {
            if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map) return true;
            return false;
          }

          function isES6Set(thing) {
            return thing instanceof Set;
          } // use Array.from in Mobx 5


          function iteratorToArray(it) {
            var res = [];

            while (true) {
              var r = it.next();
              if (r.done) break;
              res.push(r.value);
            }

            return res;
          }

          function primitiveSymbol() {
            // es-disable-next-line
            return typeof Symbol === "function" && Symbol.toPrimitive || "@@toPrimitive";
          }

          function toPrimitive(value) {
            return value === null ? null : typeof value === "object" ? "" + value : value;
          }

          function iteratorSymbol() {
            return typeof Symbol === "function" && Symbol.iterator || "@@iterator";
          }

          function declareIterator(prototType, iteratorFactory) {
            addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
          }

          function makeIterable(iterator) {
            iterator[iteratorSymbol()] = getSelf;
            return iterator;
          }

          function toStringTagSymbol() {
            return typeof Symbol === "function" && Symbol.toStringTag || "@@toStringTag";
          }

          function getSelf() {
            return this;
          }
          /**
           * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
           *
           * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
           * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
           */


          var Atom =
          /** @class */
          function () {
            /**
             * Create a new atom. For debugging purposes it is recommended to give it a name.
             * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
             */
            function Atom(name) {
              if (name === void 0) {
                name = "Atom@" + getNextId();
              }

              this.name = name;
              this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed

              this.isBeingObserved = false;
              this.observers = [];
              this.observersIndexes = {};
              this.diffValue = 0;
              this.lastAccessedBy = 0;
              this.lowestObserverState = IDerivationState.NOT_TRACKING;
            }

            Atom.prototype.onBecomeUnobserved = function () {// noop
            };

            Atom.prototype.onBecomeObserved = function () {
              /* noop */
            };
            /**
             * Invoke this method to notify mobx that your atom has been used somehow.
             * Returns true if there is currently a reactive context.
             */


            Atom.prototype.reportObserved = function () {
              return reportObserved(this);
            };
            /**
             * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
             */


            Atom.prototype.reportChanged = function () {
              startBatch();
              propagateChanged(this);
              endBatch();
            };

            Atom.prototype.toString = function () {
              return this.name;
            };

            return Atom;
          }();

          var isAtom = createInstanceofPredicate("Atom", Atom);

          function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
            if (onBecomeObservedHandler === void 0) {
              onBecomeObservedHandler = noop;
            }

            if (onBecomeUnobservedHandler === void 0) {
              onBecomeUnobservedHandler = noop;
            }

            var atom = new Atom(name);
            onBecomeObserved(atom, onBecomeObservedHandler);
            onBecomeUnobserved(atom, onBecomeUnobservedHandler);
            return atom;
          }

          function identityComparer(a, b) {
            return a === b;
          }

          function structuralComparer(a, b) {
            return deepEqual(a, b);
          }

          function shallowComparer(a, b) {
            return deepEqual(a, b, 1);
          }

          function defaultComparer(a, b) {
            return areBothNaN(a, b) || identityComparer(a, b);
          }

          var comparer = {
            identity: identityComparer,
            structural: structuralComparer,
            default: defaultComparer,
            shallow: shallowComparer
          };
          var enumerableDescriptorCache = {};
          var nonEnumerableDescriptorCache = {};

          function createPropertyInitializerDescriptor(prop, enumerable) {
            var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
            return cache[prop] || (cache[prop] = {
              configurable: true,
              enumerable: enumerable,
              get: function get() {
                initializeInstance(this);
                return this[prop];
              },
              set: function set(value) {
                initializeInstance(this);
                this[prop] = value;
              }
            });
          }

          function initializeInstance(target) {
            if (target.__mobxDidRunLazyInitializers === true) return;
            var decorators = target.__mobxDecorators;

            if (decorators) {
              addHiddenProp(target, "__mobxDidRunLazyInitializers", true);

              for (var key in decorators) {
                var d = decorators[key];
                d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
              }
            }
          }

          function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
            return function decoratorFactory() {
              var decoratorArguments;

              var decorator = function decorate(target, prop, descriptor, applyImmediately // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
              // as the instance to apply the decorator to equals the target
              ) {
                if (applyImmediately === true) {
                  propertyCreator(target, prop, descriptor, target, decoratorArguments);
                  return null;
                }

                if (false) {}

                if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
                  var inheritedDecorators = target.__mobxDecorators;
                  addHiddenProp(target, "__mobxDecorators", _assign({}, inheritedDecorators));
                }

                target.__mobxDecorators[prop] = {
                  prop: prop,
                  propertyCreator: propertyCreator,
                  descriptor: descriptor,
                  decoratorTarget: target,
                  decoratorArguments: decoratorArguments
                };
                return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
              };

              if (quacksLikeADecorator(arguments)) {
                // @decorator
                decoratorArguments = EMPTY_ARRAY;
                return decorator.apply(null, arguments);
              } else {
                // @decorator(args)
                decoratorArguments = Array.prototype.slice.call(arguments);
                return decorator;
              }
            };
          }

          function quacksLikeADecorator(args) {
            return (args.length === 2 || args.length === 3) && typeof args[1] === "string" || args.length === 4 && args[3] === true;
          }

          function deepEnhancer(v, _, name) {
            // it is an observable already, done
            if (isObservable(v)) return v; // something that can be converted and mutated?

            if (Array.isArray(v)) return observable.array(v, {
              name: name
            });
            if (isPlainObject(v)) return observable.object(v, undefined, {
              name: name
            });
            if (isES6Map(v)) return observable.map(v, {
              name: name
            });
            if (isES6Set(v)) return observable.set(v, {
              name: name
            });
            return v;
          }

          function shallowEnhancer(v, _, name) {
            if (v === undefined || v === null) return v;
            if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
            if (Array.isArray(v)) return observable.array(v, {
              name: name,
              deep: false
            });
            if (isPlainObject(v)) return observable.object(v, undefined, {
              name: name,
              deep: false
            });
            if (isES6Map(v)) return observable.map(v, {
              name: name,
              deep: false
            });
            if (isES6Set(v)) return observable.set(v, {
              name: name,
              deep: false
            });
            return fail(false && false);
          }

          function referenceEnhancer(newValue) {
            // never turn into an observable
            return newValue;
          }

          function refStructEnhancer(v, oldValue, name) {
            if (false) {}

            if (deepEqual(v, oldValue)) return oldValue;
            return v;
          }

          function createDecoratorForEnhancer(enhancer) {
            var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
              if (false) {}

              var initialValue = descriptor ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value : undefined;
              defineObservableProperty(target, propertyName, initialValue, enhancer);
            });
            var res = // Extra process checks, as this happens during module initialization
            typeof process !== "undefined" && Object({
              "NODE_ENV": "production"
            }) && "production" !== "production" ? function observableDecorator() {
              // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
              // and simply return the created prop decorator
              if (arguments.length < 2) return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
              return decorator.apply(null, arguments);
            } : decorator;
            res.enhancer = enhancer;
            return res;
          } // Predefined bags of create observable options, to avoid allocating temporarily option objects
          // in the majority of cases


          var defaultCreateObservableOptions = {
            deep: true,
            name: undefined,
            defaultDecorator: undefined
          };
          var shallowCreateObservableOptions = {
            deep: false,
            name: undefined,
            defaultDecorator: undefined
          };
          Object.freeze(defaultCreateObservableOptions);
          Object.freeze(shallowCreateObservableOptions);

          function assertValidOption(key) {
            if (!/^(deep|name|equals|defaultDecorator)$/.test(key)) fail("invalid option for (extend)observable: " + key);
          }

          function asCreateObservableOptions(thing) {
            if (thing === null || thing === undefined) return defaultCreateObservableOptions;
            if (typeof thing === "string") return {
              name: thing,
              deep: true
            };

            if (false) {}

            return thing;
          }

          function getEnhancerFromOptions(options) {
            return options.defaultDecorator ? options.defaultDecorator.enhancer : options.deep === false ? referenceEnhancer : deepEnhancer;
          }

          var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
          var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
          var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
          var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
          /**
           * Turns an object, array or function into a reactive structure.
           * @param v the value which should become observable.
           */

          function createObservable(v, arg2, arg3) {
            // @observable someProp;
            if (typeof arguments[1] === "string") {
              return deepDecorator.apply(null, arguments);
            } // it is an observable already, done


            if (isObservable(v)) return v; // something that can be converted and mutated?

            var res = isPlainObject(v) ? observable.object(v, arg2, arg3) : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : isES6Set(v) ? observable.set(v, arg2) : v; // this value could be converted to a new observable data structure, return it

            if (res !== v) return res; // otherwise, just box it

            fail(false && false);
          }

          var observableFactories = {
            box: function box(value, options) {
              if (arguments.length > 2) incorrectlyUsedAsDecorator("box");
              var o = asCreateObservableOptions(options);
              return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
            },
            shallowBox: function shallowBox(value, name) {
              if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowBox");
              deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
              return observable.box(value, {
                name: name,
                deep: false
              });
            },
            array: function array(initialValues, options) {
              if (arguments.length > 2) incorrectlyUsedAsDecorator("array");
              var o = asCreateObservableOptions(options);
              return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
            },
            shallowArray: function shallowArray(initialValues, name) {
              if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowArray");
              deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
              return observable.array(initialValues, {
                name: name,
                deep: false
              });
            },
            map: function map(initialValues, options) {
              if (arguments.length > 2) incorrectlyUsedAsDecorator("map");
              var o = asCreateObservableOptions(options);
              return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
            },
            shallowMap: function shallowMap(initialValues, name) {
              if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowMap");
              deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
              return observable.map(initialValues, {
                name: name,
                deep: false
              });
            },
            set: function set(initialValues, options) {
              if (arguments.length > 2) incorrectlyUsedAsDecorator("set");
              var o = asCreateObservableOptions(options);
              return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
            },
            object: function object(props, decorators, options) {
              if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("object");
              var o = asCreateObservableOptions(options);
              return extendObservable({}, props, decorators, o);
            },
            shallowObject: function shallowObject(props, name) {
              if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("shallowObject");
              deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
              return observable.object(props, {}, {
                name: name,
                deep: false
              });
            },
            ref: refDecorator,
            shallow: shallowDecorator,
            deep: deepDecorator,
            struct: refStructDecorator
          };
          var observable = createObservable; // weird trick to keep our typings nicely with our funcs, and still extend the observable function

          Object.keys(observableFactories).forEach(function (name) {
            return observable[name] = observableFactories[name];
          });

          function incorrectlyUsedAsDecorator(methodName) {
            fail( // process.env.NODE_ENV !== "production" &&
            "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
          }

          var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
            var get = descriptor.get,
                set = descriptor.set; // initialValue is the descriptor for get / set props
            // Optimization: faster on decorator target or instance? Assuming target
            // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
            // Forcing instance now, fixes hot reloadig issues on React Native:

            var options = decoratorArgs[0] || {};
            defineComputedProperty(instance, propertyName, _assign({
              get: get,
              set: set
            }, options));
          });
          var computedStructDecorator = computedDecorator({
            equals: comparer.structural
          });
          /**
           * Decorator for class properties: @computed get value() { return expr; }.
           * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
           */

          var computed = function computed(arg1, arg2, arg3) {
            if (typeof arg2 === "string") {
              // @computed
              return computedDecorator.apply(null, arguments);
            }

            if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
              // @computed({ options })
              return computedDecorator.apply(null, arguments);
            } // computed(expr, options?)


            if (false) {}

            var opts = typeof arg2 === "object" ? arg2 : {};
            opts.get = arg1;
            opts.set = typeof arg2 === "function" ? arg2 : opts.set;
            opts.name = opts.name || arg1.name || "";
            /* for generated name */

            return new ComputedValue(opts);
          };

          computed.struct = computedStructDecorator;
          var IDerivationState;

          (function (IDerivationState) {
            // before being run or (outside batch and not being observed)
            // at this point derivation is not holding any data about dependency tree
            IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING"; // no shallow dependency changed since last computation
            // won't recalculate derivation
            // this is what makes mobx fast

            IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE"; // some deep dependency changed, but don't know if shallow dependency changed
            // will require to check first if UP_TO_DATE or POSSIBLY_STALE
            // currently only ComputedValue will propagate POSSIBLY_STALE
            //
            // having this state is second big optimization:
            // don't have to recompute on every dependency change, but only when it's needed

            IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE"; // A shallow dependency has changed since last computation and the derivation
            // will need to recompute when it's needed next.

            IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
          })(IDerivationState || (IDerivationState = {}));

          var TraceMode;

          (function (TraceMode) {
            TraceMode[TraceMode["NONE"] = 0] = "NONE";
            TraceMode[TraceMode["LOG"] = 1] = "LOG";
            TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
          })(TraceMode || (TraceMode = {}));

          var CaughtException =
          /** @class */
          function () {
            function CaughtException(cause) {
              this.cause = cause; // Empty
            }

            return CaughtException;
          }();

          function isCaughtException(e) {
            return e instanceof CaughtException;
          }
          /**
           * Finds out whether any dependency of the derivation has actually changed.
           * If dependenciesState is 1 then it will recalculate dependencies,
           * if any dependency changed it will propagate it by changing dependenciesState to 2.
           *
           * By iterating over the dependencies in the same order that they were reported and
           * stopping on the first change, all the recalculations are only called for ComputedValues
           * that will be tracked by derivation. That is because we assume that if the first x
           * dependencies of the derivation doesn't change then the derivation should run the same way
           * up until accessing x-th dependency.
           */


          function shouldCompute(derivation) {
            switch (derivation.dependenciesState) {
              case IDerivationState.UP_TO_DATE:
                return false;

              case IDerivationState.NOT_TRACKING:
              case IDerivationState.STALE:
                return true;

              case IDerivationState.POSSIBLY_STALE:
                {
                  var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.

                  var obs = derivation.observing,
                      l = obs.length;

                  for (var i = 0; i < l; i++) {
                    var obj = obs[i];

                    if (isComputedValue(obj)) {
                      if (globalState.disableErrorBoundaries) {
                        obj.get();
                      } else {
                        try {
                          obj.get();
                        } catch (e) {
                          // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                          untrackedEnd(prevUntracked);
                          return true;
                        }
                      } // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                      // and `derivation` is an observer of `obj`
                      // invariantShouldCompute(derivation)


                      if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                      }
                    }
                  }

                  changeDependenciesStateTo0(derivation);
                  untrackedEnd(prevUntracked);
                  return false;
                }
            }
          } // function invariantShouldCompute(derivation: IDerivation) {
          //     const newDepState = (derivation as any).dependenciesState
          //     if (
          //         process.env.NODE_ENV === "production" &&
          //         (newDepState === IDerivationState.POSSIBLY_STALE ||
          //             newDepState === IDerivationState.NOT_TRACKING)
          //     )
          //         fail("Illegal dependency state")
          // }


          function isComputingDerivation() {
            return globalState.trackingDerivation !== null; // filter out actions inside computations
          }

          function checkIfStateModificationsAreAllowed(atom) {
            var hasObservers = atom.observers.length > 0; // Should never be possible to change an observed observable from inside computed, see #798

            if (globalState.computationDepth > 0 && hasObservers) fail(false && false); // Should not be possible to change observed state outside strict mode, except during initialization, see #563

            if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict")) fail(false && false);
          }

          function checkIfStateReadsAreAllowed(observable) {
            if (false) {}
          }
          /**
           * Executes the provided function `f` and tracks which observables are being accessed.
           * The tracking information is stored on the `derivation` object and the derivation is registered
           * as observer of any of the accessed observables.
           */


          function trackDerivedFunction(derivation, f, context) {
            var prevAllowStateReads = allowStateReadsStart(true); // pre allocate array allocation + room for variation in deps
            // array will be trimmed by bindDependencies

            changeDependenciesStateTo0(derivation);
            derivation.newObserving = new Array(derivation.observing.length + 100);
            derivation.unboundDepsCount = 0;
            derivation.runId = ++globalState.runId;
            var prevTracking = globalState.trackingDerivation;
            globalState.trackingDerivation = derivation;
            var result;

            if (globalState.disableErrorBoundaries === true) {
              result = f.call(context);
            } else {
              try {
                result = f.call(context);
              } catch (e) {
                result = new CaughtException(e);
              }
            }

            globalState.trackingDerivation = prevTracking;
            bindDependencies(derivation);

            if (derivation.observing.length === 0) {
              warnAboutDerivationWithoutDependencies(derivation);
            }

            allowStateReadsEnd(prevAllowStateReads);
            return result;
          }

          function warnAboutDerivationWithoutDependencies(derivation) {
            if (true) return;

            if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
              console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
            }
          }
          /**
           * diffs newObserving with observing.
           * update observing to be newObserving with unique observables
           * notify observers that become observed/unobserved
           */


          function bindDependencies(derivation) {
            // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
            var prevObserving = derivation.observing;
            var observing = derivation.observing = derivation.newObserving;
            var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE; // Go through all new observables and check diffValue: (this list can contain duplicates):
            //   0: first occurrence, change to 1 and keep it
            //   1: extra occurrence, drop it

            var i0 = 0,
                l = derivation.unboundDepsCount;

            for (var i = 0; i < l; i++) {
              var dep = observing[i];

              if (dep.diffValue === 0) {
                dep.diffValue = 1;
                if (i0 !== i) observing[i0] = dep;
                i0++;
              } // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
              // not hitting the condition


              if (dep.dependenciesState > lowestNewObservingDerivationState) {
                lowestNewObservingDerivationState = dep.dependenciesState;
              }
            }

            observing.length = i0;
            derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
            // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
            //   0: it's not in new observables, unobserve it
            //   1: it keeps being observed, don't want to notify it. change to 0

            l = prevObserving.length;

            while (l--) {
              var dep = prevObserving[l];

              if (dep.diffValue === 0) {
                removeObserver(dep, derivation);
              }

              dep.diffValue = 0;
            } // Go through all new observables and check diffValue: (now it should be unique)
            //   0: it was set to 0 in last loop. don't need to do anything.
            //   1: it wasn't observed, let's observe it. set back to 0


            while (i0--) {
              var dep = observing[i0];

              if (dep.diffValue === 1) {
                dep.diffValue = 0;
                addObserver(dep, derivation);
              }
            } // Some new observed derivations may become stale during this derivation computation
            // so they have had no chance to propagate staleness (#916)


            if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
              derivation.dependenciesState = lowestNewObservingDerivationState;
              derivation.onBecomeStale();
            }
          }

          function clearObserving(derivation) {
            // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
            var obs = derivation.observing;
            derivation.observing = [];
            var i = obs.length;

            while (i--) {
              removeObserver(obs[i], derivation);
            }

            derivation.dependenciesState = IDerivationState.NOT_TRACKING;
          }

          function untracked(action) {
            var prev = untrackedStart();
            var res = action();
            untrackedEnd(prev);
            return res;
          }

          function untrackedStart() {
            var prev = globalState.trackingDerivation;
            globalState.trackingDerivation = null;
            return prev;
          }

          function untrackedEnd(prev) {
            globalState.trackingDerivation = prev;
          }

          function allowStateReadsStart(allowStateReads) {
            var prev = globalState.allowStateReads;
            globalState.allowStateReads = allowStateReads;
            return prev;
          }

          function allowStateReadsEnd(prev) {
            globalState.allowStateReads = prev;
          }
          /**
           * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
           *
           */


          function changeDependenciesStateTo0(derivation) {
            if (derivation.dependenciesState === IDerivationState.UP_TO_DATE) return;
            derivation.dependenciesState = IDerivationState.UP_TO_DATE;
            var obs = derivation.observing;
            var i = obs.length;

            while (i--) {
              obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
            }
          } // we don't use globalState for these in order to avoid possible issues with multiple
          // mobx versions


          var currentActionId = 0;
          var nextActionId = 1;

          function createAction(actionName, fn) {
            if (false) {}

            var res = function res() {
              return executeAction(actionName, fn, this, arguments);
            };

            res.isMobxAction = true;
            return res;
          }

          function executeAction(actionName, fn, scope, args) {
            var runInfo = _startAction(actionName, scope, args);

            try {
              return fn.apply(scope, args);
            } catch (err) {
              runInfo.error = err;
              throw err;
            } finally {
              _endAction(runInfo);
            }
          }

          function _startAction(actionName, scope, args) {
            var notifySpy = isSpyEnabled() && !!actionName;
            var startTime = 0;

            if (notifySpy) {
              startTime = Date.now();
              var l = args && args.length || 0;
              var flattendArgs = new Array(l);
              if (l > 0) for (var i = 0; i < l; i++) {
                flattendArgs[i] = args[i];
              }
              spyReportStart({
                type: "action",
                name: actionName,
                object: scope,
                arguments: flattendArgs
              });
            }

            var prevDerivation = untrackedStart();
            startBatch();
            var prevAllowStateChanges = allowStateChangesStart(true);
            var prevAllowStateReads = allowStateReadsStart(true);
            var runInfo = {
              prevDerivation: prevDerivation,
              prevAllowStateChanges: prevAllowStateChanges,
              prevAllowStateReads: prevAllowStateReads,
              notifySpy: notifySpy,
              startTime: startTime,
              actionId: nextActionId++,
              parentActionId: currentActionId
            };
            currentActionId = runInfo.actionId;
            return runInfo;
          }

          function _endAction(runInfo) {
            if (currentActionId !== runInfo.actionId) {
              fail("invalid action stack. did you forget to finish an action?");
            }

            currentActionId = runInfo.parentActionId;

            if (runInfo.error !== undefined) {
              globalState.suppressReactionErrors = true;
            }

            allowStateChangesEnd(runInfo.prevAllowStateChanges);
            allowStateReadsEnd(runInfo.prevAllowStateReads);
            endBatch();
            untrackedEnd(runInfo.prevDerivation);

            if (runInfo.notifySpy) {
              spyReportEnd({
                time: Date.now() - runInfo.startTime
              });
            }

            globalState.suppressReactionErrors = false;
          }

          function allowStateChanges(allowStateChanges, func) {
            var prev = allowStateChangesStart(allowStateChanges);
            var res;

            try {
              res = func();
            } finally {
              allowStateChangesEnd(prev);
            }

            return res;
          }

          function allowStateChangesStart(allowStateChanges) {
            var prev = globalState.allowStateChanges;
            globalState.allowStateChanges = allowStateChanges;
            return prev;
          }

          function allowStateChangesEnd(prev) {
            globalState.allowStateChanges = prev;
          }

          function allowStateChangesInsideComputed(func) {
            var prev = globalState.computationDepth;
            globalState.computationDepth = 0;
            var res;

            try {
              res = func();
            } finally {
              globalState.computationDepth = prev;
            }

            return res;
          }

          var ObservableValue =
          /** @class */
          function (_super) {
            __extends(ObservableValue, _super);

            function ObservableValue(value, enhancer, name, notifySpy, equals) {
              if (name === void 0) {
                name = "ObservableValue@" + getNextId();
              }

              if (notifySpy === void 0) {
                notifySpy = true;
              }

              if (equals === void 0) {
                equals = comparer.default;
              }

              var _this = _super.call(this, name) || this;

              _this.enhancer = enhancer;
              _this.name = name;
              _this.equals = equals;
              _this.hasUnreportedChange = false;
              _this.value = enhancer(value, undefined, name);

              if (notifySpy && isSpyEnabled()) {
                // only notify spy if this is a stand-alone observable
                spyReport({
                  type: "create",
                  name: _this.name,
                  newValue: "" + _this.value
                });
              }

              return _this;
            }

            ObservableValue.prototype.dehanceValue = function (value) {
              if (this.dehancer !== undefined) return this.dehancer(value);
              return value;
            };

            ObservableValue.prototype.set = function (newValue) {
              var oldValue = this.value;
              newValue = this.prepareNewValue(newValue);

              if (newValue !== globalState.UNCHANGED) {
                var notifySpy = isSpyEnabled();

                if (notifySpy) {
                  spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                  });
                }

                this.setNewValue(newValue);
                if (notifySpy) spyReportEnd();
              }
            };

            ObservableValue.prototype.prepareNewValue = function (newValue) {
              checkIfStateModificationsAreAllowed(this);

              if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                  object: this,
                  type: "update",
                  newValue: newValue
                });
                if (!change) return globalState.UNCHANGED;
                newValue = change.newValue;
              } // apply modifier


              newValue = this.enhancer(newValue, this.value, this.name);
              return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
            };

            ObservableValue.prototype.setNewValue = function (newValue) {
              var oldValue = this.value;
              this.value = newValue;
              this.reportChanged();

              if (hasListeners(this)) {
                notifyListeners(this, {
                  type: "update",
                  object: this,
                  newValue: newValue,
                  oldValue: oldValue
                });
              }
            };

            ObservableValue.prototype.get = function () {
              this.reportObserved();
              return this.dehanceValue(this.value);
            };

            ObservableValue.prototype.intercept = function (handler) {
              return registerInterceptor(this, handler);
            };

            ObservableValue.prototype.observe = function (listener, fireImmediately) {
              if (fireImmediately) listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
              });
              return registerListener(this, listener);
            };

            ObservableValue.prototype.toJSON = function () {
              return this.get();
            };

            ObservableValue.prototype.toString = function () {
              return this.name + "[" + this.value + "]";
            };

            ObservableValue.prototype.valueOf = function () {
              return toPrimitive(this.get());
            };

            return ObservableValue;
          }(Atom);

          ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
          var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
          /**
           * A node in the state dependency root that observes other nodes, and can be observed itself.
           *
           * ComputedValue will remember the result of the computation for the duration of the batch, or
           * while being observed.
           *
           * During this time it will recompute only when one of its direct dependencies changed,
           * but only when it is being accessed with `ComputedValue.get()`.
           *
           * Implementation description:
           * 1. First time it's being accessed it will compute and remember result
           *    give back remembered result until 2. happens
           * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
           * 3. When it's being accessed, recompute if any shallow dependency changed.
           *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
           *    go to step 2. either way
           *
           * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
           */

          var ComputedValue =
          /** @class */
          function () {
            /**
             * Create a new computed value based on a function expression.
             *
             * The `name` property is for debug purposes only.
             *
             * The `equals` property specifies the comparer function to use to determine if a newly produced
             * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
             * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
             * Structural comparison can be convenient if you always produce a new aggregated object and
             * don't want to notify observers if it is structurally the same.
             * This is useful for working with vectors, mouse coordinates etc.
             */
            function ComputedValue(options) {
              this.dependenciesState = IDerivationState.NOT_TRACKING;
              this.observing = []; // nodes we are looking at. Our value depends on these nodes

              this.newObserving = null; // during tracking it's an array with new observed observers

              this.isBeingObserved = false;
              this.isPendingUnobservation = false;
              this.observers = [];
              this.observersIndexes = {};
              this.diffValue = 0;
              this.runId = 0;
              this.lastAccessedBy = 0;
              this.lowestObserverState = IDerivationState.UP_TO_DATE;
              this.unboundDepsCount = 0;
              this.__mapid = "#" + getNextId();
              this.value = new CaughtException(null);
              this.isComputing = false; // to check for cycles

              this.isRunningSetter = false;
              this.isTracing = TraceMode.NONE;

              if (false) {}

              this.derivation = options.get;
              this.name = options.name || "ComputedValue@" + getNextId();
              if (options.set) this.setter = createAction(this.name + "-setter", options.set);
              this.equals = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer.default);
              this.scope = options.context;
              this.requiresReaction = !!options.requiresReaction;
              this.keepAlive = !!options.keepAlive;
            }

            ComputedValue.prototype.onBecomeStale = function () {
              propagateMaybeChanged(this);
            };

            ComputedValue.prototype.onBecomeUnobserved = function () {};

            ComputedValue.prototype.onBecomeObserved = function () {};
            /**
             * Returns the current value of this computed value.
             * Will evaluate its computation first if needed.
             */


            ComputedValue.prototype.get = function () {
              if (this.isComputing) fail("Cycle detected in computation " + this.name + ": " + this.derivation);

              if (globalState.inBatch === 0 && this.observers.length === 0 && !this.keepAlive) {
                if (shouldCompute(this)) {
                  this.warnAboutUntrackedRead();
                  startBatch(); // See perf test 'computed memoization'

                  this.value = this.computeValue(false);
                  endBatch();
                }
              } else {
                reportObserved(this);
                if (shouldCompute(this)) if (this.trackAndCompute()) propagateChangeConfirmed(this);
              }

              var result = this.value;
              if (isCaughtException(result)) throw result.cause;
              return result;
            };

            ComputedValue.prototype.peek = function () {
              var res = this.computeValue(false);
              if (isCaughtException(res)) throw res.cause;
              return res;
            };

            ComputedValue.prototype.set = function (value) {
              if (this.setter) {
                invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
                this.isRunningSetter = true;

                try {
                  this.setter.call(this.scope, value);
                } finally {
                  this.isRunningSetter = false;
                }
              } else invariant(false, false && false);
            };

            ComputedValue.prototype.trackAndCompute = function () {
              if (isSpyEnabled()) {
                spyReport({
                  object: this.scope,
                  type: "compute",
                  name: this.name
                });
              }

              var oldValue = this.value;
              var wasSuspended =
              /* see #1208 */
              this.dependenciesState === IDerivationState.NOT_TRACKING;
              var newValue = this.computeValue(true);
              var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals(oldValue, newValue);

              if (changed) {
                this.value = newValue;
              }

              return changed;
            };

            ComputedValue.prototype.computeValue = function (track) {
              this.isComputing = true;
              globalState.computationDepth++;
              var res;

              if (track) {
                res = trackDerivedFunction(this, this.derivation, this.scope);
              } else {
                if (globalState.disableErrorBoundaries === true) {
                  res = this.derivation.call(this.scope);
                } else {
                  try {
                    res = this.derivation.call(this.scope);
                  } catch (e) {
                    res = new CaughtException(e);
                  }
                }
              }

              globalState.computationDepth--;
              this.isComputing = false;
              return res;
            };

            ComputedValue.prototype.suspend = function () {
              if (!this.keepAlive) {
                clearObserving(this);
                this.value = undefined; // don't hold on to computed value!
              }
            };

            ComputedValue.prototype.observe = function (listener, fireImmediately) {
              var _this = this;

              var firstTime = true;
              var prevValue = undefined;
              return autorun(function () {
                var newValue = _this.get();

                if (!firstTime || fireImmediately) {
                  var prevU = untrackedStart();
                  listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                  });
                  untrackedEnd(prevU);
                }

                firstTime = false;
                prevValue = newValue;
              });
            };

            ComputedValue.prototype.warnAboutUntrackedRead = function () {
              if (true) return;

              if (this.requiresReaction === true) {
                fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
              }

              if (this.isTracing !== TraceMode.NONE) {
                console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
              }

              if (globalState.computedRequiresReaction) {
                console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
              }
            };

            ComputedValue.prototype.toJSON = function () {
              return this.get();
            };

            ComputedValue.prototype.toString = function () {
              return this.name + "[" + this.derivation.toString() + "]";
            };

            ComputedValue.prototype.valueOf = function () {
              return toPrimitive(this.get());
            };

            return ComputedValue;
          }();

          ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
          var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
          /**
           * These values will persist if global state is reset
           */

          var persistentKeys = ["mobxGuid", "spyListeners", "enforceActions", "computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "allowStateReads", "disableErrorBoundaries", "runId", "UNCHANGED"];

          var MobXGlobals =
          /** @class */
          function () {
            function MobXGlobals() {
              /**
               * MobXGlobals version.
               * MobX compatiblity with other versions loaded in memory as long as this version matches.
               * It indicates that the global state still stores similar information
               *
               * N.B: this version is unrelated to the package version of MobX, and is only the version of the
               * internal state storage of MobX, and can be the same across many different package versions
               */
              this.version = 5;
              /**
               * globally unique token to signal unchanged
               */

              this.UNCHANGED = {};
              /**
               * Currently running derivation
               */

              this.trackingDerivation = null;
              /**
               * Are we running a computation currently? (not a reaction)
               */

              this.computationDepth = 0;
              /**
               * Each time a derivation is tracked, it is assigned a unique run-id
               */

              this.runId = 0;
              /**
               * 'guid' for general purpose. Will be persisted amongst resets.
               */

              this.mobxGuid = 0;
              /**
               * Are we in a batch block? (and how many of them)
               */

              this.inBatch = 0;
              /**
               * Observables that don't have observers anymore, and are about to be
               * suspended, unless somebody else accesses it in the same batch
               *
               * @type {IObservable[]}
               */

              this.pendingUnobservations = [];
              /**
               * List of scheduled, not yet executed, reactions.
               */

              this.pendingReactions = [];
              /**
               * Are we currently processing reactions?
               */

              this.isRunningReactions = false;
              /**
               * Is it allowed to change observables at this point?
               * In general, MobX doesn't allow that when running computations and React.render.
               * To ensure that those functions stay pure.
               */

              this.allowStateChanges = true;
              /**
               * Is it allowed to read observables at this point?
               * Used to hold the state needed for `observableRequiresReaction`
               */

              this.allowStateReads = true;
              /**
               * If strict mode is enabled, state changes are by default not allowed
               */

              this.enforceActions = false;
              /**
               * Spy callbacks
               */

              this.spyListeners = [];
              /**
               * Globally attached error handlers that react specifically to errors in reactions
               */

              this.globalReactionErrorHandlers = [];
              /**
               * Warn if computed values are accessed outside a reactive context
               */

              this.computedRequiresReaction = false;
              /**
               * (Experimental)
               * Warn if you try to create to derivation / reactive context without accessing any observable.
               */

              this.reactionRequiresObservable = false;
              /**
               * (Experimental)
               * Warn if observables are accessed outside a reactive context
               */

              this.observableRequiresReaction = false;
              /**
               * Allows overwriting of computed properties, useful in tests but not prod as it can cause
               * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
               */

              this.computedConfigurable = false;
              /*
               * Don't catch and rethrow exceptions. This is useful for inspecting the state of
               * the stack when an exception occurs while debugging.
               */

              this.disableErrorBoundaries = false;
              /*
               * If true, we are already handling an exception in an action. Any errors in reactions should be supressed, as
               * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
               */

              this.suppressReactionErrors = false;
            }

            return MobXGlobals;
          }();

          var canMergeGlobalState = true;
          var isolateCalled = false;

          var globalState = function () {
            var global = getGlobal();
            if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals) canMergeGlobalState = false;
            if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;

            if (!canMergeGlobalState) {
              setTimeout(function () {
                if (!isolateCalled) {
                  fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
                }
              }, 1);
              return new MobXGlobals();
            } else if (global.__mobxGlobals) {
              global.__mobxInstanceCount += 1;
              if (!global.__mobxGlobals.UNCHANGED) global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible

              return global.__mobxGlobals;
            } else {
              global.__mobxInstanceCount = 1;
              return global.__mobxGlobals = new MobXGlobals();
            }
          }();

          function isolateGlobalState() {
            if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) fail("isolateGlobalState should be called before MobX is running any reactions");
            isolateCalled = true;

            if (canMergeGlobalState) {
              if (--getGlobal().__mobxInstanceCount === 0) getGlobal().__mobxGlobals = undefined;
              globalState = new MobXGlobals();
            }
          }

          function getGlobalState() {
            return globalState;
          }
          /**
           * For testing purposes only; this will break the internal state of existing observables,
           * but can be used to get back at a stable state after throwing errors
           */


          function resetGlobalState() {
            var defaultGlobals = new MobXGlobals();

            for (var key in defaultGlobals) {
              if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
            }

            globalState.allowStateChanges = !globalState.enforceActions;
          }

          function hasObservers(observable) {
            return observable.observers && observable.observers.length > 0;
          }

          function getObservers(observable) {
            return observable.observers;
          } // function invariantObservers(observable: IObservable) {
          //     const list = observable.observers
          //     const map = observable.observersIndexes
          //     const l = list.length
          //     for (let i = 0; i < l; i++) {
          //         const id = list[i].__mapid
          //         if (i) {
          //             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
          //         } else {
          //             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
          //         }
          //     }
          //     invariant(
          //         list.length === 0 || Object.keys(map).length === list.length - 1,
          //         "INTERNAL ERROR there is no junk in map"
          //     )
          // }


          function addObserver(observable, node) {
            // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
            // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
            // invariantObservers(observable);
            var l = observable.observers.length;

            if (l) {
              // because object assignment is relatively expensive, let's not store data about index 0.
              observable.observersIndexes[node.__mapid] = l;
            }

            observable.observers[l] = node;
            if (observable.lowestObserverState > node.dependenciesState) observable.lowestObserverState = node.dependenciesState; // invariantObservers(observable);
            // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
          }

          function removeObserver(observable, node) {
            // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
            // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
            // invariantObservers(observable);
            if (observable.observers.length === 1) {
              // deleting last observer
              observable.observers.length = 0;
              queueForUnobservation(observable);
            } else {
              // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
              var list = observable.observers;
              var map = observable.observersIndexes;
              var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes

              if (filler !== node) {
                // otherwise node was the last element, which already got removed from array
                var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.

                if (index) {
                  // map store all indexes but 0, see comment in `addObserver`
                  map[filler.__mapid] = index;
                } else {
                  delete map[filler.__mapid];
                }

                list[index] = filler;
              }

              delete map[node.__mapid];
            } // invariantObservers(observable);
            // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");

          }

          function queueForUnobservation(observable) {
            if (observable.isPendingUnobservation === false) {
              // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
              observable.isPendingUnobservation = true;
              globalState.pendingUnobservations.push(observable);
            }
          }
          /**
           * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
           * During a batch `onBecomeUnobserved` will be called at most once per observable.
           * Avoids unnecessary recalculations.
           */


          function startBatch() {
            globalState.inBatch++;
          }

          function endBatch() {
            if (--globalState.inBatch === 0) {
              runReactions(); // the batch is actually about to finish, all unobserving should happen here.

              var list = globalState.pendingUnobservations;

              for (var i = 0; i < list.length; i++) {
                var observable = list[i];
                observable.isPendingUnobservation = false;

                if (observable.observers.length === 0) {
                  if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                  }

                  if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observabe of another, etc..
                    observable.suspend();
                  }
                }
              }

              globalState.pendingUnobservations = [];
            }
          }

          function reportObserved(observable) {
            checkIfStateReadsAreAllowed(observable);
            var derivation = globalState.trackingDerivation;

            if (derivation !== null) {
              /**
               * Simple optimization, give each derivation run an unique id (runId)
               * Check if last time this observable was accessed the same runId is used
               * if this is the case, the relation is already known
               */
              if (derivation.runId !== observable.lastAccessedBy) {
                observable.lastAccessedBy = derivation.runId;
                derivation.newObserving[derivation.unboundDepsCount++] = observable;

                if (!observable.isBeingObserved) {
                  observable.isBeingObserved = true;
                  observable.onBecomeObserved();
                }
              }

              return true;
            } else if (observable.observers.length === 0 && globalState.inBatch > 0) {
              queueForUnobservation(observable);
            }

            return false;
          } // function invariantLOS(observable: IObservable, msg: string) {
          //     // it's expensive so better not run it in produciton. but temporarily helpful for testing
          //     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
          //     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
          //     throw new Error(
          //         "lowestObserverState is wrong for " +
          //             msg +
          //             " because " +
          //             min +
          //             " < " +
          //             observable.lowestObserverState
          //     )
          // }

          /**
           * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
           * It will propagate changes to observers from previous run
           * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
           * Hopefully self reruning autoruns aren't a feature people should depend on
           * Also most basic use cases should be ok
           */
          // Called by Atom when its value changes


          function propagateChanged(observable) {
            // invariantLOS(observable, "changed start");
            if (observable.lowestObserverState === IDerivationState.STALE) return;
            observable.lowestObserverState = IDerivationState.STALE;
            var observers = observable.observers;
            var i = observers.length;

            while (i--) {
              var d = observers[i];

              if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
                if (d.isTracing !== TraceMode.NONE) {
                  logTraceInfo(d, observable);
                }

                d.onBecomeStale();
              }

              d.dependenciesState = IDerivationState.STALE;
            } // invariantLOS(observable, "changed end");

          } // Called by ComputedValue when it recalculate and its value changed


          function propagateChangeConfirmed(observable) {
            // invariantLOS(observable, "confirmed start");
            if (observable.lowestObserverState === IDerivationState.STALE) return;
            observable.lowestObserverState = IDerivationState.STALE;
            var observers = observable.observers;
            var i = observers.length;

            while (i--) {
              var d = observers[i];
              if (d.dependenciesState === IDerivationState.POSSIBLY_STALE) d.dependenciesState = IDerivationState.STALE;else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
              ) observable.lowestObserverState = IDerivationState.UP_TO_DATE;
            } // invariantLOS(observable, "confirmed end");

          } // Used by computed when its dependency changed, but we don't wan't to immediately recompute.


          function propagateMaybeChanged(observable) {
            // invariantLOS(observable, "maybe start");
            if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE) return;
            observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
            var observers = observable.observers;
            var i = observers.length;

            while (i--) {
              var d = observers[i];

              if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
                d.dependenciesState = IDerivationState.POSSIBLY_STALE;

                if (d.isTracing !== TraceMode.NONE) {
                  logTraceInfo(d, observable);
                }

                d.onBecomeStale();
              }
            } // invariantLOS(observable, "maybe end");

          }

          function logTraceInfo(derivation, observable) {
            console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");

            if (derivation.isTracing === TraceMode.BREAK) {
              var lines = [];
              printDepTree(getDependencyTree(derivation), lines, 1); // prettier-ignore

              new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
            }
          }

          function printDepTree(tree, lines, depth) {
            if (lines.length >= 1000) {
              lines.push("(and many more)");
              return;
            }

            lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)

            if (tree.dependencies) tree.dependencies.forEach(function (child) {
              return printDepTree(child, lines, depth + 1);
            });
          }

          var Reaction =
          /** @class */
          function () {
            function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
              if (name === void 0) {
                name = "Reaction@" + getNextId();
              }

              if (requiresObservable === void 0) {
                requiresObservable = false;
              }

              this.name = name;
              this.onInvalidate = onInvalidate;
              this.errorHandler = errorHandler;
              this.requiresObservable = requiresObservable;
              this.observing = []; // nodes we are looking at. Our value depends on these nodes

              this.newObserving = [];
              this.dependenciesState = IDerivationState.NOT_TRACKING;
              this.diffValue = 0;
              this.runId = 0;
              this.unboundDepsCount = 0;
              this.__mapid = "#" + getNextId();
              this.isDisposed = false;
              this._isScheduled = false;
              this._isTrackPending = false;
              this._isRunning = false;
              this.isTracing = TraceMode.NONE;
            }

            Reaction.prototype.onBecomeStale = function () {
              this.schedule();
            };

            Reaction.prototype.schedule = function () {
              if (!this._isScheduled) {
                this._isScheduled = true;
                globalState.pendingReactions.push(this);
                runReactions();
              }
            };

            Reaction.prototype.isScheduled = function () {
              return this._isScheduled;
            };
            /**
             * internal, use schedule() if you intend to kick off a reaction
             */


            Reaction.prototype.runReaction = function () {
              if (!this.isDisposed) {
                startBatch();
                this._isScheduled = false;

                if (shouldCompute(this)) {
                  this._isTrackPending = true;

                  try {
                    this.onInvalidate();

                    if (this._isTrackPending && isSpyEnabled()) {
                      // onInvalidate didn't trigger track right away..
                      spyReport({
                        name: this.name,
                        type: "scheduled-reaction"
                      });
                    }
                  } catch (e) {
                    this.reportExceptionInDerivation(e);
                  }
                }

                endBatch();
              }
            };

            Reaction.prototype.track = function (fn) {
              startBatch();
              var notify = isSpyEnabled();
              var startTime;

              if (notify) {
                startTime = Date.now();
                spyReportStart({
                  name: this.name,
                  type: "reaction"
                });
              }

              this._isRunning = true;
              var result = trackDerivedFunction(this, fn, undefined);
              this._isRunning = false;
              this._isTrackPending = false;

              if (this.isDisposed) {
                // disposed during last run. Clean up everything that was bound after the dispose call.
                clearObserving(this);
              }

              if (isCaughtException(result)) this.reportExceptionInDerivation(result.cause);

              if (notify) {
                spyReportEnd({
                  time: Date.now() - startTime
                });
              }

              endBatch();
            };

            Reaction.prototype.reportExceptionInDerivation = function (error) {
              var _this = this;

              if (this.errorHandler) {
                this.errorHandler(error, this);
                return;
              }

              if (globalState.disableErrorBoundaries) throw error;
              var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";

              if (globalState.suppressReactionErrors) {
                console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
              } else {
                console.error(message, error);
                /** If debugging brought you here, please, read the above message :-). Tnx! */
              }

              if (isSpyEnabled()) {
                spyReport({
                  type: "error",
                  name: this.name,
                  message: message,
                  error: "" + error
                });
              }

              globalState.globalReactionErrorHandlers.forEach(function (f) {
                return f(error, _this);
              });
            };

            Reaction.prototype.dispose = function () {
              if (!this.isDisposed) {
                this.isDisposed = true;

                if (!this._isRunning) {
                  // if disposed while running, clean up later. Maybe not optimal, but rare case
                  startBatch();
                  clearObserving(this);
                  endBatch();
                }
              }
            };

            Reaction.prototype.getDisposer = function () {
              var r = this.dispose.bind(this);
              r.$mobx = this;
              return r;
            };

            Reaction.prototype.toString = function () {
              return "Reaction[" + this.name + "]";
            };

            Reaction.prototype.trace = function (enterBreakPoint) {
              if (enterBreakPoint === void 0) {
                enterBreakPoint = false;
              }

              trace(this, enterBreakPoint);
            };

            return Reaction;
          }();

          function onReactionError(handler) {
            globalState.globalReactionErrorHandlers.push(handler);
            return function () {
              var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
              if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
            };
          }
          /**
           * Magic number alert!
           * Defines within how many times a reaction is allowed to re-trigger itself
           * until it is assumed that this is gonna be a never ending loop...
           */


          var MAX_REACTION_ITERATIONS = 100;

          var reactionScheduler = function reactionScheduler(f) {
            return f();
          };

          function runReactions() {
            // Trampolining, if runReactions are already running, new reactions will be picked up
            if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
            reactionScheduler(runReactionsHelper);
          }

          function runReactionsHelper() {
            globalState.isRunningReactions = true;
            var allReactions = globalState.pendingReactions;
            var iterations = 0; // While running reactions, new reactions might be triggered.
            // Hence we work with two variables and check whether
            // we converge to no remaining reactions after a while.

            while (allReactions.length > 0) {
              if (++iterations === MAX_REACTION_ITERATIONS) {
                console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
                allReactions.splice(0); // clear reactions
              }

              var remainingReactions = allReactions.splice(0);

              for (var i = 0, l = remainingReactions.length; i < l; i++) {
                remainingReactions[i].runReaction();
              }
            }

            globalState.isRunningReactions = false;
          }

          var isReaction = createInstanceofPredicate("Reaction", Reaction);

          function setReactionScheduler(fn) {
            var baseScheduler = reactionScheduler;

            reactionScheduler = function reactionScheduler(f) {
              return fn(function () {
                return baseScheduler(f);
              });
            };
          }

          function isSpyEnabled() {
            return !!globalState.spyListeners.length;
          }

          function spyReport(event) {
            if (!globalState.spyListeners.length) return;
            var listeners = globalState.spyListeners;

            for (var i = 0, l = listeners.length; i < l; i++) {
              listeners[i](event);
            }
          }

          function spyReportStart(event) {
            var change = _assign(_assign({}, event), {
              spyReportStart: true
            });

            spyReport(change);
          }

          var END_EVENT = {
            spyReportEnd: true
          };

          function spyReportEnd(change) {
            if (change) spyReport(_assign(_assign({}, change), {
              spyReportEnd: true
            }));else spyReport(END_EVENT);
          }

          function spy(listener) {
            globalState.spyListeners.push(listener);
            return once(function () {
              globalState.spyListeners = globalState.spyListeners.filter(function (l) {
                return l !== listener;
              });
            });
          }

          function dontReassignFields() {
            fail(false && false);
          }

          function namedActionDecorator(name) {
            return function (target, prop, descriptor) {
              if (descriptor) {
                if (false) {} // babel / typescript
                // @action method() { }


                if (descriptor.value) {
                  // typescript
                  return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)

                  };
                } // babel only: @action method = () => {}


                var initializer_1 = descriptor.initializer;
                return {
                  enumerable: false,
                  configurable: true,
                  writable: true,
                  initializer: function initializer() {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                  }
                };
              } // bound instance methods


              return actionFieldDecorator(name).apply(this, arguments);
            };
          }

          function actionFieldDecorator(name) {
            // Simple property that writes on first invocation to the current instance
            return function (target, prop, descriptor) {
              Object.defineProperty(target, prop, {
                configurable: true,
                enumerable: false,
                get: function get() {
                  return undefined;
                },
                set: function set(value) {
                  addHiddenProp(this, prop, action(name, value));
                }
              });
            };
          }

          function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
            if (applyToInstance === true) {
              defineBoundAction(target, propertyName, descriptor.value);
              return null;
            }

            if (descriptor) {
              // if (descriptor.value)
              // Typescript / Babel: @action.bound method() { }
              // also: babel @action.bound method = () => {}
              return {
                configurable: true,
                enumerable: false,
                get: function get() {
                  defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                  return this[propertyName];
                },
                set: dontReassignFields
              };
            } // field decorator Typescript @action.bound method = () => {}


            return {
              enumerable: false,
              configurable: true,
              set: function set(v) {
                defineBoundAction(this, propertyName, v);
              },
              get: function get() {
                return undefined;
              }
            };
          }

          var action = function action(arg1, arg2, arg3, arg4) {
            // action(fn() {})
            if (arguments.length === 1 && typeof arg1 === "function") return createAction(arg1.name || "<unnamed action>", arg1); // action("name", fn() {})

            if (arguments.length === 2 && typeof arg2 === "function") return createAction(arg1, arg2); // @action("name") fn() {}

            if (arguments.length === 1 && typeof arg1 === "string") return namedActionDecorator(arg1); // @action fn() {}

            if (arg4 === true) {
              // apply to instance immediately
              arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
            } else {
              return namedActionDecorator(arg2).apply(null, arguments);
            }
          };

          action.bound = boundActionDecorator;

          function runInAction(arg1, arg2) {
            // TODO: deprecate?
            var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
            var fn = typeof arg1 === "function" ? arg1 : arg2;

            if (false) {}

            return executeAction(actionName, fn, this, undefined);
          }

          function isAction(thing) {
            return typeof thing === "function" && thing.isMobxAction === true;
          }

          function defineBoundAction(target, propertyName, fn) {
            addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
          }
          /**
           * Creates a named reactive view and keeps it alive, so that the view is always
           * updated if one of the dependencies changes, even when the view is not further used by something else.
           * @param view The reactive view
           * @returns disposer function, which can be used to stop the view from being updated in the future.
           */


          function autorun(view, opts) {
            if (opts === void 0) {
              opts = EMPTY_OBJECT;
            }

            if (false) {}

            var name = opts && opts.name || view.name || "Autorun@" + getNextId();
            var runSync = !opts.scheduler && !opts.delay;
            var reaction;

            if (runSync) {
              // normal autorun
              reaction = new Reaction(name, function () {
                this.track(reactionRunner);
              }, opts.onError, opts.requiresObservable);
            } else {
              var scheduler_1 = createSchedulerFromOptions(opts); // debounced autorun

              var isScheduled_1 = false;
              reaction = new Reaction(name, function () {
                if (!isScheduled_1) {
                  isScheduled_1 = true;
                  scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                  });
                }
              }, opts.onError, opts.requiresObservable);
            }

            function reactionRunner() {
              view(reaction);
            }

            reaction.schedule();
            return reaction.getDisposer();
          }

          var run = function run(f) {
            return f();
          };

          function createSchedulerFromOptions(opts) {
            return opts.scheduler ? opts.scheduler : opts.delay ? function (f) {
              return setTimeout(f, opts.delay);
            } : run;
          }

          function reaction(expression, effect, opts) {
            if (opts === void 0) {
              opts = EMPTY_OBJECT;
            }

            if (typeof opts === "boolean") {
              opts = {
                fireImmediately: opts
              };
              deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
            }

            if (false) {}

            var name = opts.name || "Reaction@" + getNextId();
            var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
            var runSync = !opts.scheduler && !opts.delay;
            var scheduler = createSchedulerFromOptions(opts);
            var firstTime = true;
            var isScheduled = false;
            var value;
            var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer.default;
            var r = new Reaction(name, function () {
              if (firstTime || runSync) {
                reactionRunner();
              } else if (!isScheduled) {
                isScheduled = true;
                scheduler(reactionRunner);
              }
            }, opts.onError, opts.requiresObservable);

            function reactionRunner() {
              isScheduled = false; // Q: move into reaction runner?

              if (r.isDisposed) return;
              var changed = false;
              r.track(function () {
                var nextValue = expression(r);
                changed = firstTime || !equals(value, nextValue);
                value = nextValue;
              });
              if (firstTime && opts.fireImmediately) effectAction(value, r);
              if (!firstTime && changed === true) effectAction(value, r);
              if (firstTime) firstTime = false;
            }

            r.schedule();
            return r.getDisposer();
          }

          function wrapErrorHandler(errorHandler, baseFn) {
            return function () {
              try {
                return baseFn.apply(this, arguments);
              } catch (e) {
                errorHandler.call(this, e);
              }
            };
          }

          function onBecomeObserved(thing, arg2, arg3) {
            return interceptHook("onBecomeObserved", thing, arg2, arg3);
          }

          function onBecomeUnobserved(thing, arg2, arg3) {
            return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
          }

          function interceptHook(hook, thing, arg2, arg3) {
            var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
            var cb = typeof arg3 === "function" ? arg3 : arg2;
            var orig = atom[hook];
            if (typeof orig !== "function") return fail(false && false);

            atom[hook] = function () {
              orig.call(this);
              cb.call(this);
            };

            return function () {
              atom[hook] = orig;
            };
          }

          function configure(options) {
            var enforceActions = options.enforceActions,
                computedRequiresReaction = options.computedRequiresReaction,
                computedConfigurable = options.computedConfigurable,
                disableErrorBoundaries = options.disableErrorBoundaries,
                arrayBuffer = options.arrayBuffer,
                reactionScheduler = options.reactionScheduler,
                reactionRequiresObservable = options.reactionRequiresObservable,
                observableRequiresReaction = options.observableRequiresReaction;

            if (options.isolateGlobalState === true) {
              isolateGlobalState();
            }

            if (enforceActions !== undefined) {
              if (typeof enforceActions === "boolean" || enforceActions === "strict") deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
              var ea = void 0;

              switch (enforceActions) {
                case true:
                case "observed":
                  ea = true;
                  break;

                case false:
                case "never":
                  ea = false;
                  break;

                case "strict":
                case "always":
                  ea = "strict";
                  break;

                default:
                  fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
              }

              globalState.enforceActions = ea;
              globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
            }

            if (computedRequiresReaction !== undefined) {
              globalState.computedRequiresReaction = !!computedRequiresReaction;
            }

            if (reactionRequiresObservable !== undefined) {
              globalState.reactionRequiresObservable = !!reactionRequiresObservable;
            }

            if (observableRequiresReaction !== undefined) {
              globalState.observableRequiresReaction = !!observableRequiresReaction;
              globalState.allowStateReads = !globalState.observableRequiresReaction;
            }

            if (computedConfigurable !== undefined) {
              globalState.computedConfigurable = !!computedConfigurable;
            }

            if (disableErrorBoundaries !== undefined) {
              if (disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
              globalState.disableErrorBoundaries = !!disableErrorBoundaries;
            }

            if (typeof arrayBuffer === "number") {
              reserveArrayBuffer(arrayBuffer);
            }

            if (reactionScheduler) {
              setReactionScheduler(reactionScheduler);
            }
          }

          function decorate(thing, decorators) {
            if (false) {}

            var target = typeof thing === "function" ? thing.prototype : thing;

            var _loop_1 = function _loop_1(prop) {
              var propertyDecorators = decorators[prop];

              if (!Array.isArray(propertyDecorators)) {
                propertyDecorators = [propertyDecorators];
              } // prettier-ignore


              if (false) {}

              var descriptor = Object.getOwnPropertyDescriptor(target, prop);
              var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) {
                return decorator(target, prop, accDescriptor);
              }, descriptor);
              if (newDescriptor) Object.defineProperty(target, prop, newDescriptor);
            };

            for (var prop in decorators) {
              _loop_1(prop);
            }

            return thing;
          }

          function extendShallowObservable(target, properties, decorators) {
            deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
            return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
          }

          function extendObservable(target, properties, decorators, options) {
            if (false) {
              var key;
            }

            options = asCreateObservableOptions(options);
            var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
            initializeInstance(target);
            asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props

            startBatch();

            try {
              for (var key in properties) {
                var descriptor = Object.getOwnPropertyDescriptor(properties, key);

                if (false) {}

                var decorator = decorators && key in decorators ? decorators[key] : descriptor.get ? computedDecorator : defaultDecorator;

                if (false) {}

                var resultDescriptor = decorator(target, key, descriptor, true);
                if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
                ) Object.defineProperty(target, key, resultDescriptor);
              }
            } finally {
              endBatch();
            }

            return target;
          }

          function getDependencyTree(thing, property) {
            return nodeToDependencyTree(getAtom(thing, property));
          }

          function nodeToDependencyTree(node) {
            var result = {
              name: node.name
            };
            if (node.observing && node.observing.length > 0) result.dependencies = unique(node.observing).map(nodeToDependencyTree);
            return result;
          }

          function getObserverTree(thing, property) {
            return nodeToObserverTree(getAtom(thing, property));
          }

          function nodeToObserverTree(node) {
            var result = {
              name: node.name
            };
            if (hasObservers(node)) result.observers = getObservers(node).map(nodeToObserverTree);
            return result;
          }

          var generatorId = 0;

          function FlowCancellationError() {
            this.message = "FLOW_CANCELLED";
          }

          FlowCancellationError.prototype = Object.create(Error.prototype);

          function isFlowCancellationError(error) {
            return error instanceof FlowCancellationError;
          }

          function flow(generator) {
            if (arguments.length !== 1) fail(true && "Flow expects one 1 argument and cannot be used as decorator");
            var name = generator.name || "<unnamed flow>"; // Implementation based on https://github.com/tj/co/blob/master/index.js

            return function () {
              var ctx = this;
              var args = arguments;
              var runId = ++generatorId;
              var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
              var rejector;
              var pendingPromise = undefined;
              var res = new Promise(function (resolve, reject) {
                var stepId = 0;
                rejector = reject;

                function onFulfilled(res) {
                  pendingPromise = undefined;
                  var ret;

                  try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                  } catch (e) {
                    return reject(e);
                  }

                  next(ret);
                }

                function onRejected(err) {
                  pendingPromise = undefined;
                  var ret;

                  try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                  } catch (e) {
                    return reject(e);
                  }

                  next(ret);
                }

                function next(ret) {
                  if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                  }

                  if (ret.done) return resolve(ret.value);
                  pendingPromise = Promise.resolve(ret.value);
                  return pendingPromise.then(onFulfilled, onRejected);
                }

                onFulfilled(undefined); // kick off the process
              });
              res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
                try {
                  if (pendingPromise) cancelPromise(pendingPromise); // Finally block can return (or yield) stuff..

                  var res_1 = gen.return(); // eat anything that promise would do, it's cancelled!

                  var yieldedPromise = Promise.resolve(res_1.value);
                  yieldedPromise.then(noop, noop);
                  cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                  // reject our original promise

                  rejector(new FlowCancellationError());
                } catch (e) {
                  rejector(e); // there could be a throwing finally block
                }
              });
              return res;
            };
          }

          function cancelPromise(promise) {
            if (typeof promise.cancel === "function") promise.cancel();
          }

          function interceptReads(thing, propOrHandler, handler) {
            var target;

            if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
              target = getAdministration(thing);
            } else if (isObservableObject(thing)) {
              if (typeof propOrHandler !== "string") return fail(false && false);
              target = getAdministration(thing, propOrHandler);
            } else {
              return fail(false && false);
            }

            if (target.dehancer !== undefined) return fail(false && false);
            target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
            return function () {
              target.dehancer = undefined;
            };
          }

          function intercept(thing, propOrHandler, handler) {
            if (typeof handler === "function") return interceptProperty(thing, propOrHandler, handler);else return interceptInterceptable(thing, propOrHandler);
          }

          function interceptInterceptable(thing, handler) {
            return getAdministration(thing).intercept(handler);
          }

          function interceptProperty(thing, property, handler) {
            return getAdministration(thing, property).intercept(handler);
          }

          function _isComputed(value, property) {
            if (value === null || value === undefined) return false;

            if (property !== undefined) {
              if (isObservableObject(value) === false) return false;
              if (!value.$mobx.values[property]) return false;
              var atom = getAtom(value, property);
              return isComputedValue(atom);
            }

            return isComputedValue(value);
          }

          function isComputed(value) {
            if (arguments.length > 1) return fail(false && false);
            return _isComputed(value);
          }

          function isComputedProp(value, propName) {
            if (typeof propName !== "string") return fail(false && false);
            return _isComputed(value, propName);
          }

          function _isObservable(value, property) {
            if (value === null || value === undefined) return false;

            if (property !== undefined) {
              if (false) {}

              if (isObservableObject(value)) {
                var o = value.$mobx;
                return o.values && !!o.values[property];
              }

              return false;
            } // For first check, see #701


            return isObservableObject(value) || !!value.$mobx || isAtom(value) || isReaction(value) || isComputedValue(value);
          }

          function isObservable(value) {
            if (arguments.length !== 1) fail(false && false);
            return _isObservable(value);
          }

          function isObservableProp(value, propName) {
            if (typeof propName !== "string") return fail(false && false);
            return _isObservable(value, propName);
          }

          function keys(obj) {
            if (isObservableObject(obj)) {
              return obj.$mobx.getKeys();
            }

            if (isObservableMap(obj)) {
              return obj._keys.slice();
            }

            if (isObservableSet(obj)) {
              return iteratorToArray(obj.keys());
            }

            if (isObservableArray(obj)) {
              return obj.map(function (_, index) {
                return index;
              });
            }

            return fail(false && false);
          }

          function values(obj) {
            if (isObservableObject(obj)) {
              return keys(obj).map(function (key) {
                return obj[key];
              });
            }

            if (isObservableMap(obj)) {
              return keys(obj).map(function (key) {
                return obj.get(key);
              });
            }

            if (isObservableSet(obj)) {
              return iteratorToArray(obj.values());
            }

            if (isObservableArray(obj)) {
              return obj.slice();
            }

            return fail(false && false);
          }

          function entries(obj) {
            if (isObservableObject(obj)) {
              return keys(obj).map(function (key) {
                return [key, obj[key]];
              });
            }

            if (isObservableMap(obj)) {
              return keys(obj).map(function (key) {
                return [key, obj.get(key)];
              });
            }

            if (isObservableSet(obj)) {
              return iteratorToArray(obj.entries());
            }

            if (isObservableArray(obj)) {
              return obj.map(function (key, index) {
                return [index, key];
              });
            }

            return fail(false && false);
          }

          function set(obj, key, value) {
            if (arguments.length === 2 && !isObservableSet(obj)) {
              startBatch();
              var values_1 = key;

              try {
                for (var key_1 in values_1) {
                  set(obj, key_1, values_1[key_1]);
                }
              } finally {
                endBatch();
              }

              return;
            }

            if (isObservableObject(obj)) {
              var adm = obj.$mobx;
              var existingObservable = adm.values[key];

              if (existingObservable) {
                adm.write(obj, key, value);
              } else {
                defineObservableProperty(obj, key, value, adm.defaultEnhancer);
              }
            } else if (isObservableMap(obj)) {
              obj.set(key, value);
            } else if (isObservableSet(obj)) {
              obj.add(key);
            } else if (isObservableArray(obj)) {
              if (typeof key !== "number") key = parseInt(key, 10);
              invariant(key >= 0, "Not a valid index: '" + key + "'");
              startBatch();
              if (key >= obj.length) obj.length = key + 1;
              obj[key] = value;
              endBatch();
            } else {
              return fail(false && false);
            }
          }

          function remove(obj, key) {
            if (isObservableObject(obj)) {
              obj.$mobx.remove(key);
            } else if (isObservableMap(obj)) {
              obj.delete(key);
            } else if (isObservableSet(obj)) {
              obj.delete(key);
            } else if (isObservableArray(obj)) {
              if (typeof key !== "number") key = parseInt(key, 10);
              invariant(key >= 0, "Not a valid index: '" + key + "'");
              obj.splice(key, 1);
            } else {
              return fail(false && false);
            }
          }

          function has(obj, key) {
            if (isObservableObject(obj)) {
              // return keys(obj).indexOf(key) >= 0
              var adm = getAdministration(obj);
              adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence

              return !!adm.values[key];
            } else if (isObservableMap(obj)) {
              return obj.has(key);
            } else if (isObservableSet(obj)) {
              return obj.has(key);
            } else if (isObservableArray(obj)) {
              return key >= 0 && key < obj.length;
            } else {
              return fail(false && false);
            }
          }

          function get(obj, key) {
            if (!has(obj, key)) return undefined;

            if (isObservableObject(obj)) {
              return obj[key];
            } else if (isObservableMap(obj)) {
              return obj.get(key);
            } else if (isObservableArray(obj)) {
              return obj[key];
            } else {
              return fail(false && false);
            }
          }

          function observe(thing, propOrCb, cbOrFire, fireImmediately) {
            if (typeof cbOrFire === "function") return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);else return observeObservable(thing, propOrCb, cbOrFire);
          }

          function observeObservable(thing, listener, fireImmediately) {
            return getAdministration(thing).observe(listener, fireImmediately);
          }

          function observeObservableProperty(thing, property, listener, fireImmediately) {
            return getAdministration(thing, property).observe(listener, fireImmediately);
          }

          var defaultOptions = {
            detectCycles: true,
            exportMapsAsObjects: true,
            recurseEverything: false
          };

          function cache(map, key, value, options) {
            if (options.detectCycles) map.set(key, value);
            return value;
          }

          function toJSHelper(source, options, __alreadySeen) {
            if (!options.recurseEverything && !isObservable(source)) return source;
            if (typeof source !== "object") return source; // Directly return null if source is null

            if (source === null) return null; // Directly return the Date object itself if contained in the observable

            if (source instanceof Date) return source;
            if (isObservableValue(source)) return toJSHelper(source.get(), options, __alreadySeen); // make sure we track the keys of the object

            if (isObservable(source)) keys(source);
            var detectCycles = options.detectCycles === true;

            if (detectCycles && source !== null && __alreadySeen.has(source)) {
              return __alreadySeen.get(source);
            }

            if (isObservableArray(source) || Array.isArray(source)) {
              var res_1 = cache(__alreadySeen, source, [], options);
              var toAdd = source.map(function (value) {
                return toJSHelper(value, options, __alreadySeen);
              });
              res_1.length = toAdd.length;

              for (var i = 0, l = toAdd.length; i < l; i++) {
                res_1[i] = toAdd[i];
              }

              return res_1;
            }

            if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
              if (options.exportMapsAsObjects === false) {
                var res_2 = cache(__alreadySeen, source, new Set(), options);
                source.forEach(function (value) {
                  res_2.add(toJSHelper(value, options, __alreadySeen));
                });
                return res_2;
              } else {
                var res_3 = cache(__alreadySeen, source, [], options);
                source.forEach(function (value) {
                  res_3.push(toJSHelper(value, options, __alreadySeen));
                });
                return res_3;
              }
            }

            if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
              if (options.exportMapsAsObjects === false) {
                var res_4 = cache(__alreadySeen, source, new Map(), options);
                source.forEach(function (value, key) {
                  res_4.set(key, toJSHelper(value, options, __alreadySeen));
                });
                return res_4;
              } else {
                var res_5 = cache(__alreadySeen, source, {}, options);
                source.forEach(function (value, key) {
                  res_5[key] = toJSHelper(value, options, __alreadySeen);
                });
                return res_5;
              }
            } // Fallback to the situation that source is an ObservableObject or a plain object


            var res = cache(__alreadySeen, source, {}, options);

            for (var key in source) {
              res[key] = toJSHelper(source[key], options, __alreadySeen);
            }

            return res;
          }

          function toJS(source, options) {
            // backward compatibility
            if (typeof options === "boolean") options = {
              detectCycles: options
            };
            if (!options) options = defaultOptions;
            options.detectCycles = options.detectCycles === undefined ? options.recurseEverything === true : options.detectCycles === true;

            var __alreadySeen;

            if (options.detectCycles) __alreadySeen = new Map();
            return toJSHelper(source, options, __alreadySeen);
          }

          function trace() {
            var args = [];

            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }

            var enterBreakPoint = false;
            if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
            var derivation = getAtomFromArgs(args);

            if (!derivation) {
              return fail(false && false);
            }

            if (derivation.isTracing === TraceMode.NONE) {
              console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
            }

            derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
          }

          function getAtomFromArgs(args) {
            switch (args.length) {
              case 0:
                return globalState.trackingDerivation;

              case 1:
                return getAtom(args[0]);

              case 2:
                return getAtom(args[0], args[1]);
            }
          }
          /**
           * During a transaction no views are updated until the end of the transaction.
           * The transaction will be run synchronously nonetheless.
           *
           * @param action a function that updates some reactive state
           * @returns any value that was returned by the 'action' parameter.
           */


          function transaction(action, thisArg) {
            if (thisArg === void 0) {
              thisArg = undefined;
            }

            startBatch();

            try {
              return action.apply(thisArg);
            } finally {
              endBatch();
            }
          }

          function when(predicate, arg1, arg2) {
            if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
            return _when(predicate, arg1, arg2 || {});
          }

          function _when(predicate, effect, opts) {
            var timeoutHandle;

            if (typeof opts.timeout === "number") {
              timeoutHandle = setTimeout(function () {
                if (!disposer.$mobx.isDisposed) {
                  disposer();
                  var error = new Error("WHEN_TIMEOUT");
                  if (opts.onError) opts.onError(error);else throw error;
                }
              }, opts.timeout);
            }

            opts.name = opts.name || "When@" + getNextId();
            var effectAction = createAction(opts.name + "-effect", effect);
            var disposer = autorun(function (r) {
              if (predicate()) {
                r.dispose();
                if (timeoutHandle) clearTimeout(timeoutHandle);
                effectAction();
              }
            }, opts);
            return disposer;
          }

          function whenPromise(predicate, opts) {
            if (false) {}

            var cancel;
            var res = new Promise(function (resolve, reject) {
              var disposer = _when(predicate, resolve, _assign(_assign({}, opts), {
                onError: reject
              }));

              cancel = function cancel() {
                disposer();
                reject("WHEN_CANCELLED");
              };
            });
            res.cancel = cancel;
            return res;
          }

          function hasInterceptors(interceptable) {
            return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
          }

          function registerInterceptor(interceptable, handler) {
            var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
            interceptors.push(handler);
            return once(function () {
              var idx = interceptors.indexOf(handler);
              if (idx !== -1) interceptors.splice(idx, 1);
            });
          }

          function interceptChange(interceptable, change) {
            var prevU = untrackedStart();

            try {
              var interceptors = interceptable.interceptors;
              if (interceptors) for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change) break;
              }
              return change;
            } finally {
              untrackedEnd(prevU);
            }
          }

          function hasListeners(listenable) {
            return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
          }

          function registerListener(listenable, handler) {
            var listeners = listenable.changeListeners || (listenable.changeListeners = []);
            listeners.push(handler);
            return once(function () {
              var idx = listeners.indexOf(handler);
              if (idx !== -1) listeners.splice(idx, 1);
            });
          }

          function notifyListeners(listenable, change) {
            var prevU = untrackedStart();
            var listeners = listenable.changeListeners;
            if (!listeners) return;
            listeners = listeners.slice();

            for (var i = 0, l = listeners.length; i < l; i++) {
              listeners[i](change);
            }

            untrackedEnd(prevU);
          }

          var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
          // Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364

          var safariPrototypeSetterInheritanceBug = function () {
            var v = false;
            var p = {};
            Object.defineProperty(p, "0", {
              set: function set() {
                v = true;
              }
            });
            Object.create(p)["0"] = 1;
            return v === false;
          }();
          /**
           * This array buffer contains two lists of properties, so that all arrays
           * can recycle their property definitions, which significantly improves performance of creating
           * properties on the fly.
           */


          var OBSERVABLE_ARRAY_BUFFER_SIZE = 0; // Typescript workaround to make sure ObservableArray extends Array

          var StubArray =
          /** @class */
          function () {
            function StubArray() {}

            return StubArray;
          }();

          function inherit(ctor, proto) {
            if (typeof Object["setPrototypeOf"] !== "undefined") {
              Object["setPrototypeOf"](ctor.prototype, proto);
            } else if (typeof ctor.prototype.__proto__ !== "undefined") {
              ctor.prototype.__proto__ = proto;
            } else {
              ctor["prototype"] = proto;
            }
          }

          inherit(StubArray, Array.prototype); // Weex freeze Array.prototype
          // Make them writeable and configurable in prototype chain
          // https://github.com/alibaba/weex/pull/1529

          if (Object.isFrozen(Array)) {
            ["constructor", "push", "shift", "concat", "pop", "unshift", "replace", "find", "findIndex", "splice", "reverse", "sort"].forEach(function (key) {
              Object.defineProperty(StubArray.prototype, key, {
                configurable: true,
                writable: true,
                value: Array.prototype[key]
              });
            });
          }

          var ObservableArrayAdministration =
          /** @class */
          function () {
            function ObservableArrayAdministration(name, enhancer, array, owned) {
              this.array = array;
              this.owned = owned;
              this.values = [];
              this.lastKnownLength = 0;
              this.atom = new Atom(name || "ObservableArray@" + getNextId());

              this.enhancer = function (newV, oldV) {
                return enhancer(newV, oldV, name + "[..]");
              };
            }

            ObservableArrayAdministration.prototype.dehanceValue = function (value) {
              if (this.dehancer !== undefined) return this.dehancer(value);
              return value;
            };

            ObservableArrayAdministration.prototype.dehanceValues = function (values) {
              if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
              return values;
            };

            ObservableArrayAdministration.prototype.intercept = function (handler) {
              return registerInterceptor(this, handler);
            };

            ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
              if (fireImmediately === void 0) {
                fireImmediately = false;
              }

              if (fireImmediately) {
                listener({
                  object: this.array,
                  type: "splice",
                  index: 0,
                  added: this.values.slice(),
                  addedCount: this.values.length,
                  removed: [],
                  removedCount: 0
                });
              }

              return registerListener(this, listener);
            };

            ObservableArrayAdministration.prototype.getArrayLength = function () {
              this.atom.reportObserved();
              return this.values.length;
            };

            ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
              if (typeof newLength !== "number" || newLength < 0) throw new Error("[mobx.array] Out of range: " + newLength);
              var currentLength = this.values.length;
              if (newLength === currentLength) return;else if (newLength > currentLength) {
                var newItems = new Array(newLength - currentLength);

                for (var i = 0; i < newLength - currentLength; i++) {
                  newItems[i] = undefined;
                } // No Array.fill everywhere...


                this.spliceWithArray(currentLength, 0, newItems);
              } else this.spliceWithArray(newLength, currentLength - newLength);
            }; // adds / removes the necessary numeric properties to this object


            ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
              if (oldLength !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
              this.lastKnownLength += delta;
              if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE) reserveArrayBuffer(oldLength + delta + 1);
            };

            ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
              var _this = this;

              checkIfStateModificationsAreAllowed(this.atom);
              var length = this.values.length;
              if (index === undefined) index = 0;else if (index > length) index = length;else if (index < 0) index = Math.max(0, length + index);
              if (arguments.length === 1) deleteCount = length - index;else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
              if (newItems === undefined) newItems = EMPTY_ARRAY;

              if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                  object: this.array,
                  type: "splice",
                  index: index,
                  removedCount: deleteCount,
                  added: newItems
                });
                if (!change) return EMPTY_ARRAY;
                deleteCount = change.removedCount;
                newItems = change.added;
              }

              newItems = newItems.length === 0 ? newItems : newItems.map(function (v) {
                return _this.enhancer(v, undefined);
              });
              var lengthDelta = newItems.length - deleteCount;
              this.updateArrayLength(length, lengthDelta); // create or remove new entries

              var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
              if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice(index, newItems, res);
              return this.dehanceValues(res);
            };

            ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
              var _a;

              if (newItems.length < MAX_SPLICE_SIZE) {
                return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
              } else {
                var res = this.values.slice(index, index + deleteCount);
                this.values = this.values.slice(0, index).concat(newItems, this.values.slice(index + deleteCount));
                return res;
              }
            };

            ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
              var notifySpy = !this.owned && isSpyEnabled();
              var notify = hasListeners(this);
              var change = notify || notifySpy ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
              } : null;
              if (notifySpy) spyReportStart(_assign(_assign({}, change), {
                name: this.atom.name
              }));
              this.atom.reportChanged();
              if (notify) notifyListeners(this, change);
              if (notifySpy) spyReportEnd();
            };

            ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
              var notifySpy = !this.owned && isSpyEnabled();
              var notify = hasListeners(this);
              var change = notify || notifySpy ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
              } : null;
              if (notifySpy) spyReportStart(_assign(_assign({}, change), {
                name: this.atom.name
              }));
              this.atom.reportChanged(); // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe

              if (notify) notifyListeners(this, change);
              if (notifySpy) spyReportEnd();
            };

            return ObservableArrayAdministration;
          }();

          var ObservableArray =
          /** @class */
          function (_super) {
            __extends(ObservableArray, _super);

            function ObservableArray(initialValues, enhancer, name, owned) {
              if (name === void 0) {
                name = "ObservableArray@" + getNextId();
              }

              if (owned === void 0) {
                owned = false;
              }

              var _this = _super.call(this) || this;

              var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
              addHiddenFinalProp(_this, "$mobx", adm);

              if (initialValues && initialValues.length) {
                var prev = allowStateChangesStart(true);

                _this.spliceWithArray(0, 0, initialValues);

                allowStateChangesEnd(prev);
              }

              if (safariPrototypeSetterInheritanceBug) {
                // Seems that Safari won't use numeric prototype setter untill any * numeric property is
                // defined on the instance. After that it works fine, even if this property is deleted.
                Object.defineProperty(adm.array, "0", ENTRY_0);
              }

              return _this;
            }

            ObservableArray.prototype.intercept = function (handler) {
              return this.$mobx.intercept(handler);
            };

            ObservableArray.prototype.observe = function (listener, fireImmediately) {
              if (fireImmediately === void 0) {
                fireImmediately = false;
              }

              return this.$mobx.observe(listener, fireImmediately);
            };

            ObservableArray.prototype.clear = function () {
              return this.splice(0);
            };

            ObservableArray.prototype.concat = function () {
              var arrays = [];

              for (var _i = 0; _i < arguments.length; _i++) {
                arrays[_i] = arguments[_i];
              }

              this.$mobx.atom.reportObserved();
              return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) {
                return isObservableArray(a) ? a.peek() : a;
              }));
            };

            ObservableArray.prototype.replace = function (newItems) {
              return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
            };
            /**
             * Converts this array back to a (shallow) javascript structure.
             * For a deep clone use mobx.toJS
             */


            ObservableArray.prototype.toJS = function () {
              return this.slice();
            };

            ObservableArray.prototype.toJSON = function () {
              // Used by JSON.stringify
              return this.toJS();
            };

            ObservableArray.prototype.peek = function () {
              this.$mobx.atom.reportObserved();
              return this.$mobx.dehanceValues(this.$mobx.values);
            }; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find


            ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
              if (fromIndex === void 0) {
                fromIndex = 0;
              }

              if (arguments.length === 3) deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
              var idx = this.findIndex.apply(this, arguments);
              return idx === -1 ? undefined : this.get(idx);
            }; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex


            ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
              if (fromIndex === void 0) {
                fromIndex = 0;
              }

              if (arguments.length === 3) deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
              var items = this.peek(),
                  l = items.length;

              for (var i = fromIndex; i < l; i++) {
                if (predicate.call(thisArg, items[i], i, this)) return i;
              }

              return -1;
            };
            /*
             * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
             * since these functions alter the inner structure of the array, the have side effects.
             * Because the have side effects, they should not be used in computed function,
             * and for that reason the do not call dependencyState.notifyObserved
             */


            ObservableArray.prototype.splice = function (index, deleteCount) {
              var newItems = [];

              for (var _i = 2; _i < arguments.length; _i++) {
                newItems[_i - 2] = arguments[_i];
              }

              switch (arguments.length) {
                case 0:
                  return [];

                case 1:
                  return this.$mobx.spliceWithArray(index);

                case 2:
                  return this.$mobx.spliceWithArray(index, deleteCount);
              }

              return this.$mobx.spliceWithArray(index, deleteCount, newItems);
            };

            ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
              return this.$mobx.spliceWithArray(index, deleteCount, newItems);
            };

            ObservableArray.prototype.push = function () {
              var items = [];

              for (var _i = 0; _i < arguments.length; _i++) {
                items[_i] = arguments[_i];
              }

              var adm = this.$mobx;
              adm.spliceWithArray(adm.values.length, 0, items);
              return adm.values.length;
            };

            ObservableArray.prototype.pop = function () {
              return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
            };

            ObservableArray.prototype.shift = function () {
              return this.splice(0, 1)[0];
            };

            ObservableArray.prototype.unshift = function () {
              var items = [];

              for (var _i = 0; _i < arguments.length; _i++) {
                items[_i] = arguments[_i];
              }

              var adm = this.$mobx;
              adm.spliceWithArray(0, 0, items);
              return adm.values.length;
            };

            ObservableArray.prototype.reverse = function () {
              // reverse by default mutates in place before returning the result
              // which makes it both a 'derivation' and a 'mutation'.
              // so we deviate from the default and just make it an dervitation
              var clone = this.slice();
              return clone.reverse.apply(clone, arguments);
            };

            ObservableArray.prototype.sort = function (compareFn) {
              // sort by default mutates in place before returning the result
              // which goes against all good practices. Let's not change the array in place!
              var clone = this.slice();
              return clone.sort.apply(clone, arguments);
            };

            ObservableArray.prototype.remove = function (value) {
              var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);

              if (idx > -1) {
                this.splice(idx, 1);
                return true;
              }

              return false;
            };

            ObservableArray.prototype.move = function (fromIndex, toIndex) {
              deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");

              function checkIndex(index) {
                if (index < 0) {
                  throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
                }

                var length = this.$mobx.values.length;

                if (index >= length) {
                  throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
                }
              }

              checkIndex.call(this, fromIndex);
              checkIndex.call(this, toIndex);

              if (fromIndex === toIndex) {
                return;
              }

              var oldItems = this.$mobx.values;
              var newItems;

              if (fromIndex < toIndex) {
                newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [oldItems[fromIndex]], oldItems.slice(toIndex + 1));
              } else {
                // toIndex < fromIndex
                newItems = __spread(oldItems.slice(0, toIndex), [oldItems[fromIndex]], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
              }

              this.replace(newItems);
            }; // See #734, in case property accessors are unreliable...


            ObservableArray.prototype.get = function (index) {
              var impl = this.$mobx;

              if (impl) {
                if (index < impl.values.length) {
                  impl.atom.reportObserved();
                  return impl.dehanceValue(impl.values[index]);
                }

                console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
              }

              return undefined;
            }; // See #734, in case property accessors are unreliable...


            ObservableArray.prototype.set = function (index, newValue) {
              var adm = this.$mobx;
              var values = adm.values;

              if (index < values.length) {
                // update at index in range
                checkIfStateModificationsAreAllowed(adm.atom);
                var oldValue = values[index];

                if (hasInterceptors(adm)) {
                  var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                  });
                  if (!change) return;
                  newValue = change.newValue;
                }

                newValue = adm.enhancer(newValue, oldValue);
                var changed = newValue !== oldValue;

                if (changed) {
                  values[index] = newValue;
                  adm.notifyArrayChildUpdate(index, newValue, oldValue);
                }
              } else if (index === values.length) {
                // add a new item
                adm.spliceWithArray(index, 0, [newValue]);
              } else {
                // out of bounds
                throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
              }
            };

            return ObservableArray;
          }(StubArray);

          declareIterator(ObservableArray.prototype, function () {
            this.$mobx.atom.reportObserved();
            var self = this;
            var nextIndex = 0;
            return makeIterable({
              next: function next() {
                return nextIndex < self.length ? {
                  value: self[nextIndex++],
                  done: false
                } : {
                  done: true,
                  value: undefined
                };
              }
            });
          });
          Object.defineProperty(ObservableArray.prototype, "length", {
            enumerable: false,
            configurable: true,
            get: function get() {
              return this.$mobx.getArrayLength();
            },
            set: function set(newLength) {
              this.$mobx.setArrayLength(newLength);
            }
          });
          addHiddenProp(ObservableArray.prototype, toStringTagSymbol(), "Array");
          ["every", "filter", "forEach", "indexOf", "join", "lastIndexOf", "map", "reduce", "reduceRight", "slice", "some", "toString", "toLocaleString"].forEach(function (funcName) {
            var baseFunc = Array.prototype[funcName];
            invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
            addHiddenProp(ObservableArray.prototype, funcName, function () {
              return baseFunc.apply(this.peek(), arguments);
            });
          });
          /**
           * We don't want those to show up in `for (const key in ar)` ...
           */

          makeNonEnumerable(ObservableArray.prototype, ["constructor", "intercept", "observe", "clear", "concat", "get", "replace", "toJS", "toJSON", "peek", "find", "findIndex", "splice", "spliceWithArray", "push", "pop", "set", "shift", "unshift", "reverse", "sort", "remove", "move", "toString", "toLocaleString"]); // See #364

          var ENTRY_0 = createArrayEntryDescriptor(0);

          function createArrayEntryDescriptor(index) {
            return {
              enumerable: false,
              configurable: false,
              get: function get() {
                return this.get(index);
              },
              set: function set(value) {
                this.set(index, value);
              }
            };
          }

          function createArrayBufferItem(index) {
            Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
          }

          function reserveArrayBuffer(max) {
            for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++) {
              createArrayBufferItem(index);
            }

            OBSERVABLE_ARRAY_BUFFER_SIZE = max;
          }

          reserveArrayBuffer(1000);
          var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);

          function isObservableArray(thing) {
            return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
          }

          var ObservableMapMarker = {};

          var ObservableMap =
          /** @class */
          function () {
            function ObservableMap(initialData, enhancer, name) {
              if (enhancer === void 0) {
                enhancer = deepEnhancer;
              }

              if (name === void 0) {
                name = "ObservableMap@" + getNextId();
              }

              this.enhancer = enhancer;
              this.name = name;
              this.$mobx = ObservableMapMarker;
              this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);

              if (typeof Map !== "function") {
                throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
              }

              this._data = new Map();
              this._hasMap = new Map();
              this.merge(initialData);
            }

            ObservableMap.prototype._has = function (key) {
              return this._data.has(key);
            };

            ObservableMap.prototype.has = function (key) {
              var _this = this;

              if (!globalState.trackingDerivation) return this._has(key);

              var entry = this._hasMap.get(key);

              if (!entry) {
                // todo: replace with atom (breaking change)
                var newEntry = entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);

                this._hasMap.set(key, newEntry);

                onBecomeUnobserved(newEntry, function () {
                  return _this._hasMap.delete(key);
                });
              }

              return entry.get();
            };

            ObservableMap.prototype.set = function (key, value) {
              var hasKey = this._has(key);

              if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                  type: hasKey ? "update" : "add",
                  object: this,
                  newValue: value,
                  name: key
                });
                if (!change) return this;
                value = change.newValue;
              }

              if (hasKey) {
                this._updateValue(key, value);
              } else {
                this._addValue(key, value);
              }

              return this;
            };

            ObservableMap.prototype.delete = function (key) {
              var _this = this;

              if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                  type: "delete",
                  object: this,
                  name: key
                });
                if (!change) return false;
              }

              if (this._has(key)) {
                var notifySpy = isSpyEnabled();
                var notify = hasListeners(this);
                var change = notify || notifySpy ? {
                  type: "delete",
                  object: this,
                  oldValue: this._data.get(key).value,
                  name: key
                } : null;
                if (notifySpy) spyReportStart(_assign(_assign({}, change), {
                  name: this.name,
                  key: key
                }));
                transaction(function () {
                  _this._keys.remove(key);

                  _this._updateHasMapEntry(key, false);

                  var observable = _this._data.get(key);

                  observable.setNewValue(undefined);

                  _this._data.delete(key);
                });
                if (notify) notifyListeners(this, change);
                if (notifySpy) spyReportEnd();
                return true;
              }

              return false;
            };

            ObservableMap.prototype._updateHasMapEntry = function (key, value) {
              var entry = this._hasMap.get(key);

              if (entry) {
                entry.setNewValue(value);
              }
            };

            ObservableMap.prototype._updateValue = function (key, newValue) {
              var observable = this._data.get(key);

              newValue = observable.prepareNewValue(newValue);

              if (newValue !== globalState.UNCHANGED) {
                var notifySpy = isSpyEnabled();
                var notify = hasListeners(this);
                var change = notify || notifySpy ? {
                  type: "update",
                  object: this,
                  oldValue: observable.value,
                  name: key,
                  newValue: newValue
                } : null;
                if (notifySpy) spyReportStart(_assign(_assign({}, change), {
                  name: this.name,
                  key: key
                }));
                observable.setNewValue(newValue);
                if (notify) notifyListeners(this, change);
                if (notifySpy) spyReportEnd();
              }
            };

            ObservableMap.prototype._addValue = function (key, newValue) {
              var _this = this;

              transaction(function () {
                var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);

                _this._data.set(key, observable);

                newValue = observable.value; // value might have been changed

                _this._updateHasMapEntry(key, true);

                _this._keys.push(key);
              });
              var notifySpy = isSpyEnabled();
              var notify = hasListeners(this);
              var change = notify || notifySpy ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
              } : null;
              if (notifySpy) spyReportStart(_assign(_assign({}, change), {
                name: this.name,
                key: key
              }));
              if (notify) notifyListeners(this, change);
              if (notifySpy) spyReportEnd();
            };

            ObservableMap.prototype.get = function (key) {
              if (this.has(key)) return this.dehanceValue(this._data.get(key).get());
              return this.dehanceValue(undefined);
            };

            ObservableMap.prototype.dehanceValue = function (value) {
              if (this.dehancer !== undefined) {
                return this.dehancer(value);
              }

              return value;
            };

            ObservableMap.prototype.keys = function () {
              return this._keys[iteratorSymbol()]();
            };

            ObservableMap.prototype.values = function () {
              var self = this;
              var nextIndex = 0;
              return makeIterable({
                next: function next() {
                  return nextIndex < self._keys.length ? {
                    value: self.get(self._keys[nextIndex++]),
                    done: false
                  } : {
                    value: undefined,
                    done: true
                  };
                }
              });
            };

            ObservableMap.prototype.entries = function () {
              var self = this;
              var nextIndex = 0;
              return makeIterable({
                next: function next() {
                  if (nextIndex < self._keys.length) {
                    var key = self._keys[nextIndex++];
                    return {
                      value: [key, self.get(key)],
                      done: false
                    };
                  }

                  return {
                    done: true
                  };
                }
              });
            };

            ObservableMap.prototype.forEach = function (callback, thisArg) {
              var _this = this;

              this._keys.forEach(function (key) {
                return callback.call(thisArg, _this.get(key), key, _this);
              });
            };
            /** Merge another object into this object, returns this. */


            ObservableMap.prototype.merge = function (other) {
              var _this = this;

              if (isObservableMap(other)) {
                other = other.toJS();
              }

              transaction(function () {
                if (isPlainObject(other)) Object.keys(other).forEach(function (key) {
                  return _this.set(key, other[key]);
                });else if (Array.isArray(other)) other.forEach(function (_a) {
                  var _b = __read(_a, 2),
                      key = _b[0],
                      value = _b[1];

                  return _this.set(key, value);
                });else if (isES6Map(other)) {
                  if (other.constructor !== Map) fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                  else other.forEach(function (value, key) {
                      return _this.set(key, value);
                    });
                } else if (other !== null && other !== undefined) fail("Cannot initialize map from " + other);
              });
              return this;
            };

            ObservableMap.prototype.clear = function () {
              var _this = this;

              transaction(function () {
                untracked(function () {
                  _this._keys.slice().forEach(function (key) {
                    return _this.delete(key);
                  });
                });
              });
            };

            ObservableMap.prototype.replace = function (values) {
              var _this = this;

              transaction(function () {
                var replacementMap = convertToMap(values);
                var oldKeys = _this._keys;
                var newKeys = Array.from(replacementMap.keys());
                var keysChanged = false;

                for (var i = 0; i < oldKeys.length; i++) {
                  var oldKey = oldKeys[i]; // key order change

                  if (oldKeys.length === newKeys.length && oldKey !== newKeys[i]) {
                    keysChanged = true;
                  } // deleted key


                  if (!replacementMap.has(oldKey)) {
                    keysChanged = true;

                    _this.delete(oldKey);
                  }
                }

                replacementMap.forEach(function (value, key) {
                  // new key
                  if (!_this._data.has(key)) {
                    keysChanged = true;
                  }

                  _this.set(key, value);
                });

                if (keysChanged) {
                  _this._keys.replace(newKeys);
                }
              });
              return this;
            };

            Object.defineProperty(ObservableMap.prototype, "size", {
              get: function get() {
                return this._keys.length;
              },
              enumerable: true,
              configurable: true
            });
            /**
             * Returns a plain object that represents this map.
             * Note that all the keys being stringified.
             * If there are duplicating keys after converting them to strings, behaviour is undetermined.
             */

            ObservableMap.prototype.toPOJO = function () {
              var _this = this;

              var res = {};

              this._keys.forEach(function (key) {
                return res[typeof key === "symbol" ? key : stringifyKey(key)] = _this.get(key);
              });

              return res;
            };
            /**
             * Returns a shallow non observable object clone of this map.
             * Note that the values migth still be observable. For a deep clone use mobx.toJS.
             */


            ObservableMap.prototype.toJS = function () {
              var _this = this;

              var res = new Map();

              this._keys.forEach(function (key) {
                return res.set(key, _this.get(key));
              });

              return res;
            };

            ObservableMap.prototype.toJSON = function () {
              // Used by JSON.stringify
              return this.toPOJO();
            };

            ObservableMap.prototype.toString = function () {
              var _this = this;

              return this.name + "[{ " + this._keys.map(function (key) {
                return stringifyKey(key) + ": " + ("" + _this.get(key));
              }).join(", ") + " }]";
            };
            /**
             * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
             * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
             * for callback details
             */


            ObservableMap.prototype.observe = function (listener, fireImmediately) {
              false && false;
              return registerListener(this, listener);
            };

            ObservableMap.prototype.intercept = function (handler) {
              return registerInterceptor(this, handler);
            };

            return ObservableMap;
          }();

          function stringifyKey(key) {
            if (key && key.toString) return key.toString();else return new String(key).toString();
          }

          declareIterator(ObservableMap.prototype, function () {
            return this.entries();
          });
          addHiddenFinalProp(ObservableMap.prototype, toStringTagSymbol(), "Map");
          /* 'var' fixes small-build issue */

          var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
          var ObservableSetMarker = {};

          var ObservableSet =
          /** @class */
          function () {
            function ObservableSet(initialData, enhancer, name) {
              if (enhancer === void 0) {
                enhancer = deepEnhancer;
              }

              if (name === void 0) {
                name = "ObservableSet@" + getNextId();
              }

              this.name = name;
              this.$mobx = ObservableSetMarker;
              this._data = new Set();
              this._atom = createAtom(this.name);

              if (typeof Set !== "function") {
                throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
              }

              this.enhancer = function (newV, oldV) {
                return enhancer(newV, oldV, name);
              };

              if (initialData) {
                this.replace(initialData);
              }
            }

            ObservableSet.prototype.dehanceValue = function (value) {
              if (this.dehancer !== undefined) {
                return this.dehancer(value);
              }

              return value;
            };

            ObservableSet.prototype.clear = function () {
              var _this = this;

              transaction(function () {
                untracked(function () {
                  _this._data.forEach(function (value) {
                    _this.delete(value);
                  });
                });
              });
            };

            ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
              var _this = this;

              this._data.forEach(function (value) {
                callbackFn.call(thisArg, value, value, _this);
              });
            };

            Object.defineProperty(ObservableSet.prototype, "size", {
              get: function get() {
                this._atom.reportObserved();

                return this._data.size;
              },
              enumerable: true,
              configurable: true
            });

            ObservableSet.prototype.add = function (value) {
              var _this = this;

              checkIfStateModificationsAreAllowed(this._atom);

              if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                  type: "add",
                  object: this,
                  newValue: value
                });
                if (!change) return this; // TODO: ideally, value = change.value would be done here, so that values can be
                // changed by interceptor. Same applies for other Set and Map api's.
              }

              if (!this.has(value)) {
                transaction(function () {
                  _this._data.add(_this.enhancer(value, undefined));

                  _this._atom.reportChanged();
                });
                var notifySpy = isSpyEnabled();
                var notify = hasListeners(this);
                var change = notify || notifySpy ? {
                  type: "add",
                  object: this,
                  newValue: value
                } : null;
                if (notifySpy && "production" !== "production") spyReportStart(change);
                if (notify) notifyListeners(this, change);
                if (notifySpy && "production" !== "production") spyReportEnd();
              }

              return this;
            };

            ObservableSet.prototype.delete = function (value) {
              var _this = this;

              if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                  type: "delete",
                  object: this,
                  oldValue: value
                });
                if (!change) return false;
              }

              if (this.has(value)) {
                var notifySpy = isSpyEnabled();
                var notify = hasListeners(this);
                var change = notify || notifySpy ? {
                  type: "delete",
                  object: this,
                  oldValue: value
                } : null;
                if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), {
                  name: this.name
                }));
                transaction(function () {
                  _this._atom.reportChanged();

                  _this._data.delete(value);
                });
                if (notify) notifyListeners(this, change);
                if (notifySpy && "production" !== "production") spyReportEnd();
                return true;
              }

              return false;
            };

            ObservableSet.prototype.has = function (value) {
              this._atom.reportObserved();

              return this._data.has(this.dehanceValue(value));
            };

            ObservableSet.prototype.entries = function () {
              var nextIndex = 0;
              var keys = iteratorToArray(this.keys());
              var values = iteratorToArray(this.values());
              return makeIterable({
                next: function next() {
                  var index = nextIndex;
                  nextIndex += 1;
                  return index < values.length ? {
                    value: [keys[index], values[index]],
                    done: false
                  } : {
                    done: true
                  };
                }
              });
            };

            ObservableSet.prototype.keys = function () {
              return this.values();
            };

            ObservableSet.prototype.values = function () {
              this._atom.reportObserved();

              var self = this;
              var nextIndex = 0;
              var observableValues;

              if (this._data.values !== undefined) {
                observableValues = iteratorToArray(this._data.values());
              } else {
                // There is no values function in IE11
                observableValues = [];

                this._data.forEach(function (e) {
                  return observableValues.push(e);
                });
              }

              return makeIterable({
                next: function next() {
                  return nextIndex < observableValues.length ? {
                    value: self.dehanceValue(observableValues[nextIndex++]),
                    done: false
                  } : {
                    done: true
                  };
                }
              });
            };

            ObservableSet.prototype.replace = function (other) {
              var _this = this;

              if (isObservableSet(other)) {
                other = other.toJS();
              }

              transaction(function () {
                if (Array.isArray(other)) {
                  _this.clear();

                  other.forEach(function (value) {
                    return _this.add(value);
                  });
                } else if (isES6Set(other)) {
                  _this.clear();

                  other.forEach(function (value) {
                    return _this.add(value);
                  });
                } else if (other !== null && other !== undefined) {
                  fail("Cannot initialize set from " + other);
                }
              });
              return this;
            };

            ObservableSet.prototype.observe = function (listener, fireImmediately) {
              // TODO 'fireImmediately' can be true?
              false && false;
              return registerListener(this, listener);
            };

            ObservableSet.prototype.intercept = function (handler) {
              return registerInterceptor(this, handler);
            };

            ObservableSet.prototype.toJS = function () {
              return new Set(this);
            };

            ObservableSet.prototype.toString = function () {
              return this.name + "[ " + iteratorToArray(this.keys()).join(", ") + " ]";
            };

            return ObservableSet;
          }();

          declareIterator(ObservableSet.prototype, function () {
            return this.values();
          });
          addHiddenFinalProp(ObservableSet.prototype, toStringTagSymbol(), "Set");
          var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);

          var ObservableObjectAdministration =
          /** @class */
          function () {
            function ObservableObjectAdministration(target, name, defaultEnhancer) {
              this.target = target;
              this.name = name;
              this.defaultEnhancer = defaultEnhancer;
              this.values = {};
            }

            ObservableObjectAdministration.prototype.read = function (owner, key) {
              if (true && this.target !== owner) {
                this.illegalAccess(owner, key);
                if (!this.values[key]) return undefined;
              }

              return this.values[key].get();
            };

            ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
              var instance = this.target;

              if (true && instance !== owner) {
                this.illegalAccess(owner, key);
              }

              var observable = this.values[key];

              if (observable instanceof ComputedValue) {
                observable.set(newValue);
                return;
              } // intercept


              if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                  type: "update",
                  object: instance,
                  name: key,
                  newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
              }

              newValue = observable.prepareNewValue(newValue); // notify spy & observers

              if (newValue !== globalState.UNCHANGED) {
                var notify = hasListeners(this);
                var notifySpy = isSpyEnabled();
                var change = notify || notifySpy ? {
                  type: "update",
                  object: instance,
                  oldValue: observable.value,
                  name: key,
                  newValue: newValue
                } : null;
                if (notifySpy) spyReportStart(_assign(_assign({}, change), {
                  name: this.name,
                  key: key
                }));
                observable.setNewValue(newValue);
                if (notify) notifyListeners(this, change);
                if (notifySpy) spyReportEnd();
              }
            };

            ObservableObjectAdministration.prototype.remove = function (key) {
              if (!this.values[key]) return;
              var target = this.target;

              if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                  object: target,
                  name: key,
                  type: "remove"
                });
                if (!change) return;
              }

              try {
                startBatch();
                var notify = hasListeners(this);
                var notifySpy = isSpyEnabled();
                var oldValue = this.values[key].get();
                if (this.keys) this.keys.remove(key);
                delete this.values[key];
                delete this.target[key];
                var change = notify || notifySpy ? {
                  type: "remove",
                  object: target,
                  oldValue: oldValue,
                  name: key
                } : null;
                if (notifySpy) spyReportStart(_assign(_assign({}, change), {
                  name: this.name,
                  key: key
                }));
                if (notify) notifyListeners(this, change);
                if (notifySpy) spyReportEnd();
              } finally {
                endBatch();
              }
            };

            ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
              /**
               * This happens if a property is accessed through the prototype chain, but the property was
               * declared directly as own property on the prototype.
               *
               * E.g.:
               * class A {
               * }
               * extendObservable(A.prototype, { x: 1 })
               *
               * classB extens A {
               * }
               * console.log(new B().x)
               *
               * It is unclear whether the property should be considered 'static' or inherited.
               * Either use `console.log(A.x)`
               * or: decorate(A, { x: observable })
               *
               * When using decorate, the property will always be redeclared as own property on the actual instance
               */
              console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
            };
            /**
             * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
             * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
             * for callback details
             */


            ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
              false && false;
              return registerListener(this, callback);
            };

            ObservableObjectAdministration.prototype.intercept = function (handler) {
              return registerInterceptor(this, handler);
            };

            ObservableObjectAdministration.prototype.getKeys = function () {
              var _this = this;

              if (this.keys === undefined) {
                this.keys = new ObservableArray(Object.keys(this.values).filter(function (key) {
                  return _this.values[key] instanceof ObservableValue;
                }), referenceEnhancer, "keys(" + this.name + ")", true);
              }

              return this.keys.slice();
            };

            return ObservableObjectAdministration;
          }();

          function asObservableObject(target, name, defaultEnhancer) {
            if (name === void 0) {
              name = "";
            }

            if (defaultEnhancer === void 0) {
              defaultEnhancer = deepEnhancer;
            }

            var adm = target.$mobx;
            if (adm) return adm;
            false && false;
            if (!isPlainObject(target)) name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
            if (!name) name = "ObservableObject@" + getNextId();
            adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
            addHiddenFinalProp(target, "$mobx", adm);
            return adm;
          }

          function defineObservableProperty(target, propName, newValue, enhancer) {
            var adm = asObservableObject(target);
            assertPropertyConfigurable(target, propName);

            if (hasInterceptors(adm)) {
              var change = interceptChange(adm, {
                object: target,
                name: propName,
                type: "add",
                newValue: newValue
              });
              if (!change) return;
              newValue = change.newValue;
            }

            var observable = adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false);
            newValue = observable.value; // observableValue might have changed it

            Object.defineProperty(target, propName, generateObservablePropConfig(propName));
            if (adm.keys) adm.keys.push(propName);
            notifyPropertyAddition(adm, target, propName, newValue);
          }

          function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
          propName, options) {
            var adm = asObservableObject(target);
            options.name = adm.name + "." + propName;
            options.context = target;
            adm.values[propName] = new ComputedValue(options);
            Object.defineProperty(target, propName, generateComputedPropConfig(propName));
          }

          var observablePropertyConfigs = Object.create(null);
          var computedPropertyConfigs = Object.create(null);

          function generateObservablePropConfig(propName) {
            return observablePropertyConfigs[propName] || (observablePropertyConfigs[propName] = {
              configurable: true,
              enumerable: true,
              get: function get() {
                return this.$mobx.read(this, propName);
              },
              set: function set(v) {
                this.$mobx.write(this, propName, v);
              }
            });
          }

          function getAdministrationForComputedPropOwner(owner) {
            var adm = owner.$mobx;

            if (!adm) {
              // because computed props are declared on proty,
              // the current instance might not have been initialized yet
              initializeInstance(owner);
              return owner.$mobx;
            }

            return adm;
          }

          function generateComputedPropConfig(propName) {
            return computedPropertyConfigs[propName] || (computedPropertyConfigs[propName] = {
              configurable: globalState.computedConfigurable,
              enumerable: false,
              get: function get() {
                return getAdministrationForComputedPropOwner(this).read(this, propName);
              },
              set: function set(v) {
                getAdministrationForComputedPropOwner(this).write(this, propName, v);
              }
            });
          }

          function notifyPropertyAddition(adm, object, key, newValue) {
            var notify = hasListeners(adm);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy ? {
              type: "add",
              object: object,
              name: key,
              newValue: newValue
            } : null;
            if (notifySpy) spyReportStart(_assign(_assign({}, change), {
              name: adm.name,
              key: key
            }));
            if (notify) notifyListeners(adm, change);
            if (notifySpy) spyReportEnd();
          }

          var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);

          function isObservableObject(thing) {
            if (isObject(thing)) {
              // Initializers run lazily when transpiling to babel, so make sure they are run...
              initializeInstance(thing);
              return isObservableObjectAdministration(thing.$mobx);
            }

            return false;
          }

          function getAtom(thing, property) {
            if (typeof thing === "object" && thing !== null) {
              if (isObservableArray(thing)) {
                if (property !== undefined) fail(false && false);
                return thing.$mobx.atom;
              }

              if (isObservableSet(thing)) {
                return thing.$mobx;
              }

              if (isObservableMap(thing)) {
                var anyThing = thing;
                if (property === undefined) return getAtom(anyThing._keys);

                var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);

                if (!observable) fail(false && false);
                return observable;
              } // Initializers run lazily when transpiling to babel, so make sure they are run...


              initializeInstance(thing);
              if (property && !thing.$mobx) thing[property]; // See #1072

              if (isObservableObject(thing)) {
                if (!property) return fail(false && false);
                var observable = thing.$mobx.values[property];
                if (!observable) fail(false && false);
                return observable;
              }

              if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
                return thing;
              }
            } else if (typeof thing === "function") {
              if (isReaction(thing.$mobx)) {
                // disposer function
                return thing.$mobx;
              }
            }

            return fail(false && false);
          }

          function getAdministration(thing, property) {
            if (!thing) fail("Expecting some object");
            if (property !== undefined) return getAdministration(getAtom(thing, property));
            if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
            if (isObservableMap(thing) || isObservableSet(thing)) return thing; // Initializers run lazily when transpiling to babel, so make sure they are run...

            initializeInstance(thing);
            if (thing.$mobx) return thing.$mobx;
            fail(false && false);
          }

          function getDebugName(thing, property) {
            var named;
            if (property !== undefined) named = getAtom(thing, property);else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);else named = getAtom(thing); // valid for arrays as well

            return named.name;
          }

          var toString = Object.prototype.toString;

          function deepEqual(a, b, depth) {
            if (depth === void 0) {
              depth = -1;
            }

            return eq(a, b, depth);
          } // Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
          // Internal recursive comparison function for `isEqual`.


          function eq(a, b, depth, aStack, bStack) {
            // Identical objects are equal. `0 === -0`, but they aren't identical.
            // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
            if (a === b) return a !== 0 || 1 / a === 1 / b; // `null` or `undefined` only equal to itself (strict comparison).

            if (a == null || b == null) return false; // `NaN`s are equivalent, but non-reflexive.

            if (a !== a) return b !== b; // Exhaust primitive checks

            var type = typeof a;
            if (type !== "function" && type !== "object" && typeof b != "object") return false; // Unwrap any wrapped objects.

            a = unwrap(a);
            b = unwrap(b); // Compare `[[Class]]` names.

            var className = toString.call(a);
            if (className !== toString.call(b)) return false;

            switch (className) {
              // Strings, numbers, regular expressions, dates, and booleans are compared by value.
              case "[object RegExp]": // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')

              case "[object String]":
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return "" + a === "" + b;

              case "[object Number]":
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN.
                if (+a !== +a) return +b !== +b; // An `egal` comparison is performed for other numeric values.

                return +a === 0 ? 1 / +a === 1 / b : +a === +b;

              case "[object Date]":
              case "[object Boolean]":
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;

              case "[object Symbol]":
                return (// eslint-disable-next-line
                  typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b)
                );
            }

            var areArrays = className === "[object Array]";

            if (!areArrays) {
              if (typeof a != "object" || typeof b != "object") return false; // Objects with different constructors are not equivalent, but `Object`s or `Array`s
              // from different frames are.

              var aCtor = a.constructor,
                  bCtor = b.constructor;

              if (aCtor !== bCtor && !(typeof aCtor === "function" && aCtor instanceof aCtor && typeof bCtor === "function" && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) {
                return false;
              }
            }

            if (depth === 0) {
              return false;
            } else if (depth < 0) {
              depth = -1;
            } // Assume equality for cyclic structures. The algorithm for detecting cyclic
            // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
            // Initializing stack of traversed objects.
            // It's done here since we only need them for objects and arrays comparison.


            aStack = aStack || [];
            bStack = bStack || [];
            var length = aStack.length;

            while (length--) {
              // Linear search. Performance is inversely proportional to the number of
              // unique nested structures.
              if (aStack[length] === a) return bStack[length] === b;
            } // Add the first object to the stack of traversed objects.


            aStack.push(a);
            bStack.push(b); // Recursively compare objects and arrays.

            if (areArrays) {
              // Compare array lengths to determine if a deep comparison is necessary.
              length = a.length;
              if (length !== b.length) return false; // Deep compare the contents, ignoring non-numeric properties.

              while (length--) {
                if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
              }
            } else {
              // Deep compare objects.
              var keys = Object.keys(a);
              var key = void 0;
              length = keys.length; // Ensure that both objects contain the same number of properties before comparing deep equality.

              if (Object.keys(b).length !== length) return false;

              while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
              }
            } // Remove the first object from the stack of traversed objects.


            aStack.pop();
            bStack.pop();
            return true;
          }

          function unwrap(a) {
            if (isObservableArray(a)) return a.peek();
            if (isES6Map(a) || isObservableMap(a)) return iteratorToArray(a.entries());
            if (isES6Set(a) || isObservableSet(a)) return iteratorToArray(a.entries());
            return a;
          }

          function has$1(a, key) {
            return Object.prototype.hasOwnProperty.call(a, key);
          }
          /*
          The only reason for this file to exist is pure horror:
          Without it rollup can make the bundling fail at any point in time; when it rolls up the files in the wrong order
          it will cause undefined errors (for example because super classes or local variables not being hosted).
          With this file that will still happen,
          but at least in this file we can magically reorder the imports with trial and error until the build succeeds again.
          */

          /**
           * (c) Michel Weststrate 2015 - 2019
           * MIT Licensed
           *
           * Welcome to the mobx sources! To get an global overview of how MobX internally works,
           * this is a good place to start:
           * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
           *
           * Source folders:
           * ===============
           *
           * - api/     Most of the public static methods exposed by the module can be found here.
           * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
           * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
           * - utils/   Utility stuff.
           *
           */


          try {
            // define process.env if needed
            // if this is not a production build in the first place
            // (in which case the expression below would be substituted with 'production')
            // tslint:disable-next-line
            "production";
          } catch (e) {
            var g = getGlobal();
            if (typeof process === "undefined") g.process = {};
            g.process.env = {};
          }

          (function () {
            function testCodeMinification() {}

            if (testCodeMinification.name !== "testCodeMinification" && "production" !== "production" && Object({
              "NODE_ENV": "production"
            }).IGNORE_MOBX_MINIFY_WARNING !== "true") {
              // trick so it doesn't get replaced
              var varName = ["process", "env", "NODE_ENV"].join(".");
              console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
            }
          })(); // forward compatibility with mobx, so that packages can easily support mobx 4 & 5


          var $mobx = "$mobx";

          if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
            // See: https://github.com/andykog/mobx-devtools/
            __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
              spy: spy,
              extras: {
                getDebugName: getDebugName
              },
              $mobx: $mobx
            });
          } // TODO: remove in some future build


          if (false) {
            var warnedAboutDefaultExport_1;
          }
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"), __webpack_require__(
        /*! ./../../process/browser.js */
        "./node_modules/process/browser.js"));
        /***/
      },

      /***/
      "./node_modules/object-assign/index.js":
      /*!*********************************************!*\
        !*** ./node_modules/object-assign/index.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectAssignIndexJs(module, exports, __webpack_require__) {
        "use strict";
        /*
        object-assign
        (c) Sindre Sorhus
        @license MIT
        */

        /* eslint-disable no-unused-vars */

        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;

        function toObject(val) {
          if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
          }

          return Object(val);
        }

        function shouldUseNative() {
          try {
            if (!Object.assign) {
              return false;
            } // Detect buggy property enumeration order in older V8 versions.
            // https://bugs.chromium.org/p/v8/issues/detail?id=4118


            var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

            test1[5] = 'de';

            if (Object.getOwnPropertyNames(test1)[0] === '5') {
              return false;
            } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


            var test2 = {};

            for (var i = 0; i < 10; i++) {
              test2['_' + String.fromCharCode(i)] = i;
            }

            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
              return test2[n];
            });

            if (order2.join('') !== '0123456789') {
              return false;
            } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
              test3[letter] = letter;
            });

            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
              return false;
            }

            return true;
          } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
          }
        }

        module.exports = shouldUseNative() ? Object.assign : function (target, source) {
          var from;
          var to = toObject(target);
          var symbols;

          for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);

            for (var key in from) {
              if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
              }
            }

            if (getOwnPropertySymbols) {
              symbols = getOwnPropertySymbols(from);

              for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                  to[symbols[i]] = from[symbols[i]];
                }
              }
            }
          }

          return to;
        };
        /***/
      },

      /***/
      "./node_modules/object-is/implementation.js":
      /*!**************************************************!*\
        !*** ./node_modules/object-is/implementation.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectIsImplementationJs(module, exports, __webpack_require__) {
        "use strict";

        var numberIsNaN = function numberIsNaN(value) {
          return value !== value;
        };

        module.exports = function is(a, b) {
          if (a === 0 && b === 0) {
            return 1 / a === 1 / b;
          }

          if (a === b) {
            return true;
          }

          if (numberIsNaN(a) && numberIsNaN(b)) {
            return true;
          }

          return false;
        };
        /***/

      },

      /***/
      "./node_modules/object-is/index.js":
      /*!*****************************************!*\
        !*** ./node_modules/object-is/index.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectIsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var define = __webpack_require__(
        /*! define-properties */
        "./node_modules/define-properties/index.js");

        var callBind = __webpack_require__(
        /*! es-abstract/helpers/callBind */
        "./node_modules/es-abstract/helpers/callBind.js");

        var implementation = __webpack_require__(
        /*! ./implementation */
        "./node_modules/object-is/implementation.js");

        var getPolyfill = __webpack_require__(
        /*! ./polyfill */
        "./node_modules/object-is/polyfill.js");

        var shim = __webpack_require__(
        /*! ./shim */
        "./node_modules/object-is/shim.js");

        var polyfill = callBind(getPolyfill(), Object);
        define(polyfill, {
          getPolyfill: getPolyfill,
          implementation: implementation,
          shim: shim
        });
        module.exports = polyfill;
        /***/
      },

      /***/
      "./node_modules/object-is/polyfill.js":
      /*!********************************************!*\
        !*** ./node_modules/object-is/polyfill.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectIsPolyfillJs(module, exports, __webpack_require__) {
        "use strict";

        var implementation = __webpack_require__(
        /*! ./implementation */
        "./node_modules/object-is/implementation.js");

        module.exports = function getPolyfill() {
          return typeof Object.is === 'function' ? Object.is : implementation;
        };
        /***/

      },

      /***/
      "./node_modules/object-is/shim.js":
      /*!****************************************!*\
        !*** ./node_modules/object-is/shim.js ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectIsShimJs(module, exports, __webpack_require__) {
        "use strict";

        var getPolyfill = __webpack_require__(
        /*! ./polyfill */
        "./node_modules/object-is/polyfill.js");

        var define = __webpack_require__(
        /*! define-properties */
        "./node_modules/define-properties/index.js");

        module.exports = function shimObjectIs() {
          var polyfill = getPolyfill();
          define(Object, {
            is: polyfill
          }, {
            is: function testObjectIs() {
              return Object.is !== polyfill;
            }
          });
          return polyfill;
        };
        /***/

      },

      /***/
      "./node_modules/object-keys/implementation.js":
      /*!****************************************************!*\
        !*** ./node_modules/object-keys/implementation.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectKeysImplementationJs(module, exports, __webpack_require__) {
        "use strict";

        var keysShim;

        if (!Object.keys) {
          // modified from https://github.com/es-shims/es5-shim
          var has = Object.prototype.hasOwnProperty;
          var toStr = Object.prototype.toString;

          var isArgs = __webpack_require__(
          /*! ./isArguments */
          "./node_modules/object-keys/isArguments.js"); // eslint-disable-line global-require


          var isEnumerable = Object.prototype.propertyIsEnumerable;
          var hasDontEnumBug = !isEnumerable.call({
            toString: null
          }, 'toString');
          var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
          var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];

          var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
            var ctor = o.constructor;
            return ctor && ctor.prototype === o;
          };

          var excludedKeys = {
            $applicationCache: true,
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $onmozfullscreenchange: true,
            $onmozfullscreenerror: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true
          };

          var hasAutomationEqualityBug = function () {
            /* global window */
            if (typeof window === 'undefined') {
              return false;
            }

            for (var k in window) {
              try {
                if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
                  try {
                    equalsConstructorPrototype(window[k]);
                  } catch (e) {
                    return true;
                  }
                }
              } catch (e) {
                return true;
              }
            }

            return false;
          }();

          var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
            /* global window */
            if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
              return equalsConstructorPrototype(o);
            }

            try {
              return equalsConstructorPrototype(o);
            } catch (e) {
              return false;
            }
          };

          keysShim = function keys(object) {
            var isObject = object !== null && typeof object === 'object';
            var isFunction = toStr.call(object) === '[object Function]';
            var isArguments = isArgs(object);
            var isString = isObject && toStr.call(object) === '[object String]';
            var theKeys = [];

            if (!isObject && !isFunction && !isArguments) {
              throw new TypeError('Object.keys called on a non-object');
            }

            var skipProto = hasProtoEnumBug && isFunction;

            if (isString && object.length > 0 && !has.call(object, 0)) {
              for (var i = 0; i < object.length; ++i) {
                theKeys.push(String(i));
              }
            }

            if (isArguments && object.length > 0) {
              for (var j = 0; j < object.length; ++j) {
                theKeys.push(String(j));
              }
            } else {
              for (var name in object) {
                if (!(skipProto && name === 'prototype') && has.call(object, name)) {
                  theKeys.push(String(name));
                }
              }
            }

            if (hasDontEnumBug) {
              var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

              for (var k = 0; k < dontEnums.length; ++k) {
                if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
                  theKeys.push(dontEnums[k]);
                }
              }
            }

            return theKeys;
          };
        }

        module.exports = keysShim;
        /***/
      },

      /***/
      "./node_modules/object-keys/index.js":
      /*!*******************************************!*\
        !*** ./node_modules/object-keys/index.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectKeysIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var slice = Array.prototype.slice;

        var isArgs = __webpack_require__(
        /*! ./isArguments */
        "./node_modules/object-keys/isArguments.js");

        var origKeys = Object.keys;
        var keysShim = origKeys ? function keys(o) {
          return origKeys(o);
        } : __webpack_require__(
        /*! ./implementation */
        "./node_modules/object-keys/implementation.js");
        var originalKeys = Object.keys;

        keysShim.shim = function shimObjectKeys() {
          if (Object.keys) {
            var keysWorksWithArguments = function () {
              // Safari 5.0 bug
              var args = Object.keys(arguments);
              return args && args.length === arguments.length;
            }(1, 2);

            if (!keysWorksWithArguments) {
              Object.keys = function keys(object) {
                // eslint-disable-line func-name-matching
                if (isArgs(object)) {
                  return originalKeys(slice.call(object));
                }

                return originalKeys(object);
              };
            }
          } else {
            Object.keys = keysShim;
          }

          return Object.keys || keysShim;
        };

        module.exports = keysShim;
        /***/
      },

      /***/
      "./node_modules/object-keys/isArguments.js":
      /*!*************************************************!*\
        !*** ./node_modules/object-keys/isArguments.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectKeysIsArgumentsJs(module, exports, __webpack_require__) {
        "use strict";

        var toStr = Object.prototype.toString;

        module.exports = function isArguments(value) {
          var str = toStr.call(value);
          var isArgs = str === '[object Arguments]';

          if (!isArgs) {
            isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
          }

          return isArgs;
        };
        /***/

      },

      /***/
      "./node_modules/object-unfreeze/dist/objectUnfreeze.js":
      /*!*************************************************************!*\
        !*** ./node_modules/object-unfreeze/dist/objectUnfreeze.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectUnfreezeDistObjectUnfreezeJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        function _defaults(obj, defaults) {
          var keys = Object.getOwnPropertyNames(defaults);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = Object.getOwnPropertyDescriptor(defaults, key);

            if (value && value.configurable && obj[key] === undefined) {
              Object.defineProperty(obj, key, value);
            }
          }

          return obj;
        }
        /**
         * Make a shallow copy of the object maintaining the prototype.
         */


        exports.default = function (source) {
          var target = void 0;

          if (source.constructor === Array) {
            target = source.map(function (element) {
              return element;
            });
          } else {
            target = {};

            for (var property in source) {
              if (source.hasOwnProperty(property)) {
                target[property] = source[property];
              }
            }
          }

          _defaults(target, Object.getPrototypeOf(source));

          return target;
        };

        module.exports = exports['default']; //# sourceMappingURL=objectUnfreeze.js.map

        /***/
      },

      /***/
      "./node_modules/process/browser.js":
      /*!*****************************************!*\
        !*** ./node_modules/process/browser.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesProcessBrowserJs(module, exports) {
        // shim for using process in browser
        var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error('setTimeout has not been defined');
        }

        function defaultClearTimeout() {
          throw new Error('clearTimeout has not been defined');
        }

        (function () {
          try {
            if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }

          try {
            if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();

        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          } // if setTimeout wasn't available but was latter defined


          if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }

          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }

        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          } // if clearTimeout wasn't available but was latter defined


          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }

          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }

        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }

          draining = false;

          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }

          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }

          var timeout = runTimeout(cleanUpNextTick);
          draining = true;
          var len = queue.length;

          while (len) {
            currentQueue = queue;
            queue = [];

            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }

            queueIndex = -1;
            len = queue.length;
          }

          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);

          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }

          queue.push(new Item(fun, args));

          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        }; // v8 likes predictible objects


        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }

        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };

        process.title = 'browser';
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ''; // empty string to avoid regexp issues

        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error('process.binding is not supported');
        };

        process.cwd = function () {
          return '/';
        };

        process.chdir = function (dir) {
          throw new Error('process.chdir is not supported');
        };

        process.umask = function () {
          return 0;
        };
        /***/

      },

      /***/
      "./node_modules/qs/lib/index.js":
      /*!**************************************!*\
        !*** ./node_modules/qs/lib/index.js ***!
        \**************************************/

      /*! no static exports found */

      /***/
      function node_modulesQsLibIndexJs(module, exports, __webpack_require__) {
        // Load modules
        var Stringify = __webpack_require__(
        /*! ./stringify */
        "./node_modules/qs/lib/stringify.js");

        var Parse = __webpack_require__(
        /*! ./parse */
        "./node_modules/qs/lib/parse.js"); // Declare internals


        var internals = {};
        module.exports = {
          stringify: Stringify,
          parse: Parse
        };
        /***/
      },

      /***/
      "./node_modules/qs/lib/parse.js":
      /*!**************************************!*\
        !*** ./node_modules/qs/lib/parse.js ***!
        \**************************************/

      /*! no static exports found */

      /***/
      function node_modulesQsLibParseJs(module, exports, __webpack_require__) {
        // Load modules
        var Utils = __webpack_require__(
        /*! ./utils */
        "./node_modules/qs/lib/utils.js"); // Declare internals


        var internals = {
          delimiter: '&',
          depth: 5,
          arrayLimit: 20,
          parameterLimit: 1000,
          strictNullHandling: false,
          plainObjects: false,
          allowPrototypes: false
        };

        internals.parseValues = function (str, options) {
          var obj = {};
          var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

          for (var i = 0, il = parts.length; i < il; ++i) {
            var part = parts[i];
            var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

            if (pos === -1) {
              obj[Utils.decode(part)] = '';

              if (options.strictNullHandling) {
                obj[Utils.decode(part)] = null;
              }
            } else {
              var key = Utils.decode(part.slice(0, pos));
              var val = Utils.decode(part.slice(pos + 1));

              if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                obj[key] = val;
              } else {
                obj[key] = [].concat(obj[key]).concat(val);
              }
            }
          }

          return obj;
        };

        internals.parseObject = function (chain, val, options) {
          if (!chain.length) {
            return val;
          }

          var root = chain.shift();
          var obj;

          if (root === '[]') {
            obj = [];
            obj = obj.concat(internals.parseObject(chain, val, options));
          } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
            var index = parseInt(cleanRoot, 10);
            var indexString = '' + index;

            if (!isNaN(index) && root !== cleanRoot && indexString === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
              obj = [];
              obj[index] = internals.parseObject(chain, val, options);
            } else {
              obj[cleanRoot] = internals.parseObject(chain, val, options);
            }
          }

          return obj;
        };

        internals.parseKeys = function (key, val, options) {
          if (!key) {
            return;
          } // Transform dot notation to bracket notation


          if (options.allowDots) {
            key = key.replace(/\.([^\.\[]+)/g, '[$1]');
          } // The regex chunks


          var parent = /^([^\[\]]*)/;
          var child = /(\[[^\[\]]*\])/g; // Get the parent

          var segment = parent.exec(key); // Stash the parent if it exists

          var keys = [];

          if (segment[1]) {
            // If we aren't using plain objects, optionally prefix keys
            // that would overwrite object prototype properties
            if (!options.plainObjects && Object.prototype.hasOwnProperty(segment[1])) {
              if (!options.allowPrototypes) {
                return;
              }
            }

            keys.push(segment[1]);
          } // Loop through children appending to the array until we hit depth


          var i = 0;

          while ((segment = child.exec(key)) !== null && i < options.depth) {
            ++i;

            if (!options.plainObjects && Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
              if (!options.allowPrototypes) {
                continue;
              }
            }

            keys.push(segment[1]);
          } // If there's a remainder, just add whatever is left


          if (segment) {
            keys.push('[' + key.slice(segment.index) + ']');
          }

          return internals.parseObject(keys, val, options);
        };

        module.exports = function (str, options) {
          options = options || {};
          options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
          options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
          options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
          options.parseArrays = options.parseArrays !== false;
          options.allowDots = options.allowDots !== false;
          options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
          options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
          options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
          options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

          if (str === '' || str === null || typeof str === 'undefined') {
            return options.plainObjects ? Object.create(null) : {};
          }

          var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
          var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

          var keys = Object.keys(tempObj);

          for (var i = 0, il = keys.length; i < il; ++i) {
            var key = keys[i];
            var newObj = internals.parseKeys(key, tempObj[key], options);
            obj = Utils.merge(obj, newObj, options);
          }

          return Utils.compact(obj);
        };
        /***/

      },

      /***/
      "./node_modules/qs/lib/stringify.js":
      /*!******************************************!*\
        !*** ./node_modules/qs/lib/stringify.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesQsLibStringifyJs(module, exports, __webpack_require__) {
        // Load modules
        var Utils = __webpack_require__(
        /*! ./utils */
        "./node_modules/qs/lib/utils.js"); // Declare internals


        var internals = {
          delimiter: '&',
          arrayPrefixGenerators: {
            brackets: function brackets(prefix, key) {
              return prefix + '[]';
            },
            indices: function indices(prefix, key) {
              return prefix + '[' + key + ']';
            },
            repeat: function repeat(prefix, key) {
              return prefix;
            }
          },
          strictNullHandling: false
        };

        internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, filter) {
          if (typeof filter === 'function') {
            obj = filter(prefix, obj);
          } else if (Utils.isBuffer(obj)) {
            obj = obj.toString();
          } else if (obj instanceof Date) {
            obj = obj.toISOString();
          } else if (obj === null) {
            if (strictNullHandling) {
              return Utils.encode(prefix);
            }

            obj = '';
          }

          if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
          }

          var values = [];

          if (typeof obj === 'undefined') {
            return values;
          }

          var objKeys = Array.isArray(filter) ? filter : Object.keys(obj);

          for (var i = 0, il = objKeys.length; i < il; ++i) {
            var key = objKeys[i];

            if (Array.isArray(obj)) {
              values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, filter));
            } else {
              values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, filter));
            }
          }

          return values;
        };

        module.exports = function (obj, options) {
          options = options || {};
          var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
          var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
          var objKeys;
          var filter;

          if (typeof options.filter === 'function') {
            filter = options.filter;
            obj = filter('', obj);
          } else if (Array.isArray(options.filter)) {
            objKeys = filter = options.filter;
          }

          var keys = [];

          if (typeof obj !== 'object' || obj === null) {
            return '';
          }

          var arrayFormat;

          if (options.arrayFormat in internals.arrayPrefixGenerators) {
            arrayFormat = options.arrayFormat;
          } else if ('indices' in options) {
            arrayFormat = options.indices ? 'indices' : 'repeat';
          } else {
            arrayFormat = 'indices';
          }

          var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

          if (!objKeys) {
            objKeys = Object.keys(obj);
          }

          for (var i = 0, il = objKeys.length; i < il; ++i) {
            var key = objKeys[i];
            keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, filter));
          }

          return keys.join(delimiter);
        };
        /***/

      },

      /***/
      "./node_modules/qs/lib/utils.js":
      /*!**************************************!*\
        !*** ./node_modules/qs/lib/utils.js ***!
        \**************************************/

      /*! no static exports found */

      /***/
      function node_modulesQsLibUtilsJs(module, exports) {
        // Load modules
        // Declare internals
        var internals = {};
        internals.hexTable = new Array(256);

        for (var h = 0; h < 256; ++h) {
          internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
        }

        exports.arrayToObject = function (source, options) {
          var obj = options.plainObjects ? Object.create(null) : {};

          for (var i = 0, il = source.length; i < il; ++i) {
            if (typeof source[i] !== 'undefined') {
              obj[i] = source[i];
            }
          }

          return obj;
        };

        exports.merge = function (target, source, options) {
          if (!source) {
            return target;
          }

          if (typeof source !== 'object') {
            if (Array.isArray(target)) {
              target.push(source);
            } else if (typeof target === 'object') {
              target[source] = true;
            } else {
              target = [target, source];
            }

            return target;
          }

          if (typeof target !== 'object') {
            target = [target].concat(source);
            return target;
          }

          if (Array.isArray(target) && !Array.isArray(source)) {
            target = exports.arrayToObject(target, options);
          }

          var keys = Object.keys(source);

          for (var k = 0, kl = keys.length; k < kl; ++k) {
            var key = keys[k];
            var value = source[key];

            if (!Object.prototype.hasOwnProperty.call(target, key)) {
              target[key] = value;
            } else {
              target[key] = exports.merge(target[key], value, options);
            }
          }

          return target;
        };

        exports.decode = function (str) {
          try {
            return decodeURIComponent(str.replace(/\+/g, ' '));
          } catch (e) {
            return str;
          }
        };

        exports.encode = function (str) {
          // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
          // It has been adapted here for stricter adherence to RFC 3986
          if (str.length === 0) {
            return str;
          }

          if (typeof str !== 'string') {
            str = '' + str;
          }

          var out = '';

          for (var i = 0, il = str.length; i < il; ++i) {
            var c = str.charCodeAt(i);

            if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            c >= 0x30 && c <= 0x39 || // 0-9
            c >= 0x41 && c <= 0x5A || // a-z
            c >= 0x61 && c <= 0x7A) {
              // A-Z
              out += str[i];
              continue;
            }

            if (c < 0x80) {
              out += internals.hexTable[c];
              continue;
            }

            if (c < 0x800) {
              out += internals.hexTable[0xC0 | c >> 6] + internals.hexTable[0x80 | c & 0x3F];
              continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
              out += internals.hexTable[0xE0 | c >> 12] + internals.hexTable[0x80 | c >> 6 & 0x3F] + internals.hexTable[0x80 | c & 0x3F];
              continue;
            }

            ++i;
            c = 0x10000 + ((c & 0x3FF) << 10 | str.charCodeAt(i) & 0x3FF);
            out += internals.hexTable[0xF0 | c >> 18] + internals.hexTable[0x80 | c >> 12 & 0x3F] + internals.hexTable[0x80 | c >> 6 & 0x3F] + internals.hexTable[0x80 | c & 0x3F];
          }

          return out;
        };

        exports.compact = function (obj, refs) {
          if (typeof obj !== 'object' || obj === null) {
            return obj;
          }

          refs = refs || [];
          var lookup = refs.indexOf(obj);

          if (lookup !== -1) {
            return refs[lookup];
          }

          refs.push(obj);

          if (Array.isArray(obj)) {
            var compacted = [];

            for (var i = 0, il = obj.length; i < il; ++i) {
              if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
              }
            }

            return compacted;
          }

          var keys = Object.keys(obj);

          for (i = 0, il = keys.length; i < il; ++i) {
            var key = keys[i];
            obj[key] = exports.compact(obj[key], refs);
          }

          return obj;
        };

        exports.isRegExp = function (obj) {
          return Object.prototype.toString.call(obj) === '[object RegExp]';
        };

        exports.isBuffer = function (obj) {
          if (obj === null || typeof obj === 'undefined') {
            return false;
          }

          return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
        };
        /***/

      },

      /***/
      "./node_modules/query-string/index.js":
      /*!********************************************!*\
        !*** ./node_modules/query-string/index.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesQueryStringIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var strictUriEncode = __webpack_require__(
        /*! strict-uri-encode */
        "./node_modules/strict-uri-encode/index.js");

        var objectAssign = __webpack_require__(
        /*! object-assign */
        "./node_modules/object-assign/index.js");

        var decodeComponent = __webpack_require__(
        /*! decode-uri-component */
        "./node_modules/decode-uri-component/index.js");

        function encoderForArrayFormat(opts) {
          switch (opts.arrayFormat) {
            case 'index':
              return function (key, value, index) {
                return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
              };

            case 'bracket':
              return function (key, value) {
                return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
              };

            default:
              return function (key, value) {
                return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
              };
          }
        }

        function parserForArrayFormat(opts) {
          var result;

          switch (opts.arrayFormat) {
            case 'index':
              return function (key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');

                if (!result) {
                  accumulator[key] = value;
                  return;
                }

                if (accumulator[key] === undefined) {
                  accumulator[key] = {};
                }

                accumulator[key][result[1]] = value;
              };

            case 'bracket':
              return function (key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');

                if (!result) {
                  accumulator[key] = value;
                  return;
                } else if (accumulator[key] === undefined) {
                  accumulator[key] = [value];
                  return;
                }

                accumulator[key] = [].concat(accumulator[key], value);
              };

            default:
              return function (key, value, accumulator) {
                if (accumulator[key] === undefined) {
                  accumulator[key] = value;
                  return;
                }

                accumulator[key] = [].concat(accumulator[key], value);
              };
          }
        }

        function encode(value, opts) {
          if (opts.encode) {
            return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
          }

          return value;
        }

        function keysSorter(input) {
          if (Array.isArray(input)) {
            return input.sort();
          } else if (typeof input === 'object') {
            return keysSorter(Object.keys(input)).sort(function (a, b) {
              return Number(a) - Number(b);
            }).map(function (key) {
              return input[key];
            });
          }

          return input;
        }

        function extract(str) {
          var queryStart = str.indexOf('?');

          if (queryStart === -1) {
            return '';
          }

          return str.slice(queryStart + 1);
        }

        function parse(str, opts) {
          opts = objectAssign({
            arrayFormat: 'none'
          }, opts);
          var formatter = parserForArrayFormat(opts); // Create an object with no prototype
          // https://github.com/sindresorhus/query-string/issues/47

          var ret = Object.create(null);

          if (typeof str !== 'string') {
            return ret;
          }

          str = str.trim().replace(/^[?#&]/, '');

          if (!str) {
            return ret;
          }

          str.split('&').forEach(function (param) {
            var parts = param.replace(/\+/g, ' ').split('='); // Firefox (pre 40) decodes `%3D` to `=`
            // https://github.com/sindresorhus/query-string/pull/37

            var key = parts.shift();
            var val = parts.length > 0 ? parts.join('=') : undefined; // missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters

            val = val === undefined ? null : decodeComponent(val);
            formatter(decodeComponent(key), val, ret);
          });
          return Object.keys(ret).sort().reduce(function (result, key) {
            var val = ret[key];

            if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
              // Sort object keys, not values
              result[key] = keysSorter(val);
            } else {
              result[key] = val;
            }

            return result;
          }, Object.create(null));
        }

        exports.extract = extract;
        exports.parse = parse;

        exports.stringify = function (obj, opts) {
          var defaults = {
            encode: true,
            strict: true,
            arrayFormat: 'none'
          };
          opts = objectAssign(defaults, opts);

          if (opts.sort === false) {
            opts.sort = function () {};
          }

          var formatter = encoderForArrayFormat(opts);
          return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
            var val = obj[key];

            if (val === undefined) {
              return '';
            }

            if (val === null) {
              return encode(key, opts);
            }

            if (Array.isArray(val)) {
              var result = [];
              val.slice().forEach(function (val2) {
                if (val2 === undefined) {
                  return;
                }

                result.push(formatter(key, val2, result.length));
              });
              return result.join('&');
            }

            return encode(key, opts) + '=' + encode(val, opts);
          }).filter(function (x) {
            return x.length > 0;
          }).join('&') : '';
        };

        exports.parseUrl = function (str, opts) {
          return {
            url: str.split('?')[0] || '',
            query: parse(extract(str), opts)
          };
        };
        /***/

      },

      /***/
      "./node_modules/react-css-modules/dist/SimpleMap.js":
      /*!**********************************************************!*\
        !*** ./node_modules/react-css-modules/dist/SimpleMap.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistSimpleMapJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var _class = function () {
          function _class() {
            _classCallCheck(this, _class);

            this.size = 0;
            this.keys = [];
            this.values = [];
          }

          _class.prototype.get = function get(key) {
            var index = this.keys.indexOf(key);
            return this.values[index];
          };

          _class.prototype.set = function set(key, value) {
            this.keys.push(key);
            this.values.push(value);
            this.size = this.keys.length;
            return value;
          };

          return _class;
        }();

        exports.default = _class;
        module.exports = exports["default"];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/extendReactClass.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/react-css-modules/dist/extendReactClass.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistExtendReactClassJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _isObject2 = __webpack_require__(
        /*! lodash/isObject */
        "./node_modules/lodash/isObject.js");

        var _isObject3 = _interopRequireDefault(_isObject2);

        var _react = __webpack_require__(
        /*! react */
        "react");

        var _react2 = _interopRequireDefault(_react);

        var _hoistNonReactStatics = __webpack_require__(
        /*! hoist-non-react-statics */
        "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");

        var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

        var _linkClass = __webpack_require__(
        /*! ./linkClass */
        "./node_modules/react-css-modules/dist/linkClass.js");

        var _linkClass2 = _interopRequireDefault(_linkClass);

        var _renderNothing = __webpack_require__(
        /*! ./renderNothing */
        "./node_modules/react-css-modules/dist/renderNothing.js");

        var _renderNothing2 = _interopRequireDefault(_renderNothing);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _defaults(obj, defaults) {
          var keys = Object.getOwnPropertyNames(defaults);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = Object.getOwnPropertyDescriptor(defaults, key);

            if (value && value.configurable && obj[key] === undefined) {
              Object.defineProperty(obj, key, value);
            }
          }

          return obj;
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
        }
        /* eslint-disable react/prop-types */

        /**
         * @param {ReactClass} Component
         * @param {Object} defaultStyles
         * @param {Object} options
         * @returns {ReactClass}
         */


        exports.default = function (Component, defaultStyles, options) {
          var WrappedComponent = function (_Component) {
            _inherits(WrappedComponent, _Component);

            function WrappedComponent() {
              _classCallCheck(this, WrappedComponent);

              return _possibleConstructorReturn(this, _Component.apply(this, arguments));
            }

            WrappedComponent.prototype.render = function render() {
              var styles = void 0;
              var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);
              var renderResult = void 0;

              if (this.props.styles || hasDefaultstyles) {
                var props = Object.assign({}, this.props);

                if (props.styles) {
                  styles = props.styles;
                } else if (hasDefaultstyles) {
                  styles = defaultStyles;
                  delete props.styles;
                }

                Object.defineProperty(props, 'styles', {
                  configurable: true,
                  enumerable: false,
                  value: styles,
                  writable: false
                });
                var originalProps = this.props;
                var renderIsSuccessful = false;

                try {
                  this.props = props;
                  renderResult = _Component.prototype.render.call(this);
                  renderIsSuccessful = true;
                } finally {
                  this.props = originalProps;
                } // @see https://github.com/facebook/react/issues/14224


                if (!renderIsSuccessful) {
                  renderResult = _Component.prototype.render.call(this);
                }
              } else {
                styles = {};
                renderResult = _Component.prototype.render.call(this);
              }

              if (renderResult) {
                return (0, _linkClass2.default)(renderResult, styles, options);
              }

              return (0, _renderNothing2.default)(_react2.default.version);
            };

            return WrappedComponent;
          }(Component);

          return (0, _hoistNonReactStatics2.default)(WrappedComponent, Component);
        };

        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/generateAppendClassName.js":
      /*!************************************************************************!*\
        !*** ./node_modules/react-css-modules/dist/generateAppendClassName.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistGenerateAppendClassNameJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _SimpleMap = __webpack_require__(
        /*! ./SimpleMap */
        "./node_modules/react-css-modules/dist/SimpleMap.js");

        var _SimpleMap2 = _interopRequireDefault(_SimpleMap);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var CustomMap = typeof Map === 'undefined' ? _SimpleMap2.default : Map;
        var stylesIndex = new CustomMap();

        exports.default = function (styles, styleNames, handleNotFoundStyleName) {
          var appendClassName = void 0;
          var stylesIndexMap = void 0;
          stylesIndexMap = stylesIndex.get(styles);

          if (stylesIndexMap) {
            var styleNameIndex = stylesIndexMap.get(styleNames);

            if (styleNameIndex) {
              return styleNameIndex;
            }
          } else {
            stylesIndexMap = new CustomMap();
            stylesIndex.set(styles, new CustomMap());
          }

          appendClassName = '';

          for (var styleName in styleNames) {
            if (styleNames.hasOwnProperty(styleName)) {
              var className = styles[styleNames[styleName]];

              if (className) {
                appendClassName += ' ' + className;
              } else {
                if (handleNotFoundStyleName === 'throw') {
                  throw new Error('"' + styleNames[styleName] + '" CSS module is undefined.');
                }

                if (handleNotFoundStyleName === 'log') {
                  // eslint-disable-next-line no-console
                  console.warn('"' + styleNames[styleName] + '" CSS module is undefined.');
                }
              }
            }
          }

          appendClassName = appendClassName.trim();
          stylesIndexMap.set(styleNames, appendClassName);
          return appendClassName;
        };

        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/index.js":
      /*!******************************************************!*\
        !*** ./node_modules/react-css-modules/dist/index.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _isFunction2 = __webpack_require__(
        /*! lodash/isFunction */
        "./node_modules/lodash/isFunction.js");

        var _isFunction3 = _interopRequireDefault(_isFunction2);

        var _extendReactClass = __webpack_require__(
        /*! ./extendReactClass */
        "./node_modules/react-css-modules/dist/extendReactClass.js");

        var _extendReactClass2 = _interopRequireDefault(_extendReactClass);

        var _wrapStatelessFunction = __webpack_require__(
        /*! ./wrapStatelessFunction */
        "./node_modules/react-css-modules/dist/wrapStatelessFunction.js");

        var _wrapStatelessFunction2 = _interopRequireDefault(_wrapStatelessFunction);

        var _makeConfiguration = __webpack_require__(
        /*! ./makeConfiguration */
        "./node_modules/react-css-modules/dist/makeConfiguration.js");

        var _makeConfiguration2 = _interopRequireDefault(_makeConfiguration);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        /**
         * Determines if the given object has the signature of a class that inherits React.Component.
         */

        /**
         * @see https://github.com/gajus/react-css-modules#options
         */


        var isReactComponent = function isReactComponent(maybeReactComponent) {
          return 'prototype' in maybeReactComponent && (0, _isFunction3.default)(maybeReactComponent.prototype.render);
        };
        /**
         * When used as a function.
         */


        var functionConstructor = function functionConstructor(Component, defaultStyles, options) {
          var decoratedClass = void 0;
          var configuration = (0, _makeConfiguration2.default)(options);

          if (isReactComponent(Component)) {
            decoratedClass = (0, _extendReactClass2.default)(Component, defaultStyles, configuration);
          } else {
            decoratedClass = (0, _wrapStatelessFunction2.default)(Component, defaultStyles, configuration);
          }

          if (Component.displayName) {
            decoratedClass.displayName = Component.displayName;
          } else {
            decoratedClass.displayName = Component.name;
          }

          return decoratedClass;
        };
        /**
         * When used as a ES7 decorator.
         */


        var decoratorConstructor = function decoratorConstructor(defaultStyles, options) {
          return function (Component) {
            return functionConstructor(Component, defaultStyles, options);
          };
        };

        exports.default = function () {
          if ((0, _isFunction3.default)(arguments.length <= 0 ? undefined : arguments[0])) {
            return functionConstructor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
          } else {
            return decoratorConstructor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
          }
        };

        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/isIterable.js":
      /*!***********************************************************!*\
        !*** ./node_modules/react-css-modules/dist/isIterable.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistIsIterableJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _isObject2 = __webpack_require__(
        /*! lodash/isObject */
        "./node_modules/lodash/isObject.js");

        var _isObject3 = _interopRequireDefault(_isObject2);

        var _isFunction2 = __webpack_require__(
        /*! lodash/isFunction */
        "./node_modules/lodash/isFunction.js");

        var _isFunction3 = _interopRequireDefault(_isFunction2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var ITERATOR_SYMBOL = typeof Symbol !== 'undefined' && (0, _isFunction3.default)(Symbol) && Symbol.iterator;
        var OLD_ITERATOR_SYMBOL = '@@iterator';
        /**
         * @see https://github.com/lodash/lodash/issues/1668
         * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Iteration_protocols
         */

        exports.default = function (maybeIterable) {
          var iterator = void 0;

          if (!(0, _isObject3.default)(maybeIterable)) {
            return false;
          }

          if (ITERATOR_SYMBOL) {
            iterator = maybeIterable[ITERATOR_SYMBOL];
          } else {
            iterator = maybeIterable[OLD_ITERATOR_SYMBOL];
          }

          return (0, _isFunction3.default)(iterator);
        };

        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/linkClass.js":
      /*!**********************************************************!*\
        !*** ./node_modules/react-css-modules/dist/linkClass.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistLinkClassJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _isObject2 = __webpack_require__(
        /*! lodash/isObject */
        "./node_modules/lodash/isObject.js");

        var _isObject3 = _interopRequireDefault(_isObject2);

        var _isArray2 = __webpack_require__(
        /*! lodash/isArray */
        "./node_modules/lodash/isArray.js");

        var _isArray3 = _interopRequireDefault(_isArray2);

        var _forEach2 = __webpack_require__(
        /*! lodash/forEach */
        "./node_modules/lodash/forEach.js");

        var _forEach3 = _interopRequireDefault(_forEach2);

        var _react = __webpack_require__(
        /*! react */
        "react");

        var _react2 = _interopRequireDefault(_react);

        var _objectUnfreeze = __webpack_require__(
        /*! object-unfreeze */
        "./node_modules/object-unfreeze/dist/objectUnfreeze.js");

        var _objectUnfreeze2 = _interopRequireDefault(_objectUnfreeze);

        var _isIterable = __webpack_require__(
        /*! ./isIterable */
        "./node_modules/react-css-modules/dist/isIterable.js");

        var _isIterable2 = _interopRequireDefault(_isIterable);

        var _parseStyleName = __webpack_require__(
        /*! ./parseStyleName */
        "./node_modules/react-css-modules/dist/parseStyleName.js");

        var _parseStyleName2 = _interopRequireDefault(_parseStyleName);

        var _generateAppendClassName = __webpack_require__(
        /*! ./generateAppendClassName */
        "./node_modules/react-css-modules/dist/generateAppendClassName.js");

        var _generateAppendClassName2 = _interopRequireDefault(_generateAppendClassName);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {};

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }

          return target;
        }

        var linkArray = function linkArray(array, styles, configuration) {
          (0, _forEach3.default)(array, function (value, index) {
            if (_react2.default.isValidElement(value)) {
              // eslint-disable-next-line no-use-before-define
              array[index] = linkElement(_react2.default.Children.only(value), styles, configuration);
            } else if ((0, _isArray3.default)(value)) {
              var unfreezedValue = Object.isFrozen(value) ? (0, _objectUnfreeze2.default)(value) : value;
              array[index] = linkArray(unfreezedValue, styles, configuration);
            }
          });
          return array;
        };

        var linkElement = function linkElement(element, styles, configuration) {
          var appendClassName = void 0;
          var elementShallowCopy = void 0;
          elementShallowCopy = element;

          if (Array.isArray(elementShallowCopy)) {
            return elementShallowCopy.map(function (arrayElement) {
              return linkElement(arrayElement, styles, configuration);
            });
          }

          var elementIsFrozen = Object.isFrozen && Object.isFrozen(elementShallowCopy);
          var propsFrozen = Object.isFrozen && Object.isFrozen(elementShallowCopy.props);
          var propsNotExtensible = Object.isExtensible && !Object.isExtensible(elementShallowCopy.props);

          if (elementIsFrozen) {
            // https://github.com/facebook/react/blob/v0.13.3/src/classic/element/ReactElement.js#L131
            elementShallowCopy = (0, _objectUnfreeze2.default)(elementShallowCopy);
            elementShallowCopy.props = (0, _objectUnfreeze2.default)(elementShallowCopy.props);
          } else if (propsFrozen || propsNotExtensible) {
            elementShallowCopy.props = (0, _objectUnfreeze2.default)(elementShallowCopy.props);
          }

          var styleNames = (0, _parseStyleName2.default)(elementShallowCopy.props.styleName || '', configuration.allowMultiple);

          var _elementShallowCopy$p = elementShallowCopy.props,
              children = _elementShallowCopy$p.children,
              restProps = _objectWithoutProperties(_elementShallowCopy$p, ['children']);

          if (_react2.default.isValidElement(children)) {
            elementShallowCopy.props.children = linkElement(_react2.default.Children.only(children), styles, configuration);
          } else if ((0, _isArray3.default)(children) || (0, _isIterable2.default)(children)) {
            elementShallowCopy.props.children = linkArray((0, _objectUnfreeze2.default)(children), styles, configuration);
          }

          (0, _forEach3.default)(restProps, function (propValue, propName) {
            if (_react2.default.isValidElement(propValue)) {
              elementShallowCopy.props[propName] = linkElement(_react2.default.Children.only(propValue), styles, configuration);
            } else if ((0, _isArray3.default)(propValue)) {
              elementShallowCopy.props[propName] = linkArray(propValue, styles, configuration);
            }
          });

          if (styleNames.length) {
            appendClassName = (0, _generateAppendClassName2.default)(styles, styleNames, configuration.handleNotFoundStyleName);

            if (appendClassName) {
              if (elementShallowCopy.props.className) {
                appendClassName = elementShallowCopy.props.className + ' ' + appendClassName;
              }

              elementShallowCopy.props.className = appendClassName;
            }
          }

          delete elementShallowCopy.props.styleName;

          if (elementIsFrozen) {
            Object.freeze(elementShallowCopy.props);
            Object.freeze(elementShallowCopy);
          } else if (propsFrozen) {
            Object.freeze(elementShallowCopy.props);
          }

          if (propsNotExtensible) {
            Object.preventExtensions(elementShallowCopy.props);
          }

          return elementShallowCopy;
        };
        /**
         * @param {ReactElement} element
         * @param {Object} styles CSS modules class map.
         * @param {CSSModules~Options} configuration
         */


        exports.default = function (element) {
          var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var configuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}; // @see https://github.com/gajus/react-css-modules/pull/30

          if (!(0, _isObject3.default)(element)) {
            return element;
          }

          return linkElement(element, styles, configuration);
        };

        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/makeConfiguration.js":
      /*!******************************************************************!*\
        !*** ./node_modules/react-css-modules/dist/makeConfiguration.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistMakeConfigurationJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _includes2 = __webpack_require__(
        /*! lodash/includes */
        "./node_modules/lodash/includes.js");

        var _includes3 = _interopRequireDefault(_includes2);

        var _isBoolean2 = __webpack_require__(
        /*! lodash/isBoolean */
        "./node_modules/lodash/isBoolean.js");

        var _isBoolean3 = _interopRequireDefault(_isBoolean2);

        var _isUndefined2 = __webpack_require__(
        /*! lodash/isUndefined */
        "./node_modules/lodash/isUndefined.js");

        var _isUndefined3 = _interopRequireDefault(_isUndefined2);

        var _forEach2 = __webpack_require__(
        /*! lodash/forEach */
        "./node_modules/lodash/forEach.js");

        var _forEach3 = _interopRequireDefault(_forEach2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        /**
         * @typedef CSSModules~Options
         * @see {@link https://github.com/gajus/react-css-modules#options}
         * @property {boolean} allowMultiple
         * @property {string} handleNotFoundStyleName
         */

        /**
         * @param {CSSModules~Options} userConfiguration
         * @returns {CSSModules~Options}
         */


        exports.default = function () {
          var userConfiguration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var configuration = {
            allowMultiple: false,
            handleNotFoundStyleName: 'throw'
          };
          (0, _forEach3.default)(userConfiguration, function (value, name) {
            if ((0, _isUndefined3.default)(configuration[name])) {
              throw new Error('Unknown configuration property "' + name + '".');
            }

            if (name === 'allowMultiple' && !(0, _isBoolean3.default)(value)) {
              throw new Error('"allowMultiple" property value must be a boolean.');
            }

            if (name === 'handleNotFoundStyleName' && !(0, _includes3.default)(['throw', 'log', 'ignore'], value)) {
              throw new Error('"handleNotFoundStyleName" property value must be "throw", "log" or "ignore".');
            }

            configuration[name] = value;
          });
          return configuration;
        };

        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/parseStyleName.js":
      /*!***************************************************************!*\
        !*** ./node_modules/react-css-modules/dist/parseStyleName.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistParseStyleNameJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _filter2 = __webpack_require__(
        /*! lodash/filter */
        "./node_modules/lodash/filter.js");

        var _filter3 = _interopRequireDefault(_filter2);

        var _trim2 = __webpack_require__(
        /*! lodash/trim */
        "./node_modules/lodash/trim.js");

        var _trim3 = _interopRequireDefault(_trim2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var styleNameIndex = {};

        exports.default = function (styleNamePropertyValue, allowMultiple) {
          var styleNames = void 0;

          if (styleNameIndex[styleNamePropertyValue]) {
            styleNames = styleNameIndex[styleNamePropertyValue];
          } else {
            styleNames = (0, _trim3.default)(styleNamePropertyValue).split(/\s+/);
            styleNames = (0, _filter3.default)(styleNames);
            styleNameIndex[styleNamePropertyValue] = styleNames;
          }

          if (allowMultiple === false && styleNames.length > 1) {
            throw new Error('ReactElement styleName property defines multiple module names ("' + styleNamePropertyValue + '").');
          }

          return styleNames;
        };

        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/renderNothing.js":
      /*!**************************************************************!*\
        !*** ./node_modules/react-css-modules/dist/renderNothing.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistRenderNothingJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        exports.default = function (version) {
          var major = version.split('.')[0];
          return parseInt(major, 10) < 15 ? _react2.default.createElement('noscript') : null;
        };

        var _react = __webpack_require__(
        /*! react */
        "react");

        var _react2 = _interopRequireDefault(_react);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-css-modules/dist/wrapStatelessFunction.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/react-css-modules/dist/wrapStatelessFunction.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactCssModulesDistWrapStatelessFunctionJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _assign2 = __webpack_require__(
        /*! lodash/assign */
        "./node_modules/lodash/assign.js");

        var _assign3 = _interopRequireDefault(_assign2);

        var _isObject2 = __webpack_require__(
        /*! lodash/isObject */
        "./node_modules/lodash/isObject.js");

        var _isObject3 = _interopRequireDefault(_isObject2);

        var _react = __webpack_require__(
        /*! react */
        "react");

        var _react2 = _interopRequireDefault(_react);

        var _linkClass = __webpack_require__(
        /*! ./linkClass */
        "./node_modules/react-css-modules/dist/linkClass.js");

        var _linkClass2 = _interopRequireDefault(_linkClass);

        var _renderNothing = __webpack_require__(
        /*! ./renderNothing */
        "./node_modules/react-css-modules/dist/renderNothing.js");

        var _renderNothing2 = _interopRequireDefault(_renderNothing);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        /**
         * @see https://facebook.github.io/react/blog/2015/09/10/react-v0.14-rc1.html#stateless-function-components
         */


        exports.default = function (Component, defaultStyles, options) {
          var WrappedComponent = function WrappedComponent() {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var styles = void 0;
            var useProps = void 0;
            var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);

            if (props.styles || hasDefaultstyles) {
              useProps = Object.assign({}, props);

              if (props.styles) {
                styles = props.styles;
              } else {
                styles = defaultStyles;
              }

              Object.defineProperty(useProps, 'styles', {
                configurable: true,
                enumerable: false,
                value: styles,
                writable: false
              });
            } else {
              useProps = props;
              styles = {};
            }

            var renderResult = Component.apply(undefined, [useProps].concat(args));

            if (renderResult) {
              return (0, _linkClass2.default)(renderResult, styles, options);
            }

            return (0, _renderNothing2.default)(_react2.default.version);
          };

          (0, _assign3.default)(WrappedComponent, Component);
          return WrappedComponent;
        };
        /* eslint-disable react/prop-types */


        module.exports = exports['default'];
        /***/
      },

      /***/
      "./node_modules/react-jss/lib/JssProvider.js":
      /*!***************************************************!*\
        !*** ./node_modules/react-jss/lib/JssProvider.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibJssProviderJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _react = __webpack_require__(
        /*! react */
        "react");

        var _propTypes = __webpack_require__(
        /*! prop-types */
        "prop-types");

        var _jss = __webpack_require__(
        /*! ./jss */
        "./node_modules/react-jss/lib/jss.js");

        var _ns = __webpack_require__(
        /*! ./ns */
        "./node_modules/react-jss/lib/ns.js");

        var ns = _interopRequireWildcard(_ns);

        var _contextTypes = __webpack_require__(
        /*! ./contextTypes */
        "./node_modules/react-jss/lib/contextTypes.js");

        var _contextTypes2 = _interopRequireDefault(_contextTypes);

        var _propTypes2 = __webpack_require__(
        /*! ./propTypes */
        "./node_modules/react-jss/lib/propTypes.js");

        var _propTypes3 = _interopRequireDefault(_propTypes2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};

            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }

            newObj.default = obj;
            return newObj;
          }
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var JssProvider = function (_Component) {
          _inherits(JssProvider, _Component);

          function JssProvider() {
            _classCallCheck(this, JssProvider);

            return _possibleConstructorReturn(this, (JssProvider.__proto__ || Object.getPrototypeOf(JssProvider)).apply(this, arguments));
          }

          _createClass(JssProvider, [{
            key: 'getChildContext',
            // JssProvider can be nested. We allow to overwrite any context prop at any level.
            // 1. Check if there is a value passed over props.
            // 2. If value was passed, we set it on the child context.
            // 3. If value was not passed, we proxy parent context (default context behaviour).
            value: function getChildContext() {
              var _props = this.props,
                  registry = _props.registry,
                  classNamePrefix = _props.classNamePrefix,
                  localJss = _props.jss,
                  generateClassName = _props.generateClassName;
              var sheetOptions = this.context[ns.sheetOptions] || {};

              var context = _defineProperty({}, ns.sheetOptions, sheetOptions);

              if (registry) {
                context[ns.sheetsRegistry] = registry; // This way we identify a new request on the server, because user will create
                // a new Registry instance for each.

                if (registry !== this.registry) {
                  // We reset managers because we have to regenerate all sheets for the new request.
                  this.managers = {};
                  this.registry = registry;
                }
              } // Make sure we don't loose managers when JssProvider is used inside of a stateful
              // component which decides to rerender.


              context[ns.managers] = this.managers;

              if (generateClassName) {
                sheetOptions.generateClassName = generateClassName;
              } else if (!sheetOptions.generateClassName) {
                if (!this.generateClassName) {
                  var createGenerateClassName = _jss.createGenerateClassNameDefault;

                  if (localJss && localJss.options.createGenerateClassName) {
                    createGenerateClassName = localJss.options.createGenerateClassName;
                  } // Make sure we don't loose the generator when JssProvider is used inside of a stateful
                  // component which decides to rerender.


                  this.generateClassName = createGenerateClassName();
                }

                sheetOptions.generateClassName = this.generateClassName;
              }

              if (classNamePrefix) sheetOptions.classNamePrefix = classNamePrefix;
              if (localJss) context[ns.jss] = localJss;
              return context;
            }
          }, {
            key: 'render',
            value: function render() {
              return _react.Children.only(this.props.children);
            }
          }]);

          return JssProvider;
        }(_react.Component);

        JssProvider.propTypes = _extends({}, _propTypes3['default'], {
          generateClassName: _propTypes.func,
          classNamePrefix: _propTypes.string,
          children: _propTypes.node.isRequired
        });
        JssProvider.childContextTypes = _contextTypes2['default'];
        JssProvider.contextTypes = _contextTypes2['default'];
        exports['default'] = JssProvider;
        /***/
      },

      /***/
      "./node_modules/react-jss/lib/compose.js":
      /*!***********************************************!*\
        !*** ./node_modules/react-jss/lib/compose.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibComposeJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        /**
         * Adds `composes` property to each top level rule
         * in order to have a composed class name for dynamic style sheets.
         *
         * It relies on jss-compose and jss-extend plugins.
         *
         * Example:
         * classes:  {left: 'a', button: 'b'}
         * styles:   {button: {height: () => { ... }}}
         * composed: {
         *   button: {
         *     composes: 'b',
         *     height: () => { ... }
         *   },
         *   left: {
         *     composes: 'a'
         *   }
         * }
         *
         * @param {Object} classes static classes map
         * @param {Object} styles dynamic styles object without static properties
         * @return {Object|null}
         */

        exports['default'] = function (classes, styles) {
          // Add `composes` property to rules which are already defined in `classes`.
          for (var name in styles) {
            var className = classes[name];
            if (!className) break;

            if (typeof styles[name] === 'function') {
              styles[name] = {
                extend: styles[name],
                composes: className
              };
              continue;
            }

            styles[name].composes = className;
          }

          if (styles) {
            // Add rules which are defined in `classes` but aren't in styles.
            for (var _name in classes) {
              var _className = styles[_name];

              if (!_className) {
                styles[_name] = {
                  composes: classes[_name]
                };
              }
            }
          }

          return styles;
        };
        /***/

      },

      /***/
      "./node_modules/react-jss/lib/contextTypes.js":
      /*!****************************************************!*\
        !*** ./node_modules/react-jss/lib/contextTypes.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibContextTypesJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _ns$jss$ns$sheetOptio;

        var _propTypes = __webpack_require__(
        /*! prop-types */
        "prop-types");

        var _ns = __webpack_require__(
        /*! ./ns */
        "./node_modules/react-jss/lib/ns.js");

        var ns = _interopRequireWildcard(_ns);

        var _propTypes2 = __webpack_require__(
        /*! ./propTypes */
        "./node_modules/react-jss/lib/propTypes.js");

        var _propTypes3 = _interopRequireDefault(_propTypes2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};

            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }

            newObj['default'] = obj;
            return newObj;
          }
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);
        /***/
      },

      /***/
      "./node_modules/react-jss/lib/createHoc.js":
      /*!*************************************************!*\
        !*** ./node_modules/react-jss/lib/createHoc.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibCreateHocJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _react = __webpack_require__(
        /*! react */
        "react");

        var _react2 = _interopRequireDefault(_react);

        var _propTypes = __webpack_require__(
        /*! prop-types */
        "prop-types");

        var _propTypes2 = _interopRequireDefault(_propTypes);

        var _theming = __webpack_require__(
        /*! theming */
        "./node_modules/theming/dist/esm/index.js");

        var _theming2 = _interopRequireDefault(_theming);

        var _jss = __webpack_require__(
        /*! ./jss */
        "./node_modules/react-jss/lib/jss.js");

        var _jss2 = _interopRequireDefault(_jss);

        var _compose = __webpack_require__(
        /*! ./compose */
        "./node_modules/react-jss/lib/compose.js");

        var _compose2 = _interopRequireDefault(_compose);

        var _getDisplayName = __webpack_require__(
        /*! ./getDisplayName */
        "./node_modules/react-jss/lib/getDisplayName.js");

        var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

        var _ns = __webpack_require__(
        /*! ./ns */
        "./node_modules/react-jss/lib/ns.js");

        var ns = _interopRequireWildcard(_ns);

        var _contextTypes = __webpack_require__(
        /*! ./contextTypes */
        "./node_modules/react-jss/lib/contextTypes.js");

        var _contextTypes2 = _interopRequireDefault(_contextTypes);

        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};

            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }

            newObj['default'] = obj;
            return newObj;
          }
        }

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {};

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }

          return target;
        }

        var env = "production"; // Like a Symbol

        var dynamicStylesNs = Math.random();
        /*
         * # Use cases
         *
         * - Unthemed component accepts styles object
         * - Themed component accepts styles creator function which takes theme as a single argument
         * - Multiple instances will re-use the same static sheet via sheets manager
         * - Sheet manager identifies static sheets by theme as a key
         * - For unthemed components theme is an empty object
         * - The very first instance will add static sheet to sheets manager
         * - Every further instances will get that static sheet from sheet manager
         * - Every mount of every instance will call method `sheetsManager.manage`,
         * thus incrementing reference counter.
         * - Every unmount of every instance will call method `sheetsManager.unmanage`,
         * thus decrementing reference counter.
         * - `sheetsManager.unmanage` under the hood will detach static sheet once reference
         * counter is zero.
         * - Dynamic styles are not shared between instances
         *
         */

        var getStyles = function getStyles(stylesOrCreator, theme) {
          if (typeof stylesOrCreator !== 'function') {
            return stylesOrCreator;
          }

          return stylesOrCreator(theme);
        }; // Returns an object with array property as a key and true as a value.


        var toMap = function toMap(arr) {
          return arr.reduce(function (map, prop) {
            map[prop] = true;
            return map;
          }, {});
        };

        var defaultInjectProps = {
          sheet: false,
          classes: true,
          theme: true
        };
        var managersCounter = 0;
        /**
         * Wrap a Component into a JSS Container Component.
         *
         * @param {Object|Function} stylesOrCreator
         * @param {Component} InnerComponent
         * @param {Object} [options]
         * @return {Component}
         */

        exports['default'] = function (stylesOrCreator, InnerComponent) {
          var _class, _temp, _initialiseProps;

          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isThemingEnabled = typeof stylesOrCreator === 'function';

          var _options$theming = options.theming,
              theming = _options$theming === undefined ? _theming2['default'] : _options$theming,
              inject = options.inject,
              optionsJss = options.jss,
              sheetOptions = _objectWithoutProperties(options, ['theming', 'inject', 'jss']);

          var injectMap = inject ? toMap(inject) : defaultInjectProps;
          var themeListener = theming.themeListener;
          var displayName = (0, _getDisplayName2['default'])(InnerComponent);
          var defaultClassNamePrefix = env === 'production' ? undefined : displayName + '-';
          var noTheme = {};
          var managerId = managersCounter++;
          var manager = new _jss.SheetsManager();

          var defaultProps = _extends({}, InnerComponent.defaultProps);

          delete defaultProps.classes;
          return _temp = _class = function (_Component) {
            _inherits(Jss, _Component);

            function Jss(props, context) {
              _classCallCheck(this, Jss);

              var _this = _possibleConstructorReturn(this, (Jss.__proto__ || Object.getPrototypeOf(Jss)).call(this, props, context));

              _initialiseProps.call(_this);

              var theme = isThemingEnabled ? themeListener.initial(context) : noTheme;
              _this.state = _this.createState({
                theme: theme
              }, props);
              return _this;
            }

            _createClass(Jss, [{
              key: 'createState',
              value: function createState(_ref, _ref2) {
                var theme = _ref.theme,
                    dynamicSheet = _ref.dynamicSheet;
                var userClasses = _ref2.classes;
                var contextSheetOptions = this.context[ns.sheetOptions];
                var classNamePrefix = defaultClassNamePrefix;
                var staticSheet = this.manager.get(theme);
                var dynamicStyles = void 0;

                if (contextSheetOptions && contextSheetOptions.classNamePrefix) {
                  classNamePrefix = contextSheetOptions.classNamePrefix + classNamePrefix;
                }

                if (!staticSheet) {
                  var styles = getStyles(stylesOrCreator, theme);
                  staticSheet = this.jss.createStyleSheet(styles, _extends({}, sheetOptions, contextSheetOptions, {
                    meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Static',
                    classNamePrefix: classNamePrefix
                  }));
                  this.manager.add(theme, staticSheet);
                  dynamicStyles = (0, _compose2['default'])(staticSheet.classes, (0, _jss.getDynamicStyles)(styles));
                  staticSheet[dynamicStylesNs] = dynamicStyles;
                } else dynamicStyles = staticSheet[dynamicStylesNs];

                if (dynamicStyles) {
                  dynamicSheet = this.jss.createStyleSheet(dynamicStyles, _extends({}, sheetOptions, contextSheetOptions, {
                    meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Dynamic',
                    classNamePrefix: classNamePrefix,
                    link: true
                  }));
                }

                var sheet = dynamicSheet || staticSheet;
                var defaultClasses = InnerComponent.defaultProps ? InnerComponent.defaultProps.classes : {};

                var classes = _extends({}, defaultClasses, sheet.classes, userClasses);

                return {
                  theme: theme,
                  dynamicSheet: dynamicSheet,
                  classes: classes
                };
              }
            }, {
              key: 'manage',
              value: function manage(_ref3) {
                var theme = _ref3.theme,
                    dynamicSheet = _ref3.dynamicSheet;
                var registry = this.context[ns.sheetsRegistry];
                var staticSheet = this.manager.manage(theme);
                if (registry) registry.add(staticSheet);

                if (dynamicSheet) {
                  dynamicSheet.update(this.props).attach();
                  if (registry) registry.add(dynamicSheet);
                }
              }
            }, {
              key: 'componentWillMount',
              value: function componentWillMount() {
                this.manage(this.state);
              }
            }, {
              key: 'componentDidMount',
              value: function componentDidMount() {
                if (isThemingEnabled) {
                  this.unsubscribeId = themeListener.subscribe(this.context, this.setTheme);
                }
              }
            }, {
              key: 'componentWillReceiveProps',
              value: function componentWillReceiveProps(nextProps, nextContext) {
                this.context = nextContext;
                var dynamicSheet = this.state.dynamicSheet;
                if (dynamicSheet) dynamicSheet.update(nextProps);
              }
            }, {
              key: 'componentWillUpdate',
              value: function componentWillUpdate(nextProps, nextState) {
                if (isThemingEnabled && this.state.theme !== nextState.theme) {
                  var newState = this.createState(nextState, nextProps);
                  this.manage(newState);
                  this.manager.unmanage(this.state.theme);
                  this.setState(newState);
                }
              }
            }, {
              key: 'componentDidUpdate',
              value: function componentDidUpdate(prevProps, prevState) {
                // We remove previous dynamicSheet only after new one was created to avoid FOUC.
                if (prevState.dynamicSheet !== this.state.dynamicSheet) {
                  this.jss.removeStyleSheet(prevState.dynamicSheet);
                }
              }
            }, {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                if (this.unsubscribeId) {
                  themeListener.unsubscribe(this.context, this.unsubscribeId);
                }

                this.manager.unmanage(this.state.theme);

                if (this.state.dynamicSheet) {
                  this.state.dynamicSheet.detach();
                }
              }
            }, {
              key: 'render',
              value: function render() {
                var _state = this.state,
                    theme = _state.theme,
                    dynamicSheet = _state.dynamicSheet,
                    classes = _state.classes;

                var _props = this.props,
                    innerRef = _props.innerRef,
                    props = _objectWithoutProperties(_props, ['innerRef']);

                var sheet = dynamicSheet || this.manager.get(theme);
                if (injectMap.sheet && !props.sheet) props.sheet = sheet;
                if (isThemingEnabled && injectMap.theme && !props.theme) props.theme = theme; // We have merged classes already.

                if (injectMap.classes) props.classes = classes;
                return _react2['default'].createElement(InnerComponent, _extends({
                  ref: innerRef
                }, props));
              }
            }, {
              key: 'jss',
              get: function get() {
                return this.context[ns.jss] || optionsJss || _jss2['default'];
              }
            }, {
              key: 'manager',
              get: function get() {
                var managers = this.context[ns.managers]; // If `managers` map is present in the context, we use it in order to
                // let JssProvider reset them when new response has to render server-side.

                if (managers) {
                  if (!managers[managerId]) {
                    managers[managerId] = new _jss.SheetsManager();
                  }

                  return managers[managerId];
                }

                return manager;
              }
            }]);

            return Jss;
          }(_react.Component), _class.displayName = 'Jss(' + displayName + ')', _class.InnerComponent = InnerComponent, _class.contextTypes = _extends({}, _contextTypes2['default'], isThemingEnabled && themeListener.contextTypes), _class.propTypes = {
            innerRef: _propTypes2['default'].func
          }, _class.defaultProps = defaultProps, _initialiseProps = function _initialiseProps() {
            var _this2 = this;

            this.setTheme = function (theme) {
              return _this2.setState({
                theme: theme
              });
            };
          }, _temp;
        };
        /***/

      },

      /***/
      "./node_modules/react-jss/lib/getDisplayName.js":
      /*!******************************************************!*\
        !*** ./node_modules/react-jss/lib/getDisplayName.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibGetDisplayNameJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        exports['default'] = function (Component) {
          return Component.displayName || Component.name || 'Component';
        };
        /***/

      },

      /***/
      "./node_modules/react-jss/lib/index.js":
      /*!*********************************************!*\
        !*** ./node_modules/react-jss/lib/index.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _theming = __webpack_require__(
        /*! theming */
        "./node_modules/theming/dist/esm/index.js");

        Object.defineProperty(exports, 'ThemeProvider', {
          enumerable: true,
          get: function get() {
            return _theming.ThemeProvider;
          }
        });
        Object.defineProperty(exports, 'withTheme', {
          enumerable: true,
          get: function get() {
            return _theming.withTheme;
          }
        });
        Object.defineProperty(exports, 'createTheming', {
          enumerable: true,
          get: function get() {
            return _theming.createTheming;
          }
        });

        var _JssProvider = __webpack_require__(
        /*! ./JssProvider */
        "./node_modules/react-jss/lib/JssProvider.js");

        Object.defineProperty(exports, 'JssProvider', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_JssProvider)['default'];
          }
        });

        var _jss = __webpack_require__(
        /*! ./jss */
        "./node_modules/react-jss/lib/jss.js");

        Object.defineProperty(exports, 'jss', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_jss)['default'];
          }
        });
        Object.defineProperty(exports, 'SheetsRegistry', {
          enumerable: true,
          get: function get() {
            return _jss.SheetsRegistry;
          }
        });
        Object.defineProperty(exports, 'createGenerateClassName', {
          enumerable: true,
          get: function get() {
            return _jss.createGenerateClassNameDefault;
          }
        });

        var _injectSheet = __webpack_require__(
        /*! ./injectSheet */
        "./node_modules/react-jss/lib/injectSheet.js");

        Object.defineProperty(exports, 'default', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_injectSheet)['default'];
          }
        });

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/react-jss/lib/injectSheet.js":
      /*!***************************************************!*\
        !*** ./node_modules/react-jss/lib/injectSheet.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibInjectSheetJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = injectSheet;

        var _hoistNonReactStatics = __webpack_require__(
        /*! hoist-non-react-statics */
        "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");

        var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

        var _createHoc = __webpack_require__(
        /*! ./createHoc */
        "./node_modules/react-jss/lib/createHoc.js");

        var _createHoc2 = _interopRequireDefault(_createHoc);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        /**
         * Global index counter to preserve source order.
         * As we create the style sheet during componentWillMount lifecycle,
         * children are handled after the parents, so the order of style elements would
         * be parent->child. It is a problem though when a parent passes a className
         * which needs to override any childs styles. StyleSheet of the child has a higher
         * specificity, because of the source order.
         * So our solution is to render sheets them in the reverse order child->sheet, so
         * that parent has a higher specificity.
         *
         * @type {Number}
         */


        var indexCounter = -100000;

        var NoRenderer = function NoRenderer(_ref) {
          var children = _ref.children;
          return children || null;
        };
        /**
         * HOC creator function that wrapps the user component.
         *
         * `injectSheet(styles, [options])(Component)`
         *
         * @api public
         */


        function injectSheet(stylesOrSheet) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          if (options.index === undefined) {
            options.index = indexCounter++;
          }

          return function () {
            var InnerComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NoRenderer;
            var Jss = (0, _createHoc2['default'])(stylesOrSheet, InnerComponent, options);
            return (0, _hoistNonReactStatics2['default'])(Jss, InnerComponent, {
              inner: true
            });
          };
        }
        /***/

      },

      /***/
      "./node_modules/react-jss/lib/jss.js":
      /*!*******************************************!*\
        !*** ./node_modules/react-jss/lib/jss.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibJssJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.createGenerateClassNameDefault = exports.SheetsManager = exports.getDynamicStyles = exports.SheetsRegistry = undefined;

        var _jss = __webpack_require__(
        /*! jss */
        "./node_modules/jss/lib/index.js");

        Object.defineProperty(exports, 'SheetsRegistry', {
          enumerable: true,
          get: function get() {
            return _jss.SheetsRegistry;
          }
        });
        Object.defineProperty(exports, 'getDynamicStyles', {
          enumerable: true,
          get: function get() {
            return _jss.getDynamicStyles;
          }
        });
        Object.defineProperty(exports, 'SheetsManager', {
          enumerable: true,
          get: function get() {
            return _jss.SheetsManager;
          }
        });
        Object.defineProperty(exports, 'createGenerateClassNameDefault', {
          enumerable: true,
          get: function get() {
            return _jss.createGenerateClassName;
          }
        });

        var _jssPresetDefault = __webpack_require__(
        /*! jss-preset-default */
        "./node_modules/jss-preset-default/lib/index.js");

        var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        exports['default'] = (0, _jss.create)((0, _jssPresetDefault2['default'])());
        /***/
      },

      /***/
      "./node_modules/react-jss/lib/ns.js":
      /*!******************************************!*\
        !*** ./node_modules/react-jss/lib/ns.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibNsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        /**
         * Namespaces to avoid conflicts on the context.
         */

        var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
        var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
        var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
        var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';
        /***/
      },

      /***/
      "./node_modules/react-jss/lib/propTypes.js":
      /*!*************************************************!*\
        !*** ./node_modules/react-jss/lib/propTypes.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactJssLibPropTypesJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _propTypes = __webpack_require__(
        /*! prop-types */
        "prop-types");

        exports['default'] = {
          jss: (0, _propTypes.shape)({
            options: (0, _propTypes.shape)({
              createGenerateClassName: _propTypes.func.isRequired
            }).isRequired,
            createStyleSheet: _propTypes.func.isRequired,
            removeStyleSheet: _propTypes.func.isRequired
          }),
          registry: (0, _propTypes.shape)({
            add: _propTypes.func.isRequired,
            toString: _propTypes.func.isRequired
          })
        };
        /***/
      },

      /***/
      "./node_modules/regexp.prototype.flags/implementation.js":
      /*!***************************************************************!*\
        !*** ./node_modules/regexp.prototype.flags/implementation.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegexpPrototypeFlagsImplementationJs(module, exports, __webpack_require__) {
        "use strict";

        var $Object = Object;
        var $TypeError = TypeError;

        module.exports = function flags() {
          if (this != null && this !== $Object(this)) {
            throw new $TypeError('RegExp.prototype.flags getter called on non-object');
          }

          var result = '';

          if (this.global) {
            result += 'g';
          }

          if (this.ignoreCase) {
            result += 'i';
          }

          if (this.multiline) {
            result += 'm';
          }

          if (this.dotAll) {
            result += 's';
          }

          if (this.unicode) {
            result += 'u';
          }

          if (this.sticky) {
            result += 'y';
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/regexp.prototype.flags/index.js":
      /*!******************************************************!*\
        !*** ./node_modules/regexp.prototype.flags/index.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegexpPrototypeFlagsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var define = __webpack_require__(
        /*! define-properties */
        "./node_modules/define-properties/index.js");

        var callBind = __webpack_require__(
        /*! es-abstract/helpers/callBind */
        "./node_modules/es-abstract/helpers/callBind.js");

        var implementation = __webpack_require__(
        /*! ./implementation */
        "./node_modules/regexp.prototype.flags/implementation.js");

        var getPolyfill = __webpack_require__(
        /*! ./polyfill */
        "./node_modules/regexp.prototype.flags/polyfill.js");

        var shim = __webpack_require__(
        /*! ./shim */
        "./node_modules/regexp.prototype.flags/shim.js");

        var flagsBound = callBind(implementation);
        define(flagsBound, {
          getPolyfill: getPolyfill,
          implementation: implementation,
          shim: shim
        });
        module.exports = flagsBound;
        /***/
      },

      /***/
      "./node_modules/regexp.prototype.flags/polyfill.js":
      /*!*********************************************************!*\
        !*** ./node_modules/regexp.prototype.flags/polyfill.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegexpPrototypeFlagsPolyfillJs(module, exports, __webpack_require__) {
        "use strict";

        var implementation = __webpack_require__(
        /*! ./implementation */
        "./node_modules/regexp.prototype.flags/implementation.js");

        var supportsDescriptors = __webpack_require__(
        /*! define-properties */
        "./node_modules/define-properties/index.js").supportsDescriptors;

        var $gOPD = Object.getOwnPropertyDescriptor;
        var $TypeError = TypeError;

        module.exports = function getPolyfill() {
          if (!supportsDescriptors) {
            throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
          }

          if (/a/mig.flags === 'gim') {
            var descriptor = $gOPD(RegExp.prototype, 'flags');

            if (descriptor && typeof descriptor.get === 'function' && typeof /a/.dotAll === 'boolean') {
              return descriptor.get;
            }
          }

          return implementation;
        };
        /***/

      },

      /***/
      "./node_modules/regexp.prototype.flags/shim.js":
      /*!*****************************************************!*\
        !*** ./node_modules/regexp.prototype.flags/shim.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegexpPrototypeFlagsShimJs(module, exports, __webpack_require__) {
        "use strict";

        var supportsDescriptors = __webpack_require__(
        /*! define-properties */
        "./node_modules/define-properties/index.js").supportsDescriptors;

        var getPolyfill = __webpack_require__(
        /*! ./polyfill */
        "./node_modules/regexp.prototype.flags/polyfill.js");

        var gOPD = Object.getOwnPropertyDescriptor;
        var defineProperty = Object.defineProperty;
        var TypeErr = TypeError;
        var getProto = Object.getPrototypeOf;
        var regex = /a/;

        module.exports = function shimFlags() {
          if (!supportsDescriptors || !getProto) {
            throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
          }

          var polyfill = getPolyfill();
          var proto = getProto(regex);
          var descriptor = gOPD(proto, 'flags');

          if (!descriptor || descriptor.get !== polyfill) {
            defineProperty(proto, 'flags', {
              configurable: true,
              enumerable: false,
              get: polyfill
            });
          }

          return polyfill;
        };
        /***/

      },

      /***/
      "./node_modules/simple-swizzle/index.js":
      /*!**********************************************!*\
        !*** ./node_modules/simple-swizzle/index.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesSimpleSwizzleIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var isArrayish = __webpack_require__(
        /*! is-arrayish */
        "./node_modules/is-arrayish/index.js");

        var concat = Array.prototype.concat;
        var slice = Array.prototype.slice;

        var swizzle = module.exports = function swizzle(args) {
          var results = [];

          for (var i = 0, len = args.length; i < len; i++) {
            var arg = args[i];

            if (isArrayish(arg)) {
              // http://jsperf.com/javascript-array-concat-vs-push/98
              results = concat.call(results, slice.call(arg));
            } else {
              results.push(arg);
            }
          }

          return results;
        };

        swizzle.wrap = function (fn) {
          return function () {
            return fn(swizzle(arguments));
          };
        };
        /***/

      },

      /***/
      "./node_modules/smoothscroll-polyfill/dist/smoothscroll.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/smoothscroll-polyfill/dist/smoothscroll.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSmoothscrollPolyfillDistSmoothscrollJs(module, exports, __webpack_require__) {
        /* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
        (function () {
          'use strict'; // polyfill

          function polyfill() {
            // aliases
            var w = window;
            var d = document; // return if scroll behavior is supported and polyfill is not forced

            if ('scrollBehavior' in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) {
              return;
            } // globals


            var Element = w.HTMLElement || w.Element;
            var SCROLL_TIME = 468; // object gathering original scroll methods

            var original = {
              scroll: w.scroll || w.scrollTo,
              scrollBy: w.scrollBy,
              elementScroll: Element.prototype.scroll || scrollElement,
              scrollIntoView: Element.prototype.scrollIntoView
            }; // define timing method

            var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
            /**
             * indicates if a the current browser is made by Microsoft
             * @method isMicrosoftBrowser
             * @param {String} userAgent
             * @returns {Boolean}
             */

            function isMicrosoftBrowser(userAgent) {
              var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];
              return new RegExp(userAgentPatterns.join('|')).test(userAgent);
            }
            /*
             * IE has rounding bug rounding down clientHeight and clientWidth and
             * rounding up scrollHeight and scrollWidth causing false positives
             * on hasScrollableSpace
             */


            var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
            /**
             * changes scroll position inside an element
             * @method scrollElement
             * @param {Number} x
             * @param {Number} y
             * @returns {undefined}
             */

            function scrollElement(x, y) {
              this.scrollLeft = x;
              this.scrollTop = y;
            }
            /**
             * returns result of applying ease math function to a number
             * @method ease
             * @param {Number} k
             * @returns {Number}
             */


            function ease(k) {
              return 0.5 * (1 - Math.cos(Math.PI * k));
            }
            /**
             * indicates if a smooth behavior should be applied
             * @method shouldBailOut
             * @param {Number|Object} firstArg
             * @returns {Boolean}
             */


            function shouldBailOut(firstArg) {
              if (firstArg === null || typeof firstArg !== 'object' || firstArg.behavior === undefined || firstArg.behavior === 'auto' || firstArg.behavior === 'instant') {
                // first argument is not an object/null
                // or behavior is auto, instant or undefined
                return true;
              }

              if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
                // first argument is an object and behavior is smooth
                return false;
              } // throw error when behavior is not supported


              throw new TypeError('behavior member of ScrollOptions ' + firstArg.behavior + ' is not a valid value for enumeration ScrollBehavior.');
            }
            /**
             * indicates if an element has scrollable space in the provided axis
             * @method hasScrollableSpace
             * @param {Node} el
             * @param {String} axis
             * @returns {Boolean}
             */


            function hasScrollableSpace(el, axis) {
              if (axis === 'Y') {
                return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
              }

              if (axis === 'X') {
                return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
              }
            }
            /**
             * indicates if an element has a scrollable overflow property in the axis
             * @method canOverflow
             * @param {Node} el
             * @param {String} axis
             * @returns {Boolean}
             */


            function canOverflow(el, axis) {
              var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];
              return overflowValue === 'auto' || overflowValue === 'scroll';
            }
            /**
             * indicates if an element can be scrolled in either axis
             * @method isScrollable
             * @param {Node} el
             * @param {String} axis
             * @returns {Boolean}
             */


            function isScrollable(el) {
              var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
              var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');
              return isScrollableY || isScrollableX;
            }
            /**
             * finds scrollable parent of an element
             * @method findScrollableParent
             * @param {Node} el
             * @returns {Node} el
             */


            function findScrollableParent(el) {
              while (el !== d.body && isScrollable(el) === false) {
                el = el.parentNode || el.host;
              }

              return el;
            }
            /**
             * self invoked function that, given a context, steps through scrolling
             * @method step
             * @param {Object} context
             * @returns {undefined}
             */


            function step(context) {
              var time = now();
              var value;
              var currentX;
              var currentY;
              var elapsed = (time - context.startTime) / SCROLL_TIME; // avoid elapsed times higher than one

              elapsed = elapsed > 1 ? 1 : elapsed; // apply easing to elapsed time

              value = ease(elapsed);
              currentX = context.startX + (context.x - context.startX) * value;
              currentY = context.startY + (context.y - context.startY) * value;
              context.method.call(context.scrollable, currentX, currentY); // scroll more if we have not reached our destination

              if (currentX !== context.x || currentY !== context.y) {
                w.requestAnimationFrame(step.bind(w, context));
              }
            }
            /**
             * scrolls window or element with a smooth behavior
             * @method smoothScroll
             * @param {Object|Node} el
             * @param {Number} x
             * @param {Number} y
             * @returns {undefined}
             */


            function smoothScroll(el, x, y) {
              var scrollable;
              var startX;
              var startY;
              var method;
              var startTime = now(); // define scroll context

              if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
              } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
              } // scroll looping over a frame


              step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
              });
            } // ORIGINAL METHODS OVERRIDES
            // w.scroll and w.scrollTo


            w.scroll = w.scrollTo = function () {
              // avoid action when no arguments are passed
              if (arguments[0] === undefined) {
                return;
              } // avoid smooth behavior if not required


              if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
              } // LET THE SMOOTHNESS BEGIN!


              smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
            }; // w.scrollBy


            w.scrollBy = function () {
              // avoid action when no arguments are passed
              if (arguments[0] === undefined) {
                return;
              } // avoid smooth behavior if not required


              if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
              } // LET THE SMOOTHNESS BEGIN!


              smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
            }; // Element.prototype.scroll and Element.prototype.scrollTo


            Element.prototype.scroll = Element.prototype.scrollTo = function () {
              // avoid action when no arguments are passed
              if (arguments[0] === undefined) {
                return;
              } // avoid smooth behavior if not required


              if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
                  throw new SyntaxError('Value could not be converted');
                }

                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
              }

              var left = arguments[0].left;
              var top = arguments[0].top; // LET THE SMOOTHNESS BEGIN!

              smoothScroll.call(this, this, typeof left === 'undefined' ? this.scrollLeft : ~~left, typeof top === 'undefined' ? this.scrollTop : ~~top);
            }; // Element.prototype.scrollBy


            Element.prototype.scrollBy = function () {
              // avoid action when no arguments are passed
              if (arguments[0] === undefined) {
                return;
              } // avoid smooth behavior if not required


              if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
              }

              this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
              });
            }; // Element.prototype.scrollIntoView


            Element.prototype.scrollIntoView = function () {
              // avoid smooth behavior if not required
              if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
              } // LET THE SMOOTHNESS BEGIN!


              var scrollableParent = findScrollableParent(this);
              var parentRects = scrollableParent.getBoundingClientRect();
              var clientRects = this.getBoundingClientRect();

              if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top); // reveal parent in viewport unless is fixed

                if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
                  w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: 'smooth'
                  });
                }
              } else {
                // reveal element in viewport
                w.scrollBy({
                  left: clientRects.left,
                  top: clientRects.top,
                  behavior: 'smooth'
                });
              }
            };
          }

          if (true) {
            // commonjs
            module.exports = {
              polyfill: polyfill
            };
          } else {}
        })();
        /***/

      },

      /***/
      "./node_modules/strict-uri-encode/index.js":
      /*!*************************************************!*\
        !*** ./node_modules/strict-uri-encode/index.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesStrictUriEncodeIndexJs(module, exports, __webpack_require__) {
        "use strict";

        module.exports = function (str) {
          return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
          });
        };
        /***/

      },

      /***/
      "./node_modules/style-loader/lib/addStyles.js":
      /*!****************************************************!*\
        !*** ./node_modules/style-loader/lib/addStyles.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesStyleLoaderLibAddStylesJs(module, exports, __webpack_require__) {
        /*
        	MIT License http://www.opensource.org/licenses/mit-license.php
        	Author Tobias Koppers @sokra
        */
        var stylesInDom = {};

        var memoize = function memoize(fn) {
          var memo;
          return function () {
            if (typeof memo === "undefined") memo = fn.apply(this, arguments);
            return memo;
          };
        };

        var isOldIE = memoize(function () {
          // Test for IE <= 9 as proposed by Browserhacks
          // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
          // Tests for existence of standard globals is to allow style-loader
          // to operate correctly into non-standard environments
          // @see https://github.com/webpack-contrib/style-loader/issues/177
          return window && document && document.all && !window.atob;
        });

        var getTarget = function getTarget(target, parent) {
          if (parent) {
            return parent.querySelector(target);
          }

          return document.querySelector(target);
        };

        var getElement = function (fn) {
          var memo = {};
          return function (target, parent) {
            // If passing function in options, then use it for resolve "head" element.
            // Useful for Shadow Root style i.e
            // {
            //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
            // }
            if (typeof target === 'function') {
              return target();
            }

            if (typeof memo[target] === "undefined") {
              var styleTarget = getTarget.call(this, target, parent); // Special case to return head of iframe instead of iframe itself

              if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
                try {
                  // This will throw an exception if access to iframe is blocked
                  // due to cross-origin restrictions
                  styleTarget = styleTarget.contentDocument.head;
                } catch (e) {
                  styleTarget = null;
                }
              }

              memo[target] = styleTarget;
            }

            return memo[target];
          };
        }();

        var singleton = null;
        var singletonCounter = 0;
        var stylesInsertedAtTop = [];

        var fixUrls = __webpack_require__(
        /*! ./urls */
        "./node_modules/style-loader/lib/urls.js");

        module.exports = function (list, options) {
          if (typeof DEBUG !== "undefined" && DEBUG) {
            if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
          }

          options = options || {};
          options.attrs = typeof options.attrs === "object" ? options.attrs : {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
          // tags it will allow on a page

          if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE(); // By default, add <style> tags to the <head> element

          if (!options.insertInto) options.insertInto = "head"; // By default, add <style> tags to the bottom of the target

          if (!options.insertAt) options.insertAt = "bottom";
          var styles = listToStyles(list, options);
          addStylesToDom(styles, options);
          return function update(newList) {
            var mayRemove = [];

            for (var i = 0; i < styles.length; i++) {
              var item = styles[i];
              var domStyle = stylesInDom[item.id];
              domStyle.refs--;
              mayRemove.push(domStyle);
            }

            if (newList) {
              var newStyles = listToStyles(newList, options);
              addStylesToDom(newStyles, options);
            }

            for (var i = 0; i < mayRemove.length; i++) {
              var domStyle = mayRemove[i];

              if (domStyle.refs === 0) {
                for (var j = 0; j < domStyle.parts.length; j++) {
                  domStyle.parts[j]();
                }

                delete stylesInDom[domStyle.id];
              }
            }
          };
        };

        function addStylesToDom(styles, options) {
          for (var i = 0; i < styles.length; i++) {
            var item = styles[i];
            var domStyle = stylesInDom[item.id];

            if (domStyle) {
              domStyle.refs++;

              for (var j = 0; j < domStyle.parts.length; j++) {
                domStyle.parts[j](item.parts[j]);
              }

              for (; j < item.parts.length; j++) {
                domStyle.parts.push(addStyle(item.parts[j], options));
              }
            } else {
              var parts = [];

              for (var j = 0; j < item.parts.length; j++) {
                parts.push(addStyle(item.parts[j], options));
              }

              stylesInDom[item.id] = {
                id: item.id,
                refs: 1,
                parts: parts
              };
            }
          }
        }

        function listToStyles(list, options) {
          var styles = [];
          var newStyles = {};

          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = options.base ? item[0] + options.base : item[0];
            var css = item[1];
            var media = item[2];
            var sourceMap = item[3];
            var part = {
              css: css,
              media: media,
              sourceMap: sourceMap
            };
            if (!newStyles[id]) styles.push(newStyles[id] = {
              id: id,
              parts: [part]
            });else newStyles[id].parts.push(part);
          }

          return styles;
        }

        function insertStyleElement(options, style) {
          var target = getElement(options.insertInto);

          if (!target) {
            throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
          }

          var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

          if (options.insertAt === "top") {
            if (!lastStyleElementInsertedAtTop) {
              target.insertBefore(style, target.firstChild);
            } else if (lastStyleElementInsertedAtTop.nextSibling) {
              target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
            } else {
              target.appendChild(style);
            }

            stylesInsertedAtTop.push(style);
          } else if (options.insertAt === "bottom") {
            target.appendChild(style);
          } else if (typeof options.insertAt === "object" && options.insertAt.before) {
            var nextSibling = getElement(options.insertAt.before, target);
            target.insertBefore(style, nextSibling);
          } else {
            throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
          }
        }

        function removeStyleElement(style) {
          if (style.parentNode === null) return false;
          style.parentNode.removeChild(style);
          var idx = stylesInsertedAtTop.indexOf(style);

          if (idx >= 0) {
            stylesInsertedAtTop.splice(idx, 1);
          }
        }

        function createStyleElement(options) {
          var style = document.createElement("style");

          if (options.attrs.type === undefined) {
            options.attrs.type = "text/css";
          }

          if (options.attrs.nonce === undefined) {
            var nonce = getNonce();

            if (nonce) {
              options.attrs.nonce = nonce;
            }
          }

          addAttrs(style, options.attrs);
          insertStyleElement(options, style);
          return style;
        }

        function createLinkElement(options) {
          var link = document.createElement("link");

          if (options.attrs.type === undefined) {
            options.attrs.type = "text/css";
          }

          options.attrs.rel = "stylesheet";
          addAttrs(link, options.attrs);
          insertStyleElement(options, link);
          return link;
        }

        function addAttrs(el, attrs) {
          Object.keys(attrs).forEach(function (key) {
            el.setAttribute(key, attrs[key]);
          });
        }

        function getNonce() {
          if (false) {}

          return __webpack_require__.nc;
        }

        function addStyle(obj, options) {
          var style, update, remove, result; // If a transform function was defined, run it on the css

          if (options.transform && obj.css) {
            result = typeof options.transform === 'function' ? options.transform(obj.css) : options.transform.default(obj.css);

            if (result) {
              // If transform returns a value, use that instead of the original css.
              // This allows running runtime transformations on the css.
              obj.css = result;
            } else {
              // If the transform function returns a falsy value, don't add this css.
              // This allows conditional loading of css
              return function () {// noop
              };
            }
          }

          if (options.singleton) {
            var styleIndex = singletonCounter++;
            style = singleton || (singleton = createStyleElement(options));
            update = applyToSingletonTag.bind(null, style, styleIndex, false);
            remove = applyToSingletonTag.bind(null, style, styleIndex, true);
          } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
            style = createLinkElement(options);
            update = updateLink.bind(null, style, options);

            remove = function remove() {
              removeStyleElement(style);
              if (style.href) URL.revokeObjectURL(style.href);
            };
          } else {
            style = createStyleElement(options);
            update = applyToTag.bind(null, style);

            remove = function remove() {
              removeStyleElement(style);
            };
          }

          update(obj);
          return function updateStyle(newObj) {
            if (newObj) {
              if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
                return;
              }

              update(obj = newObj);
            } else {
              remove();
            }
          };
        }

        var replaceText = function () {
          var textStore = [];
          return function (index, replacement) {
            textStore[index] = replacement;
            return textStore.filter(Boolean).join('\n');
          };
        }();

        function applyToSingletonTag(style, index, remove, obj) {
          var css = remove ? "" : obj.css;

          if (style.styleSheet) {
            style.styleSheet.cssText = replaceText(index, css);
          } else {
            var cssNode = document.createTextNode(css);
            var childNodes = style.childNodes;
            if (childNodes[index]) style.removeChild(childNodes[index]);

            if (childNodes.length) {
              style.insertBefore(cssNode, childNodes[index]);
            } else {
              style.appendChild(cssNode);
            }
          }
        }

        function applyToTag(style, obj) {
          var css = obj.css;
          var media = obj.media;

          if (media) {
            style.setAttribute("media", media);
          }

          if (style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            while (style.firstChild) {
              style.removeChild(style.firstChild);
            }

            style.appendChild(document.createTextNode(css));
          }
        }

        function updateLink(link, options, obj) {
          var css = obj.css;
          var sourceMap = obj.sourceMap;
          /*
          	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
          	and there is no publicPath defined then lets turn convertToAbsoluteUrls
          	on by default.  Otherwise default to the convertToAbsoluteUrls option
          	directly
          */

          var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

          if (options.convertToAbsoluteUrls || autoFixUrls) {
            css = fixUrls(css);
          }

          if (sourceMap) {
            // http://stackoverflow.com/a/26603875
            css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
          }

          var blob = new Blob([css], {
            type: "text/css"
          });
          var oldSrc = link.href;
          link.href = URL.createObjectURL(blob);
          if (oldSrc) URL.revokeObjectURL(oldSrc);
        }
        /***/

      },

      /***/
      "./node_modules/style-loader/lib/urls.js":
      /*!***********************************************!*\
        !*** ./node_modules/style-loader/lib/urls.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesStyleLoaderLibUrlsJs(module, exports) {
        /**
         * When source maps are enabled, `style-loader` uses a link element with a data-uri to
         * embed the css on the page. This breaks all relative urls because now they are relative to a
         * bundle instead of the current page.
         *
         * One solution is to only use full urls, but that may be impossible.
         *
         * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
         *
         * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
         *
         */
        module.exports = function (css) {
          // get current location
          var location = typeof window !== "undefined" && window.location;

          if (!location) {
            throw new Error("fixUrls requires window.location");
          } // blank or null?


          if (!css || typeof css !== "string") {
            return css;
          }

          var baseUrl = location.protocol + "//" + location.host;
          var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/"); // convert each url(...)

          /*
          This regular expression is just a way to recursively match brackets within
          a string.
          	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
             (  = Start a capturing group
               (?:  = Start a non-capturing group
                   [^)(]  = Match anything that isn't a parentheses
                   |  = OR
                   \(  = Match a start parentheses
                       (?:  = Start another non-capturing groups
                           [^)(]+  = Match anything that isn't a parentheses
                           |  = OR
                           \(  = Match a start parentheses
                               [^)(]*  = Match anything that isn't a parentheses
                           \)  = Match a end parentheses
                       )  = End Group
                       *\) = Match anything and then a close parens
                   )  = Close non-capturing group
                   *  = Match anything
                )  = Close capturing group
           \)  = Match a close parens
          	 /gi  = Get all matches, not the first.  Be case insensitive.
           */

          var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
            // strip quotes (if they exist)
            var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
              return $1;
            }).replace(/^'(.*)'$/, function (o, $1) {
              return $1;
            }); // already a full url? no change

            if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
              return fullMatch;
            } // convert the url to a full url


            var newUrl;

            if (unquotedOrigUrl.indexOf("//") === 0) {
              //TODO: should we add protocol?
              newUrl = unquotedOrigUrl;
            } else if (unquotedOrigUrl.indexOf("/") === 0) {
              // path should be relative to the base url
              newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
            } else {
              // path should be relative to current directory
              newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
            } // send back the fixed url(...)


            return "url(" + JSON.stringify(newUrl) + ")";
          }); // send back the fixed css

          return fixedCss;
        };
        /***/

      },

      /***/
      "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/actions/close.svg":
      /*!******************************************************************************************!*\
        !*** ./node_modules/svgson-loader!./node_modules/mrg-icons/src/mailru/actions/close.svg ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsNode_modulesMrgIconsSrcMailruActionsCloseSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "16",
            "height": "16",
            "viewBox": "0 0 16 16"
          },
          "childs": [{
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "d": "M6.586 8L4.293 5.707a.999.999 0 1 1 1.414-1.414L8 6.586l2.293-2.293a1 1 0 0 1 1.414 1.414L9.414 8l2.293 2.293a1 1 0 0 1-1.414 1.414L8 9.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L6.586 8z"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/actions/favorite_alt.svg":
      /*!*************************************************************************************************!*\
        !*** ./node_modules/svgson-loader!./node_modules/mrg-icons/src/mailru/actions/favorite_alt.svg ***!
        \*************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsNode_modulesMrgIconsSrcMailruActionsFavorite_altSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "16",
            "height": "16",
            "viewBox": "0 0 16 16"
          },
          "childs": [{
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "d": "M8 3.906l.514-.513C9.289 2.617 10.522 2 11.62 2c1.097 0 2.149.436 2.925 1.212l.233.233a4.134 4.134 0 0 1 0 5.85l-1.695 1.694.344-.343-3.144 3.144a3.228 3.228 0 0 1-4.566 0L1.736 9.809l-.514-.514a4.136 4.136 0 0 1 0-5.85l.233-.233A4.137 4.137 0 0 1 4.38 2c1.098 0 2.33.616 3.106 1.392L8 3.906z"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/categories/currency_rouble.svg":
      /*!*******************************************************************************************************!*\
        !*** ./node_modules/svgson-loader!./node_modules/mrg-icons/src/mailru/categories/currency_rouble.svg ***!
        \*******************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsNode_modulesMrgIconsSrcMailruCategoriesCurrency_roubleSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "16",
            "height": "16",
            "viewBox": "0 0 16 16"
          },
          "childs": [{
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "d": "M9.5 1C11.984 1 14 3.016 14 5.5S11.984 10 9.5 10H6v1h4.049a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0v-1H3a1 1 0 0 1 0-2h1v-1H3a1 1 0 0 1 0-2h1V2a1 1 0 0 1 1-1h4.5zm0 2H6v5h3.5a2.5 2.5 0 0 0 0-5z"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/categories/document.svg":
      /*!************************************************************************************************!*\
        !*** ./node_modules/svgson-loader!./node_modules/mrg-icons/src/mailru/categories/document.svg ***!
        \************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsNode_modulesMrgIconsSrcMailruCategoriesDocumentSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "16",
            "height": "16",
            "viewBox": "0 0 16 16"
          },
          "childs": [{
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "d": "M12 15H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.401a3.86 3.86 0 0 1 2.729 1.13l1.74 1.74A3.86 3.86 0 0 1 14 6.599V13a2 2 0 0 1-2 2zm-.5-3a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1h7zm0-2a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1h7zm0-2a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1h7zM7 5.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5zM6.5 3h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/categories/ticket.svg":
      /*!**********************************************************************************************!*\
        !*** ./node_modules/svgson-loader!./node_modules/mrg-icons/src/mailru/categories/ticket.svg ***!
        \**********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsNode_modulesMrgIconsSrcMailruCategoriesTicketSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "16",
            "height": "16",
            "viewBox": "0 0 16 16"
          },
          "childs": [{
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "d": "M16 4.658a.993.993 0 0 1-.346.753A3.432 3.432 0 0 0 14.491 8c0 1.031.445 1.958 1.154 2.6a.98.98 0 0 1 .34.742c.015.498.015 1.302.015 1.895a.765.765 0 0 1-.763.763H.763A.765.765 0 0 1 0 13.237v-1.895c0-.289.126-.564.346-.753A3.432 3.432 0 0 0 1.509 8 3.497 3.497 0 0 0 .355 5.4a.98.98 0 0 1-.34-.742C0 4.16 0 3.356 0 2.763A.765.765 0 0 1 .763 2h14.474a.765.765 0 0 1 .763.763v1.895zm-4 .932a.59.59 0 0 0-.59-.59H4.59a.59.59 0 0 0-.59.59v4.82c0 .326.264.59.59.59h6.82a.59.59 0 0 0 .59-.59V5.59zm-1 4.037a.373.373 0 0 1-.373.373H5.373A.373.373 0 0 1 5 9.627V6.373C5 6.167 5.167 6 5.373 6h5.254c.206 0 .373.167.373.373v3.254z"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/status/security_check.svg":
      /*!**************************************************************************************************!*\
        !*** ./node_modules/svgson-loader!./node_modules/mrg-icons/src/mailru/status/security_check.svg ***!
        \**************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsNode_modulesMrgIconsSrcMailruStatusSecurity_checkSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "16",
            "height": "16",
            "viewBox": "0 0 16 16"
          },
          "childs": [{
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "d": "M8.056 1c2.382 0 4.992.34 5.938.623.596.237.988.815.988 1.457C15 4.556 15 7.278 15 9.533c0 3.261-4.739 6.442-6.974 6.467H8c-2.224 0-7-3.193-7-6.467 0-2.255 0-4.977.018-6.453 0-.642.392-1.22.988-1.457C2.959 1.337 5.604.995 8 1h.056zm2.753 4.351c.14.009.274.041.4.103a1.01 1.01 0 0 1 .516 1.169c-.043.15-.121.283-.223.4a107.443 107.443 0 0 1-3.508 3.508c-.081.071-.17.132-.269.176a1.014 1.014 0 0 1-.808 0 1.073 1.073 0 0 1-.27-.176 63.268 63.268 0 0 1-2.056-2.056 1.054 1.054 0 0 1-.223-.4 1.028 1.028 0 0 1-.034-.366 1.02 1.02 0 0 1 .289-.615 1.01 1.01 0 0 1 .981-.255c.165.047.309.137.433.255l1.284 1.284c.922-.923 1.825-1.866 2.768-2.768l.071-.059c.154-.11.322-.175.511-.197.046-.003.092-.005.138-.003z"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./src/static/icons/document.svg":
      /*!********************************************************************!*\
        !*** ./node_modules/svgson-loader!./src/static/icons/document.svg ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsSrcStaticIconsDocumentSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "width": "12",
            "height": "14",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          },
          "childs": [{
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "clipRule": "evenodd",
              "d": "M10 14H2a2 2 0 01-2-2V2a2 2 0 012-2h4.401A3.86 3.86 0 019.13 1.13l1.74 1.74A3.86 3.86 0 0112 5.599V12a2 2 0 01-2 2zm-.5-3a.5.5 0 000-1h-7a.5.5 0 000 1h7zm0-2a.5.5 0 000-1h-7a.5.5 0 000 1h7zm0-2a.5.5 0 000-1h-7a.5.5 0 000 1h7zM5 4.5a.5.5 0 00-.5-.5h-2a.5.5 0 000 1h2a.5.5 0 00.5-.5zM4.5 2h-2a.5.5 0 000 1h2a.5.5 0 000-1z",
              "fill": "#333"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./src/static/icons/government.svg":
      /*!**********************************************************************!*\
        !*** ./node_modules/svgson-loader!./src/static/icons/government.svg ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsSrcStaticIconsGovernmentSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "width": "16px",
            "height": "16px",
            "viewBox": "0 0 16 16",
            "version": "1.1",
            "xmlns": "http://www.w3.org/2000/svg",
            "xmlnsXlink": "http://www.w3.org/1999/xlink"
          },
          "childs": [{
            "name": "title",
            "attrs": {},
            "childs": [{
              "text": "icon  /  categories  /  government"
            }]
          }, {
            "name": "desc",
            "attrs": {},
            "childs": [{
              "text": "Created with Sketch."
            }]
          }, {
            "name": "defs",
            "attrs": {},
            "childs": [{
              "name": "path",
              "attrs": {
                "d": "M10.3165966,6.365 C11.3965966,6.397 12.0525966,5.735 11.8975966,4.581 C11.8285966,3.883 12.1625966,3.176 12.8095966,2.802 L15.3725966,1.322 C15.8815966,2.203 15.5785966,3.331 14.6985966,3.84 L15.4965966,3.379 C16.0045966,4.26 15.7025966,5.388 14.8215966,5.896 L15.2205966,5.666 C15.7295966,6.547 15.4265966,7.675 14.5455966,8.184 L14.4775966,8.223 C14.5835966,9.282 14.0735966,9.712 13.7115966,9.92 C13.7115966,9.92 13.5655966,10.012 13.5485966,10.015 C12.7935966,10.448 12.4985966,10.452 11.6625966,10.498 L12.2325966,11.101 C12.5635966,10.928 12.9815966,10.987 13.2515966,11.27 C13.5775966,11.613 13.5645966,12.157 13.2205966,12.483 L12.3675966,13.296 C12.0245966,13.622 11.4805966,13.609 11.1545966,13.265 C10.9005966,12.999 10.8525966,12.612 11.0035966,12.299 L10.1745966,11.422 C10.1165966,11.512 10.0445966,11.591 9.96159658,11.656 C9.94559658,11.716 9.93659658,11.781 9.93459658,11.85 C9.92059658,12.578 10.2885966,13.064 10.6205966,13.353 C10.7245966,13.44 10.7825966,13.57 10.7785966,13.706 C10.7745966,13.841 10.7085966,13.967 10.5995966,14.048 C10.1585966,14.419 9.47959658,14.922 8.98859658,15.286 C8.62259658,15.558 8.12059658,15.558 7.75459658,15.286 C7.25559658,14.916 6.56259658,14.402 6.10059658,14.059 C5.98559658,13.974 5.91559658,13.842 5.90859658,13.7 C5.90059658,13.557 5.95759658,13.419 6.06359658,13.323 C6.41159658,13.038 6.79659658,12.538 6.80859658,11.85 C6.80959658,11.784 6.80259658,11.722 6.78959658,11.665 C6.71459658,11.607 6.64759658,11.539 6.59259658,11.462 L5.73059658,12.374 C5.84159658,12.672 5.78159658,13.02 5.54859658,13.265 C5.22159658,13.609 4.67859658,13.622 4.33459658,13.296 L3.48159658,12.483 C3.13859658,12.157 3.12459658,11.613 3.45159658,11.27 C3.73959658,10.967 4.19659658,10.921 4.53559658,11.139 L5.13859658,10.501 C4.25759658,10.452 3.96759658,10.458 3.19459658,10.015 C3.17759658,10.012 3.03159658,9.92 3.03159658,9.92 C2.66959658,9.712 2.15959658,9.282 2.26559658,8.223 L2.19759658,8.184 C1.31659658,7.675 1.01359658,6.547 1.52259658,5.666 L1.92159658,5.896 C1.04059658,5.388 0.738596578,4.26 1.24659658,3.379 L2.04459658,3.84 C1.16459658,3.331 0.861596578,2.203 1.37059658,1.322 L3.93359658,2.802 C4.58059658,3.176 4.91459658,3.883 4.84559658,4.581 C4.69059658,5.734 5.34559658,6.397 6.42359658,6.365 L6.42359658,5.747 L5.64259658,5.568 C5.52259658,5.54 5.42759658,5.449 5.39459658,5.331 C5.36159658,5.212 5.39559658,5.085 5.48459658,4.999 L6.65759658,3.865 C6.68759658,3.832 6.71959658,3.8 6.75459658,3.772 C6.91459658,3.638 7.12059658,3.558 7.34459658,3.558 C7.85359658,3.558 8.18959658,3.97 8.18959658,4.479 L8.18959658,5.806 C8.18959658,6.132 8.23159658,6.301 8.37159658,6.365 C8.50559658,6.3 8.55959658,6.135 8.55959658,5.806 L8.55959658,4.479 C8.55959658,3.97 8.88659658,3.558 9.39559658,3.558 C9.64859658,3.558 9.87859658,3.66 10.0445966,3.825 C10.0445966,3.825 10.7675966,4.524 11.2585966,4.999 C11.3475966,5.085 11.3815966,5.212 11.3485966,5.331 C11.3155966,5.449 11.2205966,5.54 11.1005966,5.568 C10.7275966,5.653 10.3195966,5.747 10.3195966,5.747 L10.3165966,5.739 L10.3165966,6.365 L10.3165966,6.365 Z M8.37159658,0 C9.09359658,0 9.68059658,0.586 9.68059658,1.308 C9.68059658,2.031 9.09359658,2.617 8.37159658,2.617 C7.64959658,2.617 7.06259658,2.031 7.06259658,1.308 C7.06259658,0.586 7.64959658,0 8.37159658,0 L8.37159658,0 L8.37159658,0 Z",
                "id": "path-1"
              }
            }]
          }, {
            "name": "g",
            "attrs": {
              "id": "taxes",
              "stroke": "none",
              "strokeWidth": "1",
              "fill": "none",
              "fillRule": "evenodd"
            },
            "childs": [{
              "name": "g",
              "attrs": {
                "id": "taxes_1",
                "transform": "translate(-415.000000, -232.000000)"
              },
              "childs": [{
                "name": "g",
                "attrs": {
                  "id": "panel",
                  "transform": "translate(399.000000, 218.000000)"
                },
                "childs": [{
                  "name": "g",
                  "attrs": {
                    "id": "icon--/--categories--/--government",
                    "transform": "translate(16.000000, 14.000000)"
                  },
                  "childs": [{
                    "name": "rect",
                    "attrs": {
                      "id": "bounds",
                      "x": "0",
                      "y": "0",
                      "width": "16",
                      "height": "16"
                    }
                  }, {
                    "name": "mask",
                    "attrs": {
                      "id": "mask-2",
                      "fill": "white"
                    },
                    "childs": [{
                      "name": "use",
                      "attrs": {
                        "xlinkHref": "#path-1"
                      }
                    }]
                  }, {
                    "name": "use",
                    "attrs": {
                      "id": "Shape",
                      "fill": "#E60100",
                      "xlinkHref": "#path-1"
                    }
                  }]
                }]
              }]
            }]
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./src/static/icons/info.svg":
      /*!****************************************************************!*\
        !*** ./node_modules/svgson-loader!./src/static/icons/info.svg ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsSrcStaticIconsInfoSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "width": "16",
            "height": "16",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          },
          "childs": [{
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "clipRule": "evenodd",
              "d": "M8 0c4.415 0 8 3.585 8 8s-3.585 8-8 8-8-3.585-8-8 3.585-8 8-8zm1.331 12a.996.996 0 000-1.993h-.333v-3.25c0-.443-.239-.757-.68-.757H6.683a1.006 1.006 0 000 2.01h.312v1.997h-.341a.997.997 0 100 1.993h2.677zM8 2.658a1.342 1.342 0 110 2.684 1.342 1.342 0 010-2.684z",
              "fill": "#E60100"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./src/static/icons/payment_center.svg":
      /*!**************************************************************************!*\
        !*** ./node_modules/svgson-loader!./src/static/icons/payment_center.svg ***!
        \**************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsSrcStaticIconsPayment_centerSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "width": "24",
            "height": "24",
            "viewBox": "0 0 24 24",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          },
          "childs": [{
            "name": "rect",
            "attrs": {
              "width": "24",
              "height": "24",
              "rx": "6",
              "fill": "#005FF9"
            }
          }, {
            "name": "circle",
            "attrs": {
              "cx": "12",
              "cy": "12",
              "r": "9",
              "fill": "#FF9E00"
            }
          }, {
            "name": "path",
            "attrs": {
              "fillRule": "evenodd",
              "clipRule": "evenodd",
              "d": "M13.125 6.75C14.988 6.75 16.5 8.262 16.5 10.125C16.5 11.988 14.988 13.5 13.125 13.5H10.5V14.25H13.5367C13.9507 14.25 14.2867 14.586 14.2867 15C14.2867 15.414 13.9507 15.75 13.5367 15.75H10.5V16.5C10.5 16.914 10.164 17.25 9.75 17.25C9.336 17.25 9 16.914 9 16.5V15.75H8.25C7.836 15.75 7.5 15.414 7.5 15C7.5 14.586 7.836 14.25 8.25 14.25H9V13.5H8.25C7.836 13.5 7.5 13.164 7.5 12.75C7.5 12.336 7.836 12 8.25 12H9V7.5C9 7.086 9.336 6.75 9.75 6.75H13.125ZM13.125 8.25H10.5V12H13.125C14.16 12 15 11.16 15 10.125C15 9.09 14.16 8.25 13.125 8.25Z",
              "fill": "white"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/svgson-loader/index.js!./src/static/icons/taxi_vezet.svg":
      /*!**********************************************************************!*\
        !*** ./node_modules/svgson-loader!./src/static/icons/taxi_vezet.svg ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSvgsonLoaderIndexJsSrcStaticIconsTaxi_vezetSvg(module, exports) {
        module.exports = {
          "name": "svg",
          "attrs": {
            "width": "16",
            "height": "10",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          },
          "childs": [{
            "name": "circle",
            "attrs": {
              "cx": "10.4",
              "cy": "7.9",
              "r": "1.8",
              "fill": "#333"
            }
          }, {
            "name": "circle",
            "attrs": {
              "cx": "4.5",
              "cy": "7.9",
              "r": "1.8",
              "fill": "#333"
            }
          }, {
            "name": "path",
            "attrs": {
              "d": "M.4 3.2h3L3 6.4H0l.4-3.2zM3.8 0h3l-.4 3.2h-3L3.8 0zm2.6 3.2h3l-.5 3.2H6l.5-3.2zM9.8 0h3l-.5 3.2h-3L9.8 0z",
              "fill": "#FF331E"
            }
          }, {
            "name": "path",
            "attrs": {
              "d": "M16 .4L12.8 0l-.2.7L16 .4zm-.2.8L12.5.8v.7l3.3-.3zm-.1.7l-3.3-.4v.8l3.3-.4zm-.1.8l-3.3-.4V3l3.3-.3zm-3.3.5h3l-.5 3.2h-3l.5-3.2z",
              "fill": "#FF331E"
            }
          }]
        };
        module.exports['default'] = module.exports;
        /***/
      },

      /***/
      "./node_modules/symbol-observable/es/index.js":
      /*!****************************************************!*\
        !*** ./node_modules/symbol-observable/es/index.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesSymbolObservableEsIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* WEBPACK VAR INJECTION */


        (function (global, module) {
          /* harmony import */
          var _ponyfill_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! ./ponyfill.js */
          "./node_modules/symbol-observable/es/ponyfill.js");
          /* global window */


          var root;

          if (typeof self !== 'undefined') {
            root = self;
          } else if (typeof window !== 'undefined') {
            root = window;
          } else if (typeof global !== 'undefined') {
            root = global;
          } else if (true) {
            root = module;
          } else {}

          var result = Object(_ponyfill_js__WEBPACK_IMPORTED_MODULE_0__["default"])(root);
          /* harmony default export */

          __webpack_exports__["default"] = result;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"), __webpack_require__(
        /*! ./../../webpack/buildin/harmony-module.js */
        "./node_modules/webpack/buildin/harmony-module.js")(module));
        /***/
      },

      /***/
      "./node_modules/symbol-observable/es/ponyfill.js":
      /*!*******************************************************!*\
        !*** ./node_modules/symbol-observable/es/ponyfill.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesSymbolObservableEsPonyfillJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return symbolObservablePonyfill;
        });

        function symbolObservablePonyfill(root) {
          var result;
          var Symbol = root.Symbol;

          if (typeof Symbol === 'function') {
            if (Symbol.observable) {
              result = Symbol.observable;
            } else {
              result = Symbol('observable');
              Symbol.observable = result;
            }
          } else {
            result = '@@observable';
          }

          return result;
        }

        ;
        /***/
      },

      /***/
      "./node_modules/theming/dist/esm/channel.js":
      /*!**************************************************!*\
        !*** ./node_modules/theming/dist/esm/channel.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesThemingDistEsmChannelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony default export */


        __webpack_exports__["default"] = '__THEMING__';
        /***/
      },

      /***/
      "./node_modules/theming/dist/esm/create-theme-listener.js":
      /*!****************************************************************!*\
        !*** ./node_modules/theming/dist/esm/create-theme-listener.js ***!
        \****************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesThemingDistEsmCreateThemeListenerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return createThemeListener;
        });
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! prop-types */
        "prop-types");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./channel */
        "./node_modules/theming/dist/esm/channel.js");

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function createThemeListener() {
          var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel__WEBPACK_IMPORTED_MODULE_1__["default"];

          var contextTypes = _defineProperty({}, CHANNEL, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.object.isRequired);

          function initial(context) {
            if (!context[CHANNEL]) {
              throw new Error('[' + this.displayName + '] Please use ThemeProvider to be able to use WithTheme');
            }

            return context[CHANNEL].getState();
          }

          function subscribe(context, cb) {
            if (context[CHANNEL]) {
              return context[CHANNEL].subscribe(cb);
            }
          }

          function unsubscribe(context, subscriptionId) {
            if (context[CHANNEL]) {
              context[CHANNEL].unsubscribe(subscriptionId);
            }
          }

          return {
            contextTypes: contextTypes,
            initial: initial,
            subscribe: subscribe,
            unsubscribe: unsubscribe
          };
        }
        /***/

      },

      /***/
      "./node_modules/theming/dist/esm/create-theme-provider.js":
      /*!****************************************************************!*\
        !*** ./node_modules/theming/dist/esm/create-theme-provider.js ***!
        \****************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesThemingDistEsmCreateThemeProviderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return createThemeProvider;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "prop-types");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var is_function__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! is-function */
        "./node_modules/is-function/index.js");
        /* harmony import */


        var is_function__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(is_function__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var is_plain_object__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! is-plain-object */
        "./node_modules/is-plain-object/index.js");
        /* harmony import */


        var is_plain_object__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(is_plain_object__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./channel */
        "./node_modules/theming/dist/esm/channel.js");
        /* harmony import */


        var brcast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! brcast */
        "./node_modules/brcast/dist/brcast.es.js");

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        /**
         * Provide a theme to an entire react component tree via context
         * and event listeners (have to do both context
         * and event emitter as pure components block context updates)
         */


        function createThemeProvider() {
          var _class, _temp2;

          var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel__WEBPACK_IMPORTED_MODULE_4__["default"];
          return _temp2 = _class = function (_React$Component) {
            _inherits(ThemeProvider, _React$Component);

            function ThemeProvider() {
              var _ref;

              var _temp, _this, _ret;

              _classCallCheck(this, ThemeProvider);

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.broadcast = Object(brcast__WEBPACK_IMPORTED_MODULE_5__["default"])(_this.getTheme()), _this.setOuterTheme = function (theme) {
                _this.outerTheme = theme;
              }, _temp), _possibleConstructorReturn(_this, _ret);
            }

            _createClass(ThemeProvider, [{
              key: 'getTheme',
              // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
              value: function getTheme(passedTheme) {
                var theme = passedTheme || this.props.theme;

                if (is_function__WEBPACK_IMPORTED_MODULE_2___default()(theme)) {
                  var mergedTheme = theme(this.outerTheme);

                  if (!is_plain_object__WEBPACK_IMPORTED_MODULE_3___default()(mergedTheme)) {
                    throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
                  }

                  return mergedTheme;
                }

                if (!is_plain_object__WEBPACK_IMPORTED_MODULE_3___default()(theme)) {
                  throw new Error('[ThemeProvider] Please make your theme prop a plain object');
                }

                if (!this.outerTheme) {
                  return theme;
                }

                return _extends({}, this.outerTheme, theme);
              }
            }, {
              key: 'getChildContext',
              value: function getChildContext() {
                return _defineProperty({}, CHANNEL, this.broadcast);
              }
            }, {
              key: 'componentDidMount',
              value: function componentDidMount() {
                // create a new subscription for keeping track of outer theme, if present
                if (this.context[CHANNEL]) {
                  this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
                }
              } // set broadcast state by merging outer theme with own

            }, {
              key: 'componentWillMount',
              value: function componentWillMount() {
                if (this.context[CHANNEL]) {
                  this.setOuterTheme(this.context[CHANNEL].getState());
                  this.broadcast.setState(this.getTheme());
                }
              }
            }, {
              key: 'componentWillReceiveProps',
              value: function componentWillReceiveProps(nextProps) {
                if (this.props.theme !== nextProps.theme) {
                  this.broadcast.setState(this.getTheme(nextProps.theme));
                }
              }
            }, {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                if (this.subscriptionId !== undefined) {
                  this.context[CHANNEL].unsubscribe(this.subscriptionId);
                  delete this.subscriptionId;
                }
              }
            }, {
              key: 'render',
              value: function render() {
                if (!this.props.children) {
                  return null;
                }

                return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(this.props.children);
              }
            }]);

            return ThemeProvider;
          }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component), _class.propTypes = {
            children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.element,
            theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({}), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]).isRequired
          }, _class.childContextTypes = _defineProperty({}, CHANNEL, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object.isRequired), _class.contextTypes = _defineProperty({}, CHANNEL, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object), _temp2;
        }
        /***/

      },

      /***/
      "./node_modules/theming/dist/esm/create-with-theme.js":
      /*!************************************************************!*\
        !*** ./node_modules/theming/dist/esm/create-with-theme.js ***!
        \************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesThemingDistEsmCreateWithThemeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return createWithTheme;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./channel */
        "./node_modules/theming/dist/esm/channel.js");
        /* harmony import */


        var _create_theme_listener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./create-theme-listener */
        "./node_modules/theming/dist/esm/create-theme-listener.js");

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var getDisplayName = function getDisplayName(Component) {
          return Component.displayName || Component.name || 'Component';
        };

        function createWithTheme() {
          var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel__WEBPACK_IMPORTED_MODULE_1__["default"];
          var themeListener = Object(_create_theme_listener__WEBPACK_IMPORTED_MODULE_2__["default"])(CHANNEL);
          return function (Component) {
            var _class, _temp;

            return _temp = _class = function (_React$Component) {
              _inherits(WithTheme, _React$Component);

              function WithTheme(props, context) {
                _classCallCheck(this, WithTheme);

                var _this = _possibleConstructorReturn(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));

                _this.state = {
                  theme: themeListener.initial(context)
                };

                _this.setTheme = function (theme) {
                  return _this.setState({
                    theme: theme
                  });
                };

                return _this;
              }

              _createClass(WithTheme, [{
                key: 'componentDidMount',
                value: function componentDidMount() {
                  this.unsubscribe = themeListener.subscribe(this.context, this.setTheme);
                }
              }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                  if (typeof this.unsubscribe === 'function') {
                    this.unsubscribe();
                  }
                }
              }, {
                key: 'render',
                value: function render() {
                  var theme = this.state.theme;
                  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({
                    theme: theme
                  }, this.props));
                }
              }]);

              return WithTheme;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component), _class.displayName = 'WithTheme(' + getDisplayName(Component) + ')', _class.contextTypes = themeListener.contextTypes, _temp;
          };
        }
        /***/

      },

      /***/
      "./node_modules/theming/dist/esm/index.js":
      /*!************************************************!*\
        !*** ./node_modules/theming/dist/esm/index.js ***!
        \************************************************/

      /*! exports provided: channel, withTheme, ThemeProvider, themeListener, createTheming, default */

      /***/
      function node_modulesThemingDistEsmIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "channel", function () {
          return channel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "withTheme", function () {
          return withTheme;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ThemeProvider", function () {
          return ThemeProvider;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "themeListener", function () {
          return themeListener;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createTheming", function () {
          return createTheming;
        });
        /* harmony import */


        var _create_theme_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./create-theme-provider */
        "./node_modules/theming/dist/esm/create-theme-provider.js");
        /* harmony import */


        var _create_with_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./create-with-theme */
        "./node_modules/theming/dist/esm/create-with-theme.js");
        /* harmony import */


        var _create_theme_listener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./create-theme-listener */
        "./node_modules/theming/dist/esm/create-theme-listener.js");
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./channel */
        "./node_modules/theming/dist/esm/channel.js");

        var channel = _channel__WEBPACK_IMPORTED_MODULE_3__["default"];
        var withTheme = Object(_create_with_theme__WEBPACK_IMPORTED_MODULE_1__["default"])();
        var ThemeProvider = Object(_create_theme_provider__WEBPACK_IMPORTED_MODULE_0__["default"])();
        var themeListener = Object(_create_theme_listener__WEBPACK_IMPORTED_MODULE_2__["default"])();

        function createTheming() {
          var customChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel__WEBPACK_IMPORTED_MODULE_3__["default"];
          return {
            channel: customChannel,
            withTheme: Object(_create_with_theme__WEBPACK_IMPORTED_MODULE_1__["default"])(customChannel),
            ThemeProvider: Object(_create_theme_provider__WEBPACK_IMPORTED_MODULE_0__["default"])(customChannel),
            themeListener: Object(_create_theme_listener__WEBPACK_IMPORTED_MODULE_2__["default"])(customChannel)
          };
        }
        /* harmony default export */


        __webpack_exports__["default"] = {
          channel: _channel__WEBPACK_IMPORTED_MODULE_3__["default"],
          withTheme: withTheme,
          ThemeProvider: ThemeProvider,
          themeListener: themeListener,
          createTheming: createTheming
        };
        /***/
      },

      /***/
      "./node_modules/tslib/tslib.es6.js":
      /*!*****************************************!*\
        !*** ./node_modules/tslib/tslib.es6.js ***!
        \*****************************************/

      /*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */

      /***/
      function node_modulesTslibTslibEs6Js(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__extends", function () {
          return __extends;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__assign", function () {
          return __assign;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__rest", function () {
          return __rest;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__decorate", function () {
          return __decorate;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__param", function () {
          return __param;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__metadata", function () {
          return __metadata;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__awaiter", function () {
          return __awaiter;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__generator", function () {
          return __generator;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__exportStar", function () {
          return __exportStar;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__values", function () {
          return __values;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__read", function () {
          return __read;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__spread", function () {
          return __spread;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__await", function () {
          return __await;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function () {
          return __asyncGenerator;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function () {
          return __asyncDelegator;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__asyncValues", function () {
          return __asyncValues;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function () {
          return __makeTemplateObject;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__importStar", function () {
          return __importStar;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "__importDefault", function () {
          return __importDefault;
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        /* global Reflect, Promise */


        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };

        function __extends(d, b) {
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        }

        var __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        function __rest(s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        }

        function __decorate(decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        }

        function __param(paramIndex, decorator) {
          return function (target, key) {
            decorator(target, key, paramIndex);
          };
        }

        function __metadata(metadataKey, metadataValue) {
          if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
        }

        function __awaiter(thisArg, _arguments, P, generator) {
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }

            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }

            function step(result) {
              result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
              }).then(fulfilled, rejected);
            }

            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }

        function __generator(thisArg, body) {
          var _ = {
            label: 0,
            sent: function sent() {
              if (t[0] & 1) throw t[1];
              return t[1];
            },
            trys: [],
            ops: []
          },
              f,
              y,
              t,
              g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;

          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }

          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");

            while (_) {
              try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];

                switch (op[0]) {
                  case 0:
                  case 1:
                    t = op;
                    break;

                  case 4:
                    _.label++;
                    return {
                      value: op[1],
                      done: false
                    };

                  case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;

                  case 7:
                    op = _.ops.pop();

                    _.trys.pop();

                    continue;

                  default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                      _ = 0;
                      continue;
                    }

                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                      _.label = op[1];
                      break;
                    }

                    if (op[0] === 6 && _.label < t[1]) {
                      _.label = t[1];
                      t = op;
                      break;
                    }

                    if (t && _.label < t[2]) {
                      _.label = t[2];

                      _.ops.push(op);

                      break;
                    }

                    if (t[2]) _.ops.pop();

                    _.trys.pop();

                    continue;
                }

                op = body.call(thisArg, _);
              } catch (e) {
                op = [6, e];
                y = 0;
              } finally {
                f = t = 0;
              }
            }

            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        }

        function __exportStar(m, exports) {
          for (var p in m) {
            if (!exports.hasOwnProperty(p)) exports[p] = m[p];
          }
        }

        function __values(o) {
          var m = typeof Symbol === "function" && o[Symbol.iterator],
              i = 0;
          if (m) return m.call(o);
          return {
            next: function next() {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
        }

        function __read(o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
              r,
              ar = [],
              e;

          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
              ar.push(r.value);
            }
          } catch (error) {
            e = {
              error: error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }

          return ar;
        }

        function __spread() {
          for (var ar = [], i = 0; i < arguments.length; i++) {
            ar = ar.concat(__read(arguments[i]));
          }

          return ar;
        }

        function __await(v) {
          return this instanceof __await ? (this.v = v, this) : new __await(v);
        }

        function __asyncGenerator(thisArg, _arguments, generator) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var g = generator.apply(thisArg, _arguments || []),
              i,
              q = [];
          return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
            return this;
          }, i;

          function verb(n) {
            if (g[n]) i[n] = function (v) {
              return new Promise(function (a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            };
          }

          function resume(n, v) {
            try {
              step(g[n](v));
            } catch (e) {
              settle(q[0][3], e);
            }
          }

          function step(r) {
            r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
          }

          function fulfill(value) {
            resume("next", value);
          }

          function reject(value) {
            resume("throw", value);
          }

          function settle(f, v) {
            if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
          }
        }

        function __asyncDelegator(o) {
          var i, p;
          return i = {}, verb("next"), verb("throw", function (e) {
            throw e;
          }), verb("return"), i[Symbol.iterator] = function () {
            return this;
          }, i;

          function verb(n, f) {
            if (o[n]) i[n] = function (v) {
              return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
              } : f ? f(v) : v;
            };
          }
        }

        function __asyncValues(o) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var m = o[Symbol.asyncIterator];
          return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
        }

        function __makeTemplateObject(cooked, raw) {
          if (Object.defineProperty) {
            Object.defineProperty(cooked, "raw", {
              value: raw
            });
          } else {
            cooked.raw = raw;
          }

          return cooked;
        }

        ;

        function __importStar(mod) {
          if (mod && mod.__esModule) return mod;
          var result = {};
          if (mod != null) for (var k in mod) {
            if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
          }
          result.default = mod;
          return result;
        }

        function __importDefault(mod) {
          return mod && mod.__esModule ? mod : {
            default: mod
          };
        }
        /***/

      },

      /***/
      "./node_modules/warning/browser.js":
      /*!*****************************************!*\
        !*** ./node_modules/warning/browser.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesWarningBrowserJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright 2014-2015, Facebook, Inc.
         * All rights reserved.
         *
         * This source code is licensed under the BSD-style license found in the
         * LICENSE file in the root directory of this source tree. An additional grant
         * of patent rights can be found in the PATENTS file in the same directory.
         */

        /**
         * Similar to invariant but only logs a warning if the condition is not met.
         * This can be used to log issues in development environments in critical
         * paths. Removing the logging code for production environments will keep the
         * same logic and follow the same code paths.
         */

        var warning = function warning() {};

        if (false) {}

        module.exports = warning;
        /***/
      },

      /***/
      "./node_modules/webpack/buildin/global.js":
      /*!***********************************!*\
        !*** (webpack)/buildin/global.js ***!
        \***********************************/

      /*! no static exports found */

      /***/
      function node_modulesWebpackBuildinGlobalJs(module, exports) {
        var g; // This works in non-strict mode

        g = function () {
          return this;
        }();

        try {
          // This works if eval is allowed (see CSP)
          g = g || new Function("return this")();
        } catch (e) {
          // This works if the window reference is available
          if (typeof window === "object") g = window;
        } // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}


        module.exports = g;
        /***/
      },

      /***/
      "./node_modules/webpack/buildin/harmony-module.js":
      /*!*******************************************!*\
        !*** (webpack)/buildin/harmony-module.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesWebpackBuildinHarmonyModuleJs(module, exports) {
        module.exports = function (originalModule) {
          if (!originalModule.webpackPolyfill) {
            var module = Object.create(originalModule); // module.parent = undefined by default

            if (!module.children) module.children = [];
            Object.defineProperty(module, "loaded", {
              enumerable: true,
              get: function get() {
                return module.l;
              }
            });
            Object.defineProperty(module, "id", {
              enumerable: true,
              get: function get() {
                return module.i;
              }
            });
            Object.defineProperty(module, "exports", {
              enumerable: true
            });
            module.webpackPolyfill = 1;
          }

          return module;
        };
        /***/

      },

      /***/
      "./node_modules/webpack/buildin/module.js":
      /*!***********************************!*\
        !*** (webpack)/buildin/module.js ***!
        \***********************************/

      /*! no static exports found */

      /***/
      function node_modulesWebpackBuildinModuleJs(module, exports) {
        module.exports = function (module) {
          if (!module.webpackPolyfill) {
            module.deprecate = function () {};

            module.paths = []; // module.parent = undefined by default

            if (!module.children) module.children = [];
            Object.defineProperty(module, "loaded", {
              enumerable: true,
              get: function get() {
                return module.l;
              }
            });
            Object.defineProperty(module, "id", {
              enumerable: true,
              get: function get() {
                return module.i;
              }
            });
            module.webpackPolyfill = 1;
          }

          return module;
        };
        /***/

      },

      /***/
      "./src/components/Address/Address.css":
      /*!********************************************!*\
        !*** ./src/components/Address/Address.css ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function srcComponentsAddressAddressCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./Address.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Address/Address.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Address/Address.tsx":
      /*!********************************************!*\
        !*** ./src/components/Address/Address.tsx ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsAddressAddressTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _Address_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./Address.css */
        "./src/components/Address/Address.css");
        /* harmony import */


        var _Address_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Address_css__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_eventConstants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/eventConstants */
        "./src/utils/eventConstants.ts");
        /* harmony import */


        var _utils_dataTestId__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/dataTestId */
        "./src/utils/dataTestId.ts");
        /* harmony import */


        var _Controls_Controls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Controls/Controls */
        "./src/components/Address/Controls/Controls.tsx");
        /* harmony import */


        var _components_Address_Header_Header__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/components/Address/Header/Header */
        "./src/components/Address/Header/Header.tsx");
        /* harmony import */


        var _utils_dates__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/dates */
        "./src/utils/dates.ts");
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics5 = function extendStatics(d, b) {
            _extendStatics5 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics5(d, b);
          };

          return function (d, b) {
            _extendStatics5(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var Address =
        /** @class */
        function (_super) {
          __extends(Address, _super);

          function Address() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.onMouseDown = function () {
              var _a = _this.props,
                  startDate = _a.startDate,
                  letterTimestamp = _a.letterTimestamp,
                  radar = _a.radar;
              var params = {
                i: Object(_utils_constants__WEBPACK_IMPORTED_MODULE_12__["getEventRadarParams"])(startDate, letterTimestamp)
              };
              radar(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].addressClickLink, params);
            };

            return _this;
          }

          Address.prototype.componentDidMount = function () {
            var _a = this.props,
                startDate = _a.startDate,
                letterTimestamp = _a.letterTimestamp,
                radar = _a.radar,
                timingStart = _a.timingStart,
                timingNow = _a.timingNow;
            var params = Object(_utils_constants__WEBPACK_IMPORTED_MODULE_12__["getEventRadarParams"])(startDate, letterTimestamp);
            var timingsParams = {};

            if (typeof timingStart === 'number' && !Number.isNaN(timingStart) && timingNow) {
              timingsParams = {
                timing: timingNow() - timingStart
              };
            }

            radar(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].addressShow, {
              i: __assign(__assign({}, params), timingsParams)
            });
          };

          Address.prototype.getHeader = function () {
            var name = this.props.name;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Address_Header_Header__WEBPACK_IMPORTED_MODULE_10__["AddressHeader"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], null, name));
          };

          Address.prototype.getMapUrl = function () {
            var _a = this.props,
                street = _a.street,
                locality = _a.locality;
            return _utils_eventConstants__WEBPACK_IMPORTED_MODULE_7__["MAP_URL"] + "&query=" + locality + "+" + street;
          };

          Address.prototype.getAddress = function () {
            var _a = this.props,
                locality = _a.locality,
                street = _a.street;
            var address = locality + ", " + street;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "details-item"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "details-name"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: 'small',
              secondary: true
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_6__["i18n"])(_utils_eventConstants__WEBPACK_IMPORTED_MODULE_7__["messages"].address))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              "data-test-id": _utils_dataTestId__WEBPACK_IMPORTED_MODULE_8__["EDataTestId"].ADDRESS_HEADER_LINK
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Link"], {
              href: this.getMapUrl(),
              target: '_blank',
              onMouseDown: this.onMouseDown,
              "data-test-id": _utils_dataTestId__WEBPACK_IMPORTED_MODULE_8__["EDataTestId"].ADDRESS_HEADER_LINK
            }, address)));
          };

          Address.prototype.getEventDate = function () {
            var startDate = this.props.startDate;
            var month = "month" + startDate.getMonth();
            var weekDay = "day" + startDate.getDay();
            var minutes = startDate.getMinutes() || '00';
            var startTime = startDate.getHours() + ":" + minutes;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], null, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_6__["i18n"])(_utils_dates__WEBPACK_IMPORTED_MODULE_11__["MONTHS"][month], {
              day: startDate.getDate()
            }), ", \xA0", Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_6__["i18n"])(_utils_dates__WEBPACK_IMPORTED_MODULE_11__["DAYS"][weekDay]), ", \xA0", startTime);
          };

          Address.prototype.getDateInfo = function () {
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "details-item"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "details-name"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: 'small',
              secondary: true
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_6__["i18n"])(_utils_eventConstants__WEBPACK_IMPORTED_MODULE_7__["messages"].date))), this.getEventDate());
          };

          Address.prototype.getControls = function () {
            var _a = this.props,
                locality = _a.locality,
                startDate = _a.startDate,
                letterTimestamp = _a.letterTimestamp,
                email = _a.email,
                calendar = _a.calendar,
                taxi = _a.taxi;
            var showTaxi = taxi && locality === _utils_constants__WEBPACK_IMPORTED_MODULE_12__["TAXI_LOCALITY"];

            if (!showTaxi && !calendar) {
              return null;
            }

            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_Controls_Controls__WEBPACK_IMPORTED_MODULE_9__["default"], {
              startDate: startDate,
              letterDate: letterTimestamp,
              email: email,
              calendar: calendar,
              taxi: showTaxi,
              radar: this.props.radar
            });
          };

          Address.prototype.render = function () {
            var _a;

            var darkMode = this.props.darkMode;
            var className = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_a = {}, _a[_Address_css__WEBPACK_IMPORTED_MODULE_4___default.a.base] = true, _a[_Address_css__WEBPACK_IMPORTED_MODULE_4___default.a.baseBlack] = darkMode, _a));
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className,
              "data-test-id": _utils_dataTestId__WEBPACK_IMPORTED_MODULE_8__["EDataTestId"].ADDRESS_HEADER
            }, this.getHeader(), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Hr"], {
              oversize: false,
              responsive: "desktop"
            }), this.getDateInfo(), this.getAddress(), this.getControls());
          };

          Address = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_1__(_Address_css__WEBPACK_IMPORTED_MODULE_4___default.a)], Address);
          return Address;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);
        /* harmony default export */


        __webpack_exports__["default"] = Address;
        /***/
      },

      /***/
      "./src/components/Address/Controls/Controls.tsx":
      /*!******************************************************!*\
        !*** ./src/components/Address/Controls/Controls.tsx ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsAddressControlsControlsTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _utils_dataTestId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/utils/dataTestId */
        "./src/utils/dataTestId.ts");
        /* harmony import */


        var _components_Controls_ControlCalendar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/components/Controls/ControlCalendar */
        "./src/components/Controls/ControlCalendar.tsx");
        /* harmony import */


        var _components_Controls_ControlsContainer_tsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/components/Controls/ControlsContainer.tsx */
        "./src/components/Controls/ControlsContainer.tsx");
        /* harmony import */


        var _interfaces_ICalendar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/interfaces/ICalendar */
        "./src/interfaces/ICalendar.ts");
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _components_Controls_Elements__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/components/Controls/Elements */
        "./src/components/Controls/Elements.tsx");
        /* harmony import */


        var svgson_loader_static_icons_taxi_vezet_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! svgson-loader!@/static/icons/taxi_vezet.svg */
        "./node_modules/svgson-loader/index.js!./src/static/icons/taxi_vezet.svg");
        /* harmony import */


        var svgson_loader_static_icons_taxi_vezet_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_static_icons_taxi_vezet_svg__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics6 = function extendStatics(d, b) {
            _extendStatics6 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics6(d, b);
          };

          return function (d, b) {
            _extendStatics6(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var Controls =
        /** @class */
        function (_super) {
          __extends(Controls, _super);

          function Controls() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          Controls.prototype.getCalendarButton = function () {
            var _a = this.props,
                email = _a.email,
                calendar = _a.calendar,
                radar = _a.radar,
                startDate = _a.startDate,
                letterDate = _a.letterDate;
            var href = Object(_interfaces_ICalendar__WEBPACK_IMPORTED_MODULE_4__["formCalendarHref"])(calendar, email);

            if (!href) {
              return null;
            }

            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Controls_ControlCalendar__WEBPACK_IMPORTED_MODULE_2__["ControlCalendar"], {
              primary: true,
              href: href,
              sender: radar,
              radarParams: {
                i: Object(_utils_constants__WEBPACK_IMPORTED_MODULE_5__["getEventRadarParams"])(startDate, letterDate)
              }
            });
          };

          Controls.prototype.getTaxiButton = function () {
            var _a = this.props,
                taxi = _a.taxi,
                radar = _a.radar,
                startDate = _a.startDate,
                letterDate = _a.letterDate;

            if (!taxi) {
              return null;
            }

            var radarParams = {
              i: Object(_utils_constants__WEBPACK_IMPORTED_MODULE_5__["getEventRadarParams"])(startDate, letterDate)
            };
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Controls_Elements__WEBPACK_IMPORTED_MODULE_6__["SmartButton"], {
              sender: radar,
              testId: _utils_dataTestId__WEBPACK_IMPORTED_MODULE_1__["EDataTestId"].ADDRESS_HEADER_TAXI,
              icon: svgson_loader_static_icons_taxi_vezet_svg__WEBPACK_IMPORTED_MODULE_7___default.a,
              primary: false,
              contrast: true,
              href: _utils_constants__WEBPACK_IMPORTED_MODULE_5__["TAXI_URL"],
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_8__["i18n"])(_utils_constants__WEBPACK_IMPORTED_MODULE_5__["CONTROLS_MESSAGES"].taxi),
              radarOnMount: {
                t: _utils_radarName__WEBPACK_IMPORTED_MODULE_9__["default"].addressTaxiShow,
                params: radarParams
              },
              radar: {
                t: _utils_radarName__WEBPACK_IMPORTED_MODULE_9__["default"].addressTaxiClick,
                params: radarParams
              }
            });
          };

          Controls.prototype.render = function () {
            var calendarButton = this.getCalendarButton();
            var taxiButton = this.getTaxiButton();
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Controls_ControlsContainer_tsx__WEBPACK_IMPORTED_MODULE_3__["ControlsDefaultSpace"], {
              paddingTop: true
            }, calendarButton, taxiButton);
          };

          return Controls;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);
        /* harmony default export */


        __webpack_exports__["default"] = Controls;
        /***/
      },

      /***/
      "./src/components/Address/Header/Header.tsx":
      /*!**************************************************!*\
        !*** ./src/components/Address/Header/Header.tsx ***!
        \**************************************************/

      /*! exports provided: AddressHeader */

      /***/
      function srcComponentsAddressHeaderHeaderTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "AddressHeader", function () {
          return AddressHeader;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_categories_ticket_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! svgson-loader!mrg-icons/src/mailru/categories/ticket.svg */
        "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/categories/ticket.svg");
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_categories_ticket_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_mrg_icons_src_mailru_categories_ticket_svg__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _components_Header_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/components/Header/Header */
        "./src/components/Header/Header.tsx");
        /* harmony import */


        var _utils_eventConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/utils/eventConstants */
        "./src/utils/eventConstants.ts");
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");

        var AddressHeader = function AddressHeader(props) {
          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Header_Header__WEBPACK_IMPORTED_MODULE_2__["Header"], {
            icon: svgson_loader_mrg_icons_src_mailru_categories_ticket_svg__WEBPACK_IMPORTED_MODULE_1___default.a,
            color: _components_Header_Header__WEBPACK_IMPORTED_MODULE_2__["EIconColors"].BLUE,
            text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(_utils_eventConstants__WEBPACK_IMPORTED_MODULE_3__["messages"].tickets)
          }, props.children);
        };
        /***/

      },

      /***/
      "./src/components/Address/index.ts":
      /*!*****************************************!*\
        !*** ./src/components/Address/index.ts ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsAddressIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Address */
        "./src/components/Address/Address.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Address__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Bill/Bill.css":
      /*!**************************************!*\
        !*** ./src/components/Bill/Bill.css ***!
        \**************************************/

      /*! no static exports found */

      /***/
      function srcComponentsBillBillCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./Bill.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Bill/Bill.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Bill/Bill.tsx":
      /*!**************************************!*\
        !*** ./src/components/Bill/Bill.tsx ***!
        \**************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsBillBillTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _Bill_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Bill.css */
        "./src/components/Bill/Bill.css");
        /* harmony import */


        var _Bill_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Bill_css__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/components/BillingInfoTooltip */
        "./src/components/BillingInfoTooltip/index.ts");
        /* harmony import */


        var _components_Bill_components_BillButtons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/components/Bill/components/BillButtons */
        "./src/components/Bill/components/BillButtons/index.ts");
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/components/PaymentStatus */
        "./src/components/PaymentStatus/index.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics7 = function extendStatics(d, b) {
            _extendStatics7 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics7(d, b);
          };

          return function (d, b) {
            _extendStatics7(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };
        /* tslint:disable:no-implicit-dependencies */


        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_11__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_12__["EHeaderTypes"].LETTER_META); // tslint:disable:max-line-length

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_4__["defineMessages"])({
          billFor: {
            "id": "R4DTuQ==",
            "defaultMessage": "\u0421\u0447\u0435\u0442 \u043D\u0430 {amount}"
          },
          period: {
            "id": "KQPEaQ==",
            "defaultMessage": "\u041F\u0435\u0440\u0438\u043E\u0434:"
          },
          payer: {
            "id": "6mTtsQ==",
            "defaultMessage": "\u041F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A:"
          },
          address: {
            "id": "CjAdeQ==",
            "defaultMessage": "\u0410\u0434\u0440\u0435\u0441:"
          },
          additionalInfo: {
            "id": "HH9M0A==",
            "defaultMessage": "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443 \xAB\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C\xBB, \u0412\u044B \u0434\u0430\u0435\u0442\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0442\u0435\u043C, \u0447\u0442\u043E \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0435 \u043E\u043A\u043D\u043E \xAB\u0414\u0415\u041D\u042C\u0413\u0418.\u041C\u042D\u0419\u041B.\u0420\u0423\xBB \u0441 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u0440\u0435\u0434\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u043C\u0438\u0441\u044F \u0432 \u044D\u0442\u043E\u043C \u043F\u0438\u0441\u044C\u043C\u0435."
          },
          additionalInfoDetails: {
            "id": "3BSZKg==",
            "defaultMessage": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"
          },
          additionalInfoMore: {
            "id": "cD2Hew==",
            "defaultMessage": "\u0421\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0442\u0435\u043C, \u0447\u0442\u043E \u0432 \u0446\u0435\u043B\u044F\u0445 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u0412\u0430\u043C\u0438 \u0443\u0441\u043B\u0443\u0433 \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u043F\u0438\u0441\u044C\u043C\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0435 \u043E\u043A\u043D\u043E \u0420\u041D\u041A\u041E \xAB\u0414\u0415\u041D\u042C\u0413\u0418.\u041C\u042D\u0419\u041B.\u0420\u0423\xBB (\u041E\u041E\u041E) \u0431\u0443\u0434\u0435\u0442 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0430\u043B\u0433\u043E\u0440\u0438\u0442\u043C\u0430 \u043F\u0440\u0435\u0434\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u0434\u0430\u043D\u043D\u044B\u043C\u0438, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u043C\u0438\u0441\u044F \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u043F\u0438\u0441\u044C\u043C\u0435 \u0438/\u0438\u043B\u0438 \u0435\u0433\u043E \u0432\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0445. \u0414\u0430\u043D\u043D\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0442\u0430\u043A\u0436\u0435 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0432\u0441\u0435\u0445 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u043F\u0438\u0441\u0435\u043C \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u043E\u0433\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u044F."
          },
          billingHeader: {
            "id": "0eBx8A==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0430 \u0431\u0435\u0437 \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A\u043E\u0432 \u0447\u0435\u0440\u0435\u0437{br}\u043F\u043B\u0430\u0442\u0435\u0436\u043D\u0443\u044E \u0441\u0438\u0441\u0442\u0435\u043C\u0443 Mail.ru"
          },
          billingMosenergoHeader: {
            "id": "F2Srrw==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u0440\u044F\u043C\u043E{br}\u0432{nbsp}\u041F\u043E\u0447\u0442\u0435"
          }
        }); // tslint:enable:max-line-length

        var Bill =
        /** @class */
        function (_super) {
          __extends(Bill, _super);

          function Bill() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              infoWidth: 0,
              isMoreInfoClick: false,
              isDetailedPopupOpen: false
            };

            _this.onDetailedClose = function () {
              _this.setState({
                isDetailedPopupOpen: false
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(false);
              }
            };

            _this.onDetailedClick = function () {
              _this.setState({
                isDetailedPopupOpen: true
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(true);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].clickDetailedLink);
            };

            _this.onMoreInfoClick = function () {
              _this.setState({
                isMoreInfoClick: true
              });

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].clickMoreInfoLink);
            };

            _this.onResize = function () {
              if (_this.props.moreInfo) {
                _this.infoWrapperRef.style.width = _this.billMainRef.clientWidth + "px";
              }
            };

            return _this;
          }

          Bill.prototype.componentWillMount = function () {
            window.addEventListener('resize', this.onResize);
          };

          Bill.prototype.componentDidMount = function () {
            var moreInfo = this.props.moreInfo;

            if (moreInfo) {
              this.billMainRef.clientWidth === 0 ? this.infoWrapperRef.style.width = '100%' : this.infoWrapperRef.style.width = this.billMainRef.clientWidth + "px";
            }

            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].showDie);
          };

          Bill.prototype.componentDidUpdate = function () {
            if (this.props.moreInfo) {
              this.infoWrapperRef.style.width = this.billMainRef.clientWidth + "px";
            }
          };

          Bill.prototype.componentWillUnmount = function () {
            window.removeEventListener('resize', this.onResize);
          };

          Object.defineProperty(Bill.prototype, "billingHeader", {
            get: function get() {
              var merchant_id = this.props.context.paymentInfo.merchant_id;
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_4__["FormattedMessage"], __assign({}, messages[merchant_id === 'mosenergo' ? 'billingMosenergoHeader' : 'billingHeader'], {
                values: {
                  nbsp: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, "\xA0"),
                  br: react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("br", null)
                }
              }));
            },
            enumerable: true,
            configurable: true
          });

          Bill.prototype.render = function () {
            var _a;

            var _this = this;

            var _b = this.props.context,
                _c = _b.paymentInfo,
                amount = _c.amount,
                period = _c.period,
                payer = _c.payer,
                address = _c.address,
                status = _c.status,
                paymentUrl = _b.paymentUrl,
                octavius = _b.octavius;
            var _d = this.props,
                moreInfo = _d.moreInfo,
                detailedUrl = _d.detailedUrl,
                darkMode = _d.darkMode;
            var _e = this.state,
                isMoreInfoClick = _e.isMoreInfoClick,
                isDetailedPopupOpen = _e.isDetailedPopupOpen;
            var moreInfoClassName = isMoreInfoClick ? 'more-info-disabled' : 'more-info';
            var mainStyle = octavius ? 'bill-main-octavius' : 'bill-main';
            var className = classnames__WEBPACK_IMPORTED_MODULE_13___default()((_a = {}, _a[_Bill_css__WEBPACK_IMPORTED_MODULE_6___default.a[mainStyle]] = true, _a[_Bill_css__WEBPACK_IMPORTED_MODULE_6___default.a['bill-main-octavius-darkMode']] = octavius && darkMode, _a)); // @TODO header  можно вынести общим компонентом

            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className,
              ref: function ref(element) {
                return _this.billMainRef = element;
              },
              "data-test-id": "bill_die"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "billing-info"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_7__["default"], {
              header: this.billingHeader
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header-text"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: "h4",
              testId: "header"
            }, "\u0421\u0447\u0435\u0442 \u043D\u0430 ", amount, "\xA0", react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Rouble"], null))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_PaymentStatus__WEBPACK_IMPORTED_MODULE_10__["default"], {
              status: status
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["FramePopup"], {
              src: detailedUrl,
              initialWidth: _utils_constants__WEBPACK_IMPORTED_MODULE_14__["SIZE_POPUP"].small,
              initialHeight: _utils_constants__WEBPACK_IMPORTED_MODULE_14__["GIBDD_POPUP_HEIGHT"],
              show: isDetailedPopupOpen,
              onHide: this.onDetailedClose,
              closeByEsc: true
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "payment-info"
            }, period && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "payment-info-element"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: "small"
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.period), " ", period)), payer && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "payment-info-element"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: "small"
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.payer), " ", payer)), address && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "payment-info-element"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: "small"
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.address), " ", address))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Bill_components_BillButtons__WEBPACK_IMPORTED_MODULE_8__["default"], {
              paymentUrl: paymentUrl,
              moreInfo: moreInfo
            })), moreInfo && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "additional-info",
              ref: function ref(element) {
                return _this.infoWrapperRef = element;
              },
              "data-test-id": isMoreInfoClick ? 'full' : 'not-full'
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: "extra_small",
              secondary: true
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.additionalInfo), "\xA0", react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: moreInfoClassName,
              "data-test-id": moreInfoClassName,
              onClick: this.onMoreInfoClick
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Link"], null, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.additionalInfoDetails)))), isMoreInfoClick && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: "extra_small",
              secondary: true
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.additionalInfoMore))));
          };

          Bill = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_1__(_Bill_css__WEBPACK_IMPORTED_MODULE_6___default.a)], Bill);
          return Bill;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_9__["withContext"])(Bill);
        /***/
      },

      /***/
      "./src/components/Bill/components/BillButtons/BillButtons.tsx":
      /*!********************************************************************!*\
        !*** ./src/components/Bill/components/BillButtons/BillButtons.tsx ***!
        \********************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsBillComponentsBillButtonsBillButtonsTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _components_Bill_Bill_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/components/Bill/Bill.css */
        "./src/components/Bill/Bill.css");
        /* harmony import */


        var _components_Bill_Bill_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_components_Bill_Bill_css__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/components/PaymentStatus */
        "./src/components/PaymentStatus/index.ts");
        /* harmony import */


        var _components_ReloadStatus_ReloadStatus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/components/ReloadStatus/ReloadStatus */
        "./src/components/ReloadStatus/ReloadStatus.tsx");
        /* harmony import */


        var _components_ReceiptButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/components/ReceiptButton */
        "./src/components/ReceiptButton/index.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics8 = function extendStatics(d, b) {
            _extendStatics8 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics8(d, b);
          };

          return function (d, b) {
            _extendStatics8(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_11__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_12__["EHeaderTypes"].LETTER_META);
        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_3__["defineMessages"])({
          pay: {
            "id": "kUxRAg==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C"
          },
          showReceipt: {
            "id": "IbJgyg==",
            "defaultMessage": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043A\u0432\u0438\u0442\u0430\u043D\u0446\u0438\u044E"
          },
          downloadReceipt: {
            "id": "E89AYA==",
            "defaultMessage": "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043A\u0432\u0438\u0442\u0430\u043D\u0446\u0438\u044E"
          },
          paymentBill: {
            "id": "JdwJbw==",
            "defaultMessage": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0447\u0435\u043A \u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u0435"
          }
        });

        var BillButtons =
        /** @class */
        function (_super) {
          __extends(BillButtons, _super);

          function BillButtons() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              isOpen: false
            };

            _this.onPayedClick = function () {
              _this.setState({
                isOpen: true
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(true);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].clickButtonPayment);
            };

            _this.onPayedClose = function () {
              _this.setState({
                isOpen: false
              });

              var moreInfo = _this.props.moreInfo;
              var _a = _this.props.context,
                  onPopupToggle = _a.onPopupToggle,
                  flags = _a.flags;

              if (onPopupToggle) {
                onPopupToggle(false);
              }

              if (moreInfo) {
                // В iframe оплаты ставится хелпер, скрывающий юридическую информацию.
                // Нужно обновить локальное состояние хелперов.
                flags.fetch();
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].paymentClose);
            };

            _this.onShowReceipt = function (evt) {
              window.open(_this.pdfLink(), '_blank');
              evt.preventDefault();
              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].showReceipt);
            };

            _this.pdfLink = function () {
              var _a = _this.props.context,
                  attachid = _a.paymentInfo.attachid,
                  octavius = _a.octavius;
              var pdfLink = _this.props.context.paymentInfo.pdfLink;

              if (attachid) {
                var separator = attachid.indexOf(';');
                var page = octavius ? 'attach' : 'attachment';
                pdfLink = "/" + page + "/" + attachid.slice(0, separator) + "/" + attachid.slice(separator + 1, attachid.length);
              }

              return pdfLink;
            };

            _this.setRadarOnReceiptClick = function () {
              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].billReceiptClick);
            };

            return _this;
          }

          BillButtons.prototype.onDownloadReceipt = function () {
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].showReceipt);
          };

          BillButtons.prototype.render = function () {
            var isOpen = this.state.isOpen;
            var paymentUrl = this.props.paymentUrl;
            var _a = this.props.context.paymentInfo,
                link_receipt = _a.link_receipt,
                status = _a.status,
                link_receipt_paid = _a.link_receipt_paid;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "buttons-block"
            }, (!status || status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["STATUS_ERROR"]) && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "button-pay",
              "data-test-id": "payment_payed",
              onClick: this.onPayedClick
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Button"], {
              primary: true,
              small: true,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.pay)
            })), this.pdfLink() && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "button-view"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Button"], {
              contrast: true,
              small: true,
              testId: "payment_pdf",
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.showReceipt),
              onClick: this.onShowReceipt
            })), !!link_receipt && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("a", {
              styleName: "button-view",
              href: link_receipt,
              target: "_blank",
              "data-test-id": "payment_receipt",
              onClick: this.onDownloadReceipt
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Button"], {
              contrast: true,
              small: true,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.downloadReceipt)
            }))), status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["STATUS_AWAITING"] && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_ReloadStatus_ReloadStatus__WEBPACK_IMPORTED_MODULE_9__["default"], {
              formType: "bill"
            }), status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["STATUS_SUCCESS"] && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_ReceiptButton__WEBPACK_IMPORTED_MODULE_10__["default"], {
              href: link_receipt_paid,
              onClick: this.setRadarOnReceiptClick,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.paymentBill)
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["FramePopup"], {
              src: paymentUrl,
              initialWidth: '420px',
              initialHeight: '613px',
              show: isOpen,
              onHide: this.onPayedClose,
              closeByEsc: true
            }));
          };

          BillButtons = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_1__(_components_Bill_Bill_css__WEBPACK_IMPORTED_MODULE_5___default.a)], BillButtons);
          return BillButtons;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_7__["withContext"])(BillButtons);
        /***/
      },

      /***/
      "./src/components/Bill/components/BillButtons/index.ts":
      /*!*************************************************************!*\
        !*** ./src/components/Bill/components/BillButtons/index.ts ***!
        \*************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsBillComponentsBillButtonsIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _BillButtons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./BillButtons */
        "./src/components/Bill/components/BillButtons/BillButtons.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _BillButtons__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Bill/index.ts":
      /*!**************************************!*\
        !*** ./src/components/Bill/index.ts ***!
        \**************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsBillIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Bill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Bill */
        "./src/components/Bill/Bill.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Bill__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/BillingInfoTooltip/BillingInfoTooltip.css":
      /*!******************************************************************!*\
        !*** ./src/components/BillingInfoTooltip/BillingInfoTooltip.css ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsBillingInfoTooltipBillingInfoTooltipCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./BillingInfoTooltip.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/BillingInfoTooltip/BillingInfoTooltip.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/BillingInfoTooltip/BillingInfoTooltip.tsx":
      /*!******************************************************************!*\
        !*** ./src/components/BillingInfoTooltip/BillingInfoTooltip.tsx ***!
        \******************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsBillingInfoTooltipBillingInfoTooltipTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _BillingInfoTooltip_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./BillingInfoTooltip.css */
        "./src/components/BillingInfoTooltip/BillingInfoTooltip.css");
        /* harmony import */


        var _BillingInfoTooltip_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_BillingInfoTooltip_css__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_status_security_check_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! svgson-loader!mrg-icons/src/mailru/status/security_check.svg */
        "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/status/security_check.svg");
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_status_security_check_svg__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_mrg_icons_src_mailru_status_security_check_svg__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _static_icons_shield_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/static/icons/shield.png */
        "./src/static/icons/shield.png");
        /* harmony import */


        var _static_icons_shield_png__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_static_icons_shield_png__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics9 = function extendStatics(d, b) {
            _extendStatics9 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics9(d, b);
          };

          return function (d, b) {
            _extendStatics9(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        }; // tslint:disable:max-line-length


        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_3__["defineMessages"])({
          header: {
            "id": "JrMmUw==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0430 \u0431\u0435\u0437 \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A\u043E\u0432 \u0447\u0435\u0440\u0435\u0437 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u0443\u044E \u0441\u0438\u0441\u0442\u0435\u043C\u0443 Mail.ru"
          },
          listItem1: {
            "id": "dhmBig==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u0447\u0435\u0440\u0435\u0437 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u0443\u044E \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0420\u041D\u041A\u041E \xAB\u0414\u0435\u043D\u044C\u0433\u0438.\u041C\u044D\u0439\u043B.\u0440\u0443\xBB."
          },
          listItem2: {
            "id": "arMbrA==",
            "defaultMessage": "\u041F\u043E\u0441\u043B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u043C\u044B \u043F\u0440\u0438\u0448\u043B\u0435\u043C \u0447\u0435\u043A, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u043F\u043B\u0430\u0442\u0451\u0436."
          }
        });

        var BillingInfoTooltip =
        /** @class */
        function (_super) {
          __extends(BillingInfoTooltip, _super);

          function BillingInfoTooltip() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          Object.defineProperty(BillingInfoTooltip.prototype, "overlay", {
            get: function get() {
              var header = this.props.header;
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                styleName: "tooltip",
                "data-test-id": "billing-info-tooltip"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                styleName: "shield"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("img", {
                src: _static_icons_shield_png__WEBPACK_IMPORTED_MODULE_7__
              })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                styleName: "header"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_5__["Text"], {
                bold: true
              }, header || Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.header))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("ul", {
                styleName: "list"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("li", {
                styleName: "list-item"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_5__["Text"], null, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.listItem1))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("li", {
                styleName: "list-item"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_5__["Text"], null, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.listItem2)))));
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(BillingInfoTooltip.prototype, "link", {
            get: function get() {
              var text = this.props.textType || _utils_constants__WEBPACK_IMPORTED_MODULE_8__["TEXT_TYPES"].standart;
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                styleName: "link",
                "data-test-id": "billing-info-link"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                styleName: "icon"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_5__["Icon"], {
                icon: svgson_loader_mrg_icons_src_mailru_status_security_check_svg__WEBPACK_IMPORTED_MODULE_6___default.a
              })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                styleName: "link-text"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_5__["Text"], {
                success: true,
                mode: "small"
              }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(_utils_constants__WEBPACK_IMPORTED_MODULE_8__["TooltipTexts"][text]))));
            },
            enumerable: true,
            configurable: true
          });

          BillingInfoTooltip.prototype.render = function () {
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_5__["Tooltip"], {
              placement: "bottomRight",
              delay: 200,
              arrow: true,
              overlay: this.overlay,
              children: this.link
            });
          };

          BillingInfoTooltip = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_1__(_BillingInfoTooltip_css__WEBPACK_IMPORTED_MODULE_2___default.a)], BillingInfoTooltip);
          return BillingInfoTooltip;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);
        /* harmony default export */


        __webpack_exports__["default"] = BillingInfoTooltip;
        /***/
      },

      /***/
      "./src/components/BillingInfoTooltip/index.ts":
      /*!****************************************************!*\
        !*** ./src/components/BillingInfoTooltip/index.ts ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsBillingInfoTooltipIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./BillingInfoTooltip */
        "./src/components/BillingInfoTooltip/BillingInfoTooltip.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/ContextProvider/ContextProvider.tsx":
      /*!************************************************************!*\
        !*** ./src/components/ContextProvider/ContextProvider.tsx ***!
        \************************************************************/

      /*! exports provided: StateContext, default */

      /***/
      function srcComponentsContextProviderContextProviderTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "StateContext", function () {
          return StateContext;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/components/PaymentStatus */
        "./src/components/PaymentStatus/index.ts");
        /* harmony import */


        var _utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/utils/setUrlParameter */
        "./src/utils/setUrlParameter.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics10 = function extendStatics(d, b) {
            _extendStatics10 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics10(d, b);
          };

          return function (d, b) {
            _extendStatics10(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_4__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_5__["EHeaderTypes"].LETTER_META);
        var StateContext = react__WEBPACK_IMPORTED_MODULE_0__["createContext"]({});
        var CHANGE_PAYMENT_STATUS = 'CHANGE_PAYMENT_STATUS';

        var ContextProvider =
        /** @class */
        function (_super) {
          __extends(ContextProvider, _super);

          function ContextProvider() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.updateModelMeta = function (meta) {
              var model = _this.state.model;
              model.setPaymentMeta(meta);
            };

            _this.statusPostMessage = function (event) {
              var messageId = _this.props.messageId;
              var _a = _this.state,
                  paymentInfo = _a.paymentInfo,
                  status = _a.paymentInfo.status;
              var data;

              try {
                data = JSON.parse(event.data);
              } catch (e) {
                xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_3__["default"].postMessageParseError);
              }

              if (event.origin !== window.location.origin) {
                return;
              }

              if (data && data.uidl === messageId && data.status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_1__["STATUS_AWAITING"] && data.type === CHANGE_PAYMENT_STATUS && !status) {
                xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_3__["default"].postMessageUpdateStatus);

                var meta = __assign(__assign({}, paymentInfo), {
                  status: data.status
                });

                _this.updateModelMeta(meta);
              }
            };

            return _this;
          }

          ContextProvider.prototype.componentDidMount = function () {
            window.addEventListener('message', this.statusPostMessage);
          };

          ContextProvider.prototype.componentWillUnmount = function () {
            window.removeEventListener('message', this.statusPostMessage);
          };

          ContextProvider.getDerivedStateFromProps = function (props) {
            return {
              features: props.features,
              paymentUrl: Object(_utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_2__["default"])(props.paymentInfo.payment_url, {
                from: 'die-oct',
                mp: 'web'
              }),
              paymentInfo: props.paymentInfo,
              onPopupToggle: props.onPopupToggle,
              dataSourceDispatch: props.dataSourceDispatch,
              octavius: props.octavius,
              flags: props.flags,
              selector: props.selector,
              model: props.model,
              storage: props.storage,
              email: props.email
            };
          };

          ContextProvider.prototype.render = function () {
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](StateContext.Provider, {
              value: this.state
            }, this.props.children);
          };

          return ContextProvider;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = ContextProvider;
        /***/
      },

      /***/
      "./src/components/ContextProvider/index.ts":
      /*!*************************************************!*\
        !*** ./src/components/ContextProvider/index.ts ***!
        \*************************************************/

      /*! exports provided: default, StateContext */

      /***/
      function srcComponentsContextProviderIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _ContextProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./ContextProvider */
        "./src/components/ContextProvider/ContextProvider.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _ContextProvider__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "StateContext", function () {
          return _ContextProvider__WEBPACK_IMPORTED_MODULE_0__["StateContext"];
        });
        /***/

      },

      /***/
      "./src/components/Controls/ControlCalendar.tsx":
      /*!*****************************************************!*\
        !*** ./src/components/Controls/ControlCalendar.tsx ***!
        \*****************************************************/

      /*! exports provided: ControlCalendar */

      /***/
      function srcComponentsControlsControlCalendarTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ControlCalendar", function () {
          return ControlCalendar;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _components_Controls_Elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/components/Controls/Elements */
        "./src/components/Controls/Elements.tsx");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _utils_dataTestId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/dataTestId */
        "./src/utils/dataTestId.ts");

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = undefined && undefined.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
          }
          return t;
        };

        var ControlCalendar = function ControlCalendar(_a) {
          var radarParams = _a.radarParams,
              props = __rest(_a, ["radarParams"]);

          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Controls_Elements__WEBPACK_IMPORTED_MODULE_1__["SmartButton"], __assign({}, props, {
            contrast: true,
            testId: _utils_dataTestId__WEBPACK_IMPORTED_MODULE_5__["EDataTestId"].CALENDAR,
            text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_3__["i18n"])(_utils_constants__WEBPACK_IMPORTED_MODULE_4__["CONTROLS_MESSAGES"].calendar),
            radarOnMount: {
              t: _utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].addressCalendarShow,
              params: radarParams
            },
            radar: {
              t: _utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].addressCalendarClick,
              params: radarParams
            }
          }));
        };
        /***/

      },

      /***/
      "./src/components/Controls/ControlsContainer.styles.tsx":
      /*!**************************************************************!*\
        !*** ./src/components/Controls/ControlsContainer.styles.tsx ***!
        \**************************************************************/

      /*! exports provided: styles */

      /***/
      function srcComponentsControlsControlsContainerStylesTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "styles", function () {
          return styles;
        });

        var styles = function styles(_a) {
          var fontSize2 = _a.fontSize2,
              x4 = _a.x4;
          return {
            controls: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            },
            paddingTop: {
              paddingTop: x4
            },
            controlsPonyMode: {
              '& > button': {
                fontSize: fontSize2.fontSize
              },
              '& > p': {
                fontSize: fontSize2.fontSize
              },
              '& > span': {
                fontSize: fontSize2.fontSize
              }
            }
          };
        };
        /***/

      },

      /***/
      "./src/components/Controls/ControlsContainer.tsx":
      /*!*******************************************************!*\
        !*** ./src/components/Controls/ControlsContainer.tsx ***!
        \*******************************************************/

      /*! exports provided: default, ControlsLargeSpace, ControlsDefaultSpace */

      /***/
      function srcComponentsControlsControlsContainerTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ControlsLargeSpace", function () {
          return ControlsLargeSpace;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ControlsDefaultSpace", function () {
          return ControlsDefaultSpace;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _components_Controls_ControlsContainer_styles_tsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/components/Controls/ControlsContainer.styles.tsx */
        "./src/components/Controls/ControlsContainer.styles.tsx");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics11 = function extendStatics(d, b) {
            _extendStatics11 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics11(d, b);
          };

          return function (d, b) {
            _extendStatics11(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var __rest = undefined && undefined.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
          }
          return t;
        };

        var ControlsContainer =
        /** @class */
        function (_super) {
          __extends(ControlsContainer, _super);

          function ControlsContainer() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          ControlsContainer.prototype.getSpace = function (large) {
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Space"], {
              large: large === 'large',
              responsive: "desktop"
            });
          };

          ControlsContainer.prototype.renderControl = function (child, idx) {
            var _a = this.props,
                children = _a.children,
                space = _a.space,
                firstPrimary = _a.firstPrimary;
            var length = react__WEBPACK_IMPORTED_MODULE_0__["Children"].count(children);
            var isNotLast = idx !== length - 1;

            if (firstPrimary && idx === 0) {
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["cloneElement"](child, {
                primary: true
              }), isNotLast && this.getSpace(space));
            }

            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, child, isNotLast && this.getSpace(space));
          };

          ControlsContainer.prototype.render = function () {
            var _a;

            var _b = this.props,
                classes = _b.classes,
                children = _b.children,
                paddingTop = _b.paddingTop,
                ponymode = _b.ponymode;
            var className = classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes.controls, (_a = {}, _a[classes.controlsPonyMode] = ponymode, _a[classes.paddingTop] = paddingTop, _a));
            var childrens = react__WEBPACK_IMPORTED_MODULE_0__["Children"].toArray(children); // Нужно убрать дочерние невалидные компоненты, чтобы корректно нарисовать пробелы

            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className
            }, childrens.filter(function (c) {
              return Boolean(c);
            }).map(this.renderControl.bind(this)));
          };

          ControlsContainer = __decorate([Object(_2kit__WEBPACK_IMPORTED_MODULE_1__["withStyles"])(_components_Controls_ControlsContainer_styles_tsx__WEBPACK_IMPORTED_MODULE_3__["styles"])], ControlsContainer);
          return ControlsContainer;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);
        /* harmony default export */


        __webpack_exports__["default"] = ControlsContainer;

        var ControlsLargeSpace = function ControlsLargeSpace(_a) {
          var space = _a.space,
              props = __rest(_a, ["space"]);

          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](ControlsContainer, __assign({
            space: 'large'
          }, props), props.children);
        };

        var ControlsDefaultSpace = function ControlsDefaultSpace(_a) {
          var space = _a.space,
              props = __rest(_a, ["space"]);

          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](ControlsContainer, __assign({
            space: 'normal'
          }, props), props.children);
        };
        /***/

      },

      /***/
      "./src/components/Controls/Elements.tsx":
      /*!**********************************************!*\
        !*** ./src/components/Controls/Elements.tsx ***!
        \**********************************************/

      /*! exports provided: SmartButton, RadarLink */

      /***/
      function srcComponentsControlsElementsTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "SmartButton", function () {
          return SmartButton;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "RadarLink", function () {
          return RadarLink;
        });
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _components_Hoc_withRadar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/components/Hoc/withRadar */
        "./src/components/Hoc/withRadar.tsx");
        /* harmony import */


        var _components_Hoc_withNavigateClick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/components/Hoc/withNavigateClick */
        "./src/components/Hoc/withNavigateClick.tsx");
        /* harmony import */


        var _components_Hoc_withSmallButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/components/Hoc/withSmallButton */
        "./src/components/Hoc/withSmallButton.tsx");
        /* harmony import */


        var _utils_compose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/compose */
        "./src/utils/compose.ts");

        var SmartButton = Object(_utils_compose__WEBPACK_IMPORTED_MODULE_4__["default"])(_components_Hoc_withNavigateClick__WEBPACK_IMPORTED_MODULE_2__["withNavigateClick"], _components_Hoc_withRadar__WEBPACK_IMPORTED_MODULE_1__["withRadar"], _components_Hoc_withSmallButton__WEBPACK_IMPORTED_MODULE_3__["withSmallButton"])(_2kit__WEBPACK_IMPORTED_MODULE_0__["Button"]);
        var RadarLink = Object(_components_Hoc_withRadar__WEBPACK_IMPORTED_MODULE_1__["withRadar"])(_2kit__WEBPACK_IMPORTED_MODULE_0__["Link"]);
        /***/
      },

      /***/
      "./src/components/Dobro/Dobro.css":
      /*!****************************************!*\
        !*** ./src/components/Dobro/Dobro.css ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function srcComponentsDobroDobroCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./Dobro.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Dobro/Dobro.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Dobro/Dobro.tsx":
      /*!****************************************!*\
        !*** ./src/components/Dobro/Dobro.tsx ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsDobroDobroTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _Dobro_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Dobro.css */
        "./src/components/Dobro/Dobro.css");
        /* harmony import */


        var _Dobro_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Dobro_css__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/components/BillingInfoTooltip */
        "./src/components/BillingInfoTooltip/index.ts");
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_actions_favorite_alt_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! svgson-loader!mrg-icons/src/mailru/actions/favorite_alt.svg */
        "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/actions/favorite_alt.svg");
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_actions_favorite_alt_svg__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_mrg_icons_src_mailru_actions_favorite_alt_svg__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_11__);

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics12 = function extendStatics(d, b) {
            _extendStatics12 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics12(d, b);
          };

          return function (d, b) {
            _extendStatics12(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };
        /* tslint:disable:no-implicit-dependencies */


        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_9__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_10__["EHeaderTypes"].LETTER_META); // tslint:disable:max-line-length

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_4__["defineMessages"])({
          submit: {
            "id": "L9iQjQ==",
            "defaultMessage": "\u041F\u043E\u043C\u043E\u0447\u044C"
          }
        }); // tslint:enable:max-line-length

        var Dobro =
        /** @class */
        function (_super) {
          __extends(Dobro, _super);

          function Dobro() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              isPaymentPopupOpen: false
            };

            _this.onPaymentClose = function () {
              _this.setState({
                isPaymentPopupOpen: false
              });

              var onPopupToggle = _this.props.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(false);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].paymentClose);
            };

            _this.onPaymentClick = function () {
              _this.setState({
                isPaymentPopupOpen: true
              });

              var onPopupToggle = _this.props.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(true);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].clickButtonPayment);
            };

            return _this;
          }

          Dobro.prototype.componentDidMount = function () {
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].showDie);
          };

          Dobro.prototype.render = function () {
            var _a;

            var _b = this.props,
                comment = _b.comment,
                paymentUrl = _b.paymentUrl,
                octavius = _b.octavius,
                darkMode = _b.darkMode;
            var isPaymentPopupOpen = this.state.isPaymentPopupOpen;
            var mainStyle = octavius ? 'main-octavius' : 'main';
            var className = classnames__WEBPACK_IMPORTED_MODULE_11___default()((_a = {}, _a[_Dobro_css__WEBPACK_IMPORTED_MODULE_6___default.a[mainStyle]] = true, _a[_Dobro_css__WEBPACK_IMPORTED_MODULE_6___default.a['main-octavius-darkMode']] = octavius && darkMode, _a));
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className,
              "data-test-id": "dobro_die"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "icon"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Icon"], {
              icon: svgson_loader_mrg_icons_src_mailru_actions_favorite_alt_svg__WEBPACK_IMPORTED_MODULE_8___default.a
            })), comment), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "billing-info"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_7__["default"], null))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "buttons-block"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              "data-test-id": "payment_payed",
              onClick: this.onPaymentClick
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Button"], {
              primary: true,
              small: true,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.submit)
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["FramePopup"], {
              src: paymentUrl,
              initialWidth: '702px',
              initialHeight: '514px',
              show: isPaymentPopupOpen,
              onHide: this.onPaymentClose,
              closeByEsc: true
            })));
          };

          Dobro = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_1__(_Dobro_css__WEBPACK_IMPORTED_MODULE_6___default.a)], Dobro);
          return Dobro;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Dobro;
        /***/
      },

      /***/
      "./src/components/Dobro/index.ts":
      /*!***************************************!*\
        !*** ./src/components/Dobro/index.ts ***!
        \***************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsDobroIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Dobro__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Dobro */
        "./src/components/Dobro/Dobro.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Dobro__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Gibdd/Gibdd.css":
      /*!****************************************!*\
        !*** ./src/components/Gibdd/Gibdd.css ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function srcComponentsGibddGibddCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./Gibdd.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/Gibdd.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Gibdd/Gibdd.tsx":
      /*!****************************************!*\
        !*** ./src/components/Gibdd/Gibdd.tsx ***!
        \****************************************/

      /*! exports provided: PaymentInProgressStatus, default */

      /***/
      function srcComponentsGibddGibddTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PaymentInProgressStatus", function () {
          return PaymentInProgressStatus;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _Gibdd_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./Gibdd.css */
        "./src/components/Gibdd/Gibdd.css");
        /* harmony import */


        var _Gibdd_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Gibdd_css__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var svgson_loader_static_icons_government_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! svgson-loader!@/static/icons/government.svg */
        "./node_modules/svgson-loader/index.js!./src/static/icons/government.svg");
        /* harmony import */


        var svgson_loader_static_icons_government_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_static_icons_government_svg__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/components/BillingInfoTooltip */
        "./src/components/BillingInfoTooltip/index.ts");
        /* harmony import */


        var _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/components/PaymentStatus */
        "./src/components/PaymentStatus/index.ts");
        /* harmony import */


        var _components_Gibdd_components_GibddButtons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/components/Gibdd/components/GibddButtons */
        "./src/components/Gibdd/components/GibddButtons/index.ts");
        /* harmony import */


        var _components_Gibdd_components_GroupPayments__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/components/Gibdd/components/GroupPayments */
        "./src/components/Gibdd/components/GroupPayments/index.ts");
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _utils_dateFormat__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/dateFormat */
        "./src/utils/dateFormat.ts");
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _utils_features__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! @/utils/features */
        "./src/utils/features.ts");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var gibdd_api__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! gibdd.api */
        "./node_modules/gibdd.api/dist/index.js");
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _utils_timeDiff__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! @/utils/timeDiff */
        "./src/utils/timeDiff.ts");
        /* harmony import */


        var mobx__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! mobx */
        "./node_modules/mobx/lib/mobx.module.js");
        /* harmony import */


        var _components_Gibdd_components_GibddBody__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! @/components/Gibdd/components/GibddBody */
        "./src/components/Gibdd/components/GibddBody/index.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics13 = function extendStatics(d, b) {
            _extendStatics13 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics13(d, b);
          };

          return function (d, b) {
            _extendStatics13(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_14__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_15__["EHeaderTypes"].LETTER_META); // tslint:disable:max-line-length

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_3__["defineMessages"])({
          amountWithDiscount: {
            "id": "82LFeg==",
            "defaultMessage": "\u0421\u0443\u043C\u043C\u0430 \u0441\u043E \u0441\u043A\u0438\u0434\u043A\u043E\u0439: {amountWithDiscount}"
          },
          amount: {
            "id": "dIDanA==",
            "defaultMessage": "\u0421\u0443\u043C\u043C\u0430 \u0448\u0442\u0440\u0430\u0444\u0430: {amount}"
          },
          stsExtended: {
            "id": "zxqc4A==",
            "defaultMessage": "\u041D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442: \u0421\u0422\u0421 \u2116 {CTC}"
          },
          discountText: {
            "id": "697AZA==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u0435 \u0441\u043E \u0441\u043A\u0438\u0434\u043A\u043E\u0439 {discountSize}% \u0434\u043E {dateDeadlineDiscount}"
          },
          discountAvailable: {
            "id": "PvUU3A==",
            "defaultMessage": "\u0421\u043A\u0438\u0434\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430 \u0434\u043E {date}"
          },
          billingHeader: {
            "id": "l+lyUw==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u0448\u0442\u0440\u0430\u0444\u044B \u043F\u0440\u044F\u043C\u043E{br}\u0432{nbsp}\u041F\u043E\u0447\u0442\u0435"
          },
          gibddDelay: {
            "id": "zIVhcQ==",
            "defaultMessage": "\u0413\u0418\u0411\u0414\u0414 \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u043E\u043F\u043B\u0430\u0442\u0443 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0442\u0440\u0435\u0445 \u0441\u0443\u0442\u043E\u043A"
          }
        }); // tslint:enable:max-line-length

        var PaymentInProgressStatus;

        (function (PaymentInProgressStatus) {
          PaymentInProgressStatus["ok"] = "ok";
          PaymentInProgressStatus["fail"] = "fail";
          PaymentInProgressStatus["loading"] = "loading";
        })(PaymentInProgressStatus || (PaymentInProgressStatus = {}));

        var Gibdd =
        /** @class */
        function (_super) {
          __extends(Gibdd, _super);

          function Gibdd() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              finesInfo: null,
              loading: false,
              timeoutId: null
            };
            _this.showGroupPayment = _this.props.context.features.has(_utils_features__WEBPACK_IMPORTED_MODULE_16__["EFeatures"].GIBDD_GROUP);
            _this.gibddApiMocks = _this.props.context.features.has(_utils_features__WEBPACK_IMPORTED_MODULE_16__["EFeatures"].GIBDD_MOCK_API);

            _this.checkDeadlineDiscountString = function () {
              var dateDeadlineDiscountString = _this.props.context.paymentInfo.date_deadline_discount;
              return dateDeadlineDiscountString && !isNaN(parseInt(dateDeadlineDiscountString, 10)) && +dateDeadlineDiscountString > 0;
            };

            _this.checkDiscount = function () {
              var _a = _this.props.context.paymentInfo,
                  amountWithDiscount = _a.amount_with_discount,
                  dateDeadlineDiscountString = _a.date_deadline_discount;
              return amountWithDiscount && _this.checkDeadlineDiscountString() && +dateDeadlineDiscountString > Math.round(new Date().getTime() / 1000);
            };

            _this.renderHeader = function () {
              var _a = _this.props.context.paymentInfo,
                  amountWithDiscount = _a.amount_with_discount,
                  amount = _a.amount;

              if (_this.checkDiscount()) {
                var separatedAmount_1 = (+amountWithDiscount).toLocaleString();
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
                  mode: "h4"
                }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_3__["FormattedMessage"], __assign({}, messages.amountWithDiscount, {
                  values: {
                    amountWithDiscount: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, separatedAmount_1, "\xA0", react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Rouble"], null))
                  }
                })));
              }

              var separatedAmount = (+amount).toLocaleString();
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
                mode: "h4"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_3__["FormattedMessage"], __assign({}, messages.amount, {
                values: {
                  amount: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, separatedAmount, "\xA0", react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Rouble"], null))
                }
              })));
            };

            _this.renderBillingHeader = function () {
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_3__["FormattedMessage"], __assign({}, messages.billingHeader, {
                values: {
                  nbsp: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, "\xA0"),
                  br: react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("br", null)
                }
              }));
            };

            _this.renderPaymentTip = function () {
              var _a = _this.props.context.paymentInfo,
                  status = _a.status,
                  dateDeadlineDiscountString = _a.date_deadline_discount;
              var dateDeadlineDiscount;

              if (_this.checkDeadlineDiscountString()) {
                dateDeadlineDiscount = +dateDeadlineDiscountString * 1000;
              }

              var isDateOfDiscount = dateDeadlineDiscount && _this.checkDiscount();

              if (status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["STATUS_AWAITING"] || status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["STATUS_SUCCESS"]) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                  styleName: "discount-date-full"
                }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
                  secondary: true
                }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_13__["i18n"])(messages.gibddDelay)));
              }

              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, dateDeadlineDiscount && isDateOfDiscount && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                styleName: "discount-date-full"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
                secondary: true
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_3__["FormattedMessage"], __assign({}, messages.discountAvailable, {
                values: {
                  date: Object(_utils_dateFormat__WEBPACK_IMPORTED_MODULE_12__["dateFormat"])(dateDeadlineDiscountString)
                }
              })))));
            }; // метод возвращает модель штрафов из localStoarge, если snapshot актуален


            _this.getFinesIfSnapshotActual = function () {
              var finesCacheTimeLimit = _this.props.context.features.getAsInt(_utils_features__WEBPACK_IMPORTED_MODULE_16__["EFeatures"].GIBDD_FINES_CACHE_TIMELIMIT, 10);

              var storage = _this.props.context.storage;
              var finesInfo = storage.get(_utils_constants__WEBPACK_IMPORTED_MODULE_19__["FINES_SHAPSHOT_KEY"]);

              if (finesInfo) {
                var shapshotAge = Object(_utils_timeDiff__WEBPACK_IMPORTED_MODULE_20__["timeDiffInMinutes"])(Date.now(), finesInfo.lastUpdate);
                var isActual = shapshotAge < finesCacheTimeLimit;

                if (isActual) {
                  return finesInfo;
                }
              }

              return null;
            };

            _this.storeFinesInfo = function (finesInfo) {
              var storage = _this.props.context.storage;
              storage.set(_utils_constants__WEBPACK_IMPORTED_MODULE_19__["FINES_SHAPSHOT_KEY"], finesInfo);
            };

            _this.handlePostMessage = function (event) {
              var data;

              try {
                data = JSON.parse(event.data);
              } catch (e) {
                xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].postMessageParseError);
              }

              if (event.origin !== window.location.origin) {
                return;
              }

              if (!data) {
                return;
              }

              if (data.type === 'FINISH_GROUP_FINE_PAY') {
                try {
                  _this.props.context.dataSourceDispatch();
                } catch (e) {
                  xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].gibddGroupUpdateStatusError);
                }

                return;
              }

              if (data.type !== 'PAYMENT_IN_PROGRESS') {
                return;
              }

              if (data.status === PaymentInProgressStatus.loading) {
                var timeoutId = window.setTimeout(function () {
                  _this.setState({
                    loading: false,
                    finesInfo: null
                  });

                  _this.storeFinesInfo(null);

                  xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].gibddInProgressTimeout, {
                    rlog: 'gibdd_letter_meta_logs',
                    rlog_message: {
                      message: _utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].gibddInProgressTimeout
                    }
                  });
                }, _utils_constants__WEBPACK_IMPORTED_MODULE_19__["PAYMENT_IN_PROGRESS_TIMEOUT"]);

                _this.setState({
                  timeoutId: timeoutId,
                  loading: true
                });

                return;
              }

              if (data.status === PaymentInProgressStatus.ok) {
                clearTimeout(_this.state.timeoutId);
                var storage = _this.props.context.storage;
                var mock = storage.get(_utils_constants__WEBPACK_IMPORTED_MODULE_19__["GIBDD_MOCK_API_KEY"], {
                  email: false
                });

                if (mock && _this.gibddApiMocks) {
                  Object(gibdd_api__WEBPACK_IMPORTED_MODULE_18__["mockGibddApi"])(mock);
                }

                var fines_1 = gibdd_api__WEBPACK_IMPORTED_MODULE_18__["FinesList"].GetUnpaid({
                  cached: true
                });
                Object(mobx__WEBPACK_IMPORTED_MODULE_21__["reaction"])(function () {
                  return fines_1.loading;
                }, function (loading) {
                  if (loading === false) {
                    var finesInfo = fines_1.finesInfo;

                    _this.storeFinesInfo(finesInfo);

                    _this.setState({
                      loading: false,
                      finesInfo: finesInfo
                    });
                  }
                });
                xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].gibddInProgressOk);
              }

              if (data.status === PaymentInProgressStatus.fail) {
                clearTimeout(_this.state.timeoutId);

                _this.storeFinesInfo(null);

                _this.setState({
                  loading: false,
                  finesInfo: null
                });

                xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].gibddInProgressFail, {
                  rlog: 'gibdd_letter_meta_logs',
                  rlog_message: {
                    message: _utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].gibddInProgressFail
                  }
                });
              }
            };

            return _this;
          }

          Gibdd.prototype.componentDidMount = function () {
            var _this = this;

            window.addEventListener('message', this.handlePostMessage);
            var finesInfo = this.getFinesIfSnapshotActual();

            if (finesInfo) {
              this.setState({
                finesInfo: finesInfo,
                loading: false
              });
              return;
            }

            this.setState({
              loading: true
            });
            var storage = this.props.context.storage;
            var mock = storage.get(_utils_constants__WEBPACK_IMPORTED_MODULE_19__["GIBDD_MOCK_API_KEY"], {
              email: false
            });

            if (mock && this.gibddApiMocks) {
              Object(gibdd_api__WEBPACK_IMPORTED_MODULE_18__["mockGibddApi"])(mock);
            }

            var fines = gibdd_api__WEBPACK_IMPORTED_MODULE_18__["FinesList"].GetUnpaid();
            Object(mobx__WEBPACK_IMPORTED_MODULE_21__["reaction"])(function () {
              return fines.loading;
            }, function (loading) {
              if (loading === false) {
                var finesInfo_1 = fines.finesInfo;

                _this.setState({
                  finesInfo: finesInfo_1,
                  loading: false
                });

                _this.storeFinesInfo(finesInfo_1);
              }
            });
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].showDie);
          };

          Gibdd.prototype.componentWillUnmount = function () {
            window.removeEventListener('message', this.handlePostMessage);
            var timeoutId = this.state.timeoutId;

            if (timeoutId) {
              clearTimeout(timeoutId);
            }
          };

          Gibdd.prototype.render = function () {
            var _a;

            var _b = this.props,
                _c = _b.context,
                status = _c.paymentInfo.status,
                octavius = _c.octavius,
                dangerousFeatureIsPhotoButton = _b.dangerousFeatureIsPhotoButton,
                darkMode = _b.darkMode;
            var mainStyle = octavius ? 'main-octavius' : 'main';
            var className = classnames__WEBPACK_IMPORTED_MODULE_17___default()((_a = {}, _a[_Gibdd_css__WEBPACK_IMPORTED_MODULE_4___default.a[mainStyle]] = true, _a[_Gibdd_css__WEBPACK_IMPORTED_MODULE_4___default.a['main-octavius-darkMode']] = octavius && darkMode, _a));
            var _d = this.state,
                finesInfo = _d.finesInfo,
                loading = _d.loading;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className,
              "data-test-id": "gibdd_die"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "content"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header-info"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header-text"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "icon"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Icon"], {
              icon: svgson_loader_static_icons_government_svg__WEBPACK_IMPORTED_MODULE_5___default.a
            })), this.renderHeader()), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["default"], {
              status: status
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "billing-info"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_7__["default"], {
              header: this.renderBillingHeader(),
              textType: _utils_constants__WEBPACK_IMPORTED_MODULE_19__["TEXT_TYPES"].mail
            }))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Gibdd_components_GibddBody__WEBPACK_IMPORTED_MODULE_22__["default"], null), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "payment-block"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Gibdd_components_GibddButtons__WEBPACK_IMPORTED_MODULE_9__["default"], {
              checkDiscount: this.checkDiscount,
              dangerousFeatureIsPhotoButton: dangerousFeatureIsPhotoButton
            }), this.renderPaymentTip()), this.showGroupPayment && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Gibdd_components_GroupPayments__WEBPACK_IMPORTED_MODULE_10__["default"], {
              finesInfo: finesInfo,
              loading: loading
            })));
          };

          Gibdd = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_2__(_Gibdd_css__WEBPACK_IMPORTED_MODULE_4___default.a)], Gibdd);
          return Gibdd;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_11__["withContext"])(Gibdd);
        /***/
      },

      /***/
      "./src/components/Gibdd/components/GibddBody/GibddBody.css":
      /*!*****************************************************************!*\
        !*** ./src/components/Gibdd/components/GibddBody/GibddBody.css ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsGibddComponentsGibddBodyGibddBodyCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../../node_modules/postcss-loader/src!./GibddBody.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/GibddBody/GibddBody.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Gibdd/components/GibddBody/GibddBody.tsx":
      /*!*****************************************************************!*\
        !*** ./src/components/Gibdd/components/GibddBody/GibddBody.tsx ***!
        \*****************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsGibddBodyGibddBodyTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _GibddBody_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./GibddBody.css */
        "./src/components/Gibdd/components/GibddBody/GibddBody.css");
        /* harmony import */


        var _GibddBody_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_GibddBody_css__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var mobx_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! mobx-react */
        "./node_modules/mobx-react/index.module.js");
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_dateFormat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/dateFormat */
        "./src/utils/dateFormat.ts");
        /* harmony import */


        var _utils_dataTestId__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/dataTestId */
        "./src/utils/dataTestId.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics14 = function extendStatics(d, b) {
            _extendStatics14 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics14(d, b);
          };

          return function (d, b) {
            _extendStatics14(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_3__["defineMessages"])({
          date: {
            "id": "WeisOQ==",
            "defaultMessage": "\u0414\u0430\u0442\u0430"
          },
          car: {
            "id": "gQI4oQ==",
            "defaultMessage": "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C"
          },
          violation: {
            "id": "N9GaZQ==",
            "defaultMessage": "\u041D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435"
          },
          address: {
            "id": "iKPqXA==",
            "defaultMessage": "\u0410\u0434\u0440\u0435\u0441"
          }
        });
        var BodyElement = react_css_modules__WEBPACK_IMPORTED_MODULE_2__(function (_a) {
          var field = _a.field,
              value = _a.value,
              isBold = _a.isBold,
              testId = _a.testId;
          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("li", {
            styleName: "info-list-element",
            "data-test-id": testId
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
            styleName: "info-element-label"
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
            secondary: true
          }, field)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
            bold: isBold
          }, value));
        }, _GibddBody_css__WEBPACK_IMPORTED_MODULE_4___default.a);

        var GibddBody =
        /** @class */
        function (_super) {
          __extends(GibddBody, _super);

          function GibddBody() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.renderDate = function () {
              var date_violation = _this.props.context.paymentInfo.date_violation;
              return !!date_violation ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](BodyElement, {
                field: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_7__["i18n"])(messages.date),
                value: Object(_utils_dateFormat__WEBPACK_IMPORTED_MODULE_8__["dateFormat"])(date_violation),
                testId: _utils_dataTestId__WEBPACK_IMPORTED_MODULE_9__["EDataTestId"].GIBDD_HEADER_DESCRIPTION
              }) : null;
            };

            _this.renderCarNumber = function () {
              var car_number = _this.props.context.paymentInfo.car_number;
              return !!car_number ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](BodyElement, {
                isBold: true,
                field: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_7__["i18n"])(messages.car),
                value: react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                  styleName: "small-caps"
                }, car_number.replace(/(\d+$)/, ' $1')),
                testId: _utils_dataTestId__WEBPACK_IMPORTED_MODULE_9__["EDataTestId"].GIBDD_HEADER_MAIN
              }) : null;
            };

            _this.renderArticleKoapDescription = function () {
              var article_koap_description = _this.props.context.paymentInfo.article_koap_description;
              return !!article_koap_description ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](BodyElement, {
                field: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_7__["i18n"])(messages.violation),
                value: article_koap_description,
                testId: _utils_dataTestId__WEBPACK_IMPORTED_MODULE_9__["EDataTestId"].GIBDD_HEADER_ARTICLE
              }) : null;
            };

            _this.renderViolationPlace = function () {
              var violation_place = _this.props.context.paymentInfo.violation_place;
              return !!violation_place ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](BodyElement, {
                field: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_7__["i18n"])(messages.address),
                value: violation_place,
                testId: _utils_dataTestId__WEBPACK_IMPORTED_MODULE_9__["EDataTestId"].GIBDD_HEADER_PLACE
              }) : null;
            };

            return _this;
          }

          GibddBody.prototype.render = function () {
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("ul", {
              styleName: "info-list"
            }, this.renderDate(), this.renderCarNumber(), this.renderArticleKoapDescription(), this.renderViolationPlace());
          };

          return GibddBody;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_5__["withContext"])(Object(mobx_react__WEBPACK_IMPORTED_MODULE_6__["observer"])(react_css_modules__WEBPACK_IMPORTED_MODULE_2__(GibddBody, _GibddBody_css__WEBPACK_IMPORTED_MODULE_4___default.a)));
        /***/
      },

      /***/
      "./src/components/Gibdd/components/GibddBody/index.ts":
      /*!************************************************************!*\
        !*** ./src/components/Gibdd/components/GibddBody/index.ts ***!
        \************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsGibddBodyIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _GibddBody__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./GibddBody */
        "./src/components/Gibdd/components/GibddBody/GibddBody.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _GibddBody__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Gibdd/components/GibddButtons/GibddButtons.css":
      /*!***********************************************************************!*\
        !*** ./src/components/Gibdd/components/GibddButtons/GibddButtons.css ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsGibddComponentsGibddButtonsGibddButtonsCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../../node_modules/postcss-loader/src!./GibddButtons.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/GibddButtons/GibddButtons.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Gibdd/components/GibddButtons/GibddButtons.tsx":
      /*!***********************************************************************!*\
        !*** ./src/components/Gibdd/components/GibddButtons/GibddButtons.tsx ***!
        \***********************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsGibddButtonsGibddButtonsTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/components/PaymentStatus */
        "./src/components/PaymentStatus/index.ts");
        /* harmony import */


        var _GibddButtons_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./GibddButtons.css */
        "./src/components/Gibdd/components/GibddButtons/GibddButtons.css");
        /* harmony import */


        var _GibddButtons_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_GibddButtons_css__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _components_ReloadStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/components/ReloadStatus */
        "./src/components/ReloadStatus/index.ts");
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _utils_features__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/utils/features */
        "./src/utils/features.ts");
        /* harmony import */


        var _components_ReceiptButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/components/ReceiptButton */
        "./src/components/ReceiptButton/index.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var svgson_loader_static_icons_document_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! svgson-loader!@/static/icons/document.svg */
        "./node_modules/svgson-loader/index.js!./src/static/icons/document.svg");
        /* harmony import */


        var svgson_loader_static_icons_document_svg__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_static_icons_document_svg__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! @/utils/setUrlParameter */
        "./src/utils/setUrlParameter.ts");
        /* harmony import */


        var _utils_getFeaturesStringByPrefix__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! @/utils/getFeaturesStringByPrefix */
        "./src/utils/getFeaturesStringByPrefix.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics15 = function extendStatics(d, b) {
            _extendStatics15 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics15(d, b);
          };

          return function (d, b) {
            _extendStatics15(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_12__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_13__["EHeaderTypes"].LETTER_META);
        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_2__["defineMessages"])({
          pay: {
            "id": "W6VCIw==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C"
          },
          payWithDiscount: {
            "id": "4/X/CA==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0441\u043E \u0441\u043A\u0438\u0434\u043A\u043E\u0439"
          },
          showPhoto: {
            "id": "hBz92Q==",
            "defaultMessage": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0444\u043E\u0442\u043E"
          },
          photoHeader: {
            "id": "TetdBg==",
            "defaultMessage": "\u0424\u043E\u0442\u043E \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F"
          },
          close: {
            "id": "KngZjw==",
            "defaultMessage": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
          },
          paymentBill: {
            "id": "wlE/Yw==",
            "defaultMessage": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043A\u0432\u0438\u0442\u0430\u043D\u0446\u0438\u044E"
          }
        });

        var GibddButtons =
        /** @class */
        function (_super) {
          __extends(GibddButtons, _super);

          function GibddButtons() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              isPaymentPopupOpen: false,
              isPhotoPopupOpen: false
            };
            _this.ftrs = Object(_utils_getFeaturesStringByPrefix__WEBPACK_IMPORTED_MODULE_17__["default"])(_this.props.context.features, 'gibdd');
            _this.groupByDefault = _this.props.context.features.has(_utils_features__WEBPACK_IMPORTED_MODULE_10__["EFeatures"].GIBDD_GROUP_PAY_BY_DEFAULT);

            _this.onPhotoClose = function () {
              _this.setState({
                isPhotoPopupOpen: false
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(false);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].photoPopupClose);
            };

            _this.onPhotoClick = function (e) {
              e.preventDefault();

              _this.setState({
                isPhotoPopupOpen: true
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(true);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].photoButtonClick);
            };

            _this.onPaymentClose = function () {
              _this.setState({
                isPaymentPopupOpen: false
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(false);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].paymentClose);
            };

            _this.onPaymentClick = function () {
              _this.setState({
                isPhotoPopupOpen: false,
                isPaymentPopupOpen: true
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(true);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].clickButtonPayment);
            };

            _this.renderPaymentButton = function () {
              var checkDiscount = _this.props.checkDiscount;
              var params = {
                dataTestId: 'payment_fine',
                text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.pay)
              };

              if (checkDiscount()) {
                params = {
                  dataTestId: 'payment_fine_discount',
                  text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.payWithDiscount)
                };
              }

              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
                primary: true,
                small: true,
                text: params.text,
                "data-test-id": params.dataTestId,
                onClick: _this.onPaymentClick
              });
            };

            _this.renderPhotoButton = function () {
              var photos = _this.props.context.paymentInfo.photos;

              if (!photos || photos.length === 0) {
                return null;
              }

              if (photos.length === 1) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("a", {
                  target: "_blank",
                  href: photos[0]
                }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
                  contrast: true,
                  small: true,
                  text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.showPhoto)
                }));
              }

              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
                contrast: true,
                small: true,
                text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.showPhoto),
                onClick: _this.onPhotoClick
              }), _this.renderPhotoPopup());
            };

            _this.renderPhotoPopup = function () {
              var _a = _this.state,
                  isPhotoPopupOpen = _a.isPhotoPopupOpen,
                  isPaymentPopupOpen = _a.isPaymentPopupOpen;
              var _b = _this.props.context,
                  photos = _b.paymentInfo.photos,
                  paymentUrl = _b.paymentUrl;
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Popup"], {
                show: isPhotoPopupOpen,
                onHide: _this.onPhotoClose,
                closeByEsc: true,
                width: "420px",
                testId: "photo-popup"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Panel"], {
                popup: true,
                promo: true,
                onClose: _this.onPhotoClose
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                styleName: "popup-header"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
                mode: "h1"
              }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.photoHeader))), photos && photos.length > 0 && _this.renderPhotoBlock(), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                styleName: "popup-buttons-block"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                "data-test-id": "payment-on-popup"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
                primary: true,
                small: true,
                text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.pay),
                onClick: _this.onPaymentClick
              })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["FramePopup"], {
                src: paymentUrl,
                initialWidth: _utils_constants__WEBPACK_IMPORTED_MODULE_15__["SIZE_POPUP"].small,
                initialHeight: _utils_constants__WEBPACK_IMPORTED_MODULE_15__["GIBDD_POPUP_HEIGHT"],
                show: isPaymentPopupOpen,
                onHide: _this.onPaymentClose,
                closeByEsc: true,
                iframeScrolling: "no"
              }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                "data-test-id": "close-on-popup"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
                small: true,
                text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.close),
                onClick: _this.onPhotoClose
              })))));
            };

            _this.renderPhotoBlock = function () {
              var photos = _this.props.context.paymentInfo.photos;

              switch (photos.length) {
                case 1:
                  break;

                case 2:
                  return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                    styleName: "photo-block-2"
                  }, _this.getSvgImage(photos[0]), _this.getSvgImage(photos[1]));

                case 3:
                  return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                    styleName: "photo-block-3"
                  }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                    styleName: "photo-block-3-main"
                  }, _this.getSvgImage(photos[0])), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                    styleName: "photo-block-3-previous"
                  }, _this.getSvgImage(photos[1]), _this.getSvgImage(photos[2])));

                case 4:
                default:
                  return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                    styleName: "photo-block-4"
                  }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                    styleName: "photo-block-4-row-first"
                  }, _this.getSvgImage(photos[0]), _this.getSvgImage(photos[1])), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                    styleName: "photo-block-4-row"
                  }, _this.getSvgImage(photos[2]), _this.getSvgImage(photos[3])));
              }

              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null);
            };

            _this.getSvgImage = function (src) {
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("a", {
                target: "_blank",
                href: src,
                onClick: _this.setRadarOnPhotoClick
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", {
                role: "image",
                preserveAspectRatio: "xMidyMid slice"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("image", {
                width: "100%",
                height: "100%",
                xlinkHref: src
              })));
            };

            _this.setRadarOnPhotoClick = function () {
              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].photoPopupImageClick);
            };

            _this.setRadarOnReceiptClick = function () {
              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].gibddReceiptClick);
            };

            return _this;
          }

          GibddButtons.prototype.render = function () {
            var _a = this.props.context,
                _b = _a.paymentInfo,
                status = _b.status,
                link_receipt_paid = _b.link_receipt_paid,
                features = _a.features,
                paymentUrl = _a.paymentUrl,
                email = _a.email;
            var dangerousFeatureIsPhotoButton = this.props.dangerousFeatureIsPhotoButton;
            var isPaymentPopupOpen = this.state.isPaymentPopupOpen;
            var groupByDefault = this.groupByDefault;
            var isPhotoButton = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_10__["EFeatures"].GIBDD_PHOTO) || dangerousFeatureIsPhotoButton;
            var groupPaymentUrl = Object(_utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_16__["default"])(paymentUrl, {
              group: true,
              group_by_default: groupByDefault,
              'x-email': email,
              ftrs: this.ftrs,
              from: 'die-oct_gd-exp'
            });
            var popupWidth = groupByDefault ? _utils_constants__WEBPACK_IMPORTED_MODULE_15__["SIZE_POPUP"].medium : _utils_constants__WEBPACK_IMPORTED_MODULE_15__["SIZE_POPUP"].small;
            var popupUrl = groupByDefault ? groupPaymentUrl : paymentUrl;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "buttons-block"
            }, (!status || status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_6__["STATUS_ERROR"]) && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "button-pay",
              "data-test-id": "payment_payed"
            }, this.renderPaymentButton()), isPhotoButton && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              "data-test-id": "show_photo"
            }, this.renderPhotoButton())), status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_6__["STATUS_AWAITING"] && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_ReloadStatus__WEBPACK_IMPORTED_MODULE_8__["default"], {
              formType: "gibdd"
            }), status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_6__["STATUS_SUCCESS"] && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_ReceiptButton__WEBPACK_IMPORTED_MODULE_11__["default"], {
              icon: svgson_loader_static_icons_document_svg__WEBPACK_IMPORTED_MODULE_14___default.a,
              href: link_receipt_paid,
              onClick: this.setRadarOnReceiptClick,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.paymentBill)
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["FramePopup"], {
              src: popupUrl,
              initialWidth: popupWidth,
              initialHeight: _utils_constants__WEBPACK_IMPORTED_MODULE_15__["GIBDD_POPUP_HEIGHT"],
              show: isPaymentPopupOpen,
              onHide: this.onPaymentClose,
              closeByEsc: true,
              iframeScrolling: "no"
            }));
          };

          GibddButtons = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_3__(_GibddButtons_css__WEBPACK_IMPORTED_MODULE_7___default.a)], GibddButtons);
          return GibddButtons;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_9__["withContext"])(GibddButtons);
        /***/
      },

      /***/
      "./src/components/Gibdd/components/GibddButtons/index.ts":
      /*!***************************************************************!*\
        !*** ./src/components/Gibdd/components/GibddButtons/index.ts ***!
        \***************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsGibddButtonsIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _GibddButtons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./GibddButtons */
        "./src/components/Gibdd/components/GibddButtons/GibddButtons.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _GibddButtons__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Gibdd/components/GroupPaymentBlock/GroupPaymentBlock.tsx":
      /*!*********************************************************************************!*\
        !*** ./src/components/Gibdd/components/GroupPaymentBlock/GroupPaymentBlock.tsx ***!
        \*********************************************************************************/

      /*! exports provided: GroupPaymentBlock */

      /***/
      function srcComponentsGibddComponentsGroupPaymentBlockGroupPaymentBlockTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "GroupPaymentBlock", function () {
          return GroupPaymentBlock;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _components_Gibdd_components_GroupPaymentsLoader_GroupPaymentsLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader */
        "./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.tsx");
        /* harmony import */


        var _components_Gibdd_components_PaymentCenterBlock_PaymentCenterBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/components/Gibdd/components/PaymentCenterBlock/PaymentCenterBlock */
        "./src/components/Gibdd/components/PaymentCenterBlock/PaymentCenterBlock.tsx");
        /* harmony import */


        var _components_Gibdd_components_UnpaidFinesInfo_UnpaidFinesInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo */
        "./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.tsx");

        var GroupPaymentBlock = function GroupPaymentBlock(_a) {
          var finesInfo = _a.finesInfo,
              onMoreClick = _a.onMoreClick,
              loading = _a.loading;

          if (loading) {
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Gibdd_components_GroupPaymentsLoader_GroupPaymentsLoader__WEBPACK_IMPORTED_MODULE_1__["default"], null);
          }

          if (!(finesInfo && finesInfo.count) || finesInfo.count === 1) {
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Gibdd_components_PaymentCenterBlock_PaymentCenterBlock__WEBPACK_IMPORTED_MODULE_2__["default"], null);
          }

          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Gibdd_components_UnpaidFinesInfo_UnpaidFinesInfo__WEBPACK_IMPORTED_MODULE_3__["default"], {
            finesInfo: finesInfo,
            onMoreClick: onMoreClick
          });
        };
        /***/

      },

      /***/
      "./src/components/Gibdd/components/GroupPayments/GroupPayments.css":
      /*!*************************************************************************!*\
        !*** ./src/components/Gibdd/components/GroupPayments/GroupPayments.css ***!
        \*************************************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsGibddComponentsGroupPaymentsGroupPaymentsCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../../node_modules/postcss-loader/src!./GroupPayments.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/GroupPayments/GroupPayments.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Gibdd/components/GroupPayments/GroupPayments.tsx":
      /*!*************************************************************************!*\
        !*** ./src/components/Gibdd/components/GroupPayments/GroupPayments.tsx ***!
        \*************************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsGroupPaymentsGroupPaymentsTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _GroupPayments_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./GroupPayments.css */
        "./src/components/Gibdd/components/GroupPayments/GroupPayments.css");
        /* harmony import */


        var _GroupPayments_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_GroupPayments_css__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var mobx_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! mobx-react */
        "./node_modules/mobx-react/index.module.js");
        /* harmony import */


        var _utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/setUrlParameter */
        "./src/utils/setUrlParameter.ts");
        /* harmony import */


        var _components_Gibdd_components_GroupPaymentBlock_GroupPaymentBlock__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/components/Gibdd/components/GroupPaymentBlock/GroupPaymentBlock */
        "./src/components/Gibdd/components/GroupPaymentBlock/GroupPaymentBlock.tsx");
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _utils_features__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/features */
        "./src/utils/features.ts");
        /* harmony import */


        var _utils_getFeaturesStringByPrefix__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @/utils/getFeaturesStringByPrefix */
        "./src/utils/getFeaturesStringByPrefix.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics16 = function extendStatics(d, b) {
            _extendStatics16 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics16(d, b);
          };

          return function (d, b) {
            _extendStatics16(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_5__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_6__["EHeaderTypes"].LETTER_META);

        var GroupPayments =
        /** @class */
        function (_super) {
          __extends(GroupPayments, _super);

          function GroupPayments() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              popupOpen: false
            };
            _this.ftrs = Object(_utils_getFeaturesStringByPrefix__WEBPACK_IMPORTED_MODULE_13__["default"])(_this.props.context.features, 'gibdd');
            _this.groupByDefault = _this.props.context.features.has(_utils_features__WEBPACK_IMPORTED_MODULE_12__["EFeatures"].GIBDD_GROUP_PAY_BY_DEFAULT);

            _this.setPopupOpen = function (value) {
              _this.setState({
                popupOpen: value
              });
            };

            _this.handleGroupPaymentClose = function () {
              var onPopupToggle = _this.props.context.onPopupToggle;

              _this.setPopupOpen(false);

              onPopupToggle(false);
              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_7__["default"].paymentGroupClose);
            };

            _this.handleGroupPaymentOpen = function () {
              var onPopupToggle = _this.props.context.onPopupToggle;

              _this.setPopupOpen(true);

              onPopupToggle(true);
              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_7__["default"].clickGroupPayment);
            };

            return _this;
          }

          GroupPayments.prototype.render = function () {
            var _a = this.props,
                _b = _a.context,
                paymentUrl = _b.paymentUrl,
                email = _b.email,
                finesInfo = _a.finesInfo,
                loading = _a.loading;

            var _c = this,
                groupByDefault = _c.groupByDefault,
                ftrs = _c.ftrs;

            var popupOpen = this.state.popupOpen;
            var from = groupByDefault ? 'die-grp_gd-exp' : 'die-grp';
            var groupPaymentUrl = Object(_utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_9__["default"])(paymentUrl, {
              group: true,
              group_by_default: groupByDefault,
              ftrs: ftrs,
              from: from,
              'x-email': email,
              id: 'null'
            });
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Gibdd_components_GroupPaymentBlock_GroupPaymentBlock__WEBPACK_IMPORTED_MODULE_10__["GroupPaymentBlock"], {
              loading: loading,
              finesInfo: finesInfo,
              onMoreClick: this.handleGroupPaymentOpen
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["FramePopup"], {
              src: groupPaymentUrl,
              initialWidth: _utils_constants__WEBPACK_IMPORTED_MODULE_11__["SIZE_POPUP"].medium,
              initialHeight: _utils_constants__WEBPACK_IMPORTED_MODULE_11__["GIBDD_POPUP_HEIGHT"],
              show: popupOpen,
              onHide: this.handleGroupPaymentClose,
              closeByEsc: true,
              iframeScrolling: "no"
            }));
          };

          GroupPayments = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_2__(_GroupPayments_css__WEBPACK_IMPORTED_MODULE_3___default.a)], GroupPayments);
          return GroupPayments;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_4__["withContext"])(Object(mobx_react__WEBPACK_IMPORTED_MODULE_8__["observer"])(GroupPayments));
        /***/
      },

      /***/
      "./src/components/Gibdd/components/GroupPayments/index.ts":
      /*!****************************************************************!*\
        !*** ./src/components/Gibdd/components/GroupPayments/index.ts ***!
        \****************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsGroupPaymentsIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _GroupPayments__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./GroupPayments */
        "./src/components/Gibdd/components/GroupPayments/GroupPayments.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _GroupPayments__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.css":
      /*!*************************************************************************************!*\
        !*** ./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.css ***!
        \*************************************************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsGibddComponentsGroupPaymentsLoaderGroupPaymentsLoaderCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../../node_modules/postcss-loader/src!./GroupPaymentsLoader.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.tsx":
      /*!*************************************************************************************!*\
        !*** ./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.tsx ***!
        \*************************************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsGroupPaymentsLoaderGroupPaymentsLoaderTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _GroupPaymentsLoader_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./GroupPaymentsLoader.css */
        "./src/components/Gibdd/components/GroupPaymentsLoader/GroupPaymentsLoader.css");
        /* harmony import */


        var _GroupPaymentsLoader_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_GroupPaymentsLoader_css__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_dataTestId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/dataTestId */
        "./src/utils/dataTestId.ts");

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_3__["defineMessages"])({
          loading: {
            "id": "hC4Llg==",
            "defaultMessage": "\u041F\u043E\u0438\u0441\u043A \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0445 \u0448\u0442\u0440\u0430\u0444\u043E\u0432{hellip}"
          }
        });

        var GroupPaymentsLoader = function GroupPaymentsLoader() {
          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
            styleName: "group-payment-loading-block",
            "data-test-id": _utils_dataTestId__WEBPACK_IMPORTED_MODULE_5__["EDataTestId"].GIBDD_HEADER_GROUP_BLOCK
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
            styleName: "loader",
            "data-test-id": _utils_dataTestId__WEBPACK_IMPORTED_MODULE_5__["EDataTestId"].GIBDD_HEADER_GROUP_LOADER
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Progress"], {
            secondary: true,
            size: 16
          })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
            secondary: true
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_3__["FormattedMessage"], __assign({}, messages.loading, {
            values: {
              hellip: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, "\u2026")
            }
          }))));
        };
        /* harmony default export */


        __webpack_exports__["default"] = react_css_modules__WEBPACK_IMPORTED_MODULE_2__(GroupPaymentsLoader, _GroupPaymentsLoader_css__WEBPACK_IMPORTED_MODULE_4___default.a);
        /***/
      },

      /***/
      "./src/components/Gibdd/components/PaymentCenterBlock/PaymentCenterBlock.tsx":
      /*!***********************************************************************************!*\
        !*** ./src/components/Gibdd/components/PaymentCenterBlock/PaymentCenterBlock.tsx ***!
        \***********************************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsPaymentCenterBlockPaymentCenterBlockTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _components_Gibdd_components_GroupPayments_GroupPayments_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/components/Gibdd/components/GroupPayments/GroupPayments.css */
        "./src/components/Gibdd/components/GroupPayments/GroupPayments.css");
        /* harmony import */


        var _components_Gibdd_components_GroupPayments_GroupPayments_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_Gibdd_components_GroupPayments_GroupPayments_css__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _utils_dataTestId__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/utils/dataTestId */
        "./src/utils/dataTestId.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics17 = function extendStatics(d, b) {
            _extendStatics17 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics17(d, b);
          };

          return function (d, b) {
            _extendStatics17(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_8__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__["EHeaderTypes"].LETTER_META);
        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_3__["defineMessages"])({
          unavailable: {
            "id": "f+tG3A==",
            "defaultMessage": "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0440\u0430\u0437\u0434\u0435\u043B \u0448\u0442\u0440\u0430\u0444\u044B"
          }
        });

        var PaymentCenterBlock =
        /** @class */
        function (_super) {
          __extends(PaymentCenterBlock, _super);

          function PaymentCenterBlock() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          PaymentCenterBlock.prototype.componentDidMount = function () {
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_6__["default"].gibddShowPaymentCenterLink);
          };

          PaymentCenterBlock.prototype.render = function () {
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "group-payment-block",
              "data-test-id": _utils_dataTestId__WEBPACK_IMPORTED_MODULE_10__["EDataTestId"].GIBDD_HEADER_GROUP_BLOCK
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
              secondary: true
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Link"], {
              testId: _utils_dataTestId__WEBPACK_IMPORTED_MODULE_10__["EDataTestId"].GIBDD_HEADER_PAYMENT_CENTER_LINK,
              target: "_blank",
              rel: "noopener noreferrer",
              href: _utils_constants__WEBPACK_IMPORTED_MODULE_7__["PAYMENT_CENTER_FINES_URL"],
              secondary: true
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.unavailable))));
          };

          return PaymentCenterBlock;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = react_css_modules__WEBPACK_IMPORTED_MODULE_2__(PaymentCenterBlock, _components_Gibdd_components_GroupPayments_GroupPayments_css__WEBPACK_IMPORTED_MODULE_4___default.a);
        /***/
      },

      /***/
      "./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.css":
      /*!*****************************************************************************!*\
        !*** ./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.css ***!
        \*****************************************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsGibddComponentsUnpaidFinesInfoUnpaidFinesInfoCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../../node_modules/postcss-loader/src!./UnpaidFinesInfo.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.tsx":
      /*!*****************************************************************************!*\
        !*** ./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.tsx ***!
        \*****************************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddComponentsUnpaidFinesInfoUnpaidFinesInfoTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _UnpaidFinesInfo_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./UnpaidFinesInfo.css */
        "./src/components/Gibdd/components/UnpaidFinesInfo/UnpaidFinesInfo.css");
        /* harmony import */


        var _UnpaidFinesInfo_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_UnpaidFinesInfo_css__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var svgson_loader_static_icons_info_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! svgson-loader!@/static/icons/info.svg */
        "./node_modules/svgson-loader/index.js!./src/static/icons/info.svg");
        /* harmony import */


        var svgson_loader_static_icons_info_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_static_icons_info_svg__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _utils_dataTestId__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/utils/dataTestId */
        "./src/utils/dataTestId.ts");
        /* harmony import */


        var _utils_features__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/features */
        "./src/utils/features.ts");
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _utils_compose__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @/utils/compose */
        "./src/utils/compose.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics18 = function extendStatics(d, b) {
            _extendStatics18 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics18(d, b);
          };

          return function (d, b) {
            _extendStatics18(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_8__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__["EHeaderTypes"].LETTER_META);
        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_3__["defineMessages"])({
          available: {
            "id": "U5xzHA==",
            "defaultMessage": "\u0423 \u0432\u0430\u0441 {quantity, plural, one {# \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u0448\u0442\u0440\u0430\u0444} few {# \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0445 \u0448\u0442\u0440\u0430\u0444\u0430} other {# \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0445 \u0448\u0442\u0440\u0430\u0444\u043E\u0432}} \u043D\u0430"
          },
          more: {
            "id": "SiQJ8Q==",
            "defaultMessage": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C"
          },
          payAll: {
            "id": "qRpmUw==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0432\u0441\u0451"
          }
        });

        var UnpaidFinesInfo =
        /** @class */
        function (_super) {
          __extends(UnpaidFinesInfo, _super);

          function UnpaidFinesInfo() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.groupPayByDefault = _this.props.context.features.has(_utils_features__WEBPACK_IMPORTED_MODULE_11__["EFeatures"].GIBDD_GROUP_PAY_BY_DEFAULT);
            return _this;
          }

          UnpaidFinesInfo.prototype.componentDidMount = function () {
            var _a = this.props.finesInfo,
                amount = _a.amount,
                count = _a.count;
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_7__["default"].gibddShowGroupPayment, {
              dwh: {
                count: count,
                amount: amount
              }
            });
          };

          UnpaidFinesInfo.prototype.render = function () {
            var _a = this.props,
                _b = _a.finesInfo,
                amount = _b.amount,
                count = _b.count,
                onMoreClick = _a.onMoreClick;
            var separatedAmount = (+amount).toLocaleString();
            var moreButtonText = this.groupPayByDefault ? Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_6__["i18n"])(messages.payAll) : Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_6__["i18n"])(messages.more);
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "group-payment-block",
              "data-test-id": _utils_dataTestId__WEBPACK_IMPORTED_MODULE_10__["EDataTestId"].GIBDD_HEADER_GROUP_BLOCK
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "info-icon"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Icon"], {
              icon: svgson_loader_static_icons_info_svg__WEBPACK_IMPORTED_MODULE_5___default.a
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
              testId: _utils_dataTestId__WEBPACK_IMPORTED_MODULE_10__["EDataTestId"].GIBDD_HEADER_GROUP_COUNT + ":" + count + ":" + amount
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_6__["i18n"])(messages.available, {
              quantity: count
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "group-payment-amount",
              "data-test-id": _utils_dataTestId__WEBPACK_IMPORTED_MODULE_10__["EDataTestId"].GIBDD_HEADER_GROUP_AMOUNT
            }, "\xA0", separatedAmount, "\xA0", react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Rouble"], null))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
              styleName: "button-group-more"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Link"], {
              testId: "" + _utils_dataTestId__WEBPACK_IMPORTED_MODULE_10__["EDataTestId"].GIBDD_HEADER_GROUP_MORE + (this.groupPayByDefault ? ':group-by-default' : ''),
              onClick: onMoreClick
            }, moreButtonText)));
          };

          UnpaidFinesInfo = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_2__(_UnpaidFinesInfo_css__WEBPACK_IMPORTED_MODULE_4___default.a)], UnpaidFinesInfo);
          return UnpaidFinesInfo;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_compose__WEBPACK_IMPORTED_MODULE_13__["default"])(react_css_modules__WEBPACK_IMPORTED_MODULE_2__(_UnpaidFinesInfo_css__WEBPACK_IMPORTED_MODULE_4___default.a), _utils_withContext__WEBPACK_IMPORTED_MODULE_12__["withContext"])(UnpaidFinesInfo);
        /***/
      },

      /***/
      "./src/components/Gibdd/index.ts":
      /*!***************************************!*\
        !*** ./src/components/Gibdd/index.ts ***!
        \***************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsGibddIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Gibdd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Gibdd */
        "./src/components/Gibdd/Gibdd.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Gibdd__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Header/Header.styles.tsx":
      /*!*************************************************!*\
        !*** ./src/components/Header/Header.styles.tsx ***!
        \*************************************************/

      /*! exports provided: styles */

      /***/
      function srcComponentsHeaderHeaderStylesTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "styles", function () {
          return styles;
        });

        var styles = function styles(_a) {
          var x3 = _a.x3;
          return {
            header: {
              display: 'flex',
              alignItems: 'center',
              paddingBottom: x3
            },
            pink: {
              fill: '#FF54AA'
            },
            blue: {
              fill: '#09A6FA'
            },
            purple: {
              fill: '#ba34fc'
            },
            green: {
              fill: '#28c75d'
            }
          };
        };
        /***/

      },

      /***/
      "./src/components/Header/Header.tsx":
      /*!******************************************!*\
        !*** ./src/components/Header/Header.tsx ***!
        \******************************************/

      /*! exports provided: EIconColors, Header */

      /***/
      function srcComponentsHeaderHeaderTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "EIconColors", function () {
          return EIconColors;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Header", function () {
          return Header;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _components_Header_Header_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/components/Header/Header.styles */
        "./src/components/Header/Header.styles.tsx");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics19 = function extendStatics(d, b) {
            _extendStatics19 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics19(d, b);
          };

          return function (d, b) {
            _extendStatics19(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var EIconColors;

        (function (EIconColors) {
          EIconColors["PINK"] = "pink";
          EIconColors["BLUE"] = "blue";
          EIconColors["PURPLE"] = "purple";
          EIconColors["GREEN"] = "green";
          EIconColors["NONE"] = "none";
        })(EIconColors || (EIconColors = {}));

        var Header =
        /** @class */
        function (_super) {
          __extends(Header, _super);

          function Header() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          Header.prototype.render = function () {
            var _a;

            var _b = this.props,
                classes = _b.classes,
                icon = _b.icon,
                text = _b.text,
                children = _b.children,
                color = _b.color;
            var className = classnames__WEBPACK_IMPORTED_MODULE_3__(classes.header, (_a = {}, _a[classes[color]] = true, _a));
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Icon"], {
              icon: icon
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Space"], {
              responsive: 'desktop'
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Space"], {
              small: true,
              responsive: 'desktop'
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
              bold: true
            }, text), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Space"], {
              large: true,
              responsive: 'desktop'
            }), children);
          };

          Header = __decorate([Object(_2kit__WEBPACK_IMPORTED_MODULE_1__["withStyles"])(_components_Header_Header_styles__WEBPACK_IMPORTED_MODULE_2__["styles"])], Header);
          return Header;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);
        /***/

      },

      /***/
      "./src/components/Hoc/withNavigateClick.tsx":
      /*!**************************************************!*\
        !*** ./src/components/Hoc/withNavigateClick.tsx ***!
        \**************************************************/

      /*! exports provided: withNavigateClick */

      /***/
      function srcComponentsHocWithNavigateClickTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "withNavigateClick", function () {
          return withNavigateClick;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        function onClick(next, href) {
          if (next && typeof next === 'function') {
            next();
          }

          open(href);
        }

        function withNavigateClick(Component) {
          return function (props) {
            if (!props.href) {
              return null;
            }

            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](Component, __assign({}, props, {
              onClick: onClick.bind(null, props.onClick, props.href)
            }));
          };
        }
        /***/

      },

      /***/
      "./src/components/Hoc/withRadar.tsx":
      /*!******************************************!*\
        !*** ./src/components/Hoc/withRadar.tsx ***!
        \******************************************/

      /*! exports provided: withRadar */

      /***/
      function srcComponentsHocWithRadarTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "withRadar", function () {
          return withRadar;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics20 = function extendStatics(d, b) {
            _extendStatics20 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics20(d, b);
          };

          return function (d, b) {
            _extendStatics20(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        }; // Добавляет простой радар на mount и onClick, с передачей данных через проп


        function withRadar(Component) {
          return (
            /** @class */
            function (_super) {
              __extends(Wrapper, _super);

              function Wrapper() {
                var _this = _super !== null && _super.apply(this, arguments) || this;

                _this.onClick = function (data) {
                  var _a = _this.props,
                      radar = _a.radar,
                      sender = _a.sender,
                      next = _a.onClick;

                  if (next) {
                    next(data);
                  }

                  if (sender) {
                    sender(radar.t, radar.params);
                  }
                };

                return _this;
              }

              Wrapper.prototype.componentDidMount = function () {
                var _a = this.props,
                    _b = _a.sender,
                    sender = _b === void 0 ? null : _b,
                    radarOnMount = _a.radarOnMount;

                if (!sender || !radarOnMount) {
                  return null;
                }

                sender(radarOnMount.t, radarOnMount.params);
              };

              Wrapper.prototype.render = function () {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](Component, __assign({}, this.props, {
                  onClick: this.onClick
                }));
              };

              return Wrapper;
            }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"])
          );
        }
        /***/

      },

      /***/
      "./src/components/Hoc/withSmallButton.tsx":
      /*!************************************************!*\
        !*** ./src/components/Hoc/withSmallButton.tsx ***!
        \************************************************/

      /*! exports provided: withSmallButton */

      /***/
      function srcComponentsHocWithSmallButtonTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "withSmallButton", function () {
          return withSmallButton;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        function withSmallButton(Component) {
          return function (props) {
            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, __assign({}, props, {
              small: true
            }));
          };
        }
        /***/

      },

      /***/
      "./src/components/IncompleteOrder/IncompleteOrder.css":
      /*!************************************************************!*\
        !*** ./src/components/IncompleteOrder/IncompleteOrder.css ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsIncompleteOrderIncompleteOrderCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./IncompleteOrder.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/IncompleteOrder/IncompleteOrder.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/IncompleteOrder/IncompleteOrder.tsx":
      /*!************************************************************!*\
        !*** ./src/components/IncompleteOrder/IncompleteOrder.tsx ***!
        \************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsIncompleteOrderIncompleteOrderTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./IncompleteOrder.css */
        "./src/components/IncompleteOrder/IncompleteOrder.css");
        /* harmony import */


        var _IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/components/BillingInfoTooltip */
        "./src/components/BillingInfoTooltip/index.ts");
        /* harmony import */


        var _components_IncompleteOrder_components_IncompleteOrderButtons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/components/IncompleteOrder/components/IncompleteOrderButtons */
        "./src/components/IncompleteOrder/components/IncompleteOrderButtons/index.ts");
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/components/PaymentStatus */
        "./src/components/PaymentStatus/index.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics21 = function extendStatics(d, b) {
            _extendStatics21 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics21(d, b);
          };

          return function (d, b) {
            _extendStatics21(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };
        /* tslint:disable:no-implicit-dependencies */

        /* tslint:enable:no-implicit-dependencies */


        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_10__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_11__["EHeaderTypes"].LETTER_META); // tslint:disable:max-line-length

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_5__["defineMessages"])({
          incompleteOrder: {
            "id": "4KCXvw==",
            "defaultMessage": "\u041D\u0435\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0439 \u0437\u0430\u043A\u0430\u0437 \u043D\u0430 {amount}"
          },
          billingHeader: {
            "id": "3x/hpA==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u043F\u0440\u044F\u043C\u043E{br}\u0432{nbsp}\u041F\u043E\u0447\u0442\u0435"
          }
        }); // tslint:enable:max-line-length

        var IncompleteOrder =
        /** @class */
        function (_super) {
          __extends(IncompleteOrder, _super);

          function IncompleteOrder() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              isDetailedPopupOpen: false
            };

            _this.onDetailedClick = function () {
              _this.setState({
                isDetailedPopupOpen: true
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(true);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_3__["default"].clickDetailedLink);
            };

            _this.onDetailedClose = function () {
              _this.setState({
                isDetailedPopupOpen: false
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(false);
              }
            };

            return _this;
          }

          IncompleteOrder.prototype.componentDidMount = function () {
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_3__["default"].showDie);
          };

          Object.defineProperty(IncompleteOrder.prototype, "billingHeader", {
            get: function get() {
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_5__["FormattedMessage"], __assign({}, messages.billingHeader, {
                values: {
                  nbsp: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, "\xA0"),
                  br: react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("br", null)
                }
              }));
            },
            enumerable: true,
            configurable: true
          });

          IncompleteOrder.prototype.render = function () {
            var _a;

            var _b = this.props,
                _c = _b.context,
                paymentUrl = _c.paymentUrl,
                _d = _c.paymentInfo,
                status = _d.status,
                preview_image = _d.preview_image,
                description = _d.description,
                amount = _d.amount,
                octavius = _c.octavius,
                detailedUrl = _b.detailedUrl,
                darkMode = _b.darkMode;
            var isDetailedPopupOpen = this.state.isDetailedPopupOpen;
            var mainStyle = "order" + (octavius ? '-octavius' : '');
            var className = classnames__WEBPACK_IMPORTED_MODULE_12___default()((_a = {}, _a[_IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_4___default.a[mainStyle]] = true, _a[_IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_4___default.a['order-main-darkMode']] = octavius && darkMode, _a));
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className,
              "data-test-id": "incomplete_order_die"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "order-main"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "order-main-image-block"
            }, preview_image && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "order-main-image",
              "data-test-id": "preview_image",
              style: {
                backgroundImage: "url(" + preview_image + ")"
              }
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "order-main-text-block"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "billing-info"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_6__["default"], {
              header: this.billingHeader
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header-text"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Text"], {
              mode: "h4"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_5__["FormattedMessage"], __assign({}, messages.incompleteOrder, {
              values: {
                amount: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, amount, "\xA0", react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Rouble"], null))
              }
            })))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_PaymentStatus__WEBPACK_IMPORTED_MODULE_9__["default"], {
              status: status
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["FramePopup"], {
              src: detailedUrl,
              initialWidth: '420px',
              initialHeight: '544px',
              show: isDetailedPopupOpen,
              onHide: this.onDetailedClose,
              closeByEsc: true
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "name"
            }, description && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Text"], {
              mode: "small"
            }, description)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_IncompleteOrder_components_IncompleteOrderButtons__WEBPACK_IMPORTED_MODULE_7__["default"], {
              paymentUrl: paymentUrl
            }))));
          };

          IncompleteOrder = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_1__(_IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_4___default.a)], IncompleteOrder);
          return IncompleteOrder;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_8__["withContext"])(IncompleteOrder);
        /***/
      },

      /***/
      "./src/components/IncompleteOrder/components/IncompleteOrderButtons/IncompleteOrderButtons.tsx":
      /*!*****************************************************************************************************!*\
        !*** ./src/components/IncompleteOrder/components/IncompleteOrderButtons/IncompleteOrderButtons.tsx ***!
        \*****************************************************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsIncompleteOrderComponentsIncompleteOrderButtonsIncompleteOrderButtonsTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _components_IncompleteOrder_IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/components/IncompleteOrder/IncompleteOrder.css */
        "./src/components/IncompleteOrder/IncompleteOrder.css");
        /* harmony import */


        var _components_IncompleteOrder_IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_IncompleteOrder_IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/components/PaymentStatus */
        "./src/components/PaymentStatus/index.ts");
        /* harmony import */


        var _components_ReloadStatus_ReloadStatus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/components/ReloadStatus/ReloadStatus */
        "./src/components/ReloadStatus/ReloadStatus.tsx");
        /* harmony import */


        var _components_ReceiptButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/components/ReceiptButton */
        "./src/components/ReceiptButton/index.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics22 = function extendStatics(d, b) {
            _extendStatics22 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics22(d, b);
          };

          return function (d, b) {
            _extendStatics22(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_11__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_12__["EHeaderTypes"].LETTER_META);
        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_2__["defineMessages"])({
          buy: {
            "id": "yckMXA==",
            "defaultMessage": "\u041A\u0443\u043F\u0438\u0442\u044C"
          },
          showReceipt: {
            "id": "wSVErA==",
            "defaultMessage": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0430\u043A\u0430\u0437"
          },
          paymentBill: {
            "id": "S1wD+A==",
            "defaultMessage": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0447\u0435\u043A \u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u0435"
          }
        });

        var IncompleteOrderButtons =
        /** @class */
        function (_super) {
          __extends(IncompleteOrderButtons, _super);

          function IncompleteOrderButtons() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              isOpen: false
            };

            _this.onPayedClick = function () {
              _this.setState({
                isOpen: true
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(true);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].clickButtonPayment);
            };

            _this.onPayedClose = function () {
              _this.setState({
                isOpen: false
              });

              var onPopupToggle = _this.props.context.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(false);
              }
            };

            _this.setRadarOnReceiptClick = function () {
              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].incompleteReceiptClick);
            };

            return _this;
          }

          IncompleteOrderButtons.prototype.onShowReceipt = function () {
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"].showReceipt);
          };

          IncompleteOrderButtons.prototype.render = function () {
            var isOpen = this.state.isOpen;
            var paymentUrl = this.props.paymentUrl;
            var _a = this.props.context.paymentInfo,
                link_receipt = _a.link_receipt,
                status = _a.status,
                link_receipt_paid = _a.link_receipt_paid;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "buttons-block"
            }, (!status || status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["STATUS_ERROR"]) && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              "data-test-id": "payment_payed"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
              primary: true,
              small: true,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.buy),
              onClick: this.onPayedClick
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Space"], null)), status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["STATUS_AWAITING"] && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_ReloadStatus_ReloadStatus__WEBPACK_IMPORTED_MODULE_9__["default"], {
              formType: "incomplete"
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Space"], null)), status === _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_8__["STATUS_SUCCESS"] && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_ReceiptButton__WEBPACK_IMPORTED_MODULE_10__["default"], {
              href: link_receipt_paid,
              onClick: this.setRadarOnReceiptClick,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.paymentBill)
            }), !!link_receipt && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("a", {
              onClick: this.onShowReceipt,
              "data-test-id": "payment_order",
              href: link_receipt,
              target: "_blank"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
              contrast: true,
              small: true,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.showReceipt)
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["FramePopup"], {
              src: paymentUrl,
              initialWidth: '420px',
              initialHeight: '625px',
              show: isOpen,
              onHide: this.onPayedClose,
              closeByEsc: true,
              iframeScrolling: "no"
            }));
          };

          IncompleteOrderButtons = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_3__(_components_IncompleteOrder_IncompleteOrder_css__WEBPACK_IMPORTED_MODULE_7___default.a)], IncompleteOrderButtons);
          return IncompleteOrderButtons;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_6__["withContext"])(IncompleteOrderButtons);
        /***/
      },

      /***/
      "./src/components/IncompleteOrder/components/IncompleteOrderButtons/index.ts":
      /*!***********************************************************************************!*\
        !*** ./src/components/IncompleteOrder/components/IncompleteOrderButtons/index.ts ***!
        \***********************************************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsIncompleteOrderComponentsIncompleteOrderButtonsIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _IncompleteOrderButtons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./IncompleteOrderButtons */
        "./src/components/IncompleteOrder/components/IncompleteOrderButtons/IncompleteOrderButtons.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _IncompleteOrderButtons__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/IncompleteOrder/index.ts":
      /*!*************************************************!*\
        !*** ./src/components/IncompleteOrder/index.ts ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsIncompleteOrderIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _IncompleteOrder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./IncompleteOrder */
        "./src/components/IncompleteOrder/IncompleteOrder.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _IncompleteOrder__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Mobile/Mobile.css":
      /*!******************************************!*\
        !*** ./src/components/Mobile/Mobile.css ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function srcComponentsMobileMobileCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./Mobile.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Mobile/Mobile.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Mobile/Mobile.tsx":
      /*!******************************************!*\
        !*** ./src/components/Mobile/Mobile.tsx ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMobileMobileTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _Mobile_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Mobile.css */
        "./src/components/Mobile/Mobile.css");
        /* harmony import */


        var _Mobile_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Mobile_css__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/components/BillingInfoTooltip */
        "./src/components/BillingInfoTooltip/index.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_10__);

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics23 = function extendStatics(d, b) {
            _extendStatics23 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics23(d, b);
          };

          return function (d, b) {
            _extendStatics23(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };
        /* tslint:disable:no-implicit-dependencies */


        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_8__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__["EHeaderTypes"].LETTER_META); // tslint:disable:max-line-length

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_4__["defineMessages"])({
          balance: {
            "id": "ueGUGA==",
            "defaultMessage": "\u0411\u0430\u043B\u0430\u043D\u0441 \u043C\u0435\u043D\u044C\u0448\u0435 {threshold}"
          },
          number: {
            "id": "lXS8JQ==",
            "defaultMessage": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430:"
          },
          recharge: {
            "id": "/nzlhw==",
            "defaultMessage": "\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C"
          },
          billingHeader: {
            "id": "LHZucw==",
            "defaultMessage": "\u041F\u043E\u043F\u043E\u043B\u043D\u044F\u0439\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u043F\u0440\u044F\u043C\u043E{br}\u0432{nbsp}\u041F\u043E\u0447\u0442\u0435"
          }
        }); // tslint:enable:max-line-length

        var Mobile =
        /** @class */
        function (_super) {
          __extends(Mobile, _super);

          function Mobile() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              isPaymentPopupOpen: false
            };

            _this.onPaymentClose = function () {
              _this.setState({
                isPaymentPopupOpen: false
              });

              var onPopupToggle = _this.props.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(false);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].paymentClose);
            };

            _this.onPaymentClick = function () {
              _this.setState({
                isPaymentPopupOpen: true
              });

              var onPopupToggle = _this.props.onPopupToggle;

              if (onPopupToggle) {
                onPopupToggle(true);
              }

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].clickButtonPayment);
            };

            return _this;
          }

          Mobile.prototype.componentDidMount = function () {
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_2__["default"].showDie);
          };

          Object.defineProperty(Mobile.prototype, "billingHeader", {
            get: function get() {
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_4__["FormattedMessage"], __assign({}, messages.billingHeader, {
                values: {
                  nbsp: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, "\xA0"),
                  br: react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("br", null)
                }
              }));
            },
            enumerable: true,
            configurable: true
          });

          Mobile.prototype.render = function () {
            var _a;

            var _b = this.props,
                phone = _b.phone,
                providerLogo = _b.providerLogo,
                rechargeTreshold = _b.rechargeTreshold,
                paymentUrl = _b.paymentUrl,
                octavius = _b.octavius,
                darkMode = _b.darkMode;
            var isPaymentPopupOpen = this.state.isPaymentPopupOpen;
            var mainStyle = octavius ? 'main-octavius' : 'main';
            var className = classnames__WEBPACK_IMPORTED_MODULE_10___default()((_a = {}, _a[_Mobile_css__WEBPACK_IMPORTED_MODULE_6___default.a[mainStyle]] = true, _a[_Mobile_css__WEBPACK_IMPORTED_MODULE_6___default.a['main-octavius-darkMode']] = octavius && darkMode, _a));
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className,
              "data-test-id": "mobile_die"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "header"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], {
              mode: "h4"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "icon"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("img", {
              src: providerLogo,
              width: 24,
              height: 24
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react_intl__WEBPACK_IMPORTED_MODULE_4__["FormattedMessage"], __assign({}, messages.balance, {
              values: {
                threshold: react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, rechargeTreshold, "\xA0", react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Rouble"], null))
              }
            }))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "billing-info"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_7__["default"], {
              header: this.billingHeader
            }))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "info"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Text"], null, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.number), "\xA0", phone)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "buttons-block"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              "data-test-id": "payment_payed",
              onClick: this.onPaymentClick
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["Button"], {
              primary: true,
              small: true,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.recharge)
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_3__["FramePopup"], {
              src: paymentUrl,
              initialWidth: '420px',
              initialHeight: '351px',
              show: isPaymentPopupOpen,
              onHide: this.onPaymentClose,
              closeByEsc: true
            })));
          };

          Mobile = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_1__(_Mobile_css__WEBPACK_IMPORTED_MODULE_6___default.a)], Mobile);
          return Mobile;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Mobile;
        /***/
      },

      /***/
      "./src/components/Mobile/index.ts":
      /*!****************************************!*\
        !*** ./src/components/Mobile/index.ts ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMobileIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Mobile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Mobile */
        "./src/components/Mobile/Mobile.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Mobile__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Moneta/Body/Body.css":
      /*!*********************************************!*\
        !*** ./src/components/Moneta/Body/Body.css ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function srcComponentsMonetaBodyBodyCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src!./Body.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Moneta/Body/Body.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Moneta/Body/Body.tsx":
      /*!*********************************************!*\
        !*** ./src/components/Moneta/Body/Body.tsx ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMonetaBodyBodyTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _Body_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./Body.css */
        "./src/components/Moneta/Body/Body.css");
        /* harmony import */


        var _Body_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Body_css__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_categories_document_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! svgson-loader!mrg-icons/src/mailru/categories/document.svg */
        "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/categories/document.svg");
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_categories_document_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_mrg_icons_src_mailru_categories_document_svg__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_addMerchantParam__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/addMerchantParam */
        "./src/utils/addMerchantParam.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics24 = function extendStatics(d, b) {
            _extendStatics24 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics24(d, b);
          };

          return function (d, b) {
            _extendStatics24(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_6__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_7__["EHeaderTypes"].LETTER_META);
        var MAX_INFO_LENGTH = 3;
        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_4__["defineMessages"])({
          company: {
            "id": "NwmWIg==",
            "defaultMessage": "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F"
          },
          pay: {
            "id": "4PVfuA==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C"
          },
          receipt: {
            "id": "ijGAmg==",
            "defaultMessage": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043A\u0432\u0438\u0442\u0430\u043D\u0446\u0438\u044E"
          }
        });

        var Body =
        /** @class */
        function (_super) {
          __extends(Body, _super);

          function Body() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              isOpen: false,
              height: 680,
              width: 684
            };

            _this.handlePostMessage = function (event) {
              var _a = _this.state,
                  height = _a.height,
                  width = _a.width;

              if (!event || !event.data) {
                return;
              }

              try {
                var message = JSON.parse(event.data);

                if (!message) {
                  return;
                }

                switch (message.m_type) {
                  case 'iframeSize':
                    if (height !== message.height) {
                      _this.setState({
                        height: message.height
                      });
                    }

                    if (width !== message.width) {
                      _this.setState({
                        width: message.width
                      });
                    }

                    break;

                  case 'iframeClose':
                    _this.onPayedClose();

                    break;
                }
              } catch (e) {
                xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_8__["default"].postMessageParseError);
              }
            };

            _this.onPayedClick = function () {
              _this.setState({
                isOpen: true
              });

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_8__["default"].clickButtonPayment);
            };

            _this.onPayedClose = function () {
              _this.setState({
                isOpen: false
              });

              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_8__["default"].paymentClose);
            };

            _this.onReceiptClick = function () {
              xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_8__["default"].showReceipt);
            };

            _this.getField = function (field, isBold, value) {
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                className: _Body_css__WEBPACK_IMPORTED_MODULE_2___default.a.paymentInfoElement,
                "data-test-id": "info-field"
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                className: _Body_css__WEBPACK_IMPORTED_MODULE_2___default.a.label
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
                secondary: true,
                mode: "small"
              }, field)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
                bold: isBold
              }, value));
            };

            _this.getPaymentElement = function (url, width, height, isOpen, additionalInfo) {
              var paymentUrl = Object(_utils_addMerchantParam__WEBPACK_IMPORTED_MODULE_9__["default"])(url, {
                from: 'die'
              });
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                className: _Body_css__WEBPACK_IMPORTED_MODULE_2___default.a.buttonBlock
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
                primary: true,
                onClick: _this.onPayedClick,
                testId: "moneta_payment_button"
              }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.pay)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["FramePopup"], {
                src: paymentUrl,
                initialWidth: "680",
                initialHeight: "684",
                width: width,
                height: height,
                show: isOpen,
                onHide: _this.onPayedClose,
                closeByEsc: true,
                iframeScrolling: "no"
              }), additionalInfo);
            };

            _this.getReceiptButton = function (linkReceipt) {
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                className: _Body_css__WEBPACK_IMPORTED_MODULE_2___default.a.buttonBlock
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("a", {
                href: linkReceipt,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: _this.onReceiptClick
              }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
                contrast: true,
                icon: svgson_loader_mrg_icons_src_mailru_categories_document_svg__WEBPACK_IMPORTED_MODULE_3___default.a,
                testId: "moneta_receipt_button"
              }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.receipt))));
            };

            return _this;
          }

          Body.prototype.componentDidMount = function () {
            window.addEventListener('message', this.handlePostMessage);
          };

          Body.prototype.componentWillUnmount = function () {
            window.removeEventListener('message', this.handlePostMessage);
          };

          Body.prototype.render = function () {
            var _this = this;

            var _a = this.props,
                info = _a.info,
                additionalInfo = _a.additionalInfo,
                paymentUrl = _a.paymentUrl,
                linkReceipt = _a.linkReceipt,
                provider = _a.provider;
            var _b = this.state,
                isOpen = _b.isOpen,
                width = _b.width,
                height = _b.height;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: _Body_css__WEBPACK_IMPORTED_MODULE_2___default.a.body,
              "data-test-id": "moneta_info"
            }, info.length > 0 && info.slice(0, MAX_INFO_LENGTH).map(function (element) {
              return element.value && element.field && _this.getField(element.field, element.isBold, element.value);
            }), info.length === 0 && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: _Body_css__WEBPACK_IMPORTED_MODULE_2___default.a.paymentInfoElement,
              "data-test-id": "provider"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: _Body_css__WEBPACK_IMPORTED_MODULE_2___default.a.label
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], {
              secondary: true,
              mode: "small"
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.company))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Text"], null, provider)), paymentUrl && !linkReceipt && this.getPaymentElement(paymentUrl, width, height, isOpen, additionalInfo), linkReceipt && this.getReceiptButton(linkReceipt));
          };

          return Body;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Body;
        /***/
      },

      /***/
      "./src/components/Moneta/Body/index.ts":
      /*!*********************************************!*\
        !*** ./src/components/Moneta/Body/index.ts ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMonetaBodyIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Body__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Body */
        "./src/components/Moneta/Body/Body.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Body__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Moneta/Footer/Footer.css":
      /*!*************************************************!*\
        !*** ./src/components/Moneta/Footer/Footer.css ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsMonetaFooterFooterCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src!./Footer.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Moneta/Footer/Footer.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Moneta/Footer/Footer.tsx":
      /*!*************************************************!*\
        !*** ./src/components/Moneta/Footer/Footer.tsx ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMonetaFooterFooterTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _Footer_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./Footer.css */
        "./src/components/Moneta/Footer/Footer.css");
        /* harmony import */


        var _Footer_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Footer_css__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var svgson_loader_static_icons_payment_center_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! svgson-loader!@/static/icons/payment_center.svg */
        "./node_modules/svgson-loader/index.js!./src/static/icons/payment_center.svg");
        /* harmony import */


        var svgson_loader_static_icons_payment_center_svg__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_static_icons_payment_center_svg__WEBPACK_IMPORTED_MODULE_10__);

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_8__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__["EHeaderTypes"].LETTER_META);
        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_5__["defineMessages"])({
          about: {
            "id": "T+ehIw==",
            "defaultMessage": "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0432\u043E\u0438 \u0441\u0447\u0435\u0442\u0430, \u043D\u0430\u043B\u043E\u0433\u0438 \u0438 \u0448\u0442\u0440\u0430\u0444\u044B \u0432"
          },
          link: {
            "id": "rYn+DQ==",
            "defaultMessage": "\u0446\u0435\u043D\u0442\u0440\u0435 \u043E\u043F\u043B\u0430\u0442"
          }
        });

        var Footer = function Footer() {
          var onPaymentCenterClick = function onPaymentCenterClick() {
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_7__["default"].paymentCenterClick);
          };

          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
            className: _Footer_css__WEBPACK_IMPORTED_MODULE_3___default.a.footer
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("a", {
            href: _utils_constants__WEBPACK_IMPORTED_MODULE_6__["PAYMENT_CENTER_URL"],
            target: "_blank",
            rel: "noopener noreferrer"
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Icon"], {
            icon: svgson_loader_static_icons_payment_center_svg__WEBPACK_IMPORTED_MODULE_10___default.a
          })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
            className: _Footer_css__WEBPACK_IMPORTED_MODULE_3___default.a.mainText
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Text"], null, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.about))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
            onClick: onPaymentCenterClick,
            className: _Footer_css__WEBPACK_IMPORTED_MODULE_3___default.a.paymentCenterLink
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Link"], {
            href: _utils_constants__WEBPACK_IMPORTED_MODULE_6__["PAYMENT_CENTER_URL"],
            target: "_blank",
            rel: "noopener noreferrer",
            testId: "pay_center_link"
          }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_4__["i18n"])(messages.link))));
        };
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_1__["withContext"])(Footer);
        /***/
      },

      /***/
      "./src/components/Moneta/Footer/index.ts":
      /*!***********************************************!*\
        !*** ./src/components/Moneta/Footer/index.ts ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMonetaFooterIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Footer */
        "./src/components/Moneta/Footer/Footer.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Footer__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Moneta/Header/Header.css":
      /*!*************************************************!*\
        !*** ./src/components/Moneta/Header/Header.css ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsMonetaHeaderHeaderCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src!./Header.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Moneta/Header/Header.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Moneta/Header/Header.tsx":
      /*!*************************************************!*\
        !*** ./src/components/Moneta/Header/Header.tsx ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMonetaHeaderHeaderTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/components/BillingInfoTooltip */
        "./src/components/BillingInfoTooltip/index.ts");
        /* harmony import */


        var _Header_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./Header.css */
        "./src/components/Moneta/Header/Header.css");
        /* harmony import */


        var _Header_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Header_css__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _components_PaymentStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/components/PaymentStatus */
        "./src/components/PaymentStatus/index.ts");
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _components_Header_Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/components/Header/Header */
        "./src/components/Header/Header.tsx");

        var Header = function Header(_a) {
          var text = _a.text,
              icon = _a.icon,
              status = _a.status;
          return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
            className: _Header_css__WEBPACK_IMPORTED_MODULE_2___default.a.header
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Header_Header__WEBPACK_IMPORTED_MODULE_5__["Header"], {
            icon: icon,
            color: _components_Header_Header__WEBPACK_IMPORTED_MODULE_5__["EIconColors"].GREEN,
            text: text
          }, status && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
            "data-test-id": "moneta_status:" + status
          }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_PaymentStatus__WEBPACK_IMPORTED_MODULE_3__["default"], {
            status: status
          }))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_BillingInfoTooltip__WEBPACK_IMPORTED_MODULE_1__["default"], {
            textType: _utils_constants__WEBPACK_IMPORTED_MODULE_4__["TEXT_TYPES"].safety
          }));
        };
        /* harmony default export */


        __webpack_exports__["default"] = Header;
        /***/
      },

      /***/
      "./src/components/Moneta/Header/index.ts":
      /*!***********************************************!*\
        !*** ./src/components/Moneta/Header/index.ts ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMonetaHeaderIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Header__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Header */
        "./src/components/Moneta/Header/Header.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Header__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/Moneta/Moneta.css":
      /*!******************************************!*\
        !*** ./src/components/Moneta/Moneta.css ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function srcComponentsMonetaMonetaCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./Moneta.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Moneta/Moneta.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Moneta/Moneta.tsx":
      /*!******************************************!*\
        !*** ./src/components/Moneta/Moneta.tsx ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMonetaMonetaTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _components_Moneta_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/components/Moneta/Header */
        "./src/components/Moneta/Header/index.ts");
        /* harmony import */


        var _components_Moneta_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/components/Moneta/Footer */
        "./src/components/Moneta/Footer/index.ts");
        /* harmony import */


        var _components_Moneta_Body__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/components/Moneta/Body */
        "./src/components/Moneta/Body/index.ts");
        /* harmony import */


        var _Moneta_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./Moneta.css */
        "./src/components/Moneta/Moneta.css");
        /* harmony import */


        var _Moneta_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Moneta_css__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_categories_currency_rouble_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! svgson-loader!mrg-icons/src/mailru/categories/currency_rouble.svg */
        "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/categories/currency_rouble.svg");
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_categories_currency_rouble_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_mrg_icons_src_mailru_categories_currency_rouble_svg__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_12__);

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics25 = function extendStatics(d, b) {
            _extendStatics25 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics25(d, b);
          };

          return function (d, b) {
            _extendStatics25(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_8__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_9__["EHeaderTypes"].LETTER_META);

        var Moneta =
        /** @class */
        function (_super) {
          __extends(Moneta, _super);

          function Moneta() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          Moneta.prototype.componentDidMount = function () {
            xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_10__["default"].showDie);
          };

          Moneta.prototype.render = function () {
            var _a = this.props.context,
                paymentUrl = _a.paymentUrl,
                paymentInfo = _a.paymentInfo;
            var amount = paymentInfo.amount,
                receiptData = paymentInfo.receipt_data,
                linkReceiptPaid = paymentInfo.link_receipt_paid,
                provider = paymentInfo.provider,
                status = paymentInfo.status;
            var account = receiptData.find(function (element) {
              return element.field === _utils_constants__WEBPACK_IMPORTED_MODULE_11__["PERSONAL_ACCOUNT"];
            });

            if (account) {
              account.isBold = true;
            }

            var text = amount ? _utils_constants__WEBPACK_IMPORTED_MODULE_11__["PAYMENT_SUM"] + " " + amount + " \u20BD" : _utils_constants__WEBPACK_IMPORTED_MODULE_11__["PAYMENT"] + " \xAB\u200E" + provider + "\xBB";
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_12__["ThemeProvider"], {
              theme: _2kit__WEBPACK_IMPORTED_MODULE_12__["AllThemes"].octavius
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: _Moneta_css__WEBPACK_IMPORTED_MODULE_5___default.a.main,
              "data-test-id": "moneta_die"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Moneta_Header__WEBPACK_IMPORTED_MODULE_2__["default"], {
              text: text,
              icon: svgson_loader_mrg_icons_src_mailru_categories_currency_rouble_svg__WEBPACK_IMPORTED_MODULE_7___default.a,
              status: status
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Moneta_Body__WEBPACK_IMPORTED_MODULE_4__["default"], {
              info: receiptData,
              paymentUrl: paymentUrl,
              linkReceipt: linkReceiptPaid,
              provider: provider
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Moneta_Footer__WEBPACK_IMPORTED_MODULE_3__["default"], null)));
          };

          Moneta = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_6__(_Moneta_css__WEBPACK_IMPORTED_MODULE_5___default.a)], Moneta);
          return Moneta;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_1__["withContext"])(Moneta);
        /***/
      },

      /***/
      "./src/components/Moneta/index.ts":
      /*!****************************************!*\
        !*** ./src/components/Moneta/index.ts ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsMonetaIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Moneta__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Moneta */
        "./src/components/Moneta/Moneta.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Moneta__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/PaymentStatus/PaymentStatus.tsx":
      /*!********************************************************!*\
        !*** ./src/components/PaymentStatus/PaymentStatus.tsx ***!
        \********************************************************/

      /*! exports provided: STATUS_AWAITING, STATUS_SUCCESS, STATUS_ERROR, default */

      /***/
      function srcComponentsPaymentStatusPaymentStatusTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "STATUS_AWAITING", function () {
          return STATUS_AWAITING;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "STATUS_SUCCESS", function () {
          return STATUS_SUCCESS;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "STATUS_ERROR", function () {
          return STATUS_ERROR;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit_components_Status_Status__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit/components/Status/Status */
        "./node_modules/2kit/components/Status/Status.js");
        /* harmony import */


        var _2kit_components_Status_Status__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit_components_Status_Status__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");

        var STATUS_AWAITING = 'awaiting';
        var STATUS_SUCCESS = 'success';
        var STATUS_ERROR = 'error';
        var ConvertStatus;

        (function (ConvertStatus) {
          ConvertStatus["awaiting"] = "process";
          ConvertStatus["success"] = "done";
          ConvertStatus["error"] = "warning";
        })(ConvertStatus || (ConvertStatus = {}));

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_2__["defineMessages"])({
          awaiting: {
            "id": "90EMrA==",
            "defaultMessage": "\u0418\u0434\u0451\u0442 \u043E\u043F\u043B\u0430\u0442\u0430"
          },
          success: {
            "id": "YHJP+Q==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0447\u0435\u043D"
          },
          error: {
            "id": "E6r27w==",
            "defaultMessage": "\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u043F\u043B\u0430\u0442\u044B"
          }
        });

        var PaymentStatus = function PaymentStatus(_a) {
          var status = _a.status;
          return !!status && react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit_components_Status_Status__WEBPACK_IMPORTED_MODULE_1___default.a, {
            mode: ConvertStatus[status],
            text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_3__["i18n"])(messages[status]),
            testId: "payment-status:" + status
          });
        };
        /* harmony default export */


        __webpack_exports__["default"] = PaymentStatus;
        /***/
      },

      /***/
      "./src/components/PaymentStatus/index.ts":
      /*!***********************************************!*\
        !*** ./src/components/PaymentStatus/index.ts ***!
        \***********************************************/

      /*! exports provided: default, STATUS_AWAITING, STATUS_ERROR, STATUS_SUCCESS */

      /***/
      function srcComponentsPaymentStatusIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _PaymentStatus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./PaymentStatus */
        "./src/components/PaymentStatus/PaymentStatus.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _PaymentStatus__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "STATUS_AWAITING", function () {
          return _PaymentStatus__WEBPACK_IMPORTED_MODULE_0__["STATUS_AWAITING"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "STATUS_ERROR", function () {
          return _PaymentStatus__WEBPACK_IMPORTED_MODULE_0__["STATUS_ERROR"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "STATUS_SUCCESS", function () {
          return _PaymentStatus__WEBPACK_IMPORTED_MODULE_0__["STATUS_SUCCESS"];
        });
        /***/

      },

      /***/
      "./src/components/Promotional/Promotional.css":
      /*!****************************************************!*\
        !*** ./src/components/Promotional/Promotional.css ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function srcComponentsPromotionalPromotionalCss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src!./Promotional.css */
        "./node_modules/css-loader/dist/cjs.js?!./node_modules/postcss-loader/src/index.js!./src/components/Promotional/Promotional.css");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/components/Promotional/Promotional.tsx":
      /*!****************************************************!*\
        !*** ./src/components/Promotional/Promotional.tsx ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsPromotionalPromotionalTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-css-modules */
        "./node_modules/react-css-modules/dist/index.js");
        /* harmony import */


        var react_css_modules__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_css_modules__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_actions_close_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! svgson-loader!mrg-icons/src/mailru/actions/close.svg */
        "./node_modules/svgson-loader/index.js!./node_modules/mrg-icons/src/mailru/actions/close.svg");
        /* harmony import */


        var svgson_loader_mrg_icons_src_mailru_actions_close_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(svgson_loader_mrg_icons_src_mailru_actions_close_svg__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _static_icons_gibdd_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/static/icons/gibdd.png */
        "./src/static/icons/gibdd.png");
        /* harmony import */


        var _static_icons_gibdd_png__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_static_icons_gibdd_png__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _static_icons_mosenergo_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/static/icons/mosenergo.png */
        "./src/static/icons/mosenergo.png");
        /* harmony import */


        var _static_icons_mosenergo_png__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_static_icons_mosenergo_png__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _static_icons_shield_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/static/icons/shield.png */
        "./src/static/icons/shield.png");
        /* harmony import */


        var _static_icons_shield_png__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_static_icons_shield_png__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _static_icons_promo_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/static/icons/promo.png */
        "./src/static/icons/promo.png");
        /* harmony import */


        var _static_icons_promo_png__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_static_icons_promo_png__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _static_icons_mail_png__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/static/icons/mail.png */
        "./src/static/icons/mail.png");
        /* harmony import */


        var _static_icons_mail_png__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_static_icons_mail_png__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Promotional_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./Promotional.css */
        "./src/components/Promotional/Promotional.css");
        /* harmony import */


        var _Promotional_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Promotional_css__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! classnames */
        "classnames");
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_14__);

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics26 = function extendStatics(d, b) {
            _extendStatics26 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics26(d, b);
          };

          return function (d, b) {
            _extendStatics26(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_12__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_13__["EHeaderTypes"].LETTER_META); // tslint:disable:max-line-length

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_4__["defineMessages"])({
          gibddTitle: {
            "id": "mG8u5g==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u0448\u0442\u0440\u0430\u0444\u044B \u043F\u0440\u044F\u043C\u043E \u0432 \u041F\u043E\u0447\u0442\u0435"
          },
          gibddText: {
            "id": "Jg7eIg==",
            "defaultMessage": "\u0422\u0435\u043F\u0435\u0440\u044C \u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u0445\u043E\u0434\u0438\u0442\u044C \u0438\u0437 \u041F\u043E\u0447\u0442\u044B, \u0447\u0442\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0448\u0442\u0440\u0430\u0444"
          },
          mosenergoTitle: {
            "id": "uGsoEw==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u0440\u044F\u043C\u043E \u0432 \u041F\u043E\u0447\u0442\u0435"
          },
          mosenergoText: {
            "id": "6r1URw==",
            "defaultMessage": "\u0422\u0435\u043F\u0435\u0440\u044C \u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u0445\u043E\u0434\u0438\u0442\u044C \u0438\u0437 \u041F\u043E\u0447\u0442\u044B, \u0447\u0442\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0441\u0447\u0451\u0442"
          },
          common1Title: {
            "id": "f9DJ+A==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0430 \u0431\u0435\u0437 \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A\u043E\u0432 \u0447\u0435\u0440\u0435\u0437 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u0443\u044E \u0441\u0438\u0441\u0442\u0435\u043C\u0443 Mail.ru"
          },
          common1Text: {
            "id": "rclHZg==",
            "defaultMessage": "\u041F\u043E\u0441\u043B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u043C\u044B \u043F\u0440\u0438\u0448\u043B\u0435\u043C \u0447\u0435\u043A, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u043F\u043B\u0430\u0442\u0451\u0436"
          },
          common2Title: {
            "id": "yUwhTQ==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u0430 \u0431\u0435\u0437 \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A\u043E\u0432 \u0447\u0435\u0440\u0435\u0437 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u0443\u044E \u0441\u0438\u0441\u0442\u0435\u043C\u0443 Mail.ru"
          },
          common2Text: {
            "id": "sGLsWg==",
            "defaultMessage": "\u041F\u043E\u0441\u043B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u043C\u044B \u043F\u0440\u0438\u0448\u043B\u0435\u043C \u0447\u0435\u043A, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u043F\u043B\u0430\u0442\u0451\u0436"
          },
          promoTitle: {
            "id": "kjMZjQ==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u043F\u0440\u044F\u043C\u043E \u0432 \u041F\u043E\u0447\u0442\u0435"
          },
          promoText: {
            "id": "+tLINA==",
            "defaultMessage": "\u0422\u0435\u043F\u0435\u0440\u044C \u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u0445\u043E\u0434\u0438\u0442\u044C \u0438\u0437 \u041F\u043E\u0447\u0442\u044B, \u0447\u0442\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u043F\u043E\u043A\u0443\u043F\u043A\u0443"
          },
          try: {
            "id": "r2tcWQ==",
            "defaultMessage": "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C"
          }
        }); // tslint:enable:max-line-length

        var config = {
          gibdd: {
            title: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.gibddTitle),
            bodyText: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.gibddText),
            icon: _static_icons_gibdd_png__WEBPACK_IMPORTED_MODULE_6__
          },
          mosenergo: {
            title: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.mosenergoTitle),
            bodyText: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.mosenergoText),
            icon: _static_icons_mosenergo_png__WEBPACK_IMPORTED_MODULE_7__
          },
          common1: {
            title: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.common1Title),
            bodyText: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.common1Text),
            icon: _static_icons_shield_png__WEBPACK_IMPORTED_MODULE_8__
          },
          common2: {
            title: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.common2Title),
            bodyText: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.common2Text),
            icon: _static_icons_mail_png__WEBPACK_IMPORTED_MODULE_10__
          },
          promo: {
            title: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.promoTitle),
            bodyText: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.promoText),
            icon: _static_icons_promo_png__WEBPACK_IMPORTED_MODULE_9__
          }
        };

        var Promotional =
        /** @class */
        function (_super) {
          __extends(Promotional, _super);

          function Promotional() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          Promotional.prototype.componentDidMount = function () {
            xray.send('show_promotional');
          };

          Promotional.prototype.render = function () {
            var _a;

            var _b = this.props,
                closePromo = _b.closePromo,
                promotional = _b.promotional,
                darkMode = _b.darkMode;
            var _c = config[promotional],
                title = _c.title,
                bodyText = _c.bodyText,
                icon = _c.icon;
            var className = classnames__WEBPACK_IMPORTED_MODULE_14___default()((_a = {}, _a[_Promotional_css__WEBPACK_IMPORTED_MODULE_11___default.a.promo] = true, _a[_Promotional_css__WEBPACK_IMPORTED_MODULE_11___default.a['promo-darkMode']] = darkMode, _a));
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              className: className,
              "data-test-id": "promo_die"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "icon"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("img", {
              src: icon,
              width: 48,
              height: 48
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "closeIcon",

              /* tslint:disable-next-line */
              onClick: function onClick() {
                return closePromo('cross');
              },
              "data-test-id": "close_button"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Icon"], {
              icon: svgson_loader_mrg_icons_src_mailru_actions_close_svg__WEBPACK_IMPORTED_MODULE_3___default.a
            })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
              styleName: "content"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("b", {
              styleName: "bold"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Text"], {
              block: true
            }, title)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Margin"], {
              desktop: 8,
              mobile: 8
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Text"], {
              block: true
            }, bodyText), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Margin"], {
              desktop: 12,
              mobile: 12
            }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_2__["Button"]
            /* tslint:disable-next-line */
            , {
              /* tslint:disable-next-line */
              onClick: function onClick() {
                return closePromo('button');
              },
              primary: true,
              small: true
            }, Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_5__["i18n"])(messages.try))));
          };

          Promotional = __decorate([react_css_modules__WEBPACK_IMPORTED_MODULE_1__(_Promotional_css__WEBPACK_IMPORTED_MODULE_11___default.a)], Promotional);
          return Promotional;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Promotional;
        /***/
      },

      /***/
      "./src/components/Promotional/index.ts":
      /*!*********************************************!*\
        !*** ./src/components/Promotional/index.ts ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsPromotionalIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Promotional__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Promotional */
        "./src/components/Promotional/Promotional.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _Promotional__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/ReceiptButton/ReceiptButton.tsx":
      /*!********************************************************!*\
        !*** ./src/components/ReceiptButton/ReceiptButton.tsx ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsReceiptButtonReceiptButtonTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

        var ReceiptButton = function ReceiptButton(_a) {
          var href = _a.href,
              onClick = _a.onClick,
              text = _a.text,
              icon = _a.icon;
          return !!href && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("a", {
            href: href,
            target: "_blank",
            onClick: onClick,
            "data-test-id": "payment_receipt_show"
          }, react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_0__["Button"], {
            icon: icon,
            contrast: true,
            small: true,
            text: text
          })), react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_0__["Space"], null));
        };
        /* harmony default export */


        __webpack_exports__["default"] = ReceiptButton;
        /***/
      },

      /***/
      "./src/components/ReceiptButton/index.ts":
      /*!***********************************************!*\
        !*** ./src/components/ReceiptButton/index.ts ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsReceiptButtonIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _ReceiptButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./ReceiptButton */
        "./src/components/ReceiptButton/ReceiptButton.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _ReceiptButton__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/ReloadStatus/ReloadStatus.tsx":
      /*!******************************************************!*\
        !*** ./src/components/ReloadStatus/ReloadStatus.tsx ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsReloadStatusReloadStatusTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/utils/i18n */
        "./src/utils/i18n.ts");
        /* harmony import */


        var _utils_withContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/utils/withContext */
        "./src/utils/withContext.tsx");
        /* harmony import */


        var _utils_radarName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/radarName */
        "./src/utils/radarName.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics27 = function extendStatics(d, b) {
            _extendStatics27 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics27(d, b);
          };

          return function (d, b) {
            _extendStatics27(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }

          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }

            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }

            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }

            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };

        var __generator = undefined && undefined.__generator || function (thisArg, body) {
          var _ = {
            label: 0,
            sent: function sent() {
              if (t[0] & 1) throw t[1];
              return t[1];
            },
            trys: [],
            ops: []
          },
              f,
              y,
              t,
              g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;

          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }

          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");

            while (_) {
              try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];

                switch (op[0]) {
                  case 0:
                  case 1:
                    t = op;
                    break;

                  case 4:
                    _.label++;
                    return {
                      value: op[1],
                      done: false
                    };

                  case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;

                  case 7:
                    op = _.ops.pop();

                    _.trys.pop();

                    continue;

                  default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                      _ = 0;
                      continue;
                    }

                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                      _.label = op[1];
                      break;
                    }

                    if (op[0] === 6 && _.label < t[1]) {
                      _.label = t[1];
                      t = op;
                      break;
                    }

                    if (t && _.label < t[2]) {
                      _.label = t[2];

                      _.ops.push(op);

                      break;
                    }

                    if (t[2]) _.ops.pop();

                    _.trys.pop();

                    continue;
                }

                op = body.call(thisArg, _);
              } catch (e) {
                op = [6, e];
                y = 0;
              } finally {
                f = t = 0;
              }
            }

            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_6__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_7__["EHeaderTypes"].LETTER_META);
        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_2__["defineMessages"])({
          text: {
            "id": "zCxY9g==",
            "defaultMessage": "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441"
          }
        });

        var ReloadStatus =
        /** @class */
        function (_super) {
          __extends(ReloadStatus, _super);

          function ReloadStatus() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              isLoading: false
            };

            _this.handleClick = function () {
              return __awaiter(_this, void 0, void 0, function () {
                var e_1;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      this.setState({
                        isLoading: true
                      });
                      xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"][this.props.formType + "ReloadStatusClick"]);
                      _a.label = 1;

                    case 1:
                      _a.trys.push([1, 3,, 4]);

                      return [4
                      /*yield*/
                      , this.props.context.dataSourceDispatch()];

                    case 2:
                      _a.sent();

                      return [3
                      /*break*/
                      , 4];

                    case 3:
                      e_1 = _a.sent();
                      xray.send(_utils_radarName__WEBPACK_IMPORTED_MODULE_5__["default"][this.props.formType + "ReloadStatusError"]);
                      return [3
                      /*break*/
                      , 4];

                    case 4:
                      this.setState({
                        isLoading: false
                      });
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            };

            return _this;
          }

          ReloadStatus.prototype.render = function () {
            var isLoading = this.state.isLoading;
            return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_1__["Button"], {
              testId: "reload_status",
              contrast: true,
              small: true,
              progress: isLoading,
              disabled: isLoading,
              text: Object(_utils_i18n__WEBPACK_IMPORTED_MODULE_3__["i18n"])(messages.text),
              onClick: this.handleClick
            });
          };

          return ReloadStatus;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = Object(_utils_withContext__WEBPACK_IMPORTED_MODULE_4__["withContext"])(ReloadStatus);
        /***/
      },

      /***/
      "./src/components/ReloadStatus/index.ts":
      /*!**********************************************!*\
        !*** ./src/components/ReloadStatus/index.ts ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsReloadStatusIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _ReloadStatus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./ReloadStatus */
        "./src/components/ReloadStatus/ReloadStatus.tsx");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return _ReloadStatus__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /***/

      },

      /***/
      "./src/components/WrapperBillet/WrapperBillet.tsx":
      /*!********************************************************!*\
        !*** ./src/components/WrapperBillet/WrapperBillet.tsx ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function srcComponentsWrapperBilletWrapperBilletTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _components_Promotional__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/components/Promotional */
        "./src/components/Promotional/index.ts");
        /* harmony import */


        var _components_Bill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @/components/Bill */
        "./src/components/Bill/index.ts");
        /* harmony import */


        var _components_IncompleteOrder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/components/IncompleteOrder */
        "./src/components/IncompleteOrder/index.ts");
        /* harmony import */


        var _components_Gibdd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @/components/Gibdd */
        "./src/components/Gibdd/index.ts");
        /* harmony import */


        var _utils_skins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/utils/skins */
        "./src/utils/skins.ts");
        /* harmony import */


        var _components_Mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/components/Mobile */
        "./src/components/Mobile/index.ts");
        /* harmony import */


        var _utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/setUrlParameter */
        "./src/utils/setUrlParameter.ts");
        /* harmony import */


        var _utils_features__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/utils/features */
        "./src/utils/features.ts");
        /* harmony import */


        var _components_Dobro__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @/components/Dobro */
        "./src/components/Dobro/index.ts");
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _components_Moneta__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/components/Moneta */
        "./src/components/Moneta/index.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics28 = function extendStatics(d, b) {
            _extendStatics28 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics28(d, b);
          };

          return function (d, b) {
            _extendStatics28(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var xray = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_10__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_11__["EHeaderTypes"].LETTER_META);

        var WrapperBillet =
        /** @class */
        function (_super) {
          __extends(WrapperBillet, _super);

          function WrapperBillet() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.state = {
              activePromotional: true
            };

            _this.closePromo = function (from) {
              _this.setState({
                activePromotional: false
              });

              var flagFeaturePromotional = _this.props.flags.get('payment-letter-promotional');

              if (flagFeaturePromotional) {
                flagFeaturePromotional.save({
                  state: true
                });
              }

              xray.send('close_promotional', {
                i: from
              });
            };

            return _this;
          }

          WrapperBillet.prototype.render = function () {
            var _a = this.props,
                features = _a.features,
                flags = _a.flags,
                paymentInfo = _a.paymentInfo,
                promotional = _a.promotional,
                onPopupToggle = _a.onPopupToggle,
                octavius = _a.octavius,
                darkMode = _a.darkMode;
            var skin = paymentInfo.skin,
                payment_url = paymentInfo.payment_url,
                detailed_url = paymentInfo.detailed_url,
                show = paymentInfo.show,
                phone = paymentInfo.phone,
                provider_logo = paymentInfo.provider_logo,
                recharge_threshold = paymentInfo.recharge_threshold,
                comment = paymentInfo.comment,
                amount = paymentInfo.amount;
            var activePromotional = this.state.activePromotional;
            var flagPaymentLetterPdfInfo = flags.get('payment-letter-pdf-info');
            var flagPaymentLetterPdfInfoActive = flagPaymentLetterPdfInfo && !flagPaymentLetterPdfInfo.isActive();
            xray.send('pi_received', {
              dwh: {
                active: !!payment_url
              }
            });

            if (show && payment_url && skin) {
              if (activePromotional && promotional) {
                if (skin !== _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].DATASET && skin !== _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].PROMO && skin !== _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].GIBDD && skin !== _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].MONETA) {
                  return null;
                }

                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Promotional__WEBPACK_IMPORTED_MODULE_1__["default"], {
                  closePromo: this.closePromo,
                  promotional: promotional
                });
              } // @TODO убрать


              var ownProps = {
                amount: amount,
                paymentUrl: Object(_utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_7__["default"])(payment_url, {
                  from: 'die-oct',
                  mp: 'web'
                }),
                octavius: octavius,
                darkMode: darkMode
              };
              var detailedUrl = detailed_url && Object(_utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_7__["default"])(detailed_url, {
                from: 'die-oct'
              });

              switch (skin) {
                case _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].DATASET:
                  var paymentLetterPDF = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_8__["EFeatures"].PDF);

                  if (paymentLetterPDF) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Bill__WEBPACK_IMPORTED_MODULE_2__["default"], {
                      moreInfo: flagPaymentLetterPdfInfoActive,
                      detailedUrl: detailedUrl,
                      darkMode: darkMode
                    });
                  }

                  break;

                case _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].PROMO:
                  var paymentLetterPromo = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_8__["EFeatures"].INCOMPLETE_ORDER);

                  if (paymentLetterPromo) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_IncompleteOrder__WEBPACK_IMPORTED_MODULE_3__["default"], {
                      detailedUrl: detailedUrl,
                      darkMode: darkMode
                    });
                  }

                  break;

                case _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].GIBDD:
                  var paymentLetterGibdd = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_8__["EFeatures"].GIBDD);

                  if (paymentLetterGibdd) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Gibdd__WEBPACK_IMPORTED_MODULE_4__["default"], {
                      darkMode: darkMode
                    });
                  }

                  break;

                case _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].MOBILE:
                  var paymentLetterMobile = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_8__["EFeatures"].MOBILE); // @TODO брать из контекста

                  var paymentUrl = Object(_utils_setUrlParameter__WEBPACK_IMPORTED_MODULE_7__["default"])(payment_url, {
                    from: 'die-oct',
                    mp: 'web'
                  });

                  if (paymentLetterMobile) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Mobile__WEBPACK_IMPORTED_MODULE_6__["default"], {
                      phone: phone,
                      providerLogo: provider_logo,
                      rechargeTreshold: recharge_threshold,
                      paymentUrl: paymentUrl,
                      detailedUrl: detailedUrl,
                      onPopupToggle: onPopupToggle,
                      octavius: octavius,
                      darkMode: darkMode
                    });
                  }

                  break;

                case _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].SIMPLE:
                  var paymentLetterDobro = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_8__["EFeatures"].DOBRO);

                  if (paymentLetterDobro) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Dobro__WEBPACK_IMPORTED_MODULE_9__["default"], __assign({
                      comment: comment,
                      onPopupToggle: onPopupToggle
                    }, ownProps));
                  }

                  break;

                case _utils_skins__WEBPACK_IMPORTED_MODULE_5__["default"].MONETA:
                  var paymentLetterMoneta = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_8__["EFeatures"].MONETA);

                  if (paymentLetterMoneta) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Moneta__WEBPACK_IMPORTED_MODULE_12__["default"], null);
                  }

              }
            }

            return null;
          };

          return WrapperBillet;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /* harmony default export */


        __webpack_exports__["default"] = WrapperBillet;
        /***/
      },

      /***/
      "./src/headers/lettermeta.tsx":
      /*!************************************!*\
        !*** ./src/headers/lettermeta.tsx ***!
        \************************************/

      /*! exports provided: default */

      /***/
      function srcHeadersLettermetaTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react-dom */
        "react-dom");
        /* harmony import */


        var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _mail_react_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @mail/react-provider */
        "./node_modules/@mail/react-provider/index.ts");
        /* harmony import */


        var _utils_skins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @/utils/skins */
        "./src/utils/skins.ts");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _components_WrapperBillet_WrapperBillet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @/components/WrapperBillet/WrapperBillet */
        "./src/components/WrapperBillet/WrapperBillet.tsx");
        /* harmony import */


        var _components_Address__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @/components/Address */
        "./src/components/Address/index.ts");
        /* harmony import */


        var _utils_features__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @/utils/features */
        "./src/utils/features.ts");
        /* harmony import */


        var _components_ContextProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @/components/ContextProvider */
        "./src/components/ContextProvider/index.ts");
        /* harmony import */


        var smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! smoothscroll-polyfill */
        "./node_modules/smoothscroll-polyfill/dist/smoothscroll.js");
        /* harmony import */


        var smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _utils_radar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @/utils/radar */
        "./src/utils/radar.ts");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _utils_getTheme__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @/utils/getTheme */
        "./src/utils/getTheme.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics29 = function extendStatics(d, b) {
            _extendStatics29 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics29(d, b);
          };

          return function (d, b) {
            _extendStatics29(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }(); // ie 11 scrollTo not works


        smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_9___default.a.polyfill();

        var Wrapper =
        /** @class */
        function (_super) {
          __extends(Wrapper, _super);

          function Wrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          Wrapper.prototype.renderAddress = function (props) {
            var model = props.model,
                meta = props.meta,
                calendar = props.calendar,
                email = props.email,
                taxi = props.taxi,
                darkMode = props.darkMode,
                timingStart = props.timingStart,
                timingNow = props.timingNow,
                cfg = props.cfg;

            if (!meta.reservationFor) {
              return;
            }

            var letterTimestamp = model && model.get('messages.0.date');
            var _a = meta.reservationFor,
                startDate = _a.startDate,
                location = _a.location,
                name = _a.name;
            var hasInfo = letterTimestamp && startDate && name && location && location.address && location.address.streetAddress && location.address.addressLocality;

            if (!hasInfo) {
              react_dom__WEBPACK_IMPORTED_MODULE_1__["unmountComponentAtNode"](this.container);
              return;
            }

            var instance = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_10__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_11__["EHeaderTypes"].ADDRESS);
            var hasQA = !!cfg.get('qa');

            if (instance.getQueueConfig().idle !== hasQA) {
              instance.setQueueConfig({
                idle: hasQA
              });
            }

            instance.setConfig({
              xrayRadarUrl: 'https://e.mail.ru/api/v1/utils/xray',
              verbose: false,
              defaultParams: {
                v: 1,
                email: email,
                t_feature: _utils_features__WEBPACK_IMPORTED_MODULE_7__["EFeatures"].ADDRESS_HEADER,
                rlog: _utils_features__WEBPACK_IMPORTED_MODULE_7__["EFeatures"].ADDRESS_HEADER
              }
            });
            var theme = Object(_utils_getTheme__WEBPACK_IMPORTED_MODULE_12__["getTheme"])({
              octavius: true,
              darkMode: darkMode
            });
            react_dom__WEBPACK_IMPORTED_MODULE_1__["render"](react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_4__["Responsive"], {
              mode: "desktop"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_4__["ThemeProvider"], {
              theme: theme
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_Address__WEBPACK_IMPORTED_MODULE_6__["default"], {
              name: name,
              street: location.address.streetAddress,
              locality: location.address.addressLocality,
              startDate: new Date(startDate),
              letterTimestamp: letterTimestamp * 1000,
              email: email,
              calendar: calendar,
              taxi: taxi,
              darkMode: darkMode,
              timingStart: timingStart,
              timingNow: timingNow,
              radar: Object(_utils_radar__WEBPACK_IMPORTED_MODULE_10__["radarCreator"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_11__["EHeaderTypes"].ADDRESS)
            }))), this.container);
          };

          Wrapper.prototype.update = function (options) {
            this.renderWrapper(options);
          };

          Wrapper.prototype.renderWrapper = function (options) {
            var _a;

            var model = options.model,
                features = options.features,
                flags = options.flags,
                octavius = options.octavius,
                darkMode = options.darkMode,
                onPopupToggle = options.onPopupToggle,
                email = options.email,
                calendar = options.calendar,
                dataSourceDispatch = options.dataSourceDispatch,
                selector = options.selector,
                timingNow = options.timingNow,
                timingStart = options.timingStart,
                storage = options.storage,
                cfg = options.cfg;
            var eventMeta = model.getJsonLdEvent();

            if (eventMeta && eventMeta[0] && features.has(_utils_features__WEBPACK_IMPORTED_MODULE_7__["EFeatures"].ADDRESS_HEADER)) {
              var showCalendar = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_7__["EFeatures"].ADDRESS_CALENDAR) && calendar;
              var showTaxi = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_7__["EFeatures"].ADDRESS_TAXI);
              this.renderAddress({
                meta: eventMeta[0],
                model: model,
                email: email,
                calendar: showCalendar,
                taxi: showTaxi,
                timingNow: timingNow,
                timingStart: timingStart,
                darkMode: darkMode,
                cfg: cfg
              });
              return;
            }

            var meta = model.getPaymentMeta();

            if (!meta) {
              return;
            }

            var featurePromotional = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_7__["EFeatures"].PROMOTIONAL);
            var flagFeaturePromotional = flags.get('payment-letter-promotional');
            var flagFeaturePromotionalActive = flagFeaturePromotional && flagFeaturePromotional.isActive();
            var promotional = null;

            if (featurePromotional && !flagFeaturePromotionalActive) {
              var featurePromotionalValue = features.get(_utils_features__WEBPACK_IMPORTED_MODULE_7__["EFeatures"].PROMOTIONAL).data;

              if (featurePromotionalValue === 'common1') {
                promotional = 'common1';
              } else if (featurePromotionalValue === 'common2') {
                promotional = 'common2';
              } else if (featurePromotionalValue === 'custom') {
                if (meta.skin === _utils_skins__WEBPACK_IMPORTED_MODULE_3__["default"].GIBDD) {
                  promotional = 'gibdd';
                } else if (meta.skin === _utils_skins__WEBPACK_IMPORTED_MODULE_3__["default"].PROMO) {
                  promotional = 'promo';
                } else if (meta.merchant_id === 'mosenergo') {
                  promotional = 'mosenergo';
                }
              }
            }

            var theme = Object(_utils_getTheme__WEBPACK_IMPORTED_MODULE_12__["getTheme"])({
              octavius: octavius,
              darkMode: darkMode
            });
            var dwhParams = {
              skin: meta.skin,
              amount: meta.amount,
              promotional: promotional,
              messageId: model.get('id'),
              status: meta.status,
              merchant_id: meta.merchant_id
            };

            if (meta.fineId) {
              dwhParams.fineId = meta.fineId;
            }

            var instance = Object(_utils_radar__WEBPACK_IMPORTED_MODULE_10__["getXray"])(_utils_headersCheck__WEBPACK_IMPORTED_MODULE_11__["EHeaderTypes"].LETTER_META);
            var hasQA = !!cfg.get('qa');

            if (instance.getQueueConfig().idle !== hasQA) {
              instance.setQueueConfig({
                idle: hasQA
              });
            }

            var i = (_a = {}, _a[meta.merchant_id] = 1, _a);
            var groupPayByDefault = features.has(_utils_features__WEBPACK_IMPORTED_MODULE_7__["EFeatures"].GIBDD_GROUP_PAY_BY_DEFAULT);

            if (meta.skin === _utils_skins__WEBPACK_IMPORTED_MODULE_3__["default"].GIBDD) {
              var segmentID = groupPayByDefault ? 1 : 2;
              var groupPayByDefaultExperiment = "gd" + segmentID;
              i[groupPayByDefaultExperiment] = 1;
            }

            instance.setConfig({
              xrayRadarUrl: 'https://e.mail.ru/api/v1/utils/xray',
              verbose: false,
              defaultParams: {
                v: 1,
                email: email,
                i: i,
                t_feature: 'payment-letter',
                rlog: 'payment-letter',
                dwh: dwhParams,
                p: octavius ? 'octavius' : 'mail'
              }
            });
            react_dom__WEBPACK_IMPORTED_MODULE_1__["render"](react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_4__["Responsive"], {
              mode: "desktop"
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_2kit__WEBPACK_IMPORTED_MODULE_4__["ThemeProvider"], {
              theme: theme
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_ContextProvider__WEBPACK_IMPORTED_MODULE_8__["default"], {
              features: features,
              paymentInfo: meta,
              onPopupToggle: onPopupToggle,
              dataSourceDispatch: dataSourceDispatch,
              messageId: model.get('expand'),
              octavius: octavius,
              flags: flags,
              selector: selector,
              model: model,
              storage: storage,
              email: email
            }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_WrapperBillet_WrapperBillet__WEBPACK_IMPORTED_MODULE_5__["default"], {
              paymentInfo: meta,
              features: features,
              flags: flags,
              promotional: promotional,
              octavius: octavius,
              darkMode: darkMode
            })))), this.container);
          };

          return Wrapper;
        }(_mail_react_provider__WEBPACK_IMPORTED_MODULE_2__["default"]);
        /* harmony default export */


        __webpack_exports__["default"] = Wrapper;
        /***/
      },

      /***/
      "./src/index.ts":
      /*!**********************!*\
        !*** ./src/index.ts ***!
        \**********************/

      /*! exports provided: default */

      /***/
      function srcIndexTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return creator;
        });
        /* harmony import */


        var _utils_headersCheck_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @/utils/headersCheck.ts */
        "./src/utils/headersCheck.ts");
        /* harmony import */


        var _headers_lettermeta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/headers/lettermeta */
        "./src/headers/lettermeta.tsx");

        function creator(params) {
          if (params.isFake) {
            return _headers_lettermeta__WEBPACK_IMPORTED_MODULE_1__["default"];
          }

          return load(Object(_utils_headersCheck_ts__WEBPACK_IMPORTED_MODULE_0__["getType"])(params.message, params.features, params.promoDomainPlate, params.isFake), params.loadPath).then(function (module) {
            return module && module.default;
          }).catch(function (err) {
            if (window.logBroken && typeof window.logBroken === 'function') {
              window.logBroken('chunk', err);
            }
          });
        }

        function load(header, urlPath) {
          // Костыль, в 5 вебпаке можно сделать лучше
          // В нашем случае не должно быть проблем, так как в тарболлах только js код, который мы грузим
          __webpack_require__.p = urlPath;
          console.log('HEADER <<< ', header);

          switch (header) {
            case _utils_headersCheck_ts__WEBPACK_IMPORTED_MODULE_0__["EHeaderTypes"].LETTER_META:
              return Promise.resolve().then(__webpack_require__.bind(null,
              /*! @/headers/lettermeta */
              "./src/headers/lettermeta.tsx"));

            case _utils_headersCheck_ts__WEBPACK_IMPORTED_MODULE_0__["EHeaderTypes"].TRANSACTION_HEADER:
              return Promise.all(
              /*! import() | transaction.header */
              [__webpack_require__.e("vendors~transaction.header"), __webpack_require__.e("transaction.header")]).then(__webpack_require__.bind(null,
              /*! @/headers/transactionHeader */
              "./src/headers/transactionHeader.tsx"));

            case _utils_headersCheck_ts__WEBPACK_IMPORTED_MODULE_0__["EHeaderTypes"].AVIA:
              return __webpack_require__.e(
              /*! import() | avia.header */
              "avia.header").then(__webpack_require__.bind(null,
              /*! @/headers/aviaHeader */
              "./src/headers/aviaHeader.tsx"));

            case _utils_headersCheck_ts__WEBPACK_IMPORTED_MODULE_0__["EHeaderTypes"].PROMO_DOMAIN_HEADER:
              return Promise.all(
              /*! import() | promodomain.header */
              [__webpack_require__.e("vendors~promodomain.header"), __webpack_require__.e("promodomain.header")]).then(__webpack_require__.bind(null,
              /*! @/headers/promoDomainHeader */
              "./src/headers/promoDomainHeader.tsx"));

            case _utils_headersCheck_ts__WEBPACK_IMPORTED_MODULE_0__["EHeaderTypes"].PHISHING:
              return __webpack_require__.e(
              /*! import() | phishingalert.header */
              "phishingalert.header").then(__webpack_require__.bind(null,
              /*! @/headers/phishingAlertHeader.tsx */
              "./src/headers/phishingAlertHeader.tsx"));

            default:
              return Promise.resolve(null);
          }
        }
        /***/

      },

      /***/
      "./src/interfaces/EInjections.ts":
      /*!***************************************!*\
        !*** ./src/interfaces/EInjections.ts ***!
        \***************************************/

      /*! exports provided: EInjections */

      /***/
      function srcInterfacesEInjectionsTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "EInjections", function () {
          return EInjections;
        });

        var EInjections;

        (function (EInjections) {
          EInjections["OCTAVIUS"] = "octavius";
          EInjections["FEATURES"] = "features";
          EInjections["METADATA"] = "metadata";
          EInjections["MESSAGE"] = "message";
          EInjections["MESSAGES"] = "messages";
          EInjections["STATUS_CLICK"] = "onStatusClick";
          EInjections["PONYMODE"] = "ponymode";
          EInjections["LANG"] = "lang";
          EInjections["DARKMODE"] = "darkMode";
        })(EInjections || (EInjections = {}));
        /***/

      },

      /***/
      "./src/interfaces/ICalendar.ts":
      /*!*************************************!*\
        !*** ./src/interfaces/ICalendar.ts ***!
        \*************************************/

      /*! exports provided: formCalendarHref */

      /***/
      function srcInterfacesICalendarTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "formCalendarHref", function () {
          return formCalendarHref;
        });
        /* harmony import */


        var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @/utils/constants */
        "./src/utils/constants.ts");

        function formCalendarHref(calendar, email) {
          if (!calendar || !calendar.calendarInfo || !calendar.messageId || !email) {
            return null;
          }

          var messageId = calendar.messageId,
              calendarInfo = calendar.calendarInfo;
          var attachId = encodeURIComponent(messageId + ";" + calendarInfo.id);
          var encodeEmail = encodeURIComponent(email);
          return _utils_constants__WEBPACK_IMPORTED_MODULE_0__["CALENDAR_URL"] + "?email=" + encodeEmail + "&attachment_id=" + attachId + "&response=yes";
        }
        /***/

      },

      /***/
      "./src/static/icons/gibdd.png":
      /*!************************************!*\
        !*** ./src/static/icons/gibdd.png ***!
        \************************************/

      /*! no static exports found */

      /***/
      function srcStaticIconsGibddPng(module, exports) {
        module.exports = "data:image/png;base64,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";
        /***/
      },

      /***/
      "./src/static/icons/mail.png":
      /*!***********************************!*\
        !*** ./src/static/icons/mail.png ***!
        \***********************************/

      /*! no static exports found */

      /***/
      function srcStaticIconsMailPng(module, exports) {
        module.exports = "data:image/png;base64,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";
        /***/
      },

      /***/
      "./src/static/icons/mosenergo.png":
      /*!****************************************!*\
        !*** ./src/static/icons/mosenergo.png ***!
        \****************************************/

      /*! no static exports found */

      /***/
      function srcStaticIconsMosenergoPng(module, exports) {
        module.exports = "data:image/png;base64,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";
        /***/
      },

      /***/
      "./src/static/icons/promo.png":
      /*!************************************!*\
        !*** ./src/static/icons/promo.png ***!
        \************************************/

      /*! no static exports found */

      /***/
      function srcStaticIconsPromoPng(module, exports) {
        module.exports = "data:image/png;base64,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";
        /***/
      },

      /***/
      "./src/static/icons/shield.png":
      /*!*************************************!*\
        !*** ./src/static/icons/shield.png ***!
        \*************************************/

      /*! no static exports found */

      /***/
      function srcStaticIconsShieldPng(module, exports) {
        module.exports = "data:image/png;base64,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";
        /***/
      },

      /***/
      "./src/utils/addMerchantParam.ts":
      /*!***************************************!*\
        !*** ./src/utils/addMerchantParam.ts ***!
        \***************************************/

      /*! exports provided: default */

      /***/
      function srcUtilsAddMerchantParamTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return addMerchantParam;
        });
        /* harmony import */


        var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! qs */
        "./node_modules/qs/lib/index.js");
        /* harmony import */


        var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _mail_xray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @mail/xray */
        "./node_modules/@mail/xray/index.js");

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        function addMerchantParam(url, update) {
          var _a = url.split('?'),
              baseUrl = _a[0],
              _b = _a[1],
              queryStringWithAnchor = _b === void 0 ? '' : _b;

          var _c = queryStringWithAnchor.split('#'),
              queryString = _c[0],
              _d = _c[1],
              anchor = _d === void 0 ? '' : _d;

          var getParams = qs__WEBPACK_IMPORTED_MODULE_0___default.a.parse(queryString);
          var data = {};

          try {
            data = getParams.data && JSON.parse(getParams.data) || {};
          } catch (e) {
            _mail_xray__WEBPACK_IMPORTED_MODULE_1__["default"].send('merchant_parse_error_die');

            return url;
          }

          data.merchant_param = __assign(__assign({}, data.merchant_param), update);

          var newGetParams = __assign(__assign({}, getParams), {
            data: JSON.stringify(data)
          });

          anchor = "" + (anchor ? "#" + anchor : '');
          return baseUrl + "?" + qs__WEBPACK_IMPORTED_MODULE_0___default.a.stringify(newGetParams) + anchor;
        }
        /***/

      },

      /***/
      "./src/utils/compose.ts":
      /*!******************************!*\
        !*** ./src/utils/compose.ts ***!
        \******************************/

      /*! exports provided: default */

      /***/
      function srcUtilsComposeTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return compose;
        });

        function compose() {
          var fns = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            fns[_i] = arguments[_i];
          }

          return fns.reduce(function (f, g) {
            return function (Component) {
              return f(g(Component));
            };
          });
        }
        /***/

      },

      /***/
      "./src/utils/constants.ts":
      /*!********************************!*\
        !*** ./src/utils/constants.ts ***!
        \********************************/

      /*! exports provided: CONTROLS_MESSAGES, CALENDAR_URL, TAXI_URL, PAYMENT_CENTER_URL, PAYMENT_CENTER_FINES_URL, SIZE_POPUP, GIBDD_POPUP_HEIGHT, TAXI_LOCALITY, getEventRadarParams, FINES_SHAPSHOT_KEY, GIBDD_MOCK_API_KEY, FINES_CACHE_TIMELIMIT, PAYMENT_IN_PROGRESS_TIMEOUT, TEXT_TYPES, TooltipTexts, PERSONAL_ACCOUNT, PAYMENT_SUM, PAYMENT, XRAY_RADAR_URL, PromoDomainTypes, PromoDomainHidingTypes */

      /***/
      function srcUtilsConstantsTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "CONTROLS_MESSAGES", function () {
          return CONTROLS_MESSAGES;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "CALENDAR_URL", function () {
          return CALENDAR_URL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "TAXI_URL", function () {
          return TAXI_URL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PAYMENT_CENTER_URL", function () {
          return PAYMENT_CENTER_URL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PAYMENT_CENTER_FINES_URL", function () {
          return PAYMENT_CENTER_FINES_URL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "SIZE_POPUP", function () {
          return SIZE_POPUP;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "GIBDD_POPUP_HEIGHT", function () {
          return GIBDD_POPUP_HEIGHT;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "TAXI_LOCALITY", function () {
          return TAXI_LOCALITY;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getEventRadarParams", function () {
          return getEventRadarParams;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "FINES_SHAPSHOT_KEY", function () {
          return FINES_SHAPSHOT_KEY;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "GIBDD_MOCK_API_KEY", function () {
          return GIBDD_MOCK_API_KEY;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "FINES_CACHE_TIMELIMIT", function () {
          return FINES_CACHE_TIMELIMIT;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PAYMENT_IN_PROGRESS_TIMEOUT", function () {
          return PAYMENT_IN_PROGRESS_TIMEOUT;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "TEXT_TYPES", function () {
          return TEXT_TYPES;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "TooltipTexts", function () {
          return TooltipTexts;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PERSONAL_ACCOUNT", function () {
          return PERSONAL_ACCOUNT;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PAYMENT_SUM", function () {
          return PAYMENT_SUM;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PAYMENT", function () {
          return PAYMENT;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "XRAY_RADAR_URL", function () {
          return XRAY_RADAR_URL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PromoDomainTypes", function () {
          return PromoDomainTypes;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PromoDomainHidingTypes", function () {
          return PromoDomainHidingTypes;
        });
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_0__);

        var CONTROLS_MESSAGES = Object(react_intl__WEBPACK_IMPORTED_MODULE_0__["defineMessages"])({
          calendar: {
            "id": "dj0A2Q==",
            "defaultMessage": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C"
          },
          taxi: {
            "id": "6/agGA==",
            "defaultMessage": "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u0430\u043A\u0441\u0438"
          }
        });
        var CALENDAR_URL = 'https://calendar.mail.ru/access/event/';
        var TAXI_URL = 'https://moscow.rutaxi.ru/index.html';
        var PAYMENT_CENTER_URL = 'https://e.mail.ru/payment/center';
        var PAYMENT_CENTER_FINES_URL = PAYMENT_CENTER_URL + "/gibdd?from=lmr";
        var SIZE_POPUP;

        (function (SIZE_POPUP) {
          SIZE_POPUP["small"] = "420px";
          SIZE_POPUP["medium"] = "680px";
          SIZE_POPUP["large"] = "880px";
        })(SIZE_POPUP || (SIZE_POPUP = {}));

        var GIBDD_POPUP_HEIGHT = '576px';
        var TAXI_LOCALITY = 'Москва';
        var HOUR_FACTOR = 3600000;

        var getEventRadarParams = function getEventRadarParams(startDate, letterDate) {
          var afterReceive = Math.round((Date.now() - letterDate) / HOUR_FACTOR);
          var beforeEvent = Math.round((startDate.getTime() - Date.now()) / HOUR_FACTOR);
          return {
            after_receive: afterReceive,
            before_event: beforeEvent
          };
        }; // ключ, по которому хранятся штрафы в localStorage


        var FINES_SHAPSHOT_KEY = 'fines_shapshot'; // ключ, по которому хранится массив моков для api.gibdd. Значение задается в тестах

        var GIBDD_MOCK_API_KEY = 'gibdd_api_mock'; // время в минутах, в течение которого берем штрафы из кэша (localStorage)

        var FINES_CACHE_TIMELIMIT = 10; // таймаут в милисекундах на ожидание postmessage payment/in_progress

        var PAYMENT_IN_PROGRESS_TIMEOUT = 30 * 1000;
        var TEXT_TYPES;

        (function (TEXT_TYPES) {
          TEXT_TYPES["standart"] = "standart";
          TEXT_TYPES["safety"] = "safety";
          TEXT_TYPES["mail"] = "mail";
        })(TEXT_TYPES || (TEXT_TYPES = {}));

        var TooltipTexts = Object(react_intl__WEBPACK_IMPORTED_MODULE_0__["defineMessages"])({
          standart: {
            "id": "juUnYw==",
            "defaultMessage": "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B"
          },
          safety: {
            "id": "D9lp7g==",
            "defaultMessage": "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0432 \u043F\u043E\u0447\u0442\u0435"
          },
          mail: {
            "id": "MpGiWA==",
            "defaultMessage": "\u041E\u043F\u043B\u0430\u0442\u044B \u0432 \u043F\u043E\u0447\u0442\u0435"
          }
        });
        var PERSONAL_ACCOUNT = 'Лицевой счёт';
        var PAYMENT_SUM = 'Сумма платежа';
        var PAYMENT = 'Оплата';
        var XRAY_RADAR_URL = 'https://e.mail.ru/api/v1/utils/xray'; // типы плашек выбранных доменов

        var PromoDomainTypes;

        (function (PromoDomainTypes) {
          PromoDomainTypes["PaymentCenter"] = "payment-center";
          PromoDomainTypes["ToMyself"] = "to-myself";
        })(PromoDomainTypes || (PromoDomainTypes = {})); // список плашек, где при клике на ссылку они скрываются


        var PromoDomainHidingTypes = [PromoDomainTypes.PaymentCenter];
        /***/
      },

      /***/
      "./src/utils/correspondents.ts":
      /*!*************************************!*\
        !*** ./src/utils/correspondents.ts ***!
        \*************************************/

      /*! exports provided: getCorrespondents, getMessageFromDomain */

      /***/
      function srcUtilsCorrespondentsTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getCorrespondents", function () {
          return getCorrespondents;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getMessageFromDomain", function () {
          return getMessageFromDomain;
        });
        /* harmony import */


        var _utils_injections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @/utils/injections */
        "./src/utils/injections.ts"); // Иногда correspondents нет в треде, но есть в сообщениях


        function getCorrespondents(message) {
          var items = message.get('correspondents');

          if (items && items.length) {
            return items;
          }

          return message.get('messages.0.correspondents');
        }

        var emailDomainReg = /^\w+([\.-]?\w+)*@(\w+([\.-]?\w+)*)(\.\w{2,3})+$/;

        function getMessageFromDomain() {
          var msg = Object(_utils_injections__WEBPACK_IMPORTED_MODULE_0__["message"])();

          if (!msg) {
            return 'none';
          }

          var correspondents = getCorrespondents(msg);
          var from = correspondents && correspondents.from && correspondents.from[0];

          if (!from || !from.email) {
            return 'none';
          }

          return (from.email.match(emailDomainReg) || [])[2];
        }
        /***/

      },

      /***/
      "./src/utils/dataTestId.ts":
      /*!*********************************!*\
        !*** ./src/utils/dataTestId.ts ***!
        \*********************************/

      /*! exports provided: EDataTestId */

      /***/
      function srcUtilsDataTestIdTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "EDataTestId", function () {
          return EDataTestId;
        });

        var EDataTestId;

        (function (EDataTestId) {
          EDataTestId["ADDRESS_HEADER"] = "address_header";
          EDataTestId["ADDRESS_HEADER_LINK"] = "address_header_link";
          EDataTestId["ADDRESS_HEADER_TAXI"] = "address_header_taxi";
          EDataTestId["CALENDAR"] = "calendar_button";
          EDataTestId["GIBDD_HEADER_DESCRIPTION"] = "description_info";
          EDataTestId["GIBDD_HEADER_MAIN"] = "main_info";
          EDataTestId["GIBDD_HEADER_ARTICLE"] = "article_koap_desctiorion_info";
          EDataTestId["GIBDD_HEADER_PLACE"] = "place_info";
          EDataTestId["GIBDD_HEADER_GROUP_BLOCK"] = "group-payment-block";
          EDataTestId["GIBDD_HEADER_GROUP_LOADER"] = "group-payment-loader";
          EDataTestId["GIBDD_HEADER_PAYMENT_CENTER_LINK"] = "group-payment-payment-center-link";
          EDataTestId["GIBDD_HEADER_GROUP_AMOUNT"] = "group-payment-amount";
          EDataTestId["GIBDD_HEADER_GROUP_COUNT"] = "group-payment-count";
          EDataTestId["GIBDD_HEADER_GROUP_MORE"] = "group-payment-more";
        })(EDataTestId || (EDataTestId = {}));
        /***/

      },

      /***/
      "./src/utils/dateFormat.ts":
      /*!*********************************!*\
        !*** ./src/utils/dateFormat.ts ***!
        \*********************************/

      /*! exports provided: dateFormat */

      /***/
      function srcUtilsDateFormatTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "dateFormat", function () {
          return dateFormat;
        });

        var dateFormat = function dateFormat(dateString) {
          var date = new Date(+dateString * 1000);
          return date.toLocaleDateString('ru');
        };
        /***/

      },

      /***/
      "./src/utils/dates.ts":
      /*!****************************!*\
        !*** ./src/utils/dates.ts ***!
        \****************************/

      /*! exports provided: DAYS, MONTHS, MONTHS_SHORT */

      /***/
      function srcUtilsDatesTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "DAYS", function () {
          return DAYS;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "MONTHS", function () {
          return MONTHS;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "MONTHS_SHORT", function () {
          return MONTHS_SHORT;
        });
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_0__);

        var DAYS = Object(react_intl__WEBPACK_IMPORTED_MODULE_0__["defineMessages"])({
          day0: {
            "id": "hKFCfw==",
            "defaultMessage": "\u0432\u0441"
          },
          day1: {
            "id": "9xfZ+w==",
            "defaultMessage": "\u043F\u043D"
          },
          day2: {
            "id": "LOA6/A==",
            "defaultMessage": "\u0432\u0442"
          },
          day3: {
            "id": "UDQNJw==",
            "defaultMessage": "\u0441\u0440"
          },
          day4: {
            "id": "W0DhPw==",
            "defaultMessage": "\u0447\u0442"
          },
          day5: {
            "id": "hZcTag==",
            "defaultMessage": "\u043F\u0442"
          },
          day6: {
            "id": "8v2zZQ==",
            "defaultMessage": "\u0441\u0431"
          }
        });
        var MONTHS = Object(react_intl__WEBPACK_IMPORTED_MODULE_0__["defineMessages"])({
          month0: {
            "id": "Z0XrnA==",
            "defaultMessage": "{day} \u042F\u043D\u0432\u0430\u0440\u044F"
          },
          month1: {
            "id": "518hKw==",
            "defaultMessage": "{day} \u0424\u0435\u0432\u0440\u0430\u043B\u044F"
          },
          month2: {
            "id": "u5r4SQ==",
            "defaultMessage": "{day} \u041C\u0430\u0440\u0442\u0430"
          },
          month3: {
            "id": "q/gj+w==",
            "defaultMessage": "{day} \u0410\u043F\u0440\u0435\u043B\u044F"
          },
          month4: {
            "id": "XNtzow==",
            "defaultMessage": "{day} \u041C\u0430\u044F"
          },
          month5: {
            "id": "g6EIig==",
            "defaultMessage": "{day} \u0418\u044E\u043D\u044F"
          },
          month6: {
            "id": "FBqMSA==",
            "defaultMessage": "{day} \u0418\u044E\u043B\u044F"
          },
          month7: {
            "id": "ivEWow==",
            "defaultMessage": "{day} \u0410\u0432\u0433\u0443\u0441\u0442\u0430"
          },
          month8: {
            "id": "2calgg==",
            "defaultMessage": "{day} \u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044F"
          },
          month9: {
            "id": "wRdcZQ==",
            "defaultMessage": "{day} \u041E\u043A\u0442\u044F\u0431\u0440\u044F"
          },
          month10: {
            "id": "xvOZzA==",
            "defaultMessage": "{day} \u041D\u043E\u044F\u0431\u0440\u044F"
          },
          month11: {
            "id": "ApTsRA==",
            "defaultMessage": "{day} \u0414\u0435\u043A\u0430\u0431\u0440\u044F"
          }
        });
        var MONTHS_SHORT = Object(react_intl__WEBPACK_IMPORTED_MODULE_0__["defineMessages"])({
          m0: {
            "id": "XCr3PQ==",
            "defaultMessage": "{day} \u044F\u043D\u0432"
          },
          m1: {
            "id": "a1lv2Q==",
            "defaultMessage": "{day} \u0444\u0435\u0432"
          },
          m2: {
            "id": "vfmSGg==",
            "defaultMessage": "{day} \u043C\u0430\u0440"
          },
          m3: {
            "id": "7D5OTQ==",
            "defaultMessage": "{day} \u0430\u043F\u0440"
          },
          m4: {
            "id": "ogneKw==",
            "defaultMessage": "{day} \u043C\u0430\u0439"
          },
          m5: {
            "id": "zGc4ZA==",
            "defaultMessage": "{day} \u0438\u044E\u043D"
          },
          m6: {
            "id": "G+hOUQ==",
            "defaultMessage": "{day} \u0438\u044E\u043B"
          },
          m7: {
            "id": "+7t0SA==",
            "defaultMessage": "{day} \u0430\u0432\u0433"
          },
          m8: {
            "id": "S3RlBQ==",
            "defaultMessage": "{day} \u0441\u0435\u043D"
          },
          m9: {
            "id": "ohfjAA==",
            "defaultMessage": "{day} \u043E\u043A\u0442"
          },
          m10: {
            "id": "0yNmzQ==",
            "defaultMessage": "{day} \u043D\u043E\u044F"
          },
          m11: {
            "id": "nULu+g==",
            "defaultMessage": "{day} \u0434\u0435\u043A"
          }
        });
        /***/
      },

      /***/
      "./src/utils/eventConstants.ts":
      /*!*************************************!*\
        !*** ./src/utils/eventConstants.ts ***!
        \*************************************/

      /*! exports provided: messages, MAP_URL */

      /***/
      function srcUtilsEventConstantsTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "messages", function () {
          return messages;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "MAP_URL", function () {
          return MAP_URL;
        });
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_0__);

        var messages = Object(react_intl__WEBPACK_IMPORTED_MODULE_0__["defineMessages"])({
          address: {
            "id": "LiPiZw==",
            "defaultMessage": "\u0410\u0434\u0440\u0435\u0441"
          },
          tickets: {
            "id": "VEWJ8g==",
            "defaultMessage": "\u0411\u0438\u043B\u0435\u0442"
          },
          date: {
            "id": "NNH5AA==",
            "defaultMessage": "\u0414\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F"
          }
        });
        var MAP_URL = 'https://www.google.com/maps/search/?api=1';
        /***/
      },

      /***/
      "./src/utils/features.ts":
      /*!*******************************!*\
        !*** ./src/utils/features.ts ***!
        \*******************************/

      /*! exports provided: EFeatures, ETransactionHeaderFeatures, normalize, configBySender, getPromoDomainConfig */

      /***/
      function srcUtilsFeaturesTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "EFeatures", function () {
          return EFeatures;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ETransactionHeaderFeatures", function () {
          return ETransactionHeaderFeatures;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "normalize", function () {
          return normalize;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "configBySender", function () {
          return configBySender;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getPromoDomainConfig", function () {
          return getPromoDomainConfig;
        });

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var EFeatures;

        (function (EFeatures) {
          EFeatures["AVIA_HEADER"] = "avia-header";
          EFeatures["ADDRESS_HEADER"] = "address-header";
          EFeatures["ADDRESS_CALENDAR"] = "address-header-calendar";
          EFeatures["ADDRESS_TAXI"] = "address-header-taxi";
          EFeatures["PROMOTIONAL"] = "payment-letter-promotional";
          EFeatures["PDF"] = "payment-letter-pdf";
          EFeatures["INCOMPLETE_ORDER"] = "payment-letter-promo";
          EFeatures["GIBDD"] = "payment-letter-gibdd";
          EFeatures["GIBDD_FULL"] = "pl-gibdd-full";
          EFeatures["GIBDD_PHOTO"] = "gibdd-photo-button";
          EFeatures["GIBDD_GROUP"] = "gibdd-group-payment";
          EFeatures["GIBDD_MOCK_API"] = "gibdd-mock-api";
          EFeatures["GIBDD_DMR_SKIP_ORIGIN_CHECK"] = "gibdd-dmr-skip-origin-check";
          EFeatures["GIBDD_FINES_CACHE_TIMELIMIT"] = "gibdd-fines-cache-timelimit";
          EFeatures["GIBDD_GROUP_PAY_BY_DEFAULT"] = "gibdd-group-pay-by-default";
          EFeatures["MOBILE"] = "payment-letter-mobile";
          EFeatures["DOBRO"] = "payment-letter-dobro";
          EFeatures["MONETA"] = "payment-letter-moneta";
          EFeatures["PROMO_DOMAIN_HEADER"] = "promo-domain-header";
          EFeatures["PROMO_DOMAIN_CROSS_ENABLED"] = "promo-domain-cross-enabled";
          EFeatures["PHISHING"] = "phishing-alert";
        })(EFeatures || (EFeatures = {}));

        var ETransactionHeaderFeatures;

        (function (ETransactionHeaderFeatures) {
          ETransactionHeaderFeatures["GA_ENABLE"] = "transaction-header_ga_enable"; // Включить хэдер для определенных магазинов

          ETransactionHeaderFeatures["TRANSACTION_HEADER"] = "transaction-header";
        })(ETransactionHeaderFeatures || (ETransactionHeaderFeatures = {})); // Применяем разные странные бизнес правила/ограничения к конфигу


        function normalize(config) {
          if (!config) {
            return null;
          }

          var v2 = config.v2;
          var withTracking = v2 && config.withTracking;
          return __assign(__assign({}, config), {
            withItemLinks: v2 ? config.withItemLinks : false,
            withImages: v2 ? config.withImages : false,
            itemsCount: v2 ? config.itemsCount : 1,
            linesCount: v2 ? config.linesCount : 0,
            withTracking: withTracking,
            withLinks: withTracking ? config.withLinks : false,
            withDates: withTracking ? config.withDates : false
          });
        }

        function configBySender(sender, features) {
          var config = features && features.getAsJSON(ETransactionHeaderFeatures.TRANSACTION_HEADER, null);

          if (config === null || typeof sender !== 'string') {
            return null;
          }

          return normalize(Object.values(config).find(function (obj) {
            return obj.shops.some(function (shop) {
              return new RegExp(shop).test(sender);
            });
          }));
        }

        function getPromoDomainConfig(features, plate) {
          var config = features && features.getAsJSON(EFeatures.PROMO_DOMAIN_HEADER, null);

          if (!Array.isArray(config)) {
            return null;
          }

          var promoDomainConfig = config.find(function (el) {
            return Array.isArray(el.domains) && el.domains.includes(plate) || Array.isArray(el.emails) && el.emails.includes(plate);
          });

          if (!promoDomainConfig) {
            return null;
          }

          var text = promoDomainConfig.text,
              linkText = promoDomainConfig.linkText,
              link = promoDomainConfig.link,
              type = promoDomainConfig.type;
          var isInValidConfig = !(text && linkText && link && type);

          if (isInValidConfig) {
            return null;
          }

          var hideEnabled = features && features.has(EFeatures.PROMO_DOMAIN_CROSS_ENABLED);
          return __assign(__assign({}, promoDomainConfig), {
            plate: plate,
            hideEnabled: hideEnabled
          });
        }
        /***/

      },

      /***/
      "./src/utils/getFeaturesStringByPrefix.ts":
      /*!************************************************!*\
        !*** ./src/utils/getFeaturesStringByPrefix.ts ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function srcUtilsGetFeaturesStringByPrefixTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony default export */


        __webpack_exports__["default"] = function (features, prefix) {
          return Object.keys(features.list).filter(function (name) {
            return name.startsWith(prefix);
          }).map(function (name) {
            var value = features.getAsString(name, '');
            return "" + name + (value ? ":" + value : '');
          }).join(' ');
        };
        /***/

      },

      /***/
      "./src/utils/getTheme.ts":
      /*!*******************************!*\
        !*** ./src/utils/getTheme.ts ***!
        \*******************************/

      /*! exports provided: getTheme */

      /***/
      function srcUtilsGetThemeTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getTheme", function () {
          return getTheme;
        });
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! 2kit */
        "2kit");
        /* harmony import */


        var _2kit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_2kit__WEBPACK_IMPORTED_MODULE_0__);

        function getTheme(options) {
          if (options.octavius) {
            return options.darkMode ? _2kit__WEBPACK_IMPORTED_MODULE_0__["AllThemes"].octaviusBlack : _2kit__WEBPACK_IMPORTED_MODULE_0__["AllThemes"].octavius;
          }

          return options.darkMode ? _2kit__WEBPACK_IMPORTED_MODULE_0__["AllThemes"].black : _2kit__WEBPACK_IMPORTED_MODULE_0__["AllThemes"].base;
        }
        /***/

      },

      /***/
      "./src/utils/headersCheck.ts":
      /*!***********************************!*\
        !*** ./src/utils/headersCheck.ts ***!
        \***********************************/

      /*! exports provided: EHeaderTypes, checkAviaHeader, checkPhishingHeader, checkIs, getType */

      /***/
      function srcUtilsHeadersCheckTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "EHeaderTypes", function () {
          return EHeaderTypes;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "checkAviaHeader", function () {
          return checkAviaHeader;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "checkPhishingHeader", function () {
          return checkPhishingHeader;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "checkIs", function () {
          return checkIs;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getType", function () {
          return getType;
        });
        /* harmony import */


        var _utils_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @/utils/features */
        "./src/utils/features.ts");
        /* harmony import */


        var _utils_correspondents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/utils/correspondents */
        "./src/utils/correspondents.ts");

        var EHeaderTypes;

        (function (EHeaderTypes) {
          EHeaderTypes[EHeaderTypes["LETTER_META"] = 0] = "LETTER_META";
          EHeaderTypes[EHeaderTypes["TRANSACTION_HEADER"] = 1] = "TRANSACTION_HEADER";
          EHeaderTypes[EHeaderTypes["ADDRESS"] = 2] = "ADDRESS";
          EHeaderTypes[EHeaderTypes["AVIA"] = 3] = "AVIA";
          EHeaderTypes[EHeaderTypes["PROMO_DOMAIN_HEADER"] = 4] = "PROMO_DOMAIN_HEADER";
          EHeaderTypes[EHeaderTypes["PHISHING"] = 5] = "PHISHING";
        })(EHeaderTypes || (EHeaderTypes = {}));

        var checkFieldsTransactionHeader = function checkFieldsTransactionHeader(metadata, message, from) {
          var fields = [];

          for (var _i = 3; _i < arguments.length; _i++) {
            fields[_i - 3] = arguments[_i];
          }

          var avatarSrc = from && from.avatars && from.avatars.default;
          return !!(avatarSrc && metadata && fields.some(function (fn) {
            return fn(metadata);
          }));
        };

        var checkAliexpress = function checkAliexpress(metadata) {
          return Boolean(metadata.order_id && metadata.status && metadata.order_detail_href && metadata.order_list_href && (metadata.protection_end_date || metadata.item_name));
        };

        var checkOther = function checkOther(metadata) {
          return Boolean(metadata.order_id && metadata.status && (metadata.order_list_href || metadata.order_detail_href) && metadata.item_list && metadata.item_list.length > 0);
        };

        function checkTransactionHeader(message, features) {
          if (!message) {
            return false;
          }

          var metadataModel = message.get('transaction_metadata');
          var metadata = metadataModel && metadataModel.getAttributes();

          if (!metadata) {
            return false;
          }

          var from = (Object(_utils_correspondents__WEBPACK_IMPORTED_MODULE_1__["getCorrespondents"])(message) || {}).from;

          if (!Array.isArray(from) || !from[0]) {
            return false;
          }

          var config = Object(_utils_features__WEBPACK_IMPORTED_MODULE_0__["configBySender"])(from[0].email, features);

          if (!config) {
            return false;
          }

          if (metadata.type !== 'order_custom' && metadata.type !== 'aliexpress') {
            return false;
          }

          return checkFieldsTransactionHeader(metadata, message, from[0], checkAliexpress, checkOther);
        }

        function isValidDate(raw) {
          var d = new Date(raw);
          return d instanceof Date && !isNaN(d.getTime());
        }

        function checkAviaHeader(message, features) {
          if (!features.has(_utils_features__WEBPACK_IMPORTED_MODULE_0__["EFeatures"].AVIA_HEADER)) {
            return false;
          }

          if (!message) {
            return false;
          }

          var metadataModel = message.get('transaction_metadata');
          var metadata = metadataModel && metadataModel.getAttributes();

          if (!metadata || metadata.type !== 'flight') {
            return false;
          }

          var reservations = metadata.reservations; // Пока не показываем плашку если в ней больше одного билета

          if (!Array.isArray(reservations) || reservations.length > 1) {
            return false;
          }

          return reservations.every(function (reservation) {
            var ticket = reservation && reservation.reservationFor;
            return Boolean(ticket && ticket.departureAirport && (ticket.departureAirport.name || ticket.departureAirport.iataCode) && isValidDate(ticket.departureTime) && ticket.arrivalAirport && (ticket.arrivalAirport.name || ticket.arrivalAirport.iataCode) && isValidDate(ticket.arrivalTime) && (ticket.airline.name || ticket.airline.iataCode));
          });
        }

        function checkPromoDomainHeader(message, features, promoDomainPlate) {
          if (!message || !features) {
            return;
          }

          if (!features.has(_utils_features__WEBPACK_IMPORTED_MODULE_0__["EFeatures"].PROMO_DOMAIN_HEADER)) {
            return;
          }

          return !!promoDomainPlate;
        }

        function checkPhishingHeader(message, features) {
          return features.has(_utils_features__WEBPACK_IMPORTED_MODULE_0__["EFeatures"].PHISHING) && message.get('flags.maybe_phishing');
        }

        function checkIs(type, model, features, promoDomainPlate) {
          switch (type) {
            case EHeaderTypes.LETTER_META:
              return model.getJsonLdEvent && model.getJsonLdEvent() || model.getPaymentMeta && model.getPaymentMeta();

            case EHeaderTypes.TRANSACTION_HEADER:
              return checkTransactionHeader(model, features);

            case EHeaderTypes.AVIA:
              return checkAviaHeader(model, features);

            case EHeaderTypes.PROMO_DOMAIN_HEADER:
              return checkPromoDomainHeader(model, features, promoDomainPlate);

            case EHeaderTypes.PHISHING:
              return checkPhishingHeader(model, features);
          }
        }

        function getType(message, features, promoDomainPlate, isFake) {
          if (isFake) {
            return EHeaderTypes.LETTER_META;
          }

          if (checkIs(EHeaderTypes.PHISHING, message, features)) {
            return EHeaderTypes.PHISHING;
          }

          if (checkIs(EHeaderTypes.TRANSACTION_HEADER, message, features)) {
            return EHeaderTypes.TRANSACTION_HEADER;
          }

          if (checkIs(EHeaderTypes.AVIA, message, features)) {
            return EHeaderTypes.AVIA;
          }

          if (checkIs(EHeaderTypes.LETTER_META, message, features)) {
            return EHeaderTypes.LETTER_META;
          }

          if (checkIs(EHeaderTypes.PROMO_DOMAIN_HEADER, message, features, promoDomainPlate)) {
            return EHeaderTypes.PROMO_DOMAIN_HEADER;
          }

          return null;
        }
        /***/

      },

      /***/
      "./src/utils/i18n.ts":
      /*!***************************!*\
        !*** ./src/utils/i18n.ts ***!
        \***************************/

      /*! exports provided: intlConfig, i18n */

      /***/
      function srcUtilsI18nTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "intlConfig", function () {
          return intlConfig;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "i18n", function () {
          return i18n;
        });
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react-intl */
        "react-intl");
        /* harmony import */


        var react_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_0__);

        var defaultLocale = 'ru';
        var locale = '##lang##';
        locale = typeof locale === 'string' ? locale : defaultLocale;
        var messages = '##LOCALE_MESSAGES##';
        messages = typeof messages === 'object' ? messages : null;
        var intlConfig = new react_intl__WEBPACK_IMPORTED_MODULE_0__["IntlProvider"]({
          messages: messages,
          locale: locale,
          defaultLocale: defaultLocale
        }).getChildContext().intl;
        var i18n = intlConfig.formatMessage;
        /***/
      },

      /***/
      "./src/utils/injections.ts":
      /*!*********************************!*\
        !*** ./src/utils/injections.ts ***!
        \*********************************/

      /*! exports provided: octavius, features, lang, metadata, message, messages, onStatusClick, ponymode */

      /***/
      function srcUtilsInjectionsTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "octavius", function () {
          return octavius;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "features", function () {
          return features;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "lang", function () {
          return lang;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "metadata", function () {
          return metadata;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "message", function () {
          return message;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "messages", function () {
          return messages;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "onStatusClick", function () {
          return onStatusClick;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ponymode", function () {
          return ponymode;
        });
        /* harmony import */


        var _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @mail/react-provider */
        "./node_modules/@mail/react-provider/index.ts");
        /* harmony import */


        var _interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/interfaces/EInjections */
        "./src/interfaces/EInjections.ts");

        var octavius = function octavius() {
          return _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__["Injector"].get(_interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__["EInjections"].OCTAVIUS, false);
        };

        var features = function features() {
          return _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__["Injector"].get(_interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__["EInjections"].FEATURES);
        };

        var lang = function lang() {
          return _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__["Injector"].get(_interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__["EInjections"].LANG);
        };

        var metadata = function metadata() {
          return _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__["Injector"].get(_interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__["EInjections"].METADATA);
        };

        var message = function message() {
          return _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__["Injector"].get(_interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__["EInjections"].MESSAGE);
        };

        var messages = function messages() {
          return _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__["Injector"].get(_interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__["EInjections"].MESSAGES);
        };

        var onStatusClick = function onStatusClick() {
          return _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__["Injector"].get(_interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__["EInjections"].STATUS_CLICK);
        };

        var ponymode = function ponymode() {
          return _mail_react_provider__WEBPACK_IMPORTED_MODULE_0__["Injector"].get(_interfaces_EInjections__WEBPACK_IMPORTED_MODULE_1__["EInjections"].PONYMODE, false);
        };
        /***/

      },

      /***/
      "./src/utils/radar.ts":
      /*!****************************!*\
        !*** ./src/utils/radar.ts ***!
        \****************************/

      /*! exports provided: getXray, setXray, radar, radarCreator */

      /***/
      function srcUtilsRadarTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getXray", function () {
          return getXray;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "setXray", function () {
          return setXray;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "radar", function () {
          return radar;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "radarCreator", function () {
          return radarCreator;
        });
        /* harmony import */


        var _mail_xray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @mail/xray */
        "./node_modules/@mail/xray/index.js");
        /* harmony import */


        var _utils_headersCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/utils/headersCheck */
        "./src/utils/headersCheck.ts");

        var _a;

        var xrays = (_a = {}, _a[_utils_headersCheck__WEBPACK_IMPORTED_MODULE_1__["EHeaderTypes"].LETTER_META] = _mail_xray__WEBPACK_IMPORTED_MODULE_0__["default"].getInstanceCopy(), _a[_utils_headersCheck__WEBPACK_IMPORTED_MODULE_1__["EHeaderTypes"].TRANSACTION_HEADER] = _mail_xray__WEBPACK_IMPORTED_MODULE_0__["default"].getInstanceCopy(), _a[_utils_headersCheck__WEBPACK_IMPORTED_MODULE_1__["EHeaderTypes"].ADDRESS] = _mail_xray__WEBPACK_IMPORTED_MODULE_0__["default"].getInstanceCopy(), _a[_utils_headersCheck__WEBPACK_IMPORTED_MODULE_1__["EHeaderTypes"].AVIA] = _mail_xray__WEBPACK_IMPORTED_MODULE_0__["default"].getInstanceCopy(), _a[_utils_headersCheck__WEBPACK_IMPORTED_MODULE_1__["EHeaderTypes"].PROMO_DOMAIN_HEADER] = _mail_xray__WEBPACK_IMPORTED_MODULE_0__["default"].getInstanceCopy(), _a[_utils_headersCheck__WEBPACK_IMPORTED_MODULE_1__["EHeaderTypes"].PHISHING] = _mail_xray__WEBPACK_IMPORTED_MODULE_0__["default"].getInstanceCopy(), _a);

        function getXray(type) {
          return xrays[type];
        }

        function setXray(type, xray) {
          xrays[type] = xray;
        }

        function radar(_a) {
          var header = _a.header,
              t = _a.t,
              _b = _a.params,
              params = _b === void 0 ? {} : _b;
          xrays[header].send(t, params);
        }

        var radarCreator = function radarCreator(header) {
          return function (t, params) {
            if (params === void 0) {
              params = {};
            }

            xrays[header].send(t, params);
          };
        };
        /***/

      },

      /***/
      "./src/utils/radarName.ts":
      /*!********************************!*\
        !*** ./src/utils/radarName.ts ***!
        \********************************/

      /*! exports provided: default */

      /***/
      function srcUtilsRadarNameTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var radarName = {
          clickMoreInfoLink: 'more_info',
          clickButtonPayment: 'click_payment',
          clickGroupPayment: 'click_group_payment',
          clickDetailedLink: 'click_detailed',
          showReceipt: 'show_receipt',
          showDie: 'show_die',
          showPaymentPopup: 'show_payment_popup',
          paymentClose: 'payment_close',
          paymentGroupClose: 'payment_group_close',
          photoButtonClick: 'photo_btn_click',
          photoPopupClose: 'photo_popup_close',
          photoPopupImageClick: 'photo_img_click',
          addressShow: 'show_address',
          addressClickLink: 'click_maps_link',
          addressCalendarClick: 'calendar_click',
          addressCalendarShow: 'calendar_show',
          addressTaxiClick: 'taxi_click',
          addressTaxiShow: 'taxi_show',
          gibddShowGroupPayment: 'show_group_payment',
          gibddGroupUpdateStatusError: 'gibdd_group_upd_status_error',
          gibddReceiptClick: 'gibdd_receipt_click',
          gibddReloadStatusClick: 'gibdd_reload_status_click',
          gibddReloadStatusError: 'gibdd_reload_status_error',
          gibddInProgressTimeout: 'gibdd_in_progress_timeout',
          gibddInProgressOk: 'gibdd_in_progress_ok',
          gibddInProgressFail: 'gibdd_in_progress_fail',
          gibddShowPaymentCenterLink: 'gibdd_show_pay_center_link',
          incompleteReloadStatusClick: 'incomplete_reload_status_click',
          incompleteReloadStatusError: 'incomplete_reload_status_error',
          billReloadStatusClick: 'bill_reload_status_click',
          billReloadStatusError: 'bill_reload_status_error',
          gibddCheckFinesClick: 'gibdd_check_fines_click',
          gibddCheckFinesClose: 'gibdd_check_fines_close',
          moreButtonClick: 'more_button_click',
          incompleteReceiptClick: 'incomplete_receipt_click',
          billReceiptClick: 'bill_receipt_click',
          postMessageUpdateStatus: 'postMessage_update_status',
          scrollError: 'scroll_error',
          postMessageParseError: 'postMessage_parse_error',
          paymentCenterClick: 'p_center_click',
          clickLink: 'click_link',
          clickCrossButton: 'click_cross_btn',
          hideDomainError: 'hide_domain_error',
          phishingShow: 'show',
          phishingBlockClick: 'block-click',
          phishingHelpClick: 'help-click',
          phishingClose: 'close',
          phishingShouldShow: 'should-show'
        };
        /* harmony default export */

        __webpack_exports__["default"] = radarName;
        /***/
      },

      /***/
      "./src/utils/setUrlParameter.ts":
      /*!**************************************!*\
        !*** ./src/utils/setUrlParameter.ts ***!
        \**************************************/

      /*! exports provided: default */

      /***/
      function srcUtilsSetUrlParameterTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! query-string */
        "./node_modules/query-string/index.js");
        /* harmony import */


        var query_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(query_string__WEBPACK_IMPORTED_MODULE_0__);

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };
        /**
         * Позволяет заменить или добавить в строке с урлом гет-параметр.
         * @param url
         * @param params
         */

        /* harmony default export */


        __webpack_exports__["default"] = function (url, params) {
          // IE fallback
          var a = document.createElement('a');
          a.href = url;

          var queryParams = __assign(__assign({}, query_string__WEBPACK_IMPORTED_MODULE_0___default.a.parse(a.search)), params);

          a.search = '?' + query_string__WEBPACK_IMPORTED_MODULE_0___default.a.stringify(queryParams);
          return a.href;
        };
        /***/

      },

      /***/
      "./src/utils/skins.ts":
      /*!****************************!*\
        !*** ./src/utils/skins.ts ***!
        \****************************/

      /*! exports provided: default */

      /***/
      function srcUtilsSkinsTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var SKINS;

        (function (SKINS) {
          SKINS["DATASET"] = "dataset";
          SKINS["PROMO"] = "promo";
          SKINS["SIMPLE"] = "simple";
          SKINS["GIBDD"] = "gibdd";
          SKINS["MOBILE"] = "mobiles_payment";
          SKINS["MONETA"] = "moneta";
        })(SKINS || (SKINS = {}));
        /* harmony default export */


        __webpack_exports__["default"] = SKINS;
        /***/
      },

      /***/
      "./src/utils/timeDiff.ts":
      /*!*******************************!*\
        !*** ./src/utils/timeDiff.ts ***!
        \*******************************/

      /*! exports provided: timeDiffInMinutes */

      /***/
      function srcUtilsTimeDiffTs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "timeDiffInMinutes", function () {
          return timeDiffInMinutes;
        });

        var timeDiffInMinutes = function timeDiffInMinutes(t1, t2) {
          return Math.floor((t1 - t2) / (60 * 1000));
        };
        /***/

      },

      /***/
      "./src/utils/withContext.tsx":
      /*!***********************************!*\
        !*** ./src/utils/withContext.tsx ***!
        \***********************************/

      /*! exports provided: withContext */

      /***/
      function srcUtilsWithContextTsx(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "withContext", function () {
          return withContext;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _components_ContextProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @/components/ContextProvider */
        "./src/components/ContextProvider/index.ts");

        var __extends = undefined && undefined.__extends || function () {
          var _extendStatics30 = function extendStatics(d, b) {
            _extendStatics30 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics30(d, b);
          };

          return function (d, b) {
            _extendStatics30(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        function withContext(Component) {
          var _a;

          return _a =
          /** @class */
          function (_super) {
            __extends(WithStateComponent, _super);

            function WithStateComponent() {
              return _super !== null && _super.apply(this, arguments) || this;
            }

            WithStateComponent.prototype.render = function () {
              var props = this.props;
              return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_ContextProvider__WEBPACK_IMPORTED_MODULE_1__["StateContext"].Consumer, null, function (context) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](Component, __assign({
                  context: context
                }, props));
              });
            };

            return WithStateComponent;
          }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]), _a.NakedComponent = Component.NakedComponent || Component, _a;
        }
        /***/

      },

      /***/
      "2kit":
      /*!***********************!*\
        !*** external "2kit" ***!
        \***********************/

      /*! no static exports found */

      /***/
      function kit(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__2kit__;
        /***/
      },

      /***/
      "classnames":
      /*!*****************************!*\
        !*** external "classnames" ***!
        \*****************************/

      /*! no static exports found */

      /***/
      function classnames(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_classnames__;
        /***/
      },

      /***/
      "prop-types":
      /*!*****************************!*\
        !*** external "prop-types" ***!
        \*****************************/

      /*! no static exports found */

      /***/
      function propTypes(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;
        /***/
      },

      /***/
      "react":
      /*!************************!*\
        !*** external "react" ***!
        \************************/

      /*! no static exports found */

      /***/
      function react(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/
      },

      /***/
      "react-dom":
      /*!****************************!*\
        !*** external "react-dom" ***!
        \****************************/

      /*! no static exports found */

      /***/
      function reactDom(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;
        /***/
      },

      /***/
      "react-intl":
      /*!*****************************!*\
        !*** external "react-intl" ***!
        \*****************************/

      /*! no static exports found */

      /***/
      function reactIntl(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_react_intl__;
        /***/
      }
      /******/

    })["default"]
  );
});